/* tslint:disable */
/* eslint-disable */
/**
 * Bulletin API
 * REST API for Bulletin platform
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface A2zConnectionResponse
 */
export interface A2zConnectionResponse {
    /**
     * 
     * @type {string}
     * @memberof A2zConnectionResponse
     */
    'access_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof A2zConnectionResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof A2zConnectionResponse
     */
    'brand_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof A2zConnectionResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof A2zConnectionResponse
     */
    'role'?: A2zConnectionResponseRoleEnum;
    /**
     * 
     * @type {number}
     * @memberof A2zConnectionResponse
     */
    'number_of_logins'?: number;
    /**
     * 
     * @type {string}
     * @memberof A2zConnectionResponse
     */
    'first_login_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof A2zConnectionResponse
     */
    'last_login_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof A2zConnectionResponse
     */
    'reset_password_code'?: string;
}

export const A2zConnectionResponseRoleEnum = {
    Brand: 'BRAND',
    Retailer: 'RETAILER',
    Admin: 'ADMIN',
    ProductBuilder: 'PRODUCT_BUILDER'
} as const;

export type A2zConnectionResponseRoleEnum = typeof A2zConnectionResponseRoleEnum[keyof typeof A2zConnectionResponseRoleEnum];

/**
 * 
 * @export
 * @interface AbstractViewComponentResponse
 */
export interface AbstractViewComponentResponse {
    /**
     * 
     * @type {string}
     * @memberof AbstractViewComponentResponse
     */
    'entity_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AbstractViewComponentResponse
     */
    'component_type'?: AbstractViewComponentResponseComponentTypeEnum;
}

export const AbstractViewComponentResponseComponentTypeEnum = {
    FeaturedLinksRetailer: 'FEATURED_LINKS_RETAILER',
    NavigationV2: 'NAVIGATION_V2',
    NavigationV2Subcategory: 'NAVIGATION_V2_SUBCATEGORY',
    Category: 'CATEGORY',
    Collection: 'COLLECTION',
    Brand: 'BRAND',
    Hero: 'HERO',
    PromoBanner: 'PROMO_BANNER',
    About: 'ABOUT'
} as const;

export type AbstractViewComponentResponseComponentTypeEnum = typeof AbstractViewComponentResponseComponentTypeEnum[keyof typeof AbstractViewComponentResponseComponentTypeEnum];

/**
 * 
 * @export
 * @interface AddAllDraftProductStatusResponse
 */
export interface AddAllDraftProductStatusResponse {
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof AddAllDraftProductStatusResponse
     */
    'addAllDraftProductStatusResponse'?: { [key: string]: boolean; };
}
/**
 * Add all draft products request
 * @export
 * @interface AddAllDraftProductsRequest
 */
export interface AddAllDraftProductsRequest {
    /**
     * 
     * @type {Array<DraftProductRequest>}
     * @memberof AddAllDraftProductsRequest
     */
    'draft_products'?: Array<DraftProductRequest>;
}
/**
 * Activate Draft product object
 * @export
 * @interface AddDraftProductRequest
 */
export interface AddDraftProductRequest {
    /**
     * 
     * @type {string}
     * @memberof AddDraftProductRequest
     */
    'title': string;
    /**
     * 
     * @type {number}
     * @memberof AddDraftProductRequest
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof AddDraftProductRequest
     */
    'min_lead_time': number;
    /**
     * 
     * @type {number}
     * @memberof AddDraftProductRequest
     */
    'max_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof AddDraftProductRequest
     */
    'wholesale_price': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddDraftProductRequest
     */
    'category_ids': Array<string>;
}
/**
 * Add items request body
 * @export
 * @interface AddItemToSuborderRequest
 */
export interface AddItemToSuborderRequest {
    /**
     * 
     * @type {Array<Item>}
     * @memberof AddItemToSuborderRequest
     */
    'items'?: Array<Item>;
}
/**
 * Variants which are being added to cart
 * @export
 * @interface AddItemsToCartRequest
 */
export interface AddItemsToCartRequest {
    /**
     * 
     * @type {string}
     * @memberof AddItemsToCartRequest
     */
    'category_id'?: string;
    /**
     * 
     * @type {Array<CartVariantRequest>}
     * @memberof AddItemsToCartRequest
     */
    'variants'?: Array<CartVariantRequest>;
}
/**
 * 
 * @export
 * @interface AddNewReferralsRequest
 */
export interface AddNewReferralsRequest {
    /**
     * 
     * @type {string}
     * @memberof AddNewReferralsRequest
     */
    'referred_retailer_email': string;
    /**
     * 
     * @type {string}
     * @memberof AddNewReferralsRequest
     */
    'brand_email': string;
}
/**
 * 
 * @export
 * @interface AddNewReferralsResponse
 */
export interface AddNewReferralsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddNewReferralsResponse
     */
    'invalid_referrals'?: Array<string>;
}
/**
 * Add Product To Brand Boards object
 * @export
 * @interface AddProductToBrandBoardsRequest
 */
export interface AddProductToBrandBoardsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddProductToBrandBoardsRequest
     */
    'brand_board_ids'?: Array<string>;
}
/**
 * Add Products to manual collection object
 * @export
 * @interface AddProductsToManualCollectionRequest
 */
export interface AddProductsToManualCollectionRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddProductsToManualCollectionRequest
     */
    'collection_ids': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddProductsToManualCollectionRequest
     */
    'product_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface AddRandomProductsToBoardRequest
 */
export interface AddRandomProductsToBoardRequest {
    /**
     * 
     * @type {number}
     * @memberof AddRandomProductsToBoardRequest
     */
    'products_number'?: number;
}
/**
 * Add suborder shipping info object
 * @export
 * @interface AddSuborderShippingInfoRequest
 */
export interface AddSuborderShippingInfoRequest {
    /**
     * 
     * @type {string}
     * @memberof AddSuborderShippingInfoRequest
     */
    'shipping_info'?: string;
}
/**
 * Product id\'s with new tags
 * @export
 * @interface AddTagsToProductsRequest
 */
export interface AddTagsToProductsRequest {
    /**
     * 
     * @type {Array<ProductTagsRequest>}
     * @memberof AddTagsToProductsRequest
     */
    'product_tags': Array<ProductTagsRequest>;
}
/**
 * Variant which is being added to cart
 * @export
 * @interface AddToCartRequest
 */
export interface AddToCartRequest {
    /**
     * 
     * @type {string}
     * @memberof AddToCartRequest
     */
    'variant_id': string;
    /**
     * 
     * @type {string}
     * @memberof AddToCartRequest
     */
    'category_id': string;
    /**
     * 
     * @type {number}
     * @memberof AddToCartRequest
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof AddToCartRequest
     */
    'query_id'?: string;
}
/**
 * Create AWS Cognito user object
 * @export
 * @interface AddUserToCognitoRequest
 */
export interface AddUserToCognitoRequest {
    /**
     * 
     * @type {string}
     * @memberof AddUserToCognitoRequest
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof AddUserToCognitoRequest
     */
    'send_email': boolean;
}
/**
 * 
 * @export
 * @interface Additional
 */
export interface Additional {
    /**
     * 
     * @type {boolean}
     * @memberof Additional
     */
    'has_known_bounces': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Additional
     */
    'has_suspected_bounces': boolean;
}
/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Address
     */
    'deleted': boolean;
    /**
     * 
     * @type {Retailer}
     * @memberof Address
     */
    'retailer'?: Retailer;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'zipCode': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'street': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'district'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'company'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'city': string;
    /**
     * 
     * @type {number}
     * @memberof Address
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof Address
     */
    'latitude'?: number;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'apartment'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'state': string;
    /**
     * 
     * @type {boolean}
     * @memberof Address
     */
    'defaultShipping'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Address
     */
    'defaultBilling'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Address
     */
    'shipping': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Address
     */
    'billing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Address
     */
    'new'?: boolean;
}
/**
 * 
 * @export
 * @interface AddressPartialResponse
 */
export interface AddressPartialResponse {
    /**
     * 
     * @type {string}
     * @memberof AddressPartialResponse
     */
    'address_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressPartialResponse
     */
    'zip_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressPartialResponse
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressPartialResponse
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressPartialResponse
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressPartialResponse
     */
    'company'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressPartialResponse
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressPartialResponse
     */
    'apartment'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressPartialResponse
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressPartialResponse
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressPartialResponse
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressPartialResponse
     */
    'retailer_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddressPartialResponse
     */
    'default_address'?: boolean;
}
/**
 * 
 * @export
 * @interface AddressResponse
 */
export interface AddressResponse {
    /**
     * 
     * @type {string}
     * @memberof AddressResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressResponse
     */
    'zip_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressResponse
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressResponse
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressResponse
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressResponse
     */
    'company'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressResponse
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressResponse
     */
    'apartment'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressResponse
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressResponse
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressResponse
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressResponse
     */
    'retailer_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddressResponse
     */
    'shipping'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddressResponse
     */
    'billing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddressResponse
     */
    'default_shipping'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddressResponse
     */
    'default_billing'?: boolean;
}
/**
 * 
 * @export
 * @interface AdminCollectionResponse
 */
export interface AdminCollectionResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminCollectionResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCollectionResponse
     */
    'image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCollectionResponse
     */
    'link'?: string;
}
/**
 * 
 * @export
 * @interface AlgoliaRecommendationResponse
 */
export interface AlgoliaRecommendationResponse {
    /**
     * 
     * @type {string}
     * @memberof AlgoliaRecommendationResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlgoliaRecommendationResponse
     */
    'name'?: string;
    /**
     * 
     * @type {BrandRecommendationDTO}
     * @memberof AlgoliaRecommendationResponse
     */
    'brand'?: BrandRecommendationDTO;
    /**
     * 
     * @type {Array<ProductCategoryAlgolia>}
     * @memberof AlgoliaRecommendationResponse
     */
    'categories'?: Array<ProductCategoryAlgolia>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlgoliaRecommendationResponse
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AlgoliaRecommendationResponse
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlgoliaRecommendationResponse
     */
    'cdn_image'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AlgoliaRecommendationResponse
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AlgoliaRecommendationResponse
     */
    'product_status'?: AlgoliaRecommendationResponseProductStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AlgoliaRecommendationResponse
     */
    'is_test_product'?: boolean;
}

export const AlgoliaRecommendationResponseProductStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
    Any: 'ANY',
    Draft: 'DRAFT'
} as const;

export type AlgoliaRecommendationResponseProductStatusEnum = typeof AlgoliaRecommendationResponseProductStatusEnum[keyof typeof AlgoliaRecommendationResponseProductStatusEnum];

/**
 * Apply Promo Code to Order object
 * @export
 * @interface ApplyPromoCodeToOrderRequest
 */
export interface ApplyPromoCodeToOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplyPromoCodeToOrderRequest
     */
    'promo_code': string;
}
/**
 * Apply to buy object
 * @export
 * @interface ApplyToBuyRequest
 */
export interface ApplyToBuyRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplyToBuyRequest
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToBuyRequest
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToBuyRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToBuyRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToBuyRequest
     */
    'store_name': string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToBuyRequest
     */
    'store_url': string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToBuyRequest
     */
    'informed_from'?: ApplyToBuyRequestInformedFromEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ApplyToBuyRequest
     */
    'assortment_requested': boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplyToBuyRequest
     */
    'store_location_id': string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToBuyRequest
     */
    'referral_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToBuyRequest
     */
    'referral_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToBuyRequest
     */
    'brand_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToBuyRequest
     */
    'utm_medium'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToBuyRequest
     */
    'utm_source'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToBuyRequest
     */
    'utm_campaign'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToBuyRequest
     */
    'utm_content'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToBuyRequest
     */
    'utm_term'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToBuyRequest
     */
    'gclid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToBuyRequest
     */
    'phone_number'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplyToBuyRequest
     */
    'emerald_marketing_opt_in'?: boolean;
}

export const ApplyToBuyRequestInformedFromEnum = {
    BulletinEmailOutreach: 'Bulletin Email Outreach',
    BulletinInstagram: 'Bulletin Instagram',
    PressOrPublication: 'Press or Publication',
    WordOfMouth: 'Word of mouth',
    ReferredByABrand: 'Referred by a Brand',
    ReferredByARetailer: 'Referred by a Retailer',
    ReferredByAFriend: 'Referred by a Friend',
    FamiliarWithBulletinStores: 'Familiar with Bulletin Stores',
    ExternalFacebookGroup: 'External Facebook Group',
    NyNowDiscoveryShow: 'NY Now Discovery Show',
    ReassembledTradeShow: 'Reassembled Trade Show',
    SupportTheStoresCampaign: 'Support the Stores Campaign',
    Other: 'Other'
} as const;

export type ApplyToBuyRequestInformedFromEnum = typeof ApplyToBuyRequestInformedFromEnum[keyof typeof ApplyToBuyRequestInformedFromEnum];

/**
 * 
 * @export
 * @interface ApplyToBuyResponse
 */
export interface ApplyToBuyResponse {
    /**
     * 
     * @type {string}
     * @memberof ApplyToBuyResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToBuyResponse
     */
    'user_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToBuyResponse
     */
    'brand_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToBuyResponse
     */
    'balance_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplyToBuyResponse
     */
    'use_balance'?: boolean;
}
/**
 * Apply to sell object
 * @export
 * @interface ApplyToSellRequest
 */
export interface ApplyToSellRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplyToSellRequest
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToSellRequest
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToSellRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToSellRequest
     */
    'brand_name': string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToSellRequest
     */
    'website_url': string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToSellRequest
     */
    'years_in_business': string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToSellRequest
     */
    'phone_number': string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToSellRequest
     */
    'instagram'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplyToSellRequest
     */
    'ships_from_usa_or_canada'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplyToSellRequest
     */
    'country_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplyToSellRequest
     */
    'emerald_marketing_opt_in'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplyToSellRequest
     */
    'utm_medium'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToSellRequest
     */
    'utm_source'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToSellRequest
     */
    'utm_campaign'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToSellRequest
     */
    'utm_content'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToSellRequest
     */
    'utm_term'?: string;
}
/**
 * 
 * @export
 * @interface ApplyToSellResponse
 */
export interface ApplyToSellResponse {
    /**
     * 
     * @type {string}
     * @memberof ApplyToSellResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyToSellResponse
     */
    'user_id'?: string;
}
/**
 * Associate Product with Boards object
 * @export
 * @interface AssociateProductWithBoardsRequest
 */
export interface AssociateProductWithBoardsRequest {
    /**
     * 
     * @type {string}
     * @memberof AssociateProductWithBoardsRequest
     */
    'product_id'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssociateProductWithBoardsRequest
     */
    'board_ids'?: Array<string>;
}
/**
 * Authorization Code
 * @export
 * @interface AuthorizationCodeDto
 */
export interface AuthorizationCodeDto {
    /**
     * 
     * @type {string}
     * @memberof AuthorizationCodeDto
     */
    'code'?: string;
}
/**
 * 
 * @export
 * @interface AutomatedCollectionConditionsResponse
 */
export interface AutomatedCollectionConditionsResponse {
    /**
     * 
     * @type {Array<ConditionKeyResponse>}
     * @memberof AutomatedCollectionConditionsResponse
     */
    'condition_keys'?: Array<ConditionKeyResponse>;
    /**
     * 
     * @type {Array<ConditionOperatorResponse>}
     * @memberof AutomatedCollectionConditionsResponse
     */
    'condition_operators'?: Array<ConditionOperatorResponse>;
}
/**
 * 
 * @export
 * @interface AutomatedCollectionShopifyDTO
 */
export interface AutomatedCollectionShopifyDTO {
    /**
     * 
     * @type {string}
     * @memberof AutomatedCollectionShopifyDTO
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof AutomatedCollectionShopifyDTO
     */
    'internal_title'?: string;
    /**
     * 
     * @type {string}
     * @memberof AutomatedCollectionShopifyDTO
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof AutomatedCollectionShopifyDTO
     */
    'image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof AutomatedCollectionShopifyDTO
     */
    'collection_type'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AutomatedCollectionShopifyDTO
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AutomatedCollectionShopifyDTO
     */
    'include_all_conditions'?: boolean;
    /**
     * 
     * @type {Array<ProductSearchCriteriaInfo>}
     * @memberof AutomatedCollectionShopifyDTO
     */
    'search_criteria'?: Array<ProductSearchCriteriaInfo>;
}
/**
 * 
 * @export
 * @interface BalanceAddress
 */
export interface BalanceAddress {
    /**
     * 
     * @type {string}
     * @memberof BalanceAddress
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof BalanceAddress
     */
    'countryCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof BalanceAddress
     */
    'addressLine1'?: string;
    /**
     * 
     * @type {string}
     * @memberof BalanceAddress
     */
    'addressLine2'?: string;
    /**
     * 
     * @type {string}
     * @memberof BalanceAddress
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof BalanceAddress
     */
    'zipCode'?: string;
}
/**
 * Capture balance transaction object
 * @export
 * @interface BalanceCaptureRequest
 */
export interface BalanceCaptureRequest {
    /**
     * 
     * @type {string}
     * @memberof BalanceCaptureRequest
     */
    'transactionId'?: string;
    /**
     * 
     * @type {number}
     * @memberof BalanceCaptureRequest
     */
    'captureAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof BalanceCaptureRequest
     */
    'vendorId'?: string;
}
/**
 * 
 * @export
 * @interface BankData
 */
export interface BankData {
    /**
     * 
     * @type {string}
     * @memberof BankData
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankData
     */
    'institutionName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankData
     */
    'accountName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankData
     */
    'accountNumberMask'?: string;
}
/**
 * Split ship object
 * @export
 * @interface BatchSplitShipmentRequest
 */
export interface BatchSplitShipmentRequest {
    /**
     * 
     * @type {Array<SplitShipmentPackingSlipRequest>}
     * @memberof BatchSplitShipmentRequest
     */
    'packing_slips'?: Array<SplitShipmentPackingSlipRequest>;
}
/**
 * 
 * @export
 * @interface Board
 */
export interface Board {
    /**
     * 
     * @type {string}
     * @memberof Board
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Board
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Board
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Board
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof Board
     */
    'name'?: string;
    /**
     * 
     * @type {Retailer}
     * @memberof Board
     */
    'retailer': Retailer;
    /**
     * 
     * @type {Set<BoardProducts>}
     * @memberof Board
     */
    'products'?: Set<BoardProducts>;
    /**
     * 
     * @type {boolean}
     * @memberof Board
     */
    'new'?: boolean;
}
/**
 * 
 * @export
 * @interface BoardBrandResponse
 */
export interface BoardBrandResponse {
    /**
     * 
     * @type {string}
     * @memberof BoardBrandResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardBrandResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardBrandResponse
     */
    'vanity_url_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardBrandResponse
     */
    'thumbnail_image_url'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BoardBrandResponse
     */
    'retailer_is_following'?: boolean;
}
/**
 * 
 * @export
 * @interface BoardProductBrandResponse
 */
export interface BoardProductBrandResponse {
    /**
     * 
     * @type {string}
     * @memberof BoardProductBrandResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardProductBrandResponse
     */
    'company_name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BoardProductBrandResponse
     */
    'event_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface BoardProductResponse
 */
export interface BoardProductResponse {
    /**
     * 
     * @type {string}
     * @memberof BoardProductResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardProductResponse
     */
    'name'?: string;
    /**
     * 
     * @type {BoardProductBrandResponse}
     * @memberof BoardProductResponse
     */
    'brand'?: BoardProductBrandResponse;
    /**
     * 
     * @type {number}
     * @memberof BoardProductResponse
     */
    'wholesale_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof BoardProductResponse
     */
    'pos_price'?: number;
    /**
     * 
     * @type {string}
     * @memberof BoardProductResponse
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardProductResponse
     */
    'cdn_image'?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardProductResponse
     */
    'added_at'?: string;
}
/**
 * 
 * @export
 * @interface BoardProducts
 */
export interface BoardProducts {
    /**
     * 
     * @type {Product}
     * @memberof BoardProducts
     */
    'product'?: Product;
    /**
     * 
     * @type {Board}
     * @memberof BoardProducts
     */
    'board'?: Board;
    /**
     * 
     * @type {string}
     * @memberof BoardProducts
     */
    'dateAdded'?: string;
}
/**
 * 
 * @export
 * @interface Brand
 */
export interface Brand {
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Brand
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'ownerFirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'ownerLastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'companyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'status': BrandStatusEnum;
    /**
     * 
     * @type {User}
     * @memberof Brand
     */
    'user': User;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'companyDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'websiteUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'instagramUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'vanityUrlName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'instagramFollowers'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'basedIn'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'shippingCity'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'yearsInBusiness'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'initialSKUs'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'bulletinReference'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     * @deprecated
     */
    'referralCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'productsArrivalDuration'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'logoUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'brandBioImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'thumbnailImageUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Brand
     */
    'isPublished'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Brand
     */
    'shipToCanada'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Brand
     */
    'onboardingComplete'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Brand
     */
    'sellWithOtherShop'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Brand
     */
    'locatedInUsaCanada'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Brand
     */
    'basedInCanada'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'editorialLink'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'productPhotography'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Brand
     */
    'productCategories': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Brand
     */
    'categories': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof Brand
     */
    'increment'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Brand
     */
    'instagramGrowthHelp'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Brand
     */
    'deniedTimes'?: number;
    /**
     * 
     * @type {number}
     * @memberof Brand
     */
    'contactedTimes'?: number;
    /**
     * 
     * @type {number}
     * @memberof Brand
     */
    'minimumQuantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof Brand
     */
    'minimumPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'stripeAccountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'stripeRefreshToken'?: string;
    /**
     * 
     * @type {number}
     * @memberof Brand
     */
    'minimumOrderValue': number;
    /**
     * 
     * @type {number}
     * @memberof Brand
     */
    'minimumReorderValue': number;
    /**
     * 
     * @type {number}
     * @memberof Brand
     */
    'casePackQuantity'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof Brand
     */
    'values'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Brand
     * @deprecated
     */
    'shopifyAccessToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     * @deprecated
     */
    'shopifyShopName'?: string;
    /**
     * 
     * @type {Collection}
     * @memberof Brand
     */
    'collection'?: Collection;
    /**
     * 
     * @type {Set<Suborder>}
     * @memberof Brand
     */
    'suborders'?: Set<Suborder>;
    /**
     * 
     * @type {object}
     * @memberof Brand
     */
    'address': object;
    /**
     * 
     * @type {object}
     * @memberof Brand
     */
    'fulfillmentAddress': object;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'lineSheetUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'balanceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'bestSellers'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'madeActiveDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'source'?: BrandSourceEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof Brand
     */
    'dealsAndPromotions'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Brand
     */
    'specialServices'?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Brand
     */
    'externalId'?: { [key: string]: string; };
    /**
     * 
     * @type {Country}
     * @memberof Brand
     */
    'country'?: Country;
    /**
     * 
     * @type {boolean}
     * @memberof Brand
     */
    'shipsFromUSAOrCanada': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Brand
     */
    'bulletinPick': boolean;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'routableId'?: string;
    /**
     * 
     * @type {UtmParams}
     * @memberof Brand
     * @deprecated
     */
    'utmParams': UtmParams;
    /**
     * 
     * @type {boolean}
     * @memberof Brand
     */
    'shopifyWholesalePrices'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Brand
     */
    'buyOnBulletin': boolean;
    /**
     * 
     * @type {number}
     * @memberof Brand
     */
    'minLeadTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof Brand
     */
    'maxLeadTime'?: number;
    /**
     * 
     * @type {BrandShopifyConfig}
     * @memberof Brand
     */
    'brandShopifyConfig'?: BrandShopifyConfig;
    /**
     * 
     * @type {Array<string>}
     * @memberof Brand
     */
    'brandValues'?: Array<BrandBrandValuesEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof Brand
     */
    'new'?: boolean;
}

export const BrandStatusEnum = {
    Pending: 'PENDING',
    NeedsReview: 'NEEDS_REVIEW',
    Approved: 'APPROVED',
    Denied: 'DENIED',
    Registered: 'REGISTERED'
} as const;

export type BrandStatusEnum = typeof BrandStatusEnum[keyof typeof BrandStatusEnum];
export const BrandSourceEnum = {
    Application: 'APPLICATION',
    Exhibitor: 'EXHIBITOR',
    Outreach: 'OUTREACH'
} as const;

export type BrandSourceEnum = typeof BrandSourceEnum[keyof typeof BrandSourceEnum];
export const BrandBrandValuesEnum = {
    FemaleFounded: 'FEMALE_FOUNDED',
    EthicalProduction: 'ETHICAL_PRODUCTION',
    CleanIngredients: 'CLEAN_INGREDIENTS',
    Sustainable: 'SUSTAINABLE',
    Handmade: 'HANDMADE',
    MadeInTheUs: 'MADE_IN_THE_US',
    CharitableBrandGiveBack: 'CHARITABLE_BRAND_GIVE_BACK',
    Organic: 'ORGANIC',
    ZeroWaste: 'ZERO_WASTE',
    BlackOwned: 'BLACK_OWNED',
    LatinxOwned: 'LATINX_OWNED',
    AapiOwned: 'AAPI_OWNED',
    IndigenousOwned: 'INDIGENOUS_OWNED',
    LgbtqOwned: 'LGBTQ_OWNED',
    MinorityOwnedBusiness: 'MINORITY_OWNED_BUSINESS',
    DisabilityOwned: 'DISABILITY_OWNED'
} as const;

export type BrandBrandValuesEnum = typeof BrandBrandValuesEnum[keyof typeof BrandBrandValuesEnum];

/**
 * 
 * @export
 * @interface BrandActivePromoCodesResponse
 */
export interface BrandActivePromoCodesResponse {
    /**
     * 
     * @type {Array<PromoCodeResponse>}
     * @memberof BrandActivePromoCodesResponse
     */
    'promo_codes'?: Array<PromoCodeResponse>;
}
/**
 * 
 * @export
 * @interface BrandBoardResponse
 */
export interface BrandBoardResponse {
    /**
     * 
     * @type {string}
     * @memberof BrandBoardResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandBoardResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandBoardResponse
     */
    'visibility'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BrandBoardResponse
     */
    'show_on_profile'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof BrandBoardResponse
     */
    'thumbnail_image_urls'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof BrandBoardResponse
     */
    'contains_product'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BrandBoardResponse
     */
    'product_count'?: number;
}
/**
 * 
 * @export
 * @interface BrandBoardShareResponse
 */
export interface BrandBoardShareResponse {
    /**
     * 
     * @type {string}
     * @memberof BrandBoardShareResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandBoardShareResponse
     */
    'role'?: BrandBoardShareResponseRoleEnum;
}

export const BrandBoardShareResponseRoleEnum = {
    Creator: 'CREATOR',
    Viewer: 'VIEWER'
} as const;

export type BrandBoardShareResponseRoleEnum = typeof BrandBoardShareResponseRoleEnum[keyof typeof BrandBoardShareResponseRoleEnum];

/**
 * 
 * @export
 * @interface BrandCategoriesForDropdownResponse
 */
export interface BrandCategoriesForDropdownResponse {
    /**
     * 
     * @type {Array<GetBrandCategoriesForDropdownResponse>}
     * @memberof BrandCategoriesForDropdownResponse
     */
    'brand_categories'?: Array<GetBrandCategoriesForDropdownResponse>;
}
/**
 * Brand id which should be marked/unmarked for checkout
 * @export
 * @interface BrandCheckoutRequest
 */
export interface BrandCheckoutRequest {
    /**
     * 
     * @type {string}
     * @memberof BrandCheckoutRequest
     */
    'brand_id'?: string;
}
/**
 * 
 * @export
 * @interface BrandDropdownInfo
 */
export interface BrandDropdownInfo {
    /**
     * 
     * @type {string}
     * @memberof BrandDropdownInfo
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandDropdownInfo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandDropdownInfo
     */
    'vanityUrlName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandDropdownInfo
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface BrandFromBrandBoardResponse
 */
export interface BrandFromBrandBoardResponse {
    /**
     * 
     * @type {string}
     * @memberof BrandFromBrandBoardResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandFromBrandBoardResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandFromBrandBoardResponse
     */
    'thumbnail_image_url'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BrandFromBrandBoardResponse
     */
    'buy_on_bulletin'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BrandFromBrandBoardResponse
     */
    'bulletin_pick'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BrandFromBrandBoardResponse
     */
    'vanity_url_name'?: string;
}
/**
 * 
 * @export
 * @interface BrandInfoResponse
 */
export interface BrandInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof BrandInfoResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandInfoResponse
     */
    'vanity_url_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandInfoResponse
     */
    'brand_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandInfoResponse
     */
    'based_in'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BrandInfoResponse
     */
    'is_published'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BrandInfoResponse
     */
    'minimum_order_value'?: number;
}
/**
 * 
 * @export
 * @interface BrandLocationRequest
 */
export interface BrandLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof BrandLocationRequest
     */
    'location_id': string;
    /**
     * 
     * @type {number}
     * @memberof BrandLocationRequest
     */
    'sale_split_coefficient_in_percent': number;
    /**
     * 
     * @type {boolean}
     * @memberof BrandLocationRequest
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface BrandLocationResponse
 */
export interface BrandLocationResponse {
    /**
     * 
     * @type {string}
     * @memberof BrandLocationResponse
     */
    'location_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandLocationResponse
     */
    'payout'?: number;
}
/**
 * 
 * @export
 * @interface BrandOverrideAttributesRequest
 */
export interface BrandOverrideAttributesRequest {
    /**
     * 
     * @type {string}
     * @memberof BrandOverrideAttributesRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof BrandOverrideAttributesRequest
     */
    'companyId': string;
    /**
     * 
     * @type {string}
     * @memberof BrandOverrideAttributesRequest
     */
    'companyName': string;
    /**
     * 
     * @type {string}
     * @memberof BrandOverrideAttributesRequest
     */
    'booth': string;
    /**
     * 
     * @type {string}
     * @memberof BrandOverrideAttributesRequest
     */
    'section'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandOverrideAttributesRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof BrandOverrideAttributesRequest
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof BrandOverrideAttributesRequest
     */
    'websiteUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandOverrideAttributesRequest
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandOverrideAttributesRequest
     */
    'logoImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandOverrideAttributesRequest
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandOverrideAttributesRequest
     */
    'brandDescription'?: string;
    /**
     * 
     * @type {object}
     * @memberof BrandOverrideAttributesRequest
     */
    'address': object;
}
/**
 * Publish Promo code object
 * @export
 * @interface BrandPublishPromoCodeRequest
 */
export interface BrandPublishPromoCodeRequest {
    /**
     * 
     * @type {boolean}
     * @memberof BrandPublishPromoCodeRequest
     */
    'published'?: boolean;
}
/**
 * 
 * @export
 * @interface BrandPublishedPromoCodeResponse
 */
export interface BrandPublishedPromoCodeResponse {
    /**
     * 
     * @type {string}
     * @memberof BrandPublishedPromoCodeResponse
     */
    'code'?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandPublishedPromoCodeResponse
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandPublishedPromoCodeResponse
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface BrandRecommendationDTO
 */
export interface BrandRecommendationDTO {
    /**
     * 
     * @type {string}
     * @memberof BrandRecommendationDTO
     */
    'based_in'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BrandRecommendationDTO
     */
    'bulletin_pick'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BrandRecommendationDTO
     */
    'buy_on_bulletin'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BrandRecommendationDTO
     */
    'company_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandRecommendationDTO
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BrandRecommendationDTO
     */
    'is_published'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BrandRecommendationDTO
     */
    'minimum_order_value'?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandRecommendationDTO
     */
    'minimum_reorder_value'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BrandRecommendationDTO
     */
    'ships_from_usa_or_canada'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BrandRecommendationDTO
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandRecommendationDTO
     */
    'vanity_url_name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BrandRecommendationDTO
     */
    'values'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BrandRecommendationDTO
     */
    'event_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface BrandReferralResponse
 */
export interface BrandReferralResponse {
    /**
     * 
     * @type {string}
     * @memberof BrandReferralResponse
     */
    'brand_name'?: string;
}
/**
 * 
 * @export
 * @interface BrandReorderResponse
 */
export interface BrandReorderResponse {
    /**
     * 
     * @type {string}
     * @memberof BrandReorderResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandReorderResponse
     */
    'vanity_url_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandReorderResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandReorderResponse
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandReorderResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandReorderResponse
     */
    'image'?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandReorderResponse
     */
    'min_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandReorderResponse
     */
    'minimum_reorder_value'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BrandReorderResponse
     */
    'buy_on_bulletin'?: boolean;
}
/**
 * 
 * @export
 * @interface BrandResponse
 */
export interface BrandResponse {
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    'brand_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    'brand_description'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    'logo_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    'brand_bio_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    'website_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    'instagram_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    'instagram_followers'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    'based_in'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    'product_arrival'?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandResponse
     */
    'min_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandResponse
     */
    'max_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandResponse
     */
    'minimum_quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandResponse
     */
    'minimum_price'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof BrandResponse
     */
    'categories'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof BrandResponse
     */
    'is_published'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BrandResponse
     */
    'increment'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BrandResponse
     */
    'instagram_growth_help'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BrandResponse
     */
    'minimum_order_value'?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandResponse
     */
    'minimum_reorder_value'?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    'thumbnail_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    'vanity_url_name'?: string;
    /**
     * 
     * @type {Array<DropdownItem>}
     * @memberof BrandResponse
     */
    'values'?: Array<DropdownItem>;
    /**
     * 
     * @type {number}
     * @memberof BrandResponse
     */
    'case_pack_quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    'user_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BrandResponse
     */
    'bulletin_plus_access_level'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BrandResponse
     */
    'onboarding_complete'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof BrandResponse
     */
    'address'?: object;
    /**
     * 
     * @type {object}
     * @memberof BrandResponse
     */
    'fulfillment_address'?: object;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    'balance_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    'phone_number'?: string;
    /**
     * 
     * @type {ShopifyBrandOrders}
     * @memberof BrandResponse
     */
    'shopify'?: ShopifyBrandOrders;
}
/**
 * 
 * @export
 * @interface BrandShopifyConfig
 */
export interface BrandShopifyConfig {
    /**
     * 
     * @type {string}
     * @memberof BrandShopifyConfig
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandShopifyConfig
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof BrandShopifyConfig
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BrandShopifyConfig
     */
    'deleted': boolean;
    /**
     * 
     * @type {Brand}
     * @memberof BrandShopifyConfig
     */
    'brand'?: Brand;
    /**
     * 
     * @type {string}
     * @memberof BrandShopifyConfig
     */
    'brandId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandShopifyConfig
     */
    'accessToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandShopifyConfig
     */
    'shopName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BrandShopifyConfig
     */
    'wholesalePrices': boolean;
    /**
     * 
     * @type {string}
     * @memberof BrandShopifyConfig
     */
    'productFeedId'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BrandShopifyConfig
     */
    'syncPreferences': { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof BrandShopifyConfig
     */
    'importInProgress'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BrandShopifyConfig
     */
    'new'?: boolean;
}
/**
 * Brand info necessary for sign up
 * @export
 * @interface BrandSignUpRequest
 */
export interface BrandSignUpRequest {
    /**
     * 
     * @type {string}
     * @memberof BrandSignUpRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof BrandSignUpRequest
     */
    'company_description'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandSignUpRequest
     */
    'products_arrival_duration'?: string;
    /**
     * 
     * @type {CreateBrandApplicantRequest}
     * @memberof BrandSignUpRequest
     */
    'info': CreateBrandApplicantRequest;
}
/**
 * 
 * @export
 * @interface BrandTradeShowResponse
 */
export interface BrandTradeShowResponse {
    /**
     * 
     * @type {string}
     * @memberof BrandTradeShowResponse
     */
    'booth_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandTradeShowResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandTradeShowResponse
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandTradeShowResponse
     */
    'brand'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandTradeShowResponse
     */
    'section'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandTradeShowResponse
     */
    'registration_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandTradeShowResponse
     */
    'booth_map_url'?: string;
}
/**
 * 
 * @export
 * @interface BrandsApplicationsPagination
 */
export interface BrandsApplicationsPagination {
    /**
     * 
     * @type {number}
     * @memberof BrandsApplicationsPagination
     */
    'items_per_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandsApplicationsPagination
     */
    'total_items'?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandsApplicationsPagination
     */
    'current_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandsApplicationsPagination
     */
    'total_pages'?: number;
}
/**
 * 
 * @export
 * @interface BrandsApplicationsResponse
 */
export interface BrandsApplicationsResponse {
    /**
     * 
     * @type {string}
     * @memberof BrandsApplicationsResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandsApplicationsResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandsApplicationsResponse
     */
    'brand_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandsApplicationsResponse
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandsApplicationsResponse
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandsApplicationsResponse
     */
    'instagram_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandsApplicationsResponse
     */
    'thumbnail_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandsApplicationsResponse
     */
    'vanity_url_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandsApplicationsResponse
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandsApplicationsResponse
     */
    'based_in'?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandsApplicationsResponse
     */
    'min_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandsApplicationsResponse
     */
    'max_lead_time'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BrandsApplicationsResponse
     */
    'is_published'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BrandsApplicationsResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandsApplicationsResponse
     */
    'minimum_order_value'?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandsApplicationsResponse
     */
    'minimum_reorder_value'?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandsApplicationsResponse
     */
    'website_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandsApplicationsResponse
     */
    'onboarding_complete'?: string;
    /**
     * 
     * @type {object}
     * @memberof BrandsApplicationsResponse
     */
    'address'?: object;
    /**
     * 
     * @type {string}
     * @memberof BrandsApplicationsResponse
     */
    'source'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BrandsApplicationsResponse
     */
    'bulletin_pick'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BrandsApplicationsResponse
     */
    'buy_on_bulletin'?: boolean;
}
/**
 * 
 * @export
 * @interface BrandsDirectoryPagination
 */
export interface BrandsDirectoryPagination {
    /**
     * 
     * @type {number}
     * @memberof BrandsDirectoryPagination
     */
    'items_per_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandsDirectoryPagination
     */
    'total_items'?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandsDirectoryPagination
     */
    'current_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandsDirectoryPagination
     */
    'total_pages'?: number;
}
/**
 * 
 * @export
 * @interface BrandsDirectoryResponse
 */
export interface BrandsDirectoryResponse {
    /**
     * 
     * @type {string}
     * @memberof BrandsDirectoryResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandsDirectoryResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandsDirectoryResponse
     */
    'brand_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandsDirectoryResponse
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandsDirectoryResponse
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandsDirectoryResponse
     */
    'instagram_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandsDirectoryResponse
     */
    'thumbnail_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandsDirectoryResponse
     */
    'vanity_url_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandsDirectoryResponse
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandsDirectoryResponse
     */
    'based_in'?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandsDirectoryResponse
     */
    'min_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandsDirectoryResponse
     */
    'max_lead_time'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BrandsDirectoryResponse
     */
    'is_published'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BrandsDirectoryResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandsDirectoryResponse
     */
    'minimum_order_value'?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandsDirectoryResponse
     */
    'minimum_reorder_value'?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandsDirectoryResponse
     */
    'website_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandsDirectoryResponse
     */
    'onboarding_complete'?: string;
    /**
     * 
     * @type {object}
     * @memberof BrandsDirectoryResponse
     */
    'address'?: object;
    /**
     * 
     * @type {string}
     * @memberof BrandsDirectoryResponse
     */
    'source'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BrandsDirectoryResponse
     */
    'bulletin_pick'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BrandsDirectoryResponse
     */
    'buy_on_bulletin'?: boolean;
}
/**
 * 
 * @export
 * @interface BrandsDropdownResponse
 */
export interface BrandsDropdownResponse {
    /**
     * 
     * @type {Array<BrandDropdownInfo>}
     * @memberof BrandsDropdownResponse
     */
    'brands_dropdown'?: Array<BrandDropdownInfo>;
}
/**
 * 
 * @export
 * @interface BulkBypassOnboardingRequest
 */
export interface BulkBypassOnboardingRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkBypassOnboardingRequest
     */
    'brand_ids'?: Array<string>;
}
/**
 * Bulk delete products request
 * @export
 * @interface BulkDeleteProductsRequest
 */
export interface BulkDeleteProductsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkDeleteProductsRequest
     */
    'product_ids'?: Array<string>;
}
/**
 * Duplicate products request
 * @export
 * @interface BulkDuplicateProductsRequest
 */
export interface BulkDuplicateProductsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkDuplicateProductsRequest
     */
    'product_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface BulkDuplicateProductsResponse
 */
export interface BulkDuplicateProductsResponse {
    /**
     * 
     * @type {Array<DuplicatedProductResponse>}
     * @memberof BulkDuplicateProductsResponse
     */
    'products'?: Array<DuplicatedProductResponse>;
}
/**
 * Bulk save draft products request
 * @export
 * @interface BulkSaveDraftProductRequest
 */
export interface BulkSaveDraftProductRequest {
    /**
     * 
     * @type {Array<SaveDraftProductRequest>}
     * @memberof BulkSaveDraftProductRequest
     */
    'products'?: Array<SaveDraftProductRequest>;
}
/**
 * Bulk update draft products request
 * @export
 * @interface BulkUpdateDraftProductsRequest
 */
export interface BulkUpdateDraftProductsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkUpdateDraftProductsRequest
     */
    'product_ids'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkUpdateDraftProductsRequest
     */
    'category_ids'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateDraftProductsRequest
     */
    'min_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateDraftProductsRequest
     */
    'max_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateDraftProductsRequest
     */
    'wholesale_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateDraftProductsRequest
     */
    'pos_price'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDraftProductsRequest
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDraftProductsRequest
     */
    'approve_products'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateDraftProductsRequest
     */
    'weight'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDraftProductsRequest
     */
    'track_inventory'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateDraftProductsRequest
     */
    'min_order_quantity'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkUpdateDraftProductsRequest
     */
    'tags'?: Array<string>;
}
/**
 * Bulk update products request
 * @export
 * @interface BulkUpdateProductsRequest
 */
export interface BulkUpdateProductsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateProductsRequest
     */
    'draft_products': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateProductsRequest
     */
    'active_products': boolean;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateProductsRequest
     */
    'brand_id'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkUpdateProductsRequest
     */
    'product_ids'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkUpdateProductsRequest
     */
    'category_ids'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateProductsRequest
     */
    'min_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateProductsRequest
     */
    'max_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateProductsRequest
     */
    'wholesale_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateProductsRequest
     */
    'pos_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateProductsRequest
     */
    'wholesale_minimum'?: number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateProductsRequest
     */
    'wholesale_increment'?: number;
}
/**
 * 
 * @export
 * @interface BulletinAddress
 */
export interface BulletinAddress {
    /**
     * 
     * @type {string}
     * @memberof BulletinAddress
     */
    'street': string;
    /**
     * 
     * @type {string}
     * @memberof BulletinAddress
     */
    'zipCode': string;
    /**
     * 
     * @type {string}
     * @memberof BulletinAddress
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof BulletinAddress
     */
    'apartment': string;
    /**
     * 
     * @type {string}
     * @memberof BulletinAddress
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof BulletinAddress
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof BulletinAddress
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof BulletinAddress
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof BulletinAddress
     */
    'firstName': string;
}
/**
 * 
 * @export
 * @interface BulletinIncubatorBrandRequest
 */
export interface BulletinIncubatorBrandRequest {
    /**
     * 
     * @type {string}
     * @memberof BulletinIncubatorBrandRequest
     */
    'event'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulletinIncubatorBrandRequest
     */
    'userid'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulletinIncubatorBrandRequest
     */
    'exhibitingas'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulletinIncubatorBrandRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulletinIncubatorBrandRequest
     */
    'a2zcontractemail'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulletinIncubatorBrandRequest
     */
    'subexpocode'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulletinIncubatorBrandRequest
     */
    'booth'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulletinIncubatorBrandRequest
     */
    'companyid'?: string;
}
/**
 * 
 * @export
 * @interface Buyer
 */
export interface Buyer {
    /**
     * 
     * @type {BalanceAddress}
     * @memberof Buyer
     */
    'billingAddress'?: BalanceAddress;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'businessName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'qualificationStatus'?: string;
}
/**
 * 
 * @export
 * @interface BuyerByIdResponse
 */
export interface BuyerByIdResponse {
    /**
     * 
     * @type {string}
     * @memberof BuyerByIdResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerByIdResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerByIdResponse
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerByIdResponse
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerByIdResponse
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerByIdResponse
     */
    'businessName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerByIdResponse
     */
    'businessUrl'?: string;
    /**
     * 
     * @type {BalanceAddress}
     * @memberof BuyerByIdResponse
     */
    'billingAddress'?: BalanceAddress;
    /**
     * 
     * @type {string}
     * @memberof BuyerByIdResponse
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerByIdResponse
     */
    'qualificationStatus'?: string;
    /**
     * 
     * @type {PaymentData}
     * @memberof BuyerByIdResponse
     */
    'paymentData'?: PaymentData;
    /**
     * 
     * @type {BuyerCreditResponse}
     * @memberof BuyerByIdResponse
     */
    'qualification'?: BuyerCreditResponse;
}
/**
 * 
 * @export
 * @interface BuyerCreateResponse
 */
export interface BuyerCreateResponse {
    /**
     * 
     * @type {string}
     * @memberof BuyerCreateResponse
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerCreateResponse
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerCreateResponse
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerCreateResponse
     */
    'businessName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerCreateResponse
     */
    'businessUrl'?: string;
    /**
     * 
     * @type {BalanceAddress}
     * @memberof BuyerCreateResponse
     */
    'billingAddress'?: BalanceAddress;
    /**
     * 
     * @type {string}
     * @memberof BuyerCreateResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerCreateResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerCreateResponse
     */
    'createdAt'?: string;
}
/**
 * 
 * @export
 * @interface BuyerCreditResponse
 */
export interface BuyerCreditResponse {
    /**
     * 
     * @type {number}
     * @memberof BuyerCreditResponse
     */
    'creditLimit'?: number;
    /**
     * 
     * @type {number}
     * @memberof BuyerCreditResponse
     */
    'maxCreditLimit'?: number;
    /**
     * 
     * @type {number}
     * @memberof BuyerCreditResponse
     */
    'authHoldsSum'?: number;
    /**
     * 
     * @type {string}
     * @memberof BuyerCreditResponse
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface BuyerDirectory
 */
export interface BuyerDirectory {
    /**
     * 
     * @type {Array<string>}
     * @memberof BuyerDirectory
     */
    'event_ids'?: Array<string>;
}
/**
 * Buyer directory header object
 * @export
 * @interface BuyerDirectoryHeaderRequest
 */
export interface BuyerDirectoryHeaderRequest {
    /**
     * 
     * @type {string}
     * @memberof BuyerDirectoryHeaderRequest
     */
    'desktop_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerDirectoryHeaderRequest
     */
    'mobile_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerDirectoryHeaderRequest
     */
    'directory_title'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerDirectoryHeaderRequest
     */
    'directory_description'?: string;
}
/**
 * 
 * @export
 * @interface BuyerDirectoryHeaderResponse
 */
export interface BuyerDirectoryHeaderResponse {
    /**
     * 
     * @type {string}
     * @memberof BuyerDirectoryHeaderResponse
     */
    'trade_show_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerDirectoryHeaderResponse
     */
    'event_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerDirectoryHeaderResponse
     */
    'desktop_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerDirectoryHeaderResponse
     */
    'mobile_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerDirectoryHeaderResponse
     */
    'directory_title'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerDirectoryHeaderResponse
     */
    'directory_description'?: string;
}
/**
 * 
 * @export
 * @interface BuyerResponse
 */
export interface BuyerResponse {
    /**
     * 
     * @type {string}
     * @memberof BuyerResponse
     */
    'company_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerResponse
     */
    'website'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerResponse
     */
    'job_function'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerResponse
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerResponse
     */
    'province'?: string;
    /**
     * 
     * @type {string}
     * @memberof BuyerResponse
     */
    'primary_buying_category'?: string;
}
/**
 * 
 * @export
 * @interface CartItemResponse
 */
export interface CartItemResponse {
    /**
     * 
     * @type {string}
     * @memberof CartItemResponse
     */
    'product_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CartItemResponse
     */
    'product_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof CartItemResponse
     */
    'product_lead_time_from'?: number;
    /**
     * 
     * @type {number}
     * @memberof CartItemResponse
     */
    'product_lead_time_to'?: number;
    /**
     * 
     * @type {number}
     * @memberof CartItemResponse
     */
    'product_min_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof CartItemResponse
     */
    'product_max_lead_time'?: number;
    /**
     * 
     * @type {string}
     * @memberof CartItemResponse
     */
    'variant_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CartItemResponse
     */
    'category_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CartItemResponse
     */
    'parent_category_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CartItemResponse
     */
    'category_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CartItemResponse
     */
    'parent_category_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof CartItemResponse
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof CartItemResponse
     */
    'pos_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof CartItemResponse
     */
    'wholesale_minimum'?: number;
    /**
     * 
     * @type {number}
     * @memberof CartItemResponse
     */
    'wholesale_increment'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CartItemResponse
     */
    'is_test_product'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CartItemResponse
     */
    'is_favorite_product'?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CartItemResponse
     */
    'characteristic_option'?: { [key: string]: string; };
    /**
     * 
     * @type {number}
     * @memberof CartItemResponse
     */
    'variant_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof CartItemResponse
     */
    'variant_pos_price'?: number;
    /**
     * 
     * @type {string}
     * @memberof CartItemResponse
     */
    'variant_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CartItemResponse
     */
    'image_url'?: string;
    /**
     * 
     * @type {number}
     * @memberof CartItemResponse
     */
    'tester_minimum_quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof CartItemResponse
     */
    'tester_product_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CartItemResponse
     */
    'tester_variant_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof CartItemResponse
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof CartItemResponse
     */
    'inventory_quantity'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CartItemResponse
     */
    'tracking_inventory'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CartItemResponse
     */
    'query_id'?: string;
}
/**
 * 
 * @export
 * @interface CartResponse
 */
export interface CartResponse {
    /**
     * 
     * @type {Array<SubCartResponse>}
     * @memberof CartResponse
     */
    'sub_carts'?: Array<SubCartResponse>;
    /**
     * 
     * @type {string}
     * @memberof CartResponse
     */
    'promo_code'?: string;
    /**
     * 
     * @type {number}
     * @memberof CartResponse
     */
    'promo_code_amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CartResponse
     */
    'total'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CartResponse
     */
    'valid_mov'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CartResponse
     */
    'has_new_testers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CartResponse
     */
    'has_deleted_items'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CartResponse
     */
    'has_invalid_promo_code'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CartResponse
     */
    'payment_terms'?: CartResponsePaymentTermsEnum;
    /**
     * 
     * @type {number}
     * @memberof CartResponse
     */
    'net_60_credit_remaining'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CartResponse
     */
    'has_changed_items'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CartResponse
     */
    'has_out_of_stock_items'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CartResponse
     */
    'shipping_estimate_price'?: number;
}

export const CartResponsePaymentTermsEnum = {
    Net0: 'NET_0',
    Net60: 'NET_60'
} as const;

export type CartResponsePaymentTermsEnum = typeof CartResponsePaymentTermsEnum[keyof typeof CartResponsePaymentTermsEnum];

/**
 * 
 * @export
 * @interface CartVariantRequest
 */
export interface CartVariantRequest {
    /**
     * 
     * @type {string}
     * @memberof CartVariantRequest
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof CartVariantRequest
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof CartVariantRequest
     */
    'query_id'?: string;
}
/**
 * 
 * @export
 * @interface Category
 */
export interface Category {
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Category
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Category
     */
    'productIds'?: Array<string>;
    /**
     * 
     * @type {Set<Product>}
     * @memberof Category
     */
    'products'?: Set<Product>;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof Category
     */
    'homeOrdinal'?: number;
    /**
     * 
     * @type {number}
     * @memberof Category
     */
    'navigationOrdinal'?: number;
    /**
     * 
     * @type {Category}
     * @memberof Category
     */
    'parentCategory'?: Category;
    /**
     * 
     * @type {Set<Category>}
     * @memberof Category
     */
    'subcategories'?: Set<Category>;
    /**
     * 
     * @type {Category}
     * @memberof Category
     */
    'optionalParentCategory'?: Category;
    /**
     * 
     * @type {boolean}
     * @memberof Category
     */
    'new'?: boolean;
}
/**
 * 
 * @export
 * @interface CategoryWithSubcategoriesResponse
 */
export interface CategoryWithSubcategoriesResponse {
    /**
     * 
     * @type {string}
     * @memberof CategoryWithSubcategoriesResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryWithSubcategoriesResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryWithSubcategoriesResponse
     */
    'image_url'?: string;
    /**
     * 
     * @type {Array<CategoryWithSubcategoriesResponse>}
     * @memberof CategoryWithSubcategoriesResponse
     */
    'subcategories'?: Array<CategoryWithSubcategoriesResponse>;
}
/**
 * 
 * @export
 * @interface ChangeEmailResponse
 */
export interface ChangeEmailResponse {
    /**
     * 
     * @type {string}
     * @memberof ChangeEmailResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeEmailResponse
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeEmailResponse
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeEmailResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeEmailResponse
     */
    'role'?: ChangeEmailResponseRoleEnum;
}

export const ChangeEmailResponseRoleEnum = {
    Brand: 'BRAND',
    Retailer: 'RETAILER',
    Admin: 'ADMIN',
    ProductBuilder: 'PRODUCT_BUILDER'
} as const;

export type ChangeEmailResponseRoleEnum = typeof ChangeEmailResponseRoleEnum[keyof typeof ChangeEmailResponseRoleEnum];

/**
 * Old and new password
 * @export
 * @interface ChangePasswordRequest
 */
export interface ChangePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'current_password'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'new_password'?: string;
}
/**
 * Change card request
 * @export
 * @interface ChangeSuborderCreditCardRequest
 */
export interface ChangeSuborderCreditCardRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangeSuborderCreditCardRequest
     */
    'card_id': string;
}
/**
 * New Suborder status
 * @export
 * @interface ChangeSuborderStatusRequest
 */
export interface ChangeSuborderStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangeSuborderStatusRequest
     */
    'suborder_status': ChangeSuborderStatusRequestSuborderStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ChangeSuborderStatusRequest
     */
    'decline_order_reason'?: ChangeSuborderStatusRequestDeclineOrderReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof ChangeSuborderStatusRequest
     */
    'additional_information'?: string;
}

export const ChangeSuborderStatusRequestSuborderStatusEnum = {
    Hold: 'HOLD',
    Void: 'VOID',
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Declined: 'DECLINED',
    Expired: 'EXPIRED',
    PartiallyFulfilled: 'PARTIALLY_FULFILLED',
    FulfillmentInProgress: 'FULFILLMENT_IN_PROGRESS',
    Shipped: 'SHIPPED',
    Paid: 'PAID',
    Failed: 'FAILED',
    NotCollectable: 'NOT_COLLECTABLE',
    Cancelled: 'CANCELLED'
} as const;

export type ChangeSuborderStatusRequestSuborderStatusEnum = typeof ChangeSuborderStatusRequestSuborderStatusEnum[keyof typeof ChangeSuborderStatusRequestSuborderStatusEnum];
export const ChangeSuborderStatusRequestDeclineOrderReasonEnum = {
    OutOfStock: 'OUT_OF_STOCK',
    LocationRestrictions: 'LOCATION_RESTRICTIONS',
    RetailerBrandFit: 'RETAILER_BRAND_FIT',
    ProductionDelays: 'PRODUCTION_DELAYS',
    RetailerCancelledOrder: 'RETAILER_CANCELLED_ORDER',
    InternationalRestriction: 'INTERNATIONAL_RESTRICTION',
    BulletinDidntVerifyRetailer: 'BULLETIN_DIDNT_VERIFY_RETAILER',
    Other: 'OTHER'
} as const;

export type ChangeSuborderStatusRequestDeclineOrderReasonEnum = typeof ChangeSuborderStatusRequestDeclineOrderReasonEnum[keyof typeof ChangeSuborderStatusRequestDeclineOrderReasonEnum];

/**
 * 
 * @export
 * @interface ChangeViewComponentActivityRequest
 */
export interface ChangeViewComponentActivityRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangeViewComponentActivityRequest
     */
    'view_component_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof ChangeViewComponentActivityRequest
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface Charge
 */
export interface Charge {
    /**
     * 
     * @type {number}
     * @memberof Charge
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof Charge
     */
    'buyerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Charge
     */
    'chargeDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Charge
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Charge
     */
    'currency'?: string;
    /**
     * 
     * @type {number}
     * @memberof Charge
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Charge
     */
    'invoicePdfLink'?: string;
    /**
     * 
     * @type {string}
     * @memberof Charge
     */
    'invoiceToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof Charge
     */
    'milestoneId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Charge
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Charge
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof Charge
     */
    'paymentMethodType'?: string;
    /**
     * 
     * @type {number}
     * @memberof Charge
     */
    'processingFee'?: number;
    /**
     * 
     * @type {string}
     * @memberof Charge
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof Charge
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof Charge
     */
    'url'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Charge
     */
    'vendorIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CheckIfShopifyImportIsInProgressResponse
 */
export interface CheckIfShopifyImportIsInProgressResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CheckIfShopifyImportIsInProgressResponse
     */
    'import_in_progress'?: boolean;
}
/**
 * 
 * @export
 * @interface Checks
 */
export interface Checks {
    /**
     * 
     * @type {Domain}
     * @memberof Checks
     */
    'domain': Domain;
    /**
     * 
     * @type {LocalPart}
     * @memberof Checks
     */
    'local_part': LocalPart;
    /**
     * 
     * @type {Additional}
     * @memberof Checks
     */
    'additional': Additional;
}
/**
 * 
 * @export
 * @interface ChildrenContainerElementsResponse
 */
export interface ChildrenContainerElementsResponse {
    /**
     * 
     * @type {Array<ViewComponentResponse>}
     * @memberof ChildrenContainerElementsResponse
     */
    'view_components'?: Array<ViewComponentResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof ChildrenContainerElementsResponse
     */
    'active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChildrenContainerElementsResponse
     */
    'ordinal'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChildrenContainerElementsResponse
     */
    'container_type'?: ChildrenContainerElementsResponseContainerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ChildrenContainerElementsResponse
     */
    'container_direction'?: ChildrenContainerElementsResponseContainerDirectionEnum;
    /**
     * 
     * @type {string}
     * @memberof ChildrenContainerElementsResponse
     */
    'name'?: string;
}

export const ChildrenContainerElementsResponseContainerTypeEnum = {
    Navigation: 'NAVIGATION',
    NavigationV2: 'NAVIGATION_V2',
    NavigationV2Retailer: 'NAVIGATION_V2_RETAILER',
    NavigationV2Collection: 'NAVIGATION_V2_COLLECTION',
    NavigationV2Categories: 'NAVIGATION_V2_CATEGORIES',
    NavigationV2Subcategory: 'NAVIGATION_V2_SUBCATEGORY',
    Landing: 'LANDING',
    FeaturedCollections: 'FEATURED_COLLECTIONS',
    FeaturedBrands: 'FEATURED_BRANDS',
    FeaturedLinksRetailer: 'FEATURED_LINKS_RETAILER',
    ProductCategories: 'PRODUCT_CATEGORIES',
    TrendingBrands: 'TRENDING_BRANDS',
    Hero: 'HERO',
    About: 'ABOUT',
    PromoBanner: 'PROMO_BANNER',
    PerfectForThe: 'PERFECT_FOR_THE',
    NyNow: 'NY_NOW',
    ExploreNewTrending: 'EXPLORE_NEW_TRENDING',
    TradeShow: 'TRADE_SHOW'
} as const;

export type ChildrenContainerElementsResponseContainerTypeEnum = typeof ChildrenContainerElementsResponseContainerTypeEnum[keyof typeof ChildrenContainerElementsResponseContainerTypeEnum];
export const ChildrenContainerElementsResponseContainerDirectionEnum = {
    Row: 'ROW',
    Column: 'COLUMN',
    Grid: 'GRID'
} as const;

export type ChildrenContainerElementsResponseContainerDirectionEnum = typeof ChildrenContainerElementsResponseContainerDirectionEnum[keyof typeof ChildrenContainerElementsResponseContainerDirectionEnum];

/**
 * 
 * @export
 * @interface ChildrenContainerResponse
 */
export interface ChildrenContainerResponse {
    /**
     * 
     * @type {string}
     * @memberof ChildrenContainerResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChildrenContainerResponse
     */
    'parent_container_id'?: string;
    /**
     * 
     * @type {Array<ViewComponentResponse>}
     * @memberof ChildrenContainerResponse
     */
    'view_components'?: Array<ViewComponentResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof ChildrenContainerResponse
     */
    'active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChildrenContainerResponse
     */
    'ordinal'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChildrenContainerResponse
     */
    'container_direction'?: ChildrenContainerResponseContainerDirectionEnum;
    /**
     * 
     * @type {string}
     * @memberof ChildrenContainerResponse
     */
    'container_type'?: ChildrenContainerResponseContainerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ChildrenContainerResponse
     */
    'name'?: string;
}

export const ChildrenContainerResponseContainerDirectionEnum = {
    Row: 'ROW',
    Column: 'COLUMN',
    Grid: 'GRID'
} as const;

export type ChildrenContainerResponseContainerDirectionEnum = typeof ChildrenContainerResponseContainerDirectionEnum[keyof typeof ChildrenContainerResponseContainerDirectionEnum];
export const ChildrenContainerResponseContainerTypeEnum = {
    Navigation: 'NAVIGATION',
    NavigationV2: 'NAVIGATION_V2',
    NavigationV2Retailer: 'NAVIGATION_V2_RETAILER',
    NavigationV2Collection: 'NAVIGATION_V2_COLLECTION',
    NavigationV2Categories: 'NAVIGATION_V2_CATEGORIES',
    NavigationV2Subcategory: 'NAVIGATION_V2_SUBCATEGORY',
    Landing: 'LANDING',
    FeaturedCollections: 'FEATURED_COLLECTIONS',
    FeaturedBrands: 'FEATURED_BRANDS',
    FeaturedLinksRetailer: 'FEATURED_LINKS_RETAILER',
    ProductCategories: 'PRODUCT_CATEGORIES',
    TrendingBrands: 'TRENDING_BRANDS',
    Hero: 'HERO',
    About: 'ABOUT',
    PromoBanner: 'PROMO_BANNER',
    PerfectForThe: 'PERFECT_FOR_THE',
    NyNow: 'NY_NOW',
    ExploreNewTrending: 'EXPLORE_NEW_TRENDING',
    TradeShow: 'TRADE_SHOW'
} as const;

export type ChildrenContainerResponseContainerTypeEnum = typeof ChildrenContainerResponseContainerTypeEnum[keyof typeof ChildrenContainerResponseContainerTypeEnum];

/**
 * 
 * @export
 * @interface Collection
 */
export interface Collection {
    /**
     * 
     * @type {string}
     * @memberof Collection
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Collection
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Collection
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Collection
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof Collection
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Collection
     */
    'internalTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof Collection
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof Collection
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Collection
     */
    'collectionType': CollectionCollectionTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Collection
     */
    'active': boolean;
    /**
     * 
     * @type {number}
     * @memberof Collection
     */
    'homeOrdinal'?: number;
    /**
     * 
     * @type {Category}
     * @memberof Collection
     */
    'featuredCategory'?: Category;
    /**
     * 
     * @type {Array<string>}
     * @memberof Collection
     */
    'productIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Collection
     */
    'removedProductsIds'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof Collection
     */
    'includeAllConditions'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Collection
     */
    'searchCriteria'?: string;
    /**
     * 
     * @type {string}
     * @memberof Collection
     */
    'cdnUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Collection
     */
    'new'?: boolean;
}

export const CollectionCollectionTypeEnum = {
    Manual: 'MANUAL',
    Automated: 'AUTOMATED',
    Parent: 'PARENT'
} as const;

export type CollectionCollectionTypeEnum = typeof CollectionCollectionTypeEnum[keyof typeof CollectionCollectionTypeEnum];

/**
 * 
 * @export
 * @interface CollectionInfo
 */
export interface CollectionInfo {
    /**
     * 
     * @type {string}
     * @memberof CollectionInfo
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CollectionInfo
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CollectionInfo
     */
    'image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionInfo
     */
    'image_cdn_url'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CollectionInfo
     */
    'product_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CollectionProductBrandResponse
 */
export interface CollectionProductBrandResponse {
    /**
     * 
     * @type {string}
     * @memberof CollectionProductBrandResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionProductBrandResponse
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface CollectionProductResponse
 */
export interface CollectionProductResponse {
    /**
     * 
     * @type {string}
     * @memberof CollectionProductResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionProductResponse
     */
    'name'?: string;
    /**
     * 
     * @type {CollectionProductBrandResponse}
     * @memberof CollectionProductResponse
     */
    'brand'?: CollectionProductBrandResponse;
    /**
     * 
     * @type {number}
     * @memberof CollectionProductResponse
     */
    'wholesale_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof CollectionProductResponse
     */
    'pos_price'?: number;
    /**
     * 
     * @type {string}
     * @memberof CollectionProductResponse
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionProductResponse
     */
    'cdn_image'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionProductResponse
     */
    'is_fav'?: boolean;
}
/**
 * 
 * @export
 * @interface CollectionResponse
 */
export interface CollectionResponse {
    /**
     * 
     * @type {string}
     * @memberof CollectionResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionResponse
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionResponse
     */
    'internal_title'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionResponse
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionResponse
     */
    'image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionResponse
     */
    'image_cdn_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionResponse
     */
    'collection_type'?: CollectionResponseCollectionTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionResponse
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionResponse
     */
    'featured'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CollectionResponse
     */
    'featured_category_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionResponse
     */
    'include_all_conditions'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CollectionResponse
     */
    'search_criteria_string'?: string;
    /**
     * 
     * @type {Array<SearchCriteriaResponse>}
     * @memberof CollectionResponse
     */
    'search_criteria_list'?: Array<SearchCriteriaResponse>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CollectionResponse
     */
    'product_ids'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CollectionResponse
     */
    'removed_product_ids'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CollectionResponse
     */
    'total'?: number;
}

export const CollectionResponseCollectionTypeEnum = {
    Manual: 'MANUAL',
    Automated: 'AUTOMATED',
    Parent: 'PARENT'
} as const;

export type CollectionResponseCollectionTypeEnum = typeof CollectionResponseCollectionTypeEnum[keyof typeof CollectionResponseCollectionTypeEnum];

/**
 * 
 * @export
 * @interface ConditionKeyResponse
 */
export interface ConditionKeyResponse {
    /**
     * 
     * @type {string}
     * @memberof ConditionKeyResponse
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConditionKeyResponse
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConditionKeyResponse
     */
    'available_operators'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ConditionOperatorResponse
 */
export interface ConditionOperatorResponse {
    /**
     * 
     * @type {string}
     * @memberof ConditionOperatorResponse
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConditionOperatorResponse
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface ConfirmOrCreateA2zBrandConnectionRequest
 */
export interface ConfirmOrCreateA2zBrandConnectionRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfirmOrCreateA2zBrandConnectionRequest
     */
    'event_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmOrCreateA2zBrandConnectionRequest
     */
    'coid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmOrCreateA2zBrandConnectionRequest
     */
    'user_id'?: string;
}
/**
 * Confirm packing slip object
 * @export
 * @interface ConfirmPackingSlipRequest
 */
export interface ConfirmPackingSlipRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ConfirmPackingSlipRequest
     */
    'has_unfulfilled_items'?: boolean;
}
/**
 * Confirm user password object
 * @export
 * @interface ConfirmPasswordRequest
 */
export interface ConfirmPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfirmPasswordRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmPasswordRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmPasswordRequest
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmPasswordRequest
     */
    'confirmation_code'?: string;
}
/**
 * 
 * @export
 * @interface CountBrandProductsResponse
 */
export interface CountBrandProductsResponse {
    /**
     * 
     * @type {number}
     * @memberof CountBrandProductsResponse
     */
    'products_count'?: number;
}
/**
 * 
 * @export
 * @interface CountDraftProductsResponse
 */
export interface CountDraftProductsResponse {
    /**
     * 
     * @type {number}
     * @memberof CountDraftProductsResponse
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface CountriesResponse
 */
export interface CountriesResponse {
    /**
     * 
     * @type {Array<CountryWithStatesResponse>}
     * @memberof CountriesResponse
     */
    'countries'?: Array<CountryWithStatesResponse>;
}
/**
 * 
 * @export
 * @interface Country
 */
export interface Country {
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Country
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'abbreviation'?: string;
    /**
     * 
     * @type {Set<State>}
     * @memberof Country
     */
    'states'?: Set<State>;
    /**
     * 
     * @type {boolean}
     * @memberof Country
     */
    'new'?: boolean;
}
/**
 * 
 * @export
 * @interface CountryResponse
 */
export interface CountryResponse {
    /**
     * 
     * @type {string}
     * @memberof CountryResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CountryResponse
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface CountryWithStatesResponse
 */
export interface CountryWithStatesResponse {
    /**
     * 
     * @type {string}
     * @memberof CountryWithStatesResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CountryWithStatesResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CountryWithStatesResponse
     */
    'code'?: string;
    /**
     * 
     * @type {Array<StateResponse>}
     * @memberof CountryWithStatesResponse
     */
    'state'?: Array<StateResponse>;
}
/**
 * New address
 * @export
 * @interface CreateAddressRequest
 */
export interface CreateAddressRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CreateAddressRequest
     */
    'validShippingAddress'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressRequest
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressRequest
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressRequest
     */
    'apartment'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressRequest
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressRequest
     */
    'street': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressRequest
     */
    'zip_code': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressRequest
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressRequest
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressRequest
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressRequest
     */
    'company'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAddressRequest
     */
    'save_as_retailer_address'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAddressRequest
     */
    'shipping': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAddressRequest
     */
    'billing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAddressRequest
     */
    'default_shipping': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAddressRequest
     */
    'default_billing': boolean;
}
/**
 * Create balance order object
 * @export
 * @interface CreateBalanceOrderRequest
 */
export interface CreateBalanceOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateBalanceOrderRequest
     */
    'transaction_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBalanceOrderRequest
     */
    'token_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBalanceOrderRequest
     */
    'saved_shipping_address_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBalanceOrderRequest
     */
    'saved_billing_address_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBalanceOrderRequest
     */
    'use_shipping_as_billing'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateBalanceOrderRequest
     */
    'promo_codes'?: Array<string>;
}
/**
 * Create balance transaction object
 * @export
 * @interface CreateBalanceTransactionRequest
 */
export interface CreateBalanceTransactionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateBalanceTransactionRequest
     */
    'saved_shipping_address_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBalanceTransactionRequest
     */
    'saved_billing_address_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBalanceTransactionRequest
     */
    'use_shipping_as_billing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBalanceTransactionRequest
     */
    'financed'?: boolean;
}
/**
 * Create board object
 * @export
 * @interface CreateBoardRequest
 */
export interface CreateBoardRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateBoardRequest
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateBoardResponse
 */
export interface CreateBoardResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateBoardResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBoardResponse
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateBoardResponse
     */
    'images'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CreateBoardResponse
     */
    'products_count'?: number;
}
/**
 * 
 * @export
 * @interface CreateBoardsForExistingRetailersRequest
 */
export interface CreateBoardsForExistingRetailersRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateBoardsForExistingRetailersRequest
     */
    'number_of_batches'?: number;
}
/**
 * 
 * @export
 * @interface CreateBrandApplicantRequest
 */
export interface CreateBrandApplicantRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateBrandApplicantRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrandApplicantRequest
     */
    'company_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrandApplicantRequest
     */
    'website_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrandApplicantRequest
     */
    'instagram_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrandApplicantRequest
     */
    'bulletin_reference'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrandApplicantRequest
     */
    'based_in'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateBrandApplicantRequest
     */
    'product_category': Array<string>;
    /**
     * 
     * @type {Array<BrandLocationRequest>}
     * @memberof CreateBrandApplicantRequest
     */
    'brand_locations': Array<BrandLocationRequest>;
}
/**
 * Create Brand Board object
 * @export
 * @interface CreateBrandBoardRequest
 */
export interface CreateBrandBoardRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateBrandBoardRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrandBoardRequest
     */
    'visibility'?: CreateBrandBoardRequestVisibilityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBrandBoardRequest
     */
    'show_on_profile'?: boolean;
}

export const CreateBrandBoardRequestVisibilityEnum = {
    Bulletin: 'BULLETIN',
    Public: 'PUBLIC'
} as const;

export type CreateBrandBoardRequestVisibilityEnum = typeof CreateBrandBoardRequestVisibilityEnum[keyof typeof CreateBrandBoardRequestVisibilityEnum];

/**
 * Create brand object
 * @export
 * @interface CreateBrandRequest
 */
export interface CreateBrandRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateBrandRequest
     */
    'brand_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrandRequest
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrandRequest
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrandRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrandRequest
     */
    'brand_description': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrandRequest
     */
    'brand_bio_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrandRequest
     */
    'based_in'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateBrandRequest
     */
    'product_categories'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CreateBrandRequest
     */
    'min_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateBrandRequest
     */
    'max_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateBrandRequest
     */
    'minimum_quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateBrandRequest
     */
    'increment'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBrandRequest
     */
    'instagram_growth_help'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateBrandRequest
     */
    'website_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrandRequest
     */
    'instagram_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrandRequest
     */
    'instagram_followers'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateBrandRequest
     */
    'minimum_order_value': number;
    /**
     * 
     * @type {number}
     * @memberof CreateBrandRequest
     */
    'minimum_reorder_value'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateBrandRequest
     */
    'values'?: Array<CreateBrandRequestValuesEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBrandRequest
     */
    'is_published': boolean;
    /**
     * 
     * @type {object}
     * @memberof CreateBrandRequest
     */
    'address'?: object;
}

export const CreateBrandRequestValuesEnum = {
    FemaleFounded: 'FEMALE_FOUNDED',
    EthicalProduction: 'ETHICAL_PRODUCTION',
    CleanIngredients: 'CLEAN_INGREDIENTS',
    Sustainable: 'SUSTAINABLE',
    Handmade: 'HANDMADE',
    MadeInTheUs: 'MADE_IN_THE_US',
    CharitableBrandGiveBack: 'CHARITABLE_BRAND_GIVE_BACK',
    Organic: 'ORGANIC',
    ZeroWaste: 'ZERO_WASTE',
    BlackOwned: 'BLACK_OWNED',
    LatinxOwned: 'LATINX_OWNED',
    AapiOwned: 'AAPI_OWNED',
    IndigenousOwned: 'INDIGENOUS_OWNED',
    LgbtqOwned: 'LGBTQ_OWNED',
    MinorityOwnedBusiness: 'MINORITY_OWNED_BUSINESS',
    DisabilityOwned: 'DISABILITY_OWNED'
} as const;

export type CreateBrandRequestValuesEnum = typeof CreateBrandRequestValuesEnum[keyof typeof CreateBrandRequestValuesEnum];

/**
 * Create category object
 * @export
 * @interface CreateCategoriesRequest
 */
export interface CreateCategoriesRequest {
    /**
     * 
     * @type {Array<CreateCategoryRequest>}
     * @memberof CreateCategoriesRequest
     */
    'categories'?: Array<CreateCategoryRequest>;
}
/**
 * Create category object
 * @export
 * @interface CreateCategoryRequest
 */
export interface CreateCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCategoryRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCategoryRequest
     */
    'parent_category_id'?: string;
}
/**
 * Create collection object
 * @export
 * @interface CreateCollectionRequest
 */
export interface CreateCollectionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCollectionRequest
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCollectionRequest
     */
    'ordinal': number;
    /**
     * 
     * @type {string}
     * @memberof CreateCollectionRequest
     */
    'entity_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCollectionRequest
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCollectionRequest
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCollectionRequest
     */
    'image_url'?: string;
}
/**
 * Create container
 * @export
 * @interface CreateCollectionsRequest
 */
export interface CreateCollectionsRequest {
    /**
     * 
     * @type {Array<CreateCollectionRequest>}
     * @memberof CreateCollectionsRequest
     */
    'collections'?: Array<CreateCollectionRequest>;
}
/**
 * 
 * @export
 * @interface CreateCollectionsResponse
 */
export interface CreateCollectionsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCollectionsResponse
     */
    'collection_ids'?: Array<string>;
}
/**
 * Create custom assortment object
 * @export
 * @interface CreateCustomAssortmentRequest
 */
export interface CreateCustomAssortmentRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCustomAssortmentRequest
     */
    'retailer_id'?: string;
    /**
     * 
     * @type {Array<CustomAssortmentItemRequest>}
     * @memberof CreateCustomAssortmentRequest
     */
    'custom_assortment_items'?: Array<CustomAssortmentItemRequest>;
}
/**
 * 
 * @export
 * @interface CreateDraftBrandsRequest
 */
export interface CreateDraftBrandsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDraftBrandsRequest
     */
    'brand_ids': Array<string>;
}
/**
 * Name of duplicate product
 * @export
 * @interface CreateDuplicateProductRequest
 */
export interface CreateDuplicateProductRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateDuplicateProductRequest
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateFeaturedLinkInfoRequest
 */
export interface CreateFeaturedLinkInfoRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateFeaturedLinkInfoRequest
     */
    'link_title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFeaturedLinkInfoRequest
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface CreateFeaturedLinkRequest
 */
export interface CreateFeaturedLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateFeaturedLinkRequest
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateFeaturedLinkRequest
     */
    'ordinal': number;
    /**
     * 
     * @type {string}
     * @memberof CreateFeaturedLinkRequest
     */
    'entity_id'?: string;
    /**
     * 
     * @type {CreateFeaturedLinkInfoRequest}
     * @memberof CreateFeaturedLinkRequest
     */
    'info': CreateFeaturedLinkInfoRequest;
}
/**
 * Create featured link
 * @export
 * @interface CreateFeaturedLinksRequest
 */
export interface CreateFeaturedLinksRequest {
    /**
     * 
     * @type {Array<CreateFeaturedLinkRequest>}
     * @memberof CreateFeaturedLinksRequest
     */
    'featured_links'?: Array<CreateFeaturedLinkRequest>;
}
/**
 * 
 * @export
 * @interface CreateFeaturedLinksResponse
 */
export interface CreateFeaturedLinksResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateFeaturedLinksResponse
     */
    'featured_links_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateOnboardingBrandRequest
 */
export interface CreateOnboardingBrandRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateOnboardingBrandRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOnboardingBrandRequest
     */
    'source': CreateOnboardingBrandRequestSourceEnum;
}

export const CreateOnboardingBrandRequestSourceEnum = {
    Application: 'APPLICATION',
    Exhibitor: 'EXHIBITOR',
    Outreach: 'OUTREACH'
} as const;

export type CreateOnboardingBrandRequestSourceEnum = typeof CreateOnboardingBrandRequestSourceEnum[keyof typeof CreateOnboardingBrandRequestSourceEnum];

/**
 * Create order object
 * @export
 * @interface CreateOrderRequest
 */
export interface CreateOrderRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrderRequest
     */
    'validToken'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderRequest
     */
    'token_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderRequest
     */
    'card_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderRequest
     */
    'brand_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderRequest
     */
    'saved_shipping_address_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderRequest
     */
    'saved_billing_address_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrderRequest
     */
    'use_shipping_as_billing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrderRequest
     */
    'save_card': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrderRequest
     */
    'make_default': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrderRequest
     */
    'use_saved_card': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrderRequest
     */
    'pay_on_shipment'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateOrderRequest
     */
    'promo_codes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateOrderResponse
 */
export interface CreateOrderResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    'number'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    'retailer_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    'retailer_name'?: string;
    /**
     * 
     * @type {Array<CreateSuborderResponse>}
     * @memberof CreateOrderResponse
     */
    'suborders'?: Array<CreateSuborderResponse>;
}
/**
 * 
 * @export
 * @interface CreateOrderReturnItemRequest
 */
export interface CreateOrderReturnItemRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateOrderReturnItemRequest
     */
    'suborder_item_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderReturnItemRequest
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderReturnItemRequest
     */
    'reason'?: CreateOrderReturnItemRequestReasonEnum;
}

export const CreateOrderReturnItemRequestReasonEnum = {
    ItemsNotDescribed: 'ITEMS_NOT_DESCRIBED',
    ProductQualityIsLacking: 'PRODUCT_QUALITY_IS_LACKING',
    ProductIsNotGoodFit: 'PRODUCT_IS_NOT_GOOD_FIT',
    ProductNotSell: 'PRODUCT_NOT_SELL',
    PriceNotWork: 'PRICE_NOT_WORK',
    ProductNotMeetExpectations: 'PRODUCT_NOT_MEET_EXPECTATIONS',
    SizingAndFitWasSmallOrTooBig: 'SIZING_AND_FIT_WAS_SMALL_OR_TOO_BIG',
    ItemIsDamaged: 'ITEM_IS_DAMAGED',
    ConsumablesExpiresOrOutOfDate: 'CONSUMABLES_EXPIRES_OR_OUT_OF_DATE'
} as const;

export type CreateOrderReturnItemRequestReasonEnum = typeof CreateOrderReturnItemRequestReasonEnum[keyof typeof CreateOrderReturnItemRequestReasonEnum];

/**
 * Create order return object
 * @export
 * @interface CreateOrderReturnRequest
 */
export interface CreateOrderReturnRequest {
    /**
     * 
     * @type {Array<CreateOrderReturnItemRequest>}
     * @memberof CreateOrderReturnRequest
     */
    'order_return_items'?: Array<CreateOrderReturnItemRequest>;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderReturnRequest
     */
    'comment'?: string;
}
/**
 * Apply to sell object
 * @export
 * @interface CreateOutreachBrandRequest
 */
export interface CreateOutreachBrandRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateOutreachBrandRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOutreachBrandRequest
     */
    'password': string;
}
/**
 * Create packing slip object
 * @export
 * @interface CreatePackingSlipRequest
 */
export interface CreatePackingSlipRequest {
    /**
     * 
     * @type {Array<PackingSlipItemDto>}
     * @memberof CreatePackingSlipRequest
     */
    'items'?: Array<PackingSlipItemDto>;
}
/**
 * 
 * @export
 * @interface CreateProductRequest
 */
export interface CreateProductRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductRequest
     */
    'brand_id'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateProductRequest
     */
    'category_ids'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductRequest
     */
    'sell_pos'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductRequest
     */
    'sell_wholesale'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductRequest
     */
    'active': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateProductRequest
     */
    'pos_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateProductRequest
     */
    'wholesale_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateProductRequest
     */
    'compare_at_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateProductRequest
     */
    'wholesale_minimum'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateProductRequest
     */
    'wholesale_increment'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductRequest
     */
    'opted_into_consignment'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateProductRequest
     */
    'commission_split'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductRequest
     */
    'visible': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateProductRequest
     */
    'min_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateProductRequest
     */
    'max_lead_time'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductRequest
     */
    'is_test_product': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateProductRequest
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateProductRequest
     */
    'characteristics'?: Array<string>;
    /**
     * 
     * @type {Array<VariantRequest>}
     * @memberof CreateProductRequest
     */
    'variants'?: Array<VariantRequest>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateProductRequest
     */
    'collections'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateProductRequest
     */
    'images'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductRequest
     */
    'track_inventory'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateProductRequest
     */
    'weight'?: number;
}
/**
 * Create Promo code object
 * @export
 * @interface CreatePromoCodeRequest
 */
export interface CreatePromoCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePromoCodeRequest
     */
    'promo_code': string;
    /**
     * 
     * @type {number}
     * @memberof CreatePromoCodeRequest
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof CreatePromoCodeRequest
     */
    'start_date': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePromoCodeRequest
     */
    'end_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePromoCodeRequest
     */
    'type': CreatePromoCodeRequestTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePromoCodeRequest
     */
    'first_order_only': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePromoCodeRequest
     */
    'one_time_use': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreatePromoCodeRequest
     */
    'minimum_cart_value'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePromoCodeRequest
     */
    'ongoing_indefinite': boolean;
}

export const CreatePromoCodeRequestTypeEnum = {
    Percent: 'PERCENT',
    Amount: 'AMOUNT',
    FreeShipping: 'FREE_SHIPPING'
} as const;

export type CreatePromoCodeRequestTypeEnum = typeof CreatePromoCodeRequestTypeEnum[keyof typeof CreatePromoCodeRequestTypeEnum];

/**
 * 
 * @export
 * @interface CreateRecommendationRequest
 */
export interface CreateRecommendationRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateRecommendationRequest
     */
    'retailer_id': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateRecommendationRequest
     */
    'brand_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface CreateReferralsByEmailsResponse
 */
export interface CreateReferralsByEmailsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateReferralsByEmailsResponse
     */
    'emails_submitted_twice_by_brand'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateReferralsByEmailsResponse
     */
    'undeliverable_emails'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CreateReferralsByEmailsResponse
     */
    'referral_count'?: number;
}
/**
 * Create Referral object
 * @export
 * @interface CreateReferralsRequest
 */
export interface CreateReferralsRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateReferralsRequest
     */
    'mail_info': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateReferralsRequest
     */
    'emails'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateSuborderResponse
 */
export interface CreateSuborderResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateSuborderResponse
     */
    'suborder_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateSuborderResponse
     */
    'number'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateSuborderResponse
     */
    'brand_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSuborderResponse
     */
    'brand_name'?: string;
}
/**
 * Create TradeShow object
 * @export
 * @interface CreateTradeShowRequest
 */
export interface CreateTradeShowRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateTradeShowRequest
     */
    'trade_show_brand_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTradeShowRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTradeShowRequest
     */
    'location': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTradeShowRequest
     */
    'external_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTradeShowRequest
     */
    'start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTradeShowRequest
     */
    'end_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTradeShowRequest
     */
    'commission_start'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTradeShowRequest
     */
    'commission_end'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTradeShowRequest
     */
    'zero_commission_start'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTradeShowRequest
     */
    'zero_commission_end'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTradeShowRequest
     */
    'registration_url'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTradeShowRequest
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateTradeShowRequest
     */
    'booth_map_url'?: string;
    /**
     * 
     * @type {Array<TradeShowFeatureRequest>}
     * @memberof CreateTradeShowRequest
     */
    'features'?: Array<TradeShowFeatureRequest>;
    /**
     * 
     * @type {string}
     * @memberof CreateTradeShowRequest
     */
    'marketplace_visibility_override'?: CreateTradeShowRequestMarketplaceVisibilityOverrideEnum;
}

export const CreateTradeShowRequestMarketplaceVisibilityOverrideEnum = {
    None: 'NONE',
    Forced: 'FORCED',
    BrandOverride: 'BRAND_OVERRIDE'
} as const;

export type CreateTradeShowRequestMarketplaceVisibilityOverrideEnum = typeof CreateTradeShowRequestMarketplaceVisibilityOverrideEnum[keyof typeof CreateTradeShowRequestMarketplaceVisibilityOverrideEnum];

/**
 * 
 * @export
 * @interface CreateTransactionResponse
 */
export interface CreateTransactionResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionResponse
     */
    'externalReferenceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionResponse
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTransactionResponse
     */
    'token'?: string;
}
/**
 * Create video request
 * @export
 * @interface CreateVideoRequest
 */
export interface CreateVideoRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateVideoRequest
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof CreateVideoRequest
     */
    'entity_type': CreateVideoRequestEntityTypeEnum;
}

export const CreateVideoRequestEntityTypeEnum = {
    Product: 'PRODUCT'
} as const;

export type CreateVideoRequestEntityTypeEnum = typeof CreateVideoRequestEntityTypeEnum[keyof typeof CreateVideoRequestEntityTypeEnum];

/**
 * 
 * @export
 * @interface CreateViewComponentRequest
 */
export interface CreateViewComponentRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateViewComponentRequest
     */
    'entity_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateViewComponentRequest
     */
    'component_type': CreateViewComponentRequestComponentTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateViewComponentRequest
     */
    'ordinal': number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CreateViewComponentRequest
     */
    'info'?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof CreateViewComponentRequest
     */
    'active'?: boolean;
}

export const CreateViewComponentRequestComponentTypeEnum = {
    FeaturedLinksRetailer: 'FEATURED_LINKS_RETAILER',
    NavigationV2: 'NAVIGATION_V2',
    NavigationV2Subcategory: 'NAVIGATION_V2_SUBCATEGORY',
    Category: 'CATEGORY',
    Collection: 'COLLECTION',
    Brand: 'BRAND',
    Hero: 'HERO',
    PromoBanner: 'PROMO_BANNER',
    About: 'ABOUT'
} as const;

export type CreateViewComponentRequestComponentTypeEnum = typeof CreateViewComponentRequestComponentTypeEnum[keyof typeof CreateViewComponentRequestComponentTypeEnum];

/**
 * 
 * @export
 * @interface CreateViewComponentsRequest
 */
export interface CreateViewComponentsRequest {
    /**
     * 
     * @type {Array<CreateViewComponentRequest>}
     * @memberof CreateViewComponentsRequest
     */
    'view_components'?: Array<CreateViewComponentRequest>;
}
/**
 * 
 * @export
 * @interface CreateViewContainerElementsRequest
 */
export interface CreateViewContainerElementsRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateViewContainerElementsRequest
     */
    'parent_container_id'?: string;
    /**
     * 
     * @type {Array<ChildrenContainerElementsResponse>}
     * @memberof CreateViewContainerElementsRequest
     */
    'children_containers'?: Array<ChildrenContainerElementsResponse>;
    /**
     * 
     * @type {string}
     * @memberof CreateViewContainerElementsRequest
     */
    'container_type'?: CreateViewContainerElementsRequestContainerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateViewContainerElementsRequest
     */
    'container_direction'?: CreateViewContainerElementsRequestContainerDirectionEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateViewContainerElementsRequest
     */
    'ordinal'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateViewContainerElementsRequest
     */
    'name'?: string;
}

export const CreateViewContainerElementsRequestContainerTypeEnum = {
    Navigation: 'NAVIGATION',
    NavigationV2: 'NAVIGATION_V2',
    NavigationV2Retailer: 'NAVIGATION_V2_RETAILER',
    NavigationV2Collection: 'NAVIGATION_V2_COLLECTION',
    NavigationV2Categories: 'NAVIGATION_V2_CATEGORIES',
    NavigationV2Subcategory: 'NAVIGATION_V2_SUBCATEGORY',
    Landing: 'LANDING',
    FeaturedCollections: 'FEATURED_COLLECTIONS',
    FeaturedBrands: 'FEATURED_BRANDS',
    FeaturedLinksRetailer: 'FEATURED_LINKS_RETAILER',
    ProductCategories: 'PRODUCT_CATEGORIES',
    TrendingBrands: 'TRENDING_BRANDS',
    Hero: 'HERO',
    About: 'ABOUT',
    PromoBanner: 'PROMO_BANNER',
    PerfectForThe: 'PERFECT_FOR_THE',
    NyNow: 'NY_NOW',
    ExploreNewTrending: 'EXPLORE_NEW_TRENDING',
    TradeShow: 'TRADE_SHOW'
} as const;

export type CreateViewContainerElementsRequestContainerTypeEnum = typeof CreateViewContainerElementsRequestContainerTypeEnum[keyof typeof CreateViewContainerElementsRequestContainerTypeEnum];
export const CreateViewContainerElementsRequestContainerDirectionEnum = {
    Row: 'ROW',
    Column: 'COLUMN',
    Grid: 'GRID'
} as const;

export type CreateViewContainerElementsRequestContainerDirectionEnum = typeof CreateViewContainerElementsRequestContainerDirectionEnum[keyof typeof CreateViewContainerElementsRequestContainerDirectionEnum];

/**
 * Create container
 * @export
 * @interface CreateViewContainerRequest
 */
export interface CreateViewContainerRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateViewContainerRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateViewContainerRequest
     */
    'parent_container_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateViewContainerRequest
     */
    'active': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateViewContainerRequest
     */
    'ordinal': number;
    /**
     * 
     * @type {string}
     * @memberof CreateViewContainerRequest
     */
    'container_direction': CreateViewContainerRequestContainerDirectionEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateViewContainerRequest
     */
    'container_type': CreateViewContainerRequestContainerTypeEnum;
}

export const CreateViewContainerRequestContainerDirectionEnum = {
    Row: 'ROW',
    Column: 'COLUMN',
    Grid: 'GRID'
} as const;

export type CreateViewContainerRequestContainerDirectionEnum = typeof CreateViewContainerRequestContainerDirectionEnum[keyof typeof CreateViewContainerRequestContainerDirectionEnum];
export const CreateViewContainerRequestContainerTypeEnum = {
    Navigation: 'NAVIGATION',
    NavigationV2: 'NAVIGATION_V2',
    NavigationV2Retailer: 'NAVIGATION_V2_RETAILER',
    NavigationV2Collection: 'NAVIGATION_V2_COLLECTION',
    NavigationV2Categories: 'NAVIGATION_V2_CATEGORIES',
    NavigationV2Subcategory: 'NAVIGATION_V2_SUBCATEGORY',
    Landing: 'LANDING',
    FeaturedCollections: 'FEATURED_COLLECTIONS',
    FeaturedBrands: 'FEATURED_BRANDS',
    FeaturedLinksRetailer: 'FEATURED_LINKS_RETAILER',
    ProductCategories: 'PRODUCT_CATEGORIES',
    TrendingBrands: 'TRENDING_BRANDS',
    Hero: 'HERO',
    About: 'ABOUT',
    PromoBanner: 'PROMO_BANNER',
    PerfectForThe: 'PERFECT_FOR_THE',
    NyNow: 'NY_NOW',
    ExploreNewTrending: 'EXPLORE_NEW_TRENDING',
    TradeShow: 'TRADE_SHOW'
} as const;

export type CreateViewContainerRequestContainerTypeEnum = typeof CreateViewContainerRequestContainerTypeEnum[keyof typeof CreateViewContainerRequestContainerTypeEnum];

/**
 * 
 * @export
 * @interface CreditCardData
 */
export interface CreditCardData {
    /**
     * 
     * @type {string}
     * @memberof CreditCardData
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreditCardData
     */
    'brand'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreditCardData
     */
    'expiredMonth'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreditCardData
     */
    'expiredYear'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreditCardData
     */
    'last4'?: string;
}
/**
 * 
 * @export
 * @interface CustomAssortment
 */
export interface CustomAssortment {
    /**
     * 
     * @type {string}
     * @memberof CustomAssortment
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomAssortment
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CustomAssortment
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomAssortment
     */
    'deleted': boolean;
    /**
     * 
     * @type {Retailer}
     * @memberof CustomAssortment
     */
    'retailer': Retailer;
    /**
     * 
     * @type {Set<CustomAssortmentItem>}
     * @memberof CustomAssortment
     */
    'customAssortmentItems'?: Set<CustomAssortmentItem>;
    /**
     * 
     * @type {boolean}
     * @memberof CustomAssortment
     */
    'new'?: boolean;
}
/**
 * 
 * @export
 * @interface CustomAssortmentItem
 */
export interface CustomAssortmentItem {
    /**
     * 
     * @type {string}
     * @memberof CustomAssortmentItem
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomAssortmentItem
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CustomAssortmentItem
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomAssortmentItem
     */
    'deleted': boolean;
    /**
     * 
     * @type {CustomAssortment}
     * @memberof CustomAssortmentItem
     */
    'customAssortment': CustomAssortment;
    /**
     * 
     * @type {ProductVariant}
     * @memberof CustomAssortmentItem
     */
    'productVariant': ProductVariant;
    /**
     * 
     * @type {number}
     * @memberof CustomAssortmentItem
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof CustomAssortmentItem
     */
    'price'?: number;
    /**
     * 
     * @type {Category}
     * @memberof CustomAssortmentItem
     */
    'category': Category;
    /**
     * 
     * @type {boolean}
     * @memberof CustomAssortmentItem
     */
    'new'?: boolean;
}
/**
 * 
 * @export
 * @interface CustomAssortmentItemRequest
 */
export interface CustomAssortmentItemRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomAssortmentItemRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomAssortmentItemRequest
     */
    'variant_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomAssortmentItemRequest
     */
    'category_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomAssortmentItemRequest
     */
    'quantity'?: number;
}
/**
 * 
 * @export
 * @interface CustomAssortmentItemResponse
 */
export interface CustomAssortmentItemResponse {
    /**
     * 
     * @type {string}
     * @memberof CustomAssortmentItemResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomAssortmentItemResponse
     */
    'variant_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomAssortmentItemResponse
     */
    'quantity'?: number;
}
/**
 * 
 * @export
 * @interface CustomAssortmentResponse
 */
export interface CustomAssortmentResponse {
    /**
     * 
     * @type {string}
     * @memberof CustomAssortmentResponse
     */
    'retailer_id'?: string;
    /**
     * 
     * @type {Array<CustomAssortmentItemResponse>}
     * @memberof CustomAssortmentResponse
     */
    'items'?: Array<CustomAssortmentItemResponse>;
}
/**
 * 
 * @export
 * @interface CustomAssortmentsPagination
 */
export interface CustomAssortmentsPagination {
    /**
     * 
     * @type {number}
     * @memberof CustomAssortmentsPagination
     */
    'items_per_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomAssortmentsPagination
     */
    'total_items'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomAssortmentsPagination
     */
    'current_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomAssortmentsPagination
     */
    'total_pages'?: number;
}
/**
 * 
 * @export
 * @interface CustomAssortmentsResponse
 */
export interface CustomAssortmentsResponse {
    /**
     * 
     * @type {string}
     * @memberof CustomAssortmentsResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomAssortmentsResponse
     */
    'retailer_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomAssortmentsResponse
     */
    'retailer_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomAssortmentsResponse
     */
    'created_at'?: string;
}
/**
 * Decline order object
 * @export
 * @interface DeclineSuborderRequest
 */
export interface DeclineSuborderRequest {
    /**
     * 
     * @type {string}
     * @memberof DeclineSuborderRequest
     */
    'decline_order_reason': DeclineSuborderRequestDeclineOrderReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof DeclineSuborderRequest
     */
    'additional_information'?: string;
}

export const DeclineSuborderRequestDeclineOrderReasonEnum = {
    OutOfStock: 'OUT_OF_STOCK',
    LocationRestrictions: 'LOCATION_RESTRICTIONS',
    RetailerBrandFit: 'RETAILER_BRAND_FIT',
    ProductionDelays: 'PRODUCTION_DELAYS',
    RetailerCancelledOrder: 'RETAILER_CANCELLED_ORDER',
    InternationalRestriction: 'INTERNATIONAL_RESTRICTION',
    BulletinDidntVerifyRetailer: 'BULLETIN_DIDNT_VERIFY_RETAILER',
    Other: 'OTHER'
} as const;

export type DeclineSuborderRequestDeclineOrderReasonEnum = typeof DeclineSuborderRequestDeclineOrderReasonEnum[keyof typeof DeclineSuborderRequestDeclineOrderReasonEnum];

/**
 * Flags if address is default shipping or/and default billing address
 * @export
 * @interface DefaultAddressRequest
 */
export interface DefaultAddressRequest {
    /**
     * 
     * @type {boolean}
     * @memberof DefaultAddressRequest
     */
    'default_shipping': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultAddressRequest
     */
    'default_billing': boolean;
}
/**
 * Delete AWS Cognito user object
 * @export
 * @interface DeleteAWSCognitoUserRequest
 */
export interface DeleteAWSCognitoUserRequest {
    /**
     * 
     * @type {string}
     * @memberof DeleteAWSCognitoUserRequest
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface DeleteAlgoliaProductsRequest
 */
export interface DeleteAlgoliaProductsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteAlgoliaProductsRequest
     */
    'ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface DeleteAlgoliaRetailersRequest
 */
export interface DeleteAlgoliaRetailersRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteAlgoliaRetailersRequest
     */
    'ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface DeleteBulkProductRequest
 */
export interface DeleteBulkProductRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteBulkProductRequest
     */
    'product_ids'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DeleteBulkProductRequest
     */
    'brand_id'?: string;
}
/**
 * Packing slips Ids
 * @export
 * @interface DeletePackingSlipsRequest
 */
export interface DeletePackingSlipsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeletePackingSlipsRequest
     */
    'ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface DeletedVariantResponse
 */
export interface DeletedVariantResponse {
    /**
     * 
     * @type {string}
     * @memberof DeletedVariantResponse
     */
    'product_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeletedVariantResponse
     */
    'variant_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeletedVariantResponse
     */
    'product_name'?: string;
}
/**
 * 
 * @export
 * @interface DifferentEntityInfo
 */
export interface DifferentEntityInfo {
    /**
     * 
     * @type {Array<object>}
     * @memberof DifferentEntityInfo
     */
    'redundant_entities_on_algolia'?: Array<object>;
    /**
     * 
     * @type {Array<EntitiesToModifyObject>}
     * @memberof DifferentEntityInfo
     */
    'entities_to_modify'?: Array<EntitiesToModifyObject>;
    /**
     * 
     * @type {Array<object>}
     * @memberof DifferentEntityInfo
     */
    'missing_entities_on_algolia'?: Array<object>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DifferentEntityInfo
     */
    'unparsed_algolia_entity_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface Domain
 */
export interface Domain {
    /**
     * 
     * @type {boolean}
     * @memberof Domain
     */
    'has_valid_address_syntax': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Domain
     */
    'has_mx_or_a_record': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Domain
     */
    'is_suspected_disposable_address': boolean;
}
/**
 * 
 * @export
 * @interface DraftBrandResponse
 */
export interface DraftBrandResponse {
    /**
     * 
     * @type {string}
     * @memberof DraftBrandResponse
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DraftBrandResponse
     */
    'onboarding_complete'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DraftBrandResponse
     */
    'draft_brand_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftBrandResponse
     */
    'user_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftBrandResponse
     */
    'source'?: DraftBrandResponseSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof DraftBrandResponse
     */
    'onboarding_step'?: number;
    /**
     * 
     * @type {string}
     * @memberof DraftBrandResponse
     */
    'admin_first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftBrandResponse
     */
    'admin_last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftBrandResponse
     */
    'account_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftBrandResponse
     */
    'phone_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftBrandResponse
     */
    'company_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftBrandResponse
     */
    'website_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftBrandResponse
     */
    'owner_first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftBrandResponse
     */
    'owner_last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftBrandResponse
     */
    'instagram_account_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftBrandResponse
     */
    'instagram_follower_count'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DraftBrandResponse
     */
    'values'?: Array<DraftBrandResponseValuesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DraftBrandResponse
     */
    'product_categories'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DraftBrandResponse
     */
    'years_in_business'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftBrandResponse
     */
    'profile_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftBrandResponse
     */
    'additional_photography_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftBrandResponse
     */
    'description'?: string;
    /**
     * 
     * @type {object}
     * @memberof DraftBrandResponse
     */
    'address'?: object;
    /**
     * 
     * @type {object}
     * @memberof DraftBrandResponse
     */
    'fulfillment_address'?: object;
    /**
     * 
     * @type {number}
     * @memberof DraftBrandResponse
     */
    'minimum_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof DraftBrandResponse
     */
    'maximum_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof DraftBrandResponse
     */
    'minimum_order_value'?: number;
    /**
     * 
     * @type {number}
     * @memberof DraftBrandResponse
     */
    'reorder_minimum_order_value'?: number;
    /**
     * 
     * @type {number}
     * @memberof DraftBrandResponse
     */
    'minimum_order_quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof DraftBrandResponse
     */
    'product_building_line_sheet_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftBrandResponse
     */
    'product_building_notes'?: string;
    /**
     * 
     * @type {number}
     * @memberof DraftBrandResponse
     */
    'products_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof DraftBrandResponse
     */
    'based_in'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftBrandResponse
     */
    'vanity_url_name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DraftBrandResponse
     */
    'buy_on_bulletin'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DraftBrandResponse
     */
    'ships_from_usa_or_canada'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DraftBrandResponse
     */
    'connect_with_shopify'?: boolean;
}

export const DraftBrandResponseSourceEnum = {
    Application: 'APPLICATION',
    Exhibitor: 'EXHIBITOR',
    Outreach: 'OUTREACH'
} as const;

export type DraftBrandResponseSourceEnum = typeof DraftBrandResponseSourceEnum[keyof typeof DraftBrandResponseSourceEnum];
export const DraftBrandResponseValuesEnum = {
    FemaleFounded: 'FEMALE_FOUNDED',
    EthicalProduction: 'ETHICAL_PRODUCTION',
    CleanIngredients: 'CLEAN_INGREDIENTS',
    Sustainable: 'SUSTAINABLE',
    Handmade: 'HANDMADE',
    MadeInTheUs: 'MADE_IN_THE_US',
    CharitableBrandGiveBack: 'CHARITABLE_BRAND_GIVE_BACK',
    Organic: 'ORGANIC',
    ZeroWaste: 'ZERO_WASTE',
    BlackOwned: 'BLACK_OWNED',
    LatinxOwned: 'LATINX_OWNED',
    AapiOwned: 'AAPI_OWNED',
    IndigenousOwned: 'INDIGENOUS_OWNED',
    LgbtqOwned: 'LGBTQ_OWNED',
    MinorityOwnedBusiness: 'MINORITY_OWNED_BUSINESS',
    DisabilityOwned: 'DISABILITY_OWNED'
} as const;

export type DraftBrandResponseValuesEnum = typeof DraftBrandResponseValuesEnum[keyof typeof DraftBrandResponseValuesEnum];

/**
 * 
 * @export
 * @interface DraftProductRequest
 */
export interface DraftProductRequest {
    /**
     * 
     * @type {string}
     * @memberof DraftProductRequest
     */
    'product_id': string;
    /**
     * 
     * @type {string}
     * @memberof DraftProductRequest
     */
    'title': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DraftProductRequest
     */
    'category_ids': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof DraftProductRequest
     */
    'min_lead_time': number;
    /**
     * 
     * @type {number}
     * @memberof DraftProductRequest
     */
    'max_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof DraftProductRequest
     */
    'unit_price': number;
    /**
     * 
     * @type {number}
     * @memberof DraftProductRequest
     */
    'wholesale_price': number;
}
/**
 * 
 * @export
 * @interface DropdownItem
 */
export interface DropdownItem {
    /**
     * 
     * @type {string}
     * @memberof DropdownItem
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof DropdownItem
     */
    'label'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DropdownItem
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface DuplicateOrderEntry
 */
export interface DuplicateOrderEntry {
    /**
     * 
     * @type {OrderEntry}
     * @memberof DuplicateOrderEntry
     */
    'first'?: OrderEntry;
    /**
     * 
     * @type {OrderEntry}
     * @memberof DuplicateOrderEntry
     */
    'second'?: OrderEntry;
}
/**
 * 
 * @export
 * @interface DuplicateOrderResponse
 */
export interface DuplicateOrderResponse {
    /**
     * 
     * @type {{ [key: string]: Array<DuplicateOrderEntry>; }}
     * @memberof DuplicateOrderResponse
     */
    'duplicate_by_retailer'?: { [key: string]: Array<DuplicateOrderEntry>; };
}
/**
 * 
 * @export
 * @interface DuplicatedProductResponse
 */
export interface DuplicatedProductResponse {
    /**
     * 
     * @type {string}
     * @memberof DuplicatedProductResponse
     */
    'original_product_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DuplicatedProductResponse
     */
    'duplicate_product_id'?: string;
}
/**
 * Admin email
 * @export
 * @interface EmailWrapperDto
 */
export interface EmailWrapperDto {
    /**
     * 
     * @type {string}
     * @memberof EmailWrapperDto
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface EntitiesToModifyObject
 */
export interface EntitiesToModifyObject {
    /**
     * 
     * @type {object}
     * @memberof EntitiesToModifyObject
     */
    'entity_on_algolia'?: object;
    /**
     * 
     * @type {object}
     * @memberof EntitiesToModifyObject
     */
    'entity_in_database'?: object;
}
/**
 * 
 * @export
 * @interface EnumOptionBalanceLevel
 */
export interface EnumOptionBalanceLevel {
    /**
     * 
     * @type {string}
     * @memberof EnumOptionBalanceLevel
     */
    'value'?: EnumOptionBalanceLevelValueEnum;
    /**
     * 
     * @type {string}
     * @memberof EnumOptionBalanceLevel
     */
    'label'?: string;
}

export const EnumOptionBalanceLevelValueEnum = {
    _500: '500',
    _2000: '2000',
    _2500: '2500',
    _5000: '5000',
    _7500: '7500',
    _10000: '10000',
    _15000: '15000',
    _20000: '20000',
    _25000: '25000',
    _100000: '100000'
} as const;

export type EnumOptionBalanceLevelValueEnum = typeof EnumOptionBalanceLevelValueEnum[keyof typeof EnumOptionBalanceLevelValueEnum];

/**
 * 
 * @export
 * @interface EnumOptionOrderStatus
 */
export interface EnumOptionOrderStatus {
    /**
     * 
     * @type {string}
     * @memberof EnumOptionOrderStatus
     */
    'value'?: EnumOptionOrderStatusValueEnum;
    /**
     * 
     * @type {string}
     * @memberof EnumOptionOrderStatus
     */
    'label'?: string;
}

export const EnumOptionOrderStatusValueEnum = {
    Hold: 'HOLD',
    Void: 'VOID',
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Declined: 'DECLINED',
    Expired: 'EXPIRED',
    PartiallyFulfilled: 'PARTIALLY_FULFILLED',
    FulfillmentInProgress: 'FULFILLMENT_IN_PROGRESS',
    Shipped: 'SHIPPED',
    Paid: 'PAID',
    Failed: 'FAILED',
    NotCollectable: 'NOT_COLLECTABLE',
    Cancelled: 'CANCELLED'
} as const;

export type EnumOptionOrderStatusValueEnum = typeof EnumOptionOrderStatusValueEnum[keyof typeof EnumOptionOrderStatusValueEnum];

/**
 * 
 * @export
 * @interface EnumOptionPromoCodeStatus
 */
export interface EnumOptionPromoCodeStatus {
    /**
     * 
     * @type {string}
     * @memberof EnumOptionPromoCodeStatus
     */
    'value'?: EnumOptionPromoCodeStatusValueEnum;
    /**
     * 
     * @type {string}
     * @memberof EnumOptionPromoCodeStatus
     */
    'label'?: string;
}

export const EnumOptionPromoCodeStatusValueEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;

export type EnumOptionPromoCodeStatusValueEnum = typeof EnumOptionPromoCodeStatusValueEnum[keyof typeof EnumOptionPromoCodeStatusValueEnum];

/**
 * 
 * @export
 * @interface EnumOptionRetailerInformedFrom
 */
export interface EnumOptionRetailerInformedFrom {
    /**
     * 
     * @type {string}
     * @memberof EnumOptionRetailerInformedFrom
     */
    'value'?: EnumOptionRetailerInformedFromValueEnum;
    /**
     * 
     * @type {string}
     * @memberof EnumOptionRetailerInformedFrom
     */
    'label'?: string;
}

export const EnumOptionRetailerInformedFromValueEnum = {
    BulletinEmailOutreach: 'Bulletin Email Outreach',
    BulletinInstagram: 'Bulletin Instagram',
    PressOrPublication: 'Press or Publication',
    WordOfMouth: 'Word of mouth',
    ReferredByABrand: 'Referred by a Brand',
    ReferredByARetailer: 'Referred by a Retailer',
    ReferredByAFriend: 'Referred by a Friend',
    FamiliarWithBulletinStores: 'Familiar with Bulletin Stores',
    ExternalFacebookGroup: 'External Facebook Group',
    NyNowDiscoveryShow: 'NY Now Discovery Show',
    ReassembledTradeShow: 'Reassembled Trade Show',
    SupportTheStoresCampaign: 'Support the Stores Campaign',
    Other: 'Other'
} as const;

export type EnumOptionRetailerInformedFromValueEnum = typeof EnumOptionRetailerInformedFromValueEnum[keyof typeof EnumOptionRetailerInformedFromValueEnum];

/**
 * 
 * @export
 * @interface EnumOptionRetailerStatus
 */
export interface EnumOptionRetailerStatus {
    /**
     * 
     * @type {string}
     * @memberof EnumOptionRetailerStatus
     */
    'value'?: EnumOptionRetailerStatusValueEnum;
    /**
     * 
     * @type {string}
     * @memberof EnumOptionRetailerStatus
     */
    'label'?: string;
}

export const EnumOptionRetailerStatusValueEnum = {
    Pending: 'PENDING',
    Active: 'ACTIVE',
    Suspended: 'SUSPENDED',
    Banned: 'BANNED'
} as const;

export type EnumOptionRetailerStatusValueEnum = typeof EnumOptionRetailerStatusValueEnum[keyof typeof EnumOptionRetailerStatusValueEnum];

/**
 * 
 * @export
 * @interface EnumOptionRetailerStoreType
 */
export interface EnumOptionRetailerStoreType {
    /**
     * 
     * @type {string}
     * @memberof EnumOptionRetailerStoreType
     */
    'value'?: EnumOptionRetailerStoreTypeValueEnum;
    /**
     * 
     * @type {string}
     * @memberof EnumOptionRetailerStoreType
     */
    'label'?: string;
}

export const EnumOptionRetailerStoreTypeValueEnum = {
    BrickAndMortar: 'BRICK_AND_MORTAR',
    Online: 'ONLINE',
    PopUp: 'POP_UP'
} as const;

export type EnumOptionRetailerStoreTypeValueEnum = typeof EnumOptionRetailerStoreTypeValueEnum[keyof typeof EnumOptionRetailerStoreTypeValueEnum];

/**
 * Estimate shipping object
 * @export
 * @interface EstimateShippingRequest
 */
export interface EstimateShippingRequest {
    /**
     * 
     * @type {string}
     * @memberof EstimateShippingRequest
     */
    'shipping_address_id': string;
}
/**
 * 
 * @export
 * @interface EstimateShippingResponse
 */
export interface EstimateShippingResponse {
    /**
     * 
     * @type {number}
     * @memberof EstimateShippingResponse
     */
    'estimated_shipping_cost'?: number;
}
/**
 * 
 * @export
 * @interface ExhibitorDirectory
 */
export interface ExhibitorDirectory {
    /**
     * 
     * @type {Array<string>}
     * @memberof ExhibitorDirectory
     */
    'event_ids'?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ExhibitorDirectory
     */
    'booth_maps'?: { [key: string]: string; };
}
/**
 * Exhibitor directory header object
 * @export
 * @interface ExhibitorDirectoryHeaderRequest
 */
export interface ExhibitorDirectoryHeaderRequest {
    /**
     * 
     * @type {string}
     * @memberof ExhibitorDirectoryHeaderRequest
     */
    'desktop_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExhibitorDirectoryHeaderRequest
     */
    'mobile_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExhibitorDirectoryHeaderRequest
     */
    'medium_size_hero_image'?: string;
    /**
     * 
     * @type {ExhibitorHeaderButtonRequest}
     * @memberof ExhibitorDirectoryHeaderRequest
     */
    'button_1'?: ExhibitorHeaderButtonRequest;
    /**
     * 
     * @type {ExhibitorHeaderButtonRequest}
     * @memberof ExhibitorDirectoryHeaderRequest
     */
    'button_2'?: ExhibitorHeaderButtonRequest;
    /**
     * 
     * @type {string}
     * @memberof ExhibitorDirectoryHeaderRequest
     */
    'directory_title'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExhibitorDirectoryHeaderRequest
     */
    'booth_map_url'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExhibitorDirectoryHeaderRequest
     */
    'collections_visible'?: boolean;
}
/**
 * 
 * @export
 * @interface ExhibitorDirectoryHeaderResponse
 */
export interface ExhibitorDirectoryHeaderResponse {
    /**
     * 
     * @type {string}
     * @memberof ExhibitorDirectoryHeaderResponse
     */
    'trade_show_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExhibitorDirectoryHeaderResponse
     */
    'event_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExhibitorDirectoryHeaderResponse
     */
    'desktop_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExhibitorDirectoryHeaderResponse
     */
    'mobile_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExhibitorDirectoryHeaderResponse
     */
    'medium_size_hero_image'?: string;
    /**
     * 
     * @type {ExhibitorHeaderButtonResponse}
     * @memberof ExhibitorDirectoryHeaderResponse
     */
    'button_1'?: ExhibitorHeaderButtonResponse;
    /**
     * 
     * @type {ExhibitorHeaderButtonResponse}
     * @memberof ExhibitorDirectoryHeaderResponse
     */
    'button_2'?: ExhibitorHeaderButtonResponse;
    /**
     * 
     * @type {string}
     * @memberof ExhibitorDirectoryHeaderResponse
     */
    'view_container_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExhibitorDirectoryHeaderResponse
     */
    'directory_title'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExhibitorDirectoryHeaderResponse
     */
    'booth_map_url'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExhibitorDirectoryHeaderResponse
     */
    'collections_visible'?: boolean;
}
/**
 * 
 * @export
 * @interface ExhibitorHeaderButtonRequest
 */
export interface ExhibitorHeaderButtonRequest {
    /**
     * 
     * @type {string}
     * @memberof ExhibitorHeaderButtonRequest
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExhibitorHeaderButtonRequest
     */
    'link_url'?: string;
}
/**
 * 
 * @export
 * @interface ExhibitorHeaderButtonResponse
 */
export interface ExhibitorHeaderButtonResponse {
    /**
     * 
     * @type {string}
     * @memberof ExhibitorHeaderButtonResponse
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExhibitorHeaderButtonResponse
     */
    'link_url'?: string;
}
/**
 * 
 * @export
 * @interface ExploreMoreBrandsResponse
 */
export interface ExploreMoreBrandsResponse {
    /**
     * 
     * @type {Array<ExploredBrandResponse>}
     * @memberof ExploreMoreBrandsResponse
     */
    'brands'?: Array<ExploredBrandResponse>;
}
/**
 * 
 * @export
 * @interface ExploredBrandResponse
 */
export interface ExploredBrandResponse {
    /**
     * 
     * @type {string}
     * @memberof ExploredBrandResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExploredBrandResponse
     */
    'company_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExploredBrandResponse
     */
    'vanity_url_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExploredBrandResponse
     */
    'thumbnail_image_url'?: string;
    /**
     * 
     * @type {number}
     * @memberof ExploredBrandResponse
     */
    'minimum_order_value'?: number;
}
/**
 * Export Trade Show Exhibitors object
 * @export
 * @interface ExportTradeShowExhibitorsToCSVRequest
 */
export interface ExportTradeShowExhibitorsToCSVRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ExportTradeShowExhibitorsToCSVRequest
     */
    'exhibitor_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FavoriteBrandCountResponse
 */
export interface FavoriteBrandCountResponse {
    /**
     * 
     * @type {number}
     * @memberof FavoriteBrandCountResponse
     */
    'favorite_brands_count'?: number;
}
/**
 * 
 * @export
 * @interface FavoriteBrandResponse
 */
export interface FavoriteBrandResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof FavoriteBrandResponse
     */
    'brand_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FavoriteProductsCountResponse
 */
export interface FavoriteProductsCountResponse {
    /**
     * 
     * @type {number}
     * @memberof FavoriteProductsCountResponse
     */
    'favorite_products_count'?: number;
}
/**
 * 
 * @export
 * @interface FeaturedExhibitorsPagination
 */
export interface FeaturedExhibitorsPagination {
    /**
     * 
     * @type {number}
     * @memberof FeaturedExhibitorsPagination
     */
    'items_per_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof FeaturedExhibitorsPagination
     */
    'total_items'?: number;
    /**
     * 
     * @type {number}
     * @memberof FeaturedExhibitorsPagination
     */
    'current_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof FeaturedExhibitorsPagination
     */
    'total_pages'?: number;
    /**
     * 
     * @type {string}
     * @memberof FeaturedExhibitorsPagination
     */
    'seed'?: string;
}
/**
 * 
 * @export
 * @interface Features
 */
export interface Features {
    /**
     * 
     * @type {ExhibitorDirectory}
     * @memberof Features
     */
    'exhibitor_directory'?: ExhibitorDirectory;
    /**
     * 
     * @type {BuyerDirectory}
     * @memberof Features
     */
    'buyer_directory'?: BuyerDirectory;
    /**
     * 
     * @type {Navigation}
     * @memberof Features
     */
    'navigation'?: Navigation;
    /**
     * 
     * @type {ProfileBadges}
     * @memberof Features
     */
    'profile_badges'?: ProfileBadges;
    /**
     * 
     * @type {RestrictExhibitorVisibility}
     * @memberof Features
     */
    'restrict_exhibitor_visibility'?: RestrictExhibitorVisibility;
}
/**
 * 
 * @export
 * @interface FilterProductRequest
 */
export interface FilterProductRequest {
    /**
     * 
     * @type {boolean}
     * @memberof FilterProductRequest
     */
    'include_all_conditions': boolean;
    /**
     * 
     * @type {string}
     * @memberof FilterProductRequest
     */
    'search_criteria': string;
}
/**
 * 
 * @export
 * @interface FilteredProductResponse
 */
export interface FilteredProductResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof FilteredProductResponse
     */
    'product_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FinancingConfig
 */
export interface FinancingConfig {
    /**
     * 
     * @type {number}
     * @memberof FinancingConfig
     */
    'factoringFee'?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancingConfig
     */
    'financingNetDays'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof FinancingConfig
     */
    'financingNetDaysOptions'?: Array<number>;
}
/**
 * 
 * @export
 * @interface GetAbstractViewComponentResponse
 */
export interface GetAbstractViewComponentResponse {
    /**
     * 
     * @type {string}
     * @memberof GetAbstractViewComponentResponse
     */
    'name'?: string;
    /**
     * 
     * @type {Array<AbstractViewComponentResponse>}
     * @memberof GetAbstractViewComponentResponse
     */
    'view_components'?: Array<AbstractViewComponentResponse>;
}
/**
 * 
 * @export
 * @interface GetAllManualCollectionsResponse
 */
export interface GetAllManualCollectionsResponse {
    /**
     * 
     * @type {Array<ManualCollectionResponse>}
     * @memberof GetAllManualCollectionsResponse
     */
    'collections'?: Array<ManualCollectionResponse>;
}
/**
 * 
 * @export
 * @interface GetAllRetailerBoardsDetailsResponse
 */
export interface GetAllRetailerBoardsDetailsResponse {
    /**
     * 
     * @type {Array<RetailerBoardDetailsResponse>}
     * @memberof GetAllRetailerBoardsDetailsResponse
     */
    'boards'?: Array<RetailerBoardDetailsResponse>;
}
/**
 * 
 * @export
 * @interface GetAllTradeShowsResponse
 */
export interface GetAllTradeShowsResponse {
    /**
     * 
     * @type {Array<GetTradeShowDetailsResponse>}
     * @memberof GetAllTradeShowsResponse
     */
    'trade_shows'?: Array<GetTradeShowDetailsResponse>;
}
/**
 * 
 * @export
 * @interface GetAvailableTradeShowBrandsResponse
 */
export interface GetAvailableTradeShowBrandsResponse {
    /**
     * 
     * @type {Array<TradeShowBrandResponse>}
     * @memberof GetAvailableTradeShowBrandsResponse
     */
    'brands'?: Array<TradeShowBrandResponse>;
}
/**
 * 
 * @export
 * @interface GetBoardDetailsResponse
 */
export interface GetBoardDetailsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetBoardDetailsResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBoardDetailsResponse
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetBoardDetailsResponse
     */
    'images'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof GetBoardDetailsResponse
     */
    'products_count'?: number;
    /**
     * 
     * @type {Array<BoardProductResponse>}
     * @memberof GetBoardDetailsResponse
     */
    'products'?: Array<BoardProductResponse>;
    /**
     * 
     * @type {Array<BoardBrandResponse>}
     * @memberof GetBoardDetailsResponse
     */
    'brands'?: Array<BoardBrandResponse>;
}
/**
 * 
 * @export
 * @interface GetBrandBoardDetailsResponse
 */
export interface GetBrandBoardDetailsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetBrandBoardDetailsResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandBoardDetailsResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandBoardDetailsResponse
     */
    'visibility'?: GetBrandBoardDetailsResponseVisibilityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetBrandBoardDetailsResponse
     */
    'show_on_profile'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetBrandBoardDetailsResponse
     */
    'thumbnail_image_url'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetBrandBoardDetailsResponse
     */
    'product_count'?: number;
    /**
     * 
     * @type {BrandFromBrandBoardResponse}
     * @memberof GetBrandBoardDetailsResponse
     */
    'brand'?: BrandFromBrandBoardResponse;
    /**
     * 
     * @type {Array<ProductFromBrandBoardResponse>}
     * @memberof GetBrandBoardDetailsResponse
     */
    'products'?: Array<ProductFromBrandBoardResponse>;
}

export const GetBrandBoardDetailsResponseVisibilityEnum = {
    Bulletin: 'BULLETIN',
    Public: 'PUBLIC'
} as const;

export type GetBrandBoardDetailsResponseVisibilityEnum = typeof GetBrandBoardDetailsResponseVisibilityEnum[keyof typeof GetBrandBoardDetailsResponseVisibilityEnum];

/**
 * 
 * @export
 * @interface GetBrandBoardResponse
 */
export interface GetBrandBoardResponse {
    /**
     * 
     * @type {string}
     * @memberof GetBrandBoardResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandBoardResponse
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetBrandBoardResponse
     */
    'product_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetBrandBoardResponse
     */
    'thumbnail_image_url'?: string;
}
/**
 * 
 * @export
 * @interface GetBrandBoardSharesResponse
 */
export interface GetBrandBoardSharesResponse {
    /**
     * 
     * @type {Array<BrandBoardShareResponse>}
     * @memberof GetBrandBoardSharesResponse
     */
    'shares'?: Array<BrandBoardShareResponse>;
}
/**
 * 
 * @export
 * @interface GetBrandBoardsResponse
 */
export interface GetBrandBoardsResponse {
    /**
     * 
     * @type {Array<BrandBoardResponse>}
     * @memberof GetBrandBoardsResponse
     */
    'brand_boards'?: Array<BrandBoardResponse>;
    /**
     * 
     * @type {number}
     * @memberof GetBrandBoardsResponse
     */
    'total_count'?: number;
}
/**
 * 
 * @export
 * @interface GetBrandCategoriesForDropdownResponse
 */
export interface GetBrandCategoriesForDropdownResponse {
    /**
     * 
     * @type {string}
     * @memberof GetBrandCategoriesForDropdownResponse
     */
    'parent_category'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetBrandCategoriesForDropdownResponse
     */
    'child_categories'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetBrandDetailsResponse
 */
export interface GetBrandDetailsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetBrandDetailsResponse
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandDetailsResponse
     */
    'instagram'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandDetailsResponse
     */
    'phone_number'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetBrandDetailsResponse
     */
    'ships_from_usa_or_canada'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetBrandDetailsResponse
     */
    'years_in_business'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandDetailsResponse
     */
    'section'?: string;
}
/**
 * 
 * @export
 * @interface GetBrandProductResponse
 */
export interface GetBrandProductResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GetBrandProductResponse
     */
    'published'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetBrandProductResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandProductResponse
     */
    'vanity_url_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandProductResponse
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetBrandProductResponse
     */
    'minimum_order_value'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetBrandProductResponse
     */
    'minimum_reorder_value'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetBrandProductResponse
     */
    'ships_from_usa_or_canada'?: boolean;
    /**
     * 
     * @type {Array<DropdownItem>}
     * @memberof GetBrandProductResponse
     */
    'values'?: Array<DropdownItem>;
    /**
     * 
     * @type {number}
     * @memberof GetBrandProductResponse
     */
    'min_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetBrandProductResponse
     */
    'max_lead_time'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetBrandProductResponse
     */
    'buy_on_bulletin'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetBrandProductResponse
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandProductResponse
     */
    'based_in'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetBrandProductResponse
     */
    'is_published'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetBrandProductResponse
     */
    'event_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetBrandResponse
 */
export interface GetBrandResponse {
    /**
     * 
     * @type {string}
     * @memberof GetBrandResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandResponse
     */
    'brand_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandResponse
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandResponse
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandResponse
     */
    'status'?: GetBrandResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetBrandResponse
     */
    'brand_description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandResponse
     */
    'logo_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandResponse
     */
    'brand_bio_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandResponse
     */
    'website_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandResponse
     */
    'instagram_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandResponse
     */
    'instagram_followers'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandResponse
     */
    'based_in'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandResponse
     */
    'product_arrival'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetBrandResponse
     */
    'min_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetBrandResponse
     */
    'max_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetBrandResponse
     */
    'minimum_quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetBrandResponse
     */
    'minimum_price'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetBrandResponse
     */
    'categories'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof GetBrandResponse
     */
    'is_published'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetBrandResponse
     */
    'increment'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetBrandResponse
     */
    'instagram_growth_help'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetBrandResponse
     */
    'minimum_order_value'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetBrandResponse
     */
    'minimum_reorder_value'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetBrandResponse
     */
    'thumbnail_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandResponse
     */
    'vanity_url_name'?: string;
    /**
     * 
     * @type {Array<DropdownItem>}
     * @memberof GetBrandResponse
     */
    'values'?: Array<DropdownItem>;
    /**
     * 
     * @type {number}
     * @memberof GetBrandResponse
     */
    'case_pack_quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetBrandResponse
     */
    'user_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetBrandResponse
     */
    'bulletin_plus_access_level'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBrandResponse
     */
    'onboarding_complete'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof GetBrandResponse
     */
    'address'?: object;
    /**
     * 
     * @type {object}
     * @memberof GetBrandResponse
     */
    'fulfillment_address'?: object;
    /**
     * 
     * @type {string}
     * @memberof GetBrandResponse
     */
    'balance_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandResponse
     */
    'phone_number'?: string;
    /**
     * 
     * @type {ShopifyBrandOrders}
     * @memberof GetBrandResponse
     */
    'shopify'?: ShopifyBrandOrders;
    /**
     * 
     * @type {Array<DropdownItem>}
     * @memberof GetBrandResponse
     */
    'special_services'?: Array<DropdownItem>;
    /**
     * 
     * @type {Array<DropdownItem>}
     * @memberof GetBrandResponse
     */
    'deals_and_promotions'?: Array<DropdownItem>;
    /**
     * 
     * @type {Array<BrandPublishedPromoCodeResponse>}
     * @memberof GetBrandResponse
     */
    'published_promo_codes'?: Array<BrandPublishedPromoCodeResponse>;
    /**
     * 
     * @type {string}
     * @memberof GetBrandResponse
     */
    'source'?: GetBrandResponseSourceEnum;
    /**
     * 
     * @type {{ [key: string]: BrandTradeShowResponse; }}
     * @memberof GetBrandResponse
     */
    'trade_shows'?: { [key: string]: BrandTradeShowResponse; };
    /**
     * 
     * @type {boolean}
     * @memberof GetBrandResponse
     */
    'ships_from_usa_or_canada'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBrandResponse
     */
    'bulletin_pick'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBrandResponse
     */
    'buy_on_bulletin'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBrandResponse
     */
    'connect_with_shopify'?: boolean;
    /**
     * 
     * @type {Array<GetBrandBoardResponse>}
     * @memberof GetBrandResponse
     */
    'boards'?: Array<GetBrandBoardResponse>;
    /**
     * 
     * @type {string}
     * @memberof GetBrandResponse
     */
    'last_login_date'?: string;
}

export const GetBrandResponseStatusEnum = {
    Pending: 'PENDING',
    NeedsReview: 'NEEDS_REVIEW',
    Approved: 'APPROVED',
    Denied: 'DENIED',
    Registered: 'REGISTERED'
} as const;

export type GetBrandResponseStatusEnum = typeof GetBrandResponseStatusEnum[keyof typeof GetBrandResponseStatusEnum];
export const GetBrandResponseSourceEnum = {
    Application: 'APPLICATION',
    Exhibitor: 'EXHIBITOR',
    Outreach: 'OUTREACH'
} as const;

export type GetBrandResponseSourceEnum = typeof GetBrandResponseSourceEnum[keyof typeof GetBrandResponseSourceEnum];

/**
 * 
 * @export
 * @interface GetBrandsWithPromoCodesResponse
 */
export interface GetBrandsWithPromoCodesResponse {
    /**
     * 
     * @type {string}
     * @memberof GetBrandsWithPromoCodesResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandsWithPromoCodesResponse
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface GetCanBrandChangeMarketplaceVisibilityResponse
 */
export interface GetCanBrandChangeMarketplaceVisibilityResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GetCanBrandChangeMarketplaceVisibilityResponse
     */
    'marketplace_visibility_toggle_enabled'?: boolean;
}
/**
 * 
 * @export
 * @interface GetCartProductsAmountResponse
 */
export interface GetCartProductsAmountResponse {
    /**
     * 
     * @type {number}
     * @memberof GetCartProductsAmountResponse
     */
    'products_amount'?: number;
}
/**
 * 
 * @export
 * @interface GetCategoryResponse
 */
export interface GetCategoryResponse {
    /**
     * 
     * @type {string}
     * @memberof GetCategoryResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCategoryResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCategoryResponse
     */
    'parent_category_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCategoryResponse
     */
    'parent_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCategoryResponse
     */
    'image_url'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCategoryResponse
     */
    'product_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetCollectionProductsToExploreResponse
 */
export interface GetCollectionProductsToExploreResponse {
    /**
     * 
     * @type {string}
     * @memberof GetCollectionProductsToExploreResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCollectionProductsToExploreResponse
     */
    'title'?: string;
    /**
     * 
     * @type {Array<CollectionProductResponse>}
     * @memberof GetCollectionProductsToExploreResponse
     */
    'products'?: Array<CollectionProductResponse>;
}
/**
 * 
 * @export
 * @interface GetCollectionViewContainerIdResponse
 */
export interface GetCollectionViewContainerIdResponse {
    /**
     * 
     * @type {string}
     * @memberof GetCollectionViewContainerIdResponse
     */
    'container_id'?: string;
}
/**
 * 
 * @export
 * @interface GetDashboardInvoicesResponse
 */
export interface GetDashboardInvoicesResponse {
    /**
     * 
     * @type {string}
     * @memberof GetDashboardInvoicesResponse
     */
    'suborder_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetDashboardInvoicesResponse
     */
    'suborder_number'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetDashboardInvoicesResponse
     */
    'retailer_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDashboardInvoicesResponse
     */
    'retailer_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDashboardInvoicesResponse
     */
    'invoice_status'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDashboardInvoicesResponse
     */
    'brand_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDashboardInvoicesResponse
     */
    'brand_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetDashboardInvoicesResponse
     */
    'brand_payout'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetDashboardInvoicesResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDashboardInvoicesResponse
     */
    'balance_invoice_url'?: string;
}
/**
 * 
 * @export
 * @interface GetDashboardPaymentsResponse
 */
export interface GetDashboardPaymentsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetDashboardPaymentsResponse
     */
    'suborder_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetDashboardPaymentsResponse
     */
    'suborder_number'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetDashboardPaymentsResponse
     */
    'retailer_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDashboardPaymentsResponse
     */
    'retailer_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDashboardPaymentsResponse
     */
    'invoice_status'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDashboardPaymentsResponse
     */
    'brand_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDashboardPaymentsResponse
     */
    'brand_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetDashboardPaymentsResponse
     */
    'brand_payout'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetDashboardPaymentsResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDashboardPaymentsResponse
     */
    'balance_invoice_url'?: string;
}
/**
 * Field product_variant_ids array contains UUIDs
 * @export
 * @interface GetDeletedVariantsRequest
 */
export interface GetDeletedVariantsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDeletedVariantsRequest
     */
    'product_variant_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface GetDeletedVariantsResponse
 */
export interface GetDeletedVariantsResponse {
    /**
     * 
     * @type {Array<DeletedVariantResponse>}
     * @memberof GetDeletedVariantsResponse
     */
    'deleted_variants'?: Array<DeletedVariantResponse>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDeletedVariantsResponse
     */
    'product_names'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetEnumOptionsResponseBalanceLevel
 */
export interface GetEnumOptionsResponseBalanceLevel {
    /**
     * 
     * @type {Array<EnumOptionBalanceLevel>}
     * @memberof GetEnumOptionsResponseBalanceLevel
     */
    'options'?: Array<EnumOptionBalanceLevel>;
}
/**
 * 
 * @export
 * @interface GetEnumOptionsResponseOrderStatus
 */
export interface GetEnumOptionsResponseOrderStatus {
    /**
     * 
     * @type {Array<EnumOptionOrderStatus>}
     * @memberof GetEnumOptionsResponseOrderStatus
     */
    'options'?: Array<EnumOptionOrderStatus>;
}
/**
 * 
 * @export
 * @interface GetEnumOptionsResponsePromoCodeStatus
 */
export interface GetEnumOptionsResponsePromoCodeStatus {
    /**
     * 
     * @type {Array<EnumOptionPromoCodeStatus>}
     * @memberof GetEnumOptionsResponsePromoCodeStatus
     */
    'options'?: Array<EnumOptionPromoCodeStatus>;
}
/**
 * 
 * @export
 * @interface GetEnumOptionsResponseRetailerInformedFrom
 */
export interface GetEnumOptionsResponseRetailerInformedFrom {
    /**
     * 
     * @type {Array<EnumOptionRetailerInformedFrom>}
     * @memberof GetEnumOptionsResponseRetailerInformedFrom
     */
    'options'?: Array<EnumOptionRetailerInformedFrom>;
}
/**
 * 
 * @export
 * @interface GetEnumOptionsResponseRetailerStatus
 */
export interface GetEnumOptionsResponseRetailerStatus {
    /**
     * 
     * @type {Array<EnumOptionRetailerStatus>}
     * @memberof GetEnumOptionsResponseRetailerStatus
     */
    'options'?: Array<EnumOptionRetailerStatus>;
}
/**
 * 
 * @export
 * @interface GetEnumOptionsResponseRetailerStoreType
 */
export interface GetEnumOptionsResponseRetailerStoreType {
    /**
     * 
     * @type {Array<EnumOptionRetailerStoreType>}
     * @memberof GetEnumOptionsResponseRetailerStoreType
     */
    'options'?: Array<EnumOptionRetailerStoreType>;
}
/**
 * 
 * @export
 * @interface GetFeaturedExhibitorsResponse
 */
export interface GetFeaturedExhibitorsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetFeaturedExhibitorsResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetFeaturedExhibitorsResponse
     */
    'brand_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetFeaturedExhibitorsResponse
     */
    'thumbnail_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetFeaturedExhibitorsResponse
     */
    'vanity_url_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetFeaturedExhibitorsResponse
     */
    'booth'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetFeaturedExhibitorsResponse
     */
    'source'?: string;
}
/**
 * 
 * @export
 * @interface GetInstagramTokenResponse
 */
export interface GetInstagramTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof GetInstagramTokenResponse
     */
    'token'?: string;
}
/**
 * 
 * @export
 * @interface GetInventoryLevelsResponse
 */
export interface GetInventoryLevelsResponse {
    /**
     * 
     * @type {Array<InventoryLevelProductResponse>}
     * @memberof GetInventoryLevelsResponse
     */
    'products'?: Array<InventoryLevelProductResponse>;
    /**
     * 
     * @type {number}
     * @memberof GetInventoryLevelsResponse
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface GetOrderResponse
 */
export interface GetOrderResponse {
    /**
     * 
     * @type {string}
     * @memberof GetOrderResponse
     */
    'retailer_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetOrderResponse
     */
    'number'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrderResponse
     */
    'is_custom_assortment'?: boolean;
    /**
     * 
     * @type {AddressResponse}
     * @memberof GetOrderResponse
     */
    'address'?: AddressResponse;
    /**
     * 
     * @type {string}
     * @memberof GetOrderResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetOrderResponse
     */
    'total_order_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderResponse
     */
    'shipping_estimate_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderResponse
     */
    'total_with_estimated_shipping'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderResponse
     */
    'total_returns_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderResponse
     */
    'auth_amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetOrderResponse
     */
    'payment_type'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrderResponse
     */
    'financed'?: boolean;
    /**
     * 
     * @type {Array<SuborderResponse>}
     * @memberof GetOrderResponse
     */
    'suborders'?: Array<SuborderResponse>;
    /**
     * 
     * @type {Array<BrandResponse>}
     * @memberof GetOrderResponse
     */
    'brands'?: Array<BrandResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrderResponse
     */
    'is_first_order'?: boolean;
}
/**
 * 
 * @export
 * @interface GetOrdersDashboardForSubordersResponse
 */
export interface GetOrdersDashboardForSubordersResponse {
    /**
     * 
     * @type {string}
     * @memberof GetOrdersDashboardForSubordersResponse
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetOrdersDashboardForSubordersResponse
     */
    'order_number'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetOrdersDashboardForSubordersResponse
     */
    'number'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetOrdersDashboardForSubordersResponse
     */
    'retailer_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrdersDashboardForSubordersResponse
     */
    'retailer_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrdersDashboardForSubordersResponse
     */
    'brand_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrdersDashboardForSubordersResponse
     */
    'brand_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrdersDashboardForSubordersResponse
     */
    'order_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrdersDashboardForSubordersResponse
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrdersDashboardForSubordersResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrdersDashboardForSubordersResponse
     */
    'payout_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrdersDashboardForSubordersResponse
     */
    'original_charge_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrdersDashboardForSubordersResponse
     */
    'scheduled_charge_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetOrdersDashboardForSubordersResponse
     */
    'payout'?: number;
    /**
     * 
     * @type {AddressResponse}
     * @memberof GetOrdersDashboardForSubordersResponse
     */
    'address'?: AddressResponse;
    /**
     * 
     * @type {string}
     * @memberof GetOrdersDashboardForSubordersResponse
     */
    'balance_invoice_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrdersDashboardForSubordersResponse
     */
    'retailer_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrdersDashboardForSubordersResponse
     */
    'brand_email'?: string;
}
/**
 * 
 * @export
 * @interface GetOrdersDashboardResponse
 */
export interface GetOrdersDashboardResponse {
    /**
     * 
     * @type {string}
     * @memberof GetOrdersDashboardResponse
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetOrdersDashboardResponse
     */
    'number'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetOrdersDashboardResponse
     */
    'retailer_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrdersDashboardResponse
     */
    'retailer_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrdersDashboardResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetOrdersDashboardResponse
     */
    'shipped_quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetOrdersDashboardResponse
     */
    'total_quantity'?: number;
    /**
     * 
     * @type {Array<SuborderDashboardResponse>}
     * @memberof GetOrdersDashboardResponse
     */
    'suborders'?: Array<SuborderDashboardResponse>;
    /**
     * 
     * @type {AddressResponse}
     * @memberof GetOrdersDashboardResponse
     */
    'address'?: AddressResponse;
    /**
     * 
     * @type {number}
     * @memberof GetOrdersDashboardResponse
     */
    'number_of_returns'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetOrdersDashboardResponse
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetOrdersDashboardResponse
     */
    'total_order_price'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetOrdersDashboardResponse
     */
    'retailer_email'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetOrdersDashboardResponse
     */
    'brand_email'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetPayInvoiceInformationResponse
 */
export interface GetPayInvoiceInformationResponse {
    /**
     * 
     * @type {AddressResponse}
     * @memberof GetPayInvoiceInformationResponse
     */
    'billing_address'?: AddressResponse;
    /**
     * 
     * @type {PaymentSourceResponse}
     * @memberof GetPayInvoiceInformationResponse
     */
    'stripe_payment_source'?: PaymentSourceResponse;
}
/**
 * 
 * @export
 * @interface GetPaymentResponse
 */
export interface GetPaymentResponse {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentResponse
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentResponse
     */
    'number'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentResponse
     */
    'shipped_on'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentResponse
     */
    'brand_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentResponse
     */
    'retailer_name'?: string;
    /**
     * 
     * @type {AddressResponse}
     * @memberof GetPaymentResponse
     */
    'retailer_address'?: AddressResponse;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentResponse
     */
    'retailer_id'?: string;
    /**
     * 
     * @type {AddressResponse}
     * @memberof GetPaymentResponse
     */
    'bulletin_address'?: AddressResponse;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentResponse
     */
    'promo_code'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentResponse
     */
    'promo_code_discount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentResponse
     */
    'shipping_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentResponse
     */
    'commission'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentResponse
     */
    'commission_percent'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentResponse
     */
    'total_suborder_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentResponse
     */
    'total_payout_price'?: number;
    /**
     * 
     * @type {Array<GetSuborderItemsResponse>}
     * @memberof GetPaymentResponse
     */
    'items'?: Array<GetSuborderItemsResponse>;
}
/**
 * 
 * @export
 * @interface GetProductFeedResponse
 */
export interface GetProductFeedResponse {
    /**
     * 
     * @type {string}
     * @memberof GetProductFeedResponse
     */
    'product_feed_id'?: string;
}
/**
 * 
 * @export
 * @interface GetProductFilteredResponse
 */
export interface GetProductFilteredResponse {
    /**
     * 
     * @type {string}
     * @memberof GetProductFilteredResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetProductFilteredResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetProductFilteredResponse
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetProductFilteredResponse
     */
    'brand_id': string;
    /**
     * 
     * @type {string}
     * @memberof GetProductFilteredResponse
     */
    'brand_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetProductFilteredResponse
     */
    'brand_minimum_order_value'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetProductFilteredResponse
     */
    'brand_minimum_reorder_value'?: number;
    /**
     * 
     * @type {Array<ProductCategoryResponse>}
     * @memberof GetProductFilteredResponse
     */
    'categories'?: Array<ProductCategoryResponse>;
    /**
     * 
     * @type {string}
     * @memberof GetProductFilteredResponse
     */
    'status'?: GetProductFilteredResponseStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductFilteredResponse
     */
    'sell_pos'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductFilteredResponse
     */
    'sell_wholesale'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductFilteredResponse
     */
    'active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetProductFilteredResponse
     */
    'pos_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetProductFilteredResponse
     */
    'wholesale_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetProductFilteredResponse
     */
    'compare_at_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetProductFilteredResponse
     */
    'wholesale_minimum'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetProductFilteredResponse
     */
    'wholesale_increment'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductFilteredResponse
     */
    'opted_into_consignment'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetProductFilteredResponse
     */
    'commission_split'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductFilteredResponse
     */
    'visible'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetProductFilteredResponse
     */
    'min_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetProductFilteredResponse
     */
    'max_lead_time'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetProductFilteredResponse
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetProductFilteredResponse
     */
    'characteristics'?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof GetProductFilteredResponse
     */
    'characteristic_options'?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<GetProductVariantResponse>}
     * @memberof GetProductFilteredResponse
     */
    'variants'?: Array<GetProductVariantResponse>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetProductFilteredResponse
     */
    'images'?: Array<string>;
}

export const GetProductFilteredResponseStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
    Any: 'ANY',
    Draft: 'DRAFT'
} as const;

export type GetProductFilteredResponseStatusEnum = typeof GetProductFilteredResponseStatusEnum[keyof typeof GetProductFilteredResponseStatusEnum];

/**
 * 
 * @export
 * @interface GetProductImageResponse
 */
export interface GetProductImageResponse {
    /**
     * 
     * @type {string}
     * @memberof GetProductImageResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetProductImageResponse
     */
    'cdn_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetProductImageResponse
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetProductImageResponse
     */
    'original_url'?: string;
    /**
     * 
     * @type {object}
     * @memberof GetProductImageResponse
     */
    'crop_params'?: object;
    /**
     * 
     * @type {number}
     * @memberof GetProductImageResponse
     */
    'ordinal'?: number;
}
/**
 * 
 * @export
 * @interface GetProductResponse
 */
export interface GetProductResponse {
    /**
     * 
     * @type {string}
     * @memberof GetProductResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetProductResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetProductResponse
     */
    'description'?: string;
    /**
     * 
     * @type {GetBrandProductResponse}
     * @memberof GetProductResponse
     */
    'brand'?: GetBrandProductResponse;
    /**
     * 
     * @type {string}
     * @memberof GetProductResponse
     */
    'status'?: GetProductResponseStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductResponse
     */
    'sell_pos'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductResponse
     */
    'sell_wholesale'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductResponse
     */
    'active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetProductResponse
     */
    'pos_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetProductResponse
     */
    'wholesale_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetProductResponse
     */
    'compare_at_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetProductResponse
     */
    'wholesale_minimum'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetProductResponse
     */
    'wholesale_increment'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductResponse
     */
    'opted_into_consignment'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetProductResponse
     */
    'commission_split'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductResponse
     */
    'visible'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetProductResponse
     */
    'min_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetProductResponse
     */
    'max_lead_time'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductResponse
     */
    'is_test_product'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetProductResponse
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetProductResponse
     */
    'characteristics'?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof GetProductResponse
     */
    'characteristic_options'?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<GetProductVariantResponse>}
     * @memberof GetProductResponse
     */
    'variants'?: Array<GetProductVariantResponse>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetProductResponse
     */
    'collections'?: Array<string>;
    /**
     * 
     * @type {Array<GetProductImageResponse>}
     * @memberof GetProductResponse
     */
    'images'?: Array<GetProductImageResponse>;
    /**
     * 
     * @type {GetVideoResponse}
     * @memberof GetProductResponse
     */
    'video'?: GetVideoResponse;
    /**
     * 
     * @type {Array<GetProductImageResponse>}
     * @memberof GetProductResponse
     */
    'custom_assortment_images'?: Array<GetProductImageResponse>;
    /**
     * 
     * @type {Array<ProductCategoryResponse>}
     * @memberof GetProductResponse
     */
    'categories'?: Array<ProductCategoryResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductResponse
     */
    'track_inventory'?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetProductResponse
     */
    'shopify'?: { [key: string]: string; };
    /**
     * 
     * @type {number}
     * @memberof GetProductResponse
     */
    'weight'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductResponse
     */
    'created_by_admin'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetProductResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetProductResponse
     */
    'updated_at'?: string;
}

export const GetProductResponseStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
    Any: 'ANY',
    Draft: 'DRAFT'
} as const;

export type GetProductResponseStatusEnum = typeof GetProductResponseStatusEnum[keyof typeof GetProductResponseStatusEnum];

/**
 * 
 * @export
 * @interface GetProductVariantResponse
 */
export interface GetProductVariantResponse {
    /**
     * 
     * @type {string}
     * @memberof GetProductVariantResponse
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetProductVariantResponse
     */
    'pos_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetProductVariantResponse
     */
    'wholesale_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetProductVariantResponse
     */
    'cost_per_item'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetProductVariantResponse
     */
    'compare_at_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetProductVariantResponse
     */
    'ordinal'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetProductVariantResponse
     */
    'image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetProductVariantResponse
     */
    'image_cdn_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetProductVariantResponse
     */
    'tester_variant_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetProductVariantResponse
     */
    'tester_product_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetProductVariantResponse
     */
    'tester_product_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetProductVariantResponse
     */
    'tester_minimum_quantity'?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetProductVariantResponse
     */
    'characteristic_option'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof GetProductVariantResponse
     */
    'sku'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductVariantResponse
     */
    'in_stock'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetProductVariantResponse
     */
    'inventory_quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetProductVariantResponse
     */
    'weight'?: number;
}
/**
 * 
 * @export
 * @interface GetProductsByCategoryResponse
 */
export interface GetProductsByCategoryResponse {
    /**
     * 
     * @type {string}
     * @memberof GetProductsByCategoryResponse
     */
    'category_name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetProductsByCategoryResponse
     */
    'product_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetReorderResponse
 */
export interface GetReorderResponse {
    /**
     * 
     * @type {Array<ReorderResponse>}
     * @memberof GetReorderResponse
     */
    'reorders'?: Array<ReorderResponse>;
    /**
     * 
     * @type {number}
     * @memberof GetReorderResponse
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface GetRetailerBoardsResponse
 */
export interface GetRetailerBoardsResponse {
    /**
     * 
     * @type {Array<RetailerBoardResponse>}
     * @memberof GetRetailerBoardsResponse
     */
    'boards'?: Array<RetailerBoardResponse>;
}
/**
 * 
 * @export
 * @interface GetRetailerResponse
 */
export interface GetRetailerResponse {
    /**
     * 
     * @type {string}
     * @memberof GetRetailerResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRetailerResponse
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRetailerResponse
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRetailerResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRetailerResponse
     */
    'store_name'?: string;
    /**
     * 
     * @type {UtmParams}
     * @memberof GetRetailerResponse
     */
    'utm_params'?: UtmParams;
}
/**
 * 
 * @export
 * @interface GetStockistsResponse
 */
export interface GetStockistsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetStockistsResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStockistsResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStockistsResponse
     */
    'city'?: string;
}
/**
 * 
 * @export
 * @interface GetStripeCustomerIdResponse
 */
export interface GetStripeCustomerIdResponse {
    /**
     * 
     * @type {string}
     * @memberof GetStripeCustomerIdResponse
     */
    'stripe_customer_id'?: string;
}
/**
 * 
 * @export
 * @interface GetSubcategoriesResponse
 */
export interface GetSubcategoriesResponse {
    /**
     * 
     * @type {Array<GetCategoryResponse>}
     * @memberof GetSubcategoriesResponse
     */
    'subcategories'?: Array<GetCategoryResponse>;
}
/**
 * 
 * @export
 * @interface GetSuborderItemsResponse
 */
export interface GetSuborderItemsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetSuborderItemsResponse
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetSuborderItemsResponse
     */
    'shipped_quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetSuborderItemsResponse
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetSuborderItemsResponse
     */
    'product_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSuborderItemsResponse
     */
    'product_image'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetSuborderItemsResponse
     */
    'characteristic_option_map'?: { [key: string]: string; };
    /**
     * 
     * @type {number}
     * @memberof GetSuborderItemsResponse
     */
    'total_suborder_item_price'?: number;
}
/**
 * 
 * @export
 * @interface GetTradeShowBuyersResponse
 */
export interface GetTradeShowBuyersResponse {
    /**
     * 
     * @type {Array<BuyerResponse>}
     * @memberof GetTradeShowBuyersResponse
     */
    'buyers'?: Array<BuyerResponse>;
    /**
     * 
     * @type {number}
     * @memberof GetTradeShowBuyersResponse
     */
    'buyers_count'?: number;
}
/**
 * 
 * @export
 * @interface GetTradeShowByEventIdResponse
 */
export interface GetTradeShowByEventIdResponse {
    /**
     * 
     * @type {string}
     * @memberof GetTradeShowByEventIdResponse
     */
    'id'?: string;
    /**
     * 
     * @type {TradeShowBrandResponse}
     * @memberof GetTradeShowByEventIdResponse
     */
    'trade_show_brand'?: TradeShowBrandResponse;
    /**
     * 
     * @type {string}
     * @memberof GetTradeShowByEventIdResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTradeShowByEventIdResponse
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTradeShowByEventIdResponse
     */
    'external_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTradeShowByEventIdResponse
     */
    'start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTradeShowByEventIdResponse
     */
    'end_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetTradeShowByEventIdResponse
     */
    'exhibitor_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTradeShowByEventIdResponse
     */
    'attendee_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetTradeShowByEventIdResponse
     */
    'registration_url'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetTradeShowByEventIdResponse
     */
    'collections_visible'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetTradeShowByEventIdResponse
     */
    'view_container_id'?: string;
    /**
     * 
     * @type {object}
     * @memberof GetTradeShowByEventIdResponse
     */
    'exhibitor_directory_header'?: object;
    /**
     * 
     * @type {object}
     * @memberof GetTradeShowByEventIdResponse
     */
    'buyer_directory_header'?: object;
    /**
     * 
     * @type {Array<TradeShowFeatureResponse>}
     * @memberof GetTradeShowByEventIdResponse
     */
    'features'?: Array<TradeShowFeatureResponse>;
}
/**
 * 
 * @export
 * @interface GetTradeShowDetailsResponse
 */
export interface GetTradeShowDetailsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetTradeShowDetailsResponse
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetTradeShowDetailsResponse
     */
    'archived'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetTradeShowDetailsResponse
     */
    'brand'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTradeShowDetailsResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTradeShowDetailsResponse
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTradeShowDetailsResponse
     */
    'external_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTradeShowDetailsResponse
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTradeShowDetailsResponse
     */
    'start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTradeShowDetailsResponse
     */
    'end_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetTradeShowDetailsResponse
     */
    'exhibitor_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTradeShowDetailsResponse
     */
    'attendee_count'?: number;
}
/**
 * 
 * @export
 * @interface GetTradeShowRecommendedBrandsResponse
 */
export interface GetTradeShowRecommendedBrandsResponse {
    /**
     * 
     * @type {Array<TradeShowRecommendedBrandsResponse>}
     * @memberof GetTradeShowRecommendedBrandsResponse
     */
    'recommendations'?: Array<TradeShowRecommendedBrandsResponse>;
}
/**
 * 
 * @export
 * @interface GetVideoResponse
 */
export interface GetVideoResponse {
    /**
     * 
     * @type {string}
     * @memberof GetVideoResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetVideoResponse
     */
    'entity_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetVideoResponse
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetVideoResponse
     */
    'entity_type'?: GetVideoResponseEntityTypeEnum;
}

export const GetVideoResponseEntityTypeEnum = {
    Product: 'PRODUCT'
} as const;

export type GetVideoResponseEntityTypeEnum = typeof GetVideoResponseEntityTypeEnum[keyof typeof GetVideoResponseEntityTypeEnum];

/**
 * 
 * @export
 * @interface GrantedAuthority
 */
export interface GrantedAuthority {
    /**
     * 
     * @type {string}
     * @memberof GrantedAuthority
     */
    'authority'?: string;
}
/**
 * 
 * @export
 * @interface HubSpotRetailerSignUpRequest
 */
export interface HubSpotRetailerSignUpRequest {
    /**
     * 
     * @type {string}
     * @memberof HubSpotRetailerSignUpRequest
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof HubSpotRetailerSignUpRequest
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof HubSpotRetailerSignUpRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof HubSpotRetailerSignUpRequest
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof HubSpotRetailerSignUpRequest
     */
    'store_website_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof HubSpotRetailerSignUpRequest
     */
    'store_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof HubSpotRetailerSignUpRequest
     */
    'utm_medium'?: string;
    /**
     * 
     * @type {string}
     * @memberof HubSpotRetailerSignUpRequest
     */
    'utm_source'?: string;
    /**
     * 
     * @type {string}
     * @memberof HubSpotRetailerSignUpRequest
     */
    'utm_campaign'?: string;
}
/**
 * 
 * @export
 * @interface IdWrapper
 */
export interface IdWrapper {
    /**
     * 
     * @type {string}
     * @memberof IdWrapper
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface Image
 */
export interface Image {
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Image
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'entityType': ImageEntityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'originalUrl': string;
    /**
     * 
     * @type {object}
     * @memberof Image
     */
    'cropParams': object;
    /**
     * 
     * @type {number}
     * @memberof Image
     */
    'ordinal'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Image
     */
    'isCustomAssortmentImage'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'cdnUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Image
     */
    'thumbnail'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Image
     */
    'cropped'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Image
     */
    'new'?: boolean;
}

export const ImageEntityTypeEnum = {
    Product: 'PRODUCT',
    Location: 'LOCATION'
} as const;

export type ImageEntityTypeEnum = typeof ImageEntityTypeEnum[keyof typeof ImageEntityTypeEnum];

/**
 * 
 * @export
 * @interface ImageShopifyDTO
 */
export interface ImageShopifyDTO {
    /**
     * 
     * @type {Image}
     * @memberof ImageShopifyDTO
     */
    'image'?: Image;
    /**
     * 
     * @type {number}
     * @memberof ImageShopifyDTO
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ImageShopifyDTO
     */
    'product_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ImageShopifyDTO
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageShopifyDTO
     */
    'entity_type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ImageShopifyDTO
     */
    'ordinal'?: number;
}
/**
 * 
 * @export
 * @interface ImportBulletinIncubatorBrandsRequest
 */
export interface ImportBulletinIncubatorBrandsRequest {
    /**
     * 
     * @type {string}
     * @memberof ImportBulletinIncubatorBrandsRequest
     */
    'event_id': string;
    /**
     * 
     * @type {Array<BulletinIncubatorBrandRequest>}
     * @memberof ImportBulletinIncubatorBrandsRequest
     */
    'brands'?: Array<BulletinIncubatorBrandRequest>;
}
/**
 * 
 * @export
 * @interface ImportProductsFromCsvRequest
 */
export interface ImportProductsFromCsvRequest {
    /**
     * Csv file as form data object
     * @type {File}
     * @memberof ImportProductsFromCsvRequest
     */
    'csvFile': File;
    /**
     * Email address as form data object
     * @type {File}
     * @memberof ImportProductsFromCsvRequest
     */
    'email': File;
}
/**
 * 
 * @export
 * @interface ImportProductsNavigationRequest
 */
export interface ImportProductsNavigationRequest {
    /**
     * 
     * @type {string}
     * @memberof ImportProductsNavigationRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ImportProductsNavigationRequest
     */
    'brand_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportProductsNavigationRequest
     */
    'product_name': string;
    /**
     * 
     * @type {string}
     * @memberof ImportProductsNavigationRequest
     */
    'subcategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportProductsNavigationRequest
     */
    'new_subcategory': string;
    /**
     * 
     * @type {string}
     * @memberof ImportProductsNavigationRequest
     */
    'parent_category'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportProductsNavigationRequest
     */
    'new_parent_category'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportProductsNavigationRequest
     */
    'collection'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportProductsNavigationRequest
     */
    'tags'?: string;
}
/**
 * 
 * @export
 * @interface ImportReferralsFromCSVRequest
 */
export interface ImportReferralsFromCSVRequest {
    /**
     * CSV file which contains referrals email addresses.
     * @type {File}
     * @memberof ImportReferralsFromCSVRequest
     */
    'file': File;
    /**
     * Html file which will be included inside referral email
     * @type {File}
     * @memberof ImportReferralsFromCSVRequest
     */
    'mail_info': File;
}
/**
 * 
 * @export
 * @interface ImportTestExhibitorsRequest
 */
export interface ImportTestExhibitorsRequest {
    /**
     * 
     * @type {Array<BrandOverrideAttributesRequest>}
     * @memberof ImportTestExhibitorsRequest
     */
    'brandAttributes': Array<BrandOverrideAttributesRequest>;
}
/**
 * 
 * @export
 * @interface InventoryLevelProductResponse
 */
export interface InventoryLevelProductResponse {
    /**
     * 
     * @type {string}
     * @memberof InventoryLevelProductResponse
     */
    'product_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryLevelProductResponse
     */
    'product_name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InventoryLevelProductResponse
     */
    'track_inventory'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InventoryLevelProductResponse
     */
    'thumbnail_image'?: string;
    /**
     * 
     * @type {Array<InventoryLevelVariantResponse>}
     * @memberof InventoryLevelProductResponse
     */
    'variants'?: Array<InventoryLevelVariantResponse>;
}
/**
 * 
 * @export
 * @interface InventoryLevelVariantResponse
 */
export interface InventoryLevelVariantResponse {
    /**
     * 
     * @type {string}
     * @memberof InventoryLevelVariantResponse
     */
    'variant_id'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof InventoryLevelVariantResponse
     */
    'characteristic_options'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof InventoryLevelVariantResponse
     */
    'sku'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InventoryLevelVariantResponse
     */
    'in_stock'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InventoryLevelVariantResponse
     */
    'inventory_quantity'?: number;
}
/**
 * 
 * @export
 * @interface InvoiceResponse
 */
export interface InvoiceResponse {
    /**
     * 
     * @type {string}
     * @memberof InvoiceResponse
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof InvoiceResponse
     */
    'number'?: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {AddressResponse}
     * @memberof InvoiceResponse
     */
    'retailer_address'?: AddressResponse;
    /**
     * 
     * @type {AddressResponse}
     * @memberof InvoiceResponse
     */
    'bulletin_address'?: AddressResponse;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResponse
     */
    'scheduled_charge_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResponse
     */
    'manually_charge_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResponse
     */
    'promo_code'?: string;
    /**
     * 
     * @type {number}
     * @memberof InvoiceResponse
     */
    'promo_code_discount'?: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResponse
     */
    'promo_code_type'?: InvoiceResponsePromoCodeTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof InvoiceResponse
     */
    'shipping_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceResponse
     */
    'total_suborder_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceResponse
     */
    'total_suborder_items_price'?: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResponse
     */
    'status'?: InvoiceResponseStatusEnum;
    /**
     * 
     * @type {Array<GetSuborderItemsResponse>}
     * @memberof InvoiceResponse
     */
    'items'?: Array<GetSuborderItemsResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceResponse
     */
    'manually_charged'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResponse
     */
    'charge_status'?: InvoiceResponseChargeStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceResponse
     */
    'paid_via_balance'?: boolean;
}

export const InvoiceResponsePromoCodeTypeEnum = {
    Percent: 'PERCENT',
    Amount: 'AMOUNT',
    FreeShipping: 'FREE_SHIPPING'
} as const;

export type InvoiceResponsePromoCodeTypeEnum = typeof InvoiceResponsePromoCodeTypeEnum[keyof typeof InvoiceResponsePromoCodeTypeEnum];
export const InvoiceResponseStatusEnum = {
    Paid: 'PAID',
    NotPaid: 'NOT_PAID',
    PaymentFailed: 'PAYMENT_FAILED',
    UnprocessableCharge: 'UNPROCESSABLE_CHARGE'
} as const;

export type InvoiceResponseStatusEnum = typeof InvoiceResponseStatusEnum[keyof typeof InvoiceResponseStatusEnum];
export const InvoiceResponseChargeStatusEnum = {
    Pending: 'PENDING',
    Successful: 'SUCCESSFUL',
    Failed: 'FAILED',
    OrderCanceled: 'ORDER_CANCELED'
} as const;

export type InvoiceResponseChargeStatusEnum = typeof InvoiceResponseChargeStatusEnum[keyof typeof InvoiceResponseChargeStatusEnum];

/**
 * 
 * @export
 * @interface InvoicesPaginationResponse
 */
export interface InvoicesPaginationResponse {
    /**
     * 
     * @type {number}
     * @memberof InvoicesPaginationResponse
     */
    'items_per_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicesPaginationResponse
     */
    'total_items'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicesPaginationResponse
     */
    'current_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicesPaginationResponse
     */
    'total_pages'?: number;
}
/**
 * 
 * @export
 * @interface Item
 */
export interface Item {
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'variant_id': string;
    /**
     * 
     * @type {number}
     * @memberof Item
     */
    'ordered_quantity': number;
    /**
     * 
     * @type {number}
     * @memberof Item
     */
    'fulfilled_quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof Item
     */
    'shipped_quantity'?: number;
}
/**
 * 
 * @export
 * @interface LeverResponse
 */
export interface LeverResponse {
    /**
     * 
     * @type {string}
     * @memberof LeverResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof LeverResponse
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof LeverResponse
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface LeversResponse
 */
export interface LeversResponse {
    /**
     * 
     * @type {Array<LeverResponse>}
     * @memberof LeversResponse
     */
    'levers'?: Array<LeverResponse>;
}
/**
 * 
 * @export
 * @interface Line
 */
export interface Line {
    /**
     * 
     * @type {number}
     * @memberof Line
     */
    'discount'?: number;
    /**
     * 
     * @type {Array<LineItem>}
     * @memberof Line
     */
    'lineItems'?: Array<LineItem>;
    /**
     * 
     * @type {number}
     * @memberof Line
     */
    'marketplaceFixedTake'?: number;
    /**
     * 
     * @type {number}
     * @memberof Line
     */
    'marketplacePercentageTake'?: number;
    /**
     * 
     * @type {number}
     * @memberof Line
     */
    'shippingPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof Line
     */
    'tax'?: number;
    /**
     * 
     * @type {string}
     * @memberof Line
     */
    'vendorId'?: string;
}
/**
 * 
 * @export
 * @interface LineItem
 */
export interface LineItem {
    /**
     * 
     * @type {string}
     * @memberof LineItem
     */
    'itemType'?: string;
    /**
     * 
     * @type {number}
     * @memberof LineItem
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof LineItem
     */
    'productId'?: string;
    /**
     * 
     * @type {string}
     * @memberof LineItem
     */
    'productSku'?: string;
    /**
     * 
     * @type {number}
     * @memberof LineItem
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof LineItem
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof LineItem
     */
    'variationId'?: string;
}
/**
 * 
 * @export
 * @interface LinkRetailersWithTradeShowRequest
 */
export interface LinkRetailersWithTradeShowRequest {
    /**
     * Csv file as form data object
     * @type {File}
     * @memberof LinkRetailersWithTradeShowRequest
     */
    'csvFile': File;
}
/**
 * 
 * @export
 * @interface ListRequestWrapperRenameCategoryRequest
 */
export interface ListRequestWrapperRenameCategoryRequest {
    /**
     * 
     * @type {Array<RenameCategoryRequest>}
     * @memberof ListRequestWrapperRenameCategoryRequest
     */
    'items'?: Array<RenameCategoryRequest>;
}
/**
 * 
 * @export
 * @interface ListRequestWrapperUUID
 */
export interface ListRequestWrapperUUID {
    /**
     * 
     * @type {Array<string>}
     * @memberof ListRequestWrapperUUID
     */
    'items'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ListRequestWrapperUpdatePackingSlipShippedQuantitiesRequest
 */
export interface ListRequestWrapperUpdatePackingSlipShippedQuantitiesRequest {
    /**
     * 
     * @type {Array<UpdatePackingSlipShippedQuantitiesRequest>}
     * @memberof ListRequestWrapperUpdatePackingSlipShippedQuantitiesRequest
     */
    'items'?: Array<UpdatePackingSlipShippedQuantitiesRequest>;
}
/**
 * 
 * @export
 * @interface LocalPart
 */
export interface LocalPart {
    /**
     * 
     * @type {boolean}
     * @memberof LocalPart
     */
    'is_suspected_role_address': boolean;
}
/**
 * 
 * @export
 * @interface ManualCollectionResponse
 */
export interface ManualCollectionResponse {
    /**
     * 
     * @type {string}
     * @memberof ManualCollectionResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualCollectionResponse
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface ManualCollectionShopifyDTO
 */
export interface ManualCollectionShopifyDTO {
    /**
     * 
     * @type {string}
     * @memberof ManualCollectionShopifyDTO
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualCollectionShopifyDTO
     */
    'internal_title'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualCollectionShopifyDTO
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualCollectionShopifyDTO
     */
    'image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualCollectionShopifyDTO
     */
    'collection_type'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ManualCollectionShopifyDTO
     */
    'active'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ManualCollectionShopifyDTO
     */
    'product_ids'?: Array<number>;
}
/**
 * 
 * @export
 * @interface MarketingCategoriesResponse
 */
export interface MarketingCategoriesResponse {
    /**
     * 
     * @type {Array<MarketingCategoryResponse>}
     * @memberof MarketingCategoriesResponse
     */
    'marketing_categories'?: Array<MarketingCategoryResponse>;
}
/**
 * 
 * @export
 * @interface MarketingCategoryResponse
 */
export interface MarketingCategoryResponse {
    /**
     * 
     * @type {string}
     * @memberof MarketingCategoryResponse
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketingCategoryResponse
     */
    'value'?: MarketingCategoryResponseValueEnum;
}

export const MarketingCategoryResponseValueEnum = {
    GiftAndLifestyle: 'GIFT_AND_LIFESTYLE',
    Home: 'HOME',
    JewelryAndAccessories: 'JEWELRY_AND_ACCESSORIES'
} as const;

export type MarketingCategoryResponseValueEnum = typeof MarketingCategoryResponseValueEnum[keyof typeof MarketingCategoryResponseValueEnum];

/**
 * Merge Exhibitor Brand into Existing Brand
 * @export
 * @interface MergeExhibitorBrandRequest
 */
export interface MergeExhibitorBrandRequest {
    /**
     * 
     * @type {string}
     * @memberof MergeExhibitorBrandRequest
     */
    'exhibitor_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MergeExhibitorBrandRequest
     */
    'brand_id'?: string;
}
/**
 * Retailer id and suborder items
 * @export
 * @interface MinimumOrderValueValidationRequest
 */
export interface MinimumOrderValueValidationRequest {
    /**
     * 
     * @type {Array<SuborderItemRequest>}
     * @memberof MinimumOrderValueValidationRequest
     */
    'order_items': Array<SuborderItemRequest>;
}
/**
 * 
 * @export
 * @interface MinimumOrderValuesResponse
 */
export interface MinimumOrderValuesResponse {
    /**
     * 
     * @type {Array<number>}
     * @memberof MinimumOrderValuesResponse
     */
    'minimum_order_values'?: Array<number>;
}
/**
 * List of suborder ids
 * @export
 * @interface MoveHoldSubordersToVoidStatusRequest
 */
export interface MoveHoldSubordersToVoidStatusRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof MoveHoldSubordersToVoidStatusRequest
     */
    'suborder_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface Navigation
 */
export interface Navigation {
    /**
     * 
     * @type {Array<string>}
     * @memberof Navigation
     */
    'event_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface Order
 */
export interface Order {
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Order
     */
    'deleted': boolean;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'number'?: number;
    /**
     * 
     * @type {Retailer}
     * @memberof Order
     */
    'retailer': Retailer;
    /**
     * 
     * @type {Address}
     * @memberof Order
     * @deprecated
     */
    'shippingAddress'?: Address;
    /**
     * 
     * @type {Address}
     * @memberof Order
     * @deprecated
     */
    'billingAddress'?: Address;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'retailerBalance'?: number;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'paymentTerms'?: OrderPaymentTermsEnum;
    /**
     * 
     * @type {string}
     * @memberof Order
     * @deprecated
     */
    'promoCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     * @deprecated
     */
    'stripePaymentSourceId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Order
     */
    'returnable'?: boolean;
    /**
     * 
     * @type {Set<Suborder>}
     * @memberof Order
     */
    'suborders'?: Set<Suborder>;
    /**
     * 
     * @type {Set<OrderReturn>}
     * @memberof Order
     */
    'orderReturns'?: Set<OrderReturn>;
    /**
     * 
     * @type {boolean}
     * @memberof Order
     */
    'payOnShipment': boolean;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'balanceInvoice'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'balanceTransactionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'balanceToken'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Order
     */
    'active'?: boolean;
    /**
     * 
     * @type {Array<PromoCode>}
     * @memberof Order
     */
    'promoCodes'?: Array<PromoCode>;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'finalValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'totalShippedValue'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Order
     */
    'paymentByBalance'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'shippingEstimate'?: number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'totalOriginalPriceWithPromoCode'?: number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'totalOriginalPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'totalFulfilledPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'finalValueWithoutPromoCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'lastUpdateTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Order
     */
    'eligibleToCloseTransaction'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof Order
     */
    'associatedBrand'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Order
     */
    'associatedProducts'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof Order
     */
    'createdBeforePaymentFlow3'?: boolean;
    /**
     * 
     * @type {PromoCode}
     * @memberof Order
     */
    'orderAdminPromoCode'?: PromoCode;
    /**
     * 
     * @type {boolean}
     * @memberof Order
     */
    'createdInPaymentFlow3'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'totalReturnsPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'suborderCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Order
     */
    'new'?: boolean;
}

export const OrderPaymentTermsEnum = {
    Net0: 'NET_0',
    Net60: 'NET_60'
} as const;

export type OrderPaymentTermsEnum = typeof OrderPaymentTermsEnum[keyof typeof OrderPaymentTermsEnum];

/**
 * 
 * @export
 * @interface OrderCountByBrandResponse
 */
export interface OrderCountByBrandResponse {
    /**
     * 
     * @type {number}
     * @memberof OrderCountByBrandResponse
     */
    'order_count'?: number;
}
/**
 * 
 * @export
 * @interface OrderCountResponse
 */
export interface OrderCountResponse {
    /**
     * 
     * @type {number}
     * @memberof OrderCountResponse
     */
    'orders_count'?: number;
}
/**
 * 
 * @export
 * @interface OrderEntry
 */
export interface OrderEntry {
    /**
     * 
     * @type {string}
     * @memberof OrderEntry
     */
    'order_id'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderEntry
     */
    'brand_id'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderEntry
     */
    'product_id'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof OrderEntry
     */
    'total_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderEntry
     */
    'suborder_count'?: number;
}
/**
 * 
 * @export
 * @interface OrderPreviewAddressResponse
 */
export interface OrderPreviewAddressResponse {
    /**
     * 
     * @type {string}
     * @memberof OrderPreviewAddressResponse
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPreviewAddressResponse
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPreviewAddressResponse
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPreviewAddressResponse
     */
    'zip_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPreviewAddressResponse
     */
    'street'?: string;
}
/**
 * 
 * @export
 * @interface OrderPreviewResponse
 */
export interface OrderPreviewResponse {
    /**
     * 
     * @type {string}
     * @memberof OrderPreviewResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPreviewResponse
     */
    'number'?: string;
    /**
     * 
     * @type {OrderPreviewAddressResponse}
     * @memberof OrderPreviewResponse
     */
    'delivery_address'?: OrderPreviewAddressResponse;
    /**
     * 
     * @type {string}
     * @memberof OrderPreviewResponse
     */
    'promo_code_type'?: OrderPreviewResponsePromoCodeTypeEnum;
}

export const OrderPreviewResponsePromoCodeTypeEnum = {
    Percent: 'PERCENT',
    Amount: 'AMOUNT',
    FreeShipping: 'FREE_SHIPPING'
} as const;

export type OrderPreviewResponsePromoCodeTypeEnum = typeof OrderPreviewResponsePromoCodeTypeEnum[keyof typeof OrderPreviewResponsePromoCodeTypeEnum];

/**
 * 
 * @export
 * @interface OrderResponse
 */
export interface OrderResponse {
    /**
     * 
     * @type {string}
     * @memberof OrderResponse
     */
    'order_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderResponse
     */
    'retailer_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderResponse
     */
    'city'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderResponse
     */
    'is_custom_assortment'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderResponse
     */
    'timestamp'?: string;
    /**
     * 
     * @type {Array<SuborderPartialResponse>}
     * @memberof OrderResponse
     */
    'suborders'?: Array<SuborderPartialResponse>;
    /**
     * 
     * @type {AddressPartialResponse}
     * @memberof OrderResponse
     */
    'address'?: AddressPartialResponse;
}
/**
 * 
 * @export
 * @interface OrderReturn
 */
export interface OrderReturn {
    /**
     * 
     * @type {string}
     * @memberof OrderReturn
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderReturn
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof OrderReturn
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderReturn
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderReturn
     */
    'trackingNumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderReturn
     */
    'shippingCost'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderReturn
     */
    'comment'?: string;
    /**
     * 
     * @type {Address}
     * @memberof OrderReturn
     */
    'retailerAddress'?: Address;
    /**
     * 
     * @type {Set<OrderReturnItem>}
     * @memberof OrderReturn
     */
    'orderReturnItems'?: Set<OrderReturnItem>;
    /**
     * 
     * @type {string}
     * @memberof OrderReturn
     */
    'status'?: OrderReturnStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderReturn
     */
    'shippingCarrier'?: OrderReturnShippingCarrierEnum;
    /**
     * 
     * @type {Order}
     * @memberof OrderReturn
     */
    'order'?: Order;
    /**
     * 
     * @type {boolean}
     * @memberof OrderReturn
     */
    'new'?: boolean;
}

export const OrderReturnStatusEnum = {
    Pending: 'PENDING',
    Accepted: 'ACCEPTED',
    Declined: 'DECLINED',
    PartiallyAccepted: 'PARTIALLY_ACCEPTED'
} as const;

export type OrderReturnStatusEnum = typeof OrderReturnStatusEnum[keyof typeof OrderReturnStatusEnum];
export const OrderReturnShippingCarrierEnum = {
    Apc: 'APC',
    CanadaPost: 'CANADA_POST',
    Canpar: 'CANPAR',
    Dhl: 'DHL',
    FedEx: 'FedEx',
    Gls: 'GLS',
    NewGistics: 'NEW_GISTICS',
    Purolator: 'PUROLATOR',
    Sendle: 'SENDLE',
    SfExpress: 'SF_EXPRESS',
    Ups: 'UPS',
    Usps: 'USPS',
    Other: 'OTHER'
} as const;

export type OrderReturnShippingCarrierEnum = typeof OrderReturnShippingCarrierEnum[keyof typeof OrderReturnShippingCarrierEnum];

/**
 * 
 * @export
 * @interface OrderReturnItem
 */
export interface OrderReturnItem {
    /**
     * 
     * @type {string}
     * @memberof OrderReturnItem
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderReturnItem
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof OrderReturnItem
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderReturnItem
     */
    'deleted': boolean;
    /**
     * 
     * @type {OrderReturn}
     * @memberof OrderReturnItem
     */
    'orderReturn'?: OrderReturn;
    /**
     * 
     * @type {number}
     * @memberof OrderReturnItem
     */
    'originalQuantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderReturnItem
     */
    'acceptedQuantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderReturnItem
     */
    'declinedQuantity'?: number;
    /**
     * 
     * @type {SuborderItem}
     * @memberof OrderReturnItem
     */
    'suborderItem'?: SuborderItem;
    /**
     * 
     * @type {string}
     * @memberof OrderReturnItem
     */
    'reason': OrderReturnItemReasonEnum;
    /**
     * 
     * @type {boolean}
     * @memberof OrderReturnItem
     */
    'new'?: boolean;
}

export const OrderReturnItemReasonEnum = {
    ItemsNotDescribed: 'ITEMS_NOT_DESCRIBED',
    ProductQualityIsLacking: 'PRODUCT_QUALITY_IS_LACKING',
    ProductIsNotGoodFit: 'PRODUCT_IS_NOT_GOOD_FIT',
    ProductNotSell: 'PRODUCT_NOT_SELL',
    PriceNotWork: 'PRICE_NOT_WORK',
    ProductNotMeetExpectations: 'PRODUCT_NOT_MEET_EXPECTATIONS',
    SizingAndFitWasSmallOrTooBig: 'SIZING_AND_FIT_WAS_SMALL_OR_TOO_BIG',
    ItemIsDamaged: 'ITEM_IS_DAMAGED',
    ConsumablesExpiresOrOutOfDate: 'CONSUMABLES_EXPIRES_OR_OUT_OF_DATE'
} as const;

export type OrderReturnItemReasonEnum = typeof OrderReturnItemReasonEnum[keyof typeof OrderReturnItemReasonEnum];

/**
 * 
 * @export
 * @interface OrderReturnItemResponse
 */
export interface OrderReturnItemResponse {
    /**
     * 
     * @type {string}
     * @memberof OrderReturnItemResponse
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderReturnItemResponse
     */
    'returned_quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderReturnItemResponse
     */
    'accepted_quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderReturnItemResponse
     */
    'declined_quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderReturnItemResponse
     */
    'returnable_quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderReturnItemResponse
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderReturnItemResponse
     */
    'product_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderReturnItemResponse
     */
    'product_image'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof OrderReturnItemResponse
     */
    'characteristic_option_map'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof OrderReturnItemResponse
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface OrderReturnReasonResponse
 */
export interface OrderReturnReasonResponse {
    /**
     * 
     * @type {string}
     * @memberof OrderReturnReasonResponse
     */
    'reason_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderReturnReasonResponse
     */
    'reason_value'?: string;
}
/**
 * 
 * @export
 * @interface OrderReturnResponse
 */
export interface OrderReturnResponse {
    /**
     * 
     * @type {string}
     * @memberof OrderReturnResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderReturnResponse
     */
    'order_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderReturnResponse
     */
    'order_number'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderReturnResponse
     */
    'shipping_cost'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderReturnResponse
     */
    'tracking_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderReturnResponse
     */
    'shipping_carrier'?: OrderReturnResponseShippingCarrierEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderReturnResponse
     */
    'retailer_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderReturnResponse
     */
    'retailer_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderReturnResponse
     */
    'comment'?: string;
    /**
     * 
     * @type {BulletinAddress}
     * @memberof OrderReturnResponse
     */
    'bulletin_address'?: BulletinAddress;
    /**
     * 
     * @type {Array<SuborderReturnResponse>}
     * @memberof OrderReturnResponse
     */
    'suborder_returns'?: Array<SuborderReturnResponse>;
    /**
     * 
     * @type {string}
     * @memberof OrderReturnResponse
     */
    'status'?: OrderReturnResponseStatusEnum;
}

export const OrderReturnResponseShippingCarrierEnum = {
    Apc: 'APC',
    CanadaPost: 'CANADA_POST',
    Canpar: 'CANPAR',
    Dhl: 'DHL',
    FedEx: 'FedEx',
    Gls: 'GLS',
    NewGistics: 'NEW_GISTICS',
    Purolator: 'PUROLATOR',
    Sendle: 'SENDLE',
    SfExpress: 'SF_EXPRESS',
    Ups: 'UPS',
    Usps: 'USPS',
    Other: 'OTHER'
} as const;

export type OrderReturnResponseShippingCarrierEnum = typeof OrderReturnResponseShippingCarrierEnum[keyof typeof OrderReturnResponseShippingCarrierEnum];
export const OrderReturnResponseStatusEnum = {
    Pending: 'PENDING',
    Accepted: 'ACCEPTED',
    Declined: 'DECLINED',
    PartiallyAccepted: 'PARTIALLY_ACCEPTED'
} as const;

export type OrderReturnResponseStatusEnum = typeof OrderReturnResponseStatusEnum[keyof typeof OrderReturnResponseStatusEnum];

/**
 * 
 * @export
 * @interface OrdersPagination
 */
export interface OrdersPagination {
    /**
     * 
     * @type {number}
     * @memberof OrdersPagination
     */
    'items_per_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrdersPagination
     */
    'total_items'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrdersPagination
     */
    'current_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrdersPagination
     */
    'total_pages'?: number;
}
/**
 * 
 * @export
 * @interface PackingSlip
 */
export interface PackingSlip {
    /**
     * 
     * @type {string}
     * @memberof PackingSlip
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PackingSlip
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof PackingSlip
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PackingSlip
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof PackingSlip
     */
    'trackingNumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof PackingSlip
     */
    'shippingCost'?: number;
    /**
     * 
     * @type {string}
     * @memberof PackingSlip
     */
    'shippingCarrier'?: PackingSlipShippingCarrierEnum;
    /**
     * 
     * @type {Suborder}
     * @memberof PackingSlip
     */
    'suborder'?: Suborder;
    /**
     * 
     * @type {string}
     * @memberof PackingSlip
     */
    'packingSlipStatus': PackingSlipPackingSlipStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof PackingSlip
     */
    'ordinal'?: number;
    /**
     * 
     * @type {Set<PackingSlipItem>}
     * @memberof PackingSlip
     */
    'packingSlipItems'?: Set<PackingSlipItem>;
    /**
     * 
     * @type {boolean}
     * @memberof PackingSlip
     */
    'complete'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PackingSlip
     */
    'totalPackingSlipPrice'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PackingSlip
     */
    'new'?: boolean;
}

export const PackingSlipShippingCarrierEnum = {
    Apc: 'APC',
    CanadaPost: 'CANADA_POST',
    Canpar: 'CANPAR',
    Dhl: 'DHL',
    FedEx: 'FedEx',
    Gls: 'GLS',
    NewGistics: 'NEW_GISTICS',
    Purolator: 'PUROLATOR',
    Sendle: 'SENDLE',
    SfExpress: 'SF_EXPRESS',
    Ups: 'UPS',
    Usps: 'USPS',
    Other: 'OTHER'
} as const;

export type PackingSlipShippingCarrierEnum = typeof PackingSlipShippingCarrierEnum[keyof typeof PackingSlipShippingCarrierEnum];
export const PackingSlipPackingSlipStatusEnum = {
    Draft: 'DRAFT',
    Confirmed: 'CONFIRMED',
    Shipped: 'SHIPPED'
} as const;

export type PackingSlipPackingSlipStatusEnum = typeof PackingSlipPackingSlipStatusEnum[keyof typeof PackingSlipPackingSlipStatusEnum];

/**
 * 
 * @export
 * @interface PackingSlipItem
 */
export interface PackingSlipItem {
    /**
     * 
     * @type {string}
     * @memberof PackingSlipItem
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PackingSlipItem
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof PackingSlipItem
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PackingSlipItem
     */
    'deleted': boolean;
    /**
     * 
     * @type {PackingSlip}
     * @memberof PackingSlipItem
     */
    'packingSlip'?: PackingSlip;
    /**
     * 
     * @type {number}
     * @memberof PackingSlipItem
     */
    'quantity'?: number;
    /**
     * 
     * @type {SuborderItem}
     * @memberof PackingSlipItem
     */
    'suborderItem'?: SuborderItem;
    /**
     * 
     * @type {number}
     * @memberof PackingSlipItem
     */
    'maximumShippingQuantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof PackingSlipItem
     */
    'ordinal'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PackingSlipItem
     */
    'new'?: boolean;
}
/**
 * 
 * @export
 * @interface PackingSlipItemDto
 */
export interface PackingSlipItemDto {
    /**
     * 
     * @type {string}
     * @memberof PackingSlipItemDto
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof PackingSlipItemDto
     */
    'quantity'?: number;
}
/**
 * 
 * @export
 * @interface PackingSlipItemRequest
 */
export interface PackingSlipItemRequest {
    /**
     * 
     * @type {string}
     * @memberof PackingSlipItemRequest
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof PackingSlipItemRequest
     */
    'quantity'?: number;
}
/**
 * 
 * @export
 * @interface PackingSlipItemResponse
 */
export interface PackingSlipItemResponse {
    /**
     * 
     * @type {string}
     * @memberof PackingSlipItemResponse
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof PackingSlipItemResponse
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof PackingSlipItemResponse
     */
    'packing_slip_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PackingSlipItemResponse
     */
    'suborder_id'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PackingSlipItemResponse
     */
    'characteristic_option_map'?: { [key: string]: string; };
    /**
     * 
     * @type {number}
     * @memberof PackingSlipItemResponse
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof PackingSlipItemResponse
     */
    'product_image'?: string;
    /**
     * 
     * @type {string}
     * @memberof PackingSlipItemResponse
     */
    'product_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof PackingSlipItemResponse
     */
    'shipped_quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof PackingSlipItemResponse
     */
    'sku'?: string;
    /**
     * 
     * @type {number}
     * @memberof PackingSlipItemResponse
     */
    'maximum_shipping_quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof PackingSlipItemResponse
     */
    'ordinal'?: number;
}
/**
 * 
 * @export
 * @interface PackingSlipRequest
 */
export interface PackingSlipRequest {
    /**
     * 
     * @type {Array<PackingSlipItemRequest>}
     * @memberof PackingSlipRequest
     */
    'items'?: Array<PackingSlipItemRequest>;
    /**
     * 
     * @type {number}
     * @memberof PackingSlipRequest
     */
    'ordinal'?: number;
}
/**
 * 
 * @export
 * @interface PackingSlipResponse
 */
export interface PackingSlipResponse {
    /**
     * 
     * @type {string}
     * @memberof PackingSlipResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PackingSlipResponse
     */
    'suborder_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PackingSlipResponse
     */
    'tracking_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof PackingSlipResponse
     */
    'shipping_cost'?: number;
    /**
     * 
     * @type {string}
     * @memberof PackingSlipResponse
     */
    'shipping_carrier'?: PackingSlipResponseShippingCarrierEnum;
    /**
     * 
     * @type {string}
     * @memberof PackingSlipResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof PackingSlipResponse
     */
    'updated_at'?: string;
    /**
     * 
     * @type {Array<PackingSlipItemResponse>}
     * @memberof PackingSlipResponse
     */
    'items'?: Array<PackingSlipItemResponse>;
    /**
     * 
     * @type {string}
     * @memberof PackingSlipResponse
     */
    'status'?: PackingSlipResponseStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof PackingSlipResponse
     */
    'ordinal'?: number;
}

export const PackingSlipResponseShippingCarrierEnum = {
    Apc: 'APC',
    CanadaPost: 'CANADA_POST',
    Canpar: 'CANPAR',
    Dhl: 'DHL',
    FedEx: 'FedEx',
    Gls: 'GLS',
    NewGistics: 'NEW_GISTICS',
    Purolator: 'PUROLATOR',
    Sendle: 'SENDLE',
    SfExpress: 'SF_EXPRESS',
    Ups: 'UPS',
    Usps: 'USPS',
    Other: 'OTHER'
} as const;

export type PackingSlipResponseShippingCarrierEnum = typeof PackingSlipResponseShippingCarrierEnum[keyof typeof PackingSlipResponseShippingCarrierEnum];
export const PackingSlipResponseStatusEnum = {
    Draft: 'DRAFT',
    Confirmed: 'CONFIRMED',
    Shipped: 'SHIPPED'
} as const;

export type PackingSlipResponseStatusEnum = typeof PackingSlipResponseStatusEnum[keyof typeof PackingSlipResponseStatusEnum];

/**
 * 
 * @export
 * @interface PaginatedBrandsApplicationsResponse
 */
export interface PaginatedBrandsApplicationsResponse {
    /**
     * 
     * @type {Array<BrandsApplicationsResponse>}
     * @memberof PaginatedBrandsApplicationsResponse
     */
    'hits'?: Array<BrandsApplicationsResponse>;
    /**
     * 
     * @type {BrandsApplicationsPagination}
     * @memberof PaginatedBrandsApplicationsResponse
     */
    'pagination'?: BrandsApplicationsPagination;
}
/**
 * 
 * @export
 * @interface PaginatedBrandsDirectoryResponse
 */
export interface PaginatedBrandsDirectoryResponse {
    /**
     * 
     * @type {Array<BrandsDirectoryResponse>}
     * @memberof PaginatedBrandsDirectoryResponse
     */
    'hits'?: Array<BrandsDirectoryResponse>;
    /**
     * 
     * @type {BrandsDirectoryPagination}
     * @memberof PaginatedBrandsDirectoryResponse
     */
    'pagination'?: BrandsDirectoryPagination;
}
/**
 * 
 * @export
 * @interface PaginatedCustomAssortmentsResponse
 */
export interface PaginatedCustomAssortmentsResponse {
    /**
     * 
     * @type {Array<CustomAssortmentsResponse>}
     * @memberof PaginatedCustomAssortmentsResponse
     */
    'hits'?: Array<CustomAssortmentsResponse>;
    /**
     * 
     * @type {CustomAssortmentsPagination}
     * @memberof PaginatedCustomAssortmentsResponse
     */
    'pagination'?: CustomAssortmentsPagination;
}
/**
 * 
 * @export
 * @interface PaginatedFilteredProductResponse
 */
export interface PaginatedFilteredProductResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof PaginatedFilteredProductResponse
     */
    'product_ids'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedFilteredProductResponse
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface PaginatedGetFeaturedExhibitorsResponse
 */
export interface PaginatedGetFeaturedExhibitorsResponse {
    /**
     * 
     * @type {Array<GetFeaturedExhibitorsResponse>}
     * @memberof PaginatedGetFeaturedExhibitorsResponse
     */
    'exhibitors'?: Array<GetFeaturedExhibitorsResponse>;
    /**
     * 
     * @type {FeaturedExhibitorsPagination}
     * @memberof PaginatedGetFeaturedExhibitorsResponse
     */
    'pagination'?: FeaturedExhibitorsPagination;
}
/**
 * 
 * @export
 * @interface PaginatedInvoicesResponse
 */
export interface PaginatedInvoicesResponse {
    /**
     * 
     * @type {Array<GetDashboardInvoicesResponse>}
     * @memberof PaginatedInvoicesResponse
     */
    'hits'?: Array<GetDashboardInvoicesResponse>;
    /**
     * 
     * @type {InvoicesPaginationResponse}
     * @memberof PaginatedInvoicesResponse
     */
    'pagination'?: InvoicesPaginationResponse;
}
/**
 * 
 * @export
 * @interface PaginatedOrdersForSubordersResponse
 */
export interface PaginatedOrdersForSubordersResponse {
    /**
     * 
     * @type {Array<GetOrdersDashboardForSubordersResponse>}
     * @memberof PaginatedOrdersForSubordersResponse
     */
    'hits'?: Array<GetOrdersDashboardForSubordersResponse>;
    /**
     * 
     * @type {OrdersPagination}
     * @memberof PaginatedOrdersForSubordersResponse
     */
    'pagination'?: OrdersPagination;
}
/**
 * 
 * @export
 * @interface PaginatedOrdersResponse
 */
export interface PaginatedOrdersResponse {
    /**
     * 
     * @type {Array<GetOrdersDashboardResponse>}
     * @memberof PaginatedOrdersResponse
     */
    'hits'?: Array<GetOrdersDashboardResponse>;
    /**
     * 
     * @type {OrdersPagination}
     * @memberof PaginatedOrdersResponse
     */
    'pagination'?: OrdersPagination;
}
/**
 * 
 * @export
 * @interface PaginatedPaymentsResponse
 */
export interface PaginatedPaymentsResponse {
    /**
     * 
     * @type {Array<GetDashboardPaymentsResponse>}
     * @memberof PaginatedPaymentsResponse
     */
    'hits'?: Array<GetDashboardPaymentsResponse>;
    /**
     * 
     * @type {PaymentsPagination}
     * @memberof PaginatedPaymentsResponse
     */
    'pagination'?: PaymentsPagination;
}
/**
 * 
 * @export
 * @interface PaginatedProductsResponse
 */
export interface PaginatedProductsResponse {
    /**
     * 
     * @type {Array<ProductsDashboardResponse>}
     * @memberof PaginatedProductsResponse
     */
    'products'?: Array<ProductsDashboardResponse>;
    /**
     * 
     * @type {ProductsPagination}
     * @memberof PaginatedProductsResponse
     */
    'pagination'?: ProductsPagination;
}
/**
 * 
 * @export
 * @interface PaginatedRefferalsResponse
 */
export interface PaginatedRefferalsResponse {
    /**
     * 
     * @type {Array<ReferralResponse>}
     * @memberof PaginatedRefferalsResponse
     */
    'referrals'?: Array<ReferralResponse>;
    /**
     * 
     * @type {ReferralsPagination}
     * @memberof PaginatedRefferalsResponse
     */
    'pagination'?: ReferralsPagination;
}
/**
 * 
 * @export
 * @interface PaginatedRetailersApplicationsResponse
 */
export interface PaginatedRetailersApplicationsResponse {
    /**
     * 
     * @type {Array<RetailersApplicationsResponse>}
     * @memberof PaginatedRetailersApplicationsResponse
     */
    'hits'?: Array<RetailersApplicationsResponse>;
    /**
     * 
     * @type {RetailersApplicationsPagination}
     * @memberof PaginatedRetailersApplicationsResponse
     */
    'pagination'?: RetailersApplicationsPagination;
}
/**
 * 
 * @export
 * @interface PaginatedRetailersDirectoryResponse
 */
export interface PaginatedRetailersDirectoryResponse {
    /**
     * 
     * @type {Array<RetailersDirectoryResponse>}
     * @memberof PaginatedRetailersDirectoryResponse
     */
    'hits'?: Array<RetailersDirectoryResponse>;
    /**
     * 
     * @type {RetailersDirectoryPagination}
     * @memberof PaginatedRetailersDirectoryResponse
     */
    'pagination'?: RetailersDirectoryPagination;
}
/**
 * 
 * @export
 * @interface PayInvoiceResponse
 */
export interface PayInvoiceResponse {
    /**
     * 
     * @type {string}
     * @memberof PayInvoiceResponse
     */
    'status'?: PayInvoiceResponseStatusEnum;
}

export const PayInvoiceResponseStatusEnum = {
    Paid: 'PAID',
    NotPaid: 'NOT_PAID',
    PaymentFailed: 'PAYMENT_FAILED',
    UnprocessableCharge: 'UNPROCESSABLE_CHARGE'
} as const;

export type PayInvoiceResponseStatusEnum = typeof PayInvoiceResponseStatusEnum[keyof typeof PayInvoiceResponseStatusEnum];

/**
 * 
 * @export
 * @interface PaymentData
 */
export interface PaymentData {
    /**
     * 
     * @type {Array<BankData>}
     * @memberof PaymentData
     */
    'banks'?: Array<BankData>;
    /**
     * 
     * @type {Array<CreditCardData>}
     * @memberof PaymentData
     */
    'creditCards'?: Array<CreditCardData>;
}
/**
 * 
 * @export
 * @interface PaymentMethodTokenResponse
 */
export interface PaymentMethodTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodTokenResponse
     */
    'token'?: string;
}
/**
 * 
 * @export
 * @interface PaymentSourceResponse
 */
export interface PaymentSourceResponse {
    /**
     * 
     * @type {string}
     * @memberof PaymentSourceResponse
     */
    'card_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentSourceResponse
     */
    'card_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentSourceResponse
     */
    'last_4'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentSourceResponse
     */
    'is_default'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PaymentSourceResponse
     */
    'expiration_year'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentSourceResponse
     */
    'expiration_month'?: string;
}
/**
 * 
 * @export
 * @interface PaymentsPagination
 */
export interface PaymentsPagination {
    /**
     * 
     * @type {number}
     * @memberof PaymentsPagination
     */
    'items_per_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentsPagination
     */
    'total_items'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentsPagination
     */
    'current_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentsPagination
     */
    'total_pages'?: number;
}
/**
 * 
 * @export
 * @interface Plan
 */
export interface Plan {
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    'chargeDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof Plan
     */
    'installments'?: number;
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    'planType'?: string;
    /**
     * 
     * @type {string}
     * @memberof Plan
     */
    'recurringPayment'?: string;
}
/**
 * 
 * @export
 * @interface PlatformInfoDto
 */
export interface PlatformInfoDto {
    /**
     * 
     * @type {string}
     * @memberof PlatformInfoDto
     */
    'clientId'?: string;
}
/**
 * 
 * @export
 * @interface PlaybackIDsResponse
 */
export interface PlaybackIDsResponse {
    /**
     * 
     * @type {Array<PlaybackIdResponse>}
     * @memberof PlaybackIDsResponse
     */
    'playback_ids'?: Array<PlaybackIdResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof PlaybackIDsResponse
     */
    'processed'?: boolean;
}
/**
 * 
 * @export
 * @interface PlaybackIdResponse
 */
export interface PlaybackIdResponse {
    /**
     * 
     * @type {string}
     * @memberof PlaybackIdResponse
     */
    'policy'?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaybackIdResponse
     */
    'id'?: string;
}
/**
 * Prevent overlap levers dates.
 * @export
 * @interface PreventEndDateOverlapRequest
 */
export interface PreventEndDateOverlapRequest {
    /**
     * 
     * @type {string}
     * @memberof PreventEndDateOverlapRequest
     */
    'old_trade_show_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PreventEndDateOverlapRequest
     */
    'new_trade_show_id'?: string;
}
/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'status': ProductStatusEnum;
    /**
     * 
     * @type {Set<Category>}
     * @memberof Product
     */
    'categories'?: Set<Category>;
    /**
     * 
     * @type {Brand}
     * @memberof Product
     */
    'brand'?: Brand;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'brandId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'sellWholesale'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'sellPos'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'prioritized'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'prioritizedAtTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'createdByAdmin'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof Product
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'posPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'wholesalePrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'wholesaleMinimum'?: number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'wholesaleIncrement'?: number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'compareAtPrice'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'optedIntoConsignment'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'commissionSplit'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'visible': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'isTestProduct': boolean;
    /**
     * 
     * @type {Set<ProductVariant>}
     * @memberof Product
     */
    'variants'?: Set<ProductVariant>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Product
     */
    'characteristics'?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Product
     */
    'externProductId': { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'trackInventory': boolean;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'weight'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'pendingDeletion'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'source': ProductSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'minLeadTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'maxLeadTime'?: number;
    /**
     * 
     * @type {Set<BoardProducts>}
     * @memberof Product
     */
    'boards'?: Set<BoardProducts>;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'new'?: boolean;
}

export const ProductStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
    Any: 'ANY',
    Draft: 'DRAFT'
} as const;

export type ProductStatusEnum = typeof ProductStatusEnum[keyof typeof ProductStatusEnum];
export const ProductSourceEnum = {
    Manual: 'MANUAL',
    Csv: 'CSV',
    Shopify: 'SHOPIFY'
} as const;

export type ProductSourceEnum = typeof ProductSourceEnum[keyof typeof ProductSourceEnum];

/**
 * Create Product object
 * @export
 * @interface ProductBuilderCreateProductRequest
 */
export interface ProductBuilderCreateProductRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductBuilderCreateProductRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProductBuilderCreateProductRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductBuilderCreateProductRequest
     */
    'brand_id'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductBuilderCreateProductRequest
     */
    'category_ids'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ProductBuilderCreateProductRequest
     */
    'sell_pos'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductBuilderCreateProductRequest
     */
    'sell_wholesale'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductBuilderCreateProductRequest
     */
    'active': boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductBuilderCreateProductRequest
     */
    'pos_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductBuilderCreateProductRequest
     */
    'wholesale_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductBuilderCreateProductRequest
     */
    'compare_at_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductBuilderCreateProductRequest
     */
    'wholesale_minimum'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductBuilderCreateProductRequest
     */
    'wholesale_increment'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductBuilderCreateProductRequest
     */
    'opted_into_consignment'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductBuilderCreateProductRequest
     */
    'commission_split'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductBuilderCreateProductRequest
     */
    'visible': boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductBuilderCreateProductRequest
     */
    'min_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductBuilderCreateProductRequest
     */
    'max_lead_time'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductBuilderCreateProductRequest
     */
    'is_test_product': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductBuilderCreateProductRequest
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductBuilderCreateProductRequest
     */
    'characteristics'?: Array<string>;
    /**
     * 
     * @type {Array<VariantRequest>}
     * @memberof ProductBuilderCreateProductRequest
     */
    'variants'?: Array<VariantRequest>;
    /**
     * 
     * @type {boolean}
     * @memberof ProductBuilderCreateProductRequest
     */
    'track_inventory'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductBuilderCreateProductRequest
     */
    'weight'?: number;
}
/**
 * Update Product object
 * @export
 * @interface ProductBuilderUpdateProductRequest
 */
export interface ProductBuilderUpdateProductRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'brand_id'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'category_ids'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'sell_pos'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'sell_wholesale'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'active': boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'pos_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'wholesale_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'compare_at_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'wholesale_minimum'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'wholesale_increment'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'opted_into_consignment'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'commission_split'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'visible': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'min_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'max_lead_time'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'is_test_product': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'characteristics'?: Array<string>;
    /**
     * 
     * @type {Array<VariantRequest>}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'variants'?: Array<VariantRequest>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'images'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'custom_assortment_images'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'track_inventory'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductBuilderUpdateProductRequest
     */
    'weight'?: number;
}
/**
 * 
 * @export
 * @interface ProductCategoryAlgolia
 */
export interface ProductCategoryAlgolia {
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryAlgolia
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryAlgolia
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryAlgolia
     */
    'parent_category_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryAlgolia
     */
    'parent_category'?: string;
}
/**
 * 
 * @export
 * @interface ProductCategoryResponse
 */
export interface ProductCategoryResponse {
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryResponse
     */
    'parent_category_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryResponse
     */
    'parent_category_name'?: string;
}
/**
 * 
 * @export
 * @interface ProductDifferencesRequest
 */
export interface ProductDifferencesRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductDifferencesRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface ProductFromBrandBoardResponse
 */
export interface ProductFromBrandBoardResponse {
    /**
     * 
     * @type {string}
     * @memberof ProductFromBrandBoardResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductFromBrandBoardResponse
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductFromBrandBoardResponse
     */
    'wholesale_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductFromBrandBoardResponse
     */
    'pos_price'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductFromBrandBoardResponse
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductFromBrandBoardResponse
     */
    'cdn_image'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductFromBrandBoardResponse
     */
    'added_at'?: string;
}
/**
 * 
 * @export
 * @interface ProductIdShopifyDTO
 */
export interface ProductIdShopifyDTO {
    /**
     * 
     * @type {Product}
     * @memberof ProductIdShopifyDTO
     */
    'product'?: Product;
    /**
     * 
     * @type {number}
     * @memberof ProductIdShopifyDTO
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ProductOrdinalDto
 */
export interface ProductOrdinalDto {
    /**
     * 
     * @type {string}
     * @memberof ProductOrdinalDto
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductOrdinalDto
     */
    'ordinal'?: number;
}
/**
 * 
 * @export
 * @interface ProductSearchCriteriaInfo
 */
export interface ProductSearchCriteriaInfo {
    /**
     * 
     * @type {string}
     * @memberof ProductSearchCriteriaInfo
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductSearchCriteriaInfo
     */
    'operator'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductSearchCriteriaInfo
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface ProductSearchCriteriaRequest
 */
export interface ProductSearchCriteriaRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductSearchCriteriaRequest
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductSearchCriteriaRequest
     */
    'operator'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductSearchCriteriaRequest
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface ProductShopifyDTO
 */
export interface ProductShopifyDTO {
    /**
     * 
     * @type {Product}
     * @memberof ProductShopifyDTO
     */
    'product'?: Product;
    /**
     * 
     * @type {number}
     * @memberof ProductShopifyDTO
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductShopifyDTO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductShopifyDTO
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductShopifyDTO
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductShopifyDTO
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductShopifyDTO
     */
    'brand'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductShopifyDTO
     */
    'sell_wholesale'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductShopifyDTO
     */
    'sell_pos'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductShopifyDTO
     */
    'active'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductShopifyDTO
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ProductShopifyDTO
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductShopifyDTO
     */
    'lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductShopifyDTO
     */
    'pos_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductShopifyDTO
     */
    'wholesale_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductShopifyDTO
     */
    'wholesale_minimum'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductShopifyDTO
     */
    'wholesale_increment'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductShopifyDTO
     */
    'compare_at_price'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductShopifyDTO
     */
    'opted_into_consignment'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductShopifyDTO
     */
    'commision_split'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductShopifyDTO
     */
    'characteristics'?: Array<string>;
    /**
     * 
     * @type {ImageShopifyDTO}
     * @memberof ProductShopifyDTO
     */
    'image'?: ImageShopifyDTO;
    /**
     * 
     * @type {Array<ImageShopifyDTO>}
     * @memberof ProductShopifyDTO
     */
    'images'?: Array<ImageShopifyDTO>;
    /**
     * 
     * @type {Array<VariantShopifyDTO>}
     * @memberof ProductShopifyDTO
     */
    'variants'?: Array<VariantShopifyDTO>;
}
/**
 * 
 * @export
 * @interface ProductTagsRequest
 */
export interface ProductTagsRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductTagsRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTagsRequest
     */
    'tags': string;
}
/**
 * 
 * @export
 * @interface ProductVariant
 */
export interface ProductVariant {
    /**
     * 
     * @type {string}
     * @memberof ProductVariant
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductVariant
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ProductVariant
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductVariant
     */
    'deleted': boolean;
    /**
     * 
     * @type {Product}
     * @memberof ProductVariant
     */
    'product': Product;
    /**
     * 
     * @type {Image}
     * @memberof ProductVariant
     */
    'image'?: Image;
    /**
     * 
     * @type {number}
     * @memberof ProductVariant
     */
    'posPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductVariant
     */
    'wholesalePrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductVariant
     */
    'compareAtPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductVariant
     */
    'costPerItem'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductVariant
     */
    'ordinal'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductVariant
     */
    'testerMinimumQuantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductVariant
     */
    'sku'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductVariant
     */
    'inventoryQuantity'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductVariant
     */
    'inStock': boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductVariant
     */
    'weight'?: number;
    /**
     * 
     * @type {ProductVariant}
     * @memberof ProductVariant
     */
    'testerVariant'?: ProductVariant;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ProductVariant
     */
    'characteristicOptionMap'?: { [key: string]: string; };
    /**
     * 
     * @type {Set<SuborderItem>}
     * @memberof ProductVariant
     */
    'suborderItems'?: Set<SuborderItem>;
    /**
     * 
     * @type {boolean}
     * @memberof ProductVariant
     */
    'pendingDeletion'?: boolean;
    /**
     * 
     * @type {Brand}
     * @memberof ProductVariant
     */
    'brand'?: Brand;
    /**
     * 
     * @type {boolean}
     * @memberof ProductVariant
     */
    'new'?: boolean;
}
/**
 * 
 * @export
 * @interface ProductVariantInventoryLevelRequest
 */
export interface ProductVariantInventoryLevelRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductVariantInventoryLevelRequest
     */
    'variant_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductVariantInventoryLevelRequest
     */
    'sku'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductVariantInventoryLevelRequest
     */
    'inventory_quantity'?: number;
}
/**
 * 
 * @export
 * @interface ProductWithoutImageResponse
 */
export interface ProductWithoutImageResponse {
    /**
     * 
     * @type {string}
     * @memberof ProductWithoutImageResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductWithoutImageResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductWithoutImageResponse
     */
    'brandName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductWithoutImageResponse
     */
    'image'?: string;
}
/**
 * 
 * @export
 * @interface ProductsDashboardResponse
 */
export interface ProductsDashboardResponse {
    /**
     * 
     * @type {string}
     * @memberof ProductsDashboardResponse
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductsDashboardResponse
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductsDashboardResponse
     */
    'created_by_admin'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductsDashboardResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductsDashboardResponse
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductsDashboardResponse
     */
    'cdn_image'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductsDashboardResponse
     */
    'is_test_product'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductsDashboardResponse
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductsDashboardResponse
     */
    'pos_price'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductsDashboardResponse
     */
    'status'?: ProductsDashboardResponseStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ProductsDashboardResponse
     */
    'visible'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductsDashboardResponse
     */
    'wholesale_increment'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductsDashboardResponse
     */
    'wholesale_minimum'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductsDashboardResponse
     */
    'wholesale_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductsDashboardResponse
     */
    'min_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductsDashboardResponse
     */
    'max_lead_time'?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ProductsDashboardResponse
     */
    'extern_product_id'?: { [key: string]: string; };
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductsDashboardResponse
     */
    'characteristic_options'?: Array<string>;
    /**
     * 
     * @type {object}
     * @memberof ProductsDashboardResponse
     */
    'brand'?: object;
    /**
     * 
     * @type {object}
     * @memberof ProductsDashboardResponse
     */
    'categories'?: object;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductsDashboardResponse
     */
    'tags'?: Array<string>;
}

export const ProductsDashboardResponseStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
    Any: 'ANY',
    Draft: 'DRAFT'
} as const;

export type ProductsDashboardResponseStatusEnum = typeof ProductsDashboardResponseStatusEnum[keyof typeof ProductsDashboardResponseStatusEnum];

/**
 * 
 * @export
 * @interface ProductsPagination
 */
export interface ProductsPagination {
    /**
     * 
     * @type {number}
     * @memberof ProductsPagination
     */
    'items_per_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductsPagination
     */
    'total_items'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductsPagination
     */
    'current_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductsPagination
     */
    'total_pages'?: number;
}
/**
 * 
 * @export
 * @interface ProfileBadges
 */
export interface ProfileBadges {
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileBadges
     */
    'event_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PromoCode
 */
export interface PromoCode {
    /**
     * 
     * @type {string}
     * @memberof PromoCode
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PromoCode
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof PromoCode
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PromoCode
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof PromoCode
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof PromoCode
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof PromoCode
     */
    'endDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof PromoCode
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof PromoCode
     */
    'type': PromoCodeTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PromoCode
     */
    'oneTimeUse': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromoCode
     */
    'firstOrderOnly': boolean;
    /**
     * 
     * @type {number}
     * @memberof PromoCode
     */
    'minimumCartValue'?: number;
    /**
     * 
     * @type {User}
     * @memberof PromoCode
     */
    'user': User;
    /**
     * 
     * @type {boolean}
     * @memberof PromoCode
     */
    'published': boolean;
    /**
     * 
     * @type {string}
     * @memberof PromoCode
     */
    'status'?: PromoCodeStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PromoCode
     */
    'expired'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromoCode
     */
    'freeShipping'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromoCode
     */
    'adminPublishedPromo'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromoCode
     */
    'brandPublishedPromo'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromoCode
     */
    'expiredPublishedPromoCode'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromoCode
     */
    'adminFreeShipping'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromoCode
     */
    'brandFreeShipping'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromoCode
     */
    'new'?: boolean;
}

export const PromoCodeTypeEnum = {
    Percent: 'PERCENT',
    Amount: 'AMOUNT',
    FreeShipping: 'FREE_SHIPPING'
} as const;

export type PromoCodeTypeEnum = typeof PromoCodeTypeEnum[keyof typeof PromoCodeTypeEnum];
export const PromoCodeStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;

export type PromoCodeStatusEnum = typeof PromoCodeStatusEnum[keyof typeof PromoCodeStatusEnum];

/**
 * 
 * @export
 * @interface PromoCodeResponse
 */
export interface PromoCodeResponse {
    /**
     * 
     * @type {string}
     * @memberof PromoCodeResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PromoCodeResponse
     */
    'promo_code'?: string;
    /**
     * 
     * @type {number}
     * @memberof PromoCodeResponse
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof PromoCodeResponse
     */
    'type'?: PromoCodeResponseTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PromoCodeResponse
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof PromoCodeResponse
     */
    'start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof PromoCodeResponse
     */
    'end_date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PromoCodeResponse
     */
    'first_order_only'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromoCodeResponse
     */
    'one_time_use'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PromoCodeResponse
     */
    'status'?: PromoCodeResponseStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof PromoCodeResponse
     */
    'minimum_cart_value'?: number;
    /**
     * 
     * @type {string}
     * @memberof PromoCodeResponse
     */
    'promo_code_creator'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PromoCodeResponse
     */
    'ongoing_indefinite': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromoCodeResponse
     */
    'published'?: boolean;
}

export const PromoCodeResponseTypeEnum = {
    Percent: 'PERCENT',
    Amount: 'AMOUNT',
    FreeShipping: 'FREE_SHIPPING'
} as const;

export type PromoCodeResponseTypeEnum = typeof PromoCodeResponseTypeEnum[keyof typeof PromoCodeResponseTypeEnum];
export const PromoCodeResponseStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;

export type PromoCodeResponseStatusEnum = typeof PromoCodeResponseStatusEnum[keyof typeof PromoCodeResponseStatusEnum];

/**
 * 
 * @export
 * @interface PromoCodesWithPaginationResponse
 */
export interface PromoCodesWithPaginationResponse {
    /**
     * 
     * @type {Array<PromoCodeResponse>}
     * @memberof PromoCodesWithPaginationResponse
     */
    'promo_codes'?: Array<PromoCodeResponse>;
    /**
     * 
     * @type {number}
     * @memberof PromoCodesWithPaginationResponse
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface PublicBrandResponse
 */
export interface PublicBrandResponse {
    /**
     * 
     * @type {string}
     * @memberof PublicBrandResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicBrandResponse
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicBrandResponse
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicBrandResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicBrandResponse
     */
    'brand_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicBrandResponse
     */
    'brand_description'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicBrandResponse
     */
    'status'?: PublicBrandResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PublicBrandResponse
     */
    'logo_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicBrandResponse
     */
    'brand_bio_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicBrandResponse
     */
    'thumbnail_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicBrandResponse
     */
    'instagram_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicBrandResponse
     */
    'vanity_url_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicBrandResponse
     */
    'instagram_followers'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicBrandResponse
     */
    'based_in'?: string;
    /**
     * 
     * @type {number}
     * @memberof PublicBrandResponse
     */
    'min_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof PublicBrandResponse
     */
    'max_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof PublicBrandResponse
     */
    'minimum_order_value'?: number;
    /**
     * 
     * @type {number}
     * @memberof PublicBrandResponse
     */
    'minimum_reorder_value'?: number;
    /**
     * 
     * @type {Array<DropdownItem>}
     * @memberof PublicBrandResponse
     */
    'values'?: Array<DropdownItem>;
    /**
     * 
     * @type {Array<BrandLocationResponse>}
     * @memberof PublicBrandResponse
     */
    'brand_locations'?: Array<BrandLocationResponse>;
    /**
     * 
     * @type {Array<DropdownItem>}
     * @memberof PublicBrandResponse
     */
    'special_services'?: Array<DropdownItem>;
    /**
     * 
     * @type {Array<DropdownItem>}
     * @memberof PublicBrandResponse
     */
    'deals_and_promotions'?: Array<DropdownItem>;
    /**
     * 
     * @type {Array<BrandPublishedPromoCodeResponse>}
     * @memberof PublicBrandResponse
     */
    'published_promo_codes'?: Array<BrandPublishedPromoCodeResponse>;
    /**
     * 
     * @type {{ [key: string]: BrandTradeShowResponse; }}
     * @memberof PublicBrandResponse
     */
    'trade_shows'?: { [key: string]: BrandTradeShowResponse; };
    /**
     * 
     * @type {string}
     * @memberof PublicBrandResponse
     */
    'source'?: PublicBrandResponseSourceEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PublicBrandResponse
     */
    'ships_from_usa_or_canada'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PublicBrandResponse
     */
    'bulletin_pick'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PublicBrandResponse
     */
    'buy_on_bulletin'?: boolean;
    /**
     * 
     * @type {Array<GetBrandBoardResponse>}
     * @memberof PublicBrandResponse
     */
    'boards'?: Array<GetBrandBoardResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof PublicBrandResponse
     */
    'onboard_complete'?: boolean;
}

export const PublicBrandResponseStatusEnum = {
    Pending: 'PENDING',
    NeedsReview: 'NEEDS_REVIEW',
    Approved: 'APPROVED',
    Denied: 'DENIED',
    Registered: 'REGISTERED'
} as const;

export type PublicBrandResponseStatusEnum = typeof PublicBrandResponseStatusEnum[keyof typeof PublicBrandResponseStatusEnum];
export const PublicBrandResponseSourceEnum = {
    Application: 'APPLICATION',
    Exhibitor: 'EXHIBITOR',
    Outreach: 'OUTREACH'
} as const;

export type PublicBrandResponseSourceEnum = typeof PublicBrandResponseSourceEnum[keyof typeof PublicBrandResponseSourceEnum];

/**
 * 
 * @export
 * @interface PurchasedBrandResponse
 */
export interface PurchasedBrandResponse {
    /**
     * 
     * @type {string}
     * @memberof PurchasedBrandResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchasedBrandResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchasedBrandResponse
     */
    'based_in'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchasedBrandResponse
     */
    'thumbnail_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchasedBrandResponse
     */
    'vanity_url_name'?: string;
}
/**
 * 
 * @export
 * @interface RecommendationsCountResponse
 */
export interface RecommendationsCountResponse {
    /**
     * 
     * @type {number}
     * @memberof RecommendationsCountResponse
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface RecommendedBrandsResponse
 */
export interface RecommendedBrandsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof RecommendedBrandsResponse
     */
    'brand_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface Referral
 */
export interface Referral {
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Referral
     */
    'deleted': boolean;
    /**
     * 
     * @type {Brand}
     * @memberof Referral
     */
    'brand': Brand;
    /**
     * 
     * @type {Retailer}
     * @memberof Referral
     */
    'retailer'?: Retailer;
    /**
     * 
     * @type {PromoCode}
     * @memberof Referral
     */
    'promoCode'?: PromoCode;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'store'?: string;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'status': ReferralStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Referral
     */
    'completed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Referral
     */
    'isReferralCompletenessEmailSent': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Referral
     */
    'new'?: boolean;
}

export const ReferralStatusEnum = {
    InviteSent: 'INVITE_SENT',
    NotVerified: 'NOT_VERIFIED',
    SignedUp: 'SIGNED_UP',
    OrderPlaced: 'ORDER_PLACED'
} as const;

export type ReferralStatusEnum = typeof ReferralStatusEnum[keyof typeof ReferralStatusEnum];

/**
 * 
 * @export
 * @interface ReferralLinkResponse
 */
export interface ReferralLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof ReferralLinkResponse
     */
    'link'?: string;
}
/**
 * 
 * @export
 * @interface ReferralResponse
 */
export interface ReferralResponse {
    /**
     * 
     * @type {string}
     * @memberof ReferralResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralResponse
     */
    'brand_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralResponse
     */
    'brand_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralResponse
     */
    'retailer_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralResponse
     */
    'retailer_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralResponse
     */
    'store'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralResponse
     */
    'status'?: ReferralResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ReferralResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReferralResponse
     */
    'completed'?: boolean;
}

export const ReferralResponseStatusEnum = {
    InviteSent: 'INVITE_SENT',
    NotVerified: 'NOT_VERIFIED',
    SignedUp: 'SIGNED_UP',
    OrderPlaced: 'ORDER_PLACED'
} as const;

export type ReferralResponseStatusEnum = typeof ReferralResponseStatusEnum[keyof typeof ReferralResponseStatusEnum];

/**
 * 
 * @export
 * @interface ReferralsPagination
 */
export interface ReferralsPagination {
    /**
     * 
     * @type {number}
     * @memberof ReferralsPagination
     */
    'items_per_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReferralsPagination
     */
    'total_items'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReferralsPagination
     */
    'current_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReferralsPagination
     */
    'total_pages'?: number;
}
/**
 * 
 * @export
 * @interface ReindexBrandsProductCategoriesRequest
 */
export interface ReindexBrandsProductCategoriesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ReindexBrandsProductCategoriesRequest
     */
    'categories'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ReindexProductsRequest
 */
export interface ReindexProductsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ReindexProductsRequest
     */
    'product_ids'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReindexProductsRequest
     */
    'brand_ids'?: Array<string>;
    /**
     * Optional batch size for processing
     * @type {number}
     * @memberof ReindexProductsRequest
     */
    'batch_size'?: number;
}
/**
 * 
 * @export
 * @interface ReindexSpecificBrandsRequest
 */
export interface ReindexSpecificBrandsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ReindexSpecificBrandsRequest
     */
    'brandIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ReindexTradeShowBrandRequest
 */
export interface ReindexTradeShowBrandRequest {
    /**
     * 
     * @type {string}
     * @memberof ReindexTradeShowBrandRequest
     */
    'trade_show_id'?: string;
}
/**
 * Rename board object
 * @export
 * @interface RenameBoardRequest
 */
export interface RenameBoardRequest {
    /**
     * 
     * @type {string}
     * @memberof RenameBoardRequest
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface RenameBoardResponse
 */
export interface RenameBoardResponse {
    /**
     * 
     * @type {string}
     * @memberof RenameBoardResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RenameBoardResponse
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RenameBoardResponse
     */
    'images'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof RenameBoardResponse
     */
    'products_count'?: number;
}
/**
 * 
 * @export
 * @interface RenameCategoryRequest
 */
export interface RenameCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof RenameCategoryRequest
     */
    'category_id': string;
    /**
     * 
     * @type {string}
     * @memberof RenameCategoryRequest
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface RenameViewComponentRequest
 */
export interface RenameViewComponentRequest {
    /**
     * 
     * @type {string}
     * @memberof RenameViewComponentRequest
     */
    'view_component_id': string;
    /**
     * 
     * @type {string}
     * @memberof RenameViewComponentRequest
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof RenameViewComponentRequest
     */
    'rename_entity': boolean;
}
/**
 * 
 * @export
 * @interface ReorderResponse
 */
export interface ReorderResponse {
    /**
     * 
     * @type {BrandReorderResponse}
     * @memberof ReorderResponse
     */
    'brand'?: BrandReorderResponse;
    /**
     * 
     * @type {SuborderFromReorderResponse}
     * @memberof ReorderResponse
     */
    'suborder'?: SuborderFromReorderResponse;
}
/**
 * 
 * @export
 * @interface ReplaceCreditCardRequest
 */
export interface ReplaceCreditCardRequest {
    /**
     * 
     * @type {string}
     * @memberof ReplaceCreditCardRequest
     */
    'stripe_card_token': string;
    /**
     * 
     * @type {string}
     * @memberof ReplaceCreditCardRequest
     */
    'old_card_token': string;
}
/**
 * 
 * @export
 * @interface ResendBrandWelcomeEmailRequest
 */
export interface ResendBrandWelcomeEmailRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ResendBrandWelcomeEmailRequest
     */
    'override'?: boolean;
}
/**
 * 
 * @export
 * @interface ResetPasswordCodeToEmailResponse
 */
export interface ResetPasswordCodeToEmailResponse {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordCodeToEmailResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordCodeToEmailResponse
     */
    'email'?: string;
}
/**
 * Password and reset password code
 * @export
 * @interface ResetPasswordRequest
 */
export interface ResetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    'password': string;
    /**
     * 
     * @type {boolean}
     * @memberof ResetPasswordRequest
     */
    'bulletin_marketing_opt_in'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResetPasswordRequest
     */
    'emerald_marketing_opt_in'?: boolean;
}
/**
 * 
 * @export
 * @interface RestrictExhibitorVisibility
 */
export interface RestrictExhibitorVisibility {
    /**
     * 
     * @type {Array<string>}
     * @memberof RestrictExhibitorVisibility
     */
    'event_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface Retailer
 */
export interface Retailer {
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Retailer
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    'name': string;
    /**
     * 
     * @type {User}
     * @memberof Retailer
     */
    'user': User;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    'status': RetailerStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof Retailer
     */
    'storeTypes'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof Retailer
     */
    'yearsInBusiness'?: number;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    'resellerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    'storeUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    'yearFounded'?: string;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    'instagram'?: string;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    'facebook'?: string;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    'twitter'?: string;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    'bio'?: string;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    'thumbnailImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    'informedFrom'?: RetailerInformedFromEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof Retailer
     */
    'usedPromoCodes'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    'stripeCustomerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    'defaultCreditCard'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Retailer
     */
    'assortmentRequested'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof Retailer
     */
    'favoriteProducts'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Retailer
     */
    'favoriteBrands'?: Array<string>;
    /**
     * 
     * @type {Set<Order>}
     * @memberof Retailer
     */
    'orders'?: Set<Order>;
    /**
     * 
     * @type {Set<CustomAssortment>}
     * @memberof Retailer
     */
    'customAssortments'?: Set<CustomAssortment>;
    /**
     * 
     * @type {Set<Address>}
     * @memberof Retailer
     */
    'addresses'?: Set<Address>;
    /**
     * 
     * @type {Country}
     * @memberof Retailer
     */
    'storeLocation': Country;
    /**
     * 
     * @type {Set<Referral>}
     * @memberof Retailer
     */
    'referrals'?: Set<Referral>;
    /**
     * 
     * @type {UtmParams}
     * @memberof Retailer
     */
    'utmParams': UtmParams;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    'balanceLevel': RetailerBalanceLevelEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof Retailer
     */
    'values'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof Retailer
     */
    'isPublic': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Retailer
     */
    'isApproved': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Retailer
     */
    'isDeclined': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Retailer
     */
    'paymentPlanEnrolled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Retailer
     */
    'reviewRequired': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof Retailer
     */
    'storeGallery'?: Array<string>;
    /**
     * 
     * @type {object}
     * @memberof Retailer
     */
    'score': object;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    'balanceId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Retailer
     */
    'useBalance'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    'qualificationStatus'?: string;
    /**
     * 
     * @type {number}
     * @memberof Retailer
     */
    'balanceIssuedCredit'?: number;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    'source'?: RetailerSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof Retailer
     */
    'creditLimit'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Retailer
     */
    'suspended'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Retailer
     */
    'retailerUsingBalancePayment'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Retailer
     */
    'balanceQualificationSuspended'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    'bulletinReview'?: RetailerBulletinReviewEnum;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    'creditLimitAsString'?: string;
    /**
     * 
     * @type {string}
     * @memberof Retailer
     */
    'retailerStatus'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Retailer
     */
    'new'?: boolean;
}

export const RetailerStatusEnum = {
    Pending: 'PENDING',
    Active: 'ACTIVE',
    Suspended: 'SUSPENDED',
    Banned: 'BANNED'
} as const;

export type RetailerStatusEnum = typeof RetailerStatusEnum[keyof typeof RetailerStatusEnum];
export const RetailerInformedFromEnum = {
    BulletinEmailOutreach: 'Bulletin Email Outreach',
    BulletinInstagram: 'Bulletin Instagram',
    PressOrPublication: 'Press or Publication',
    WordOfMouth: 'Word of mouth',
    ReferredByABrand: 'Referred by a Brand',
    ReferredByARetailer: 'Referred by a Retailer',
    ReferredByAFriend: 'Referred by a Friend',
    FamiliarWithBulletinStores: 'Familiar with Bulletin Stores',
    ExternalFacebookGroup: 'External Facebook Group',
    NyNowDiscoveryShow: 'NY Now Discovery Show',
    ReassembledTradeShow: 'Reassembled Trade Show',
    SupportTheStoresCampaign: 'Support the Stores Campaign',
    Other: 'Other'
} as const;

export type RetailerInformedFromEnum = typeof RetailerInformedFromEnum[keyof typeof RetailerInformedFromEnum];
export const RetailerBalanceLevelEnum = {
    _500: '500',
    _2000: '2000',
    _2500: '2500',
    _5000: '5000',
    _7500: '7500',
    _10000: '10000',
    _15000: '15000',
    _20000: '20000',
    _25000: '25000',
    _100000: '100000'
} as const;

export type RetailerBalanceLevelEnum = typeof RetailerBalanceLevelEnum[keyof typeof RetailerBalanceLevelEnum];
export const RetailerSourceEnum = {
    Application: 'APPLICATION',
    Attendee: 'ATTENDEE'
} as const;

export type RetailerSourceEnum = typeof RetailerSourceEnum[keyof typeof RetailerSourceEnum];
export const RetailerBulletinReviewEnum = {
    Empty: '',
    Approved: 'Approved',
    Declined: 'Declined'
} as const;

export type RetailerBulletinReviewEnum = typeof RetailerBulletinReviewEnum[keyof typeof RetailerBulletinReviewEnum];

/**
 * 
 * @export
 * @interface RetailerBalanceResponse
 */
export interface RetailerBalanceResponse {
    /**
     * 
     * @type {string}
     * @memberof RetailerBalanceResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerBalanceResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerBalanceResponse
     */
    'store_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof RetailerBalanceResponse
     */
    'balance'?: number;
    /**
     * 
     * @type {Array<RetailerSuborderResponse>}
     * @memberof RetailerBalanceResponse
     */
    'suborders'?: Array<RetailerSuborderResponse>;
}
/**
 * 
 * @export
 * @interface RetailerBoardDetailsResponse
 */
export interface RetailerBoardDetailsResponse {
    /**
     * 
     * @type {string}
     * @memberof RetailerBoardDetailsResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerBoardDetailsResponse
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RetailerBoardDetailsResponse
     */
    'images'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof RetailerBoardDetailsResponse
     */
    'products_count'?: number;
}
/**
 * 
 * @export
 * @interface RetailerBoardResponse
 */
export interface RetailerBoardResponse {
    /**
     * 
     * @type {string}
     * @memberof RetailerBoardResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerBoardResponse
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RetailerBoardResponse
     */
    'images'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof RetailerBoardResponse
     */
    'products_count'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RetailerBoardResponse
     */
    'contains_product'?: boolean;
}
/**
 * 
 * @export
 * @interface RetailerCreditResponse
 */
export interface RetailerCreditResponse {
    /**
     * 
     * @type {number}
     * @memberof RetailerCreditResponse
     */
    'balance'?: number;
    /**
     * 
     * @type {number}
     * @memberof RetailerCreditResponse
     */
    'credit_used'?: number;
    /**
     * 
     * @type {number}
     * @memberof RetailerCreditResponse
     */
    'credit_left'?: number;
    /**
     * 
     * @type {number}
     * @memberof RetailerCreditResponse
     */
    'credit_level'?: number;
}
/**
 * 
 * @export
 * @interface RetailerDropdownInfo
 */
export interface RetailerDropdownInfo {
    /**
     * 
     * @type {string}
     * @memberof RetailerDropdownInfo
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerDropdownInfo
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface RetailerDropdownResponse
 */
export interface RetailerDropdownResponse {
    /**
     * 
     * @type {Array<RetailerDropdownInfo>}
     * @memberof RetailerDropdownResponse
     */
    'retailers_dropdown'?: Array<RetailerDropdownInfo>;
}
/**
 * 
 * @export
 * @interface RetailerResponse
 */
export interface RetailerResponse {
    /**
     * 
     * @type {string}
     * @memberof RetailerResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerResponse
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerResponse
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerResponse
     */
    'store_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerResponse
     */
    'store_url'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RetailerResponse
     */
    'store_types'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RetailerResponse
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerResponse
     */
    'year_founded'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerResponse
     */
    'instagram'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerResponse
     */
    'facebook'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerResponse
     */
    'twitter'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerResponse
     */
    'bio'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerResponse
     */
    'thumbnail_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerResponse
     */
    'balance_level'?: RetailerResponseBalanceLevelEnum;
    /**
     * 
     * @type {number}
     * @memberof RetailerResponse
     */
    'credit_used'?: number;
    /**
     * 
     * @type {number}
     * @memberof RetailerResponse
     */
    'credit_left'?: number;
    /**
     * 
     * @type {number}
     * @memberof RetailerResponse
     */
    'credit_level'?: number;
    /**
     * 
     * @type {number}
     * @memberof RetailerResponse
     */
    'balance'?: number;
    /**
     * 
     * @type {string}
     * @memberof RetailerResponse
     */
    'status'?: RetailerResponseStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof RetailerResponse
     */
    'values'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RetailerResponse
     */
    'store_gallery'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RetailerResponse
     */
    'city'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RetailerResponse
     */
    'is_public'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RetailerResponse
     */
    'is_approved'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RetailerResponse
     */
    'is_declined'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RetailerResponse
     */
    'score'?: number;
    /**
     * 
     * @type {string}
     * @memberof RetailerResponse
     */
    'phone_number'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RetailerResponse
     */
    'payment_plan_enrolled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RetailerResponse
     */
    'review_required'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RetailerResponse
     */
    'use_balance'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RetailerResponse
     */
    'balance_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerResponse
     */
    'qualification_status'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerResponse
     */
    'user_id'?: string;
    /**
     * 
     * @type {AddressResponse}
     * @memberof RetailerResponse
     */
    'billing_address'?: AddressResponse;
}

export const RetailerResponseBalanceLevelEnum = {
    _500: '500',
    _2000: '2000',
    _2500: '2500',
    _5000: '5000',
    _7500: '7500',
    _10000: '10000',
    _15000: '15000',
    _20000: '20000',
    _25000: '25000',
    _100000: '100000'
} as const;

export type RetailerResponseBalanceLevelEnum = typeof RetailerResponseBalanceLevelEnum[keyof typeof RetailerResponseBalanceLevelEnum];
export const RetailerResponseStatusEnum = {
    Pending: 'PENDING',
    Active: 'ACTIVE',
    Suspended: 'SUSPENDED',
    Banned: 'BANNED'
} as const;

export type RetailerResponseStatusEnum = typeof RetailerResponseStatusEnum[keyof typeof RetailerResponseStatusEnum];

/**
 * 
 * @export
 * @interface RetailerSuborderResponse
 */
export interface RetailerSuborderResponse {
    /**
     * 
     * @type {string}
     * @memberof RetailerSuborderResponse
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof RetailerSuborderResponse
     */
    'number'?: number;
    /**
     * 
     * @type {string}
     * @memberof RetailerSuborderResponse
     */
    'status'?: RetailerSuborderResponseStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof RetailerSuborderResponse
     */
    'amount'?: number;
}

export const RetailerSuborderResponseStatusEnum = {
    Hold: 'HOLD',
    Void: 'VOID',
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Declined: 'DECLINED',
    Expired: 'EXPIRED',
    PartiallyFulfilled: 'PARTIALLY_FULFILLED',
    FulfillmentInProgress: 'FULFILLMENT_IN_PROGRESS',
    Shipped: 'SHIPPED',
    Paid: 'PAID',
    Failed: 'FAILED',
    NotCollectable: 'NOT_COLLECTABLE',
    Cancelled: 'CANCELLED'
} as const;

export type RetailerSuborderResponseStatusEnum = typeof RetailerSuborderResponseStatusEnum[keyof typeof RetailerSuborderResponseStatusEnum];

/**
 * 
 * @export
 * @interface RetailersApplicationsPagination
 */
export interface RetailersApplicationsPagination {
    /**
     * 
     * @type {number}
     * @memberof RetailersApplicationsPagination
     */
    'items_per_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof RetailersApplicationsPagination
     */
    'total_items'?: number;
    /**
     * 
     * @type {number}
     * @memberof RetailersApplicationsPagination
     */
    'current_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof RetailersApplicationsPagination
     */
    'total_pages'?: number;
}
/**
 * 
 * @export
 * @interface RetailersApplicationsResponse
 */
export interface RetailersApplicationsResponse {
    /**
     * 
     * @type {string}
     * @memberof RetailersApplicationsResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailersApplicationsResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailersApplicationsResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailersApplicationsResponse
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailersApplicationsResponse
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailersApplicationsResponse
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailersApplicationsResponse
     */
    'store_url'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RetailersApplicationsResponse
     */
    'assortment_requested'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RetailersApplicationsResponse
     */
    'status'?: RetailersApplicationsResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RetailersApplicationsResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RetailersApplicationsResponse
     */
    'banned'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RetailersApplicationsResponse
     */
    'balance_level'?: RetailersApplicationsResponseBalanceLevelEnum;
    /**
     * 
     * @type {boolean}
     * @memberof RetailersApplicationsResponse
     */
    'is_public'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RetailersApplicationsResponse
     */
    'is_approved'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RetailersApplicationsResponse
     */
    'is_declined'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RetailersApplicationsResponse
     */
    'orders_places'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RetailersApplicationsResponse
     */
    'payment_plan_enrolled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RetailersApplicationsResponse
     */
    'review_required'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RetailersApplicationsResponse
     */
    'credit_limit'?: number;
}

export const RetailersApplicationsResponseStatusEnum = {
    Pending: 'PENDING',
    Active: 'ACTIVE',
    Suspended: 'SUSPENDED',
    Banned: 'BANNED'
} as const;

export type RetailersApplicationsResponseStatusEnum = typeof RetailersApplicationsResponseStatusEnum[keyof typeof RetailersApplicationsResponseStatusEnum];
export const RetailersApplicationsResponseBalanceLevelEnum = {
    _500: '500',
    _2000: '2000',
    _2500: '2500',
    _5000: '5000',
    _7500: '7500',
    _10000: '10000',
    _15000: '15000',
    _20000: '20000',
    _25000: '25000',
    _100000: '100000'
} as const;

export type RetailersApplicationsResponseBalanceLevelEnum = typeof RetailersApplicationsResponseBalanceLevelEnum[keyof typeof RetailersApplicationsResponseBalanceLevelEnum];

/**
 * 
 * @export
 * @interface RetailersDirectoryPagination
 */
export interface RetailersDirectoryPagination {
    /**
     * 
     * @type {number}
     * @memberof RetailersDirectoryPagination
     */
    'items_per_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof RetailersDirectoryPagination
     */
    'total_items'?: number;
    /**
     * 
     * @type {number}
     * @memberof RetailersDirectoryPagination
     */
    'current_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof RetailersDirectoryPagination
     */
    'total_pages'?: number;
}
/**
 * 
 * @export
 * @interface RetailersDirectoryResponse
 */
export interface RetailersDirectoryResponse {
    /**
     * 
     * @type {string}
     * @memberof RetailersDirectoryResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailersDirectoryResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailersDirectoryResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailersDirectoryResponse
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailersDirectoryResponse
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailersDirectoryResponse
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetailersDirectoryResponse
     */
    'store_url'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RetailersDirectoryResponse
     */
    'assortment_requested'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RetailersDirectoryResponse
     */
    'status'?: RetailersDirectoryResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RetailersDirectoryResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RetailersDirectoryResponse
     */
    'banned'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RetailersDirectoryResponse
     */
    'balance_level'?: RetailersDirectoryResponseBalanceLevelEnum;
    /**
     * 
     * @type {boolean}
     * @memberof RetailersDirectoryResponse
     */
    'is_public'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RetailersDirectoryResponse
     */
    'is_approved'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RetailersDirectoryResponse
     */
    'is_declined'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RetailersDirectoryResponse
     */
    'orders_places'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RetailersDirectoryResponse
     */
    'payment_plan_enrolled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RetailersDirectoryResponse
     */
    'review_required'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RetailersDirectoryResponse
     */
    'credit_limit'?: number;
}

export const RetailersDirectoryResponseStatusEnum = {
    Pending: 'PENDING',
    Active: 'ACTIVE',
    Suspended: 'SUSPENDED',
    Banned: 'BANNED'
} as const;

export type RetailersDirectoryResponseStatusEnum = typeof RetailersDirectoryResponseStatusEnum[keyof typeof RetailersDirectoryResponseStatusEnum];
export const RetailersDirectoryResponseBalanceLevelEnum = {
    _500: '500',
    _2000: '2000',
    _2500: '2500',
    _5000: '5000',
    _7500: '7500',
    _10000: '10000',
    _15000: '15000',
    _20000: '20000',
    _25000: '25000',
    _100000: '100000'
} as const;

export type RetailersDirectoryResponseBalanceLevelEnum = typeof RetailersDirectoryResponseBalanceLevelEnum[keyof typeof RetailersDirectoryResponseBalanceLevelEnum];

/**
 * 
 * @export
 * @interface SaveDraftProductRequest
 */
export interface SaveDraftProductRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveDraftProductRequest
     */
    'product_id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDraftProductRequest
     */
    'title': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SaveDraftProductRequest
     */
    'category_ids': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof SaveDraftProductRequest
     */
    'min_lead_time': number;
    /**
     * 
     * @type {number}
     * @memberof SaveDraftProductRequest
     */
    'max_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof SaveDraftProductRequest
     */
    'unit_price': number;
    /**
     * 
     * @type {number}
     * @memberof SaveDraftProductRequest
     */
    'wholesale_price': number;
}
/**
 * Instagram token
 * @export
 * @interface SaveInstagramTokenRequest
 */
export interface SaveInstagramTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveInstagramTokenRequest
     */
    'token'?: string;
}
/**
 * Save Shopify data request
 * @export
 * @interface SaveShopifyStoreDataRequest
 */
export interface SaveShopifyStoreDataRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveShopifyStoreDataRequest
     */
    'store_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveShopifyStoreDataRequest
     */
    'access_token'?: string;
}
/**
 * Save Shopify WholesalePrices request
 * @export
 * @interface SaveShopifyWholesalePricesFlagRequest
 */
export interface SaveShopifyWholesalePricesFlagRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SaveShopifyWholesalePricesFlagRequest
     */
    'shopify_wholesale_prices'?: boolean;
}
/**
 * 
 * @export
 * @interface SearchCriteriaResponse
 */
export interface SearchCriteriaResponse {
    /**
     * 
     * @type {string}
     * @memberof SearchCriteriaResponse
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchCriteriaResponse
     */
    'operator'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchCriteriaResponse
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface SendNewTradeShowNotificationEmailToBrandsRequest
 */
export interface SendNewTradeShowNotificationEmailToBrandsRequest {
    /**
     * 
     * @type {string}
     * @memberof SendNewTradeShowNotificationEmailToBrandsRequest
     */
    'importTimestamp': string;
}
/**
 * 
 * @export
 * @interface SendTradeShowWelcomeEmailsRequest
 */
export interface SendTradeShowWelcomeEmailsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof SendTradeShowWelcomeEmailsRequest
     */
    'brand_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface SendVerificationEmailsRequest
 */
export interface SendVerificationEmailsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof SendVerificationEmailsRequest
     */
    'country_ids'?: Array<string>;
}
/**
 * Send welcome email to trade show attendees object
 * @export
 * @interface SendWelcomeEmailToTradeShowAttendeesRequest
 */
export interface SendWelcomeEmailToTradeShowAttendeesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof SendWelcomeEmailToTradeShowAttendeesRequest
     */
    'retailer_ids'?: Array<string>;
}
/**
 * Ordinal
 * @export
 * @interface SetHomeOrdinalRequest
 */
export interface SetHomeOrdinalRequest {
    /**
     * 
     * @type {number}
     * @memberof SetHomeOrdinalRequest
     */
    'home_ordinal'?: number;
}
/**
 * Set trade show attendee password object
 * @export
 * @interface SetTradeShowAttendeePasswordRequest
 */
export interface SetTradeShowAttendeePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof SetTradeShowAttendeePasswordRequest
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof SetTradeShowAttendeePasswordRequest
     */
    'password': string;
    /**
     * 
     * @type {boolean}
     * @memberof SetTradeShowAttendeePasswordRequest
     */
    'bulletin_marketing_opt_in': boolean;
}
/**
 * 
 * @export
 * @interface SetTradeShowAttendeePasswordResponse
 */
export interface SetTradeShowAttendeePasswordResponse {
    /**
     * 
     * @type {string}
     * @memberof SetTradeShowAttendeePasswordResponse
     */
    'access_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof SetTradeShowAttendeePasswordResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SetTradeShowAttendeePasswordResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof SetTradeShowAttendeePasswordResponse
     */
    'role'?: SetTradeShowAttendeePasswordResponseRoleEnum;
    /**
     * 
     * @type {number}
     * @memberof SetTradeShowAttendeePasswordResponse
     */
    'number_of_logins'?: number;
    /**
     * 
     * @type {string}
     * @memberof SetTradeShowAttendeePasswordResponse
     */
    'first_login_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof SetTradeShowAttendeePasswordResponse
     */
    'last_login_date'?: string;
}

export const SetTradeShowAttendeePasswordResponseRoleEnum = {
    Brand: 'BRAND',
    Retailer: 'RETAILER',
    Admin: 'ADMIN',
    ProductBuilder: 'PRODUCT_BUILDER'
} as const;

export type SetTradeShowAttendeePasswordResponseRoleEnum = typeof SetTradeShowAttendeePasswordResponseRoleEnum[keyof typeof SetTradeShowAttendeePasswordResponseRoleEnum];

/**
 * Share Brand Board object
 * @export
 * @interface ShareBrandBoardRequest
 */
export interface ShareBrandBoardRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ShareBrandBoardRequest
     */
    'emails': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ShareBrandBoardRequest
     */
    'role'?: ShareBrandBoardRequestRoleEnum;
}

export const ShareBrandBoardRequestRoleEnum = {
    Creator: 'CREATOR',
    Viewer: 'VIEWER'
} as const;

export type ShareBrandBoardRequestRoleEnum = typeof ShareBrandBoardRequestRoleEnum[keyof typeof ShareBrandBoardRequestRoleEnum];

/**
 * 
 * @export
 * @interface ShippingCarrierResponse
 */
export interface ShippingCarrierResponse {
    /**
     * 
     * @type {string}
     * @memberof ShippingCarrierResponse
     */
    'shipping_carrier'?: ShippingCarrierResponseShippingCarrierEnum;
}

export const ShippingCarrierResponseShippingCarrierEnum = {
    Apc: 'APC',
    CanadaPost: 'CANADA_POST',
    Canpar: 'CANPAR',
    Dhl: 'DHL',
    FedEx: 'FedEx',
    Gls: 'GLS',
    NewGistics: 'NEW_GISTICS',
    Purolator: 'PUROLATOR',
    Sendle: 'SENDLE',
    SfExpress: 'SF_EXPRESS',
    Ups: 'UPS',
    Usps: 'USPS',
    Other: 'OTHER'
} as const;

export type ShippingCarrierResponseShippingCarrierEnum = typeof ShippingCarrierResponseShippingCarrierEnum[keyof typeof ShippingCarrierResponseShippingCarrierEnum];

/**
 * 
 * @export
 * @interface ShopifyBrandOrders
 */
export interface ShopifyBrandOrders {
    /**
     * 
     * @type {string}
     * @memberof ShopifyBrandOrders
     */
    'domain'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShopifyBrandOrders
     */
    'orders_url'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShopifyBrandOrders
     */
    'wholesale_prices'?: boolean;
}
/**
 * 
 * @export
 * @interface ShopifyConnectionInfoResponse
 */
export interface ShopifyConnectionInfoResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ShopifyConnectionInfoResponse
     */
    'connected'?: boolean;
}
/**
 * 
 * @export
 * @interface ShopifyImportDTO
 */
export interface ShopifyImportDTO {
    /**
     * 
     * @type {{ [key: string]: ProductIdShopifyDTO; }}
     * @memberof ShopifyImportDTO
     */
    'id_product_map'?: { [key: string]: ProductIdShopifyDTO; };
    /**
     * 
     * @type {Array<string>}
     * @memberof ShopifyImportDTO
     */
    'categories'?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<ProductShopifyDTO>; }}
     * @memberof ShopifyImportDTO
     */
    'brand_products_map'?: { [key: string]: Array<ProductShopifyDTO>; };
    /**
     * 
     * @type {Array<AutomatedCollectionShopifyDTO>}
     * @memberof ShopifyImportDTO
     */
    'automated_collections'?: Array<AutomatedCollectionShopifyDTO>;
    /**
     * 
     * @type {Array<ManualCollectionShopifyDTO>}
     * @memberof ShopifyImportDTO
     */
    'manual_collections'?: Array<ManualCollectionShopifyDTO>;
}
/**
 * 
 * @export
 * @interface ShopifyOrderAlgolia
 */
export interface ShopifyOrderAlgolia {
    /**
     * 
     * @type {string}
     * @memberof ShopifyOrderAlgolia
     */
    'objectID'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopifyOrderAlgolia
     */
    'order_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopifyOrderAlgolia
     */
    'order_gid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShopifyOrderAlgolia
     */
    'order_url'?: string;
}
/**
 * 
 * @export
 * @interface ShopifyProductStatusResponse
 */
export interface ShopifyProductStatusResponse {
    /**
     * 
     * @type {number}
     * @memberof ShopifyProductStatusResponse
     */
    'imported'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopifyProductStatusResponse
     */
    'published'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopifyProductStatusResponse
     */
    'draft'?: number;
}
/**
 * 
 * @export
 * @interface ShopifySuborderResponse
 */
export interface ShopifySuborderResponse {
    /**
     * 
     * @type {string}
     * @memberof ShopifySuborderResponse
     */
    'shopify_status'?: ShopifySuborderResponseShopifyStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ShopifySuborderResponse
     */
    'shopify_fulfill_complete'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShopifySuborderResponse
     */
    'chargeable'?: boolean;
}

export const ShopifySuborderResponseShopifyStatusEnum = {
    Fulfilled: 'FULFILLED',
    Unfulfilled: 'UNFULFILLED',
    Partial: 'PARTIAL',
    Restocked: 'RESTOCKED',
    Null: 'NULL'
} as const;

export type ShopifySuborderResponseShopifyStatusEnum = typeof ShopifySuborderResponseShopifyStatusEnum[keyof typeof ShopifySuborderResponseShopifyStatusEnum];

/**
 * 
 * @export
 * @interface ShopifyUpdateSettingsResponse
 */
export interface ShopifyUpdateSettingsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ShopifyUpdateSettingsResponse
     */
    'shopify_update_settings'?: boolean;
}
/**
 * 
 * @export
 * @interface ShopifyVersionResponse
 */
export interface ShopifyVersionResponse {
    /**
     * 
     * @type {string}
     * @memberof ShopifyVersionResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface SignInRequest
 */
export interface SignInRequest {
    /**
     * 
     * @type {string}
     * @memberof SignInRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SignInRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface SignInResponse
 */
export interface SignInResponse {
    /**
     * 
     * @type {string}
     * @memberof SignInResponse
     */
    'access_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignInResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignInResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignInResponse
     */
    'role'?: SignInResponseRoleEnum;
    /**
     * 
     * @type {number}
     * @memberof SignInResponse
     */
    'number_of_logins'?: number;
    /**
     * 
     * @type {string}
     * @memberof SignInResponse
     */
    'first_login_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignInResponse
     */
    'last_login_date'?: string;
}

export const SignInResponseRoleEnum = {
    Brand: 'BRAND',
    Retailer: 'RETAILER',
    Admin: 'ADMIN',
    ProductBuilder: 'PRODUCT_BUILDER'
} as const;

export type SignInResponseRoleEnum = typeof SignInResponseRoleEnum[keyof typeof SignInResponseRoleEnum];

/**
 * Split ship object
 * @export
 * @interface SplitShipRequest
 */
export interface SplitShipRequest {
    /**
     * 
     * @type {Array<PackingSlipRequest>}
     * @memberof SplitShipRequest
     */
    'packing_slips'?: Array<PackingSlipRequest>;
}
/**
 * 
 * @export
 * @interface SplitShipResponse
 */
export interface SplitShipResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof SplitShipResponse
     */
    'packing_slip_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface SplitShipmentPackingSlipRequest
 */
export interface SplitShipmentPackingSlipRequest {
    /**
     * 
     * @type {string}
     * @memberof SplitShipmentPackingSlipRequest
     */
    'id'?: string;
    /**
     * 
     * @type {Array<PackingSlipItemRequest>}
     * @memberof SplitShipmentPackingSlipRequest
     */
    'items'?: Array<PackingSlipItemRequest>;
    /**
     * 
     * @type {number}
     * @memberof SplitShipmentPackingSlipRequest
     */
    'ordinal'?: number;
}
/**
 * 
 * @export
 * @interface State
 */
export interface State {
    /**
     * 
     * @type {string}
     * @memberof State
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof State
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof State
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof State
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof State
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof State
     */
    'abbreviation'?: string;
    /**
     * 
     * @type {Country}
     * @memberof State
     */
    'country'?: Country;
    /**
     * 
     * @type {boolean}
     * @memberof State
     */
    'new'?: boolean;
}
/**
 * State Id and Country Id
 * @export
 * @interface StateCountryValidationRequest
 */
export interface StateCountryValidationRequest {
    /**
     * 
     * @type {string}
     * @memberof StateCountryValidationRequest
     */
    'country_id': string;
    /**
     * 
     * @type {string}
     * @memberof StateCountryValidationRequest
     */
    'state_id': string;
}
/**
 * 
 * @export
 * @interface StateResponse
 */
export interface StateResponse {
    /**
     * 
     * @type {string}
     * @memberof StateResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof StateResponse
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface StatementDescriptor
 */
export interface StatementDescriptor {
    /**
     * 
     * @type {string}
     * @memberof StatementDescriptor
     */
    'charge'?: string;
}
/**
 * 
 * @export
 * @interface SubCartResponse
 */
export interface SubCartResponse {
    /**
     * 
     * @type {BrandInfoResponse}
     * @memberof SubCartResponse
     */
    'brand_info'?: BrandInfoResponse;
    /**
     * 
     * @type {Array<CartItemResponse>}
     * @memberof SubCartResponse
     */
    'cart_items'?: Array<CartItemResponse>;
    /**
     * 
     * @type {number}
     * @memberof SubCartResponse
     */
    'subtotal'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubCartResponse
     */
    'selected_for_checkout'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubCartResponse
     */
    'valid_mov'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubCartResponse
     */
    'promo_code'?: string;
    /**
     * 
     * @type {number}
     * @memberof SubCartResponse
     */
    'promo_code_amount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubCartResponse
     */
    'admin_promo_code'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubCartResponse
     */
    'promo_code_type'?: SubCartResponsePromoCodeTypeEnum;
}

export const SubCartResponsePromoCodeTypeEnum = {
    Percent: 'PERCENT',
    Amount: 'AMOUNT',
    FreeShipping: 'FREE_SHIPPING'
} as const;

export type SubCartResponsePromoCodeTypeEnum = typeof SubCartResponsePromoCodeTypeEnum[keyof typeof SubCartResponsePromoCodeTypeEnum];

/**
 * 
 * @export
 * @interface SubcategoriesResponse
 */
export interface SubcategoriesResponse {
    /**
     * 
     * @type {Array<ViewComponentResponse>}
     * @memberof SubcategoriesResponse
     */
    'subcategories'?: Array<ViewComponentResponse>;
}
/**
 * Submit outbound-onboarding form object
 * @export
 * @interface SubmitOutboundOnboardingFormRequest
 */
export interface SubmitOutboundOnboardingFormRequest {
    /**
     * 
     * @type {string}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'owner_first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'owner_last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'brand_name': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'website_url': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'location': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'years_in_business': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'based_in'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'shipping_city'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'categories': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'instagram'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'instagram_follower'?: string;
    /**
     * 
     * @type {number}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'min_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'minimum_order_value': number;
    /**
     * 
     * @type {number}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'minimum_reorder_value': number;
    /**
     * 
     * @type {string}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'initial_skus'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'brand_bio'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'ship_to_canada': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'values': Array<SubmitOutboundOnboardingFormRequestValuesEnum>;
    /**
     * 
     * @type {number}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'case_pack_quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'phone_number': string;
    /**
     * 
     * @type {boolean}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'sell_with_other_shop': boolean;
    /**
     * 
     * @type {object}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'address': object;
    /**
     * 
     * @type {string}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'line_sheet_url'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'located_in_usa_canada': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'based_in_canada': boolean;
    /**
     * 
     * @type {string}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'editorial_link'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'product_photography'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'thumbnail_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitOutboundOnboardingFormRequest
     */
    'best_sellers'?: string;
}

export const SubmitOutboundOnboardingFormRequestValuesEnum = {
    FemaleFounded: 'FEMALE_FOUNDED',
    EthicalProduction: 'ETHICAL_PRODUCTION',
    CleanIngredients: 'CLEAN_INGREDIENTS',
    Sustainable: 'SUSTAINABLE',
    Handmade: 'HANDMADE',
    MadeInTheUs: 'MADE_IN_THE_US',
    CharitableBrandGiveBack: 'CHARITABLE_BRAND_GIVE_BACK',
    Organic: 'ORGANIC',
    ZeroWaste: 'ZERO_WASTE',
    BlackOwned: 'BLACK_OWNED',
    LatinxOwned: 'LATINX_OWNED',
    AapiOwned: 'AAPI_OWNED',
    IndigenousOwned: 'INDIGENOUS_OWNED',
    LgbtqOwned: 'LGBTQ_OWNED',
    MinorityOwnedBusiness: 'MINORITY_OWNED_BUSINESS',
    DisabilityOwned: 'DISABILITY_OWNED'
} as const;

export type SubmitOutboundOnboardingFormRequestValuesEnum = typeof SubmitOutboundOnboardingFormRequestValuesEnum[keyof typeof SubmitOutboundOnboardingFormRequestValuesEnum];

/**
 * 
 * @export
 * @interface SubmitOutboundOnboardingFormResponse
 */
export interface SubmitOutboundOnboardingFormResponse {
    /**
     * 
     * @type {string}
     * @memberof SubmitOutboundOnboardingFormResponse
     */
    'brand_id': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitOutboundOnboardingFormResponse
     */
    'brand_bio_image_url': string;
}
/**
 * 
 * @export
 * @interface Suborder
 */
export interface Suborder {
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Suborder
     */
    'deleted': boolean;
    /**
     * 
     * @type {number}
     * @memberof Suborder
     */
    'number'?: number;
    /**
     * 
     * @type {Brand}
     * @memberof Suborder
     */
    'brand'?: Brand;
    /**
     * 
     * @type {Order}
     * @memberof Suborder
     */
    'order'?: Order;
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'status': SuborderStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'statusChangeDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Suborder
     */
    'adjustedStatus': boolean;
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'declineOrderReason'?: SuborderDeclineOrderReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'additionalInformation'?: string;
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'trackingNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'paymentIntent'?: string;
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'paymentDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'originalChargeDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'scheduledChargeDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'manuallyChargeDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'shippedDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Suborder
     */
    'manuallyCharged': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Suborder
     * @deprecated
     */
    'chargeDateAdjusted': boolean;
    /**
     * 
     * @type {Set<SuborderItem>}
     * @memberof Suborder
     */
    'suborderItems'?: Set<SuborderItem>;
    /**
     * 
     * @type {Set<PackingSlip>}
     * @memberof Suborder
     */
    'packingSlips'?: Set<PackingSlip>;
    /**
     * 
     * @type {boolean}
     * @memberof Suborder
     * @deprecated
     */
    'isManuallyPaid'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Suborder
     */
    'chargeNotProcessable'?: boolean;
    /**
     * 
     * @type {PromoCode}
     * @memberof Suborder
     */
    'promoCode'?: PromoCode;
    /**
     * 
     * @type {number}
     * @memberof Suborder
     */
    'shippingDiscountApplied'?: number;
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'stripePaymentSourceId'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Suborder
     */
    'shippingAddress'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Suborder
     */
    'billingAddress'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'acceptedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'expiredDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'declinedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'invoiceUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof Suborder
     */
    'balanceChargeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof Suborder
     */
    'paymentCaptureAttempt'?: number;
    /**
     * 
     * @type {number}
     * @memberof Suborder
     */
    'shippingCostEstimate'?: number;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof Suborder
     */
    'externalIds'?: { [key: string]: object; };
    /**
     * 
     * @type {boolean}
     * @memberof Suborder
     */
    'active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Suborder
     */
    'totalPriceForBalanceTransaction'?: number;
    /**
     * 
     * @type {Retailer}
     * @memberof Suborder
     */
    'retailer'?: Retailer;
    /**
     * 
     * @type {boolean}
     * @memberof Suborder
     */
    'paidByBalance'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Suborder
     */
    'shopifyOrderId'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof Suborder
     */
    'productIds'?: Array<string>;
    /**
     * 
     * @type {PackingSlip}
     * @memberof Suborder
     */
    'packingSlip'?: PackingSlip;
    /**
     * 
     * @type {number}
     * @memberof Suborder
     */
    'finalValue'?: number;
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'retailerEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'brandEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'invoiceStatus'?: SuborderInvoiceStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'paymentTerms'?: SuborderPaymentTermsEnum;
    /**
     * 
     * @type {number}
     * @memberof Suborder
     */
    'totalPriceWithDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof Suborder
     */
    'totalPrice'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Suborder
     */
    'shopifyOrder'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'shopifyStatus'?: SuborderShopifyStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Suborder
     */
    'chargeStatus'?: SuborderChargeStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof Suborder
     */
    'totalOriginalPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof Suborder
     */
    'totalFulfilledPrice'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Suborder
     */
    'declinedOrExpired'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Suborder
     */
    'totalShippedPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof Suborder
     */
    'totalShippingCost'?: number;
    /**
     * 
     * @type {number}
     * @memberof Suborder
     */
    'finalShippedValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof Suborder
     */
    'shippedFinalValueWithPromoCode'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Suborder
     */
    'createdBeforePaymentFlow3'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Suborder
     */
    'paidAndHasShippingCost'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Suborder
     */
    'originalValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof Suborder
     */
    'finalValueWithPromoCode'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Suborder
     */
    'shippedOrPaid'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Suborder
     */
    'totalReturnPrice'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Suborder
     */
    'fulfilled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Suborder
     */
    'shippedValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof Suborder
     */
    'fulfilledValue'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Suborder
     */
    'new'?: boolean;
}

export const SuborderStatusEnum = {
    Hold: 'HOLD',
    Void: 'VOID',
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Declined: 'DECLINED',
    Expired: 'EXPIRED',
    PartiallyFulfilled: 'PARTIALLY_FULFILLED',
    FulfillmentInProgress: 'FULFILLMENT_IN_PROGRESS',
    Shipped: 'SHIPPED',
    Paid: 'PAID',
    Failed: 'FAILED',
    NotCollectable: 'NOT_COLLECTABLE',
    Cancelled: 'CANCELLED'
} as const;

export type SuborderStatusEnum = typeof SuborderStatusEnum[keyof typeof SuborderStatusEnum];
export const SuborderDeclineOrderReasonEnum = {
    OutOfStock: 'OUT_OF_STOCK',
    LocationRestrictions: 'LOCATION_RESTRICTIONS',
    RetailerBrandFit: 'RETAILER_BRAND_FIT',
    ProductionDelays: 'PRODUCTION_DELAYS',
    RetailerCancelledOrder: 'RETAILER_CANCELLED_ORDER',
    InternationalRestriction: 'INTERNATIONAL_RESTRICTION',
    BulletinDidntVerifyRetailer: 'BULLETIN_DIDNT_VERIFY_RETAILER',
    Other: 'OTHER'
} as const;

export type SuborderDeclineOrderReasonEnum = typeof SuborderDeclineOrderReasonEnum[keyof typeof SuborderDeclineOrderReasonEnum];
export const SuborderInvoiceStatusEnum = {
    Paid: 'PAID',
    NotPaid: 'NOT_PAID',
    PaymentFailed: 'PAYMENT_FAILED',
    UnprocessableCharge: 'UNPROCESSABLE_CHARGE'
} as const;

export type SuborderInvoiceStatusEnum = typeof SuborderInvoiceStatusEnum[keyof typeof SuborderInvoiceStatusEnum];
export const SuborderPaymentTermsEnum = {
    Net0: 'NET_0',
    Net60: 'NET_60'
} as const;

export type SuborderPaymentTermsEnum = typeof SuborderPaymentTermsEnum[keyof typeof SuborderPaymentTermsEnum];
export const SuborderShopifyStatusEnum = {
    Fulfilled: 'FULFILLED',
    Unfulfilled: 'UNFULFILLED',
    Partial: 'PARTIAL',
    Restocked: 'RESTOCKED',
    Null: 'NULL'
} as const;

export type SuborderShopifyStatusEnum = typeof SuborderShopifyStatusEnum[keyof typeof SuborderShopifyStatusEnum];
export const SuborderChargeStatusEnum = {
    Pending: 'PENDING',
    Successful: 'SUCCESSFUL',
    Failed: 'FAILED',
    OrderCanceled: 'ORDER_CANCELED'
} as const;

export type SuborderChargeStatusEnum = typeof SuborderChargeStatusEnum[keyof typeof SuborderChargeStatusEnum];

/**
 * 
 * @export
 * @interface SuborderBrandResponse
 */
export interface SuborderBrandResponse {
    /**
     * 
     * @type {string}
     * @memberof SuborderBrandResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderBrandResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderBrandResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderBrandResponse
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderBrandResponse
     */
    'last_name'?: string;
}
/**
 * 
 * @export
 * @interface SuborderDashboardResponse
 */
export interface SuborderDashboardResponse {
    /**
     * 
     * @type {string}
     * @memberof SuborderDashboardResponse
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof SuborderDashboardResponse
     */
    'number'?: number;
    /**
     * 
     * @type {string}
     * @memberof SuborderDashboardResponse
     */
    'brand_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderDashboardResponse
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderDashboardResponse
     */
    'payout_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderDashboardResponse
     */
    'original_charge_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderDashboardResponse
     */
    'scheduled_charge_date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SuborderDashboardResponse
     */
    'manually_charged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuborderDashboardResponse
     */
    'charge_date_adjusted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SuborderDashboardResponse
     */
    'returned_amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuborderDashboardResponse
     */
    'accepted_amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuborderDashboardResponse
     */
    'declined_amount'?: number;
}
/**
 * 
 * @export
 * @interface SuborderFromReorderResponse
 */
export interface SuborderFromReorderResponse {
    /**
     * 
     * @type {string}
     * @memberof SuborderFromReorderResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderFromReorderResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof SuborderFromReorderResponse
     */
    'order_number'?: number;
    /**
     * 
     * @type {string}
     * @memberof SuborderFromReorderResponse
     */
    'order_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderFromReorderResponse
     */
    'order_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof SuborderFromReorderResponse
     */
    'suborder_number'?: number;
    /**
     * 
     * @type {Array<SuborderItemFromReorderResponse>}
     * @memberof SuborderFromReorderResponse
     */
    'items'?: Array<SuborderItemFromReorderResponse>;
}
/**
 * 
 * @export
 * @interface SuborderHistoryResponse
 */
export interface SuborderHistoryResponse {
    /**
     * 
     * @type {string}
     * @memberof SuborderHistoryResponse
     */
    'user_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderHistoryResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderHistoryResponse
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderHistoryResponse
     */
    'action'?: SuborderHistoryResponseActionEnum;
    /**
     * 
     * @type {string}
     * @memberof SuborderHistoryResponse
     */
    'order_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderHistoryResponse
     */
    'suborder_id'?: string;
}

export const SuborderHistoryResponseActionEnum = {
    ManuallyChargeSuborder: 'MANUALLY_CHARGE_SUBORDER',
    ChangeSuborderStatus: 'CHANGE_SUBORDER_STATUS',
    AddNewSuborderItems: 'ADD_NEW_SUBORDER_ITEMS',
    AdjustPackingSlipShippedQuantity: 'ADJUST_PACKING_SLIP_SHIPPED_QUANTITY',
    AdjustSuborderChargeDate: 'ADJUST_SUBORDER_CHARGE_DATE',
    PayInvoice: 'PAY_INVOICE',
    TrackInventory: 'TRACK_INVENTORY',
    ChangePaymentTerms: 'CHANGE_PAYMENT_TERMS'
} as const;

export type SuborderHistoryResponseActionEnum = typeof SuborderHistoryResponseActionEnum[keyof typeof SuborderHistoryResponseActionEnum];

/**
 * 
 * @export
 * @interface SuborderItem
 */
export interface SuborderItem {
    /**
     * 
     * @type {string}
     * @memberof SuborderItem
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderItem
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SuborderItem
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SuborderItem
     */
    'deleted': boolean;
    /**
     * 
     * @type {Suborder}
     * @memberof SuborderItem
     */
    'suborder': Suborder;
    /**
     * 
     * @type {ProductVariant}
     * @memberof SuborderItem
     */
    'productVariant': ProductVariant;
    /**
     * 
     * @type {number}
     * @memberof SuborderItem
     */
    'fulfilledQuantity': number;
    /**
     * 
     * @type {number}
     * @memberof SuborderItem
     */
    'orderedQuantity': number;
    /**
     * 
     * @type {number}
     * @memberof SuborderItem
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof SuborderItem
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderItem
     */
    'productName'?: string;
    /**
     * 
     * @type {number}
     * @memberof SuborderItem
     */
    'posPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuborderItem
     */
    'compareAtPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuborderItem
     */
    'costPerItem'?: number;
    /**
     * 
     * @type {Category}
     * @memberof SuborderItem
     */
    'category': Category;
    /**
     * 
     * @type {string}
     * @memberof SuborderItem
     */
    'sku'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SuborderItem
     */
    'characteristicOptionMap'?: { [key: string]: string; };
    /**
     * 
     * @type {Set<PackingSlipItem>}
     * @memberof SuborderItem
     */
    'packingSlipItems'?: Set<PackingSlipItem>;
    /**
     * 
     * @type {Set<OrderReturnItem>}
     * @memberof SuborderItem
     */
    'orderReturnItems'?: Set<OrderReturnItem>;
    /**
     * 
     * @type {number}
     * @memberof SuborderItem
     */
    'finalValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuborderItem
     */
    'totalShippedQuantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuborderItem
     */
    'totalShippedPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuborderItem
     */
    'finalQuantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuborderItem
     */
    'finalShippedValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuborderItem
     */
    'totalReturnPrice'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SuborderItem
     */
    'new'?: boolean;
}
/**
 * 
 * @export
 * @interface SuborderItemFromReorderResponse
 */
export interface SuborderItemFromReorderResponse {
    /**
     * 
     * @type {string}
     * @memberof SuborderItemFromReorderResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderItemFromReorderResponse
     */
    'product_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SuborderItemFromReorderResponse
     */
    'is_product_active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SuborderItemFromReorderResponse
     */
    'variant_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SuborderItemFromReorderResponse
     */
    'is_variant_deleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuborderItemFromReorderResponse
     */
    'is_tester'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SuborderItemFromReorderResponse
     */
    'original_quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuborderItemFromReorderResponse
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuborderItemFromReorderResponse
     */
    'pos_price'?: number;
    /**
     * 
     * @type {string}
     * @memberof SuborderItemFromReorderResponse
     */
    'product_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderItemFromReorderResponse
     */
    'product_image'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SuborderItemFromReorderResponse
     */
    'characteristic_option_map'?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof SuborderItemFromReorderResponse
     */
    'track_inventory'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuborderItemFromReorderResponse
     */
    'in_stock'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SuborderItemFromReorderResponse
     */
    'inventory_quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuborderItemFromReorderResponse
     */
    'wholesale_increment'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuborderItemFromReorderResponse
     */
    'wholesale_minimum'?: number;
}
/**
 * 
 * @export
 * @interface SuborderItemRequest
 */
export interface SuborderItemRequest {
    /**
     * 
     * @type {string}
     * @memberof SuborderItemRequest
     */
    'variant_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderItemRequest
     */
    'category_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof SuborderItemRequest
     */
    'quantity'?: number;
}
/**
 * 
 * @export
 * @interface SuborderItemResponse
 */
export interface SuborderItemResponse {
    /**
     * 
     * @type {string}
     * @memberof SuborderItemResponse
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof SuborderItemResponse
     */
    'fulfilled_quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuborderItemResponse
     */
    'ordered_quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuborderItemResponse
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof SuborderItemResponse
     */
    'product_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderItemResponse
     */
    'product_image'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderItemResponse
     */
    'sku'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SuborderItemResponse
     */
    'characteristic_option_map'?: { [key: string]: string; };
    /**
     * 
     * @type {number}
     * @memberof SuborderItemResponse
     */
    'shipped_quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuborderItemResponse
     */
    'returnable_quantity'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SuborderItemResponse
     */
    'added_subsequently'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SuborderItemResponse
     */
    'total_suborder_item_price'?: number;
}
/**
 * 
 * @export
 * @interface SuborderPartialResponse
 */
export interface SuborderPartialResponse {
    /**
     * 
     * @type {string}
     * @memberof SuborderPartialResponse
     */
    'suborder_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderPartialResponse
     */
    'brand_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderPartialResponse
     */
    'order_status'?: SuborderPartialResponseOrderStatusEnum;
}

export const SuborderPartialResponseOrderStatusEnum = {
    Hold: 'HOLD',
    Void: 'VOID',
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Declined: 'DECLINED',
    Expired: 'EXPIRED',
    PartiallyFulfilled: 'PARTIALLY_FULFILLED',
    FulfillmentInProgress: 'FULFILLMENT_IN_PROGRESS',
    Shipped: 'SHIPPED',
    Paid: 'PAID',
    Failed: 'FAILED',
    NotCollectable: 'NOT_COLLECTABLE',
    Cancelled: 'CANCELLED'
} as const;

export type SuborderPartialResponseOrderStatusEnum = typeof SuborderPartialResponseOrderStatusEnum[keyof typeof SuborderPartialResponseOrderStatusEnum];

/**
 * 
 * @export
 * @interface SuborderResponse
 */
export interface SuborderResponse {
    /**
     * 
     * @type {string}
     * @memberof SuborderResponse
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof SuborderResponse
     */
    'number'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuborderResponse
     */
    'order_number'?: number;
    /**
     * 
     * @type {SuborderBrandResponse}
     * @memberof SuborderResponse
     */
    'brand'?: SuborderBrandResponse;
    /**
     * 
     * @type {SuborderRetailerResponse}
     * @memberof SuborderResponse
     */
    'retailer'?: SuborderRetailerResponse;
    /**
     * 
     * @type {string}
     * @memberof SuborderResponse
     */
    'status'?: SuborderResponseStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SuborderResponse
     */
    'adjusted_status'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SuborderResponse
     */
    'shipping_info'?: string;
    /**
     * 
     * @type {AddressResponse}
     * @memberof SuborderResponse
     */
    'address'?: AddressResponse;
    /**
     * 
     * @type {boolean}
     * @memberof SuborderResponse
     */
    'is_custom_assortment'?: boolean;
    /**
     * 
     * @type {Array<SuborderItemResponse>}
     * @memberof SuborderResponse
     */
    'items'?: Array<SuborderItemResponse>;
    /**
     * 
     * @type {string}
     * @memberof SuborderResponse
     */
    'payout_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderResponse
     */
    'original_charge_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderResponse
     */
    'scheduled_charge_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderResponse
     */
    'updated_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof SuborderResponse
     */
    'payout'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuborderResponse
     */
    'commission'?: number;
    /**
     * 
     * @type {number}
     * @memberof SuborderResponse
     */
    'commission_percent'?: number;
    /**
     * 
     * @type {Array<PackingSlipResponse>}
     * @memberof SuborderResponse
     */
    'packing_slips'?: Array<PackingSlipResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof SuborderResponse
     */
    'manually_charged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuborderResponse
     */
    'charge_date_adjusted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SuborderResponse
     */
    'decline_order_reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderResponse
     */
    'additional_information'?: string;
    /**
     * 
     * @type {number}
     * @memberof SuborderResponse
     */
    'total_suborder_price'?: number;
    /**
     * 
     * @type {string}
     * @memberof SuborderResponse
     */
    'promo_code'?: string;
    /**
     * 
     * @type {number}
     * @memberof SuborderResponse
     */
    'promo_code_amount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SuborderResponse
     */
    'admin_promo_code'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SuborderResponse
     */
    'promo_code_type'?: SuborderResponsePromoCodeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SuborderResponse
     */
    'invoiceUrl'?: string;
    /**
     * 
     * @type {ShopifyOrderAlgolia}
     * @memberof SuborderResponse
     */
    'shopify'?: ShopifyOrderAlgolia;
    /**
     * 
     * @type {ShopifySuborderResponse}
     * @memberof SuborderResponse
     */
    'shopify_suborder'?: ShopifySuborderResponse;
}

export const SuborderResponseStatusEnum = {
    Hold: 'HOLD',
    Void: 'VOID',
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Declined: 'DECLINED',
    Expired: 'EXPIRED',
    PartiallyFulfilled: 'PARTIALLY_FULFILLED',
    FulfillmentInProgress: 'FULFILLMENT_IN_PROGRESS',
    Shipped: 'SHIPPED',
    Paid: 'PAID',
    Failed: 'FAILED',
    NotCollectable: 'NOT_COLLECTABLE',
    Cancelled: 'CANCELLED'
} as const;

export type SuborderResponseStatusEnum = typeof SuborderResponseStatusEnum[keyof typeof SuborderResponseStatusEnum];
export const SuborderResponsePromoCodeTypeEnum = {
    Percent: 'PERCENT',
    Amount: 'AMOUNT',
    FreeShipping: 'FREE_SHIPPING'
} as const;

export type SuborderResponsePromoCodeTypeEnum = typeof SuborderResponsePromoCodeTypeEnum[keyof typeof SuborderResponsePromoCodeTypeEnum];

/**
 * 
 * @export
 * @interface SuborderRetailerResponse
 */
export interface SuborderRetailerResponse {
    /**
     * 
     * @type {string}
     * @memberof SuborderRetailerResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderRetailerResponse
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderRetailerResponse
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderRetailerResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuborderRetailerResponse
     */
    'store_name'?: string;
}
/**
 * 
 * @export
 * @interface SuborderReturnResponse
 */
export interface SuborderReturnResponse {
    /**
     * 
     * @type {string}
     * @memberof SuborderReturnResponse
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof SuborderReturnResponse
     */
    'number'?: number;
    /**
     * 
     * @type {string}
     * @memberof SuborderReturnResponse
     */
    'brand_name'?: string;
    /**
     * 
     * @type {Array<OrderReturnItemResponse>}
     * @memberof SuborderReturnResponse
     */
    'items'?: Array<OrderReturnItemResponse>;
}
/**
 * 
 * @export
 * @interface SubordersLogsResponse
 */
export interface SubordersLogsResponse {
    /**
     * 
     * @type {Array<SuborderHistoryResponse>}
     * @memberof SubordersLogsResponse
     */
    'suborders'?: Array<SuborderHistoryResponse>;
}
/**
 * 
 * @export
 * @interface SyncBrandsToSalesforceRequest
 */
export interface SyncBrandsToSalesforceRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncBrandsToSalesforceRequest
     */
    'brand_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface SyncOrdersToSalesforceRequest
 */
export interface SyncOrdersToSalesforceRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncOrdersToSalesforceRequest
     */
    'order_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface SyncRetailersToSalesforceRequest
 */
export interface SyncRetailersToSalesforceRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncRetailersToSalesforceRequest
     */
    'retailer_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface SyncSubordersToSalesforceRequest
 */
export interface SyncSubordersToSalesforceRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncSubordersToSalesforceRequest
     */
    'suborder_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface SyncTradeShowsToAlgoliaRequest
 */
export interface SyncTradeShowsToAlgoliaRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncTradeShowsToAlgoliaRequest
     */
    'event_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface TestEmailRequest
 */
export interface TestEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof TestEmailRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof TestEmailRequest
     */
    'email_template_name'?: string;
}
/**
 * 
 * @export
 * @interface ToggleBrandsBulletinPickRequest
 */
export interface ToggleBrandsBulletinPickRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ToggleBrandsBulletinPickRequest
     */
    'brand_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface TradeShowAttendeeProvince
 */
export interface TradeShowAttendeeProvince {
    /**
     * 
     * @type {string}
     * @memberof TradeShowAttendeeProvince
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TradeShowAttendeeProvince
     */
    'code'?: string;
}
/**
 * 
 * @export
 * @interface TradeShowBrandResponse
 */
export interface TradeShowBrandResponse {
    /**
     * 
     * @type {string}
     * @memberof TradeShowBrandResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TradeShowBrandResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TradeShowBrandResponse
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof TradeShowBrandResponse
     */
    'registration_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof TradeShowBrandResponse
     */
    'marketplace_visibility_override'?: TradeShowBrandResponseMarketplaceVisibilityOverrideEnum;
}

export const TradeShowBrandResponseMarketplaceVisibilityOverrideEnum = {
    None: 'NONE',
    Forced: 'FORCED',
    BrandOverride: 'BRAND_OVERRIDE'
} as const;

export type TradeShowBrandResponseMarketplaceVisibilityOverrideEnum = typeof TradeShowBrandResponseMarketplaceVisibilityOverrideEnum[keyof typeof TradeShowBrandResponseMarketplaceVisibilityOverrideEnum];

/**
 * 
 * @export
 * @interface TradeShowCountryResponse
 */
export interface TradeShowCountryResponse {
    /**
     * 
     * @type {string}
     * @memberof TradeShowCountryResponse
     */
    'country'?: string;
    /**
     * 
     * @type {Array<TradeShowAttendeeProvince>}
     * @memberof TradeShowCountryResponse
     */
    'provinces'?: Array<TradeShowAttendeeProvince>;
}
/**
 * 
 * @export
 * @interface TradeShowEnabledFeaturesResponse
 */
export interface TradeShowEnabledFeaturesResponse {
    /**
     * 
     * @type {Features}
     * @memberof TradeShowEnabledFeaturesResponse
     */
    'features'?: Features;
}
/**
 * 
 * @export
 * @interface TradeShowFeatureRequest
 */
export interface TradeShowFeatureRequest {
    /**
     * 
     * @type {string}
     * @memberof TradeShowFeatureRequest
     */
    'name': TradeShowFeatureRequestNameEnum;
    /**
     * 
     * @type {string}
     * @memberof TradeShowFeatureRequest
     */
    'start_date_time': string;
    /**
     * 
     * @type {string}
     * @memberof TradeShowFeatureRequest
     */
    'end_date_time': string;
}

export const TradeShowFeatureRequestNameEnum = {
    BrandProfileBadges: 'BRAND_PROFILE_BADGES',
    BuyerDirectory: 'BUYER_DIRECTORY',
    BuyerWelcomeEmails: 'BUYER_WELCOME_EMAILS',
    DailyReports: 'DAILY_REPORTS',
    ExhibitorDirectory: 'EXHIBITOR_DIRECTORY',
    ExhibitorImport: 'EXHIBITOR_IMPORT',
    ExhibitorWelcomeEmails: 'EXHIBITOR_WELCOME_EMAILS',
    Navigation: 'NAVIGATION',
    RestrictExhibitorVisibility: 'RESTRICT_EXHIBITOR_VISIBILITY',
    ReducedCommission: 'REDUCED_COMMISSION',
    ZeroCommission: 'ZERO_COMMISSION'
} as const;

export type TradeShowFeatureRequestNameEnum = typeof TradeShowFeatureRequestNameEnum[keyof typeof TradeShowFeatureRequestNameEnum];

/**
 * 
 * @export
 * @interface TradeShowFeatureResponse
 */
export interface TradeShowFeatureResponse {
    /**
     * 
     * @type {string}
     * @memberof TradeShowFeatureResponse
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TradeShowFeatureResponse
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TradeShowFeatureResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TradeShowFeatureResponse
     */
    'start_date_time'?: string;
    /**
     * 
     * @type {string}
     * @memberof TradeShowFeatureResponse
     */
    'end_date_time'?: string;
}
/**
 * 
 * @export
 * @interface TradeShowFeaturesResponse
 */
export interface TradeShowFeaturesResponse {
    /**
     * 
     * @type {boolean}
     * @memberof TradeShowFeaturesResponse
     */
    'exhibitor_directory_enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TradeShowFeaturesResponse
     */
    'buyer_directory_enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TradeShowFeaturesResponse
     */
    'navigation_enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TradeShowFeaturesResponse
     */
    'brand_profile_badges_enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TradeShowFeaturesResponse
     */
    'restrict_exhibitor_visibility'?: boolean;
}
/**
 * 
 * @export
 * @interface TradeShowRecommendedBrandsResponse
 */
export interface TradeShowRecommendedBrandsResponse {
    /**
     * 
     * @type {string}
     * @memberof TradeShowRecommendedBrandsResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TradeShowRecommendedBrandsResponse
     */
    'company_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TradeShowRecommendedBrandsResponse
     */
    'vanity_url_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TradeShowRecommendedBrandsResponse
     */
    'thumbnail_image_url'?: string;
    /**
     * 
     * @type {number}
     * @memberof TradeShowRecommendedBrandsResponse
     */
    'minimum_order_value'?: number;
    /**
     * 
     * @type {string}
     * @memberof TradeShowRecommendedBrandsResponse
     */
    'booth'?: string;
}
/**
 * 
 * @export
 * @interface TradeShowResponse
 */
export interface TradeShowResponse {
    /**
     * 
     * @type {string}
     * @memberof TradeShowResponse
     */
    'id'?: string;
    /**
     * 
     * @type {TradeShowFeaturesResponse}
     * @memberof TradeShowResponse
     */
    'features'?: TradeShowFeaturesResponse;
    /**
     * 
     * @type {string}
     * @memberof TradeShowResponse
     */
    'a2z_event_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TradeShowResponse
     */
    'active'?: boolean;
    /**
     * 
     * @type {TradeShowBrandResponse}
     * @memberof TradeShowResponse
     */
    'trade_show_brand'?: TradeShowBrandResponse;
    /**
     * 
     * @type {string}
     * @memberof TradeShowResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TradeShowResponse
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof TradeShowResponse
     */
    'start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof TradeShowResponse
     */
    'end_date'?: string;
    /**
     * 
     * @type {Array<AdminCollectionResponse>}
     * @memberof TradeShowResponse
     */
    'admin_collections'?: Array<AdminCollectionResponse>;
    /**
     * 
     * @type {string}
     * @memberof TradeShowResponse
     */
    'booth_map_url'?: string;
}
/**
 * 
 * @export
 * @interface TransactionResponse
 */
export interface TransactionResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof TransactionResponse
     */
    'allowedPaymentMethods'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof TransactionResponse
     */
    'authAmount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionResponse
     */
    'autoBilled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionResponse
     */
    'autoPayouts'?: boolean;
    /**
     * 
     * @type {BalanceAddress}
     * @memberof TransactionResponse
     */
    'billingAddress'?: BalanceAddress;
    /**
     * 
     * @type {Buyer}
     * @memberof TransactionResponse
     */
    'buyer'?: Buyer;
    /**
     * 
     * @type {number}
     * @memberof TransactionResponse
     */
    'capturedAmount'?: number;
    /**
     * 
     * @type {Array<Charge>}
     * @memberof TransactionResponse
     */
    'charges'?: Array<Charge>;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    'currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    'externalReferenceId'?: string;
    /**
     * 
     * @type {FinancingConfig}
     * @memberof TransactionResponse
     */
    'financingConfig'?: FinancingConfig;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionResponse
     */
    'isFinanced'?: boolean;
    /**
     * 
     * @type {Array<Line>}
     * @memberof TransactionResponse
     */
    'lines'?: Array<Line>;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    'link'?: string;
    /**
     * 
     * @type {object}
     * @memberof TransactionResponse
     */
    'marketplaceFixedTake'?: object;
    /**
     * 
     * @type {object}
     * @memberof TransactionResponse
     */
    'marketplacePercentageTake'?: object;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    'notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    'paymentMethodId'?: string;
    /**
     * 
     * @type {Plan}
     * @memberof TransactionResponse
     */
    'plan'?: Plan;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    'selectedPaymentMethod'?: string;
    /**
     * 
     * @type {BalanceAddress}
     * @memberof TransactionResponse
     */
    'shippingAddress'?: BalanceAddress;
    /**
     * 
     * @type {StatementDescriptor}
     * @memberof TransactionResponse
     */
    'statementDescriptor'?: StatementDescriptor;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionResponse
     */
    'totalDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionResponse
     */
    'totalLineItems'?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionResponse
     */
    'totalPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionResponse
     */
    'totalShipping'?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionResponse
     */
    'totalTax'?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    'vendorName'?: string;
    /**
     * 
     * @type {Array<Vendor>}
     * @memberof TransactionResponse
     */
    'vendors'?: Array<Vendor>;
}
/**
 * Unlink brands from trade show request
 * @export
 * @interface UnlinkBrandsFromTradeShowRequest
 */
export interface UnlinkBrandsFromTradeShowRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UnlinkBrandsFromTradeShowRequest
     */
    'emails'?: Array<string>;
}
/**
 * Updated address data
 * @export
 * @interface UpdateAddressRequest
 */
export interface UpdateAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressRequest
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressRequest
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressRequest
     */
    'apartment'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressRequest
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressRequest
     */
    'street': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressRequest
     */
    'zip_code': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressRequest
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressRequest
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressRequest
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressRequest
     */
    'company'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAddressRequest
     */
    'shipping': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAddressRequest
     */
    'billing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAddressRequest
     */
    'default_shipping': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAddressRequest
     */
    'default_billing': boolean;
}
/**
 * 
 * @export
 * @interface UpdateAlgoliaProductsInBatchesRequest
 */
export interface UpdateAlgoliaProductsInBatchesRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateAlgoliaProductsInBatchesRequest
     */
    'number_of_batches': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAlgoliaProductsInBatchesRequest
     */
    'start_page_number'?: number;
}
/**
 * 
 * @export
 * @interface UpdateBannerComponentRequest
 */
export interface UpdateBannerComponentRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateBannerComponentRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBannerComponentRequest
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBannerComponentRequest
     */
    'link'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBannerComponentRequest
     */
    'text_color'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBannerComponentRequest
     */
    'background_color'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBannerComponentRequest
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateBannerContainerRequest
 */
export interface UpdateBannerContainerRequest {
    /**
     * 
     * @type {Array<UpdateBannerComponentRequest>}
     * @memberof UpdateBannerContainerRequest
     */
    'components'?: Array<UpdateBannerComponentRequest>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBannerContainerRequest
     */
    'toggled'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateBrandAlgoliaFlagRequest
 */
export interface UpdateBrandAlgoliaFlagRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateBrandAlgoliaFlagRequest
     */
    'number_of_batches'?: number;
}
/**
 * Update Brand Board object
 * @export
 * @interface UpdateBrandBoardRequest
 */
export interface UpdateBrandBoardRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandBoardRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandBoardRequest
     */
    'visibility'?: UpdateBrandBoardRequestVisibilityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBrandBoardRequest
     */
    'show_on_profile'?: boolean;
}

export const UpdateBrandBoardRequestVisibilityEnum = {
    Bulletin: 'BULLETIN',
    Public: 'PUBLIC'
} as const;

export type UpdateBrandBoardRequestVisibilityEnum = typeof UpdateBrandBoardRequestVisibilityEnum[keyof typeof UpdateBrandBoardRequestVisibilityEnum];

/**
 * Update brand object
 * @export
 * @interface UpdateBrandRequest
 */
export interface UpdateBrandRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandRequest
     */
    'brand_name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandRequest
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandRequest
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandRequest
     */
    'brand_description': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandRequest
     */
    'vanity_url_name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandRequest
     */
    'website_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandRequest
     */
    'instagram_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandRequest
     */
    'instagram_followers'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandRequest
     */
    'based_in'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateBrandRequest
     */
    'min_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBrandRequest
     */
    'max_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBrandRequest
     */
    'minimum_quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBrandRequest
     */
    'minimum_price'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandRequest
     */
    'product_arrival'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBrandRequest
     */
    'is_published': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandRequest
     */
    'logo_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandRequest
     */
    'brand_bio_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandRequest
     */
    'bulletin_reference'?: string;
    /**
     * 
     * @type {Array<BrandLocationRequest>}
     * @memberof UpdateBrandRequest
     */
    'brand_locations'?: Array<BrandLocationRequest>;
    /**
     * 
     * @type {number}
     * @memberof UpdateBrandRequest
     */
    'increment'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBrandRequest
     */
    'instagram_growth_help'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateBrandRequest
     */
    'minimum_order_value': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBrandRequest
     */
    'minimum_reorder_value'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandRequest
     */
    'thumbnail_image_url'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateBrandRequest
     */
    'values'?: Array<UpdateBrandRequestValuesEnum>;
    /**
     * 
     * @type {object}
     * @memberof UpdateBrandRequest
     */
    'address'?: object;
    /**
     * 
     * @type {object}
     * @memberof UpdateBrandRequest
     */
    'fulfillment_address'?: object;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandRequest
     */
    'phone_number'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateBrandRequest
     */
    'special_services'?: Array<UpdateBrandRequestSpecialServicesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateBrandRequest
     */
    'deals_and_promotions'?: Array<UpdateBrandRequestDealsAndPromotionsEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBrandRequest
     */
    'bulletin_pick': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBrandRequest
     */
    'buy_on_bulletin'?: boolean;
}

export const UpdateBrandRequestValuesEnum = {
    FemaleFounded: 'FEMALE_FOUNDED',
    EthicalProduction: 'ETHICAL_PRODUCTION',
    CleanIngredients: 'CLEAN_INGREDIENTS',
    Sustainable: 'SUSTAINABLE',
    Handmade: 'HANDMADE',
    MadeInTheUs: 'MADE_IN_THE_US',
    CharitableBrandGiveBack: 'CHARITABLE_BRAND_GIVE_BACK',
    Organic: 'ORGANIC',
    ZeroWaste: 'ZERO_WASTE',
    BlackOwned: 'BLACK_OWNED',
    LatinxOwned: 'LATINX_OWNED',
    AapiOwned: 'AAPI_OWNED',
    IndigenousOwned: 'INDIGENOUS_OWNED',
    LgbtqOwned: 'LGBTQ_OWNED',
    MinorityOwnedBusiness: 'MINORITY_OWNED_BUSINESS',
    DisabilityOwned: 'DISABILITY_OWNED'
} as const;

export type UpdateBrandRequestValuesEnum = typeof UpdateBrandRequestValuesEnum[keyof typeof UpdateBrandRequestValuesEnum];
export const UpdateBrandRequestSpecialServicesEnum = {
    Collaboration: 'COLLABORATION',
    Customization: 'CUSTOMIZATION',
    DropShipping: 'DROP_SHIPPING',
    Personalization: 'PERSONALIZATION',
    PrivateLabel: 'PRIVATE_LABEL',
    WhiteLabel: 'WHITE_LABEL'
} as const;

export type UpdateBrandRequestSpecialServicesEnum = typeof UpdateBrandRequestSpecialServicesEnum[keyof typeof UpdateBrandRequestSpecialServicesEnum];
export const UpdateBrandRequestDealsAndPromotionsEnum = {
    Discounts: 'DISCOUNTS',
    FreeGifts: 'FREE_GIFTS',
    FreeProductSamples: 'FREE_PRODUCT_SAMPLES',
    FreeShipping: 'FREE_SHIPPING',
    LowMinimumOrder: 'LOW_MINIMUM_ORDER',
    NewBuyerPromotion: 'NEW_BUYER_PROMOTION',
    NoMinimumOrder: 'NO_MINIMUM_ORDER',
    SpecialSale: 'SPECIAL_SALE'
} as const;

export type UpdateBrandRequestDealsAndPromotionsEnum = typeof UpdateBrandRequestDealsAndPromotionsEnum[keyof typeof UpdateBrandRequestDealsAndPromotionsEnum];

/**
 * Variant with total quantity to set in cart
 * @export
 * @interface UpdateCartRequest
 */
export interface UpdateCartRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCartRequest
     */
    'variant_id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCartRequest
     */
    'category_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCartRequest
     */
    'total_quantity': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCartRequest
     */
    'query_id'?: string;
}
/**
 * Updated category object
 * @export
 * @interface UpdateCategoryRequest
 */
export interface UpdateCategoryRequest {
    /**
     * 
     * @type {Array<ProductOrdinalDto>}
     * @memberof UpdateCategoryRequest
     */
    'product_ids': Array<ProductOrdinalDto>;
}
/**
 * 
 * @export
 * @interface UpdateCollectionRequest
 */
export interface UpdateCollectionRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCollectionRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCollectionRequest
     */
    'internal_title'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCollectionRequest
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCollectionRequest
     */
    'active': boolean;
    /**
     * 
     * @type {Array<ProductOrdinalDto>}
     * @memberof UpdateCollectionRequest
     */
    'product_ids'?: Array<ProductOrdinalDto>;
    /**
     * 
     * @type {Array<ProductOrdinalDto>}
     * @memberof UpdateCollectionRequest
     */
    'removed_product_ids'?: Array<ProductOrdinalDto>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCollectionRequest
     */
    'include_all_conditions'?: boolean;
    /**
     * 
     * @type {Array<ProductSearchCriteriaRequest>}
     * @memberof UpdateCollectionRequest
     */
    'product_search_criteria'?: Array<ProductSearchCriteriaRequest>;
    /**
     * 
     * @type {string}
     * @memberof UpdateCollectionRequest
     */
    'featured_category_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCollectionRequest
     */
    'collection_type'?: UpdateCollectionRequestCollectionTypeEnum;
}

export const UpdateCollectionRequestCollectionTypeEnum = {
    Manual: 'MANUAL',
    Automated: 'AUTOMATED',
    Parent: 'PARENT'
} as const;

export type UpdateCollectionRequestCollectionTypeEnum = typeof UpdateCollectionRequestCollectionTypeEnum[keyof typeof UpdateCollectionRequestCollectionTypeEnum];

/**
 * 
 * @export
 * @interface UpdateCreditCardRequest
 */
export interface UpdateCreditCardRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCreditCardRequest
     */
    'stripe_card_token': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCreditCardRequest
     */
    'old_card_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCreditCardRequest
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCreditCardRequest
     */
    'last_name': string;
}
/**
 * Update custom assortment object
 * @export
 * @interface UpdateCustomAssortmentRequest
 */
export interface UpdateCustomAssortmentRequest {
    /**
     * 
     * @type {Array<CustomAssortmentItemRequest>}
     * @memberof UpdateCustomAssortmentRequest
     */
    'custom_assortment_items'?: Array<CustomAssortmentItemRequest>;
}
/**
 * 
 * @export
 * @interface UpdateDraftBrandRequest
 */
export interface UpdateDraftBrandRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftBrandRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftBrandRequest
     */
    'draft_brand_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftBrandRequest
     */
    'user_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateDraftBrandRequest
     */
    'onboarding_step'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftBrandRequest
     */
    'admin_first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftBrandRequest
     */
    'admin_last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftBrandRequest
     */
    'account_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftBrandRequest
     */
    'phone_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftBrandRequest
     */
    'company_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftBrandRequest
     */
    'website_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftBrandRequest
     */
    'owner_first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftBrandRequest
     */
    'owner_last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftBrandRequest
     */
    'instagram_account_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftBrandRequest
     */
    'instagram_follower_count'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDraftBrandRequest
     */
    'values'?: Array<UpdateDraftBrandRequestValuesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDraftBrandRequest
     */
    'product_categories'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftBrandRequest
     */
    'years_in_business'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftBrandRequest
     */
    'profile_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftBrandRequest
     */
    'additional_photography_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftBrandRequest
     */
    'description'?: string;
    /**
     * 
     * @type {object}
     * @memberof UpdateDraftBrandRequest
     */
    'address'?: object;
    /**
     * 
     * @type {object}
     * @memberof UpdateDraftBrandRequest
     */
    'fulfillment_address'?: object;
    /**
     * 
     * @type {number}
     * @memberof UpdateDraftBrandRequest
     */
    'minimum_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDraftBrandRequest
     */
    'maximum_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDraftBrandRequest
     */
    'minimum_order_value'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDraftBrandRequest
     */
    'reorder_minimum_order_value'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDraftBrandRequest
     */
    'minimum_order_quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftBrandRequest
     */
    'product_building_line_sheet_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDraftBrandRequest
     */
    'product_building_notes'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDraftBrandRequest
     */
    'buy_on_bulletin'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDraftBrandRequest
     */
    'connect_with_shopify'?: boolean;
}

export const UpdateDraftBrandRequestValuesEnum = {
    FemaleFounded: 'FEMALE_FOUNDED',
    EthicalProduction: 'ETHICAL_PRODUCTION',
    CleanIngredients: 'CLEAN_INGREDIENTS',
    Sustainable: 'SUSTAINABLE',
    Handmade: 'HANDMADE',
    MadeInTheUs: 'MADE_IN_THE_US',
    CharitableBrandGiveBack: 'CHARITABLE_BRAND_GIVE_BACK',
    Organic: 'ORGANIC',
    ZeroWaste: 'ZERO_WASTE',
    BlackOwned: 'BLACK_OWNED',
    LatinxOwned: 'LATINX_OWNED',
    AapiOwned: 'AAPI_OWNED',
    IndigenousOwned: 'INDIGENOUS_OWNED',
    LgbtqOwned: 'LGBTQ_OWNED',
    MinorityOwnedBusiness: 'MINORITY_OWNED_BUSINESS',
    DisabilityOwned: 'DISABILITY_OWNED'
} as const;

export type UpdateDraftBrandRequestValuesEnum = typeof UpdateDraftBrandRequestValuesEnum[keyof typeof UpdateDraftBrandRequestValuesEnum];

/**
 * Update external service object
 * @export
 * @interface UpdateExternalServiceRequest
 */
export interface UpdateExternalServiceRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateExternalServiceRequest
     */
    'numbers': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateExternalServiceRequest
     */
    'algolia'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateExternalServiceRequest
     */
    'salesforce'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateExternalServiceRequest
     */
    'retailer'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateInventoryLevelResponse
 */
export interface UpdateInventoryLevelResponse {
    /**
     * 
     * @type {Array<VariantWithoutSkuResponse>}
     * @memberof UpdateInventoryLevelResponse
     */
    'variants'?: Array<VariantWithoutSkuResponse>;
    /**
     * 
     * @type {string}
     * @memberof UpdateInventoryLevelResponse
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface UpdateInventoryTrackingResponse
 */
export interface UpdateInventoryTrackingResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateInventoryTrackingResponse
     */
    'invalidSkus'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof UpdateInventoryTrackingResponse
     */
    'validSkusNumber'?: number;
}
/**
 * 
 * @export
 * @interface UpdateOrderReturnItemRequest
 */
export interface UpdateOrderReturnItemRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderReturnItemRequest
     */
    'order_return_item_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateOrderReturnItemRequest
     */
    'accepted_quantity': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOrderReturnItemRequest
     */
    'declined_quantity': number;
}
/**
 * Update order return item object
 * @export
 * @interface UpdateOrderReturnItemsRequest
 */
export interface UpdateOrderReturnItemsRequest {
    /**
     * 
     * @type {Array<UpdateOrderReturnItemRequest>}
     * @memberof UpdateOrderReturnItemsRequest
     */
    'order_return_items'?: Array<UpdateOrderReturnItemRequest>;
}
/**
 * Update order return object
 * @export
 * @interface UpdateOrderReturnRequest
 */
export interface UpdateOrderReturnRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderReturnRequest
     */
    'tracking_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateOrderReturnRequest
     */
    'shipping_cost'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderReturnRequest
     */
    'shipping_carrier'?: UpdateOrderReturnRequestShippingCarrierEnum;
}

export const UpdateOrderReturnRequestShippingCarrierEnum = {
    Apc: 'APC',
    CanadaPost: 'CANADA_POST',
    Canpar: 'CANPAR',
    Dhl: 'DHL',
    FedEx: 'FedEx',
    Gls: 'GLS',
    NewGistics: 'NEW_GISTICS',
    Purolator: 'PUROLATOR',
    Sendle: 'SENDLE',
    SfExpress: 'SF_EXPRESS',
    Ups: 'UPS',
    Usps: 'USPS',
    Other: 'OTHER'
} as const;

export type UpdateOrderReturnRequestShippingCarrierEnum = typeof UpdateOrderReturnRequestShippingCarrierEnum[keyof typeof UpdateOrderReturnRequestShippingCarrierEnum];

/**
 * Update packing slip object
 * @export
 * @interface UpdatePackingSlipRequest
 */
export interface UpdatePackingSlipRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePackingSlipRequest
     */
    'tracking_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdatePackingSlipRequest
     */
    'shipping_cost'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdatePackingSlipRequest
     */
    'shipping_carrier'?: UpdatePackingSlipRequestShippingCarrierEnum;
}

export const UpdatePackingSlipRequestShippingCarrierEnum = {
    Apc: 'APC',
    CanadaPost: 'CANADA_POST',
    Canpar: 'CANPAR',
    Dhl: 'DHL',
    FedEx: 'FedEx',
    Gls: 'GLS',
    NewGistics: 'NEW_GISTICS',
    Purolator: 'PUROLATOR',
    Sendle: 'SENDLE',
    SfExpress: 'SF_EXPRESS',
    Ups: 'UPS',
    Usps: 'USPS',
    Other: 'OTHER'
} as const;

export type UpdatePackingSlipRequestShippingCarrierEnum = typeof UpdatePackingSlipRequestShippingCarrierEnum[keyof typeof UpdatePackingSlipRequestShippingCarrierEnum];

/**
 * 
 * @export
 * @interface UpdatePackingSlipShippedQuantitiesRequest
 */
export interface UpdatePackingSlipShippedQuantitiesRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePackingSlipShippedQuantitiesRequest
     */
    'packing_slip_item_id': string;
    /**
     * 
     * @type {number}
     * @memberof UpdatePackingSlipShippedQuantitiesRequest
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface UpdateProductImageCropInfoRequest
 */
export interface UpdateProductImageCropInfoRequest {
    /**
     * Image
     * @type {File}
     * @memberof UpdateProductImageCropInfoRequest
     */
    'image': File;
    /**
     * Crop data
     * @type {object}
     * @memberof UpdateProductImageCropInfoRequest
     */
    'crop_params': object;
}
/**
 * Update Product Inventory level object
 * @export
 * @interface UpdateProductInventoryLevelRequest
 */
export interface UpdateProductInventoryLevelRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductInventoryLevelRequest
     */
    'product_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductInventoryLevelRequest
     */
    'track_inventory'?: boolean;
    /**
     * 
     * @type {Array<ProductVariantInventoryLevelRequest>}
     * @memberof UpdateProductInventoryLevelRequest
     */
    'variants'?: Array<ProductVariantInventoryLevelRequest>;
}
/**
 * Update Product object
 * @export
 * @interface UpdateProductRequest
 */
export interface UpdateProductRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductRequest
     */
    'brand_id'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateProductRequest
     */
    'category_ids'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductRequest
     */
    'sell_pos'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductRequest
     */
    'sell_wholesale'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductRequest
     */
    'active': boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateProductRequest
     */
    'pos_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateProductRequest
     */
    'wholesale_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateProductRequest
     */
    'compare_at_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateProductRequest
     */
    'wholesale_minimum'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateProductRequest
     */
    'wholesale_increment'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductRequest
     */
    'opted_into_consignment'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateProductRequest
     */
    'commission_split'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductRequest
     */
    'visible': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateProductRequest
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof UpdateProductRequest
     */
    'min_lead_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateProductRequest
     */
    'max_lead_time'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductRequest
     */
    'is_test_product': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateProductRequest
     */
    'characteristics'?: Array<string>;
    /**
     * 
     * @type {Array<VariantRequest>}
     * @memberof UpdateProductRequest
     */
    'variants'?: Array<VariantRequest>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateProductRequest
     */
    'collections'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateProductRequest
     */
    'images'?: Array<string>;
    /**
     * 
     * @type {UpdateVideoRequest}
     * @memberof UpdateProductRequest
     */
    'video'?: UpdateVideoRequest;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateProductRequest
     */
    'custom_assortment_images'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductRequest
     */
    'track_inventory'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateProductRequest
     */
    'weight'?: number;
}
/**
 * Update Products Inventory levels object
 * @export
 * @interface UpdateProductsInventoryLevelsRequest
 */
export interface UpdateProductsInventoryLevelsRequest {
    /**
     * 
     * @type {Array<UpdateProductInventoryLevelRequest>}
     * @memberof UpdateProductsInventoryLevelsRequest
     */
    'products'?: Array<UpdateProductInventoryLevelRequest>;
}
/**
 * Update Promo code object
 * @export
 * @interface UpdatePromoCodeRequest
 */
export interface UpdatePromoCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePromoCodeRequest
     */
    'end_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePromoCodeRequest
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof UpdatePromoCodeRequest
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof UpdatePromoCodeRequest
     */
    'minimum_cart_value'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePromoCodeRequest
     */
    'ongoing_indefinite'?: boolean;
}
/**
 * Update Retailer Account object
 * @export
 * @interface UpdateRetailerAccountRequest
 */
export interface UpdateRetailerAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateRetailerAccountRequest
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRetailerAccountRequest
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRetailerAccountRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRetailerAccountRequest
     */
    'store_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRetailerAccountRequest
     */
    'store_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRetailerAccountRequest
     */
    'year_founded'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRetailerAccountRequest
     */
    'instagram'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRetailerAccountRequest
     */
    'facebook'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRetailerAccountRequest
     */
    'twitter'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRetailerAccountRequest
     */
    'bio'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRetailerAccountRequest
     */
    'thumbnail_image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRetailerAccountRequest
     */
    'status'?: UpdateRetailerAccountRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateRetailerAccountRequest
     */
    'store_location_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRetailerAccountRequest
     */
    'balance_level'?: UpdateRetailerAccountRequestBalanceLevelEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateRetailerAccountRequest
     */
    'values'?: Array<UpdateRetailerAccountRequestValuesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateRetailerAccountRequest
     */
    'store_types'?: Array<UpdateRetailerAccountRequestStoreTypesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateRetailerAccountRequest
     */
    'store_gallery'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRetailerAccountRequest
     */
    'is_public': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateRetailerAccountRequest
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRetailerAccountRequest
     */
    'score'?: UpdateRetailerAccountRequestScoreEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateRetailerAccountRequest
     */
    'phone_number'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRetailerAccountRequest
     */
    'review_required': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRetailerAccountRequest
     */
    'payment_plan_enrolled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRetailerAccountRequest
     */
    'use_balance': boolean;
}

export const UpdateRetailerAccountRequestStatusEnum = {
    Pending: 'PENDING',
    Active: 'ACTIVE',
    Suspended: 'SUSPENDED',
    Banned: 'BANNED'
} as const;

export type UpdateRetailerAccountRequestStatusEnum = typeof UpdateRetailerAccountRequestStatusEnum[keyof typeof UpdateRetailerAccountRequestStatusEnum];
export const UpdateRetailerAccountRequestBalanceLevelEnum = {
    _500: '500',
    _2000: '2000',
    _2500: '2500',
    _5000: '5000',
    _7500: '7500',
    _10000: '10000',
    _15000: '15000',
    _20000: '20000',
    _25000: '25000',
    _100000: '100000'
} as const;

export type UpdateRetailerAccountRequestBalanceLevelEnum = typeof UpdateRetailerAccountRequestBalanceLevelEnum[keyof typeof UpdateRetailerAccountRequestBalanceLevelEnum];
export const UpdateRetailerAccountRequestValuesEnum = {
    FemaleFounded: 'FEMALE_FOUNDED',
    EthicalProduction: 'ETHICAL_PRODUCTION',
    CleanIngredients: 'CLEAN_INGREDIENTS',
    Sustainable: 'SUSTAINABLE',
    Handmade: 'HANDMADE',
    MadeInTheUs: 'MADE_IN_THE_US',
    CharitableBrandGiveBack: 'CHARITABLE_BRAND_GIVE_BACK',
    Organic: 'ORGANIC',
    ZeroWaste: 'ZERO_WASTE',
    BlackOwned: 'BLACK_OWNED',
    LatinxOwned: 'LATINX_OWNED',
    AapiOwned: 'AAPI_OWNED',
    IndigenousOwned: 'INDIGENOUS_OWNED',
    LgbtqOwned: 'LGBTQ_OWNED',
    MinorityOwnedBusiness: 'MINORITY_OWNED_BUSINESS',
    DisabilityOwned: 'DISABILITY_OWNED'
} as const;

export type UpdateRetailerAccountRequestValuesEnum = typeof UpdateRetailerAccountRequestValuesEnum[keyof typeof UpdateRetailerAccountRequestValuesEnum];
export const UpdateRetailerAccountRequestStoreTypesEnum = {
    BrickAndMortar: 'BRICK_AND_MORTAR',
    Online: 'ONLINE',
    PopUp: 'POP_UP'
} as const;

export type UpdateRetailerAccountRequestStoreTypesEnum = typeof UpdateRetailerAccountRequestStoreTypesEnum[keyof typeof UpdateRetailerAccountRequestStoreTypesEnum];
export const UpdateRetailerAccountRequestScoreEnum = {
    NoScore: 'NO_SCORE',
    Good: 'GOOD',
    Better: 'BETTER',
    Best: 'BEST'
} as const;

export type UpdateRetailerAccountRequestScoreEnum = typeof UpdateRetailerAccountRequestScoreEnum[keyof typeof UpdateRetailerAccountRequestScoreEnum];

/**
 * 
 * @export
 * @interface UpdateRetailerStatusRequest
 */
export interface UpdateRetailerStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateRetailerStatusRequest
     */
    'status': UpdateRetailerStatusRequestStatusEnum;
}

export const UpdateRetailerStatusRequestStatusEnum = {
    Pending: 'PENDING',
    Active: 'ACTIVE',
    Suspended: 'SUSPENDED',
    Banned: 'BANNED'
} as const;

export type UpdateRetailerStatusRequestStatusEnum = typeof UpdateRetailerStatusRequestStatusEnum[keyof typeof UpdateRetailerStatusRequestStatusEnum];

/**
 * Charge date request body
 * @export
 * @interface UpdateSuborderChargeDateRequest
 */
export interface UpdateSuborderChargeDateRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateSuborderChargeDateRequest
     */
    'charge_date': string;
}
/**
 * Attach card request
 * @export
 * @interface UpdateSuborderCreditCardRequest
 */
export interface UpdateSuborderCreditCardRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateSuborderCreditCardRequest
     */
    'token_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSuborderCreditCardRequest
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSuborderCreditCardRequest
     */
    'last_name': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSuborderCreditCardRequest
     */
    'make_default': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSuborderCreditCardRequest
     */
    'save_card': boolean;
}
/**
 * 
 * @export
 * @interface UpdateSuborderItemRequest
 */
export interface UpdateSuborderItemRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateSuborderItemRequest
     */
    'suborder_item_id': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateSuborderItemRequest
     */
    'fulfilled_quantity': number;
}
/**
 * Update suborder object
 * @export
 * @interface UpdateSuborderRequest
 */
export interface UpdateSuborderRequest {
    /**
     * 
     * @type {Array<UpdateSuborderItemRequest>}
     * @memberof UpdateSuborderRequest
     */
    'items'?: Array<UpdateSuborderItemRequest>;
}
/**
 * 
 * @export
 * @interface UpdateSuborderResponse
 */
export interface UpdateSuborderResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateSuborderResponse
     */
    'message'?: string;
}
/**
 * Update order status by suborder Id and brand Id
 * @export
 * @interface UpdateSuborderStatusRequest
 */
export interface UpdateSuborderStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateSuborderStatusRequest
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSuborderStatusRequest
     */
    'brand_id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSuborderStatusRequest
     */
    'suborder_status': UpdateSuborderStatusRequestSuborderStatusEnum;
}

export const UpdateSuborderStatusRequestSuborderStatusEnum = {
    Hold: 'HOLD',
    Void: 'VOID',
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Declined: 'DECLINED',
    Expired: 'EXPIRED',
    PartiallyFulfilled: 'PARTIALLY_FULFILLED',
    FulfillmentInProgress: 'FULFILLMENT_IN_PROGRESS',
    Shipped: 'SHIPPED',
    Paid: 'PAID',
    Failed: 'FAILED',
    NotCollectable: 'NOT_COLLECTABLE',
    Cancelled: 'CANCELLED'
} as const;

export type UpdateSuborderStatusRequestSuborderStatusEnum = typeof UpdateSuborderStatusRequestSuborderStatusEnum[keyof typeof UpdateSuborderStatusRequestSuborderStatusEnum];

/**
 * 
 * @export
 * @interface UpdateTradeShowLinksRequest
 */
export interface UpdateTradeShowLinksRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateTradeShowLinksRequest
     */
    'booth_map_url'?: string;
}
/**
 * Update TradeShow object
 * @export
 * @interface UpdateTradeShowRequest
 */
export interface UpdateTradeShowRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateTradeShowRequest
     */
    'trade_show_brand_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTradeShowRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTradeShowRequest
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTradeShowRequest
     */
    'start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTradeShowRequest
     */
    'end_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTradeShowRequest
     */
    'commission_start'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTradeShowRequest
     */
    'commission_end'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTradeShowRequest
     */
    'zero_commission_start'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTradeShowRequest
     */
    'zero_commission_end'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTradeShowRequest
     */
    'registration_url'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTradeShowRequest
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateTradeShowRequest
     */
    'external_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTradeShowRequest
     */
    'booth_map_url'?: string;
    /**
     * 
     * @type {Array<TradeShowFeatureRequest>}
     * @memberof UpdateTradeShowRequest
     */
    'features'?: Array<TradeShowFeatureRequest>;
    /**
     * 
     * @type {string}
     * @memberof UpdateTradeShowRequest
     */
    'marketplace_visibility_override'?: UpdateTradeShowRequestMarketplaceVisibilityOverrideEnum;
}

export const UpdateTradeShowRequestMarketplaceVisibilityOverrideEnum = {
    None: 'NONE',
    Forced: 'FORCED',
    BrandOverride: 'BRAND_OVERRIDE'
} as const;

export type UpdateTradeShowRequestMarketplaceVisibilityOverrideEnum = typeof UpdateTradeShowRequestMarketplaceVisibilityOverrideEnum[keyof typeof UpdateTradeShowRequestMarketplaceVisibilityOverrideEnum];

/**
 * 
 * @export
 * @interface UpdateUserEmailVerifiedRequest
 */
export interface UpdateUserEmailVerifiedRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserEmailVerifiedRequest
     */
    'email_verified'?: boolean;
}
/**
 * Update user phone number
 * @export
 * @interface UpdateUserPhoneNumberRequest
 */
export interface UpdateUserPhoneNumberRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserPhoneNumberRequest
     */
    'phone_number': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserPhoneNumberRequest
     */
    'send_invite_sms': boolean;
}
/**
 * Update user object
 * @export
 * @interface UpdateUserProfileRequest
 */
export interface UpdateUserProfileRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserProfileRequest
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserProfileRequest
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserProfileRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserProfileRequest
     */
    'phone_number': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserProfileRequest
     */
    'image_url': string;
}
/**
 * 
 * @export
 * @interface UpdateVideoRequest
 */
export interface UpdateVideoRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateVideoRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVideoRequest
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVideoRequest
     */
    'entity_id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVideoRequest
     */
    'entity_type': UpdateVideoRequestEntityTypeEnum;
}

export const UpdateVideoRequestEntityTypeEnum = {
    Product: 'PRODUCT'
} as const;

export type UpdateVideoRequestEntityTypeEnum = typeof UpdateVideoRequestEntityTypeEnum[keyof typeof UpdateVideoRequestEntityTypeEnum];

/**
 * 
 * @export
 * @interface UpdateViewComponentRequest
 */
export interface UpdateViewComponentRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateViewComponentRequest
     */
    'entity_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateViewComponentRequest
     */
    'ordinal': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateViewComponentRequest
     */
    'component_type'?: UpdateViewComponentRequestComponentTypeEnum;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof UpdateViewComponentRequest
     */
    'attributes'?: { [key: string]: string; };
}

export const UpdateViewComponentRequestComponentTypeEnum = {
    FeaturedLinksRetailer: 'FEATURED_LINKS_RETAILER',
    NavigationV2: 'NAVIGATION_V2',
    NavigationV2Subcategory: 'NAVIGATION_V2_SUBCATEGORY',
    Category: 'CATEGORY',
    Collection: 'COLLECTION',
    Brand: 'BRAND',
    Hero: 'HERO',
    PromoBanner: 'PROMO_BANNER',
    About: 'ABOUT'
} as const;

export type UpdateViewComponentRequestComponentTypeEnum = typeof UpdateViewComponentRequestComponentTypeEnum[keyof typeof UpdateViewComponentRequestComponentTypeEnum];

/**
 * 
 * @export
 * @interface UpdateViewComponentsRequest
 */
export interface UpdateViewComponentsRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateViewComponentsRequest
     */
    'view_component_id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateViewComponentsRequest
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateViewComponentsRequest
     */
    'rename_entity'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateViewComponentsRequest
     */
    'image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateViewComponentsRequest
     */
    'entity_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateViewComponentsRequest
     */
    'component_type'?: UpdateViewComponentsRequestComponentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateViewComponentsRequest
     */
    'view_container_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateViewComponentsRequest
     */
    'ordinal'?: number;
}

export const UpdateViewComponentsRequestComponentTypeEnum = {
    FeaturedLinksRetailer: 'FEATURED_LINKS_RETAILER',
    NavigationV2: 'NAVIGATION_V2',
    NavigationV2Subcategory: 'NAVIGATION_V2_SUBCATEGORY',
    Category: 'CATEGORY',
    Collection: 'COLLECTION',
    Brand: 'BRAND',
    Hero: 'HERO',
    PromoBanner: 'PROMO_BANNER',
    About: 'ABOUT'
} as const;

export type UpdateViewComponentsRequestComponentTypeEnum = typeof UpdateViewComponentsRequestComponentTypeEnum[keyof typeof UpdateViewComponentsRequestComponentTypeEnum];

/**
 * 
 * @export
 * @interface UpdateViewContainerElementsRequest
 */
export interface UpdateViewContainerElementsRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateViewContainerElementsRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateViewContainerElementsRequest
     */
    'parent_container_id'?: string;
    /**
     * 
     * @type {Array<ChildrenContainerResponse>}
     * @memberof UpdateViewContainerElementsRequest
     */
    'children_containers'?: Array<ChildrenContainerResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateViewContainerElementsRequest
     */
    'active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateViewContainerElementsRequest
     */
    'ordinal'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateViewContainerElementsRequest
     */
    'container_direction'?: UpdateViewContainerElementsRequestContainerDirectionEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateViewContainerElementsRequest
     */
    'container_type'?: UpdateViewContainerElementsRequestContainerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateViewContainerElementsRequest
     */
    'name'?: string;
}

export const UpdateViewContainerElementsRequestContainerDirectionEnum = {
    Row: 'ROW',
    Column: 'COLUMN',
    Grid: 'GRID'
} as const;

export type UpdateViewContainerElementsRequestContainerDirectionEnum = typeof UpdateViewContainerElementsRequestContainerDirectionEnum[keyof typeof UpdateViewContainerElementsRequestContainerDirectionEnum];
export const UpdateViewContainerElementsRequestContainerTypeEnum = {
    Navigation: 'NAVIGATION',
    NavigationV2: 'NAVIGATION_V2',
    NavigationV2Retailer: 'NAVIGATION_V2_RETAILER',
    NavigationV2Collection: 'NAVIGATION_V2_COLLECTION',
    NavigationV2Categories: 'NAVIGATION_V2_CATEGORIES',
    NavigationV2Subcategory: 'NAVIGATION_V2_SUBCATEGORY',
    Landing: 'LANDING',
    FeaturedCollections: 'FEATURED_COLLECTIONS',
    FeaturedBrands: 'FEATURED_BRANDS',
    FeaturedLinksRetailer: 'FEATURED_LINKS_RETAILER',
    ProductCategories: 'PRODUCT_CATEGORIES',
    TrendingBrands: 'TRENDING_BRANDS',
    Hero: 'HERO',
    About: 'ABOUT',
    PromoBanner: 'PROMO_BANNER',
    PerfectForThe: 'PERFECT_FOR_THE',
    NyNow: 'NY_NOW',
    ExploreNewTrending: 'EXPLORE_NEW_TRENDING',
    TradeShow: 'TRADE_SHOW'
} as const;

export type UpdateViewContainerElementsRequestContainerTypeEnum = typeof UpdateViewContainerElementsRequestContainerTypeEnum[keyof typeof UpdateViewContainerElementsRequestContainerTypeEnum];

/**
 * Update container
 * @export
 * @interface UpdateViewContainerRequest
 */
export interface UpdateViewContainerRequest {
    /**
     * 
     * @type {Array<UpdateViewComponentRequest>}
     * @memberof UpdateViewContainerRequest
     */
    'view_components'?: Array<UpdateViewComponentRequest>;
    /**
     * 
     * @type {string}
     * @memberof UpdateViewContainerRequest
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface UploadCollectionImageRequest
 */
export interface UploadCollectionImageRequest {
    /**
     * Image to upload
     * @type {File}
     * @memberof UploadCollectionImageRequest
     */
    'image': File;
}
/**
 * 
 * @export
 * @interface UploadComponentImageRequest
 */
export interface UploadComponentImageRequest {
    /**
     * Image for upload
     * @type {File}
     * @memberof UploadComponentImageRequest
     */
    'image': File;
}
/**
 * 
 * @export
 * @interface UploadFileRequest
 */
export interface UploadFileRequest {
    /**
     * File
     * @type {File}
     * @memberof UploadFileRequest
     */
    'file': File;
}
/**
 * 
 * @export
 * @interface UploadFileResponse
 */
export interface UploadFileResponse {
    /**
     * 
     * @type {string}
     * @memberof UploadFileResponse
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface UploadImageRequest
 */
export interface UploadImageRequest {
    /**
     * Crop Image
     * @type {File}
     * @memberof UploadImageRequest
     */
    'crop_image': File;
    /**
     * Original Image
     * @type {File}
     * @memberof UploadImageRequest
     */
    'original_image': File;
    /**
     * Crop data
     * @type {object}
     * @memberof UploadImageRequest
     */
    'crop_params': object;
}
/**
 * 
 * @export
 * @interface UploadImageResponse
 */
export interface UploadImageResponse {
    /**
     * 
     * @type {string}
     * @memberof UploadImageResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadImageResponse
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadImageResponse
     */
    'cdn_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadImageResponse
     */
    'original_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadImageResponse
     */
    'type'?: UploadImageResponseTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UploadImageResponse
     */
    'is_custom_assortment_image'?: boolean;
}

export const UploadImageResponseTypeEnum = {
    Product: 'PRODUCT',
    Location: 'LOCATION'
} as const;

export type UploadImageResponseTypeEnum = typeof UploadImageResponseTypeEnum[keyof typeof UploadImageResponseTypeEnum];

/**
 * 
 * @export
 * @interface UploadProductBuildingLineSheetResponse
 */
export interface UploadProductBuildingLineSheetResponse {
    /**
     * 
     * @type {string}
     * @memberof UploadProductBuildingLineSheetResponse
     */
    'product_building_line_sheet_url'?: string;
}
/**
 * 
 * @export
 * @interface UploadProductImageRequest
 */
export interface UploadProductImageRequest {
    /**
     * Image
     * @type {File}
     * @memberof UploadProductImageRequest
     */
    'image': File;
    /**
     * Original Image
     * @type {File}
     * @memberof UploadProductImageRequest
     */
    'original_image': File;
    /**
     * Crop data
     * @type {object}
     * @memberof UploadProductImageRequest
     */
    'crop_params': object;
}
/**
 * 
 * @export
 * @interface UploadRetailerThumbnailImageRequest
 */
export interface UploadRetailerThumbnailImageRequest {
    /**
     * Retailer thumbnail image
     * @type {File}
     * @memberof UploadRetailerThumbnailImageRequest
     */
    'file': File;
}
/**
 * 
 * @export
 * @interface UploadVideoUrlResponse
 */
export interface UploadVideoUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof UploadVideoUrlResponse
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadVideoUrlResponse
     */
    'upload_id'?: string;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'passwordHash': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'role': UserRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     * @deprecated
     */
    'profilePictureUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'emailVerificationCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'emailVerificationCodeTimestamp'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'emailVerified': boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'resetPasswordCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'resetPasswordCodeTimestamp'?: string;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'numberOfLogins'?: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'firstLoginDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'lastLoginDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'banned'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'instagramToken'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof User
     */
    'emailVerificationRequests'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof User
     */
    'capabilities'?: { [key: string]: boolean; };
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'shopifyUpdateSetting': boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'emeraldMarketingOptInStatus': UserEmeraldMarketingOptInStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'bulletinMarketingOptInStatus': UserBulletinMarketingOptInStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'sub'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'password'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {Array<GrantedAuthority>}
     * @memberof User
     */
    'authorities'?: Array<GrantedAuthority>;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'invited'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'credentialsNonExpired'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'accountNonLocked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'accountNonExpired'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'new'?: boolean;
}

export const UserRoleEnum = {
    Brand: 'BRAND',
    Retailer: 'RETAILER',
    Admin: 'ADMIN',
    ProductBuilder: 'PRODUCT_BUILDER'
} as const;

export type UserRoleEnum = typeof UserRoleEnum[keyof typeof UserRoleEnum];
export const UserEmeraldMarketingOptInStatusEnum = {
    NotAsked: 'NOT_ASKED',
    OptedIn: 'OPTED_IN',
    OptedOut: 'OPTED_OUT'
} as const;

export type UserEmeraldMarketingOptInStatusEnum = typeof UserEmeraldMarketingOptInStatusEnum[keyof typeof UserEmeraldMarketingOptInStatusEnum];
export const UserBulletinMarketingOptInStatusEnum = {
    NotAsked: 'NOT_ASKED',
    OptedIn: 'OPTED_IN',
    OptedOut: 'OPTED_OUT'
} as const;

export type UserBulletinMarketingOptInStatusEnum = typeof UserBulletinMarketingOptInStatusEnum[keyof typeof UserBulletinMarketingOptInStatusEnum];

/**
 * 
 * @export
 * @interface UserAccessLevelResponse
 */
export interface UserAccessLevelResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UserAccessLevelResponse
     */
    'bulletin_plus_access_level'?: boolean;
}
/**
 * 
 * @export
 * @interface UserEmailVerificationResponse
 */
export interface UserEmailVerificationResponse {
    /**
     * 
     * @type {string}
     * @memberof UserEmailVerificationResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEmailVerificationResponse
     */
    'last_login_date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserEmailVerificationResponse
     */
    'email_verified'?: boolean;
}
/**
 * 
 * @export
 * @interface UserGeneratePasswordResetCodeResponse
 */
export interface UserGeneratePasswordResetCodeResponse {
    /**
     * 
     * @type {string}
     * @memberof UserGeneratePasswordResetCodeResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGeneratePasswordResetCodeResponse
     */
    'reset_password_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGeneratePasswordResetCodeResponse
     */
    'reset_password_code_timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGeneratePasswordResetCodeResponse
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface UserMessagingAbilityResponse
 */
export interface UserMessagingAbilityResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UserMessagingAbilityResponse
     */
    'can_send_message'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserMessagingAbilityResponse
     */
    'error_message'?: string;
}
/**
 * 
 * @export
 * @interface UserProfileResponse
 */
export interface UserProfileResponse {
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'role'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'phone_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'image_url'?: string;
}
/**
 * 
 * @export
 * @interface UtmParams
 */
export interface UtmParams {
    /**
     * 
     * @type {string}
     * @memberof UtmParams
     */
    'utm_source'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtmParams
     */
    'utm_medium'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtmParams
     */
    'utm_campaign'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtmParams
     */
    'utm_content'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtmParams
     */
    'utm_term'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtmParams
     */
    'gclid'?: string;
}
/**
 * 
 * @export
 * @interface ValidateEmailRequest
 */
export interface ValidateEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidateEmailRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface ValidateEmailResponse
 */
export interface ValidateEmailResponse {
    /**
     * 
     * @type {Validation}
     * @memberof ValidateEmailResponse
     */
    'validation': Validation;
}
/**
 * 
 * @export
 * @interface ValidateResetPasswordTokenByBrandResponse
 */
export interface ValidateResetPasswordTokenByBrandResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ValidateResetPasswordTokenByBrandResponse
     */
    'valid'?: boolean;
}
/**
 * 
 * @export
 * @interface ValidateSKURequest
 */
export interface ValidateSKURequest {
    /**
     * 
     * @type {string}
     * @memberof ValidateSKURequest
     */
    'sku': string;
    /**
     * 
     * @type {string}
     * @memberof ValidateSKURequest
     */
    'brand_id'?: string;
}
/**
 * 
 * @export
 * @interface ValidateSKUResponse
 */
export interface ValidateSKUResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ValidateSKUResponse
     */
    'valid'?: boolean;
}
/**
 * 
 * @export
 * @interface Validation
 */
export interface Validation {
    /**
     * 
     * @type {Checks}
     * @memberof Validation
     */
    'checks': Checks;
}
/**
 * 
 * @export
 * @interface VariantRequest
 */
export interface VariantRequest {
    /**
     * 
     * @type {string}
     * @memberof VariantRequest
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof VariantRequest
     */
    'pos_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof VariantRequest
     */
    'wholesale_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof VariantRequest
     */
    'cost_per_item'?: number;
    /**
     * 
     * @type {number}
     * @memberof VariantRequest
     */
    'compare_at_price'?: number;
    /**
     * 
     * @type {string}
     * @memberof VariantRequest
     */
    'tester_variant_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof VariantRequest
     */
    'tester_minimum_quantity'?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof VariantRequest
     */
    'characteristic_option'?: { [key: string]: string; };
    /**
     * 
     * @type {number}
     * @memberof VariantRequest
     */
    'ordinal'?: number;
    /**
     * 
     * @type {string}
     * @memberof VariantRequest
     */
    'sku'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VariantRequest
     */
    'in_stock'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VariantRequest
     */
    'inventory_quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof VariantRequest
     */
    'weight'?: number;
}
/**
 * 
 * @export
 * @interface VariantShopifyDTO
 */
export interface VariantShopifyDTO {
    /**
     * 
     * @type {ProductVariant}
     * @memberof VariantShopifyDTO
     */
    'productVariant'?: ProductVariant;
    /**
     * 
     * @type {number}
     * @memberof VariantShopifyDTO
     */
    'product_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof VariantShopifyDTO
     */
    'image_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof VariantShopifyDTO
     */
    'pos_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof VariantShopifyDTO
     */
    'wholesale_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof VariantShopifyDTO
     */
    'compare_at_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof VariantShopifyDTO
     */
    'cost_per_item'?: number;
    /**
     * 
     * @type {number}
     * @memberof VariantShopifyDTO
     */
    'ordinal'?: number;
    /**
     * 
     * @type {ImageShopifyDTO}
     * @memberof VariantShopifyDTO
     */
    'image'?: ImageShopifyDTO;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof VariantShopifyDTO
     */
    'characteristic_option_map'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface VariantWithoutSkuResponse
 */
export interface VariantWithoutSkuResponse {
    /**
     * 
     * @type {string}
     * @memberof VariantWithoutSkuResponse
     */
    'variant_id'?: string;
}
/**
 * 
 * @export
 * @interface Vendor
 */
export interface Vendor {
    /**
     * 
     * @type {string}
     * @memberof Vendor
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Vendor
     */
    'businessName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Vendor
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Vendor
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof Vendor
     */
    'referenceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Vendor
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface VendorCreateResponse
 */
export interface VendorCreateResponse {
    /**
     * 
     * @type {Vendor}
     * @memberof VendorCreateResponse
     */
    'vendor'?: Vendor;
}
/**
 * Email verification code
 * @export
 * @interface VerifyEmailRequest
 */
export interface VerifyEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifyEmailRequest
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface ViewComponentResponse
 */
export interface ViewComponentResponse {
    /**
     * 
     * @type {string}
     * @memberof ViewComponentResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewComponentResponse
     */
    'view_container_id'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ViewComponentResponse
     */
    'info'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof ViewComponentResponse
     */
    'entity_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ViewComponentResponse
     */
    'ordinal'?: number;
    /**
     * 
     * @type {string}
     * @memberof ViewComponentResponse
     */
    'component_type'?: ViewComponentResponseComponentTypeEnum;
}

export const ViewComponentResponseComponentTypeEnum = {
    FeaturedLinksRetailer: 'FEATURED_LINKS_RETAILER',
    NavigationV2: 'NAVIGATION_V2',
    NavigationV2Subcategory: 'NAVIGATION_V2_SUBCATEGORY',
    Category: 'CATEGORY',
    Collection: 'COLLECTION',
    Brand: 'BRAND',
    Hero: 'HERO',
    PromoBanner: 'PROMO_BANNER',
    About: 'ABOUT'
} as const;

export type ViewComponentResponseComponentTypeEnum = typeof ViewComponentResponseComponentTypeEnum[keyof typeof ViewComponentResponseComponentTypeEnum];

/**
 * 
 * @export
 * @interface ViewContainerResponse
 */
export interface ViewContainerResponse {
    /**
     * 
     * @type {string}
     * @memberof ViewContainerResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewContainerResponse
     */
    'parent_container_id'?: string;
    /**
     * 
     * @type {Array<ViewContainerResponse>}
     * @memberof ViewContainerResponse
     */
    'children_containers'?: Array<ViewContainerResponse>;
    /**
     * 
     * @type {Array<ViewComponentResponse>}
     * @memberof ViewContainerResponse
     */
    'view_components'?: Array<ViewComponentResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof ViewContainerResponse
     */
    'active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ViewContainerResponse
     */
    'ordinal'?: number;
    /**
     * 
     * @type {string}
     * @memberof ViewContainerResponse
     */
    'container_direction'?: ViewContainerResponseContainerDirectionEnum;
    /**
     * 
     * @type {string}
     * @memberof ViewContainerResponse
     */
    'container_type'?: ViewContainerResponseContainerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ViewContainerResponse
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ViewContainerResponse
     */
    'toggled'?: boolean;
}

export const ViewContainerResponseContainerDirectionEnum = {
    Row: 'ROW',
    Column: 'COLUMN',
    Grid: 'GRID'
} as const;

export type ViewContainerResponseContainerDirectionEnum = typeof ViewContainerResponseContainerDirectionEnum[keyof typeof ViewContainerResponseContainerDirectionEnum];
export const ViewContainerResponseContainerTypeEnum = {
    Navigation: 'NAVIGATION',
    NavigationV2: 'NAVIGATION_V2',
    NavigationV2Retailer: 'NAVIGATION_V2_RETAILER',
    NavigationV2Collection: 'NAVIGATION_V2_COLLECTION',
    NavigationV2Categories: 'NAVIGATION_V2_CATEGORIES',
    NavigationV2Subcategory: 'NAVIGATION_V2_SUBCATEGORY',
    Landing: 'LANDING',
    FeaturedCollections: 'FEATURED_COLLECTIONS',
    FeaturedBrands: 'FEATURED_BRANDS',
    FeaturedLinksRetailer: 'FEATURED_LINKS_RETAILER',
    ProductCategories: 'PRODUCT_CATEGORIES',
    TrendingBrands: 'TRENDING_BRANDS',
    Hero: 'HERO',
    About: 'ABOUT',
    PromoBanner: 'PROMO_BANNER',
    PerfectForThe: 'PERFECT_FOR_THE',
    NyNow: 'NY_NOW',
    ExploreNewTrending: 'EXPLORE_NEW_TRENDING',
    TradeShow: 'TRADE_SHOW'
} as const;

export type ViewContainerResponseContainerTypeEnum = typeof ViewContainerResponseContainerTypeEnum[keyof typeof ViewContainerResponseContainerTypeEnum];

/**
 * 
 * @export
 * @interface Webhook
 */
export interface Webhook {
    /**
     * 
     * @type {number}
     * @memberof Webhook
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Webhook
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof Webhook
     */
    'topic'?: string;
    /**
     * 
     * @type {string}
     * @memberof Webhook
     */
    'api_version'?: string;
    /**
     * 
     * @type {string}
     * @memberof Webhook
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Webhook
     */
    'updated_at'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Webhook
     */
    'fields'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Webhook
     */
    'metafield_namespaces'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Webhook
     */
    'private_metafield_namespaces'?: Array<string>;
}
/**
 * 
 * @export
 * @interface WebhookList
 */
export interface WebhookList {
    /**
     * 
     * @type {Array<Webhook>}
     * @memberof WebhookList
     */
    'webhooks'?: Array<Webhook>;
}

/**
 * AddressControllerApi - axios parameter creator
 * @export
 */
export const AddressControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete retailer\'s address
         * @param {string} id Address id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('_delete', 'id', id)
            const localVarPath = `/addresses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add retailer\'s new address
         * @param {CreateAddressRequest} createAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRetailerAddress: async (createAddressRequest: CreateAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAddressRequest' is not null or undefined
            assertParamExists('addRetailerAddress', 'createAddressRequest', createAddressRequest)
            const localVarPath = `/addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all addresses for retailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get address by id
         * @param {string} id Address id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOne: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOne', 'id', id)
            const localVarPath = `/addresses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set default shipping or billing address
         * @param {string} id Address id
         * @param {DefaultAddressRequest} defaultAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefault: async (id: string, defaultAddressRequest: DefaultAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setDefault', 'id', id)
            // verify required parameter 'defaultAddressRequest' is not null or undefined
            assertParamExists('setDefault', 'defaultAddressRequest', defaultAddressRequest)
            const localVarPath = `/addresses/{id}/default`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(defaultAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update retailer\'s address
         * @param {string} id Address id
         * @param {UpdateAddressRequest} updateAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateAddressRequest: UpdateAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateAddressRequest' is not null or undefined
            assertParamExists('update', 'updateAddressRequest', updateAddressRequest)
            const localVarPath = `/addresses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddressControllerApi - functional programming interface
 * @export
 */
export const AddressControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AddressControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete retailer\'s address
         * @param {string} id Address id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddressControllerApi._delete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add retailer\'s new address
         * @param {CreateAddressRequest} createAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addRetailerAddress(createAddressRequest: CreateAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addRetailerAddress(createAddressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddressControllerApi.addRetailerAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all addresses for retailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AddressResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddressControllerApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get address by id
         * @param {string} id Address id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOne(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddressControllerApi.getOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set default shipping or billing address
         * @param {string} id Address id
         * @param {DefaultAddressRequest} defaultAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDefault(id: string, defaultAddressRequest: DefaultAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDefault(id, defaultAddressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddressControllerApi.setDefault']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update retailer\'s address
         * @param {string} id Address id
         * @param {UpdateAddressRequest} updateAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateAddressRequest: UpdateAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateAddressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddressControllerApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AddressControllerApi - factory interface
 * @export
 */
export const AddressControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AddressControllerApiFp(configuration)
    return {
        /**
         * Delete retailer\'s address
         * @param {string} id Address id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp._delete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Add retailer\'s new address
         * @param {CreateAddressRequest} createAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRetailerAddress(createAddressRequest: CreateAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper> {
            return localVarFp.addRetailerAddress(createAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all addresses for retailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<AddressResponse>> {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         * Get address by id
         * @param {string} id Address id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOne(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AddressResponse> {
            return localVarFp.getOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Set default shipping or billing address
         * @param {string} id Address id
         * @param {DefaultAddressRequest} defaultAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefault(id: string, defaultAddressRequest: DefaultAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setDefault(id, defaultAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update retailer\'s address
         * @param {string} id Address id
         * @param {UpdateAddressRequest} updateAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateAddressRequest: UpdateAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.update(id, updateAddressRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AddressControllerApi - interface
 * @export
 * @interface AddressControllerApi
 */
export interface AddressControllerApiInterface {
    /**
     * Delete retailer\'s address
     * @param {string} id Address id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressControllerApiInterface
     */
    _delete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Add retailer\'s new address
     * @param {CreateAddressRequest} createAddressRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressControllerApiInterface
     */
    addRetailerAddress(createAddressRequest: CreateAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper>;

    /**
     * Get all addresses for retailer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressControllerApiInterface
     */
    getAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<AddressResponse>>;

    /**
     * Get address by id
     * @param {string} id Address id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressControllerApiInterface
     */
    getOne(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AddressResponse>;

    /**
     * Set default shipping or billing address
     * @param {string} id Address id
     * @param {DefaultAddressRequest} defaultAddressRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressControllerApiInterface
     */
    setDefault(id: string, defaultAddressRequest: DefaultAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update retailer\'s address
     * @param {string} id Address id
     * @param {UpdateAddressRequest} updateAddressRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressControllerApiInterface
     */
    update(id: string, updateAddressRequest: UpdateAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * AddressControllerApi - object-oriented interface
 * @export
 * @class AddressControllerApi
 * @extends {BaseAPI}
 */
export class AddressControllerApi extends BaseAPI implements AddressControllerApiInterface {
    /**
     * Delete retailer\'s address
     * @param {string} id Address id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressControllerApi
     */
    public _delete(id: string, options?: RawAxiosRequestConfig) {
        return AddressControllerApiFp(this.configuration)._delete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add retailer\'s new address
     * @param {CreateAddressRequest} createAddressRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressControllerApi
     */
    public addRetailerAddress(createAddressRequest: CreateAddressRequest, options?: RawAxiosRequestConfig) {
        return AddressControllerApiFp(this.configuration).addRetailerAddress(createAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all addresses for retailer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressControllerApi
     */
    public getAll(options?: RawAxiosRequestConfig) {
        return AddressControllerApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get address by id
     * @param {string} id Address id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressControllerApi
     */
    public getOne(id: string, options?: RawAxiosRequestConfig) {
        return AddressControllerApiFp(this.configuration).getOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set default shipping or billing address
     * @param {string} id Address id
     * @param {DefaultAddressRequest} defaultAddressRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressControllerApi
     */
    public setDefault(id: string, defaultAddressRequest: DefaultAddressRequest, options?: RawAxiosRequestConfig) {
        return AddressControllerApiFp(this.configuration).setDefault(id, defaultAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update retailer\'s address
     * @param {string} id Address id
     * @param {UpdateAddressRequest} updateAddressRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressControllerApi
     */
    public update(id: string, updateAddressRequest: UpdateAddressRequest, options?: RawAxiosRequestConfig) {
        return AddressControllerApiFp(this.configuration).update(id, updateAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AlgoliaControllerApi - axios parameter creator
 * @export
 */
export const AlgoliaControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSourceToBrandsIndex: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/algolia/index/brands/update-source`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteAlgoliaProductsRequest} deleteAlgoliaProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlgoliaProducts: async (deleteAlgoliaProductsRequest: DeleteAlgoliaProductsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteAlgoliaProductsRequest' is not null or undefined
            assertParamExists('deleteAlgoliaProducts', 'deleteAlgoliaProductsRequest', deleteAlgoliaProductsRequest)
            const localVarPath = `/algolia/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteAlgoliaProductsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteAlgoliaRetailersRequest} deleteAlgoliaRetailersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlgoliaRetailers: async (deleteAlgoliaRetailersRequest: DeleteAlgoliaRetailersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteAlgoliaRetailersRequest' is not null or undefined
            assertParamExists('deleteAlgoliaRetailers', 'deleteAlgoliaRetailersRequest', deleteAlgoliaRetailersRequest)
            const localVarPath = `/algolia/retailers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteAlgoliaRetailersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsWithoutBulletinPick: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/algolia/products/without-bulletin-pick`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexBrands: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/algolia/index/brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexCategories: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/algolia/index/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexCollections: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/algolia/index/collections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexAlgoliaCategoryViewContainers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/algolia/reindex/category-view-containers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Triggers reindexing of all brands in Algolia in batches.
         * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexAllBrands: async (updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAlgoliaProductsInBatchesRequest' is not null or undefined
            assertParamExists('reindexAllBrands', 'updateAlgoliaProductsInBatchesRequest', updateAlgoliaProductsInBatchesRequest)
            const localVarPath = `/algolia/reindex/brands/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAlgoliaProductsInBatchesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Triggers reindexing of all products in Algolia in batches.
         * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexAllProducts: async (updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAlgoliaProductsInBatchesRequest' is not null or undefined
            assertParamExists('reindexAllProducts', 'updateAlgoliaProductsInBatchesRequest', updateAlgoliaProductsInBatchesRequest)
            const localVarPath = `/algolia/reindex/products/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAlgoliaProductsInBatchesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReindexSpecificBrandsRequest} reindexSpecificBrandsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexBrands: async (reindexSpecificBrandsRequest: ReindexSpecificBrandsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reindexSpecificBrandsRequest' is not null or undefined
            assertParamExists('reindexBrands', 'reindexSpecificBrandsRequest', reindexSpecificBrandsRequest)
            const localVarPath = `/algolia/reindex/brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reindexSpecificBrandsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Triggers reindexing of brands product-category in Algolia.
         * @param {ReindexBrandsProductCategoriesRequest} reindexBrandsProductCategoriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexBrandsProductCategories: async (reindexBrandsProductCategoriesRequest: ReindexBrandsProductCategoriesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reindexBrandsProductCategoriesRequest' is not null or undefined
            assertParamExists('reindexBrandsProductCategories', 'reindexBrandsProductCategoriesRequest', reindexBrandsProductCategoriesRequest)
            const localVarPath = `/algolia/reindex/brands/product-categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reindexBrandsProductCategoriesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexCustomAssortments: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/algolia/index/custom-assortments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexInvoices: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/algolia/index/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexOrderReturns: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/algolia/index/order-returns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexOrders: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/algolia/index/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexProductWholesaleMinimums: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/algolia/index/products-wholesale-minimums`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexProducts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/algolia/index/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexProductsActiveDealsAndPromos: async (updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAlgoliaProductsInBatchesRequest' is not null or undefined
            assertParamExists('reindexProductsActiveDealsAndPromos', 'updateAlgoliaProductsInBatchesRequest', updateAlgoliaProductsInBatchesRequest)
            const localVarPath = `/algolia/reindex/products-active-deals-and-promos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAlgoliaProductsInBatchesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexProductsDealsAndPromos: async (updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAlgoliaProductsInBatchesRequest' is not null or undefined
            assertParamExists('reindexProductsDealsAndPromos', 'updateAlgoliaProductsInBatchesRequest', updateAlgoliaProductsInBatchesRequest)
            const localVarPath = `/algolia/reindex/products-deals-and-promos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAlgoliaProductsInBatchesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexProductsSetToActive: async (updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAlgoliaProductsInBatchesRequest' is not null or undefined
            assertParamExists('reindexProductsSetToActive', 'updateAlgoliaProductsInBatchesRequest', updateAlgoliaProductsInBatchesRequest)
            const localVarPath = `/algolia/reindex/set-to-active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAlgoliaProductsInBatchesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexProductsTotalOrders: async (updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAlgoliaProductsInBatchesRequest' is not null or undefined
            assertParamExists('reindexProductsTotalOrders', 'updateAlgoliaProductsInBatchesRequest', updateAlgoliaProductsInBatchesRequest)
            const localVarPath = `/algolia/reindex/products-total-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAlgoliaProductsInBatchesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexRetailers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/algolia/index/retailers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Triggers reindexing of specific products in Algolia based on the provided request. Only accessible by ADMIN users. The `batchSize` field in the request is optional; if not provided, a default batch size will be used.
         * @summary Reindex specific products in Algolia
         * @param {ReindexProductsRequest} reindexProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexSpecificProducts: async (reindexProductsRequest: ReindexProductsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reindexProductsRequest' is not null or undefined
            assertParamExists('reindexSpecificProducts', 'reindexProductsRequest', reindexProductsRequest)
            const localVarPath = `/algolia/reindex/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reindexProductsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexSuborders: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/algolia/index/suborders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexTags: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/algolia/index/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AlgoliaControllerApi - functional programming interface
 * @export
 */
export const AlgoliaControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AlgoliaControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSourceToBrandsIndex(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSourceToBrandsIndex(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.addSourceToBrandsIndex']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteAlgoliaProductsRequest} deleteAlgoliaProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAlgoliaProducts(deleteAlgoliaProductsRequest: DeleteAlgoliaProductsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAlgoliaProducts(deleteAlgoliaProductsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.deleteAlgoliaProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteAlgoliaRetailersRequest} deleteAlgoliaRetailersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAlgoliaRetailers(deleteAlgoliaRetailersRequest: DeleteAlgoliaRetailersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAlgoliaRetailers(deleteAlgoliaRetailersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.deleteAlgoliaRetailers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductsWithoutBulletinPick(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductsWithoutBulletinPick(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.getProductsWithoutBulletinPick']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexBrands(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexBrands(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.indexBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexCategories(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexCategories(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.indexCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexCollections(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexCollections(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.indexCollections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindexAlgoliaCategoryViewContainers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindexAlgoliaCategoryViewContainers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.reindexAlgoliaCategoryViewContainers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Triggers reindexing of all brands in Algolia in batches.
         * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindexAllBrands(updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindexAllBrands(updateAlgoliaProductsInBatchesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.reindexAllBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Triggers reindexing of all products in Algolia in batches.
         * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindexAllProducts(updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindexAllProducts(updateAlgoliaProductsInBatchesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.reindexAllProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ReindexSpecificBrandsRequest} reindexSpecificBrandsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindexBrands(reindexSpecificBrandsRequest: ReindexSpecificBrandsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindexBrands(reindexSpecificBrandsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.reindexBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Triggers reindexing of brands product-category in Algolia.
         * @param {ReindexBrandsProductCategoriesRequest} reindexBrandsProductCategoriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindexBrandsProductCategories(reindexBrandsProductCategoriesRequest: ReindexBrandsProductCategoriesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindexBrandsProductCategories(reindexBrandsProductCategoriesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.reindexBrandsProductCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindexCustomAssortments(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindexCustomAssortments(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.reindexCustomAssortments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindexInvoices(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindexInvoices(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.reindexInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindexOrderReturns(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindexOrderReturns(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.reindexOrderReturns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindexOrders(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindexOrders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.reindexOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindexProductWholesaleMinimums(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindexProductWholesaleMinimums(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.reindexProductWholesaleMinimums']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindexProducts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindexProducts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.reindexProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindexProductsActiveDealsAndPromos(updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindexProductsActiveDealsAndPromos(updateAlgoliaProductsInBatchesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.reindexProductsActiveDealsAndPromos']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindexProductsDealsAndPromos(updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindexProductsDealsAndPromos(updateAlgoliaProductsInBatchesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.reindexProductsDealsAndPromos']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindexProductsSetToActive(updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindexProductsSetToActive(updateAlgoliaProductsInBatchesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.reindexProductsSetToActive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindexProductsTotalOrders(updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindexProductsTotalOrders(updateAlgoliaProductsInBatchesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.reindexProductsTotalOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindexRetailers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindexRetailers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.reindexRetailers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Triggers reindexing of specific products in Algolia based on the provided request. Only accessible by ADMIN users. The `batchSize` field in the request is optional; if not provided, a default batch size will be used.
         * @summary Reindex specific products in Algolia
         * @param {ReindexProductsRequest} reindexProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindexSpecificProducts(reindexProductsRequest: ReindexProductsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindexSpecificProducts(reindexProductsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.reindexSpecificProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindexSuborders(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindexSuborders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.reindexSuborders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindexTags(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindexTags(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaControllerApi.reindexTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AlgoliaControllerApi - factory interface
 * @export
 */
export const AlgoliaControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AlgoliaControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSourceToBrandsIndex(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.addSourceToBrandsIndex(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteAlgoliaProductsRequest} deleteAlgoliaProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlgoliaProducts(deleteAlgoliaProductsRequest: DeleteAlgoliaProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.deleteAlgoliaProducts(deleteAlgoliaProductsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteAlgoliaRetailersRequest} deleteAlgoliaRetailersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlgoliaRetailers(deleteAlgoliaRetailersRequest: DeleteAlgoliaRetailersRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.deleteAlgoliaRetailers(deleteAlgoliaRetailersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsWithoutBulletinPick(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getProductsWithoutBulletinPick(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexBrands(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.indexBrands(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexCategories(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.indexCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexCollections(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.indexCollections(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexAlgoliaCategoryViewContainers(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reindexAlgoliaCategoryViewContainers(options).then((request) => request(axios, basePath));
        },
        /**
         * Triggers reindexing of all brands in Algolia in batches.
         * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexAllBrands(updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reindexAllBrands(updateAlgoliaProductsInBatchesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Triggers reindexing of all products in Algolia in batches.
         * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexAllProducts(updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reindexAllProducts(updateAlgoliaProductsInBatchesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReindexSpecificBrandsRequest} reindexSpecificBrandsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexBrands(reindexSpecificBrandsRequest: ReindexSpecificBrandsRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.reindexBrands(reindexSpecificBrandsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Triggers reindexing of brands product-category in Algolia.
         * @param {ReindexBrandsProductCategoriesRequest} reindexBrandsProductCategoriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexBrandsProductCategories(reindexBrandsProductCategoriesRequest: ReindexBrandsProductCategoriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reindexBrandsProductCategories(reindexBrandsProductCategoriesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexCustomAssortments(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.reindexCustomAssortments(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexInvoices(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.reindexInvoices(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexOrderReturns(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.reindexOrderReturns(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexOrders(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.reindexOrders(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexProductWholesaleMinimums(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.reindexProductWholesaleMinimums(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexProducts(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.reindexProducts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexProductsActiveDealsAndPromos(updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reindexProductsActiveDealsAndPromos(updateAlgoliaProductsInBatchesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexProductsDealsAndPromos(updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reindexProductsDealsAndPromos(updateAlgoliaProductsInBatchesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexProductsSetToActive(updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reindexProductsSetToActive(updateAlgoliaProductsInBatchesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexProductsTotalOrders(updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reindexProductsTotalOrders(updateAlgoliaProductsInBatchesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexRetailers(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.reindexRetailers(options).then((request) => request(axios, basePath));
        },
        /**
         * Triggers reindexing of specific products in Algolia based on the provided request. Only accessible by ADMIN users. The `batchSize` field in the request is optional; if not provided, a default batch size will be used.
         * @summary Reindex specific products in Algolia
         * @param {ReindexProductsRequest} reindexProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexSpecificProducts(reindexProductsRequest: ReindexProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.reindexSpecificProducts(reindexProductsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexSuborders(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.reindexSuborders(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexTags(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.reindexTags(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AlgoliaControllerApi - interface
 * @export
 * @interface AlgoliaControllerApi
 */
export interface AlgoliaControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    addSourceToBrandsIndex(options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @param {DeleteAlgoliaProductsRequest} deleteAlgoliaProductsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    deleteAlgoliaProducts(deleteAlgoliaProductsRequest: DeleteAlgoliaProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @param {DeleteAlgoliaRetailersRequest} deleteAlgoliaRetailersRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    deleteAlgoliaRetailers(deleteAlgoliaRetailersRequest: DeleteAlgoliaRetailersRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    getProductsWithoutBulletinPick(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    indexBrands(options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    indexCategories(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    indexCollections(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    reindexAlgoliaCategoryViewContainers(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Triggers reindexing of all brands in Algolia in batches.
     * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    reindexAllBrands(updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Triggers reindexing of all products in Algolia in batches.
     * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    reindexAllProducts(updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {ReindexSpecificBrandsRequest} reindexSpecificBrandsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    reindexBrands(reindexSpecificBrandsRequest: ReindexSpecificBrandsRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * Triggers reindexing of brands product-category in Algolia.
     * @param {ReindexBrandsProductCategoriesRequest} reindexBrandsProductCategoriesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    reindexBrandsProductCategories(reindexBrandsProductCategoriesRequest: ReindexBrandsProductCategoriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    reindexCustomAssortments(options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    reindexInvoices(options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    reindexOrderReturns(options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    reindexOrders(options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    reindexProductWholesaleMinimums(options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    reindexProducts(options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    reindexProductsActiveDealsAndPromos(updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    reindexProductsDealsAndPromos(updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    reindexProductsSetToActive(updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    reindexProductsTotalOrders(updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    reindexRetailers(options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * Triggers reindexing of specific products in Algolia based on the provided request. Only accessible by ADMIN users. The `batchSize` field in the request is optional; if not provided, a default batch size will be used.
     * @summary Reindex specific products in Algolia
     * @param {ReindexProductsRequest} reindexProductsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    reindexSpecificProducts(reindexProductsRequest: ReindexProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    reindexSuborders(options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApiInterface
     */
    reindexTags(options?: RawAxiosRequestConfig): AxiosPromise<string>;

}

/**
 * AlgoliaControllerApi - object-oriented interface
 * @export
 * @class AlgoliaControllerApi
 * @extends {BaseAPI}
 */
export class AlgoliaControllerApi extends BaseAPI implements AlgoliaControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public addSourceToBrandsIndex(options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).addSourceToBrandsIndex(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteAlgoliaProductsRequest} deleteAlgoliaProductsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public deleteAlgoliaProducts(deleteAlgoliaProductsRequest: DeleteAlgoliaProductsRequest, options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).deleteAlgoliaProducts(deleteAlgoliaProductsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteAlgoliaRetailersRequest} deleteAlgoliaRetailersRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public deleteAlgoliaRetailers(deleteAlgoliaRetailersRequest: DeleteAlgoliaRetailersRequest, options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).deleteAlgoliaRetailers(deleteAlgoliaRetailersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public getProductsWithoutBulletinPick(options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).getProductsWithoutBulletinPick(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public indexBrands(options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).indexBrands(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public indexCategories(options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).indexCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public indexCollections(options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).indexCollections(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public reindexAlgoliaCategoryViewContainers(options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).reindexAlgoliaCategoryViewContainers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Triggers reindexing of all brands in Algolia in batches.
     * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public reindexAllBrands(updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).reindexAllBrands(updateAlgoliaProductsInBatchesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Triggers reindexing of all products in Algolia in batches.
     * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public reindexAllProducts(updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).reindexAllProducts(updateAlgoliaProductsInBatchesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReindexSpecificBrandsRequest} reindexSpecificBrandsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public reindexBrands(reindexSpecificBrandsRequest: ReindexSpecificBrandsRequest, options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).reindexBrands(reindexSpecificBrandsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Triggers reindexing of brands product-category in Algolia.
     * @param {ReindexBrandsProductCategoriesRequest} reindexBrandsProductCategoriesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public reindexBrandsProductCategories(reindexBrandsProductCategoriesRequest: ReindexBrandsProductCategoriesRequest, options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).reindexBrandsProductCategories(reindexBrandsProductCategoriesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public reindexCustomAssortments(options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).reindexCustomAssortments(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public reindexInvoices(options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).reindexInvoices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public reindexOrderReturns(options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).reindexOrderReturns(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public reindexOrders(options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).reindexOrders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public reindexProductWholesaleMinimums(options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).reindexProductWholesaleMinimums(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public reindexProducts(options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).reindexProducts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public reindexProductsActiveDealsAndPromos(updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).reindexProductsActiveDealsAndPromos(updateAlgoliaProductsInBatchesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public reindexProductsDealsAndPromos(updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).reindexProductsDealsAndPromos(updateAlgoliaProductsInBatchesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public reindexProductsSetToActive(updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).reindexProductsSetToActive(updateAlgoliaProductsInBatchesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateAlgoliaProductsInBatchesRequest} updateAlgoliaProductsInBatchesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public reindexProductsTotalOrders(updateAlgoliaProductsInBatchesRequest: UpdateAlgoliaProductsInBatchesRequest, options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).reindexProductsTotalOrders(updateAlgoliaProductsInBatchesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public reindexRetailers(options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).reindexRetailers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Triggers reindexing of specific products in Algolia based on the provided request. Only accessible by ADMIN users. The `batchSize` field in the request is optional; if not provided, a default batch size will be used.
     * @summary Reindex specific products in Algolia
     * @param {ReindexProductsRequest} reindexProductsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public reindexSpecificProducts(reindexProductsRequest: ReindexProductsRequest, options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).reindexSpecificProducts(reindexProductsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public reindexSuborders(options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).reindexSuborders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaControllerApi
     */
    public reindexTags(options?: RawAxiosRequestConfig) {
        return AlgoliaControllerApiFp(this.configuration).reindexTags(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AlgoliaDatabaseDifferencesControllerApi - axios parameter creator
 * @export
 */
export const AlgoliaDatabaseDifferencesControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brandDifferences: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/algolia-database-differences/brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryDifferences: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/algolia-database-differences/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectionDifferences: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/algolia-database-differences/collections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customAssortmentDifferences: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/algolia-database-differences/custom-assortments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderDifferences: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/algolia-database-differences/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderReturnDifferences: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/algolia-database-differences/order-returns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProductDifferencesRequest} productDifferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productDifferences: async (productDifferencesRequest: ProductDifferencesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productDifferencesRequest' is not null or undefined
            assertParamExists('productDifferences', 'productDifferencesRequest', productDifferencesRequest)
            const localVarPath = `/algolia-database-differences/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productDifferencesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retailerDifferences: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/algolia-database-differences/retailers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suborderDifferences: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/algolia-database-differences/suborders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagDifferences: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/algolia-database-differences/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AlgoliaDatabaseDifferencesControllerApi - functional programming interface
 * @export
 */
export const AlgoliaDatabaseDifferencesControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AlgoliaDatabaseDifferencesControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brandDifferences(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DifferentEntityInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.brandDifferences(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaDatabaseDifferencesControllerApi.brandDifferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async categoryDifferences(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DifferentEntityInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.categoryDifferences(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaDatabaseDifferencesControllerApi.categoryDifferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async collectionDifferences(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DifferentEntityInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.collectionDifferences(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaDatabaseDifferencesControllerApi.collectionDifferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customAssortmentDifferences(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DifferentEntityInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customAssortmentDifferences(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaDatabaseDifferencesControllerApi.customAssortmentDifferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderDifferences(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DifferentEntityInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderDifferences(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaDatabaseDifferencesControllerApi.orderDifferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderReturnDifferences(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DifferentEntityInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderReturnDifferences(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaDatabaseDifferencesControllerApi.orderReturnDifferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ProductDifferencesRequest} productDifferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productDifferences(productDifferencesRequest: ProductDifferencesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productDifferences(productDifferencesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaDatabaseDifferencesControllerApi.productDifferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retailerDifferences(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DifferentEntityInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retailerDifferences(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaDatabaseDifferencesControllerApi.retailerDifferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suborderDifferences(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DifferentEntityInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suborderDifferences(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaDatabaseDifferencesControllerApi.suborderDifferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tagDifferences(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DifferentEntityInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tagDifferences(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaDatabaseDifferencesControllerApi.tagDifferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AlgoliaDatabaseDifferencesControllerApi - factory interface
 * @export
 */
export const AlgoliaDatabaseDifferencesControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AlgoliaDatabaseDifferencesControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brandDifferences(options?: RawAxiosRequestConfig): AxiosPromise<DifferentEntityInfo> {
            return localVarFp.brandDifferences(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryDifferences(options?: RawAxiosRequestConfig): AxiosPromise<DifferentEntityInfo> {
            return localVarFp.categoryDifferences(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectionDifferences(options?: RawAxiosRequestConfig): AxiosPromise<DifferentEntityInfo> {
            return localVarFp.collectionDifferences(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customAssortmentDifferences(options?: RawAxiosRequestConfig): AxiosPromise<DifferentEntityInfo> {
            return localVarFp.customAssortmentDifferences(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderDifferences(options?: RawAxiosRequestConfig): AxiosPromise<DifferentEntityInfo> {
            return localVarFp.orderDifferences(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderReturnDifferences(options?: RawAxiosRequestConfig): AxiosPromise<DifferentEntityInfo> {
            return localVarFp.orderReturnDifferences(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductDifferencesRequest} productDifferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productDifferences(productDifferencesRequest: ProductDifferencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.productDifferences(productDifferencesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retailerDifferences(options?: RawAxiosRequestConfig): AxiosPromise<DifferentEntityInfo> {
            return localVarFp.retailerDifferences(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suborderDifferences(options?: RawAxiosRequestConfig): AxiosPromise<DifferentEntityInfo> {
            return localVarFp.suborderDifferences(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagDifferences(options?: RawAxiosRequestConfig): AxiosPromise<DifferentEntityInfo> {
            return localVarFp.tagDifferences(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AlgoliaDatabaseDifferencesControllerApi - interface
 * @export
 * @interface AlgoliaDatabaseDifferencesControllerApi
 */
export interface AlgoliaDatabaseDifferencesControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaDatabaseDifferencesControllerApiInterface
     */
    brandDifferences(options?: RawAxiosRequestConfig): AxiosPromise<DifferentEntityInfo>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaDatabaseDifferencesControllerApiInterface
     */
    categoryDifferences(options?: RawAxiosRequestConfig): AxiosPromise<DifferentEntityInfo>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaDatabaseDifferencesControllerApiInterface
     */
    collectionDifferences(options?: RawAxiosRequestConfig): AxiosPromise<DifferentEntityInfo>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaDatabaseDifferencesControllerApiInterface
     */
    customAssortmentDifferences(options?: RawAxiosRequestConfig): AxiosPromise<DifferentEntityInfo>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaDatabaseDifferencesControllerApiInterface
     */
    orderDifferences(options?: RawAxiosRequestConfig): AxiosPromise<DifferentEntityInfo>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaDatabaseDifferencesControllerApiInterface
     */
    orderReturnDifferences(options?: RawAxiosRequestConfig): AxiosPromise<DifferentEntityInfo>;

    /**
     * 
     * @param {ProductDifferencesRequest} productDifferencesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaDatabaseDifferencesControllerApiInterface
     */
    productDifferences(productDifferencesRequest: ProductDifferencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaDatabaseDifferencesControllerApiInterface
     */
    retailerDifferences(options?: RawAxiosRequestConfig): AxiosPromise<DifferentEntityInfo>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaDatabaseDifferencesControllerApiInterface
     */
    suborderDifferences(options?: RawAxiosRequestConfig): AxiosPromise<DifferentEntityInfo>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaDatabaseDifferencesControllerApiInterface
     */
    tagDifferences(options?: RawAxiosRequestConfig): AxiosPromise<DifferentEntityInfo>;

}

/**
 * AlgoliaDatabaseDifferencesControllerApi - object-oriented interface
 * @export
 * @class AlgoliaDatabaseDifferencesControllerApi
 * @extends {BaseAPI}
 */
export class AlgoliaDatabaseDifferencesControllerApi extends BaseAPI implements AlgoliaDatabaseDifferencesControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaDatabaseDifferencesControllerApi
     */
    public brandDifferences(options?: RawAxiosRequestConfig) {
        return AlgoliaDatabaseDifferencesControllerApiFp(this.configuration).brandDifferences(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaDatabaseDifferencesControllerApi
     */
    public categoryDifferences(options?: RawAxiosRequestConfig) {
        return AlgoliaDatabaseDifferencesControllerApiFp(this.configuration).categoryDifferences(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaDatabaseDifferencesControllerApi
     */
    public collectionDifferences(options?: RawAxiosRequestConfig) {
        return AlgoliaDatabaseDifferencesControllerApiFp(this.configuration).collectionDifferences(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaDatabaseDifferencesControllerApi
     */
    public customAssortmentDifferences(options?: RawAxiosRequestConfig) {
        return AlgoliaDatabaseDifferencesControllerApiFp(this.configuration).customAssortmentDifferences(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaDatabaseDifferencesControllerApi
     */
    public orderDifferences(options?: RawAxiosRequestConfig) {
        return AlgoliaDatabaseDifferencesControllerApiFp(this.configuration).orderDifferences(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaDatabaseDifferencesControllerApi
     */
    public orderReturnDifferences(options?: RawAxiosRequestConfig) {
        return AlgoliaDatabaseDifferencesControllerApiFp(this.configuration).orderReturnDifferences(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductDifferencesRequest} productDifferencesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaDatabaseDifferencesControllerApi
     */
    public productDifferences(productDifferencesRequest: ProductDifferencesRequest, options?: RawAxiosRequestConfig) {
        return AlgoliaDatabaseDifferencesControllerApiFp(this.configuration).productDifferences(productDifferencesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaDatabaseDifferencesControllerApi
     */
    public retailerDifferences(options?: RawAxiosRequestConfig) {
        return AlgoliaDatabaseDifferencesControllerApiFp(this.configuration).retailerDifferences(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaDatabaseDifferencesControllerApi
     */
    public suborderDifferences(options?: RawAxiosRequestConfig) {
        return AlgoliaDatabaseDifferencesControllerApiFp(this.configuration).suborderDifferences(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaDatabaseDifferencesControllerApi
     */
    public tagDifferences(options?: RawAxiosRequestConfig) {
        return AlgoliaDatabaseDifferencesControllerApiFp(this.configuration).tagDifferences(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AlgoliaRecommendationControllerApi - axios parameter creator
 * @export
 */
export const AlgoliaRecommendationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetches Algolia-based related product recommendations for a given product object ID.
         * @summary Get related product recommendations
         * @param {string} objectID 
         * @param {number} [threshold] 
         * @param {number} [maxRecommendations] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecommendations: async (objectID: string, threshold?: number, maxRecommendations?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectID' is not null or undefined
            assertParamExists('getRecommendations', 'objectID', objectID)
            const localVarPath = `/algolia/recommendations/{objectID}`
                .replace(`{${"objectID"}}`, encodeURIComponent(String(objectID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (threshold !== undefined) {
                localVarQueryParameter['threshold'] = threshold;
            }

            if (maxRecommendations !== undefined) {
                localVarQueryParameter['maxRecommendations'] = maxRecommendations;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AlgoliaRecommendationControllerApi - functional programming interface
 * @export
 */
export const AlgoliaRecommendationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AlgoliaRecommendationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetches Algolia-based related product recommendations for a given product object ID.
         * @summary Get related product recommendations
         * @param {string} objectID 
         * @param {number} [threshold] 
         * @param {number} [maxRecommendations] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecommendations(objectID: string, threshold?: number, maxRecommendations?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AlgoliaRecommendationResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecommendations(objectID, threshold, maxRecommendations, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlgoliaRecommendationControllerApi.getRecommendations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AlgoliaRecommendationControllerApi - factory interface
 * @export
 */
export const AlgoliaRecommendationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AlgoliaRecommendationControllerApiFp(configuration)
    return {
        /**
         * Fetches Algolia-based related product recommendations for a given product object ID.
         * @summary Get related product recommendations
         * @param {string} objectID 
         * @param {number} [threshold] 
         * @param {number} [maxRecommendations] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecommendations(objectID: string, threshold?: number, maxRecommendations?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<AlgoliaRecommendationResponse>> {
            return localVarFp.getRecommendations(objectID, threshold, maxRecommendations, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AlgoliaRecommendationControllerApi - interface
 * @export
 * @interface AlgoliaRecommendationControllerApi
 */
export interface AlgoliaRecommendationControllerApiInterface {
    /**
     * Fetches Algolia-based related product recommendations for a given product object ID.
     * @summary Get related product recommendations
     * @param {string} objectID 
     * @param {number} [threshold] 
     * @param {number} [maxRecommendations] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaRecommendationControllerApiInterface
     */
    getRecommendations(objectID: string, threshold?: number, maxRecommendations?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<AlgoliaRecommendationResponse>>;

}

/**
 * AlgoliaRecommendationControllerApi - object-oriented interface
 * @export
 * @class AlgoliaRecommendationControllerApi
 * @extends {BaseAPI}
 */
export class AlgoliaRecommendationControllerApi extends BaseAPI implements AlgoliaRecommendationControllerApiInterface {
    /**
     * Fetches Algolia-based related product recommendations for a given product object ID.
     * @summary Get related product recommendations
     * @param {string} objectID 
     * @param {number} [threshold] 
     * @param {number} [maxRecommendations] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlgoliaRecommendationControllerApi
     */
    public getRecommendations(objectID: string, threshold?: number, maxRecommendations?: number, options?: RawAxiosRequestConfig) {
        return AlgoliaRecommendationControllerApiFp(this.configuration).getRecommendations(objectID, threshold, maxRecommendations, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthenticationControllerApi - axios parameter creator
 * @export
 */
export const AuthenticationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Change user email
         * @param {VerifyEmailRequest} verifyEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeEmail: async (verifyEmailRequest: VerifyEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyEmailRequest' is not null or undefined
            assertParamExists('changeEmail', 'verifyEmailRequest', verifyEmailRequest)
            const localVarPath = `/auth/change-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change user password
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (changePasswordRequest: ChangePasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changePasswordRequest' is not null or undefined
            assertParamExists('changePassword', 'changePasswordRequest', changePasswordRequest)
            const localVarPath = `/auth/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm user password
         * @param {ConfirmPasswordRequest} confirmPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPassword: async (confirmPasswordRequest: ConfirmPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'confirmPasswordRequest' is not null or undefined
            assertParamExists('confirmPassword', 'confirmPasswordRequest', confirmPasswordRequest)
            const localVarPath = `/auth/confirm-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create AWS Cognito user
         * @param {AddUserToCognitoRequest} addUserToCognitoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAWSCognitoUser: async (addUserToCognitoRequest: AddUserToCognitoRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addUserToCognitoRequest' is not null or undefined
            assertParamExists('createAWSCognitoUser', 'addUserToCognitoRequest', addUserToCognitoRequest)
            const localVarPath = `/auth/cognito-user/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addUserToCognitoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete AWS Cognito user
         * @param {DeleteAWSCognitoUserRequest} deleteAWSCognitoUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAWSCognitoUser: async (deleteAWSCognitoUserRequest: DeleteAWSCognitoUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteAWSCognitoUserRequest' is not null or undefined
            assertParamExists('deleteAWSCognitoUser', 'deleteAWSCognitoUserRequest', deleteAWSCognitoUserRequest)
            const localVarPath = `/auth/cognito-user/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteAWSCognitoUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Extend reset password codes for all users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendAllResetPasswordCodes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/extend-all-reset-password-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User forgot password
         * @param {EmailWrapperDto} emailWrapperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: async (emailWrapperDto: EmailWrapperDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailWrapperDto' is not null or undefined
            assertParamExists('forgotPassword', 'emailWrapperDto', emailWrapperDto)
            const localVarPath = `/auth/forgot-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailWrapperDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Invite admin
         * @param {EmailWrapperDto} emailWrapperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteAdmin: async (emailWrapperDto: EmailWrapperDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailWrapperDto' is not null or undefined
            assertParamExists('inviteAdmin', 'emailWrapperDto', emailWrapperDto)
            const localVarPath = `/auth/admin/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailWrapperDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns new access token using refresh token from cookie.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/refresh-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Brand registration. Returns registered brand info
         * @param {BrandSignUpRequest} brandSignUpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerBrand: async (brandSignUpRequest: BrandSignUpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandSignUpRequest' is not null or undefined
            assertParamExists('registerBrand', 'brandSignUpRequest', brandSignUpRequest)
            const localVarPath = `/auth/brand/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(brandSignUpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reset user password
         * @param {ResetPasswordRequest} resetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (resetPasswordRequest: ResetPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordRequest' is not null or undefined
            assertParamExists('resetPassword', 'resetPasswordRequest', resetPasswordRequest)
            const localVarPath = `/auth/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send invitation email to brand
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBrandInvitationMail: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sendBrandInvitationMail', 'id', id)
            const localVarPath = `/auth/brand/{id}/invite`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set trade show attendee password
         * @param {SetTradeShowAttendeePasswordRequest} setTradeShowAttendeePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTradeShowAttendeePassword: async (setTradeShowAttendeePasswordRequest: SetTradeShowAttendeePasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setTradeShowAttendeePasswordRequest' is not null or undefined
            assertParamExists('setTradeShowAttendeePassword', 'setTradeShowAttendeePasswordRequest', setTradeShowAttendeePasswordRequest)
            const localVarPath = `/auth/retailer/set-attendee-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setTradeShowAttendeePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User sign in. Returns info about user login
         * @param {SignInRequest} signInRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signIn: async (signInRequest: SignInRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signInRequest' is not null or undefined
            assertParamExists('signIn', 'signInRequest', signInRequest)
            const localVarPath = `/auth/sign-in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signInRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User sign out. Clear Refresh Token Cookie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOut: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/sign-out`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verify brand. Returns verified brand info
         * @param {VerifyEmailRequest} verifyEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyBrand: async (verifyEmailRequest: VerifyEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyEmailRequest' is not null or undefined
            assertParamExists('verifyBrand', 'verifyEmailRequest', verifyEmailRequest)
            const localVarPath = `/auth/brand/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verify retailer. Returns registered retailer info
         * @param {VerifyEmailRequest} verifyEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyRetailer: async (verifyEmailRequest: VerifyEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyEmailRequest' is not null or undefined
            assertParamExists('verifyRetailer', 'verifyEmailRequest', verifyEmailRequest)
            const localVarPath = `/auth/retailer/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationControllerApi - functional programming interface
 * @export
 */
export const AuthenticationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Change user email
         * @param {VerifyEmailRequest} verifyEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeEmail(verifyEmailRequest: VerifyEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeEmail(verifyEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationControllerApi.changeEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change user password
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(changePasswordRequest: ChangePasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword(changePasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationControllerApi.changePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Confirm user password
         * @param {ConfirmPasswordRequest} confirmPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmPassword(confirmPasswordRequest: ConfirmPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmPassword(confirmPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationControllerApi.confirmPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create AWS Cognito user
         * @param {AddUserToCognitoRequest} addUserToCognitoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAWSCognitoUser(addUserToCognitoRequest: AddUserToCognitoRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAWSCognitoUser(addUserToCognitoRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationControllerApi.createAWSCognitoUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete AWS Cognito user
         * @param {DeleteAWSCognitoUserRequest} deleteAWSCognitoUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAWSCognitoUser(deleteAWSCognitoUserRequest: DeleteAWSCognitoUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAWSCognitoUser(deleteAWSCognitoUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationControllerApi.deleteAWSCognitoUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Extend reset password codes for all users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async extendAllResetPasswordCodes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.extendAllResetPasswordCodes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationControllerApi.extendAllResetPasswordCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * User forgot password
         * @param {EmailWrapperDto} emailWrapperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forgotPassword(emailWrapperDto: EmailWrapperDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forgotPassword(emailWrapperDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationControllerApi.forgotPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Invite admin
         * @param {EmailWrapperDto} emailWrapperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteAdmin(emailWrapperDto: EmailWrapperDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteAdmin(emailWrapperDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationControllerApi.inviteAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns new access token using refresh token from cookie.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshToken(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshToken(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationControllerApi.refreshToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Brand registration. Returns registered brand info
         * @param {BrandSignUpRequest} brandSignUpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerBrand(brandSignUpRequest: BrandSignUpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignInResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerBrand(brandSignUpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationControllerApi.registerBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reset user password
         * @param {ResetPasswordRequest} resetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(resetPasswordRequest: ResetPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignInResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(resetPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationControllerApi.resetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send invitation email to brand
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendBrandInvitationMail(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendBrandInvitationMail(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationControllerApi.sendBrandInvitationMail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set trade show attendee password
         * @param {SetTradeShowAttendeePasswordRequest} setTradeShowAttendeePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setTradeShowAttendeePassword(setTradeShowAttendeePasswordRequest: SetTradeShowAttendeePasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetTradeShowAttendeePasswordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setTradeShowAttendeePassword(setTradeShowAttendeePasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationControllerApi.setTradeShowAttendeePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * User sign in. Returns info about user login
         * @param {SignInRequest} signInRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signIn(signInRequest: SignInRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignInResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signIn(signInRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationControllerApi.signIn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * User sign out. Clear Refresh Token Cookie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signOut(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signOut(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationControllerApi.signOut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Verify brand. Returns verified brand info
         * @param {VerifyEmailRequest} verifyEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyBrand(verifyEmailRequest: VerifyEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateBrandApplicantRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyBrand(verifyEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationControllerApi.verifyBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Verify retailer. Returns registered retailer info
         * @param {VerifyEmailRequest} verifyEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyRetailer(verifyEmailRequest: VerifyEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyRetailer(verifyEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationControllerApi.verifyRetailer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthenticationControllerApi - factory interface
 * @export
 */
export const AuthenticationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationControllerApiFp(configuration)
    return {
        /**
         * Change user email
         * @param {VerifyEmailRequest} verifyEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeEmail(verifyEmailRequest: VerifyEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChangeEmailResponse> {
            return localVarFp.changeEmail(verifyEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Change user password
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(changePasswordRequest: ChangePasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changePassword(changePasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm user password
         * @param {ConfirmPasswordRequest} confirmPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPassword(confirmPasswordRequest: ConfirmPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.confirmPassword(confirmPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create AWS Cognito user
         * @param {AddUserToCognitoRequest} addUserToCognitoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAWSCognitoUser(addUserToCognitoRequest: AddUserToCognitoRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createAWSCognitoUser(addUserToCognitoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete AWS Cognito user
         * @param {DeleteAWSCognitoUserRequest} deleteAWSCognitoUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAWSCognitoUser(deleteAWSCognitoUserRequest: DeleteAWSCognitoUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAWSCognitoUser(deleteAWSCognitoUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Extend reset password codes for all users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendAllResetPasswordCodes(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.extendAllResetPasswordCodes(options).then((request) => request(axios, basePath));
        },
        /**
         * User forgot password
         * @param {EmailWrapperDto} emailWrapperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword(emailWrapperDto: EmailWrapperDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.forgotPassword(emailWrapperDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Invite admin
         * @param {EmailWrapperDto} emailWrapperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteAdmin(emailWrapperDto: EmailWrapperDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.inviteAdmin(emailWrapperDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns new access token using refresh token from cookie.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.refreshToken(options).then((request) => request(axios, basePath));
        },
        /**
         * Brand registration. Returns registered brand info
         * @param {BrandSignUpRequest} brandSignUpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerBrand(brandSignUpRequest: BrandSignUpRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignInResponse> {
            return localVarFp.registerBrand(brandSignUpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Reset user password
         * @param {ResetPasswordRequest} resetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(resetPasswordRequest: ResetPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignInResponse> {
            return localVarFp.resetPassword(resetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Send invitation email to brand
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBrandInvitationMail(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendBrandInvitationMail(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Set trade show attendee password
         * @param {SetTradeShowAttendeePasswordRequest} setTradeShowAttendeePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTradeShowAttendeePassword(setTradeShowAttendeePasswordRequest: SetTradeShowAttendeePasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<SetTradeShowAttendeePasswordResponse> {
            return localVarFp.setTradeShowAttendeePassword(setTradeShowAttendeePasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * User sign in. Returns info about user login
         * @param {SignInRequest} signInRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signIn(signInRequest: SignInRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignInResponse> {
            return localVarFp.signIn(signInRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * User sign out. Clear Refresh Token Cookie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOut(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.signOut(options).then((request) => request(axios, basePath));
        },
        /**
         * Verify brand. Returns verified brand info
         * @param {VerifyEmailRequest} verifyEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyBrand(verifyEmailRequest: VerifyEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateBrandApplicantRequest> {
            return localVarFp.verifyBrand(verifyEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Verify retailer. Returns registered retailer info
         * @param {VerifyEmailRequest} verifyEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyRetailer(verifyEmailRequest: VerifyEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.verifyRetailer(verifyEmailRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationControllerApi - interface
 * @export
 * @interface AuthenticationControllerApi
 */
export interface AuthenticationControllerApiInterface {
    /**
     * Change user email
     * @param {VerifyEmailRequest} verifyEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApiInterface
     */
    changeEmail(verifyEmailRequest: VerifyEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChangeEmailResponse>;

    /**
     * Change user password
     * @param {ChangePasswordRequest} changePasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApiInterface
     */
    changePassword(changePasswordRequest: ChangePasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Confirm user password
     * @param {ConfirmPasswordRequest} confirmPasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApiInterface
     */
    confirmPassword(confirmPasswordRequest: ConfirmPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Create AWS Cognito user
     * @param {AddUserToCognitoRequest} addUserToCognitoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApiInterface
     */
    createAWSCognitoUser(addUserToCognitoRequest: AddUserToCognitoRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Delete AWS Cognito user
     * @param {DeleteAWSCognitoUserRequest} deleteAWSCognitoUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApiInterface
     */
    deleteAWSCognitoUser(deleteAWSCognitoUserRequest: DeleteAWSCognitoUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Extend reset password codes for all users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApiInterface
     */
    extendAllResetPasswordCodes(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * User forgot password
     * @param {EmailWrapperDto} emailWrapperDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApiInterface
     */
    forgotPassword(emailWrapperDto: EmailWrapperDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Invite admin
     * @param {EmailWrapperDto} emailWrapperDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApiInterface
     */
    inviteAdmin(emailWrapperDto: EmailWrapperDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Returns new access token using refresh token from cookie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApiInterface
     */
    refreshToken(options?: RawAxiosRequestConfig): AxiosPromise<object>;

    /**
     * Brand registration. Returns registered brand info
     * @param {BrandSignUpRequest} brandSignUpRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApiInterface
     */
    registerBrand(brandSignUpRequest: BrandSignUpRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignInResponse>;

    /**
     * Reset user password
     * @param {ResetPasswordRequest} resetPasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApiInterface
     */
    resetPassword(resetPasswordRequest: ResetPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignInResponse>;

    /**
     * Send invitation email to brand
     * @param {string} id Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApiInterface
     */
    sendBrandInvitationMail(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Set trade show attendee password
     * @param {SetTradeShowAttendeePasswordRequest} setTradeShowAttendeePasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApiInterface
     */
    setTradeShowAttendeePassword(setTradeShowAttendeePasswordRequest: SetTradeShowAttendeePasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<SetTradeShowAttendeePasswordResponse>;

    /**
     * User sign in. Returns info about user login
     * @param {SignInRequest} signInRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApiInterface
     */
    signIn(signInRequest: SignInRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignInResponse>;

    /**
     * User sign out. Clear Refresh Token Cookie
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApiInterface
     */
    signOut(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Verify brand. Returns verified brand info
     * @param {VerifyEmailRequest} verifyEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApiInterface
     */
    verifyBrand(verifyEmailRequest: VerifyEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateBrandApplicantRequest>;

    /**
     * Verify retailer. Returns registered retailer info
     * @param {VerifyEmailRequest} verifyEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApiInterface
     */
    verifyRetailer(verifyEmailRequest: VerifyEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * AuthenticationControllerApi - object-oriented interface
 * @export
 * @class AuthenticationControllerApi
 * @extends {BaseAPI}
 */
export class AuthenticationControllerApi extends BaseAPI implements AuthenticationControllerApiInterface {
    /**
     * Change user email
     * @param {VerifyEmailRequest} verifyEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public changeEmail(verifyEmailRequest: VerifyEmailRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationControllerApiFp(this.configuration).changeEmail(verifyEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change user password
     * @param {ChangePasswordRequest} changePasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public changePassword(changePasswordRequest: ChangePasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationControllerApiFp(this.configuration).changePassword(changePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm user password
     * @param {ConfirmPasswordRequest} confirmPasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public confirmPassword(confirmPasswordRequest: ConfirmPasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationControllerApiFp(this.configuration).confirmPassword(confirmPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create AWS Cognito user
     * @param {AddUserToCognitoRequest} addUserToCognitoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public createAWSCognitoUser(addUserToCognitoRequest: AddUserToCognitoRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationControllerApiFp(this.configuration).createAWSCognitoUser(addUserToCognitoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete AWS Cognito user
     * @param {DeleteAWSCognitoUserRequest} deleteAWSCognitoUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public deleteAWSCognitoUser(deleteAWSCognitoUserRequest: DeleteAWSCognitoUserRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationControllerApiFp(this.configuration).deleteAWSCognitoUser(deleteAWSCognitoUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Extend reset password codes for all users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public extendAllResetPasswordCodes(options?: RawAxiosRequestConfig) {
        return AuthenticationControllerApiFp(this.configuration).extendAllResetPasswordCodes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * User forgot password
     * @param {EmailWrapperDto} emailWrapperDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public forgotPassword(emailWrapperDto: EmailWrapperDto, options?: RawAxiosRequestConfig) {
        return AuthenticationControllerApiFp(this.configuration).forgotPassword(emailWrapperDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Invite admin
     * @param {EmailWrapperDto} emailWrapperDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public inviteAdmin(emailWrapperDto: EmailWrapperDto, options?: RawAxiosRequestConfig) {
        return AuthenticationControllerApiFp(this.configuration).inviteAdmin(emailWrapperDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns new access token using refresh token from cookie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public refreshToken(options?: RawAxiosRequestConfig) {
        return AuthenticationControllerApiFp(this.configuration).refreshToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Brand registration. Returns registered brand info
     * @param {BrandSignUpRequest} brandSignUpRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public registerBrand(brandSignUpRequest: BrandSignUpRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationControllerApiFp(this.configuration).registerBrand(brandSignUpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reset user password
     * @param {ResetPasswordRequest} resetPasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public resetPassword(resetPasswordRequest: ResetPasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationControllerApiFp(this.configuration).resetPassword(resetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send invitation email to brand
     * @param {string} id Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public sendBrandInvitationMail(id: string, options?: RawAxiosRequestConfig) {
        return AuthenticationControllerApiFp(this.configuration).sendBrandInvitationMail(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set trade show attendee password
     * @param {SetTradeShowAttendeePasswordRequest} setTradeShowAttendeePasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public setTradeShowAttendeePassword(setTradeShowAttendeePasswordRequest: SetTradeShowAttendeePasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationControllerApiFp(this.configuration).setTradeShowAttendeePassword(setTradeShowAttendeePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * User sign in. Returns info about user login
     * @param {SignInRequest} signInRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public signIn(signInRequest: SignInRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationControllerApiFp(this.configuration).signIn(signInRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * User sign out. Clear Refresh Token Cookie
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public signOut(options?: RawAxiosRequestConfig) {
        return AuthenticationControllerApiFp(this.configuration).signOut(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verify brand. Returns verified brand info
     * @param {VerifyEmailRequest} verifyEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public verifyBrand(verifyEmailRequest: VerifyEmailRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationControllerApiFp(this.configuration).verifyBrand(verifyEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verify retailer. Returns registered retailer info
     * @param {VerifyEmailRequest} verifyEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public verifyRetailer(verifyEmailRequest: VerifyEmailRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationControllerApiFp(this.configuration).verifyRetailer(verifyEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BalanceControllerApi - axios parameter creator
 * @export
 */
export const BalanceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Capture transaction for Suborder ID
         * @param {string} suborderId ID of the suborder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        captureSuborder: async (suborderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'suborderId' is not null or undefined
            assertParamExists('captureSuborder', 'suborderId', suborderId)
            const localVarPath = `/balance/transaction/capture/{suborderId}`
                .replace(`{${"suborderId"}}`, encodeURIComponent(String(suborderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Capture transaction
         * @param {BalanceCaptureRequest} balanceCaptureRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        captureTransaction: async (balanceCaptureRequest: BalanceCaptureRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'balanceCaptureRequest' is not null or undefined
            assertParamExists('captureTransaction', 'balanceCaptureRequest', balanceCaptureRequest)
            const localVarPath = `/balance/transaction/capture`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(balanceCaptureRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for creating buyer profile in balance system.
         * @param {string} retailerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBuyer: async (retailerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'retailerId' is not null or undefined
            assertParamExists('createBuyer', 'retailerId', retailerId)
            const localVarPath = `/balance/buyer/{retailerId}/create`
                .replace(`{${"retailerId"}}`, encodeURIComponent(String(retailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for creating balance transaction for checkout
         * @param {CreateBalanceTransactionRequest} createBalanceTransactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransaction: async (createBalanceTransactionRequest: CreateBalanceTransactionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBalanceTransactionRequest' is not null or undefined
            assertParamExists('createTransaction', 'createBalanceTransactionRequest', createBalanceTransactionRequest)
            const localVarPath = `/balance/transactions/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBalanceTransactionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for creating vendor profile for a brand in balance.
         * @param {string} brandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVendorByEmail: async (brandId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('createVendorByEmail', 'brandId', brandId)
            const localVarPath = `/balance/vendor/{brandId}/create`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete payment method by paymentId
         * @param {string} paymentId ID of the payment method
         * @param {string} paymentType Type of the payment method-[card, bank]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaymentMethod: async (paymentId: string, paymentType: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('deletePaymentMethod', 'paymentId', paymentId)
            // verify required parameter 'paymentType' is not null or undefined
            assertParamExists('deletePaymentMethod', 'paymentType', paymentType)
            const localVarPath = `/balance/payment/{paymentType}/{paymentId}`
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)))
                .replace(`{${"paymentType"}}`, encodeURIComponent(String(paymentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get credit limit by buyerId
         * @param {string} buyerId ID of the buyer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuyerCredit: async (buyerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerId' is not null or undefined
            assertParamExists('getBuyerCredit', 'buyerId', buyerId)
            const localVarPath = `/balance/credit-limit/{buyerId}`
                .replace(`{${"buyerId"}}`, encodeURIComponent(String(buyerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get buyer detail from balance for a retailer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuyerDetail: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/balance/buyers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get credit qualification link by buyerId
         * @param {string} buyerId ID of the buyer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuyerQualificationLink: async (buyerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerId' is not null or undefined
            assertParamExists('getBuyerQualificationLink', 'buyerId', buyerId)
            const localVarPath = `/balance/qualification/{buyerId}`
                .replace(`{${"buyerId"}}`, encodeURIComponent(String(buyerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get payment detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentDetail: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/balance/payment-detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get payment method token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentMethodToken: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/balance/payment-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get transaction by Id
         * @param {string} transactionId ID of the transaction assocaited with order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransaction: async (transactionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('getTransaction', 'transactionId', transactionId)
            const localVarPath = `/balance/transaction/{transactionId}`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API for search vendor profile for a brand in balance by brandId as referenceId.
         * @param {string} brandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVendorByBrandId: async (brandId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('searchVendorByBrandId', 'brandId', brandId)
            const localVarPath = `/balance/vendors/search/{brandId}`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set suborder status to be cancel after balance mark transaction as cancelled
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSetSuborderAsCanceled1: async (body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('setSetSuborderAsCanceled1', 'body', body)
            const localVarPath = `/balance/transaction-canceled`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;charset=UTF-8';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set suborder status to be failed after unsuccessful charge
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSetSuborderAsFailed: async (body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('setSetSuborderAsFailed', 'body', body)
            const localVarPath = `/balance/transaction-failed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;charset=UTF-8';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set suborder status to be paid after successful charge
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSuborderAsPaid: async (body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('setSuborderAsPaid', 'body', body)
            const localVarPath = `/balance/transaction-charged`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;charset=UTF-8';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates subscription for supported webhook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeToWebhookUpdate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/balance/webhook/subscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set buyer qualification status
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBuyerQualification: async (body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateBuyerQualification', 'body', body)
            const localVarPath = `/balance/buyer-qualification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;charset=UTF-8';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BalanceControllerApi - functional programming interface
 * @export
 */
export const BalanceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BalanceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Capture transaction for Suborder ID
         * @param {string} suborderId ID of the suborder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async captureSuborder(suborderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.captureSuborder(suborderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceControllerApi.captureSuborder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Capture transaction
         * @param {BalanceCaptureRequest} balanceCaptureRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async captureTransaction(balanceCaptureRequest: BalanceCaptureRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.captureTransaction(balanceCaptureRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceControllerApi.captureTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for creating buyer profile in balance system.
         * @param {string} retailerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBuyer(retailerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuyerCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBuyer(retailerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceControllerApi.createBuyer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for creating balance transaction for checkout
         * @param {CreateBalanceTransactionRequest} createBalanceTransactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTransaction(createBalanceTransactionRequest: CreateBalanceTransactionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateTransactionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTransaction(createBalanceTransactionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceControllerApi.createTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for creating vendor profile for a brand in balance.
         * @param {string} brandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVendorByEmail(brandId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VendorCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVendorByEmail(brandId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceControllerApi.createVendorByEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete payment method by paymentId
         * @param {string} paymentId ID of the payment method
         * @param {string} paymentType Type of the payment method-[card, bank]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePaymentMethod(paymentId: string, paymentType: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePaymentMethod(paymentId, paymentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceControllerApi.deletePaymentMethod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get credit limit by buyerId
         * @param {string} buyerId ID of the buyer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBuyerCredit(buyerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuyerCreditResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBuyerCredit(buyerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceControllerApi.getBuyerCredit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get buyer detail from balance for a retailer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBuyerDetail(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuyerByIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBuyerDetail(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceControllerApi.getBuyerDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get credit qualification link by buyerId
         * @param {string} buyerId ID of the buyer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBuyerQualificationLink(buyerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBuyerQualificationLink(buyerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceControllerApi.getBuyerQualificationLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get payment detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentDetail(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentDetail(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceControllerApi.getPaymentDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get payment method token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentMethodToken(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentMethodTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentMethodToken(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceControllerApi.getPaymentMethodToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get transaction by Id
         * @param {string} transactionId ID of the transaction assocaited with order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransaction(transactionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransaction(transactionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceControllerApi.getTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API for search vendor profile for a brand in balance by brandId as referenceId.
         * @param {string} brandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchVendorByBrandId(brandId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VendorCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchVendorByBrandId(brandId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceControllerApi.searchVendorByBrandId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set suborder status to be cancel after balance mark transaction as cancelled
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setSetSuborderAsCanceled1(body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setSetSuborderAsCanceled1(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceControllerApi.setSetSuborderAsCanceled1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set suborder status to be failed after unsuccessful charge
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setSetSuborderAsFailed(body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setSetSuborderAsFailed(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceControllerApi.setSetSuborderAsFailed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set suborder status to be paid after successful charge
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setSuborderAsPaid(body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setSuborderAsPaid(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceControllerApi.setSuborderAsPaid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates subscription for supported webhook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribeToWebhookUpdate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribeToWebhookUpdate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceControllerApi.subscribeToWebhookUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set buyer qualification status
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBuyerQualification(body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBuyerQualification(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceControllerApi.updateBuyerQualification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BalanceControllerApi - factory interface
 * @export
 */
export const BalanceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BalanceControllerApiFp(configuration)
    return {
        /**
         * Capture transaction for Suborder ID
         * @param {string} suborderId ID of the suborder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        captureSuborder(suborderId: string, options?: RawAxiosRequestConfig): AxiosPromise<TransactionResponse> {
            return localVarFp.captureSuborder(suborderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Capture transaction
         * @param {BalanceCaptureRequest} balanceCaptureRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        captureTransaction(balanceCaptureRequest: BalanceCaptureRequest, options?: RawAxiosRequestConfig): AxiosPromise<TransactionResponse> {
            return localVarFp.captureTransaction(balanceCaptureRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API for creating buyer profile in balance system.
         * @param {string} retailerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBuyer(retailerId: string, options?: RawAxiosRequestConfig): AxiosPromise<BuyerCreateResponse> {
            return localVarFp.createBuyer(retailerId, options).then((request) => request(axios, basePath));
        },
        /**
         * API for creating balance transaction for checkout
         * @param {CreateBalanceTransactionRequest} createBalanceTransactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransaction(createBalanceTransactionRequest: CreateBalanceTransactionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateTransactionResponse> {
            return localVarFp.createTransaction(createBalanceTransactionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API for creating vendor profile for a brand in balance.
         * @param {string} brandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVendorByEmail(brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<VendorCreateResponse> {
            return localVarFp.createVendorByEmail(brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete payment method by paymentId
         * @param {string} paymentId ID of the payment method
         * @param {string} paymentType Type of the payment method-[card, bank]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaymentMethod(paymentId: string, paymentType: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePaymentMethod(paymentId, paymentType, options).then((request) => request(axios, basePath));
        },
        /**
         * Get credit limit by buyerId
         * @param {string} buyerId ID of the buyer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuyerCredit(buyerId: string, options?: RawAxiosRequestConfig): AxiosPromise<BuyerCreditResponse> {
            return localVarFp.getBuyerCredit(buyerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get buyer detail from balance for a retailer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuyerDetail(options?: RawAxiosRequestConfig): AxiosPromise<BuyerByIdResponse> {
            return localVarFp.getBuyerDetail(options).then((request) => request(axios, basePath));
        },
        /**
         * Get credit qualification link by buyerId
         * @param {string} buyerId ID of the buyer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuyerQualificationLink(buyerId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getBuyerQualificationLink(buyerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get payment detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentDetail(options?: RawAxiosRequestConfig): AxiosPromise<PaymentData> {
            return localVarFp.getPaymentDetail(options).then((request) => request(axios, basePath));
        },
        /**
         * Get payment method token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentMethodToken(options?: RawAxiosRequestConfig): AxiosPromise<PaymentMethodTokenResponse> {
            return localVarFp.getPaymentMethodToken(options).then((request) => request(axios, basePath));
        },
        /**
         * Get transaction by Id
         * @param {string} transactionId ID of the transaction assocaited with order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransaction(transactionId: string, options?: RawAxiosRequestConfig): AxiosPromise<TransactionResponse> {
            return localVarFp.getTransaction(transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * API for search vendor profile for a brand in balance by brandId as referenceId.
         * @param {string} brandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVendorByBrandId(brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<VendorCreateResponse> {
            return localVarFp.searchVendorByBrandId(brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Set suborder status to be cancel after balance mark transaction as cancelled
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSetSuborderAsCanceled1(body: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setSetSuborderAsCanceled1(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Set suborder status to be failed after unsuccessful charge
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSetSuborderAsFailed(body: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setSetSuborderAsFailed(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Set suborder status to be paid after successful charge
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSuborderAsPaid(body: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setSuborderAsPaid(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates subscription for supported webhook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeToWebhookUpdate(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.subscribeToWebhookUpdate(options).then((request) => request(axios, basePath));
        },
        /**
         * Set buyer qualification status
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBuyerQualification(body: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateBuyerQualification(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BalanceControllerApi - interface
 * @export
 * @interface BalanceControllerApi
 */
export interface BalanceControllerApiInterface {
    /**
     * Capture transaction for Suborder ID
     * @param {string} suborderId ID of the suborder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApiInterface
     */
    captureSuborder(suborderId: string, options?: RawAxiosRequestConfig): AxiosPromise<TransactionResponse>;

    /**
     * Capture transaction
     * @param {BalanceCaptureRequest} balanceCaptureRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApiInterface
     */
    captureTransaction(balanceCaptureRequest: BalanceCaptureRequest, options?: RawAxiosRequestConfig): AxiosPromise<TransactionResponse>;

    /**
     * API for creating buyer profile in balance system.
     * @param {string} retailerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApiInterface
     */
    createBuyer(retailerId: string, options?: RawAxiosRequestConfig): AxiosPromise<BuyerCreateResponse>;

    /**
     * API for creating balance transaction for checkout
     * @param {CreateBalanceTransactionRequest} createBalanceTransactionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApiInterface
     */
    createTransaction(createBalanceTransactionRequest: CreateBalanceTransactionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateTransactionResponse>;

    /**
     * API for creating vendor profile for a brand in balance.
     * @param {string} brandId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApiInterface
     */
    createVendorByEmail(brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<VendorCreateResponse>;

    /**
     * Delete payment method by paymentId
     * @param {string} paymentId ID of the payment method
     * @param {string} paymentType Type of the payment method-[card, bank]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApiInterface
     */
    deletePaymentMethod(paymentId: string, paymentType: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Get credit limit by buyerId
     * @param {string} buyerId ID of the buyer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApiInterface
     */
    getBuyerCredit(buyerId: string, options?: RawAxiosRequestConfig): AxiosPromise<BuyerCreditResponse>;

    /**
     * Get buyer detail from balance for a retailer.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApiInterface
     */
    getBuyerDetail(options?: RawAxiosRequestConfig): AxiosPromise<BuyerByIdResponse>;

    /**
     * Get credit qualification link by buyerId
     * @param {string} buyerId ID of the buyer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApiInterface
     */
    getBuyerQualificationLink(buyerId: string, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * Get payment detail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApiInterface
     */
    getPaymentDetail(options?: RawAxiosRequestConfig): AxiosPromise<PaymentData>;

    /**
     * Get payment method token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApiInterface
     */
    getPaymentMethodToken(options?: RawAxiosRequestConfig): AxiosPromise<PaymentMethodTokenResponse>;

    /**
     * Get transaction by Id
     * @param {string} transactionId ID of the transaction assocaited with order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApiInterface
     */
    getTransaction(transactionId: string, options?: RawAxiosRequestConfig): AxiosPromise<TransactionResponse>;

    /**
     * API for search vendor profile for a brand in balance by brandId as referenceId.
     * @param {string} brandId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApiInterface
     */
    searchVendorByBrandId(brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<VendorCreateResponse>;

    /**
     * Set suborder status to be cancel after balance mark transaction as cancelled
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApiInterface
     */
    setSetSuborderAsCanceled1(body: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Set suborder status to be failed after unsuccessful charge
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApiInterface
     */
    setSetSuborderAsFailed(body: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Set suborder status to be paid after successful charge
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApiInterface
     */
    setSuborderAsPaid(body: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Creates subscription for supported webhook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApiInterface
     */
    subscribeToWebhookUpdate(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Set buyer qualification status
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApiInterface
     */
    updateBuyerQualification(body: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * BalanceControllerApi - object-oriented interface
 * @export
 * @class BalanceControllerApi
 * @extends {BaseAPI}
 */
export class BalanceControllerApi extends BaseAPI implements BalanceControllerApiInterface {
    /**
     * Capture transaction for Suborder ID
     * @param {string} suborderId ID of the suborder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApi
     */
    public captureSuborder(suborderId: string, options?: RawAxiosRequestConfig) {
        return BalanceControllerApiFp(this.configuration).captureSuborder(suborderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Capture transaction
     * @param {BalanceCaptureRequest} balanceCaptureRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApi
     */
    public captureTransaction(balanceCaptureRequest: BalanceCaptureRequest, options?: RawAxiosRequestConfig) {
        return BalanceControllerApiFp(this.configuration).captureTransaction(balanceCaptureRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for creating buyer profile in balance system.
     * @param {string} retailerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApi
     */
    public createBuyer(retailerId: string, options?: RawAxiosRequestConfig) {
        return BalanceControllerApiFp(this.configuration).createBuyer(retailerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for creating balance transaction for checkout
     * @param {CreateBalanceTransactionRequest} createBalanceTransactionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApi
     */
    public createTransaction(createBalanceTransactionRequest: CreateBalanceTransactionRequest, options?: RawAxiosRequestConfig) {
        return BalanceControllerApiFp(this.configuration).createTransaction(createBalanceTransactionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for creating vendor profile for a brand in balance.
     * @param {string} brandId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApi
     */
    public createVendorByEmail(brandId: string, options?: RawAxiosRequestConfig) {
        return BalanceControllerApiFp(this.configuration).createVendorByEmail(brandId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete payment method by paymentId
     * @param {string} paymentId ID of the payment method
     * @param {string} paymentType Type of the payment method-[card, bank]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApi
     */
    public deletePaymentMethod(paymentId: string, paymentType: string, options?: RawAxiosRequestConfig) {
        return BalanceControllerApiFp(this.configuration).deletePaymentMethod(paymentId, paymentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get credit limit by buyerId
     * @param {string} buyerId ID of the buyer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApi
     */
    public getBuyerCredit(buyerId: string, options?: RawAxiosRequestConfig) {
        return BalanceControllerApiFp(this.configuration).getBuyerCredit(buyerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get buyer detail from balance for a retailer.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApi
     */
    public getBuyerDetail(options?: RawAxiosRequestConfig) {
        return BalanceControllerApiFp(this.configuration).getBuyerDetail(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get credit qualification link by buyerId
     * @param {string} buyerId ID of the buyer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApi
     */
    public getBuyerQualificationLink(buyerId: string, options?: RawAxiosRequestConfig) {
        return BalanceControllerApiFp(this.configuration).getBuyerQualificationLink(buyerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get payment detail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApi
     */
    public getPaymentDetail(options?: RawAxiosRequestConfig) {
        return BalanceControllerApiFp(this.configuration).getPaymentDetail(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get payment method token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApi
     */
    public getPaymentMethodToken(options?: RawAxiosRequestConfig) {
        return BalanceControllerApiFp(this.configuration).getPaymentMethodToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get transaction by Id
     * @param {string} transactionId ID of the transaction assocaited with order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApi
     */
    public getTransaction(transactionId: string, options?: RawAxiosRequestConfig) {
        return BalanceControllerApiFp(this.configuration).getTransaction(transactionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API for search vendor profile for a brand in balance by brandId as referenceId.
     * @param {string} brandId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApi
     */
    public searchVendorByBrandId(brandId: string, options?: RawAxiosRequestConfig) {
        return BalanceControllerApiFp(this.configuration).searchVendorByBrandId(brandId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set suborder status to be cancel after balance mark transaction as cancelled
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApi
     */
    public setSetSuborderAsCanceled1(body: string, options?: RawAxiosRequestConfig) {
        return BalanceControllerApiFp(this.configuration).setSetSuborderAsCanceled1(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set suborder status to be failed after unsuccessful charge
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApi
     */
    public setSetSuborderAsFailed(body: string, options?: RawAxiosRequestConfig) {
        return BalanceControllerApiFp(this.configuration).setSetSuborderAsFailed(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set suborder status to be paid after successful charge
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApi
     */
    public setSuborderAsPaid(body: string, options?: RawAxiosRequestConfig) {
        return BalanceControllerApiFp(this.configuration).setSuborderAsPaid(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates subscription for supported webhook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApi
     */
    public subscribeToWebhookUpdate(options?: RawAxiosRequestConfig) {
        return BalanceControllerApiFp(this.configuration).subscribeToWebhookUpdate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set buyer qualification status
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApi
     */
    public updateBuyerQualification(body: string, options?: RawAxiosRequestConfig) {
        return BalanceControllerApiFp(this.configuration).updateBuyerQualification(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BoardControllerApi - axios parameter creator
 * @export
 */
export const BoardControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Associate Product with Boards
         * @param {AssociateProductWithBoardsRequest} associateProductWithBoardsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateProductWithBoards: async (associateProductWithBoardsRequest: AssociateProductWithBoardsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'associateProductWithBoardsRequest' is not null or undefined
            assertParamExists('associateProductWithBoards', 'associateProductWithBoardsRequest', associateProductWithBoardsRequest)
            const localVarPath = `/boards/associate-product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(associateProductWithBoardsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create board
         * @param {CreateBoardRequest} createBoardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBoard: async (createBoardRequest: CreateBoardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBoardRequest' is not null or undefined
            assertParamExists('createBoard', 'createBoardRequest', createBoardRequest)
            const localVarPath = `/boards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBoardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete board
         * @param {string} id Board Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBoard: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteBoard', 'id', id)
            const localVarPath = `/boards/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export board to CSV file
         * @param {string} id Board Id
         * @param {string} order Order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportBoardToCsv: async (id: string, order: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('exportBoardToCsv', 'id', id)
            // verify required parameter 'order' is not null or undefined
            assertParamExists('exportBoardToCsv', 'order', order)
            const localVarPath = `/boards/{id}/export`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get board details
         * @param {string} id Board Id
         * @param {string} order Order
         * @param {string} [search] Search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoardById: async (id: string, order: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBoardById', 'id', id)
            // verify required parameter 'order' is not null or undefined
            assertParamExists('getBoardById', 'order', order)
            const localVarPath = `/boards/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get retailer all boards details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailerBoards: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/boards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get retailer boards details
         * @param {string} productId Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailerBoards1: async (productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getRetailerBoards1', 'productId', productId)
            const localVarPath = `/boards/with-product/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update board name
         * @param {string} id Board Id
         * @param {RenameBoardRequest} renameBoardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameBoard: async (id: string, renameBoardRequest: RenameBoardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('renameBoard', 'id', id)
            // verify required parameter 'renameBoardRequest' is not null or undefined
            assertParamExists('renameBoard', 'renameBoardRequest', renameBoardRequest)
            const localVarPath = `/boards/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renameBoardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BoardControllerApi - functional programming interface
 * @export
 */
export const BoardControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BoardControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Associate Product with Boards
         * @param {AssociateProductWithBoardsRequest} associateProductWithBoardsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async associateProductWithBoards(associateProductWithBoardsRequest: AssociateProductWithBoardsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.associateProductWithBoards(associateProductWithBoardsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoardControllerApi.associateProductWithBoards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create board
         * @param {CreateBoardRequest} createBoardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBoard(createBoardRequest: CreateBoardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateBoardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBoard(createBoardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoardControllerApi.createBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete board
         * @param {string} id Board Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBoard(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBoard(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoardControllerApi.deleteBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export board to CSV file
         * @param {string} id Board Id
         * @param {string} order Order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportBoardToCsv(id: string, order: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportBoardToCsv(id, order, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoardControllerApi.exportBoardToCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get board details
         * @param {string} id Board Id
         * @param {string} order Order
         * @param {string} [search] Search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBoardById(id: string, order: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBoardDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBoardById(id, order, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoardControllerApi.getBoardById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get retailer all boards details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRetailerBoards(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllRetailerBoardsDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRetailerBoards(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoardControllerApi.getRetailerBoards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get retailer boards details
         * @param {string} productId Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRetailerBoards1(productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRetailerBoardsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRetailerBoards1(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoardControllerApi.getRetailerBoards1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update board name
         * @param {string} id Board Id
         * @param {RenameBoardRequest} renameBoardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renameBoard(id: string, renameBoardRequest: RenameBoardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RenameBoardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renameBoard(id, renameBoardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoardControllerApi.renameBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BoardControllerApi - factory interface
 * @export
 */
export const BoardControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BoardControllerApiFp(configuration)
    return {
        /**
         * Associate Product with Boards
         * @param {AssociateProductWithBoardsRequest} associateProductWithBoardsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateProductWithBoards(associateProductWithBoardsRequest: AssociateProductWithBoardsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.associateProductWithBoards(associateProductWithBoardsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create board
         * @param {CreateBoardRequest} createBoardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBoard(createBoardRequest: CreateBoardRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateBoardResponse> {
            return localVarFp.createBoard(createBoardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete board
         * @param {string} id Board Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBoard(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteBoard(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Export board to CSV file
         * @param {string} id Board Id
         * @param {string} order Order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportBoardToCsv(id: string, order: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportBoardToCsv(id, order, options).then((request) => request(axios, basePath));
        },
        /**
         * Get board details
         * @param {string} id Board Id
         * @param {string} order Order
         * @param {string} [search] Search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoardById(id: string, order: string, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetBoardDetailsResponse> {
            return localVarFp.getBoardById(id, order, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Get retailer all boards details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailerBoards(options?: RawAxiosRequestConfig): AxiosPromise<GetAllRetailerBoardsDetailsResponse> {
            return localVarFp.getRetailerBoards(options).then((request) => request(axios, basePath));
        },
        /**
         * Get retailer boards details
         * @param {string} productId Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailerBoards1(productId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetRetailerBoardsResponse> {
            return localVarFp.getRetailerBoards1(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update board name
         * @param {string} id Board Id
         * @param {RenameBoardRequest} renameBoardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameBoard(id: string, renameBoardRequest: RenameBoardRequest, options?: RawAxiosRequestConfig): AxiosPromise<RenameBoardResponse> {
            return localVarFp.renameBoard(id, renameBoardRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BoardControllerApi - interface
 * @export
 * @interface BoardControllerApi
 */
export interface BoardControllerApiInterface {
    /**
     * Associate Product with Boards
     * @param {AssociateProductWithBoardsRequest} associateProductWithBoardsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoardControllerApiInterface
     */
    associateProductWithBoards(associateProductWithBoardsRequest: AssociateProductWithBoardsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Create board
     * @param {CreateBoardRequest} createBoardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoardControllerApiInterface
     */
    createBoard(createBoardRequest: CreateBoardRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateBoardResponse>;

    /**
     * Delete board
     * @param {string} id Board Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoardControllerApiInterface
     */
    deleteBoard(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Export board to CSV file
     * @param {string} id Board Id
     * @param {string} order Order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoardControllerApiInterface
     */
    exportBoardToCsv(id: string, order: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * Get board details
     * @param {string} id Board Id
     * @param {string} order Order
     * @param {string} [search] Search
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoardControllerApiInterface
     */
    getBoardById(id: string, order: string, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetBoardDetailsResponse>;

    /**
     * Get retailer all boards details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoardControllerApiInterface
     */
    getRetailerBoards(options?: RawAxiosRequestConfig): AxiosPromise<GetAllRetailerBoardsDetailsResponse>;

    /**
     * Get retailer boards details
     * @param {string} productId Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoardControllerApiInterface
     */
    getRetailerBoards1(productId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetRetailerBoardsResponse>;

    /**
     * Update board name
     * @param {string} id Board Id
     * @param {RenameBoardRequest} renameBoardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoardControllerApiInterface
     */
    renameBoard(id: string, renameBoardRequest: RenameBoardRequest, options?: RawAxiosRequestConfig): AxiosPromise<RenameBoardResponse>;

}

/**
 * BoardControllerApi - object-oriented interface
 * @export
 * @class BoardControllerApi
 * @extends {BaseAPI}
 */
export class BoardControllerApi extends BaseAPI implements BoardControllerApiInterface {
    /**
     * Associate Product with Boards
     * @param {AssociateProductWithBoardsRequest} associateProductWithBoardsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoardControllerApi
     */
    public associateProductWithBoards(associateProductWithBoardsRequest: AssociateProductWithBoardsRequest, options?: RawAxiosRequestConfig) {
        return BoardControllerApiFp(this.configuration).associateProductWithBoards(associateProductWithBoardsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create board
     * @param {CreateBoardRequest} createBoardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoardControllerApi
     */
    public createBoard(createBoardRequest: CreateBoardRequest, options?: RawAxiosRequestConfig) {
        return BoardControllerApiFp(this.configuration).createBoard(createBoardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete board
     * @param {string} id Board Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoardControllerApi
     */
    public deleteBoard(id: string, options?: RawAxiosRequestConfig) {
        return BoardControllerApiFp(this.configuration).deleteBoard(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export board to CSV file
     * @param {string} id Board Id
     * @param {string} order Order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoardControllerApi
     */
    public exportBoardToCsv(id: string, order: string, options?: RawAxiosRequestConfig) {
        return BoardControllerApiFp(this.configuration).exportBoardToCsv(id, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get board details
     * @param {string} id Board Id
     * @param {string} order Order
     * @param {string} [search] Search
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoardControllerApi
     */
    public getBoardById(id: string, order: string, search?: string, options?: RawAxiosRequestConfig) {
        return BoardControllerApiFp(this.configuration).getBoardById(id, order, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get retailer all boards details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoardControllerApi
     */
    public getRetailerBoards(options?: RawAxiosRequestConfig) {
        return BoardControllerApiFp(this.configuration).getRetailerBoards(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get retailer boards details
     * @param {string} productId Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoardControllerApi
     */
    public getRetailerBoards1(productId: string, options?: RawAxiosRequestConfig) {
        return BoardControllerApiFp(this.configuration).getRetailerBoards1(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update board name
     * @param {string} id Board Id
     * @param {RenameBoardRequest} renameBoardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoardControllerApi
     */
    public renameBoard(id: string, renameBoardRequest: RenameBoardRequest, options?: RawAxiosRequestConfig) {
        return BoardControllerApiFp(this.configuration).renameBoard(id, renameBoardRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BrandBoardControllerApi - axios parameter creator
 * @export
 */
export const BrandBoardControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add product to Brand Board
         * @param {string} boardId Brand Board Id
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProductToBrandBoard: async (boardId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('addProductToBrandBoard', 'boardId', boardId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addProductToBrandBoard', 'id', id)
            const localVarPath = `/brand-boards/boards/{boardId}/products/{id}/add`
                .replace(`{${"boardId"}}`, encodeURIComponent(String(boardId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add products to Brand Boards
         * @param {string} id Product Id
         * @param {AddProductToBrandBoardsRequest} addProductToBrandBoardsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProductToBrandBoards: async (id: string, addProductToBrandBoardsRequest: AddProductToBrandBoardsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addProductToBrandBoards', 'id', id)
            // verify required parameter 'addProductToBrandBoardsRequest' is not null or undefined
            assertParamExists('addProductToBrandBoards', 'addProductToBrandBoardsRequest', addProductToBrandBoardsRequest)
            const localVarPath = `/brand-boards/products/{id}/add`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addProductToBrandBoardsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Brand Board
         * @param {string} brandId Brand Id
         * @param {CreateBrandBoardRequest} createBrandBoardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrandBoard: async (brandId: string, createBrandBoardRequest: CreateBrandBoardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('createBrandBoard', 'brandId', brandId)
            // verify required parameter 'createBrandBoardRequest' is not null or undefined
            assertParamExists('createBrandBoard', 'createBrandBoardRequest', createBrandBoardRequest)
            const localVarPath = `/brand-boards/brands/{brandId}/boards`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBrandBoardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete Brand Board
         * @param {string} id Brand Board Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrandBoard: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteBrandBoard', 'id', id)
            const localVarPath = `/brand-boards/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove Product from Brand Board
         * @param {string} id Brand Board Id
         * @param {string} productId Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrandBoard1: async (id: string, productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteBrandBoard1', 'id', id)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('deleteBrandBoard1', 'productId', productId)
            const localVarPath = `/brand-boards/{id}/product/{productId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Brand Board details
         * @param {string} id Brand Board Id
         * @param {string} order Order
         * @param {string} [search] Search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandBoardById: async (id: string, order: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBrandBoardById', 'id', id)
            // verify required parameter 'order' is not null or undefined
            assertParamExists('getBrandBoardById', 'order', order)
            const localVarPath = `/brand-boards/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Brand Board Shares by Brand Id
         * @param {string} brandId Brand Id
         * @param {string} boardId Brand Board Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandBoardSharesByBrandId: async (brandId: string, boardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getBrandBoardSharesByBrandId', 'brandId', brandId)
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('getBrandBoardSharesByBrandId', 'boardId', boardId)
            const localVarPath = `/brand-boards/brands/{brandId}/boards/{boardId}/shared-with`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"boardId"}}`, encodeURIComponent(String(boardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Brand Boards details
         * @param {string} brandId Brand Id
         * @param {number} page Page
         * @param {number} size Size
         * @param {string} sortBy Sort By
         * @param {string} sortOrder Sort Order
         * @param {string} [search] Search
         * @param {string} [productId] Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandBoards: async (brandId: string, page: number, size: number, sortBy: string, sortOrder: string, search?: string, productId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getBrandBoards', 'brandId', brandId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getBrandBoards', 'page', page)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('getBrandBoards', 'size', size)
            // verify required parameter 'sortBy' is not null or undefined
            assertParamExists('getBrandBoards', 'sortBy', sortBy)
            // verify required parameter 'sortOrder' is not null or undefined
            assertParamExists('getBrandBoards', 'sortOrder', sortOrder)
            const localVarPath = `/brand-boards/brands/{brandId}/boards`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Share Brand Board
         * @param {string} id Brand Board Id
         * @param {ShareBrandBoardRequest} shareBrandBoardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareBrandBoard: async (id: string, shareBrandBoardRequest: ShareBrandBoardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('shareBrandBoard', 'id', id)
            // verify required parameter 'shareBrandBoardRequest' is not null or undefined
            assertParamExists('shareBrandBoard', 'shareBrandBoardRequest', shareBrandBoardRequest)
            const localVarPath = `/brand-boards/{id}/share`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shareBrandBoardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Brand Board
         * @param {string} id Brand Board Id
         * @param {UpdateBrandBoardRequest} updateBrandBoardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrandBoard: async (id: string, updateBrandBoardRequest: UpdateBrandBoardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateBrandBoard', 'id', id)
            // verify required parameter 'updateBrandBoardRequest' is not null or undefined
            assertParamExists('updateBrandBoard', 'updateBrandBoardRequest', updateBrandBoardRequest)
            const localVarPath = `/brand-boards/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBrandBoardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BrandBoardControllerApi - functional programming interface
 * @export
 */
export const BrandBoardControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BrandBoardControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add product to Brand Board
         * @param {string} boardId Brand Board Id
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addProductToBrandBoard(boardId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addProductToBrandBoard(boardId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandBoardControllerApi.addProductToBrandBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add products to Brand Boards
         * @param {string} id Product Id
         * @param {AddProductToBrandBoardsRequest} addProductToBrandBoardsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addProductToBrandBoards(id: string, addProductToBrandBoardsRequest: AddProductToBrandBoardsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addProductToBrandBoards(id, addProductToBrandBoardsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandBoardControllerApi.addProductToBrandBoards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Brand Board
         * @param {string} brandId Brand Id
         * @param {CreateBrandBoardRequest} createBrandBoardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBrandBoard(brandId: string, createBrandBoardRequest: CreateBrandBoardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBrandBoard(brandId, createBrandBoardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandBoardControllerApi.createBrandBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete Brand Board
         * @param {string} id Brand Board Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBrandBoard(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBrandBoard(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandBoardControllerApi.deleteBrandBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove Product from Brand Board
         * @param {string} id Brand Board Id
         * @param {string} productId Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBrandBoard1(id: string, productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBrandBoard1(id, productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandBoardControllerApi.deleteBrandBoard1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Brand Board details
         * @param {string} id Brand Board Id
         * @param {string} order Order
         * @param {string} [search] Search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandBoardById(id: string, order: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBrandBoardDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandBoardById(id, order, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandBoardControllerApi.getBrandBoardById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Brand Board Shares by Brand Id
         * @param {string} brandId Brand Id
         * @param {string} boardId Brand Board Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandBoardSharesByBrandId(brandId: string, boardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBrandBoardSharesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandBoardSharesByBrandId(brandId, boardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandBoardControllerApi.getBrandBoardSharesByBrandId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Brand Boards details
         * @param {string} brandId Brand Id
         * @param {number} page Page
         * @param {number} size Size
         * @param {string} sortBy Sort By
         * @param {string} sortOrder Sort Order
         * @param {string} [search] Search
         * @param {string} [productId] Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandBoards(brandId: string, page: number, size: number, sortBy: string, sortOrder: string, search?: string, productId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBrandBoardsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandBoards(brandId, page, size, sortBy, sortOrder, search, productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandBoardControllerApi.getBrandBoards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Share Brand Board
         * @param {string} id Brand Board Id
         * @param {ShareBrandBoardRequest} shareBrandBoardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shareBrandBoard(id: string, shareBrandBoardRequest: ShareBrandBoardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shareBrandBoard(id, shareBrandBoardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandBoardControllerApi.shareBrandBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update Brand Board
         * @param {string} id Brand Board Id
         * @param {UpdateBrandBoardRequest} updateBrandBoardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBrandBoard(id: string, updateBrandBoardRequest: UpdateBrandBoardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBrandBoard(id, updateBrandBoardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandBoardControllerApi.updateBrandBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BrandBoardControllerApi - factory interface
 * @export
 */
export const BrandBoardControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BrandBoardControllerApiFp(configuration)
    return {
        /**
         * Add product to Brand Board
         * @param {string} boardId Brand Board Id
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProductToBrandBoard(boardId: string, id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addProductToBrandBoard(boardId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Add products to Brand Boards
         * @param {string} id Product Id
         * @param {AddProductToBrandBoardsRequest} addProductToBrandBoardsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProductToBrandBoards(id: string, addProductToBrandBoardsRequest: AddProductToBrandBoardsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addProductToBrandBoards(id, addProductToBrandBoardsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Brand Board
         * @param {string} brandId Brand Id
         * @param {CreateBrandBoardRequest} createBrandBoardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrandBoard(brandId: string, createBrandBoardRequest: CreateBrandBoardRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper> {
            return localVarFp.createBrandBoard(brandId, createBrandBoardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete Brand Board
         * @param {string} id Brand Board Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrandBoard(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteBrandBoard(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove Product from Brand Board
         * @param {string} id Brand Board Id
         * @param {string} productId Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrandBoard1(id: string, productId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteBrandBoard1(id, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Brand Board details
         * @param {string} id Brand Board Id
         * @param {string} order Order
         * @param {string} [search] Search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandBoardById(id: string, order: string, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetBrandBoardDetailsResponse> {
            return localVarFp.getBrandBoardById(id, order, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Brand Board Shares by Brand Id
         * @param {string} brandId Brand Id
         * @param {string} boardId Brand Board Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandBoardSharesByBrandId(brandId: string, boardId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetBrandBoardSharesResponse> {
            return localVarFp.getBrandBoardSharesByBrandId(brandId, boardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Brand Boards details
         * @param {string} brandId Brand Id
         * @param {number} page Page
         * @param {number} size Size
         * @param {string} sortBy Sort By
         * @param {string} sortOrder Sort Order
         * @param {string} [search] Search
         * @param {string} [productId] Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandBoards(brandId: string, page: number, size: number, sortBy: string, sortOrder: string, search?: string, productId?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetBrandBoardsResponse> {
            return localVarFp.getBrandBoards(brandId, page, size, sortBy, sortOrder, search, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Share Brand Board
         * @param {string} id Brand Board Id
         * @param {ShareBrandBoardRequest} shareBrandBoardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareBrandBoard(id: string, shareBrandBoardRequest: ShareBrandBoardRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.shareBrandBoard(id, shareBrandBoardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update Brand Board
         * @param {string} id Brand Board Id
         * @param {UpdateBrandBoardRequest} updateBrandBoardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrandBoard(id: string, updateBrandBoardRequest: UpdateBrandBoardRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateBrandBoard(id, updateBrandBoardRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BrandBoardControllerApi - interface
 * @export
 * @interface BrandBoardControllerApi
 */
export interface BrandBoardControllerApiInterface {
    /**
     * Add product to Brand Board
     * @param {string} boardId Brand Board Id
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandBoardControllerApiInterface
     */
    addProductToBrandBoard(boardId: string, id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Add products to Brand Boards
     * @param {string} id Product Id
     * @param {AddProductToBrandBoardsRequest} addProductToBrandBoardsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandBoardControllerApiInterface
     */
    addProductToBrandBoards(id: string, addProductToBrandBoardsRequest: AddProductToBrandBoardsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Create Brand Board
     * @param {string} brandId Brand Id
     * @param {CreateBrandBoardRequest} createBrandBoardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandBoardControllerApiInterface
     */
    createBrandBoard(brandId: string, createBrandBoardRequest: CreateBrandBoardRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper>;

    /**
     * Delete Brand Board
     * @param {string} id Brand Board Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandBoardControllerApiInterface
     */
    deleteBrandBoard(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Remove Product from Brand Board
     * @param {string} id Brand Board Id
     * @param {string} productId Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandBoardControllerApiInterface
     */
    deleteBrandBoard1(id: string, productId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Get Brand Board details
     * @param {string} id Brand Board Id
     * @param {string} order Order
     * @param {string} [search] Search
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandBoardControllerApiInterface
     */
    getBrandBoardById(id: string, order: string, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetBrandBoardDetailsResponse>;

    /**
     * Get Brand Board Shares by Brand Id
     * @param {string} brandId Brand Id
     * @param {string} boardId Brand Board Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandBoardControllerApiInterface
     */
    getBrandBoardSharesByBrandId(brandId: string, boardId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetBrandBoardSharesResponse>;

    /**
     * Get Brand Boards details
     * @param {string} brandId Brand Id
     * @param {number} page Page
     * @param {number} size Size
     * @param {string} sortBy Sort By
     * @param {string} sortOrder Sort Order
     * @param {string} [search] Search
     * @param {string} [productId] Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandBoardControllerApiInterface
     */
    getBrandBoards(brandId: string, page: number, size: number, sortBy: string, sortOrder: string, search?: string, productId?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetBrandBoardsResponse>;

    /**
     * Share Brand Board
     * @param {string} id Brand Board Id
     * @param {ShareBrandBoardRequest} shareBrandBoardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandBoardControllerApiInterface
     */
    shareBrandBoard(id: string, shareBrandBoardRequest: ShareBrandBoardRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update Brand Board
     * @param {string} id Brand Board Id
     * @param {UpdateBrandBoardRequest} updateBrandBoardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandBoardControllerApiInterface
     */
    updateBrandBoard(id: string, updateBrandBoardRequest: UpdateBrandBoardRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * BrandBoardControllerApi - object-oriented interface
 * @export
 * @class BrandBoardControllerApi
 * @extends {BaseAPI}
 */
export class BrandBoardControllerApi extends BaseAPI implements BrandBoardControllerApiInterface {
    /**
     * Add product to Brand Board
     * @param {string} boardId Brand Board Id
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandBoardControllerApi
     */
    public addProductToBrandBoard(boardId: string, id: string, options?: RawAxiosRequestConfig) {
        return BrandBoardControllerApiFp(this.configuration).addProductToBrandBoard(boardId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add products to Brand Boards
     * @param {string} id Product Id
     * @param {AddProductToBrandBoardsRequest} addProductToBrandBoardsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandBoardControllerApi
     */
    public addProductToBrandBoards(id: string, addProductToBrandBoardsRequest: AddProductToBrandBoardsRequest, options?: RawAxiosRequestConfig) {
        return BrandBoardControllerApiFp(this.configuration).addProductToBrandBoards(id, addProductToBrandBoardsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Brand Board
     * @param {string} brandId Brand Id
     * @param {CreateBrandBoardRequest} createBrandBoardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandBoardControllerApi
     */
    public createBrandBoard(brandId: string, createBrandBoardRequest: CreateBrandBoardRequest, options?: RawAxiosRequestConfig) {
        return BrandBoardControllerApiFp(this.configuration).createBrandBoard(brandId, createBrandBoardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete Brand Board
     * @param {string} id Brand Board Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandBoardControllerApi
     */
    public deleteBrandBoard(id: string, options?: RawAxiosRequestConfig) {
        return BrandBoardControllerApiFp(this.configuration).deleteBrandBoard(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove Product from Brand Board
     * @param {string} id Brand Board Id
     * @param {string} productId Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandBoardControllerApi
     */
    public deleteBrandBoard1(id: string, productId: string, options?: RawAxiosRequestConfig) {
        return BrandBoardControllerApiFp(this.configuration).deleteBrandBoard1(id, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Brand Board details
     * @param {string} id Brand Board Id
     * @param {string} order Order
     * @param {string} [search] Search
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandBoardControllerApi
     */
    public getBrandBoardById(id: string, order: string, search?: string, options?: RawAxiosRequestConfig) {
        return BrandBoardControllerApiFp(this.configuration).getBrandBoardById(id, order, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Brand Board Shares by Brand Id
     * @param {string} brandId Brand Id
     * @param {string} boardId Brand Board Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandBoardControllerApi
     */
    public getBrandBoardSharesByBrandId(brandId: string, boardId: string, options?: RawAxiosRequestConfig) {
        return BrandBoardControllerApiFp(this.configuration).getBrandBoardSharesByBrandId(brandId, boardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Brand Boards details
     * @param {string} brandId Brand Id
     * @param {number} page Page
     * @param {number} size Size
     * @param {string} sortBy Sort By
     * @param {string} sortOrder Sort Order
     * @param {string} [search] Search
     * @param {string} [productId] Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandBoardControllerApi
     */
    public getBrandBoards(brandId: string, page: number, size: number, sortBy: string, sortOrder: string, search?: string, productId?: string, options?: RawAxiosRequestConfig) {
        return BrandBoardControllerApiFp(this.configuration).getBrandBoards(brandId, page, size, sortBy, sortOrder, search, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Share Brand Board
     * @param {string} id Brand Board Id
     * @param {ShareBrandBoardRequest} shareBrandBoardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandBoardControllerApi
     */
    public shareBrandBoard(id: string, shareBrandBoardRequest: ShareBrandBoardRequest, options?: RawAxiosRequestConfig) {
        return BrandBoardControllerApiFp(this.configuration).shareBrandBoard(id, shareBrandBoardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Brand Board
     * @param {string} id Brand Board Id
     * @param {UpdateBrandBoardRequest} updateBrandBoardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandBoardControllerApi
     */
    public updateBrandBoard(id: string, updateBrandBoardRequest: UpdateBrandBoardRequest, options?: RawAxiosRequestConfig) {
        return BrandBoardControllerApiFp(this.configuration).updateBrandBoard(id, updateBrandBoardRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BrandControllerApi - axios parameter creator
 * @export
 */
export const BrandControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Apply to Sell
         * @param {ApplyToSellRequest} applyToSellRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyToSell: async (applyToSellRequest: ApplyToSellRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applyToSellRequest' is not null or undefined
            assertParamExists('applyToSell', 'applyToSellRequest', applyToSellRequest)
            const localVarPath = `/brands/apply-to-sell`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applyToSellRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Approve brand
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('approve', 'id', id)
            const localVarPath = `/brands/{id}/approve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns brand info by his vanity url name
         * @param {string} vanityUrlName Vanity url name to look for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brandBio: async (vanityUrlName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vanityUrlName' is not null or undefined
            assertParamExists('brandBio', 'vanityUrlName', vanityUrlName)
            const localVarPath = `/brands/brand-bio/{vanityUrlName}`
                .replace(`{${"vanityUrlName"}}`, encodeURIComponent(String(vanityUrlName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return whether a product import from Shopify is currently in progress
         * @param {string} brandId Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfShopifyImportIsInProgress: async (brandId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('checkIfShopifyImportIsInProgress', 'brandId', brandId)
            const localVarPath = `/brands/{brandId}/shopify-import-in-progress`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return whether a product import from Shopify is currently in progress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfShopifyImportIsInProgress1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands/me/shopify-import-in-progress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create brand
         * @param {CreateBrandRequest} createBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrand: async (createBrandRequest: CreateBrandRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBrandRequest' is not null or undefined
            assertParamExists('createBrand', 'createBrandRequest', createBrandRequest)
            const localVarPath = `/brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBrandRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create outreach brand
         * @param {CreateOutreachBrandRequest} createOutreachBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOutreachBrand: async (createOutreachBrandRequest: CreateOutreachBrandRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOutreachBrandRequest' is not null or undefined
            assertParamExists('createOutreachBrand', 'createOutreachBrandRequest', createOutreachBrandRequest)
            const localVarPath = `/brands/outreach`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOutreachBrandRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create brand profile in routable
         * @param {string} brandId brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoutable: async (brandId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('createRoutable', 'brandId', brandId)
            const localVarPath = `/brands/{brandId}/create-routable-profile`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete Brand
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrand: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteBrand', 'id', id)
            const localVarPath = `/brands/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deny brand
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        denyBrandApplicant: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('denyBrandApplicant', 'id', id)
            const localVarPath = `/brands/{id}/deny`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return published”/visible brands of any source up to the 4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exploreMoreBrands: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands/explore-more`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Favoritize brand
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoritizeBrand: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('favoritizeBrand', 'id', id)
            const localVarPath = `/brands/{id}/favoritize`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate routable to csv
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateRoutableCSV: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands/generate-routable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateVanityUrlNames: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands/generate-vanity-url-names`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get brand by Id
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrand: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBrand', 'id', id)
            const localVarPath = `/brands/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get brand\'s active promo codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandActivePromoCodes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands/promo-codes/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find brand by referral code
         * @param {string} referralCode Referral code
         * @param {string} referralId Referral Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandByReferralCode: async (referralCode: string, referralId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'referralCode' is not null or undefined
            assertParamExists('getBrandByReferralCode', 'referralCode', referralCode)
            // verify required parameter 'referralId' is not null or undefined
            assertParamExists('getBrandByReferralCode', 'referralId', referralId)
            const localVarPath = `/brands/brand-referral`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (referralCode !== undefined) {
                localVarQueryParameter['referralCode'] = referralCode;
            }

            if (referralId !== undefined) {
                localVarQueryParameter['referralId'] = referralId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get brand\'s categories
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandCategories: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBrandCategories', 'id', id)
            const localVarPath = `/brands/{id}/categories`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get brand details
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandDetails: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBrandDetails', 'id', id)
            const localVarPath = `/brands/{id}/details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all brand values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandValues: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands/values/dropdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find all Brand applicants per multiple/custom criteria
         * @param {string} [searchBy] Search by
         * @param {string} [source] Source
         * @param {string} [status] Status
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandsApplications: async (searchBy?: string, source?: string, status?: string, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands/applications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchBy !== undefined) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find all Brand directory per multiple/custom criteria
         * @param {string} [searchBy] Search by
         * @param {string} [source] Source
         * @param {boolean} [bulletinPick] Bulletin pick
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandsDirectory: async (searchBy?: string, source?: string, bulletinPick?: boolean, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands/directory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchBy !== undefined) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (bulletinPick !== undefined) {
                localVarQueryParameter['bulletinPick'] = bulletinPick;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get brands for dropdown
         * @param {string} [ifNoneMatch] Is published flag if needed to filter brands
         * @param {boolean} [isPublished] 
         * @param {boolean} [excludeShopify] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandsDropdown: async (ifNoneMatch?: string, isPublished?: boolean, excludeShopify?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands/dropdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isPublished !== undefined) {
                localVarQueryParameter['is_published'] = isPublished;
            }

            if (excludeShopify !== undefined) {
                localVarQueryParameter['exclude_shopify'] = excludeShopify;
            }


    
            if (ifNoneMatch != null) {
                localVarHeaderParameter['If-None-Match'] = String(ifNoneMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get brands from component for dropdown
         * @param {string} componentId Component Id from which needed to get brands for dropdown
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandsFromComponentForDropdown: async (componentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('getBrandsFromComponentForDropdown', 'componentId', componentId)
            const localVarPath = `/brands/component/{componentId}/dropdown`
                .replace(`{${"componentId"}}`, encodeURIComponent(String(componentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get brands from container for dropdown
         * @param {string} containerId Container Id from which needed to get brands for dropdown
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandsFromContainerForDropdown: async (containerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'containerId' is not null or undefined
            assertParamExists('getBrandsFromContainerForDropdown', 'containerId', containerId)
            const localVarPath = `/brands/container/{containerId}/dropdown`
                .replace(`{${"containerId"}}`, encodeURIComponent(String(containerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a true/false response indicating whether the frontend should display the Marketplace Visibility toggle.
         * @param {string} brandId Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanBrandChangeMarketplaceVisibility: async (brandId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getCanBrandChangeMarketplaceVisibility', 'brandId', brandId)
            const localVarPath = `/brands/{brandId}/enable_marketplace_visibility`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all brand deals and promotions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDealsAndPromotions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands/deals-and-promotions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find retailer favorite brands
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteBrands: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands/favorite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find retailer\'s last five favorite brands
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredFavoriteBrands: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands/favorite-brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find brand by user Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyId1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands/my-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get number of favorite brands
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumberOfFavoriteBrands: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands/number-of-favorite-brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get public brand
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicBrand: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPublicBrand', 'id', id)
            const localVarPath = `/brands/{id}/public`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all retailers related to the brand
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailersDropdown1: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRetailersDropdown1', 'id', id)
            const localVarPath = `/brands/{id}/retailers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get active retailers stockists for the brand
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailersStockists: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRetailersStockists', 'id', id)
            const localVarPath = `/brands/{id}/stockists`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of possible values for special services
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecialServicesValues: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands/special-services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Merge EXHIBITOR Brand into existing Brand
         * @param {MergeExhibitorBrandRequest} mergeExhibitorBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeExhibitorBrand: async (mergeExhibitorBrandRequest: MergeExhibitorBrandRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mergeExhibitorBrandRequest' is not null or undefined
            assertParamExists('mergeExhibitorBrand', 'mergeExhibitorBrandRequest', mergeExhibitorBrandRequest)
            const localVarPath = `/brands/merge-exhibitor-brand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mergeExhibitorBrandRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resends verification email to given brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendVerificationMail1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands/resend-verification-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resend appropriate welcome email to a brand, depending on the brand source and state.
         * @param {string} id brand Id
         * @param {ResendBrandWelcomeEmailRequest} resendBrandWelcomeEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendWelcomeEmail: async (id: string, resendBrandWelcomeEmailRequest: ResendBrandWelcomeEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resendWelcomeEmail', 'id', id)
            // verify required parameter 'resendBrandWelcomeEmailRequest' is not null or undefined
            assertParamExists('resendWelcomeEmail', 'resendBrandWelcomeEmailRequest', resendBrandWelcomeEmailRequest)
            const localVarPath = `/brands/{id}/resend-welcome-email`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendBrandWelcomeEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit outbound onboarding form
         * @param {SubmitOutboundOnboardingFormRequest} submitOutboundOnboardingFormRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitOutboundOnboardingForm: async (submitOutboundOnboardingFormRequest: SubmitOutboundOnboardingFormRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submitOutboundOnboardingFormRequest' is not null or undefined
            assertParamExists('submitOutboundOnboardingForm', 'submitOutboundOnboardingFormRequest', submitOutboundOnboardingFormRequest)
            const localVarPath = `/brands/outbound-onboarding-form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitOutboundOnboardingFormRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Toggle brands bulletin pick flag
         * @param {ToggleBrandsBulletinPickRequest} toggleBrandsBulletinPickRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleBrandsBulletinPick: async (toggleBrandsBulletinPickRequest: ToggleBrandsBulletinPickRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toggleBrandsBulletinPickRequest' is not null or undefined
            assertParamExists('toggleBrandsBulletinPick', 'toggleBrandsBulletinPickRequest', toggleBrandsBulletinPickRequest)
            const localVarPath = `/brands/toggle-bulletin-pick`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleBrandsBulletinPickRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Toggle brand bulletin pick flag
         * @param {string} brandId Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleBulletinPick: async (brandId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('toggleBulletinPick', 'brandId', brandId)
            const localVarPath = `/brands/{brandId}/toggle-bulletin-pick`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Toggle brand buy on bulletin flag
         * @param {string} brandId Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleBuyOnBulletin: async (brandId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('toggleBuyOnBulletin', 'brandId', brandId)
            const localVarPath = `/brands/{brandId}/toggle-buy-on-bulletin`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update brand
         * @param {string} id Brand Id
         * @param {UpdateBrandRequest} updateBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrand: async (id: string, updateBrandRequest: UpdateBrandRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateBrand', 'id', id)
            // verify required parameter 'updateBrandRequest' is not null or undefined
            assertParamExists('updateBrand', 'updateBrandRequest', updateBrandRequest)
            const localVarPath = `/brands/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBrandRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update brand by user Id
         * @param {UpdateBrandRequest} updateBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMe: async (updateBrandRequest: UpdateBrandRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateBrandRequest' is not null or undefined
            assertParamExists('updateMe', 'updateBrandRequest', updateBrandRequest)
            const localVarPath = `/brands/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBrandRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload Brand Bio image
         * @param {string} id Brand Id
         * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadBrandBioImage: async (id: string, uploadComponentImageRequest?: UploadComponentImageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadBrandBioImage', 'id', id)
            const localVarPath = `/brands/{id}/image`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadComponentImageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload user Brand Bio image
         * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMyBrandBioImage: async (uploadComponentImageRequest?: UploadComponentImageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands/my-image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadComponentImageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload user thumbnail image
         * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMyThumbnailImage: async (uploadComponentImageRequest?: UploadComponentImageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands/my-thumbnail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadComponentImageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload thumbnail image
         * @param {string} id Brand Id
         * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadThumbnailImage: async (id: string, uploadComponentImageRequest?: UploadComponentImageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadThumbnailImage', 'id', id)
            const localVarPath = `/brands/{id}/thumbnail`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadComponentImageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return whether the reset password token is valid for the brand.
         * @param {string} brandId Brand id
         * @param {string} token Reset password token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateResetPasswordToken: async (brandId: string, token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('validateResetPasswordToken', 'brandId', brandId)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('validateResetPasswordToken', 'token', token)
            const localVarPath = `/brands/{brandId}/validate-reset-token`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BrandControllerApi - functional programming interface
 * @export
 */
export const BrandControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BrandControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Apply to Sell
         * @param {ApplyToSellRequest} applyToSellRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyToSell(applyToSellRequest: ApplyToSellRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplyToSellResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyToSell(applyToSellRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.applyToSell']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Approve brand
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.approve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns brand info by his vanity url name
         * @param {string} vanityUrlName Vanity url name to look for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brandBio(vanityUrlName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicBrandResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.brandBio(vanityUrlName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.brandBio']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return whether a product import from Shopify is currently in progress
         * @param {string} brandId Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkIfShopifyImportIsInProgress(brandId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckIfShopifyImportIsInProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkIfShopifyImportIsInProgress(brandId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.checkIfShopifyImportIsInProgress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return whether a product import from Shopify is currently in progress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkIfShopifyImportIsInProgress1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckIfShopifyImportIsInProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkIfShopifyImportIsInProgress1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.checkIfShopifyImportIsInProgress1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create brand
         * @param {CreateBrandRequest} createBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBrand(createBrandRequest: CreateBrandRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBrand(createBrandRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.createBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create outreach brand
         * @param {CreateOutreachBrandRequest} createOutreachBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOutreachBrand(createOutreachBrandRequest: CreateOutreachBrandRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOutreachBrand(createOutreachBrandRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.createOutreachBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create brand profile in routable
         * @param {string} brandId brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRoutable(brandId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRoutable(brandId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.createRoutable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete Brand
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBrand(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBrand(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.deleteBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deny brand
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async denyBrandApplicant(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.denyBrandApplicant(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.denyBrandApplicant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return published”/visible brands of any source up to the 4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exploreMoreBrands(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExploreMoreBrandsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exploreMoreBrands(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.exploreMoreBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Favoritize brand
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async favoritizeBrand(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.favoritizeBrand(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.favoritizeBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate routable to csv
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateRoutableCSV(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateRoutableCSV(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.generateRoutableCSV']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateVanityUrlNames(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateVanityUrlNames(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.generateVanityUrlNames']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get brand by Id
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrand(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBrandResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrand(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.getBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get brand\'s active promo codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandActivePromoCodes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandActivePromoCodesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandActivePromoCodes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.getBrandActivePromoCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find brand by referral code
         * @param {string} referralCode Referral code
         * @param {string} referralId Referral Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandByReferralCode(referralCode: string, referralId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandReferralResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandByReferralCode(referralCode, referralId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.getBrandByReferralCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get brand\'s categories
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandCategories(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandCategoriesForDropdownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandCategories(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.getBrandCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get brand details
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandDetails(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBrandDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.getBrandDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all brand values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandValues(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DropdownItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandValues(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.getBrandValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find all Brand applicants per multiple/custom criteria
         * @param {string} [searchBy] Search by
         * @param {string} [source] Source
         * @param {string} [status] Status
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandsApplications(searchBy?: string, source?: string, status?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedBrandsApplicationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandsApplications(searchBy, source, status, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.getBrandsApplications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find all Brand directory per multiple/custom criteria
         * @param {string} [searchBy] Search by
         * @param {string} [source] Source
         * @param {boolean} [bulletinPick] Bulletin pick
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandsDirectory(searchBy?: string, source?: string, bulletinPick?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedBrandsDirectoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandsDirectory(searchBy, source, bulletinPick, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.getBrandsDirectory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get brands for dropdown
         * @param {string} [ifNoneMatch] Is published flag if needed to filter brands
         * @param {boolean} [isPublished] 
         * @param {boolean} [excludeShopify] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandsDropdown(ifNoneMatch?: string, isPublished?: boolean, excludeShopify?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandsDropdown(ifNoneMatch, isPublished, excludeShopify, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.getBrandsDropdown']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get brands from component for dropdown
         * @param {string} componentId Component Id from which needed to get brands for dropdown
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandsFromComponentForDropdown(componentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandsDropdownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandsFromComponentForDropdown(componentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.getBrandsFromComponentForDropdown']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get brands from container for dropdown
         * @param {string} containerId Container Id from which needed to get brands for dropdown
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandsFromContainerForDropdown(containerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandsDropdownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandsFromContainerForDropdown(containerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.getBrandsFromContainerForDropdown']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a true/false response indicating whether the frontend should display the Marketplace Visibility toggle.
         * @param {string} brandId Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCanBrandChangeMarketplaceVisibility(brandId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCanBrandChangeMarketplaceVisibilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCanBrandChangeMarketplaceVisibility(brandId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.getCanBrandChangeMarketplaceVisibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all brand deals and promotions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDealsAndPromotions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DropdownItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDealsAndPromotions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.getDealsAndPromotions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find retailer favorite brands
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFavoriteBrands(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FavoriteBrandResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFavoriteBrands(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.getFavoriteBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find retailer\'s last five favorite brands
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilteredFavoriteBrands(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FavoriteBrandResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilteredFavoriteBrands(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.getFilteredFavoriteBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMe(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBrandResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMe(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.getMe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find brand by user Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyId1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyId1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.getMyId1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get number of favorite brands
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNumberOfFavoriteBrands(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FavoriteBrandCountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNumberOfFavoriteBrands(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.getNumberOfFavoriteBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get public brand
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicBrand(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicBrandResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicBrand(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.getPublicBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all retailers related to the brand
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRetailersDropdown1(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetailerDropdownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRetailersDropdown1(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.getRetailersDropdown1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get active retailers stockists for the brand
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRetailersStockists(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetStockistsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRetailersStockists(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.getRetailersStockists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a list of possible values for special services
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSpecialServicesValues(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DropdownItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSpecialServicesValues(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.getSpecialServicesValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Merge EXHIBITOR Brand into existing Brand
         * @param {MergeExhibitorBrandRequest} mergeExhibitorBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mergeExhibitorBrand(mergeExhibitorBrandRequest: MergeExhibitorBrandRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mergeExhibitorBrand(mergeExhibitorBrandRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.mergeExhibitorBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resends verification email to given brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendVerificationMail1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendVerificationMail1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.resendVerificationMail1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resend appropriate welcome email to a brand, depending on the brand source and state.
         * @param {string} id brand Id
         * @param {ResendBrandWelcomeEmailRequest} resendBrandWelcomeEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendWelcomeEmail(id: string, resendBrandWelcomeEmailRequest: ResendBrandWelcomeEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendWelcomeEmail(id, resendBrandWelcomeEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.resendWelcomeEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Submit outbound onboarding form
         * @param {SubmitOutboundOnboardingFormRequest} submitOutboundOnboardingFormRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitOutboundOnboardingForm(submitOutboundOnboardingFormRequest: SubmitOutboundOnboardingFormRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmitOutboundOnboardingFormResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitOutboundOnboardingForm(submitOutboundOnboardingFormRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.submitOutboundOnboardingForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Toggle brands bulletin pick flag
         * @param {ToggleBrandsBulletinPickRequest} toggleBrandsBulletinPickRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleBrandsBulletinPick(toggleBrandsBulletinPickRequest: ToggleBrandsBulletinPickRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleBrandsBulletinPick(toggleBrandsBulletinPickRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.toggleBrandsBulletinPick']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Toggle brand bulletin pick flag
         * @param {string} brandId Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleBulletinPick(brandId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleBulletinPick(brandId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.toggleBulletinPick']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Toggle brand buy on bulletin flag
         * @param {string} brandId Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleBuyOnBulletin(brandId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleBuyOnBulletin(brandId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.toggleBuyOnBulletin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update brand
         * @param {string} id Brand Id
         * @param {UpdateBrandRequest} updateBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBrand(id: string, updateBrandRequest: UpdateBrandRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBrand(id, updateBrandRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.updateBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update brand by user Id
         * @param {UpdateBrandRequest} updateBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMe(updateBrandRequest: UpdateBrandRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMe(updateBrandRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.updateMe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload Brand Bio image
         * @param {string} id Brand Id
         * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadBrandBioImage(id: string, uploadComponentImageRequest?: UploadComponentImageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadBrandBioImage(id, uploadComponentImageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.uploadBrandBioImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload user Brand Bio image
         * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadMyBrandBioImage(uploadComponentImageRequest?: UploadComponentImageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadMyBrandBioImage(uploadComponentImageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.uploadMyBrandBioImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload user thumbnail image
         * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadMyThumbnailImage(uploadComponentImageRequest?: UploadComponentImageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadMyThumbnailImage(uploadComponentImageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.uploadMyThumbnailImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload thumbnail image
         * @param {string} id Brand Id
         * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadThumbnailImage(id: string, uploadComponentImageRequest?: UploadComponentImageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadThumbnailImage(id, uploadComponentImageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.uploadThumbnailImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return whether the reset password token is valid for the brand.
         * @param {string} brandId Brand id
         * @param {string} token Reset password token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateResetPasswordToken(brandId: string, token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateResetPasswordTokenByBrandResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateResetPasswordToken(brandId, token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandControllerApi.validateResetPasswordToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BrandControllerApi - factory interface
 * @export
 */
export const BrandControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BrandControllerApiFp(configuration)
    return {
        /**
         * Apply to Sell
         * @param {ApplyToSellRequest} applyToSellRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyToSell(applyToSellRequest: ApplyToSellRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApplyToSellResponse> {
            return localVarFp.applyToSell(applyToSellRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Approve brand
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.approve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns brand info by his vanity url name
         * @param {string} vanityUrlName Vanity url name to look for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brandBio(vanityUrlName: string, options?: RawAxiosRequestConfig): AxiosPromise<PublicBrandResponse> {
            return localVarFp.brandBio(vanityUrlName, options).then((request) => request(axios, basePath));
        },
        /**
         * Return whether a product import from Shopify is currently in progress
         * @param {string} brandId Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfShopifyImportIsInProgress(brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<CheckIfShopifyImportIsInProgressResponse> {
            return localVarFp.checkIfShopifyImportIsInProgress(brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return whether a product import from Shopify is currently in progress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfShopifyImportIsInProgress1(options?: RawAxiosRequestConfig): AxiosPromise<CheckIfShopifyImportIsInProgressResponse> {
            return localVarFp.checkIfShopifyImportIsInProgress1(options).then((request) => request(axios, basePath));
        },
        /**
         * Create brand
         * @param {CreateBrandRequest} createBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrand(createBrandRequest: CreateBrandRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper> {
            return localVarFp.createBrand(createBrandRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create outreach brand
         * @param {CreateOutreachBrandRequest} createOutreachBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOutreachBrand(createOutreachBrandRequest: CreateOutreachBrandRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper> {
            return localVarFp.createOutreachBrand(createOutreachBrandRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create brand profile in routable
         * @param {string} brandId brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoutable(brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createRoutable(brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete Brand
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrand(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteBrand(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Deny brand
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        denyBrandApplicant(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.denyBrandApplicant(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Return published”/visible brands of any source up to the 4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exploreMoreBrands(options?: RawAxiosRequestConfig): AxiosPromise<ExploreMoreBrandsResponse> {
            return localVarFp.exploreMoreBrands(options).then((request) => request(axios, basePath));
        },
        /**
         * Favoritize brand
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoritizeBrand(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.favoritizeBrand(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate routable to csv
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateRoutableCSV(options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.generateRoutableCSV(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateVanityUrlNames(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.generateVanityUrlNames(options).then((request) => request(axios, basePath));
        },
        /**
         * Get brand by Id
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrand(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetBrandResponse> {
            return localVarFp.getBrand(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get brand\'s active promo codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandActivePromoCodes(options?: RawAxiosRequestConfig): AxiosPromise<BrandActivePromoCodesResponse> {
            return localVarFp.getBrandActivePromoCodes(options).then((request) => request(axios, basePath));
        },
        /**
         * Find brand by referral code
         * @param {string} referralCode Referral code
         * @param {string} referralId Referral Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandByReferralCode(referralCode: string, referralId: string, options?: RawAxiosRequestConfig): AxiosPromise<BrandReferralResponse> {
            return localVarFp.getBrandByReferralCode(referralCode, referralId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get brand\'s categories
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandCategories(id: string, options?: RawAxiosRequestConfig): AxiosPromise<BrandCategoriesForDropdownResponse> {
            return localVarFp.getBrandCategories(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get brand details
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandDetails(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetBrandDetailsResponse> {
            return localVarFp.getBrandDetails(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all brand values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandValues(options?: RawAxiosRequestConfig): AxiosPromise<Array<DropdownItem>> {
            return localVarFp.getBrandValues(options).then((request) => request(axios, basePath));
        },
        /**
         * Find all Brand applicants per multiple/custom criteria
         * @param {string} [searchBy] Search by
         * @param {string} [source] Source
         * @param {string} [status] Status
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandsApplications(searchBy?: string, source?: string, status?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedBrandsApplicationsResponse> {
            return localVarFp.getBrandsApplications(searchBy, source, status, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Find all Brand directory per multiple/custom criteria
         * @param {string} [searchBy] Search by
         * @param {string} [source] Source
         * @param {boolean} [bulletinPick] Bulletin pick
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandsDirectory(searchBy?: string, source?: string, bulletinPick?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedBrandsDirectoryResponse> {
            return localVarFp.getBrandsDirectory(searchBy, source, bulletinPick, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Get brands for dropdown
         * @param {string} [ifNoneMatch] Is published flag if needed to filter brands
         * @param {boolean} [isPublished] 
         * @param {boolean} [excludeShopify] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandsDropdown(ifNoneMatch?: string, isPublished?: boolean, excludeShopify?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getBrandsDropdown(ifNoneMatch, isPublished, excludeShopify, options).then((request) => request(axios, basePath));
        },
        /**
         * Get brands from component for dropdown
         * @param {string} componentId Component Id from which needed to get brands for dropdown
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandsFromComponentForDropdown(componentId: string, options?: RawAxiosRequestConfig): AxiosPromise<BrandsDropdownResponse> {
            return localVarFp.getBrandsFromComponentForDropdown(componentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get brands from container for dropdown
         * @param {string} containerId Container Id from which needed to get brands for dropdown
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandsFromContainerForDropdown(containerId: string, options?: RawAxiosRequestConfig): AxiosPromise<BrandsDropdownResponse> {
            return localVarFp.getBrandsFromContainerForDropdown(containerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a true/false response indicating whether the frontend should display the Marketplace Visibility toggle.
         * @param {string} brandId Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanBrandChangeMarketplaceVisibility(brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetCanBrandChangeMarketplaceVisibilityResponse> {
            return localVarFp.getCanBrandChangeMarketplaceVisibility(brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all brand deals and promotions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDealsAndPromotions(options?: RawAxiosRequestConfig): AxiosPromise<Array<DropdownItem>> {
            return localVarFp.getDealsAndPromotions(options).then((request) => request(axios, basePath));
        },
        /**
         * Find retailer favorite brands
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteBrands(options?: RawAxiosRequestConfig): AxiosPromise<FavoriteBrandResponse> {
            return localVarFp.getFavoriteBrands(options).then((request) => request(axios, basePath));
        },
        /**
         * Find retailer\'s last five favorite brands
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredFavoriteBrands(options?: RawAxiosRequestConfig): AxiosPromise<FavoriteBrandResponse> {
            return localVarFp.getFilteredFavoriteBrands(options).then((request) => request(axios, basePath));
        },
        /**
         * Get brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe(options?: RawAxiosRequestConfig): AxiosPromise<GetBrandResponse> {
            return localVarFp.getMe(options).then((request) => request(axios, basePath));
        },
        /**
         * Find brand by user Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyId1(options?: RawAxiosRequestConfig): AxiosPromise<BrandInfoResponse> {
            return localVarFp.getMyId1(options).then((request) => request(axios, basePath));
        },
        /**
         * Get number of favorite brands
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumberOfFavoriteBrands(options?: RawAxiosRequestConfig): AxiosPromise<FavoriteBrandCountResponse> {
            return localVarFp.getNumberOfFavoriteBrands(options).then((request) => request(axios, basePath));
        },
        /**
         * Get public brand
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicBrand(id: string, options?: RawAxiosRequestConfig): AxiosPromise<PublicBrandResponse> {
            return localVarFp.getPublicBrand(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all retailers related to the brand
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailersDropdown1(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RetailerDropdownResponse> {
            return localVarFp.getRetailersDropdown1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get active retailers stockists for the brand
         * @param {string} id Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailersStockists(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetStockistsResponse>> {
            return localVarFp.getRetailersStockists(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of possible values for special services
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecialServicesValues(options?: RawAxiosRequestConfig): AxiosPromise<Array<DropdownItem>> {
            return localVarFp.getSpecialServicesValues(options).then((request) => request(axios, basePath));
        },
        /**
         * Merge EXHIBITOR Brand into existing Brand
         * @param {MergeExhibitorBrandRequest} mergeExhibitorBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeExhibitorBrand(mergeExhibitorBrandRequest: MergeExhibitorBrandRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.mergeExhibitorBrand(mergeExhibitorBrandRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Resends verification email to given brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendVerificationMail1(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resendVerificationMail1(options).then((request) => request(axios, basePath));
        },
        /**
         * Resend appropriate welcome email to a brand, depending on the brand source and state.
         * @param {string} id brand Id
         * @param {ResendBrandWelcomeEmailRequest} resendBrandWelcomeEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendWelcomeEmail(id: string, resendBrandWelcomeEmailRequest: ResendBrandWelcomeEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resendWelcomeEmail(id, resendBrandWelcomeEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit outbound onboarding form
         * @param {SubmitOutboundOnboardingFormRequest} submitOutboundOnboardingFormRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitOutboundOnboardingForm(submitOutboundOnboardingFormRequest: SubmitOutboundOnboardingFormRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmitOutboundOnboardingFormResponse> {
            return localVarFp.submitOutboundOnboardingForm(submitOutboundOnboardingFormRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Toggle brands bulletin pick flag
         * @param {ToggleBrandsBulletinPickRequest} toggleBrandsBulletinPickRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleBrandsBulletinPick(toggleBrandsBulletinPickRequest: ToggleBrandsBulletinPickRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.toggleBrandsBulletinPick(toggleBrandsBulletinPickRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Toggle brand bulletin pick flag
         * @param {string} brandId Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleBulletinPick(brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.toggleBulletinPick(brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Toggle brand buy on bulletin flag
         * @param {string} brandId Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleBuyOnBulletin(brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.toggleBuyOnBulletin(brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update brand
         * @param {string} id Brand Id
         * @param {UpdateBrandRequest} updateBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrand(id: string, updateBrandRequest: UpdateBrandRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateBrand(id, updateBrandRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update brand by user Id
         * @param {UpdateBrandRequest} updateBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMe(updateBrandRequest: UpdateBrandRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMe(updateBrandRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload Brand Bio image
         * @param {string} id Brand Id
         * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadBrandBioImage(id: string, uploadComponentImageRequest?: UploadComponentImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.uploadBrandBioImage(id, uploadComponentImageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload user Brand Bio image
         * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMyBrandBioImage(uploadComponentImageRequest?: UploadComponentImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.uploadMyBrandBioImage(uploadComponentImageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload user thumbnail image
         * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMyThumbnailImage(uploadComponentImageRequest?: UploadComponentImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.uploadMyThumbnailImage(uploadComponentImageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload thumbnail image
         * @param {string} id Brand Id
         * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadThumbnailImage(id: string, uploadComponentImageRequest?: UploadComponentImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.uploadThumbnailImage(id, uploadComponentImageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Return whether the reset password token is valid for the brand.
         * @param {string} brandId Brand id
         * @param {string} token Reset password token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateResetPasswordToken(brandId: string, token: string, options?: RawAxiosRequestConfig): AxiosPromise<ValidateResetPasswordTokenByBrandResponse> {
            return localVarFp.validateResetPasswordToken(brandId, token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BrandControllerApi - interface
 * @export
 * @interface BrandControllerApi
 */
export interface BrandControllerApiInterface {
    /**
     * Apply to Sell
     * @param {ApplyToSellRequest} applyToSellRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    applyToSell(applyToSellRequest: ApplyToSellRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApplyToSellResponse>;

    /**
     * Approve brand
     * @param {string} id Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    approve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Returns brand info by his vanity url name
     * @param {string} vanityUrlName Vanity url name to look for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    brandBio(vanityUrlName: string, options?: RawAxiosRequestConfig): AxiosPromise<PublicBrandResponse>;

    /**
     * Return whether a product import from Shopify is currently in progress
     * @param {string} brandId Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    checkIfShopifyImportIsInProgress(brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<CheckIfShopifyImportIsInProgressResponse>;

    /**
     * Return whether a product import from Shopify is currently in progress
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    checkIfShopifyImportIsInProgress1(options?: RawAxiosRequestConfig): AxiosPromise<CheckIfShopifyImportIsInProgressResponse>;

    /**
     * Create brand
     * @param {CreateBrandRequest} createBrandRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    createBrand(createBrandRequest: CreateBrandRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper>;

    /**
     * Create outreach brand
     * @param {CreateOutreachBrandRequest} createOutreachBrandRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    createOutreachBrand(createOutreachBrandRequest: CreateOutreachBrandRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper>;

    /**
     * Create brand profile in routable
     * @param {string} brandId brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    createRoutable(brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Delete Brand
     * @param {string} id Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    deleteBrand(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Deny brand
     * @param {string} id Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    denyBrandApplicant(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Return published”/visible brands of any source up to the 4
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    exploreMoreBrands(options?: RawAxiosRequestConfig): AxiosPromise<ExploreMoreBrandsResponse>;

    /**
     * Favoritize brand
     * @param {string} id Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    favoritizeBrand(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Generate routable to csv
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    generateRoutableCSV(options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    generateVanityUrlNames(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Get brand by Id
     * @param {string} id Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    getBrand(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetBrandResponse>;

    /**
     * Get brand\'s active promo codes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    getBrandActivePromoCodes(options?: RawAxiosRequestConfig): AxiosPromise<BrandActivePromoCodesResponse>;

    /**
     * Find brand by referral code
     * @param {string} referralCode Referral code
     * @param {string} referralId Referral Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    getBrandByReferralCode(referralCode: string, referralId: string, options?: RawAxiosRequestConfig): AxiosPromise<BrandReferralResponse>;

    /**
     * Get brand\'s categories
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    getBrandCategories(id: string, options?: RawAxiosRequestConfig): AxiosPromise<BrandCategoriesForDropdownResponse>;

    /**
     * Get brand details
     * @param {string} id Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    getBrandDetails(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetBrandDetailsResponse>;

    /**
     * Returns all brand values
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    getBrandValues(options?: RawAxiosRequestConfig): AxiosPromise<Array<DropdownItem>>;

    /**
     * Find all Brand applicants per multiple/custom criteria
     * @param {string} [searchBy] Search by
     * @param {string} [source] Source
     * @param {string} [status] Status
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    getBrandsApplications(searchBy?: string, source?: string, status?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedBrandsApplicationsResponse>;

    /**
     * Find all Brand directory per multiple/custom criteria
     * @param {string} [searchBy] Search by
     * @param {string} [source] Source
     * @param {boolean} [bulletinPick] Bulletin pick
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    getBrandsDirectory(searchBy?: string, source?: string, bulletinPick?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedBrandsDirectoryResponse>;

    /**
     * Get brands for dropdown
     * @param {string} [ifNoneMatch] Is published flag if needed to filter brands
     * @param {boolean} [isPublished] 
     * @param {boolean} [excludeShopify] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    getBrandsDropdown(ifNoneMatch?: string, isPublished?: boolean, excludeShopify?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<object>;

    /**
     * Get brands from component for dropdown
     * @param {string} componentId Component Id from which needed to get brands for dropdown
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    getBrandsFromComponentForDropdown(componentId: string, options?: RawAxiosRequestConfig): AxiosPromise<BrandsDropdownResponse>;

    /**
     * Get brands from container for dropdown
     * @param {string} containerId Container Id from which needed to get brands for dropdown
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    getBrandsFromContainerForDropdown(containerId: string, options?: RawAxiosRequestConfig): AxiosPromise<BrandsDropdownResponse>;

    /**
     * Returns a true/false response indicating whether the frontend should display the Marketplace Visibility toggle.
     * @param {string} brandId Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    getCanBrandChangeMarketplaceVisibility(brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetCanBrandChangeMarketplaceVisibilityResponse>;

    /**
     * Returns all brand deals and promotions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    getDealsAndPromotions(options?: RawAxiosRequestConfig): AxiosPromise<Array<DropdownItem>>;

    /**
     * Find retailer favorite brands
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    getFavoriteBrands(options?: RawAxiosRequestConfig): AxiosPromise<FavoriteBrandResponse>;

    /**
     * Find retailer\'s last five favorite brands
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    getFilteredFavoriteBrands(options?: RawAxiosRequestConfig): AxiosPromise<FavoriteBrandResponse>;

    /**
     * Get brand
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    getMe(options?: RawAxiosRequestConfig): AxiosPromise<GetBrandResponse>;

    /**
     * Find brand by user Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    getMyId1(options?: RawAxiosRequestConfig): AxiosPromise<BrandInfoResponse>;

    /**
     * Get number of favorite brands
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    getNumberOfFavoriteBrands(options?: RawAxiosRequestConfig): AxiosPromise<FavoriteBrandCountResponse>;

    /**
     * Get public brand
     * @param {string} id Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    getPublicBrand(id: string, options?: RawAxiosRequestConfig): AxiosPromise<PublicBrandResponse>;

    /**
     * Get all retailers related to the brand
     * @param {string} id Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    getRetailersDropdown1(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RetailerDropdownResponse>;

    /**
     * Get active retailers stockists for the brand
     * @param {string} id Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    getRetailersStockists(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetStockistsResponse>>;

    /**
     * Get a list of possible values for special services
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    getSpecialServicesValues(options?: RawAxiosRequestConfig): AxiosPromise<Array<DropdownItem>>;

    /**
     * Merge EXHIBITOR Brand into existing Brand
     * @param {MergeExhibitorBrandRequest} mergeExhibitorBrandRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    mergeExhibitorBrand(mergeExhibitorBrandRequest: MergeExhibitorBrandRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Resends verification email to given brand
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    resendVerificationMail1(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Resend appropriate welcome email to a brand, depending on the brand source and state.
     * @param {string} id brand Id
     * @param {ResendBrandWelcomeEmailRequest} resendBrandWelcomeEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    resendWelcomeEmail(id: string, resendBrandWelcomeEmailRequest: ResendBrandWelcomeEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Submit outbound onboarding form
     * @param {SubmitOutboundOnboardingFormRequest} submitOutboundOnboardingFormRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    submitOutboundOnboardingForm(submitOutboundOnboardingFormRequest: SubmitOutboundOnboardingFormRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmitOutboundOnboardingFormResponse>;

    /**
     * Toggle brands bulletin pick flag
     * @param {ToggleBrandsBulletinPickRequest} toggleBrandsBulletinPickRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    toggleBrandsBulletinPick(toggleBrandsBulletinPickRequest: ToggleBrandsBulletinPickRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Toggle brand bulletin pick flag
     * @param {string} brandId Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    toggleBulletinPick(brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Toggle brand buy on bulletin flag
     * @param {string} brandId Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    toggleBuyOnBulletin(brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update brand
     * @param {string} id Brand Id
     * @param {UpdateBrandRequest} updateBrandRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    updateBrand(id: string, updateBrandRequest: UpdateBrandRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update brand by user Id
     * @param {UpdateBrandRequest} updateBrandRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    updateMe(updateBrandRequest: UpdateBrandRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Upload Brand Bio image
     * @param {string} id Brand Id
     * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    uploadBrandBioImage(id: string, uploadComponentImageRequest?: UploadComponentImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * Upload user Brand Bio image
     * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    uploadMyBrandBioImage(uploadComponentImageRequest?: UploadComponentImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * Upload user thumbnail image
     * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    uploadMyThumbnailImage(uploadComponentImageRequest?: UploadComponentImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * Upload thumbnail image
     * @param {string} id Brand Id
     * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    uploadThumbnailImage(id: string, uploadComponentImageRequest?: UploadComponentImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * Return whether the reset password token is valid for the brand.
     * @param {string} brandId Brand id
     * @param {string} token Reset password token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApiInterface
     */
    validateResetPasswordToken(brandId: string, token: string, options?: RawAxiosRequestConfig): AxiosPromise<ValidateResetPasswordTokenByBrandResponse>;

}

/**
 * BrandControllerApi - object-oriented interface
 * @export
 * @class BrandControllerApi
 * @extends {BaseAPI}
 */
export class BrandControllerApi extends BaseAPI implements BrandControllerApiInterface {
    /**
     * Apply to Sell
     * @param {ApplyToSellRequest} applyToSellRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public applyToSell(applyToSellRequest: ApplyToSellRequest, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).applyToSell(applyToSellRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Approve brand
     * @param {string} id Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public approve(id: string, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).approve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns brand info by his vanity url name
     * @param {string} vanityUrlName Vanity url name to look for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public brandBio(vanityUrlName: string, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).brandBio(vanityUrlName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return whether a product import from Shopify is currently in progress
     * @param {string} brandId Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public checkIfShopifyImportIsInProgress(brandId: string, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).checkIfShopifyImportIsInProgress(brandId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return whether a product import from Shopify is currently in progress
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public checkIfShopifyImportIsInProgress1(options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).checkIfShopifyImportIsInProgress1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create brand
     * @param {CreateBrandRequest} createBrandRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public createBrand(createBrandRequest: CreateBrandRequest, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).createBrand(createBrandRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create outreach brand
     * @param {CreateOutreachBrandRequest} createOutreachBrandRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public createOutreachBrand(createOutreachBrandRequest: CreateOutreachBrandRequest, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).createOutreachBrand(createOutreachBrandRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create brand profile in routable
     * @param {string} brandId brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public createRoutable(brandId: string, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).createRoutable(brandId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete Brand
     * @param {string} id Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public deleteBrand(id: string, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).deleteBrand(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deny brand
     * @param {string} id Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public denyBrandApplicant(id: string, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).denyBrandApplicant(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return published”/visible brands of any source up to the 4
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public exploreMoreBrands(options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).exploreMoreBrands(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Favoritize brand
     * @param {string} id Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public favoritizeBrand(id: string, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).favoritizeBrand(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate routable to csv
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public generateRoutableCSV(options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).generateRoutableCSV(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public generateVanityUrlNames(options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).generateVanityUrlNames(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get brand by Id
     * @param {string} id Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public getBrand(id: string, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).getBrand(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get brand\'s active promo codes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public getBrandActivePromoCodes(options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).getBrandActivePromoCodes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find brand by referral code
     * @param {string} referralCode Referral code
     * @param {string} referralId Referral Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public getBrandByReferralCode(referralCode: string, referralId: string, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).getBrandByReferralCode(referralCode, referralId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get brand\'s categories
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public getBrandCategories(id: string, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).getBrandCategories(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get brand details
     * @param {string} id Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public getBrandDetails(id: string, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).getBrandDetails(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all brand values
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public getBrandValues(options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).getBrandValues(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find all Brand applicants per multiple/custom criteria
     * @param {string} [searchBy] Search by
     * @param {string} [source] Source
     * @param {string} [status] Status
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public getBrandsApplications(searchBy?: string, source?: string, status?: string, page?: number, size?: number, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).getBrandsApplications(searchBy, source, status, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find all Brand directory per multiple/custom criteria
     * @param {string} [searchBy] Search by
     * @param {string} [source] Source
     * @param {boolean} [bulletinPick] Bulletin pick
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public getBrandsDirectory(searchBy?: string, source?: string, bulletinPick?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).getBrandsDirectory(searchBy, source, bulletinPick, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get brands for dropdown
     * @param {string} [ifNoneMatch] Is published flag if needed to filter brands
     * @param {boolean} [isPublished] 
     * @param {boolean} [excludeShopify] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public getBrandsDropdown(ifNoneMatch?: string, isPublished?: boolean, excludeShopify?: boolean, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).getBrandsDropdown(ifNoneMatch, isPublished, excludeShopify, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get brands from component for dropdown
     * @param {string} componentId Component Id from which needed to get brands for dropdown
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public getBrandsFromComponentForDropdown(componentId: string, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).getBrandsFromComponentForDropdown(componentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get brands from container for dropdown
     * @param {string} containerId Container Id from which needed to get brands for dropdown
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public getBrandsFromContainerForDropdown(containerId: string, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).getBrandsFromContainerForDropdown(containerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a true/false response indicating whether the frontend should display the Marketplace Visibility toggle.
     * @param {string} brandId Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public getCanBrandChangeMarketplaceVisibility(brandId: string, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).getCanBrandChangeMarketplaceVisibility(brandId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all brand deals and promotions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public getDealsAndPromotions(options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).getDealsAndPromotions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find retailer favorite brands
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public getFavoriteBrands(options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).getFavoriteBrands(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find retailer\'s last five favorite brands
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public getFilteredFavoriteBrands(options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).getFilteredFavoriteBrands(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get brand
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public getMe(options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).getMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find brand by user Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public getMyId1(options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).getMyId1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get number of favorite brands
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public getNumberOfFavoriteBrands(options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).getNumberOfFavoriteBrands(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get public brand
     * @param {string} id Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public getPublicBrand(id: string, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).getPublicBrand(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all retailers related to the brand
     * @param {string} id Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public getRetailersDropdown1(id: string, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).getRetailersDropdown1(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get active retailers stockists for the brand
     * @param {string} id Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public getRetailersStockists(id: string, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).getRetailersStockists(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of possible values for special services
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public getSpecialServicesValues(options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).getSpecialServicesValues(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Merge EXHIBITOR Brand into existing Brand
     * @param {MergeExhibitorBrandRequest} mergeExhibitorBrandRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public mergeExhibitorBrand(mergeExhibitorBrandRequest: MergeExhibitorBrandRequest, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).mergeExhibitorBrand(mergeExhibitorBrandRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resends verification email to given brand
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public resendVerificationMail1(options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).resendVerificationMail1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resend appropriate welcome email to a brand, depending on the brand source and state.
     * @param {string} id brand Id
     * @param {ResendBrandWelcomeEmailRequest} resendBrandWelcomeEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public resendWelcomeEmail(id: string, resendBrandWelcomeEmailRequest: ResendBrandWelcomeEmailRequest, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).resendWelcomeEmail(id, resendBrandWelcomeEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submit outbound onboarding form
     * @param {SubmitOutboundOnboardingFormRequest} submitOutboundOnboardingFormRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public submitOutboundOnboardingForm(submitOutboundOnboardingFormRequest: SubmitOutboundOnboardingFormRequest, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).submitOutboundOnboardingForm(submitOutboundOnboardingFormRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Toggle brands bulletin pick flag
     * @param {ToggleBrandsBulletinPickRequest} toggleBrandsBulletinPickRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public toggleBrandsBulletinPick(toggleBrandsBulletinPickRequest: ToggleBrandsBulletinPickRequest, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).toggleBrandsBulletinPick(toggleBrandsBulletinPickRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Toggle brand bulletin pick flag
     * @param {string} brandId Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public toggleBulletinPick(brandId: string, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).toggleBulletinPick(brandId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Toggle brand buy on bulletin flag
     * @param {string} brandId Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public toggleBuyOnBulletin(brandId: string, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).toggleBuyOnBulletin(brandId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update brand
     * @param {string} id Brand Id
     * @param {UpdateBrandRequest} updateBrandRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public updateBrand(id: string, updateBrandRequest: UpdateBrandRequest, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).updateBrand(id, updateBrandRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update brand by user Id
     * @param {UpdateBrandRequest} updateBrandRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public updateMe(updateBrandRequest: UpdateBrandRequest, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).updateMe(updateBrandRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload Brand Bio image
     * @param {string} id Brand Id
     * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public uploadBrandBioImage(id: string, uploadComponentImageRequest?: UploadComponentImageRequest, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).uploadBrandBioImage(id, uploadComponentImageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload user Brand Bio image
     * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public uploadMyBrandBioImage(uploadComponentImageRequest?: UploadComponentImageRequest, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).uploadMyBrandBioImage(uploadComponentImageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload user thumbnail image
     * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public uploadMyThumbnailImage(uploadComponentImageRequest?: UploadComponentImageRequest, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).uploadMyThumbnailImage(uploadComponentImageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload thumbnail image
     * @param {string} id Brand Id
     * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public uploadThumbnailImage(id: string, uploadComponentImageRequest?: UploadComponentImageRequest, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).uploadThumbnailImage(id, uploadComponentImageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return whether the reset password token is valid for the brand.
     * @param {string} brandId Brand id
     * @param {string} token Reset password token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandControllerApi
     */
    public validateResetPasswordToken(brandId: string, token: string, options?: RawAxiosRequestConfig) {
        return BrandControllerApiFp(this.configuration).validateResetPasswordToken(brandId, token, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CartControllerApi - axios parameter creator
 * @export
 */
export const CartControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add custom assortment items to cart. Used in case of buying custom assortment.Retailer has to be able to add items from custom assortment in one hit.
         * @param {string} id Id of custom assortment which should be added to cart
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCustomAssortmentToCart: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addCustomAssortmentToCart', 'id', id)
            const localVarPath = `/carts/custom-assortments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add items To Cart
         * @param {AddItemsToCartRequest} addItemsToCartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemsToCart: async (addItemsToCartRequest: AddItemsToCartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addItemsToCartRequest' is not null or undefined
            assertParamExists('addItemsToCart', 'addItemsToCartRequest', addItemsToCartRequest)
            const localVarPath = `/carts/add-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addItemsToCartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add To Cart
         * @param {AddToCartRequest} addToCartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addToCart: async (addToCartRequest: AddToCartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addToCartRequest' is not null or undefined
            assertParamExists('addToCart', 'addToCartRequest', addToCartRequest)
            const localVarPath = `/carts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addToCartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Apply Promo Code to cart for logged user
         * @param {string} code Promo Code which is being applied
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyPromoCode: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('applyPromoCode', 'code', code)
            const localVarPath = `/carts/promo-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete variant from cart for logged user
         * @param {string} variantId Variant Id to be deleted from cart
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFromCart: async (variantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'variantId' is not null or undefined
            assertParamExists('deleteFromCart', 'variantId', variantId)
            const localVarPath = `/carts/{variantId}`
                .replace(`{${"variantId"}}`, encodeURIComponent(String(variantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartProductsAmount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/carts/products-amount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get validated cart for logged user
         * @param {boolean} selectedForCheckout Gets only subCarts marked for checkout or all carts if false passed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidatedCart: async (selectedForCheckout: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'selectedForCheckout' is not null or undefined
            assertParamExists('getValidatedCart', 'selectedForCheckout', selectedForCheckout)
            const localVarPath = `/carts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (selectedForCheckout !== undefined) {
                localVarQueryParameter['selected_for_checkout'] = selectedForCheckout;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove Promo Code from cart for logged user
         * @param {string} code Order Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePromoCode: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('removePromoCode', 'code', code)
            const localVarPath = `/carts/promo-code/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Marks one SubCart flag selected for checkout = true and other SubCarts to false or reset all SubCarts to true if null passed
         * @param {BrandCheckoutRequest} brandCheckoutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selectSubCartForCheckout: async (brandCheckoutRequest: BrandCheckoutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandCheckoutRequest' is not null or undefined
            assertParamExists('selectSubCartForCheckout', 'brandCheckoutRequest', brandCheckoutRequest)
            const localVarPath = `/carts/brand-checkout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(brandCheckoutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update variant quantity inside cart for logged user
         * @param {UpdateCartRequest} updateCartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCart: async (updateCartRequest: UpdateCartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateCartRequest' is not null or undefined
            assertParamExists('updateCart', 'updateCartRequest', updateCartRequest)
            const localVarPath = `/carts/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate cart MOV and RMOV for sub carts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCart: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/carts/validation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CartControllerApi - functional programming interface
 * @export
 */
export const CartControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CartControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add custom assortment items to cart. Used in case of buying custom assortment.Retailer has to be able to add items from custom assortment in one hit.
         * @param {string} id Id of custom assortment which should be added to cart
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCustomAssortmentToCart(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCustomAssortmentToCart(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartControllerApi.addCustomAssortmentToCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add items To Cart
         * @param {AddItemsToCartRequest} addItemsToCartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addItemsToCart(addItemsToCartRequest: AddItemsToCartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addItemsToCart(addItemsToCartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartControllerApi.addItemsToCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add To Cart
         * @param {AddToCartRequest} addToCartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addToCart(addToCartRequest: AddToCartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addToCart(addToCartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartControllerApi.addToCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Apply Promo Code to cart for logged user
         * @param {string} code Promo Code which is being applied
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyPromoCode(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyPromoCode(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartControllerApi.applyPromoCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete variant from cart for logged user
         * @param {string} variantId Variant Id to be deleted from cart
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFromCart(variantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFromCart(variantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartControllerApi.deleteFromCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCartProductsAmount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCartProductsAmountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCartProductsAmount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartControllerApi.getCartProductsAmount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get validated cart for logged user
         * @param {boolean} selectedForCheckout Gets only subCarts marked for checkout or all carts if false passed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getValidatedCart(selectedForCheckout: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getValidatedCart(selectedForCheckout, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartControllerApi.getValidatedCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove Promo Code from cart for logged user
         * @param {string} code Order Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removePromoCode(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removePromoCode(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartControllerApi.removePromoCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Marks one SubCart flag selected for checkout = true and other SubCarts to false or reset all SubCarts to true if null passed
         * @param {BrandCheckoutRequest} brandCheckoutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async selectSubCartForCheckout(brandCheckoutRequest: BrandCheckoutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.selectSubCartForCheckout(brandCheckoutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartControllerApi.selectSubCartForCheckout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update variant quantity inside cart for logged user
         * @param {UpdateCartRequest} updateCartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCart(updateCartRequest: UpdateCartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCart(updateCartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartControllerApi.updateCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate cart MOV and RMOV for sub carts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateCart(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateCart(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CartControllerApi.validateCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CartControllerApi - factory interface
 * @export
 */
export const CartControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CartControllerApiFp(configuration)
    return {
        /**
         * Add custom assortment items to cart. Used in case of buying custom assortment.Retailer has to be able to add items from custom assortment in one hit.
         * @param {string} id Id of custom assortment which should be added to cart
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCustomAssortmentToCart(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addCustomAssortmentToCart(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Add items To Cart
         * @param {AddItemsToCartRequest} addItemsToCartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemsToCart(addItemsToCartRequest: AddItemsToCartRequest, options?: RawAxiosRequestConfig): AxiosPromise<CartResponse> {
            return localVarFp.addItemsToCart(addItemsToCartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add To Cart
         * @param {AddToCartRequest} addToCartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addToCart(addToCartRequest: AddToCartRequest, options?: RawAxiosRequestConfig): AxiosPromise<CartResponse> {
            return localVarFp.addToCart(addToCartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Apply Promo Code to cart for logged user
         * @param {string} code Promo Code which is being applied
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyPromoCode(code: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.applyPromoCode(code, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete variant from cart for logged user
         * @param {string} variantId Variant Id to be deleted from cart
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFromCart(variantId: string, options?: RawAxiosRequestConfig): AxiosPromise<CartResponse> {
            return localVarFp.deleteFromCart(variantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartProductsAmount(options?: RawAxiosRequestConfig): AxiosPromise<GetCartProductsAmountResponse> {
            return localVarFp.getCartProductsAmount(options).then((request) => request(axios, basePath));
        },
        /**
         * Get validated cart for logged user
         * @param {boolean} selectedForCheckout Gets only subCarts marked for checkout or all carts if false passed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidatedCart(selectedForCheckout: boolean, options?: RawAxiosRequestConfig): AxiosPromise<CartResponse> {
            return localVarFp.getValidatedCart(selectedForCheckout, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove Promo Code from cart for logged user
         * @param {string} code Order Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePromoCode(code: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removePromoCode(code, options).then((request) => request(axios, basePath));
        },
        /**
         * Marks one SubCart flag selected for checkout = true and other SubCarts to false or reset all SubCarts to true if null passed
         * @param {BrandCheckoutRequest} brandCheckoutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selectSubCartForCheckout(brandCheckoutRequest: BrandCheckoutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CartResponse> {
            return localVarFp.selectSubCartForCheckout(brandCheckoutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update variant quantity inside cart for logged user
         * @param {UpdateCartRequest} updateCartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCart(updateCartRequest: UpdateCartRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCart(updateCartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate cart MOV and RMOV for sub carts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCart(options?: RawAxiosRequestConfig): AxiosPromise<CartResponse> {
            return localVarFp.validateCart(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CartControllerApi - interface
 * @export
 * @interface CartControllerApi
 */
export interface CartControllerApiInterface {
    /**
     * Add custom assortment items to cart. Used in case of buying custom assortment.Retailer has to be able to add items from custom assortment in one hit.
     * @param {string} id Id of custom assortment which should be added to cart
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerApiInterface
     */
    addCustomAssortmentToCart(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Add items To Cart
     * @param {AddItemsToCartRequest} addItemsToCartRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerApiInterface
     */
    addItemsToCart(addItemsToCartRequest: AddItemsToCartRequest, options?: RawAxiosRequestConfig): AxiosPromise<CartResponse>;

    /**
     * Add To Cart
     * @param {AddToCartRequest} addToCartRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerApiInterface
     */
    addToCart(addToCartRequest: AddToCartRequest, options?: RawAxiosRequestConfig): AxiosPromise<CartResponse>;

    /**
     * Apply Promo Code to cart for logged user
     * @param {string} code Promo Code which is being applied
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerApiInterface
     */
    applyPromoCode(code: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Delete variant from cart for logged user
     * @param {string} variantId Variant Id to be deleted from cart
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerApiInterface
     */
    deleteFromCart(variantId: string, options?: RawAxiosRequestConfig): AxiosPromise<CartResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerApiInterface
     */
    getCartProductsAmount(options?: RawAxiosRequestConfig): AxiosPromise<GetCartProductsAmountResponse>;

    /**
     * Get validated cart for logged user
     * @param {boolean} selectedForCheckout Gets only subCarts marked for checkout or all carts if false passed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerApiInterface
     */
    getValidatedCart(selectedForCheckout: boolean, options?: RawAxiosRequestConfig): AxiosPromise<CartResponse>;

    /**
     * Remove Promo Code from cart for logged user
     * @param {string} code Order Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerApiInterface
     */
    removePromoCode(code: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Marks one SubCart flag selected for checkout = true and other SubCarts to false or reset all SubCarts to true if null passed
     * @param {BrandCheckoutRequest} brandCheckoutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerApiInterface
     */
    selectSubCartForCheckout(brandCheckoutRequest: BrandCheckoutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CartResponse>;

    /**
     * Update variant quantity inside cart for logged user
     * @param {UpdateCartRequest} updateCartRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerApiInterface
     */
    updateCart(updateCartRequest: UpdateCartRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Validate cart MOV and RMOV for sub carts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerApiInterface
     */
    validateCart(options?: RawAxiosRequestConfig): AxiosPromise<CartResponse>;

}

/**
 * CartControllerApi - object-oriented interface
 * @export
 * @class CartControllerApi
 * @extends {BaseAPI}
 */
export class CartControllerApi extends BaseAPI implements CartControllerApiInterface {
    /**
     * Add custom assortment items to cart. Used in case of buying custom assortment.Retailer has to be able to add items from custom assortment in one hit.
     * @param {string} id Id of custom assortment which should be added to cart
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerApi
     */
    public addCustomAssortmentToCart(id: string, options?: RawAxiosRequestConfig) {
        return CartControllerApiFp(this.configuration).addCustomAssortmentToCart(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add items To Cart
     * @param {AddItemsToCartRequest} addItemsToCartRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerApi
     */
    public addItemsToCart(addItemsToCartRequest: AddItemsToCartRequest, options?: RawAxiosRequestConfig) {
        return CartControllerApiFp(this.configuration).addItemsToCart(addItemsToCartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add To Cart
     * @param {AddToCartRequest} addToCartRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerApi
     */
    public addToCart(addToCartRequest: AddToCartRequest, options?: RawAxiosRequestConfig) {
        return CartControllerApiFp(this.configuration).addToCart(addToCartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Apply Promo Code to cart for logged user
     * @param {string} code Promo Code which is being applied
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerApi
     */
    public applyPromoCode(code: string, options?: RawAxiosRequestConfig) {
        return CartControllerApiFp(this.configuration).applyPromoCode(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete variant from cart for logged user
     * @param {string} variantId Variant Id to be deleted from cart
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerApi
     */
    public deleteFromCart(variantId: string, options?: RawAxiosRequestConfig) {
        return CartControllerApiFp(this.configuration).deleteFromCart(variantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerApi
     */
    public getCartProductsAmount(options?: RawAxiosRequestConfig) {
        return CartControllerApiFp(this.configuration).getCartProductsAmount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get validated cart for logged user
     * @param {boolean} selectedForCheckout Gets only subCarts marked for checkout or all carts if false passed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerApi
     */
    public getValidatedCart(selectedForCheckout: boolean, options?: RawAxiosRequestConfig) {
        return CartControllerApiFp(this.configuration).getValidatedCart(selectedForCheckout, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove Promo Code from cart for logged user
     * @param {string} code Order Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerApi
     */
    public removePromoCode(code: string, options?: RawAxiosRequestConfig) {
        return CartControllerApiFp(this.configuration).removePromoCode(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Marks one SubCart flag selected for checkout = true and other SubCarts to false or reset all SubCarts to true if null passed
     * @param {BrandCheckoutRequest} brandCheckoutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerApi
     */
    public selectSubCartForCheckout(brandCheckoutRequest: BrandCheckoutRequest, options?: RawAxiosRequestConfig) {
        return CartControllerApiFp(this.configuration).selectSubCartForCheckout(brandCheckoutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update variant quantity inside cart for logged user
     * @param {UpdateCartRequest} updateCartRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerApi
     */
    public updateCart(updateCartRequest: UpdateCartRequest, options?: RawAxiosRequestConfig) {
        return CartControllerApiFp(this.configuration).updateCart(updateCartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate cart MOV and RMOV for sub carts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerApi
     */
    public validateCart(options?: RawAxiosRequestConfig) {
        return CartControllerApiFp(this.configuration).validateCart(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CategoryControllerApi - axios parameter creator
 * @export
 */
export const CategoryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create categories
         * @param {CreateCategoriesRequest} createCategoriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategories: async (createCategoriesRequest: CreateCategoriesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCategoriesRequest' is not null or undefined
            assertParamExists('createCategories', 'createCategoriesRequest', createCategoriesRequest)
            const localVarPath = `/categories/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCategoriesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create category
         * @param {CreateCategoryRequest} createCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategory: async (createCategoryRequest: CreateCategoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCategoryRequest' is not null or undefined
            assertParamExists('createCategory', 'createCategoryRequest', createCategoryRequest)
            const localVarPath = `/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get categories for home page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoriesForHome: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/categories/home`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} active Active categories flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoriesFromNavigation: async (active: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'active' is not null or undefined
            assertParamExists('getCategoriesFromNavigation', 'active', active)
            const localVarPath = `/categories/navigation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all nested categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoriesNested: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/categories/nested`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get category
         * @param {string} id Category Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategory: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCategory', 'id', id)
            const localVarPath = `/categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get nested category
         * @param {string} id Category Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryNested: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCategoryNested', 'id', id)
            const localVarPath = `/categories/{id}/nested`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get subcategories
         * @param {string} id Parent category view container id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubcategories: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSubcategories', 'id', id)
            const localVarPath = `/categories/subcategories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} active Active subcategories flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubcategoriesFromNavigation: async (active: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'active' is not null or undefined
            assertParamExists('getSubcategoriesFromNavigation', 'active', active)
            const localVarPath = `/categories/navigation/subcategories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add products to categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategoriesWithProducts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/categories/update-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update category
         * @param {string} id Category Id
         * @param {UpdateCategoryRequest} updateCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategory: async (id: string, updateCategoryRequest: UpdateCategoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCategory', 'id', id)
            // verify required parameter 'updateCategoryRequest' is not null or undefined
            assertParamExists('updateCategory', 'updateCategoryRequest', updateCategoryRequest)
            const localVarPath = `/categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload category image
         * @param {string} id Category Id
         * @param {UploadCollectionImageRequest} [uploadCollectionImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCategoryImage: async (id: string, uploadCollectionImageRequest?: UploadCollectionImageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadCategoryImage', 'id', id)
            const localVarPath = `/categories/{id}/image`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadCollectionImageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CategoryControllerApi - functional programming interface
 * @export
 */
export const CategoryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CategoryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Create categories
         * @param {CreateCategoriesRequest} createCategoriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCategories(createCategoriesRequest: CreateCategoriesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCategories(createCategoriesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryControllerApi.createCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create category
         * @param {CreateCategoryRequest} createCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCategory(createCategoryRequest: CreateCategoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCategoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCategory(createCategoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryControllerApi.createCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategories(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCategoryResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategories(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryControllerApi.getCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get categories for home page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoriesForHome(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCategoryResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoriesForHome(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryControllerApi.getCategoriesForHome']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} active Active categories flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoriesFromNavigation(active: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewContainerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoriesFromNavigation(active, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryControllerApi.getCategoriesFromNavigation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all nested categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoriesNested(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CategoryWithSubcategoriesResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoriesNested(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryControllerApi.getCategoriesNested']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get category
         * @param {string} id Category Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategory(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCategoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategory(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryControllerApi.getCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get nested category
         * @param {string} id Category Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoryNested(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCategoryResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoryNested(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryControllerApi.getCategoryNested']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get subcategories
         * @param {string} id Parent category view container id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubcategories(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSubcategoriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubcategories(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryControllerApi.getSubcategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} active Active subcategories flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubcategoriesFromNavigation(active: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubcategoriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubcategoriesFromNavigation(active, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryControllerApi.getSubcategoriesFromNavigation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add products to categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCategoriesWithProducts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCategoriesWithProducts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryControllerApi.updateCategoriesWithProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update category
         * @param {string} id Category Id
         * @param {UpdateCategoryRequest} updateCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCategory(id: string, updateCategoryRequest: UpdateCategoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCategory(id, updateCategoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryControllerApi.updateCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload category image
         * @param {string} id Category Id
         * @param {UploadCollectionImageRequest} [uploadCollectionImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadCategoryImage(id: string, uploadCollectionImageRequest?: UploadCollectionImageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadCategoryImage(id, uploadCollectionImageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryControllerApi.uploadCategoryImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CategoryControllerApi - factory interface
 * @export
 */
export const CategoryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CategoryControllerApiFp(configuration)
    return {
        /**
         * Create categories
         * @param {CreateCategoriesRequest} createCategoriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategories(createCategoriesRequest: CreateCategoriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createCategories(createCategoriesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create category
         * @param {CreateCategoryRequest} createCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategory(createCategoryRequest: CreateCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCategoryResponse> {
            return localVarFp.createCategory(createCategoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetCategoryResponse>> {
            return localVarFp.getCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * Get categories for home page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoriesForHome(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetCategoryResponse>> {
            return localVarFp.getCategoriesForHome(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} active Active categories flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoriesFromNavigation(active: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ViewContainerResponse> {
            return localVarFp.getCategoriesFromNavigation(active, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all nested categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoriesNested(options?: RawAxiosRequestConfig): AxiosPromise<Array<CategoryWithSubcategoriesResponse>> {
            return localVarFp.getCategoriesNested(options).then((request) => request(axios, basePath));
        },
        /**
         * Get category
         * @param {string} id Category Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategory(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetCategoryResponse> {
            return localVarFp.getCategory(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get nested category
         * @param {string} id Category Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryNested(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetCategoryResponse>> {
            return localVarFp.getCategoryNested(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get subcategories
         * @param {string} id Parent category view container id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubcategories(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetSubcategoriesResponse> {
            return localVarFp.getSubcategories(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} active Active subcategories flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubcategoriesFromNavigation(active: boolean, options?: RawAxiosRequestConfig): AxiosPromise<SubcategoriesResponse> {
            return localVarFp.getSubcategoriesFromNavigation(active, options).then((request) => request(axios, basePath));
        },
        /**
         * Add products to categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategoriesWithProducts(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCategoriesWithProducts(options).then((request) => request(axios, basePath));
        },
        /**
         * Update category
         * @param {string} id Category Id
         * @param {UpdateCategoryRequest} updateCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategory(id: string, updateCategoryRequest: UpdateCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCategory(id, updateCategoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload category image
         * @param {string} id Category Id
         * @param {UploadCollectionImageRequest} [uploadCollectionImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCategoryImage(id: string, uploadCollectionImageRequest?: UploadCollectionImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.uploadCategoryImage(id, uploadCollectionImageRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CategoryControllerApi - interface
 * @export
 * @interface CategoryControllerApi
 */
export interface CategoryControllerApiInterface {
    /**
     * Create categories
     * @param {CreateCategoriesRequest} createCategoriesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApiInterface
     */
    createCategories(createCategoriesRequest: CreateCategoriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Create category
     * @param {CreateCategoryRequest} createCategoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApiInterface
     */
    createCategory(createCategoryRequest: CreateCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCategoryResponse>;

    /**
     * Get all categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApiInterface
     */
    getCategories(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetCategoryResponse>>;

    /**
     * Get categories for home page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApiInterface
     */
    getCategoriesForHome(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetCategoryResponse>>;

    /**
     * 
     * @param {boolean} active Active categories flag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApiInterface
     */
    getCategoriesFromNavigation(active: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ViewContainerResponse>;

    /**
     * Get all nested categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApiInterface
     */
    getCategoriesNested(options?: RawAxiosRequestConfig): AxiosPromise<Array<CategoryWithSubcategoriesResponse>>;

    /**
     * Get category
     * @param {string} id Category Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApiInterface
     */
    getCategory(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetCategoryResponse>;

    /**
     * Get nested category
     * @param {string} id Category Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApiInterface
     */
    getCategoryNested(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetCategoryResponse>>;

    /**
     * Get subcategories
     * @param {string} id Parent category view container id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApiInterface
     */
    getSubcategories(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetSubcategoriesResponse>;

    /**
     * 
     * @param {boolean} active Active subcategories flag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApiInterface
     */
    getSubcategoriesFromNavigation(active: boolean, options?: RawAxiosRequestConfig): AxiosPromise<SubcategoriesResponse>;

    /**
     * Add products to categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApiInterface
     */
    updateCategoriesWithProducts(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update category
     * @param {string} id Category Id
     * @param {UpdateCategoryRequest} updateCategoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApiInterface
     */
    updateCategory(id: string, updateCategoryRequest: UpdateCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Upload category image
     * @param {string} id Category Id
     * @param {UploadCollectionImageRequest} [uploadCollectionImageRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApiInterface
     */
    uploadCategoryImage(id: string, uploadCollectionImageRequest?: UploadCollectionImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

}

/**
 * CategoryControllerApi - object-oriented interface
 * @export
 * @class CategoryControllerApi
 * @extends {BaseAPI}
 */
export class CategoryControllerApi extends BaseAPI implements CategoryControllerApiInterface {
    /**
     * Create categories
     * @param {CreateCategoriesRequest} createCategoriesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApi
     */
    public createCategories(createCategoriesRequest: CreateCategoriesRequest, options?: RawAxiosRequestConfig) {
        return CategoryControllerApiFp(this.configuration).createCategories(createCategoriesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create category
     * @param {CreateCategoryRequest} createCategoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApi
     */
    public createCategory(createCategoryRequest: CreateCategoryRequest, options?: RawAxiosRequestConfig) {
        return CategoryControllerApiFp(this.configuration).createCategory(createCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApi
     */
    public getCategories(options?: RawAxiosRequestConfig) {
        return CategoryControllerApiFp(this.configuration).getCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get categories for home page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApi
     */
    public getCategoriesForHome(options?: RawAxiosRequestConfig) {
        return CategoryControllerApiFp(this.configuration).getCategoriesForHome(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} active Active categories flag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApi
     */
    public getCategoriesFromNavigation(active: boolean, options?: RawAxiosRequestConfig) {
        return CategoryControllerApiFp(this.configuration).getCategoriesFromNavigation(active, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all nested categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApi
     */
    public getCategoriesNested(options?: RawAxiosRequestConfig) {
        return CategoryControllerApiFp(this.configuration).getCategoriesNested(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get category
     * @param {string} id Category Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApi
     */
    public getCategory(id: string, options?: RawAxiosRequestConfig) {
        return CategoryControllerApiFp(this.configuration).getCategory(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get nested category
     * @param {string} id Category Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApi
     */
    public getCategoryNested(id: string, options?: RawAxiosRequestConfig) {
        return CategoryControllerApiFp(this.configuration).getCategoryNested(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get subcategories
     * @param {string} id Parent category view container id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApi
     */
    public getSubcategories(id: string, options?: RawAxiosRequestConfig) {
        return CategoryControllerApiFp(this.configuration).getSubcategories(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} active Active subcategories flag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApi
     */
    public getSubcategoriesFromNavigation(active: boolean, options?: RawAxiosRequestConfig) {
        return CategoryControllerApiFp(this.configuration).getSubcategoriesFromNavigation(active, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add products to categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApi
     */
    public updateCategoriesWithProducts(options?: RawAxiosRequestConfig) {
        return CategoryControllerApiFp(this.configuration).updateCategoriesWithProducts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update category
     * @param {string} id Category Id
     * @param {UpdateCategoryRequest} updateCategoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApi
     */
    public updateCategory(id: string, updateCategoryRequest: UpdateCategoryRequest, options?: RawAxiosRequestConfig) {
        return CategoryControllerApiFp(this.configuration).updateCategory(id, updateCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload category image
     * @param {string} id Category Id
     * @param {UploadCollectionImageRequest} [uploadCollectionImageRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryControllerApi
     */
    public uploadCategoryImage(id: string, uploadCollectionImageRequest?: UploadCollectionImageRequest, options?: RawAxiosRequestConfig) {
        return CategoryControllerApiFp(this.configuration).uploadCategoryImage(id, uploadCollectionImageRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CollectionControllerApi - axios parameter creator
 * @export
 */
export const CollectionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add new products to the manual collections
         * @param {AddProductsToManualCollectionRequest} addProductsToManualCollectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProductsToManualCollections: async (addProductsToManualCollectionRequest: AddProductsToManualCollectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addProductsToManualCollectionRequest' is not null or undefined
            assertParamExists('addProductsToManualCollections', 'addProductsToManualCollectionRequest', addProductsToManualCollectionRequest)
            const localVarPath = `/collections/manual/add-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addProductsToManualCollectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create collection
         * @param {CreateCollectionRequest} createCollectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollection: async (createCollectionRequest: CreateCollectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCollectionRequest' is not null or undefined
            assertParamExists('createCollection', 'createCollectionRequest', createCollectionRequest)
            const localVarPath = `/collections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCollectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete collection
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCollection: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCollection', 'id', id)
            const localVarPath = `/collections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete collection
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteImageFromCollection: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteImageFromCollection', 'id', id)
            const localVarPath = `/collections/{id}/image`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all conditions for automated collections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutomatedCollectionConditions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/collections/automated/conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get collection
         * @param {string} id Collection Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollection: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCollection', 'id', id)
            const localVarPath = `/collections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get collection products
         * @param {string} id Collection Id
         * @param {number} [productsNumber] Products Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionProductToExplore: async (id: string, productsNumber?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCollectionProductToExplore', 'id', id)
            const localVarPath = `/collections/{id}/products-to-explore`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (productsNumber !== undefined) {
                localVarQueryParameter['products_number'] = productsNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all collections for home page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionsForHome: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/collections/home`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find featured collections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeaturedCollections: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/collections/featured/landing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get featured collections for home page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeaturedOnHome: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/collections/featured/home`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all manual collections with search by title
         * @param {string} [search] Search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManualCollections: async (search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/collections/manual`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add ordinal for collection on home page
         * @param {string} id Collection Id
         * @param {SetHomeOrdinalRequest} setHomeOrdinalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setHomeOrdinal: async (id: string, setHomeOrdinalRequest: SetHomeOrdinalRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setHomeOrdinal', 'id', id)
            // verify required parameter 'setHomeOrdinalRequest' is not null or undefined
            assertParamExists('setHomeOrdinal', 'setHomeOrdinalRequest', setHomeOrdinalRequest)
            const localVarPath = `/collections/{id}/home-ordinal`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setHomeOrdinalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update collection
         * @param {string} id Collection Id
         * @param {UpdateCollectionRequest} updateCollectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCollection: async (id: string, updateCollectionRequest: UpdateCollectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCollection', 'id', id)
            // verify required parameter 'updateCollectionRequest' is not null or undefined
            assertParamExists('updateCollection', 'updateCollectionRequest', updateCollectionRequest)
            const localVarPath = `/collections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCollectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update products inside collections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductsInCollections: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/collections/update-collections-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload collection image
         * @param {string} id Collection Id
         * @param {UploadCollectionImageRequest} [uploadCollectionImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCollectionImage: async (id: string, uploadCollectionImageRequest?: UploadCollectionImageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadCollectionImage', 'id', id)
            const localVarPath = `/collections/{id}/image`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadCollectionImageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CollectionControllerApi - functional programming interface
 * @export
 */
export const CollectionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CollectionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add new products to the manual collections
         * @param {AddProductsToManualCollectionRequest} addProductsToManualCollectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addProductsToManualCollections(addProductsToManualCollectionRequest: AddProductsToManualCollectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addProductsToManualCollections(addProductsToManualCollectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionControllerApi.addProductsToManualCollections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create collection
         * @param {CreateCollectionRequest} createCollectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCollection(createCollectionRequest: CreateCollectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCollection(createCollectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionControllerApi.createCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete collection
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCollection(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCollection(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionControllerApi.deleteCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete collection
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteImageFromCollection(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteImageFromCollection(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionControllerApi.deleteImageFromCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all conditions for automated collections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAutomatedCollectionConditions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutomatedCollectionConditionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAutomatedCollectionConditions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionControllerApi.getAutomatedCollectionConditions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get collection
         * @param {string} id Collection Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollection(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollection(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionControllerApi.getCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get collection products
         * @param {string} id Collection Id
         * @param {number} [productsNumber] Products Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionProductToExplore(id: string, productsNumber?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCollectionProductsToExploreResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectionProductToExplore(id, productsNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionControllerApi.getCollectionProductToExplore']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all collections for home page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionsForHome(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CollectionInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectionsForHome(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionControllerApi.getCollectionsForHome']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find featured collections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeaturedCollections(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CollectionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeaturedCollections(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionControllerApi.getFeaturedCollections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get featured collections for home page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeaturedOnHome(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeaturedOnHome(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionControllerApi.getFeaturedOnHome']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all manual collections with search by title
         * @param {string} [search] Search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManualCollections(search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllManualCollectionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManualCollections(search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionControllerApi.getManualCollections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add ordinal for collection on home page
         * @param {string} id Collection Id
         * @param {SetHomeOrdinalRequest} setHomeOrdinalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setHomeOrdinal(id: string, setHomeOrdinalRequest: SetHomeOrdinalRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setHomeOrdinal(id, setHomeOrdinalRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionControllerApi.setHomeOrdinal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update collection
         * @param {string} id Collection Id
         * @param {UpdateCollectionRequest} updateCollectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCollection(id: string, updateCollectionRequest: UpdateCollectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCollection(id, updateCollectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionControllerApi.updateCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update products inside collections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductsInCollections(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductsInCollections(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionControllerApi.updateProductsInCollections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload collection image
         * @param {string} id Collection Id
         * @param {UploadCollectionImageRequest} [uploadCollectionImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadCollectionImage(id: string, uploadCollectionImageRequest?: UploadCollectionImageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadCollectionImage(id, uploadCollectionImageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollectionControllerApi.uploadCollectionImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CollectionControllerApi - factory interface
 * @export
 */
export const CollectionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CollectionControllerApiFp(configuration)
    return {
        /**
         * Add new products to the manual collections
         * @param {AddProductsToManualCollectionRequest} addProductsToManualCollectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProductsToManualCollections(addProductsToManualCollectionRequest: AddProductsToManualCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addProductsToManualCollections(addProductsToManualCollectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create collection
         * @param {CreateCollectionRequest} createCollectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollection(createCollectionRequest: CreateCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper> {
            return localVarFp.createCollection(createCollectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete collection
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCollection(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCollection(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete collection
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteImageFromCollection(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteImageFromCollection(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all conditions for automated collections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutomatedCollectionConditions(options?: RawAxiosRequestConfig): AxiosPromise<AutomatedCollectionConditionsResponse> {
            return localVarFp.getAutomatedCollectionConditions(options).then((request) => request(axios, basePath));
        },
        /**
         * Get collection
         * @param {string} id Collection Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollection(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CollectionResponse> {
            return localVarFp.getCollection(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get collection products
         * @param {string} id Collection Id
         * @param {number} [productsNumber] Products Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionProductToExplore(id: string, productsNumber?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetCollectionProductsToExploreResponse> {
            return localVarFp.getCollectionProductToExplore(id, productsNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all collections for home page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionsForHome(options?: RawAxiosRequestConfig): AxiosPromise<Array<CollectionInfo>> {
            return localVarFp.getCollectionsForHome(options).then((request) => request(axios, basePath));
        },
        /**
         * Find featured collections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeaturedCollections(options?: RawAxiosRequestConfig): AxiosPromise<Array<CollectionResponse>> {
            return localVarFp.getFeaturedCollections(options).then((request) => request(axios, basePath));
        },
        /**
         * Get featured collections for home page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeaturedOnHome(options?: RawAxiosRequestConfig): AxiosPromise<CollectionResponse> {
            return localVarFp.getFeaturedOnHome(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all manual collections with search by title
         * @param {string} [search] Search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManualCollections(search?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetAllManualCollectionsResponse> {
            return localVarFp.getManualCollections(search, options).then((request) => request(axios, basePath));
        },
        /**
         * Add ordinal for collection on home page
         * @param {string} id Collection Id
         * @param {SetHomeOrdinalRequest} setHomeOrdinalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setHomeOrdinal(id: string, setHomeOrdinalRequest: SetHomeOrdinalRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setHomeOrdinal(id, setHomeOrdinalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update collection
         * @param {string} id Collection Id
         * @param {UpdateCollectionRequest} updateCollectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCollection(id: string, updateCollectionRequest: UpdateCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCollection(id, updateCollectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update products inside collections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductsInCollections(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProductsInCollections(options).then((request) => request(axios, basePath));
        },
        /**
         * Upload collection image
         * @param {string} id Collection Id
         * @param {UploadCollectionImageRequest} [uploadCollectionImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCollectionImage(id: string, uploadCollectionImageRequest?: UploadCollectionImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.uploadCollectionImage(id, uploadCollectionImageRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CollectionControllerApi - interface
 * @export
 * @interface CollectionControllerApi
 */
export interface CollectionControllerApiInterface {
    /**
     * Add new products to the manual collections
     * @param {AddProductsToManualCollectionRequest} addProductsToManualCollectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApiInterface
     */
    addProductsToManualCollections(addProductsToManualCollectionRequest: AddProductsToManualCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Create collection
     * @param {CreateCollectionRequest} createCollectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApiInterface
     */
    createCollection(createCollectionRequest: CreateCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper>;

    /**
     * Delete collection
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApiInterface
     */
    deleteCollection(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Delete collection
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApiInterface
     */
    deleteImageFromCollection(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Get all conditions for automated collections
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApiInterface
     */
    getAutomatedCollectionConditions(options?: RawAxiosRequestConfig): AxiosPromise<AutomatedCollectionConditionsResponse>;

    /**
     * Get collection
     * @param {string} id Collection Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApiInterface
     */
    getCollection(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CollectionResponse>;

    /**
     * Get collection products
     * @param {string} id Collection Id
     * @param {number} [productsNumber] Products Number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApiInterface
     */
    getCollectionProductToExplore(id: string, productsNumber?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetCollectionProductsToExploreResponse>;

    /**
     * Get all collections for home page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApiInterface
     */
    getCollectionsForHome(options?: RawAxiosRequestConfig): AxiosPromise<Array<CollectionInfo>>;

    /**
     * Find featured collections
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApiInterface
     */
    getFeaturedCollections(options?: RawAxiosRequestConfig): AxiosPromise<Array<CollectionResponse>>;

    /**
     * Get featured collections for home page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApiInterface
     */
    getFeaturedOnHome(options?: RawAxiosRequestConfig): AxiosPromise<CollectionResponse>;

    /**
     * Get all manual collections with search by title
     * @param {string} [search] Search
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApiInterface
     */
    getManualCollections(search?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetAllManualCollectionsResponse>;

    /**
     * Add ordinal for collection on home page
     * @param {string} id Collection Id
     * @param {SetHomeOrdinalRequest} setHomeOrdinalRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApiInterface
     */
    setHomeOrdinal(id: string, setHomeOrdinalRequest: SetHomeOrdinalRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update collection
     * @param {string} id Collection Id
     * @param {UpdateCollectionRequest} updateCollectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApiInterface
     */
    updateCollection(id: string, updateCollectionRequest: UpdateCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update products inside collections
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApiInterface
     */
    updateProductsInCollections(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Upload collection image
     * @param {string} id Collection Id
     * @param {UploadCollectionImageRequest} [uploadCollectionImageRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApiInterface
     */
    uploadCollectionImage(id: string, uploadCollectionImageRequest?: UploadCollectionImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

}

/**
 * CollectionControllerApi - object-oriented interface
 * @export
 * @class CollectionControllerApi
 * @extends {BaseAPI}
 */
export class CollectionControllerApi extends BaseAPI implements CollectionControllerApiInterface {
    /**
     * Add new products to the manual collections
     * @param {AddProductsToManualCollectionRequest} addProductsToManualCollectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApi
     */
    public addProductsToManualCollections(addProductsToManualCollectionRequest: AddProductsToManualCollectionRequest, options?: RawAxiosRequestConfig) {
        return CollectionControllerApiFp(this.configuration).addProductsToManualCollections(addProductsToManualCollectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create collection
     * @param {CreateCollectionRequest} createCollectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApi
     */
    public createCollection(createCollectionRequest: CreateCollectionRequest, options?: RawAxiosRequestConfig) {
        return CollectionControllerApiFp(this.configuration).createCollection(createCollectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete collection
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApi
     */
    public deleteCollection(id: string, options?: RawAxiosRequestConfig) {
        return CollectionControllerApiFp(this.configuration).deleteCollection(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete collection
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApi
     */
    public deleteImageFromCollection(id: string, options?: RawAxiosRequestConfig) {
        return CollectionControllerApiFp(this.configuration).deleteImageFromCollection(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all conditions for automated collections
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApi
     */
    public getAutomatedCollectionConditions(options?: RawAxiosRequestConfig) {
        return CollectionControllerApiFp(this.configuration).getAutomatedCollectionConditions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get collection
     * @param {string} id Collection Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApi
     */
    public getCollection(id: string, options?: RawAxiosRequestConfig) {
        return CollectionControllerApiFp(this.configuration).getCollection(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get collection products
     * @param {string} id Collection Id
     * @param {number} [productsNumber] Products Number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApi
     */
    public getCollectionProductToExplore(id: string, productsNumber?: number, options?: RawAxiosRequestConfig) {
        return CollectionControllerApiFp(this.configuration).getCollectionProductToExplore(id, productsNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all collections for home page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApi
     */
    public getCollectionsForHome(options?: RawAxiosRequestConfig) {
        return CollectionControllerApiFp(this.configuration).getCollectionsForHome(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find featured collections
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApi
     */
    public getFeaturedCollections(options?: RawAxiosRequestConfig) {
        return CollectionControllerApiFp(this.configuration).getFeaturedCollections(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get featured collections for home page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApi
     */
    public getFeaturedOnHome(options?: RawAxiosRequestConfig) {
        return CollectionControllerApiFp(this.configuration).getFeaturedOnHome(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all manual collections with search by title
     * @param {string} [search] Search
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApi
     */
    public getManualCollections(search?: string, options?: RawAxiosRequestConfig) {
        return CollectionControllerApiFp(this.configuration).getManualCollections(search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add ordinal for collection on home page
     * @param {string} id Collection Id
     * @param {SetHomeOrdinalRequest} setHomeOrdinalRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApi
     */
    public setHomeOrdinal(id: string, setHomeOrdinalRequest: SetHomeOrdinalRequest, options?: RawAxiosRequestConfig) {
        return CollectionControllerApiFp(this.configuration).setHomeOrdinal(id, setHomeOrdinalRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update collection
     * @param {string} id Collection Id
     * @param {UpdateCollectionRequest} updateCollectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApi
     */
    public updateCollection(id: string, updateCollectionRequest: UpdateCollectionRequest, options?: RawAxiosRequestConfig) {
        return CollectionControllerApiFp(this.configuration).updateCollection(id, updateCollectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update products inside collections
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApi
     */
    public updateProductsInCollections(options?: RawAxiosRequestConfig) {
        return CollectionControllerApiFp(this.configuration).updateProductsInCollections(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload collection image
     * @param {string} id Collection Id
     * @param {UploadCollectionImageRequest} [uploadCollectionImageRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionControllerApi
     */
    public uploadCollectionImage(id: string, uploadCollectionImageRequest?: UploadCollectionImageRequest, options?: RawAxiosRequestConfig) {
        return CollectionControllerApiFp(this.configuration).uploadCollectionImage(id, uploadCollectionImageRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CountryControllerApi - axios parameter creator
 * @export
 */
export const CountryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Find all countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns US and Canada as countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountriesAvailableForShipment: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/countries/available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get countries with states
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountriesWithStates: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/countries/states`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find states by country Id
         * @param {string} countryId Id of country
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatesByCountry: async (countryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryId' is not null or undefined
            assertParamExists('getStatesByCountry', 'countryId', countryId)
            const localVarPath = `/countries/{countryId}/states`
                .replace(`{${"countryId"}}`, encodeURIComponent(String(countryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check match for given state and country id
         * @param {StateCountryValidationRequest} stateCountryValidationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateStateForCountry: async (stateCountryValidationRequest: StateCountryValidationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stateCountryValidationRequest' is not null or undefined
            assertParamExists('validateStateForCountry', 'stateCountryValidationRequest', stateCountryValidationRequest)
            const localVarPath = `/countries/states/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stateCountryValidationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CountryControllerApi - functional programming interface
 * @export
 */
export const CountryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CountryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Find all countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountries(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CountryResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountries(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CountryControllerApi.getCountries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns US and Canada as countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountriesAvailableForShipment(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CountryResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountriesAvailableForShipment(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CountryControllerApi.getCountriesAvailableForShipment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get countries with states
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountriesWithStates(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountriesWithStates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CountryControllerApi.getCountriesWithStates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find states by country Id
         * @param {string} countryId Id of country
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatesByCountry(countryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StateResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatesByCountry(countryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CountryControllerApi.getStatesByCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check match for given state and country id
         * @param {StateCountryValidationRequest} stateCountryValidationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateStateForCountry(stateCountryValidationRequest: StateCountryValidationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateStateForCountry(stateCountryValidationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CountryControllerApi.validateStateForCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CountryControllerApi - factory interface
 * @export
 */
export const CountryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CountryControllerApiFp(configuration)
    return {
        /**
         * Find all countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries(options?: RawAxiosRequestConfig): AxiosPromise<Array<CountryResponse>> {
            return localVarFp.getCountries(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns US and Canada as countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountriesAvailableForShipment(options?: RawAxiosRequestConfig): AxiosPromise<Array<CountryResponse>> {
            return localVarFp.getCountriesAvailableForShipment(options).then((request) => request(axios, basePath));
        },
        /**
         * Get countries with states
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountriesWithStates(options?: RawAxiosRequestConfig): AxiosPromise<CountriesResponse> {
            return localVarFp.getCountriesWithStates(options).then((request) => request(axios, basePath));
        },
        /**
         * Find states by country Id
         * @param {string} countryId Id of country
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatesByCountry(countryId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StateResponse>> {
            return localVarFp.getStatesByCountry(countryId, options).then((request) => request(axios, basePath));
        },
        /**
         * Check match for given state and country id
         * @param {StateCountryValidationRequest} stateCountryValidationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateStateForCountry(stateCountryValidationRequest: StateCountryValidationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.validateStateForCountry(stateCountryValidationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CountryControllerApi - interface
 * @export
 * @interface CountryControllerApi
 */
export interface CountryControllerApiInterface {
    /**
     * Find all countries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountryControllerApiInterface
     */
    getCountries(options?: RawAxiosRequestConfig): AxiosPromise<Array<CountryResponse>>;

    /**
     * Returns US and Canada as countries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountryControllerApiInterface
     */
    getCountriesAvailableForShipment(options?: RawAxiosRequestConfig): AxiosPromise<Array<CountryResponse>>;

    /**
     * Get countries with states
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountryControllerApiInterface
     */
    getCountriesWithStates(options?: RawAxiosRequestConfig): AxiosPromise<CountriesResponse>;

    /**
     * Find states by country Id
     * @param {string} countryId Id of country
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountryControllerApiInterface
     */
    getStatesByCountry(countryId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StateResponse>>;

    /**
     * Check match for given state and country id
     * @param {StateCountryValidationRequest} stateCountryValidationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountryControllerApiInterface
     */
    validateStateForCountry(stateCountryValidationRequest: StateCountryValidationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * CountryControllerApi - object-oriented interface
 * @export
 * @class CountryControllerApi
 * @extends {BaseAPI}
 */
export class CountryControllerApi extends BaseAPI implements CountryControllerApiInterface {
    /**
     * Find all countries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountryControllerApi
     */
    public getCountries(options?: RawAxiosRequestConfig) {
        return CountryControllerApiFp(this.configuration).getCountries(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns US and Canada as countries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountryControllerApi
     */
    public getCountriesAvailableForShipment(options?: RawAxiosRequestConfig) {
        return CountryControllerApiFp(this.configuration).getCountriesAvailableForShipment(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get countries with states
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountryControllerApi
     */
    public getCountriesWithStates(options?: RawAxiosRequestConfig) {
        return CountryControllerApiFp(this.configuration).getCountriesWithStates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find states by country Id
     * @param {string} countryId Id of country
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountryControllerApi
     */
    public getStatesByCountry(countryId: string, options?: RawAxiosRequestConfig) {
        return CountryControllerApiFp(this.configuration).getStatesByCountry(countryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check match for given state and country id
     * @param {StateCountryValidationRequest} stateCountryValidationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountryControllerApi
     */
    public validateStateForCountry(stateCountryValidationRequest: StateCountryValidationRequest, options?: RawAxiosRequestConfig) {
        return CountryControllerApiFp(this.configuration).validateStateForCountry(stateCountryValidationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomAssortmentControllerApi - axios parameter creator
 * @export
 */
export const CustomAssortmentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create custom assortment. Returns Id of created custom assortment.
         * @param {CreateCustomAssortmentRequest} createCustomAssortmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomAssortment: async (createCustomAssortmentRequest: CreateCustomAssortmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCustomAssortmentRequest' is not null or undefined
            assertParamExists('createCustomAssortment', 'createCustomAssortmentRequest', createCustomAssortmentRequest)
            const localVarPath = `/custom-assortments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCustomAssortmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete custom assortment
         * @param {string} id Custom assortment Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomAssortment: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCustomAssortment', 'id', id)
            const localVarPath = `/custom-assortments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get custom assortment by Id
         * @param {string} id Custom assortment Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomAssortment: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCustomAssortment', 'id', id)
            const localVarPath = `/custom-assortments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find all custom-assortments per multiple/custom criteria
         * @param {string} [retailerId] Retailer Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomAssortments: async (retailerId?: string, page?: number, size?: number, searchBy?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/custom-assortments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (retailerId !== undefined) {
                localVarQueryParameter['retailerId'] = retailerId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (searchBy !== undefined) {
                localVarQueryParameter['searchBy'] = searchBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find all custom-assortments for provided retailer
         * @param {string} retailerId Retailer Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomAssortmentsByRetailer: async (retailerId: string, page?: number, size?: number, searchBy?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'retailerId' is not null or undefined
            assertParamExists('getCustomAssortmentsByRetailer', 'retailerId', retailerId)
            const localVarPath = `/custom-assortments/retailer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (retailerId !== undefined) {
                localVarQueryParameter['retailerId'] = retailerId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (searchBy !== undefined) {
                localVarQueryParameter['searchBy'] = searchBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update custom assortment
         * @param {string} id Custom assortment Id
         * @param {UpdateCustomAssortmentRequest} updateCustomAssortmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomAssortment: async (id: string, updateCustomAssortmentRequest: UpdateCustomAssortmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCustomAssortment', 'id', id)
            // verify required parameter 'updateCustomAssortmentRequest' is not null or undefined
            assertParamExists('updateCustomAssortment', 'updateCustomAssortmentRequest', updateCustomAssortmentRequest)
            const localVarPath = `/custom-assortments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomAssortmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomAssortmentControllerApi - functional programming interface
 * @export
 */
export const CustomAssortmentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomAssortmentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Create custom assortment. Returns Id of created custom assortment.
         * @param {CreateCustomAssortmentRequest} createCustomAssortmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomAssortment(createCustomAssortmentRequest: CreateCustomAssortmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomAssortment(createCustomAssortmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomAssortmentControllerApi.createCustomAssortment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete custom assortment
         * @param {string} id Custom assortment Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomAssortment(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomAssortment(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomAssortmentControllerApi.deleteCustomAssortment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get custom assortment by Id
         * @param {string} id Custom assortment Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomAssortment(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomAssortmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomAssortment(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomAssortmentControllerApi.getCustomAssortment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find all custom-assortments per multiple/custom criteria
         * @param {string} [retailerId] Retailer Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomAssortments(retailerId?: string, page?: number, size?: number, searchBy?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCustomAssortmentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomAssortments(retailerId, page, size, searchBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomAssortmentControllerApi.getCustomAssortments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find all custom-assortments for provided retailer
         * @param {string} retailerId Retailer Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomAssortmentsByRetailer(retailerId: string, page?: number, size?: number, searchBy?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCustomAssortmentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomAssortmentsByRetailer(retailerId, page, size, searchBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomAssortmentControllerApi.getCustomAssortmentsByRetailer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update custom assortment
         * @param {string} id Custom assortment Id
         * @param {UpdateCustomAssortmentRequest} updateCustomAssortmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomAssortment(id: string, updateCustomAssortmentRequest: UpdateCustomAssortmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomAssortment(id, updateCustomAssortmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomAssortmentControllerApi.updateCustomAssortment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomAssortmentControllerApi - factory interface
 * @export
 */
export const CustomAssortmentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomAssortmentControllerApiFp(configuration)
    return {
        /**
         * Create custom assortment. Returns Id of created custom assortment.
         * @param {CreateCustomAssortmentRequest} createCustomAssortmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomAssortment(createCustomAssortmentRequest: CreateCustomAssortmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper> {
            return localVarFp.createCustomAssortment(createCustomAssortmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete custom assortment
         * @param {string} id Custom assortment Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomAssortment(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCustomAssortment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get custom assortment by Id
         * @param {string} id Custom assortment Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomAssortment(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CustomAssortmentResponse> {
            return localVarFp.getCustomAssortment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Find all custom-assortments per multiple/custom criteria
         * @param {string} [retailerId] Retailer Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomAssortments(retailerId?: string, page?: number, size?: number, searchBy?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedCustomAssortmentsResponse> {
            return localVarFp.getCustomAssortments(retailerId, page, size, searchBy, options).then((request) => request(axios, basePath));
        },
        /**
         * Find all custom-assortments for provided retailer
         * @param {string} retailerId Retailer Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomAssortmentsByRetailer(retailerId: string, page?: number, size?: number, searchBy?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedCustomAssortmentsResponse> {
            return localVarFp.getCustomAssortmentsByRetailer(retailerId, page, size, searchBy, options).then((request) => request(axios, basePath));
        },
        /**
         * Update custom assortment
         * @param {string} id Custom assortment Id
         * @param {UpdateCustomAssortmentRequest} updateCustomAssortmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomAssortment(id: string, updateCustomAssortmentRequest: UpdateCustomAssortmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCustomAssortment(id, updateCustomAssortmentRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomAssortmentControllerApi - interface
 * @export
 * @interface CustomAssortmentControllerApi
 */
export interface CustomAssortmentControllerApiInterface {
    /**
     * Create custom assortment. Returns Id of created custom assortment.
     * @param {CreateCustomAssortmentRequest} createCustomAssortmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAssortmentControllerApiInterface
     */
    createCustomAssortment(createCustomAssortmentRequest: CreateCustomAssortmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper>;

    /**
     * Delete custom assortment
     * @param {string} id Custom assortment Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAssortmentControllerApiInterface
     */
    deleteCustomAssortment(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Get custom assortment by Id
     * @param {string} id Custom assortment Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAssortmentControllerApiInterface
     */
    getCustomAssortment(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CustomAssortmentResponse>;

    /**
     * Find all custom-assortments per multiple/custom criteria
     * @param {string} [retailerId] Retailer Id
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {string} [searchBy] Search by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAssortmentControllerApiInterface
     */
    getCustomAssortments(retailerId?: string, page?: number, size?: number, searchBy?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedCustomAssortmentsResponse>;

    /**
     * Find all custom-assortments for provided retailer
     * @param {string} retailerId Retailer Id
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {string} [searchBy] Search by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAssortmentControllerApiInterface
     */
    getCustomAssortmentsByRetailer(retailerId: string, page?: number, size?: number, searchBy?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedCustomAssortmentsResponse>;

    /**
     * Update custom assortment
     * @param {string} id Custom assortment Id
     * @param {UpdateCustomAssortmentRequest} updateCustomAssortmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAssortmentControllerApiInterface
     */
    updateCustomAssortment(id: string, updateCustomAssortmentRequest: UpdateCustomAssortmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * CustomAssortmentControllerApi - object-oriented interface
 * @export
 * @class CustomAssortmentControllerApi
 * @extends {BaseAPI}
 */
export class CustomAssortmentControllerApi extends BaseAPI implements CustomAssortmentControllerApiInterface {
    /**
     * Create custom assortment. Returns Id of created custom assortment.
     * @param {CreateCustomAssortmentRequest} createCustomAssortmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAssortmentControllerApi
     */
    public createCustomAssortment(createCustomAssortmentRequest: CreateCustomAssortmentRequest, options?: RawAxiosRequestConfig) {
        return CustomAssortmentControllerApiFp(this.configuration).createCustomAssortment(createCustomAssortmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete custom assortment
     * @param {string} id Custom assortment Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAssortmentControllerApi
     */
    public deleteCustomAssortment(id: string, options?: RawAxiosRequestConfig) {
        return CustomAssortmentControllerApiFp(this.configuration).deleteCustomAssortment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get custom assortment by Id
     * @param {string} id Custom assortment Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAssortmentControllerApi
     */
    public getCustomAssortment(id: string, options?: RawAxiosRequestConfig) {
        return CustomAssortmentControllerApiFp(this.configuration).getCustomAssortment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find all custom-assortments per multiple/custom criteria
     * @param {string} [retailerId] Retailer Id
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {string} [searchBy] Search by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAssortmentControllerApi
     */
    public getCustomAssortments(retailerId?: string, page?: number, size?: number, searchBy?: string, options?: RawAxiosRequestConfig) {
        return CustomAssortmentControllerApiFp(this.configuration).getCustomAssortments(retailerId, page, size, searchBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find all custom-assortments for provided retailer
     * @param {string} retailerId Retailer Id
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {string} [searchBy] Search by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAssortmentControllerApi
     */
    public getCustomAssortmentsByRetailer(retailerId: string, page?: number, size?: number, searchBy?: string, options?: RawAxiosRequestConfig) {
        return CustomAssortmentControllerApiFp(this.configuration).getCustomAssortmentsByRetailer(retailerId, page, size, searchBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update custom assortment
     * @param {string} id Custom assortment Id
     * @param {UpdateCustomAssortmentRequest} updateCustomAssortmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAssortmentControllerApi
     */
    public updateCustomAssortment(id: string, updateCustomAssortmentRequest: UpdateCustomAssortmentRequest, options?: RawAxiosRequestConfig) {
        return CustomAssortmentControllerApiFp(this.configuration).updateCustomAssortment(id, updateCustomAssortmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CxSupportControllerApi - axios parameter creator
 * @export
 */
export const CxSupportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id Order Id
         * @param {ApplyPromoCodeToOrderRequest} applyPromoCodeToOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyPromoCodeToOrder: async (id: string, applyPromoCodeToOrderRequest: ApplyPromoCodeToOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('applyPromoCodeToOrder', 'id', id)
            // verify required parameter 'applyPromoCodeToOrderRequest' is not null or undefined
            assertParamExists('applyPromoCodeToOrder', 'applyPromoCodeToOrderRequest', applyPromoCodeToOrderRequest)
            const localVarPath = `/support/orders/{id}/apply-promo-code`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applyPromoCodeToOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get estimated shipping by suborder id.
         * @param {string} suborderId Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateEstimatedShipping: async (suborderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'suborderId' is not null or undefined
            assertParamExists('calculateEstimatedShipping', 'suborderId', suborderId)
            const localVarPath = `/support/suborders/calculate-estimated-shipping/{suborderId}`
                .replace(`{${"suborderId"}}`, encodeURIComponent(String(suborderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MoveHoldSubordersToVoidStatusRequest} moveHoldSubordersToVoidStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeSuborderStatusToVoid: async (moveHoldSubordersToVoidStatusRequest: MoveHoldSubordersToVoidStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moveHoldSubordersToVoidStatusRequest' is not null or undefined
            assertParamExists('changeSuborderStatusToVoid', 'moveHoldSubordersToVoidStatusRequest', moveHoldSubordersToVoidStatusRequest)
            const localVarPath = `/support/suborders/move-hold-to-void`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveHoldSubordersToVoidStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete variant from cart for specified retailer
         * @param {string} retailerId Retailer Id
         * @param {string} variantId Variant Id
         * @param {boolean} validateCart Validate or ignore validation for cart.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVariantFromCartForRetailer: async (retailerId: string, variantId: string, validateCart: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'retailerId' is not null or undefined
            assertParamExists('deleteVariantFromCartForRetailer', 'retailerId', retailerId)
            // verify required parameter 'variantId' is not null or undefined
            assertParamExists('deleteVariantFromCartForRetailer', 'variantId', variantId)
            // verify required parameter 'validateCart' is not null or undefined
            assertParamExists('deleteVariantFromCartForRetailer', 'validateCart', validateCart)
            const localVarPath = `/support/cart/{retailerId}/{variantId}`
                .replace(`{${"retailerId"}}`, encodeURIComponent(String(retailerId)))
                .replace(`{${"variantId"}}`, encodeURIComponent(String(variantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (validateCart !== undefined) {
                localVarQueryParameter['validate_cart'] = validateCart;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFeatureFlags: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/feature-flags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get cart contents for specified retailer
         * @param {string} retailerId Retailer Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartContentsForRetailer: async (retailerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'retailerId' is not null or undefined
            assertParamExists('getCartContentsForRetailer', 'retailerId', retailerId)
            const localVarPath = `/support/carts/{retailerId}`
                .replace(`{${"retailerId"}}`, encodeURIComponent(String(retailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} featureKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureStatus: async (featureKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'featureKey' is not null or undefined
            assertParamExists('getFeatureStatus', 'featureKey', featureKey)
            const localVarPath = `/support/feature-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (featureKey !== undefined) {
                localVarQueryParameter['featureKey'] = featureKey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set suborder status to be cancel after balance mark transaction as cancelled
         * @param {string} suborderId Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSetSuborderAsCanceled: async (suborderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'suborderId' is not null or undefined
            assertParamExists('setSetSuborderAsCanceled', 'suborderId', suborderId)
            const localVarPath = `/support/suborders/{suborderId}/cancel`
                .replace(`{${"suborderId"}}`, encodeURIComponent(String(suborderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CxSupportControllerApi - functional programming interface
 * @export
 */
export const CxSupportControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CxSupportControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id Order Id
         * @param {ApplyPromoCodeToOrderRequest} applyPromoCodeToOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyPromoCodeToOrder(id: string, applyPromoCodeToOrderRequest: ApplyPromoCodeToOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyPromoCodeToOrder(id, applyPromoCodeToOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CxSupportControllerApi.applyPromoCodeToOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get estimated shipping by suborder id.
         * @param {string} suborderId Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateEstimatedShipping(suborderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EstimateShippingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateEstimatedShipping(suborderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CxSupportControllerApi.calculateEstimatedShipping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MoveHoldSubordersToVoidStatusRequest} moveHoldSubordersToVoidStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeSuborderStatusToVoid(moveHoldSubordersToVoidStatusRequest: MoveHoldSubordersToVoidStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeSuborderStatusToVoid(moveHoldSubordersToVoidStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CxSupportControllerApi.changeSuborderStatusToVoid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete variant from cart for specified retailer
         * @param {string} retailerId Retailer Id
         * @param {string} variantId Variant Id
         * @param {boolean} validateCart Validate or ignore validation for cart.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVariantFromCartForRetailer(retailerId: string, variantId: string, validateCart: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVariantFromCartForRetailer(retailerId, variantId, validateCart, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CxSupportControllerApi.deleteVariantFromCartForRetailer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllFeatureFlags(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: boolean; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllFeatureFlags(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CxSupportControllerApi.getAllFeatureFlags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get cart contents for specified retailer
         * @param {string} retailerId Retailer Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCartContentsForRetailer(retailerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCartContentsForRetailer(retailerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CxSupportControllerApi.getCartContentsForRetailer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} featureKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeatureStatus(featureKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeatureStatus(featureKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CxSupportControllerApi.getFeatureStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set suborder status to be cancel after balance mark transaction as cancelled
         * @param {string} suborderId Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setSetSuborderAsCanceled(suborderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setSetSuborderAsCanceled(suborderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CxSupportControllerApi.setSetSuborderAsCanceled']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CxSupportControllerApi - factory interface
 * @export
 */
export const CxSupportControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CxSupportControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id Order Id
         * @param {ApplyPromoCodeToOrderRequest} applyPromoCodeToOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyPromoCodeToOrder(id: string, applyPromoCodeToOrderRequest: ApplyPromoCodeToOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.applyPromoCodeToOrder(id, applyPromoCodeToOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get estimated shipping by suborder id.
         * @param {string} suborderId Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateEstimatedShipping(suborderId: string, options?: RawAxiosRequestConfig): AxiosPromise<EstimateShippingResponse> {
            return localVarFp.calculateEstimatedShipping(suborderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MoveHoldSubordersToVoidStatusRequest} moveHoldSubordersToVoidStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeSuborderStatusToVoid(moveHoldSubordersToVoidStatusRequest: MoveHoldSubordersToVoidStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changeSuborderStatusToVoid(moveHoldSubordersToVoidStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete variant from cart for specified retailer
         * @param {string} retailerId Retailer Id
         * @param {string} variantId Variant Id
         * @param {boolean} validateCart Validate or ignore validation for cart.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVariantFromCartForRetailer(retailerId: string, variantId: string, validateCart: boolean, options?: RawAxiosRequestConfig): AxiosPromise<CartResponse> {
            return localVarFp.deleteVariantFromCartForRetailer(retailerId, variantId, validateCart, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFeatureFlags(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: boolean; }> {
            return localVarFp.getAllFeatureFlags(options).then((request) => request(axios, basePath));
        },
        /**
         * Get cart contents for specified retailer
         * @param {string} retailerId Retailer Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartContentsForRetailer(retailerId: string, options?: RawAxiosRequestConfig): AxiosPromise<CartResponse> {
            return localVarFp.getCartContentsForRetailer(retailerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} featureKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureStatus(featureKey: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getFeatureStatus(featureKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Set suborder status to be cancel after balance mark transaction as cancelled
         * @param {string} suborderId Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSetSuborderAsCanceled(suborderId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setSetSuborderAsCanceled(suborderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CxSupportControllerApi - interface
 * @export
 * @interface CxSupportControllerApi
 */
export interface CxSupportControllerApiInterface {
    /**
     * 
     * @param {string} id Order Id
     * @param {ApplyPromoCodeToOrderRequest} applyPromoCodeToOrderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CxSupportControllerApiInterface
     */
    applyPromoCodeToOrder(id: string, applyPromoCodeToOrderRequest: ApplyPromoCodeToOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Get estimated shipping by suborder id.
     * @param {string} suborderId Suborder Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CxSupportControllerApiInterface
     */
    calculateEstimatedShipping(suborderId: string, options?: RawAxiosRequestConfig): AxiosPromise<EstimateShippingResponse>;

    /**
     * 
     * @param {MoveHoldSubordersToVoidStatusRequest} moveHoldSubordersToVoidStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CxSupportControllerApiInterface
     */
    changeSuborderStatusToVoid(moveHoldSubordersToVoidStatusRequest: MoveHoldSubordersToVoidStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Delete variant from cart for specified retailer
     * @param {string} retailerId Retailer Id
     * @param {string} variantId Variant Id
     * @param {boolean} validateCart Validate or ignore validation for cart.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CxSupportControllerApiInterface
     */
    deleteVariantFromCartForRetailer(retailerId: string, variantId: string, validateCart: boolean, options?: RawAxiosRequestConfig): AxiosPromise<CartResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CxSupportControllerApiInterface
     */
    getAllFeatureFlags(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: boolean; }>;

    /**
     * Get cart contents for specified retailer
     * @param {string} retailerId Retailer Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CxSupportControllerApiInterface
     */
    getCartContentsForRetailer(retailerId: string, options?: RawAxiosRequestConfig): AxiosPromise<CartResponse>;

    /**
     * 
     * @param {string} featureKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CxSupportControllerApiInterface
     */
    getFeatureStatus(featureKey: string, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * Set suborder status to be cancel after balance mark transaction as cancelled
     * @param {string} suborderId Suborder Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CxSupportControllerApiInterface
     */
    setSetSuborderAsCanceled(suborderId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * CxSupportControllerApi - object-oriented interface
 * @export
 * @class CxSupportControllerApi
 * @extends {BaseAPI}
 */
export class CxSupportControllerApi extends BaseAPI implements CxSupportControllerApiInterface {
    /**
     * 
     * @param {string} id Order Id
     * @param {ApplyPromoCodeToOrderRequest} applyPromoCodeToOrderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CxSupportControllerApi
     */
    public applyPromoCodeToOrder(id: string, applyPromoCodeToOrderRequest: ApplyPromoCodeToOrderRequest, options?: RawAxiosRequestConfig) {
        return CxSupportControllerApiFp(this.configuration).applyPromoCodeToOrder(id, applyPromoCodeToOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get estimated shipping by suborder id.
     * @param {string} suborderId Suborder Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CxSupportControllerApi
     */
    public calculateEstimatedShipping(suborderId: string, options?: RawAxiosRequestConfig) {
        return CxSupportControllerApiFp(this.configuration).calculateEstimatedShipping(suborderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MoveHoldSubordersToVoidStatusRequest} moveHoldSubordersToVoidStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CxSupportControllerApi
     */
    public changeSuborderStatusToVoid(moveHoldSubordersToVoidStatusRequest: MoveHoldSubordersToVoidStatusRequest, options?: RawAxiosRequestConfig) {
        return CxSupportControllerApiFp(this.configuration).changeSuborderStatusToVoid(moveHoldSubordersToVoidStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete variant from cart for specified retailer
     * @param {string} retailerId Retailer Id
     * @param {string} variantId Variant Id
     * @param {boolean} validateCart Validate or ignore validation for cart.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CxSupportControllerApi
     */
    public deleteVariantFromCartForRetailer(retailerId: string, variantId: string, validateCart: boolean, options?: RawAxiosRequestConfig) {
        return CxSupportControllerApiFp(this.configuration).deleteVariantFromCartForRetailer(retailerId, variantId, validateCart, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CxSupportControllerApi
     */
    public getAllFeatureFlags(options?: RawAxiosRequestConfig) {
        return CxSupportControllerApiFp(this.configuration).getAllFeatureFlags(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get cart contents for specified retailer
     * @param {string} retailerId Retailer Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CxSupportControllerApi
     */
    public getCartContentsForRetailer(retailerId: string, options?: RawAxiosRequestConfig) {
        return CxSupportControllerApiFp(this.configuration).getCartContentsForRetailer(retailerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} featureKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CxSupportControllerApi
     */
    public getFeatureStatus(featureKey: string, options?: RawAxiosRequestConfig) {
        return CxSupportControllerApiFp(this.configuration).getFeatureStatus(featureKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set suborder status to be cancel after balance mark transaction as cancelled
     * @param {string} suborderId Suborder Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CxSupportControllerApi
     */
    public setSetSuborderAsCanceled(suborderId: string, options?: RawAxiosRequestConfig) {
        return CxSupportControllerApiFp(this.configuration).setSetSuborderAsCanceled(suborderId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DataMigrationControllerApi - axios parameter creator
 * @export
 */
export const DataMigrationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add Buy On Bulletin flag to Algolia for existing brands.
         * @param {UpdateBrandAlgoliaFlagRequest} updateBrandAlgoliaFlagRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBrandBuyOnBulletinToAlgolia: async (updateBrandAlgoliaFlagRequest: UpdateBrandAlgoliaFlagRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateBrandAlgoliaFlagRequest' is not null or undefined
            assertParamExists('addBrandBuyOnBulletinToAlgolia', 'updateBrandAlgoliaFlagRequest', updateBrandAlgoliaFlagRequest)
            const localVarPath = `/data-migrations/algolia/brands/buy-on-bulletin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBrandAlgoliaFlagRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Mixpanel Brand profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBrandSourceInMixPanel: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/update-mixpanel-brand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update existing brands\' trade show data in Mixpanel
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBrandTradeShowDataInMixPanel: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('addBrandTradeShowDataInMixPanel', 'eventId', eventId)
            const localVarPath = `/data-migrations/mixpanel/trade-shows/{eventId}/brands`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Retailer\'s trade show data in Mixpanel
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRetailerTradeShowDataInMixPanel: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('addRetailerTradeShowDataInMixPanel', 'eventId', eventId)
            const localVarPath = `/data-migrations/mixpanel/trade-shows/{eventId}/retailers`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used to add new tags to existing product tags, and add product to automated collection if tag fulfills the criteria.This is only used for client request to add new tags so navigation collections fill up.
         * @param {AddTagsToProductsRequest} addTagsToProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTagsToProducts: async (addTagsToProductsRequest: AddTagsToProductsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addTagsToProductsRequest' is not null or undefined
            assertParamExists('addTagsToProducts', 'addTagsToProductsRequest', addTagsToProductsRequest)
            const localVarPath = `/data-migrations/products-tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addTagsToProductsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create boards for retailers with favorite products
         * @param {CreateBoardsForExistingRetailersRequest} createBoardsForExistingRetailersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBoardsForExistingRetailers: async (createBoardsForExistingRetailersRequest: CreateBoardsForExistingRetailersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBoardsForExistingRetailersRequest' is not null or undefined
            assertParamExists('createBoardsForExistingRetailers', 'createBoardsForExistingRetailersRequest', createBoardsForExistingRetailersRequest)
            const localVarPath = `/data-migrations/boards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBoardsForExistingRetailersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create Canadian Buyers on Balance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCanadianBuyers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/canadian-buyers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create DraftBrand entity for existing APPROVED and PENDING Brands
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDraftBrandForExistingBrands: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/brands/create-draft-brand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create draft brand entities for brands.
         * @param {CreateDraftBrandsRequest} createDraftBrandsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDraftBrands: async (createDraftBrandsRequest: CreateDraftBrandsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDraftBrandsRequest' is not null or undefined
            assertParamExists('createDraftBrands', 'createDraftBrandsRequest', createDraftBrandsRequest)
            const localVarPath = `/data-migrations/draft-brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDraftBrandsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create event log for that users with number_of_logins > 0.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPasswordChangedEventLogs: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/create-password-changed-event-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create vendor profile for exhibitor brands
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVendorProfileForExhibitors: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/brands/create-vendor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deactivate non USA retailers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateNonUSARetailers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/retailers/deactivate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete active custom assortment items with deleted products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomAssortmentItemsWithDeletedVariants: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/custom-assortment-items/deleted-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Migration which parse CSV file and import categories with weights
         * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCategoriesWithWeights: async (linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/import-category-weight`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(linkRetailersWithTradeShowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Migration which parse CSV file and import routable_id for brands
         * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importRoutableIdToBrandTable: async (linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/import-routable-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(linkRetailersWithTradeShowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateBrandCategories: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/brand-categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refill Product ids in parent containers with missing Products from children
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateParentCollection: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('migrateParentCollection', 'requestBody', requestBody)
            const localVarPath = `/data-migrations/navigation/view-containers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Migrate old posthooks and keep their IDs as IntegrationKeys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migratePosthooks: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/migrate-posthooks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Migration which fills brand with all categories thier products are from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateProductCategoriesFromBrands: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/brands/migrate-product-categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Migration which set promo code from orders to their suborders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migratePromoCodeToSuborders: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/suborders/promo-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Migration which set promo codes from cart to sub-cart level
         * @param {string} accessKey Access key
         * @param {string} secretKey Secret key
         * @param {string} tableName Table name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migratePromoCodesToSubCart: async (accessKey: string, secretKey: string, tableName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessKey' is not null or undefined
            assertParamExists('migratePromoCodesToSubCart', 'accessKey', accessKey)
            // verify required parameter 'secretKey' is not null or undefined
            assertParamExists('migratePromoCodesToSubCart', 'secretKey', secretKey)
            // verify required parameter 'tableName' is not null or undefined
            assertParamExists('migratePromoCodesToSubCart', 'tableName', tableName)
            const localVarPath = `/data-migrations/sub-carts/promo-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (accessKey !== undefined) {
                localVarQueryParameter['access_key'] = accessKey;
            }

            if (secretKey !== undefined) {
                localVarQueryParameter['secret_key'] = secretKey;
            }

            if (tableName !== undefined) {
                localVarQueryParameter['table_name'] = tableName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Migrate retailers default credit cards from Stripe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateRetailersDefaultCard: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/retailers/credit-cards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Migration which pull utm params and migrate them on Retailer table in database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateRetailersUtmParams: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/retailers/utm-params`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Migration which fills order and suborder ids for existing logs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOrderAndSuborderIdsToLogs: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/logs/migrate-suborder-information`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Migration which removes all duplicated product ids from all collections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDuplicatedProductIds: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/collections/remove-duplicated-product-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove Invalid Promo Codes from old carts saved on DynamoDB
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeInvalidPromoCodesFromCart: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/promo-codes/remove-invalids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Migration which remove promo codes from the cart level
         * @param {string} accessKey Access key
         * @param {string} secretKey Secret key
         * @param {string} tableName Table name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePromoCodesFromCart: async (accessKey: string, secretKey: string, tableName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessKey' is not null or undefined
            assertParamExists('removePromoCodesFromCart', 'accessKey', accessKey)
            // verify required parameter 'secretKey' is not null or undefined
            assertParamExists('removePromoCodesFromCart', 'secretKey', secretKey)
            // verify required parameter 'tableName' is not null or undefined
            assertParamExists('removePromoCodesFromCart', 'tableName', tableName)
            const localVarPath = `/data-migrations/carts/remove-promo-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (accessKey !== undefined) {
                localVarQueryParameter['access_key'] = accessKey;
            }

            if (secretKey !== undefined) {
                localVarQueryParameter['secret_key'] = secretKey;
            }

            if (tableName !== undefined) {
                localVarQueryParameter['table_name'] = tableName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove testers without product from custom assortment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTestersFromCustomAssortments: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/custom-assortments/remove-testers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update categories - Set new names for the categories provided
         * @param {ListRequestWrapperRenameCategoryRequest} listRequestWrapperRenameCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameCategories: async (listRequestWrapperRenameCategoryRequest: ListRequestWrapperRenameCategoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listRequestWrapperRenameCategoryRequest' is not null or undefined
            assertParamExists('renameCategories', 'listRequestWrapperRenameCategoryRequest', listRequestWrapperRenameCategoryRequest)
            const localVarPath = `/data-migrations/categories/rename`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listRequestWrapperRenameCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Backfill brands buy on bulletin flag on Mixpanel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBrandBuyOnBulletinOnMixpanel: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/mixpanel/brands/buy-on-bulletin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send notification email of a new trade show to brands existing on Bulletin prior to the passed import timestamp.
         * @param {string} eventId 
         * @param {SendNewTradeShowNotificationEmailToBrandsRequest} sendNewTradeShowNotificationEmailToBrandsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNewTradeShowNotificationEmailToBrands: async (eventId: string, sendNewTradeShowNotificationEmailToBrandsRequest: SendNewTradeShowNotificationEmailToBrandsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('sendNewTradeShowNotificationEmailToBrands', 'eventId', eventId)
            // verify required parameter 'sendNewTradeShowNotificationEmailToBrandsRequest' is not null or undefined
            assertParamExists('sendNewTradeShowNotificationEmailToBrands', 'sendNewTradeShowNotificationEmailToBrandsRequest', sendNewTradeShowNotificationEmailToBrandsRequest)
            const localVarPath = `/data-migrations/trade-shows/{eventId}/send-new-trade-show-notification-email`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendNewTradeShowNotificationEmailToBrandsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set refresh token in cookie for currently logged in user. Returns success status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setRefreshTokenInCookieForMigration: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/user/set-refresh-token-in-cookie`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update image url from the view components
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUpdateViewComponentsImageUrl: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/view-components/update-image-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Trim brand name on Database, Algolia 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trimBrandName: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/brand-names`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check all tags on platform and trim them if any tag has redundant empty spaces at ther beginning or end.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trimTags: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/tags/trim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Exhibitors with created products buy on bulletin flag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExhibitorsBuyOnBulletin: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/brands/exhibitors/buy-on-bulletin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update products with more than 3 characteristics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductCharacteristics: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/products/update-characteristics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Partially reindex products from categories with changes
         * @param {ListRequestWrapperUUID} listRequestWrapperUUID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductsFromCategoriesOnAlgolia: async (listRequestWrapperUUID: ListRequestWrapperUUID, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listRequestWrapperUUID' is not null or undefined
            assertParamExists('updateProductsFromCategoriesOnAlgolia', 'listRequestWrapperUUID', listRequestWrapperUUID)
            const localVarPath = `/data-migrations/products/categories/reindex`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listRequestWrapperUUID, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Migration which sets all active product which aren\'t testers to visible
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductsToVisible: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/products/visible`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Migration which updates Suborders on Salesforce. Can be executed N times.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesforceSuborders: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data-migrations/salesforce/suborders/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update order status by suborder Id and brand Id
         * @param {UpdateSuborderStatusRequest} updateSuborderStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatus: async (updateSuborderStatusRequest: UpdateSuborderStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateSuborderStatusRequest' is not null or undefined
            assertParamExists('updateStatus', 'updateSuborderStatusRequest', updateSuborderStatusRequest)
            const localVarPath = `/data-migrations/suborders/update-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSuborderStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataMigrationControllerApi - functional programming interface
 * @export
 */
export const DataMigrationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataMigrationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add Buy On Bulletin flag to Algolia for existing brands.
         * @param {UpdateBrandAlgoliaFlagRequest} updateBrandAlgoliaFlagRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addBrandBuyOnBulletinToAlgolia(updateBrandAlgoliaFlagRequest: UpdateBrandAlgoliaFlagRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addBrandBuyOnBulletinToAlgolia(updateBrandAlgoliaFlagRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.addBrandBuyOnBulletinToAlgolia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update Mixpanel Brand profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addBrandSourceInMixPanel(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addBrandSourceInMixPanel(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.addBrandSourceInMixPanel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update existing brands\' trade show data in Mixpanel
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addBrandTradeShowDataInMixPanel(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addBrandTradeShowDataInMixPanel(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.addBrandTradeShowDataInMixPanel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update Retailer\'s trade show data in Mixpanel
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addRetailerTradeShowDataInMixPanel(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addRetailerTradeShowDataInMixPanel(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.addRetailerTradeShowDataInMixPanel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Used to add new tags to existing product tags, and add product to automated collection if tag fulfills the criteria.This is only used for client request to add new tags so navigation collections fill up.
         * @param {AddTagsToProductsRequest} addTagsToProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTagsToProducts(addTagsToProductsRequest: AddTagsToProductsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTagsToProducts(addTagsToProductsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.addTagsToProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create boards for retailers with favorite products
         * @param {CreateBoardsForExistingRetailersRequest} createBoardsForExistingRetailersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBoardsForExistingRetailers(createBoardsForExistingRetailersRequest: CreateBoardsForExistingRetailersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBoardsForExistingRetailers(createBoardsForExistingRetailersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.createBoardsForExistingRetailers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create Canadian Buyers on Balance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCanadianBuyers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCanadianBuyers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.createCanadianBuyers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create DraftBrand entity for existing APPROVED and PENDING Brands
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDraftBrandForExistingBrands(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDraftBrandForExistingBrands(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.createDraftBrandForExistingBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create draft brand entities for brands.
         * @param {CreateDraftBrandsRequest} createDraftBrandsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDraftBrands(createDraftBrandsRequest: CreateDraftBrandsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDraftBrands(createDraftBrandsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.createDraftBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create event log for that users with number_of_logins > 0.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPasswordChangedEventLogs(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPasswordChangedEventLogs(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.createPasswordChangedEventLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create vendor profile for exhibitor brands
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVendorProfileForExhibitors(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVendorProfileForExhibitors(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.createVendorProfileForExhibitors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deactivate non USA retailers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateNonUSARetailers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateNonUSARetailers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.deactivateNonUSARetailers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete active custom assortment items with deleted products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomAssortmentItemsWithDeletedVariants(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomAssortmentItemsWithDeletedVariants(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.deleteCustomAssortmentItemsWithDeletedVariants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Migration which parse CSV file and import categories with weights
         * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importCategoriesWithWeights(linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importCategoriesWithWeights(linkRetailersWithTradeShowRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.importCategoriesWithWeights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Migration which parse CSV file and import routable_id for brands
         * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importRoutableIdToBrandTable(linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importRoutableIdToBrandTable(linkRetailersWithTradeShowRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.importRoutableIdToBrandTable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async migrateBrandCategories(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.migrateBrandCategories(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.migrateBrandCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Refill Product ids in parent containers with missing Products from children
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async migrateParentCollection(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.migrateParentCollection(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.migrateParentCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Migrate old posthooks and keep their IDs as IntegrationKeys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async migratePosthooks(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.migratePosthooks(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.migratePosthooks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Migration which fills brand with all categories thier products are from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async migrateProductCategoriesFromBrands(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.migrateProductCategoriesFromBrands(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.migrateProductCategoriesFromBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Migration which set promo code from orders to their suborders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async migratePromoCodeToSuborders(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.migratePromoCodeToSuborders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.migratePromoCodeToSuborders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Migration which set promo codes from cart to sub-cart level
         * @param {string} accessKey Access key
         * @param {string} secretKey Secret key
         * @param {string} tableName Table name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async migratePromoCodesToSubCart(accessKey: string, secretKey: string, tableName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.migratePromoCodesToSubCart(accessKey, secretKey, tableName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.migratePromoCodesToSubCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Migrate retailers default credit cards from Stripe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async migrateRetailersDefaultCard(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.migrateRetailersDefaultCard(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.migrateRetailersDefaultCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Migration which pull utm params and migrate them on Retailer table in database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async migrateRetailersUtmParams(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.migrateRetailersUtmParams(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.migrateRetailersUtmParams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Migration which fills order and suborder ids for existing logs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putOrderAndSuborderIdsToLogs(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putOrderAndSuborderIdsToLogs(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.putOrderAndSuborderIdsToLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Migration which removes all duplicated product ids from all collections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeDuplicatedProductIds(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeDuplicatedProductIds(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.removeDuplicatedProductIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove Invalid Promo Codes from old carts saved on DynamoDB
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeInvalidPromoCodesFromCart(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeInvalidPromoCodesFromCart(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.removeInvalidPromoCodesFromCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Migration which remove promo codes from the cart level
         * @param {string} accessKey Access key
         * @param {string} secretKey Secret key
         * @param {string} tableName Table name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removePromoCodesFromCart(accessKey: string, secretKey: string, tableName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removePromoCodesFromCart(accessKey, secretKey, tableName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.removePromoCodesFromCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove testers without product from custom assortment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeTestersFromCustomAssortments(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeTestersFromCustomAssortments(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.removeTestersFromCustomAssortments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update categories - Set new names for the categories provided
         * @param {ListRequestWrapperRenameCategoryRequest} listRequestWrapperRenameCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renameCategories(listRequestWrapperRenameCategoryRequest: ListRequestWrapperRenameCategoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renameCategories(listRequestWrapperRenameCategoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.renameCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Backfill brands buy on bulletin flag on Mixpanel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendBrandBuyOnBulletinOnMixpanel(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendBrandBuyOnBulletinOnMixpanel(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.sendBrandBuyOnBulletinOnMixpanel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send notification email of a new trade show to brands existing on Bulletin prior to the passed import timestamp.
         * @param {string} eventId 
         * @param {SendNewTradeShowNotificationEmailToBrandsRequest} sendNewTradeShowNotificationEmailToBrandsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendNewTradeShowNotificationEmailToBrands(eventId: string, sendNewTradeShowNotificationEmailToBrandsRequest: SendNewTradeShowNotificationEmailToBrandsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendNewTradeShowNotificationEmailToBrands(eventId, sendNewTradeShowNotificationEmailToBrandsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.sendNewTradeShowNotificationEmailToBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set refresh token in cookie for currently logged in user. Returns success status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setRefreshTokenInCookieForMigration(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setRefreshTokenInCookieForMigration(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.setRefreshTokenInCookieForMigration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update image url from the view components
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setUpdateViewComponentsImageUrl(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setUpdateViewComponentsImageUrl(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.setUpdateViewComponentsImageUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Trim brand name on Database, Algolia 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trimBrandName(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trimBrandName(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.trimBrandName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check all tags on platform and trim them if any tag has redundant empty spaces at ther beginning or end.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trimTags(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trimTags(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.trimTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update Exhibitors with created products buy on bulletin flag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExhibitorsBuyOnBulletin(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExhibitorsBuyOnBulletin(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.updateExhibitorsBuyOnBulletin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update products with more than 3 characteristics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductCharacteristics(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductCharacteristics(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.updateProductCharacteristics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Partially reindex products from categories with changes
         * @param {ListRequestWrapperUUID} listRequestWrapperUUID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductsFromCategoriesOnAlgolia(listRequestWrapperUUID: ListRequestWrapperUUID, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductsFromCategoriesOnAlgolia(listRequestWrapperUUID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.updateProductsFromCategoriesOnAlgolia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Migration which sets all active product which aren\'t testers to visible
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductsToVisible(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductsToVisible(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.updateProductsToVisible']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Migration which updates Suborders on Salesforce. Can be executed N times.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSalesforceSuborders(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSalesforceSuborders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.updateSalesforceSuborders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update order status by suborder Id and brand Id
         * @param {UpdateSuborderStatusRequest} updateSuborderStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStatus(updateSuborderStatusRequest: UpdateSuborderStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStatus(updateSuborderStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataMigrationControllerApi.updateStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DataMigrationControllerApi - factory interface
 * @export
 */
export const DataMigrationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataMigrationControllerApiFp(configuration)
    return {
        /**
         * Add Buy On Bulletin flag to Algolia for existing brands.
         * @param {UpdateBrandAlgoliaFlagRequest} updateBrandAlgoliaFlagRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBrandBuyOnBulletinToAlgolia(updateBrandAlgoliaFlagRequest: UpdateBrandAlgoliaFlagRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addBrandBuyOnBulletinToAlgolia(updateBrandAlgoliaFlagRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update Mixpanel Brand profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBrandSourceInMixPanel(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addBrandSourceInMixPanel(options).then((request) => request(axios, basePath));
        },
        /**
         * Update existing brands\' trade show data in Mixpanel
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBrandTradeShowDataInMixPanel(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addBrandTradeShowDataInMixPanel(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update Retailer\'s trade show data in Mixpanel
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRetailerTradeShowDataInMixPanel(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addRetailerTradeShowDataInMixPanel(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Used to add new tags to existing product tags, and add product to automated collection if tag fulfills the criteria.This is only used for client request to add new tags so navigation collections fill up.
         * @param {AddTagsToProductsRequest} addTagsToProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTagsToProducts(addTagsToProductsRequest: AddTagsToProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addTagsToProducts(addTagsToProductsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create boards for retailers with favorite products
         * @param {CreateBoardsForExistingRetailersRequest} createBoardsForExistingRetailersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBoardsForExistingRetailers(createBoardsForExistingRetailersRequest: CreateBoardsForExistingRetailersRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createBoardsForExistingRetailers(createBoardsForExistingRetailersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create Canadian Buyers on Balance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCanadianBuyers(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createCanadianBuyers(options).then((request) => request(axios, basePath));
        },
        /**
         * Create DraftBrand entity for existing APPROVED and PENDING Brands
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDraftBrandForExistingBrands(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createDraftBrandForExistingBrands(options).then((request) => request(axios, basePath));
        },
        /**
         * Create draft brand entities for brands.
         * @param {CreateDraftBrandsRequest} createDraftBrandsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDraftBrands(createDraftBrandsRequest: CreateDraftBrandsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createDraftBrands(createDraftBrandsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create event log for that users with number_of_logins > 0.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPasswordChangedEventLogs(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createPasswordChangedEventLogs(options).then((request) => request(axios, basePath));
        },
        /**
         * Create vendor profile for exhibitor brands
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVendorProfileForExhibitors(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createVendorProfileForExhibitors(options).then((request) => request(axios, basePath));
        },
        /**
         * Deactivate non USA retailers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateNonUSARetailers(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deactivateNonUSARetailers(options).then((request) => request(axios, basePath));
        },
        /**
         * Delete active custom assortment items with deleted products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomAssortmentItemsWithDeletedVariants(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCustomAssortmentItemsWithDeletedVariants(options).then((request) => request(axios, basePath));
        },
        /**
         * Migration which parse CSV file and import categories with weights
         * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCategoriesWithWeights(linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.importCategoriesWithWeights(linkRetailersWithTradeShowRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Migration which parse CSV file and import routable_id for brands
         * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importRoutableIdToBrandTable(linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.importRoutableIdToBrandTable(linkRetailersWithTradeShowRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateBrandCategories(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.migrateBrandCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * Refill Product ids in parent containers with missing Products from children
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateParentCollection(requestBody: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.migrateParentCollection(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Migrate old posthooks and keep their IDs as IntegrationKeys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migratePosthooks(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.migratePosthooks(options).then((request) => request(axios, basePath));
        },
        /**
         * Migration which fills brand with all categories thier products are from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateProductCategoriesFromBrands(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.migrateProductCategoriesFromBrands(options).then((request) => request(axios, basePath));
        },
        /**
         * Migration which set promo code from orders to their suborders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migratePromoCodeToSuborders(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.migratePromoCodeToSuborders(options).then((request) => request(axios, basePath));
        },
        /**
         * Migration which set promo codes from cart to sub-cart level
         * @param {string} accessKey Access key
         * @param {string} secretKey Secret key
         * @param {string} tableName Table name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migratePromoCodesToSubCart(accessKey: string, secretKey: string, tableName: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.migratePromoCodesToSubCart(accessKey, secretKey, tableName, options).then((request) => request(axios, basePath));
        },
        /**
         * Migrate retailers default credit cards from Stripe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateRetailersDefaultCard(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.migrateRetailersDefaultCard(options).then((request) => request(axios, basePath));
        },
        /**
         * Migration which pull utm params and migrate them on Retailer table in database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateRetailersUtmParams(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.migrateRetailersUtmParams(options).then((request) => request(axios, basePath));
        },
        /**
         * Migration which fills order and suborder ids for existing logs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOrderAndSuborderIdsToLogs(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putOrderAndSuborderIdsToLogs(options).then((request) => request(axios, basePath));
        },
        /**
         * Migration which removes all duplicated product ids from all collections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDuplicatedProductIds(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeDuplicatedProductIds(options).then((request) => request(axios, basePath));
        },
        /**
         * Remove Invalid Promo Codes from old carts saved on DynamoDB
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeInvalidPromoCodesFromCart(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeInvalidPromoCodesFromCart(options).then((request) => request(axios, basePath));
        },
        /**
         * Migration which remove promo codes from the cart level
         * @param {string} accessKey Access key
         * @param {string} secretKey Secret key
         * @param {string} tableName Table name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePromoCodesFromCart(accessKey: string, secretKey: string, tableName: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removePromoCodesFromCart(accessKey, secretKey, tableName, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove testers without product from custom assortment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTestersFromCustomAssortments(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeTestersFromCustomAssortments(options).then((request) => request(axios, basePath));
        },
        /**
         * Update categories - Set new names for the categories provided
         * @param {ListRequestWrapperRenameCategoryRequest} listRequestWrapperRenameCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameCategories(listRequestWrapperRenameCategoryRequest: ListRequestWrapperRenameCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.renameCategories(listRequestWrapperRenameCategoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Backfill brands buy on bulletin flag on Mixpanel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBrandBuyOnBulletinOnMixpanel(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendBrandBuyOnBulletinOnMixpanel(options).then((request) => request(axios, basePath));
        },
        /**
         * Send notification email of a new trade show to brands existing on Bulletin prior to the passed import timestamp.
         * @param {string} eventId 
         * @param {SendNewTradeShowNotificationEmailToBrandsRequest} sendNewTradeShowNotificationEmailToBrandsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNewTradeShowNotificationEmailToBrands(eventId: string, sendNewTradeShowNotificationEmailToBrandsRequest: SendNewTradeShowNotificationEmailToBrandsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendNewTradeShowNotificationEmailToBrands(eventId, sendNewTradeShowNotificationEmailToBrandsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Set refresh token in cookie for currently logged in user. Returns success status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setRefreshTokenInCookieForMigration(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.setRefreshTokenInCookieForMigration(options).then((request) => request(axios, basePath));
        },
        /**
         * Update image url from the view components
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUpdateViewComponentsImageUrl(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setUpdateViewComponentsImageUrl(options).then((request) => request(axios, basePath));
        },
        /**
         * Trim brand name on Database, Algolia 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trimBrandName(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.trimBrandName(options).then((request) => request(axios, basePath));
        },
        /**
         * Check all tags on platform and trim them if any tag has redundant empty spaces at ther beginning or end.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trimTags(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.trimTags(options).then((request) => request(axios, basePath));
        },
        /**
         * Update Exhibitors with created products buy on bulletin flag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExhibitorsBuyOnBulletin(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateExhibitorsBuyOnBulletin(options).then((request) => request(axios, basePath));
        },
        /**
         * Update products with more than 3 characteristics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductCharacteristics(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProductCharacteristics(options).then((request) => request(axios, basePath));
        },
        /**
         * Partially reindex products from categories with changes
         * @param {ListRequestWrapperUUID} listRequestWrapperUUID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductsFromCategoriesOnAlgolia(listRequestWrapperUUID: ListRequestWrapperUUID, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProductsFromCategoriesOnAlgolia(listRequestWrapperUUID, options).then((request) => request(axios, basePath));
        },
        /**
         * Migration which sets all active product which aren\'t testers to visible
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductsToVisible(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProductsToVisible(options).then((request) => request(axios, basePath));
        },
        /**
         * Migration which updates Suborders on Salesforce. Can be executed N times.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesforceSuborders(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSalesforceSuborders(options).then((request) => request(axios, basePath));
        },
        /**
         * Update order status by suborder Id and brand Id
         * @param {UpdateSuborderStatusRequest} updateSuborderStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatus(updateSuborderStatusRequest: UpdateSuborderStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateStatus(updateSuborderStatusRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataMigrationControllerApi - interface
 * @export
 * @interface DataMigrationControllerApi
 */
export interface DataMigrationControllerApiInterface {
    /**
     * Add Buy On Bulletin flag to Algolia for existing brands.
     * @param {UpdateBrandAlgoliaFlagRequest} updateBrandAlgoliaFlagRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    addBrandBuyOnBulletinToAlgolia(updateBrandAlgoliaFlagRequest: UpdateBrandAlgoliaFlagRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update Mixpanel Brand profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    addBrandSourceInMixPanel(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update existing brands\' trade show data in Mixpanel
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    addBrandTradeShowDataInMixPanel(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update Retailer\'s trade show data in Mixpanel
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    addRetailerTradeShowDataInMixPanel(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Used to add new tags to existing product tags, and add product to automated collection if tag fulfills the criteria.This is only used for client request to add new tags so navigation collections fill up.
     * @param {AddTagsToProductsRequest} addTagsToProductsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    addTagsToProducts(addTagsToProductsRequest: AddTagsToProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Create boards for retailers with favorite products
     * @param {CreateBoardsForExistingRetailersRequest} createBoardsForExistingRetailersRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    createBoardsForExistingRetailers(createBoardsForExistingRetailersRequest: CreateBoardsForExistingRetailersRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Create Canadian Buyers on Balance
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    createCanadianBuyers(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Create DraftBrand entity for existing APPROVED and PENDING Brands
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    createDraftBrandForExistingBrands(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Create draft brand entities for brands.
     * @param {CreateDraftBrandsRequest} createDraftBrandsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    createDraftBrands(createDraftBrandsRequest: CreateDraftBrandsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Create event log for that users with number_of_logins > 0.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    createPasswordChangedEventLogs(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Create vendor profile for exhibitor brands
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    createVendorProfileForExhibitors(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Deactivate non USA retailers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    deactivateNonUSARetailers(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Delete active custom assortment items with deleted products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    deleteCustomAssortmentItemsWithDeletedVariants(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Migration which parse CSV file and import categories with weights
     * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    importCategoriesWithWeights(linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Migration which parse CSV file and import routable_id for brands
     * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    importRoutableIdToBrandTable(linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    migrateBrandCategories(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Refill Product ids in parent containers with missing Products from children
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    migrateParentCollection(requestBody: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Migrate old posthooks and keep their IDs as IntegrationKeys
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    migratePosthooks(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Migration which fills brand with all categories thier products are from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    migrateProductCategoriesFromBrands(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Migration which set promo code from orders to their suborders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    migratePromoCodeToSuborders(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Migration which set promo codes from cart to sub-cart level
     * @param {string} accessKey Access key
     * @param {string} secretKey Secret key
     * @param {string} tableName Table name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    migratePromoCodesToSubCart(accessKey: string, secretKey: string, tableName: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Migrate retailers default credit cards from Stripe
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    migrateRetailersDefaultCard(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Migration which pull utm params and migrate them on Retailer table in database
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    migrateRetailersUtmParams(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Migration which fills order and suborder ids for existing logs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    putOrderAndSuborderIdsToLogs(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Migration which removes all duplicated product ids from all collections
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    removeDuplicatedProductIds(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Remove Invalid Promo Codes from old carts saved on DynamoDB
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    removeInvalidPromoCodesFromCart(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Migration which remove promo codes from the cart level
     * @param {string} accessKey Access key
     * @param {string} secretKey Secret key
     * @param {string} tableName Table name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    removePromoCodesFromCart(accessKey: string, secretKey: string, tableName: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Remove testers without product from custom assortment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    removeTestersFromCustomAssortments(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update categories - Set new names for the categories provided
     * @param {ListRequestWrapperRenameCategoryRequest} listRequestWrapperRenameCategoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    renameCategories(listRequestWrapperRenameCategoryRequest: ListRequestWrapperRenameCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Backfill brands buy on bulletin flag on Mixpanel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    sendBrandBuyOnBulletinOnMixpanel(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Send notification email of a new trade show to brands existing on Bulletin prior to the passed import timestamp.
     * @param {string} eventId 
     * @param {SendNewTradeShowNotificationEmailToBrandsRequest} sendNewTradeShowNotificationEmailToBrandsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    sendNewTradeShowNotificationEmailToBrands(eventId: string, sendNewTradeShowNotificationEmailToBrandsRequest: SendNewTradeShowNotificationEmailToBrandsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Set refresh token in cookie for currently logged in user. Returns success status.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    setRefreshTokenInCookieForMigration(options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * Update image url from the view components
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    setUpdateViewComponentsImageUrl(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Trim brand name on Database, Algolia 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    trimBrandName(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Check all tags on platform and trim them if any tag has redundant empty spaces at ther beginning or end.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    trimTags(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update Exhibitors with created products buy on bulletin flag 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    updateExhibitorsBuyOnBulletin(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update products with more than 3 characteristics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    updateProductCharacteristics(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Partially reindex products from categories with changes
     * @param {ListRequestWrapperUUID} listRequestWrapperUUID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    updateProductsFromCategoriesOnAlgolia(listRequestWrapperUUID: ListRequestWrapperUUID, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Migration which sets all active product which aren\'t testers to visible
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    updateProductsToVisible(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Migration which updates Suborders on Salesforce. Can be executed N times.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    updateSalesforceSuborders(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update order status by suborder Id and brand Id
     * @param {UpdateSuborderStatusRequest} updateSuborderStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApiInterface
     */
    updateStatus(updateSuborderStatusRequest: UpdateSuborderStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * DataMigrationControllerApi - object-oriented interface
 * @export
 * @class DataMigrationControllerApi
 * @extends {BaseAPI}
 */
export class DataMigrationControllerApi extends BaseAPI implements DataMigrationControllerApiInterface {
    /**
     * Add Buy On Bulletin flag to Algolia for existing brands.
     * @param {UpdateBrandAlgoliaFlagRequest} updateBrandAlgoliaFlagRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public addBrandBuyOnBulletinToAlgolia(updateBrandAlgoliaFlagRequest: UpdateBrandAlgoliaFlagRequest, options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).addBrandBuyOnBulletinToAlgolia(updateBrandAlgoliaFlagRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Mixpanel Brand profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public addBrandSourceInMixPanel(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).addBrandSourceInMixPanel(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update existing brands\' trade show data in Mixpanel
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public addBrandTradeShowDataInMixPanel(eventId: string, options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).addBrandTradeShowDataInMixPanel(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Retailer\'s trade show data in Mixpanel
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public addRetailerTradeShowDataInMixPanel(eventId: string, options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).addRetailerTradeShowDataInMixPanel(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used to add new tags to existing product tags, and add product to automated collection if tag fulfills the criteria.This is only used for client request to add new tags so navigation collections fill up.
     * @param {AddTagsToProductsRequest} addTagsToProductsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public addTagsToProducts(addTagsToProductsRequest: AddTagsToProductsRequest, options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).addTagsToProducts(addTagsToProductsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create boards for retailers with favorite products
     * @param {CreateBoardsForExistingRetailersRequest} createBoardsForExistingRetailersRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public createBoardsForExistingRetailers(createBoardsForExistingRetailersRequest: CreateBoardsForExistingRetailersRequest, options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).createBoardsForExistingRetailers(createBoardsForExistingRetailersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create Canadian Buyers on Balance
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public createCanadianBuyers(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).createCanadianBuyers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create DraftBrand entity for existing APPROVED and PENDING Brands
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public createDraftBrandForExistingBrands(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).createDraftBrandForExistingBrands(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create draft brand entities for brands.
     * @param {CreateDraftBrandsRequest} createDraftBrandsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public createDraftBrands(createDraftBrandsRequest: CreateDraftBrandsRequest, options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).createDraftBrands(createDraftBrandsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create event log for that users with number_of_logins > 0.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public createPasswordChangedEventLogs(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).createPasswordChangedEventLogs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create vendor profile for exhibitor brands
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public createVendorProfileForExhibitors(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).createVendorProfileForExhibitors(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deactivate non USA retailers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public deactivateNonUSARetailers(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).deactivateNonUSARetailers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete active custom assortment items with deleted products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public deleteCustomAssortmentItemsWithDeletedVariants(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).deleteCustomAssortmentItemsWithDeletedVariants(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Migration which parse CSV file and import categories with weights
     * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public importCategoriesWithWeights(linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).importCategoriesWithWeights(linkRetailersWithTradeShowRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Migration which parse CSV file and import routable_id for brands
     * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public importRoutableIdToBrandTable(linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).importRoutableIdToBrandTable(linkRetailersWithTradeShowRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public migrateBrandCategories(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).migrateBrandCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Refill Product ids in parent containers with missing Products from children
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public migrateParentCollection(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).migrateParentCollection(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Migrate old posthooks and keep their IDs as IntegrationKeys
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public migratePosthooks(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).migratePosthooks(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Migration which fills brand with all categories thier products are from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public migrateProductCategoriesFromBrands(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).migrateProductCategoriesFromBrands(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Migration which set promo code from orders to their suborders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public migratePromoCodeToSuborders(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).migratePromoCodeToSuborders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Migration which set promo codes from cart to sub-cart level
     * @param {string} accessKey Access key
     * @param {string} secretKey Secret key
     * @param {string} tableName Table name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public migratePromoCodesToSubCart(accessKey: string, secretKey: string, tableName: string, options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).migratePromoCodesToSubCart(accessKey, secretKey, tableName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Migrate retailers default credit cards from Stripe
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public migrateRetailersDefaultCard(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).migrateRetailersDefaultCard(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Migration which pull utm params and migrate them on Retailer table in database
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public migrateRetailersUtmParams(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).migrateRetailersUtmParams(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Migration which fills order and suborder ids for existing logs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public putOrderAndSuborderIdsToLogs(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).putOrderAndSuborderIdsToLogs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Migration which removes all duplicated product ids from all collections
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public removeDuplicatedProductIds(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).removeDuplicatedProductIds(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove Invalid Promo Codes from old carts saved on DynamoDB
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public removeInvalidPromoCodesFromCart(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).removeInvalidPromoCodesFromCart(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Migration which remove promo codes from the cart level
     * @param {string} accessKey Access key
     * @param {string} secretKey Secret key
     * @param {string} tableName Table name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public removePromoCodesFromCart(accessKey: string, secretKey: string, tableName: string, options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).removePromoCodesFromCart(accessKey, secretKey, tableName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove testers without product from custom assortment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public removeTestersFromCustomAssortments(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).removeTestersFromCustomAssortments(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update categories - Set new names for the categories provided
     * @param {ListRequestWrapperRenameCategoryRequest} listRequestWrapperRenameCategoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public renameCategories(listRequestWrapperRenameCategoryRequest: ListRequestWrapperRenameCategoryRequest, options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).renameCategories(listRequestWrapperRenameCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Backfill brands buy on bulletin flag on Mixpanel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public sendBrandBuyOnBulletinOnMixpanel(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).sendBrandBuyOnBulletinOnMixpanel(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send notification email of a new trade show to brands existing on Bulletin prior to the passed import timestamp.
     * @param {string} eventId 
     * @param {SendNewTradeShowNotificationEmailToBrandsRequest} sendNewTradeShowNotificationEmailToBrandsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public sendNewTradeShowNotificationEmailToBrands(eventId: string, sendNewTradeShowNotificationEmailToBrandsRequest: SendNewTradeShowNotificationEmailToBrandsRequest, options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).sendNewTradeShowNotificationEmailToBrands(eventId, sendNewTradeShowNotificationEmailToBrandsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set refresh token in cookie for currently logged in user. Returns success status.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public setRefreshTokenInCookieForMigration(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).setRefreshTokenInCookieForMigration(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update image url from the view components
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public setUpdateViewComponentsImageUrl(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).setUpdateViewComponentsImageUrl(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Trim brand name on Database, Algolia 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public trimBrandName(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).trimBrandName(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check all tags on platform and trim them if any tag has redundant empty spaces at ther beginning or end.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public trimTags(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).trimTags(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Exhibitors with created products buy on bulletin flag 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public updateExhibitorsBuyOnBulletin(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).updateExhibitorsBuyOnBulletin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update products with more than 3 characteristics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public updateProductCharacteristics(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).updateProductCharacteristics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Partially reindex products from categories with changes
     * @param {ListRequestWrapperUUID} listRequestWrapperUUID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public updateProductsFromCategoriesOnAlgolia(listRequestWrapperUUID: ListRequestWrapperUUID, options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).updateProductsFromCategoriesOnAlgolia(listRequestWrapperUUID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Migration which sets all active product which aren\'t testers to visible
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public updateProductsToVisible(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).updateProductsToVisible(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Migration which updates Suborders on Salesforce. Can be executed N times.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public updateSalesforceSuborders(options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).updateSalesforceSuborders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update order status by suborder Id and brand Id
     * @param {UpdateSuborderStatusRequest} updateSuborderStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataMigrationControllerApi
     */
    public updateStatus(updateSuborderStatusRequest: UpdateSuborderStatusRequest, options?: RawAxiosRequestConfig) {
        return DataMigrationControllerApiFp(this.configuration).updateStatus(updateSuborderStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FileControllerApi - axios parameter creator
 * @export
 */
export const FileControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Upload file
         * @param {UploadFileRequest} [uploadFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile: async (uploadFileRequest?: UploadFileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadFileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileControllerApi - functional programming interface
 * @export
 */
export const FileControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FileControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Upload file
         * @param {UploadFileRequest} [uploadFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFile(uploadFileRequest?: UploadFileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadFileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFile(uploadFileRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileControllerApi.uploadFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FileControllerApi - factory interface
 * @export
 */
export const FileControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FileControllerApiFp(configuration)
    return {
        /**
         * Upload file
         * @param {UploadFileRequest} [uploadFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile(uploadFileRequest?: UploadFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadFileResponse> {
            return localVarFp.uploadFile(uploadFileRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FileControllerApi - interface
 * @export
 * @interface FileControllerApi
 */
export interface FileControllerApiInterface {
    /**
     * Upload file
     * @param {UploadFileRequest} [uploadFileRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileControllerApiInterface
     */
    uploadFile(uploadFileRequest?: UploadFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadFileResponse>;

}

/**
 * FileControllerApi - object-oriented interface
 * @export
 * @class FileControllerApi
 * @extends {BaseAPI}
 */
export class FileControllerApi extends BaseAPI implements FileControllerApiInterface {
    /**
     * Upload file
     * @param {UploadFileRequest} [uploadFileRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileControllerApi
     */
    public uploadFile(uploadFileRequest?: UploadFileRequest, options?: RawAxiosRequestConfig) {
        return FileControllerApiFp(this.configuration).uploadFile(uploadFileRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ImageControllerApi - axios parameter creator
 * @export
 */
export const ImageControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete image
         * @param {string} imageId Image Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteImage: async (imageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('deleteImage', 'imageId', imageId)
            const localVarPath = `/images/{imageId}`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update image crop info
         * @param {string} imageId Image Id
         * @param {UpdateProductImageCropInfoRequest} updateProductImageCropInfoRequest 
         * @param {string} [productId] Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateImageCropInfo: async (imageId: string, updateProductImageCropInfoRequest: UpdateProductImageCropInfoRequest, productId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('updateImageCropInfo', 'imageId', imageId)
            // verify required parameter 'updateProductImageCropInfoRequest' is not null or undefined
            assertParamExists('updateImageCropInfo', 'updateProductImageCropInfoRequest', updateProductImageCropInfoRequest)
            const localVarPath = `/images/{imageId}`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductImageCropInfoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload a cropped image and an original image along with additional parameters
         * @summary Upload an image
         * @param {number} ordinal Image ordinal 
         * @param {UploadImageRequest} uploadImageRequest 
         * @param {string} [productId] Product Id
         * @param {boolean} [isCustomAssortment] Custom Assortment flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImage: async (ordinal: number, uploadImageRequest: UploadImageRequest, productId?: string, isCustomAssortment?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ordinal' is not null or undefined
            assertParamExists('uploadImage', 'ordinal', ordinal)
            // verify required parameter 'uploadImageRequest' is not null or undefined
            assertParamExists('uploadImage', 'uploadImageRequest', uploadImageRequest)
            const localVarPath = `/images`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }

            if (ordinal !== undefined) {
                localVarQueryParameter['ordinal'] = ordinal;
            }

            if (isCustomAssortment !== undefined) {
                localVarQueryParameter['is_custom_assortment'] = isCustomAssortment;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadImageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImageControllerApi - functional programming interface
 * @export
 */
export const ImageControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImageControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete image
         * @param {string} imageId Image Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteImage(imageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteImage(imageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImageControllerApi.deleteImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update image crop info
         * @param {string} imageId Image Id
         * @param {UpdateProductImageCropInfoRequest} updateProductImageCropInfoRequest 
         * @param {string} [productId] Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateImageCropInfo(imageId: string, updateProductImageCropInfoRequest: UpdateProductImageCropInfoRequest, productId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadImageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateImageCropInfo(imageId, updateProductImageCropInfoRequest, productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImageControllerApi.updateImageCropInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload a cropped image and an original image along with additional parameters
         * @summary Upload an image
         * @param {number} ordinal Image ordinal 
         * @param {UploadImageRequest} uploadImageRequest 
         * @param {string} [productId] Product Id
         * @param {boolean} [isCustomAssortment] Custom Assortment flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadImage(ordinal: number, uploadImageRequest: UploadImageRequest, productId?: string, isCustomAssortment?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadImageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadImage(ordinal, uploadImageRequest, productId, isCustomAssortment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImageControllerApi.uploadImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ImageControllerApi - factory interface
 * @export
 */
export const ImageControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImageControllerApiFp(configuration)
    return {
        /**
         * Delete image
         * @param {string} imageId Image Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteImage(imageId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteImage(imageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update image crop info
         * @param {string} imageId Image Id
         * @param {UpdateProductImageCropInfoRequest} updateProductImageCropInfoRequest 
         * @param {string} [productId] Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateImageCropInfo(imageId: string, updateProductImageCropInfoRequest: UpdateProductImageCropInfoRequest, productId?: string, options?: RawAxiosRequestConfig): AxiosPromise<UploadImageResponse> {
            return localVarFp.updateImageCropInfo(imageId, updateProductImageCropInfoRequest, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a cropped image and an original image along with additional parameters
         * @summary Upload an image
         * @param {number} ordinal Image ordinal 
         * @param {UploadImageRequest} uploadImageRequest 
         * @param {string} [productId] Product Id
         * @param {boolean} [isCustomAssortment] Custom Assortment flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImage(ordinal: number, uploadImageRequest: UploadImageRequest, productId?: string, isCustomAssortment?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<UploadImageResponse> {
            return localVarFp.uploadImage(ordinal, uploadImageRequest, productId, isCustomAssortment, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ImageControllerApi - interface
 * @export
 * @interface ImageControllerApi
 */
export interface ImageControllerApiInterface {
    /**
     * Delete image
     * @param {string} imageId Image Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageControllerApiInterface
     */
    deleteImage(imageId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update image crop info
     * @param {string} imageId Image Id
     * @param {UpdateProductImageCropInfoRequest} updateProductImageCropInfoRequest 
     * @param {string} [productId] Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageControllerApiInterface
     */
    updateImageCropInfo(imageId: string, updateProductImageCropInfoRequest: UpdateProductImageCropInfoRequest, productId?: string, options?: RawAxiosRequestConfig): AxiosPromise<UploadImageResponse>;

    /**
     * Upload a cropped image and an original image along with additional parameters
     * @summary Upload an image
     * @param {number} ordinal Image ordinal 
     * @param {UploadImageRequest} uploadImageRequest 
     * @param {string} [productId] Product Id
     * @param {boolean} [isCustomAssortment] Custom Assortment flag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageControllerApiInterface
     */
    uploadImage(ordinal: number, uploadImageRequest: UploadImageRequest, productId?: string, isCustomAssortment?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<UploadImageResponse>;

}

/**
 * ImageControllerApi - object-oriented interface
 * @export
 * @class ImageControllerApi
 * @extends {BaseAPI}
 */
export class ImageControllerApi extends BaseAPI implements ImageControllerApiInterface {
    /**
     * Delete image
     * @param {string} imageId Image Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageControllerApi
     */
    public deleteImage(imageId: string, options?: RawAxiosRequestConfig) {
        return ImageControllerApiFp(this.configuration).deleteImage(imageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update image crop info
     * @param {string} imageId Image Id
     * @param {UpdateProductImageCropInfoRequest} updateProductImageCropInfoRequest 
     * @param {string} [productId] Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageControllerApi
     */
    public updateImageCropInfo(imageId: string, updateProductImageCropInfoRequest: UpdateProductImageCropInfoRequest, productId?: string, options?: RawAxiosRequestConfig) {
        return ImageControllerApiFp(this.configuration).updateImageCropInfo(imageId, updateProductImageCropInfoRequest, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload a cropped image and an original image along with additional parameters
     * @summary Upload an image
     * @param {number} ordinal Image ordinal 
     * @param {UploadImageRequest} uploadImageRequest 
     * @param {string} [productId] Product Id
     * @param {boolean} [isCustomAssortment] Custom Assortment flag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageControllerApi
     */
    public uploadImage(ordinal: number, uploadImageRequest: UploadImageRequest, productId?: string, isCustomAssortment?: boolean, options?: RawAxiosRequestConfig) {
        return ImageControllerApiFp(this.configuration).uploadImage(ordinal, uploadImageRequest, productId, isCustomAssortment, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InvoiceControllerApi - axios parameter creator
 * @export
 */
export const InvoiceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Find all invoices per multiple/custom criteria
         * @param {string} [retailerId] Retailer Id
         * @param {string} [brandId] Brand Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {string} [status] Status
         * @param {string} [sortName] Sort name
         * @param {string} [sortValue] Sort value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoices: async (retailerId?: string, brandId?: string, page?: number, size?: number, searchBy?: string, status?: string, sortName?: string, sortValue?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (retailerId !== undefined) {
                localVarQueryParameter['retailerId'] = retailerId;
            }

            if (brandId !== undefined) {
                localVarQueryParameter['brandId'] = brandId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (searchBy !== undefined) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (sortName !== undefined) {
                localVarQueryParameter['sortName'] = sortName;
            }

            if (sortValue !== undefined) {
                localVarQueryParameter['sortValue'] = sortValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find all invoices for provided brand
         * @param {string} retailerId Retailer Id
         * @param {string} [brandId] Brand Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {string} [status] Status
         * @param {string} [sortName] Sort name
         * @param {string} [sortValue] Sort value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicesByRetailer: async (retailerId: string, brandId?: string, page?: number, size?: number, searchBy?: string, status?: string, sortName?: string, sortValue?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'retailerId' is not null or undefined
            assertParamExists('getInvoicesByRetailer', 'retailerId', retailerId)
            const localVarPath = `/invoices/retailer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (retailerId !== undefined) {
                localVarQueryParameter['retailerId'] = retailerId;
            }

            if (brandId !== undefined) {
                localVarQueryParameter['brandId'] = brandId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (searchBy !== undefined) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (sortName !== undefined) {
                localVarQueryParameter['sortName'] = sortName;
            }

            if (sortValue !== undefined) {
                localVarQueryParameter['sortValue'] = sortValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoiceControllerApi - functional programming interface
 * @export
 */
export const InvoiceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoiceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Find all invoices per multiple/custom criteria
         * @param {string} [retailerId] Retailer Id
         * @param {string} [brandId] Brand Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {string} [status] Status
         * @param {string} [sortName] Sort name
         * @param {string} [sortValue] Sort value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoices(retailerId?: string, brandId?: string, page?: number, size?: number, searchBy?: string, status?: string, sortName?: string, sortValue?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedInvoicesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoices(retailerId, brandId, page, size, searchBy, status, sortName, sortValue, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceControllerApi.getInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find all invoices for provided brand
         * @param {string} retailerId Retailer Id
         * @param {string} [brandId] Brand Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {string} [status] Status
         * @param {string} [sortName] Sort name
         * @param {string} [sortValue] Sort value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoicesByRetailer(retailerId: string, brandId?: string, page?: number, size?: number, searchBy?: string, status?: string, sortName?: string, sortValue?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedInvoicesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoicesByRetailer(retailerId, brandId, page, size, searchBy, status, sortName, sortValue, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceControllerApi.getInvoicesByRetailer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvoiceControllerApi - factory interface
 * @export
 */
export const InvoiceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoiceControllerApiFp(configuration)
    return {
        /**
         * Find all invoices per multiple/custom criteria
         * @param {string} [retailerId] Retailer Id
         * @param {string} [brandId] Brand Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {string} [status] Status
         * @param {string} [sortName] Sort name
         * @param {string} [sortValue] Sort value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoices(retailerId?: string, brandId?: string, page?: number, size?: number, searchBy?: string, status?: string, sortName?: string, sortValue?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedInvoicesResponse> {
            return localVarFp.getInvoices(retailerId, brandId, page, size, searchBy, status, sortName, sortValue, options).then((request) => request(axios, basePath));
        },
        /**
         * Find all invoices for provided brand
         * @param {string} retailerId Retailer Id
         * @param {string} [brandId] Brand Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {string} [status] Status
         * @param {string} [sortName] Sort name
         * @param {string} [sortValue] Sort value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicesByRetailer(retailerId: string, brandId?: string, page?: number, size?: number, searchBy?: string, status?: string, sortName?: string, sortValue?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedInvoicesResponse> {
            return localVarFp.getInvoicesByRetailer(retailerId, brandId, page, size, searchBy, status, sortName, sortValue, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvoiceControllerApi - interface
 * @export
 * @interface InvoiceControllerApi
 */
export interface InvoiceControllerApiInterface {
    /**
     * Find all invoices per multiple/custom criteria
     * @param {string} [retailerId] Retailer Id
     * @param {string} [brandId] Brand Id
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {string} [searchBy] Search by
     * @param {string} [status] Status
     * @param {string} [sortName] Sort name
     * @param {string} [sortValue] Sort value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceControllerApiInterface
     */
    getInvoices(retailerId?: string, brandId?: string, page?: number, size?: number, searchBy?: string, status?: string, sortName?: string, sortValue?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedInvoicesResponse>;

    /**
     * Find all invoices for provided brand
     * @param {string} retailerId Retailer Id
     * @param {string} [brandId] Brand Id
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {string} [searchBy] Search by
     * @param {string} [status] Status
     * @param {string} [sortName] Sort name
     * @param {string} [sortValue] Sort value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceControllerApiInterface
     */
    getInvoicesByRetailer(retailerId: string, brandId?: string, page?: number, size?: number, searchBy?: string, status?: string, sortName?: string, sortValue?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedInvoicesResponse>;

}

/**
 * InvoiceControllerApi - object-oriented interface
 * @export
 * @class InvoiceControllerApi
 * @extends {BaseAPI}
 */
export class InvoiceControllerApi extends BaseAPI implements InvoiceControllerApiInterface {
    /**
     * Find all invoices per multiple/custom criteria
     * @param {string} [retailerId] Retailer Id
     * @param {string} [brandId] Brand Id
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {string} [searchBy] Search by
     * @param {string} [status] Status
     * @param {string} [sortName] Sort name
     * @param {string} [sortValue] Sort value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceControllerApi
     */
    public getInvoices(retailerId?: string, brandId?: string, page?: number, size?: number, searchBy?: string, status?: string, sortName?: string, sortValue?: string, options?: RawAxiosRequestConfig) {
        return InvoiceControllerApiFp(this.configuration).getInvoices(retailerId, brandId, page, size, searchBy, status, sortName, sortValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find all invoices for provided brand
     * @param {string} retailerId Retailer Id
     * @param {string} [brandId] Brand Id
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {string} [searchBy] Search by
     * @param {string} [status] Status
     * @param {string} [sortName] Sort name
     * @param {string} [sortValue] Sort value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceControllerApi
     */
    public getInvoicesByRetailer(retailerId: string, brandId?: string, page?: number, size?: number, searchBy?: string, status?: string, sortName?: string, sortValue?: string, options?: RawAxiosRequestConfig) {
        return InvoiceControllerApiFp(this.configuration).getInvoicesByRetailer(retailerId, brandId, page, size, searchBy, status, sortName, sortValue, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * KeysControllerApi - axios parameter creator
 * @export
 */
export const KeysControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Users can obtain their client keys for third party services integrations through this api
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientKeys: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/keys/client`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KeysControllerApi - functional programming interface
 * @export
 */
export const KeysControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KeysControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Users can obtain their client keys for third party services integrations through this api
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientKeys(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientKeys(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KeysControllerApi.getClientKeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * KeysControllerApi - factory interface
 * @export
 */
export const KeysControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KeysControllerApiFp(configuration)
    return {
        /**
         * Users can obtain their client keys for third party services integrations through this api
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientKeys(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getClientKeys(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KeysControllerApi - interface
 * @export
 * @interface KeysControllerApi
 */
export interface KeysControllerApiInterface {
    /**
     * Users can obtain their client keys for third party services integrations through this api
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeysControllerApiInterface
     */
    getClientKeys(options?: RawAxiosRequestConfig): AxiosPromise<object>;

}

/**
 * KeysControllerApi - object-oriented interface
 * @export
 * @class KeysControllerApi
 * @extends {BaseAPI}
 */
export class KeysControllerApi extends BaseAPI implements KeysControllerApiInterface {
    /**
     * Users can obtain their client keys for third party services integrations through this api
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeysControllerApi
     */
    public getClientKeys(options?: RawAxiosRequestConfig) {
        return KeysControllerApiFp(this.configuration).getClientKeys(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LoggingHistoryControllerApi - axios parameter creator
 * @export
 */
export const LoggingHistoryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Find all logs by suborder id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findHistoryBySuborderId: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findHistoryBySuborderId', 'id', id)
            const localVarPath = `/histories/suborders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoggingHistoryControllerApi - functional programming interface
 * @export
 */
export const LoggingHistoryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoggingHistoryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Find all logs by suborder id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findHistoryBySuborderId(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubordersLogsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findHistoryBySuborderId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoggingHistoryControllerApi.findHistoryBySuborderId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LoggingHistoryControllerApi - factory interface
 * @export
 */
export const LoggingHistoryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoggingHistoryControllerApiFp(configuration)
    return {
        /**
         * Find all logs by suborder id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findHistoryBySuborderId(id: string, options?: RawAxiosRequestConfig): AxiosPromise<SubordersLogsResponse> {
            return localVarFp.findHistoryBySuborderId(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoggingHistoryControllerApi - interface
 * @export
 * @interface LoggingHistoryControllerApi
 */
export interface LoggingHistoryControllerApiInterface {
    /**
     * Find all logs by suborder id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoggingHistoryControllerApiInterface
     */
    findHistoryBySuborderId(id: string, options?: RawAxiosRequestConfig): AxiosPromise<SubordersLogsResponse>;

}

/**
 * LoggingHistoryControllerApi - object-oriented interface
 * @export
 * @class LoggingHistoryControllerApi
 * @extends {BaseAPI}
 */
export class LoggingHistoryControllerApi extends BaseAPI implements LoggingHistoryControllerApiInterface {
    /**
     * Find all logs by suborder id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoggingHistoryControllerApi
     */
    public findHistoryBySuborderId(id: string, options?: RawAxiosRequestConfig) {
        return LoggingHistoryControllerApiFp(this.configuration).findHistoryBySuborderId(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NavigationV2ControllerApi - axios parameter creator
 * @export
 */
export const NavigationV2ControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create collections for retailer type user.
         * @param {CreateCollectionsRequest} createCollectionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollections: async (createCollectionsRequest: CreateCollectionsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCollectionsRequest' is not null or undefined
            assertParamExists('createCollections', 'createCollectionsRequest', createCollectionsRequest)
            const localVarPath = `/navigation-v2/collections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCollectionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create featured link for retailer type user.
         * @param {CreateFeaturedLinksRequest} createFeaturedLinksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFeaturedLinks: async (createFeaturedLinksRequest: CreateFeaturedLinksRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFeaturedLinksRequest' is not null or undefined
            assertParamExists('createFeaturedLinks', 'createFeaturedLinksRequest', createFeaturedLinksRequest)
            const localVarPath = `/navigation-v2/featured-links`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFeaturedLinksRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete navigation v2 container or component
         * @param {string} id Container or component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNavigationV2ContainerOrComponent: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteNavigationV2ContainerOrComponent', 'id', id)
            const localVarPath = `/navigation-v2/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Collection ViewContainer Id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionViewContainerId: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigation-v2/collection-container-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get navigation V2 view container
         * @param {string} [role] Role
         * @param {string} [userId] User Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavigationV2: async (role?: string, userId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigation-v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NavigationV2ControllerApi - functional programming interface
 * @export
 */
export const NavigationV2ControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NavigationV2ControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Create collections for retailer type user.
         * @param {CreateCollectionsRequest} createCollectionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCollections(createCollectionsRequest: CreateCollectionsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateCollectionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCollections(createCollectionsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NavigationV2ControllerApi.createCollections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create featured link for retailer type user.
         * @param {CreateFeaturedLinksRequest} createFeaturedLinksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFeaturedLinks(createFeaturedLinksRequest: CreateFeaturedLinksRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateFeaturedLinksResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFeaturedLinks(createFeaturedLinksRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NavigationV2ControllerApi.createFeaturedLinks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete navigation v2 container or component
         * @param {string} id Container or component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNavigationV2ContainerOrComponent(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNavigationV2ContainerOrComponent(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NavigationV2ControllerApi.deleteNavigationV2ContainerOrComponent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Collection ViewContainer Id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionViewContainerId(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCollectionViewContainerIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectionViewContainerId(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NavigationV2ControllerApi.getCollectionViewContainerId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get navigation V2 view container
         * @param {string} [role] Role
         * @param {string} [userId] User Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNavigationV2(role?: string, userId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNavigationV2(role, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NavigationV2ControllerApi.getNavigationV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NavigationV2ControllerApi - factory interface
 * @export
 */
export const NavigationV2ControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NavigationV2ControllerApiFp(configuration)
    return {
        /**
         * Create collections for retailer type user.
         * @param {CreateCollectionsRequest} createCollectionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollections(createCollectionsRequest: CreateCollectionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateCollectionsResponse> {
            return localVarFp.createCollections(createCollectionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create featured link for retailer type user.
         * @param {CreateFeaturedLinksRequest} createFeaturedLinksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFeaturedLinks(createFeaturedLinksRequest: CreateFeaturedLinksRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateFeaturedLinksResponse> {
            return localVarFp.createFeaturedLinks(createFeaturedLinksRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete navigation v2 container or component
         * @param {string} id Container or component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNavigationV2ContainerOrComponent(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteNavigationV2ContainerOrComponent(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Collection ViewContainer Id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionViewContainerId(options?: RawAxiosRequestConfig): AxiosPromise<GetCollectionViewContainerIdResponse> {
            return localVarFp.getCollectionViewContainerId(options).then((request) => request(axios, basePath));
        },
        /**
         * Get navigation V2 view container
         * @param {string} [role] Role
         * @param {string} [userId] User Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavigationV2(role?: string, userId?: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getNavigationV2(role, userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NavigationV2ControllerApi - interface
 * @export
 * @interface NavigationV2ControllerApi
 */
export interface NavigationV2ControllerApiInterface {
    /**
     * Create collections for retailer type user.
     * @param {CreateCollectionsRequest} createCollectionsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigationV2ControllerApiInterface
     */
    createCollections(createCollectionsRequest: CreateCollectionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateCollectionsResponse>;

    /**
     * Create featured link for retailer type user.
     * @param {CreateFeaturedLinksRequest} createFeaturedLinksRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigationV2ControllerApiInterface
     */
    createFeaturedLinks(createFeaturedLinksRequest: CreateFeaturedLinksRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateFeaturedLinksResponse>;

    /**
     * Delete navigation v2 container or component
     * @param {string} id Container or component Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigationV2ControllerApiInterface
     */
    deleteNavigationV2ContainerOrComponent(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Get Collection ViewContainer Id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigationV2ControllerApiInterface
     */
    getCollectionViewContainerId(options?: RawAxiosRequestConfig): AxiosPromise<GetCollectionViewContainerIdResponse>;

    /**
     * Get navigation V2 view container
     * @param {string} [role] Role
     * @param {string} [userId] User Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigationV2ControllerApiInterface
     */
    getNavigationV2(role?: string, userId?: string, options?: RawAxiosRequestConfig): AxiosPromise<object>;

}

/**
 * NavigationV2ControllerApi - object-oriented interface
 * @export
 * @class NavigationV2ControllerApi
 * @extends {BaseAPI}
 */
export class NavigationV2ControllerApi extends BaseAPI implements NavigationV2ControllerApiInterface {
    /**
     * Create collections for retailer type user.
     * @param {CreateCollectionsRequest} createCollectionsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigationV2ControllerApi
     */
    public createCollections(createCollectionsRequest: CreateCollectionsRequest, options?: RawAxiosRequestConfig) {
        return NavigationV2ControllerApiFp(this.configuration).createCollections(createCollectionsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create featured link for retailer type user.
     * @param {CreateFeaturedLinksRequest} createFeaturedLinksRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigationV2ControllerApi
     */
    public createFeaturedLinks(createFeaturedLinksRequest: CreateFeaturedLinksRequest, options?: RawAxiosRequestConfig) {
        return NavigationV2ControllerApiFp(this.configuration).createFeaturedLinks(createFeaturedLinksRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete navigation v2 container or component
     * @param {string} id Container or component Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigationV2ControllerApi
     */
    public deleteNavigationV2ContainerOrComponent(id: string, options?: RawAxiosRequestConfig) {
        return NavigationV2ControllerApiFp(this.configuration).deleteNavigationV2ContainerOrComponent(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Collection ViewContainer Id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigationV2ControllerApi
     */
    public getCollectionViewContainerId(options?: RawAxiosRequestConfig) {
        return NavigationV2ControllerApiFp(this.configuration).getCollectionViewContainerId(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get navigation V2 view container
     * @param {string} [role] Role
     * @param {string} [userId] User Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigationV2ControllerApi
     */
    public getNavigationV2(role?: string, userId?: string, options?: RawAxiosRequestConfig) {
        return NavigationV2ControllerApiFp(this.configuration).getNavigationV2(role, userId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OnboardingControllerApi - axios parameter creator
 * @export
 */
export const OnboardingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Approve an outreach brand that is in NEEDS_REVIEW status by admin.
         * @param {string} id Brand ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveOutreachBrand: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('approveOutreachBrand', 'id', id)
            const localVarPath = `/onboarding/brand/{id}/approve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Move draft brand data to appropriate brand entity and mark onboarding as complete, ignoring required product count
         * @param {BulkBypassOnboardingRequest} bulkBypassOnboardingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkBypassOnboarding: async (bulkBypassOnboardingRequest: BulkBypassOnboardingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkBypassOnboardingRequest' is not null or undefined
            assertParamExists('bulkBypassOnboarding', 'bulkBypassOnboardingRequest', bulkBypassOnboardingRequest)
            const localVarPath = `/onboarding/brand/bulk-bypass-onboarding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkBypassOnboardingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Move draft brand data to appropriate brand entity and mark onboarding as complete, ignoring required product count
         * @param {string} id Brand ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bypassProductRequiredInOnboarding: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bypassProductRequiredInOnboarding', 'id', id)
            const localVarPath = `/onboarding/brand/{id}/bypass-onboarding`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Complete brand onboarding form
         * @param {string} id Brand ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeOnboardingForm: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('completeOnboardingForm', 'id', id)
            const localVarPath = `/onboarding/brand/{id}/complete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deny outreach brand which completed onboarding form and needs review
         * @param {string} id Brand ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        denyBrand: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('denyBrand', 'id', id)
            const localVarPath = `/onboarding/brand/{id}/deny`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get draft brand by brand ID
         * @param {string} id Brand ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftBrandByBrandId: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDraftBrandByBrandId', 'id', id)
            const localVarPath = `/onboarding/brand/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get draft brand by principal ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftBrandByPrincipalId: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/onboarding/brand/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get marketing category values.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingCategoryValues: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/onboarding/marketing-categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Move draft brand data to appropriate brand entity
         * @param {string} id Brand ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveDraftBrandDataToBrand: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('moveDraftBrandDataToBrand', 'id', id)
            const localVarPath = `/onboarding/brand/{id}/move-data`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Publish the brand after reviewing the profile that was built by the Bulletin team.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishBrand: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/onboarding/brand/me/publish`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unlink A2Z brands from trade show
         * @param {string} eventId Event Id
         * @param {UnlinkBrandsFromTradeShowRequest} unlinkBrandsFromTradeShowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkBrandsFromTradeShow: async (eventId: string, unlinkBrandsFromTradeShowRequest: UnlinkBrandsFromTradeShowRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('unlinkBrandsFromTradeShow', 'eventId', eventId)
            // verify required parameter 'unlinkBrandsFromTradeShowRequest' is not null or undefined
            assertParamExists('unlinkBrandsFromTradeShow', 'unlinkBrandsFromTradeShowRequest', unlinkBrandsFromTradeShowRequest)
            const localVarPath = `/onboarding/brands/trade-show/{eventId}/unlink`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unlinkBrandsFromTradeShowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update draft brand by brand ID
         * @param {string} id Brand ID
         * @param {UpdateDraftBrandRequest} updateDraftBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDraftBrand: async (id: string, updateDraftBrandRequest: UpdateDraftBrandRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDraftBrand', 'id', id)
            // verify required parameter 'updateDraftBrandRequest' is not null or undefined
            assertParamExists('updateDraftBrand', 'updateDraftBrandRequest', updateDraftBrandRequest)
            const localVarPath = `/onboarding/brand/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDraftBrandRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload brand\'s product building line sheet
         * @param {string} id Brand ID
         * @param {UploadFileRequest} uploadFileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadBrandProductBuildingLineSheet: async (id: string, uploadFileRequest: UploadFileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadBrandProductBuildingLineSheet', 'id', id)
            // verify required parameter 'uploadFileRequest' is not null or undefined
            assertParamExists('uploadBrandProductBuildingLineSheet', 'uploadFileRequest', uploadFileRequest)
            const localVarPath = `/onboarding/brand/{id}/line-sheet`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadFileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OnboardingControllerApi - functional programming interface
 * @export
 */
export const OnboardingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OnboardingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Approve an outreach brand that is in NEEDS_REVIEW status by admin.
         * @param {string} id Brand ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveOutreachBrand(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveOutreachBrand(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingControllerApi.approveOutreachBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Move draft brand data to appropriate brand entity and mark onboarding as complete, ignoring required product count
         * @param {BulkBypassOnboardingRequest} bulkBypassOnboardingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkBypassOnboarding(bulkBypassOnboardingRequest: BulkBypassOnboardingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkBypassOnboarding(bulkBypassOnboardingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingControllerApi.bulkBypassOnboarding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Move draft brand data to appropriate brand entity and mark onboarding as complete, ignoring required product count
         * @param {string} id Brand ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bypassProductRequiredInOnboarding(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bypassProductRequiredInOnboarding(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingControllerApi.bypassProductRequiredInOnboarding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Complete brand onboarding form
         * @param {string} id Brand ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeOnboardingForm(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeOnboardingForm(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingControllerApi.completeOnboardingForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deny outreach brand which completed onboarding form and needs review
         * @param {string} id Brand ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async denyBrand(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.denyBrand(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingControllerApi.denyBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get draft brand by brand ID
         * @param {string} id Brand ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDraftBrandByBrandId(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DraftBrandResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDraftBrandByBrandId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingControllerApi.getDraftBrandByBrandId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get draft brand by principal ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDraftBrandByPrincipalId(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DraftBrandResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDraftBrandByPrincipalId(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingControllerApi.getDraftBrandByPrincipalId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get marketing category values.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarketingCategoryValues(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingCategoriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketingCategoryValues(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingControllerApi.getMarketingCategoryValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Move draft brand data to appropriate brand entity
         * @param {string} id Brand ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveDraftBrandDataToBrand(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveDraftBrandDataToBrand(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingControllerApi.moveDraftBrandDataToBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Publish the brand after reviewing the profile that was built by the Bulletin team.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishBrand(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishBrand(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingControllerApi.publishBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unlink A2Z brands from trade show
         * @param {string} eventId Event Id
         * @param {UnlinkBrandsFromTradeShowRequest} unlinkBrandsFromTradeShowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlinkBrandsFromTradeShow(eventId: string, unlinkBrandsFromTradeShowRequest: UnlinkBrandsFromTradeShowRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlinkBrandsFromTradeShow(eventId, unlinkBrandsFromTradeShowRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingControllerApi.unlinkBrandsFromTradeShow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update draft brand by brand ID
         * @param {string} id Brand ID
         * @param {UpdateDraftBrandRequest} updateDraftBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDraftBrand(id: string, updateDraftBrandRequest: UpdateDraftBrandRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDraftBrand(id, updateDraftBrandRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingControllerApi.updateDraftBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload brand\'s product building line sheet
         * @param {string} id Brand ID
         * @param {UploadFileRequest} uploadFileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadBrandProductBuildingLineSheet(id: string, uploadFileRequest: UploadFileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadProductBuildingLineSheetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadBrandProductBuildingLineSheet(id, uploadFileRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingControllerApi.uploadBrandProductBuildingLineSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OnboardingControllerApi - factory interface
 * @export
 */
export const OnboardingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OnboardingControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Approve an outreach brand that is in NEEDS_REVIEW status by admin.
         * @param {string} id Brand ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveOutreachBrand(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.approveOutreachBrand(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Move draft brand data to appropriate brand entity and mark onboarding as complete, ignoring required product count
         * @param {BulkBypassOnboardingRequest} bulkBypassOnboardingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkBypassOnboarding(bulkBypassOnboardingRequest: BulkBypassOnboardingRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.bulkBypassOnboarding(bulkBypassOnboardingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Move draft brand data to appropriate brand entity and mark onboarding as complete, ignoring required product count
         * @param {string} id Brand ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bypassProductRequiredInOnboarding(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.bypassProductRequiredInOnboarding(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Complete brand onboarding form
         * @param {string} id Brand ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeOnboardingForm(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.completeOnboardingForm(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deny outreach brand which completed onboarding form and needs review
         * @param {string} id Brand ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        denyBrand(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.denyBrand(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get draft brand by brand ID
         * @param {string} id Brand ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftBrandByBrandId(id: string, options?: RawAxiosRequestConfig): AxiosPromise<DraftBrandResponse> {
            return localVarFp.getDraftBrandByBrandId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get draft brand by principal ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftBrandByPrincipalId(options?: RawAxiosRequestConfig): AxiosPromise<DraftBrandResponse> {
            return localVarFp.getDraftBrandByPrincipalId(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get marketing category values.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingCategoryValues(options?: RawAxiosRequestConfig): AxiosPromise<MarketingCategoriesResponse> {
            return localVarFp.getMarketingCategoryValues(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Move draft brand data to appropriate brand entity
         * @param {string} id Brand ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveDraftBrandDataToBrand(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.moveDraftBrandDataToBrand(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Publish the brand after reviewing the profile that was built by the Bulletin team.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishBrand(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.publishBrand(options).then((request) => request(axios, basePath));
        },
        /**
         * Unlink A2Z brands from trade show
         * @param {string} eventId Event Id
         * @param {UnlinkBrandsFromTradeShowRequest} unlinkBrandsFromTradeShowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkBrandsFromTradeShow(eventId: string, unlinkBrandsFromTradeShowRequest: UnlinkBrandsFromTradeShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unlinkBrandsFromTradeShow(eventId, unlinkBrandsFromTradeShowRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update draft brand by brand ID
         * @param {string} id Brand ID
         * @param {UpdateDraftBrandRequest} updateDraftBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDraftBrand(id: string, updateDraftBrandRequest: UpdateDraftBrandRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateDraftBrand(id, updateDraftBrandRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload brand\'s product building line sheet
         * @param {string} id Brand ID
         * @param {UploadFileRequest} uploadFileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadBrandProductBuildingLineSheet(id: string, uploadFileRequest: UploadFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadProductBuildingLineSheetResponse> {
            return localVarFp.uploadBrandProductBuildingLineSheet(id, uploadFileRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OnboardingControllerApi - interface
 * @export
 * @interface OnboardingControllerApi
 */
export interface OnboardingControllerApiInterface {
    /**
     * 
     * @summary Approve an outreach brand that is in NEEDS_REVIEW status by admin.
     * @param {string} id Brand ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApiInterface
     */
    approveOutreachBrand(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Move draft brand data to appropriate brand entity and mark onboarding as complete, ignoring required product count
     * @param {BulkBypassOnboardingRequest} bulkBypassOnboardingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApiInterface
     */
    bulkBypassOnboarding(bulkBypassOnboardingRequest: BulkBypassOnboardingRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Move draft brand data to appropriate brand entity and mark onboarding as complete, ignoring required product count
     * @param {string} id Brand ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApiInterface
     */
    bypassProductRequiredInOnboarding(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Complete brand onboarding form
     * @param {string} id Brand ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApiInterface
     */
    completeOnboardingForm(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Deny outreach brand which completed onboarding form and needs review
     * @param {string} id Brand ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApiInterface
     */
    denyBrand(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get draft brand by brand ID
     * @param {string} id Brand ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApiInterface
     */
    getDraftBrandByBrandId(id: string, options?: RawAxiosRequestConfig): AxiosPromise<DraftBrandResponse>;

    /**
     * 
     * @summary Get draft brand by principal ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApiInterface
     */
    getDraftBrandByPrincipalId(options?: RawAxiosRequestConfig): AxiosPromise<DraftBrandResponse>;

    /**
     * 
     * @summary Get marketing category values.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApiInterface
     */
    getMarketingCategoryValues(options?: RawAxiosRequestConfig): AxiosPromise<MarketingCategoriesResponse>;

    /**
     * 
     * @summary Move draft brand data to appropriate brand entity
     * @param {string} id Brand ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApiInterface
     */
    moveDraftBrandDataToBrand(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Publish the brand after reviewing the profile that was built by the Bulletin team.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApiInterface
     */
    publishBrand(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Unlink A2Z brands from trade show
     * @param {string} eventId Event Id
     * @param {UnlinkBrandsFromTradeShowRequest} unlinkBrandsFromTradeShowRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApiInterface
     */
    unlinkBrandsFromTradeShow(eventId: string, unlinkBrandsFromTradeShowRequest: UnlinkBrandsFromTradeShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update draft brand by brand ID
     * @param {string} id Brand ID
     * @param {UpdateDraftBrandRequest} updateDraftBrandRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApiInterface
     */
    updateDraftBrand(id: string, updateDraftBrandRequest: UpdateDraftBrandRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Upload brand\'s product building line sheet
     * @param {string} id Brand ID
     * @param {UploadFileRequest} uploadFileRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApiInterface
     */
    uploadBrandProductBuildingLineSheet(id: string, uploadFileRequest: UploadFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadProductBuildingLineSheetResponse>;

}

/**
 * OnboardingControllerApi - object-oriented interface
 * @export
 * @class OnboardingControllerApi
 * @extends {BaseAPI}
 */
export class OnboardingControllerApi extends BaseAPI implements OnboardingControllerApiInterface {
    /**
     * 
     * @summary Approve an outreach brand that is in NEEDS_REVIEW status by admin.
     * @param {string} id Brand ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApi
     */
    public approveOutreachBrand(id: string, options?: RawAxiosRequestConfig) {
        return OnboardingControllerApiFp(this.configuration).approveOutreachBrand(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Move draft brand data to appropriate brand entity and mark onboarding as complete, ignoring required product count
     * @param {BulkBypassOnboardingRequest} bulkBypassOnboardingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApi
     */
    public bulkBypassOnboarding(bulkBypassOnboardingRequest: BulkBypassOnboardingRequest, options?: RawAxiosRequestConfig) {
        return OnboardingControllerApiFp(this.configuration).bulkBypassOnboarding(bulkBypassOnboardingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Move draft brand data to appropriate brand entity and mark onboarding as complete, ignoring required product count
     * @param {string} id Brand ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApi
     */
    public bypassProductRequiredInOnboarding(id: string, options?: RawAxiosRequestConfig) {
        return OnboardingControllerApiFp(this.configuration).bypassProductRequiredInOnboarding(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Complete brand onboarding form
     * @param {string} id Brand ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApi
     */
    public completeOnboardingForm(id: string, options?: RawAxiosRequestConfig) {
        return OnboardingControllerApiFp(this.configuration).completeOnboardingForm(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deny outreach brand which completed onboarding form and needs review
     * @param {string} id Brand ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApi
     */
    public denyBrand(id: string, options?: RawAxiosRequestConfig) {
        return OnboardingControllerApiFp(this.configuration).denyBrand(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get draft brand by brand ID
     * @param {string} id Brand ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApi
     */
    public getDraftBrandByBrandId(id: string, options?: RawAxiosRequestConfig) {
        return OnboardingControllerApiFp(this.configuration).getDraftBrandByBrandId(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get draft brand by principal ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApi
     */
    public getDraftBrandByPrincipalId(options?: RawAxiosRequestConfig) {
        return OnboardingControllerApiFp(this.configuration).getDraftBrandByPrincipalId(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get marketing category values.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApi
     */
    public getMarketingCategoryValues(options?: RawAxiosRequestConfig) {
        return OnboardingControllerApiFp(this.configuration).getMarketingCategoryValues(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Move draft brand data to appropriate brand entity
     * @param {string} id Brand ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApi
     */
    public moveDraftBrandDataToBrand(id: string, options?: RawAxiosRequestConfig) {
        return OnboardingControllerApiFp(this.configuration).moveDraftBrandDataToBrand(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Publish the brand after reviewing the profile that was built by the Bulletin team.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApi
     */
    public publishBrand(options?: RawAxiosRequestConfig) {
        return OnboardingControllerApiFp(this.configuration).publishBrand(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unlink A2Z brands from trade show
     * @param {string} eventId Event Id
     * @param {UnlinkBrandsFromTradeShowRequest} unlinkBrandsFromTradeShowRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApi
     */
    public unlinkBrandsFromTradeShow(eventId: string, unlinkBrandsFromTradeShowRequest: UnlinkBrandsFromTradeShowRequest, options?: RawAxiosRequestConfig) {
        return OnboardingControllerApiFp(this.configuration).unlinkBrandsFromTradeShow(eventId, unlinkBrandsFromTradeShowRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update draft brand by brand ID
     * @param {string} id Brand ID
     * @param {UpdateDraftBrandRequest} updateDraftBrandRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApi
     */
    public updateDraftBrand(id: string, updateDraftBrandRequest: UpdateDraftBrandRequest, options?: RawAxiosRequestConfig) {
        return OnboardingControllerApiFp(this.configuration).updateDraftBrand(id, updateDraftBrandRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload brand\'s product building line sheet
     * @param {string} id Brand ID
     * @param {UploadFileRequest} uploadFileRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingControllerApi
     */
    public uploadBrandProductBuildingLineSheet(id: string, uploadFileRequest: UploadFileRequest, options?: RawAxiosRequestConfig) {
        return OnboardingControllerApiFp(this.configuration).uploadBrandProductBuildingLineSheet(id, uploadFileRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderAdjustmentControllerApi - axios parameter creator
 * @export
 */
export const OrderAdjustmentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ORDER ADJUSTMENT: Change suborder status (Allowed transitions [APPROVED, FULFILLMENT_IN_PROGRESS]->DECLINED, [DECLINED, EXPIRED]->APPROVED)
         * @param {string} id Suborder Id
         * @param {ChangeSuborderStatusRequest} changeSuborderStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeSuborderStatus: async (id: string, changeSuborderStatusRequest: ChangeSuborderStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changeSuborderStatus', 'id', id)
            // verify required parameter 'changeSuborderStatusRequest' is not null or undefined
            assertParamExists('changeSuborderStatus', 'changeSuborderStatusRequest', changeSuborderStatusRequest)
            const localVarPath = `/order-adjustments/suborders/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeSuborderStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set order to manually charged, killing the charge posthook and setting the charge date to null
         * @param {string} suborderId Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSuborderToManuallyCharged: async (suborderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'suborderId' is not null or undefined
            assertParamExists('setSuborderToManuallyCharged', 'suborderId', suborderId)
            const localVarPath = `/order-adjustments/suborders/{suborderId}/manually-charge`
                .replace(`{${"suborderId"}}`, encodeURIComponent(String(suborderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update packing slip\'s shipped quantities
         * @param {string} packingSlipId 
         * @param {ListRequestWrapperUpdatePackingSlipShippedQuantitiesRequest} listRequestWrapperUpdatePackingSlipShippedQuantitiesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShippedQuantities: async (packingSlipId: string, listRequestWrapperUpdatePackingSlipShippedQuantitiesRequest: ListRequestWrapperUpdatePackingSlipShippedQuantitiesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'packingSlipId' is not null or undefined
            assertParamExists('updateShippedQuantities', 'packingSlipId', packingSlipId)
            // verify required parameter 'listRequestWrapperUpdatePackingSlipShippedQuantitiesRequest' is not null or undefined
            assertParamExists('updateShippedQuantities', 'listRequestWrapperUpdatePackingSlipShippedQuantitiesRequest', listRequestWrapperUpdatePackingSlipShippedQuantitiesRequest)
            const localVarPath = `/order-adjustments/packing-slips/{packingSlipId}/packing-slip-items/shipped-quantities`
                .replace(`{${"packingSlipId"}}`, encodeURIComponent(String(packingSlipId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listRequestWrapperUpdatePackingSlipShippedQuantitiesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add items (product variants) to an suborder. Fulfilled and shipped quantities are optional.
         * @param {string} suborderId Suborder id
         * @param {AddItemToSuborderRequest} addItemToSuborderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuborder1: async (suborderId: string, addItemToSuborderRequest: AddItemToSuborderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'suborderId' is not null or undefined
            assertParamExists('updateSuborder1', 'suborderId', suborderId)
            // verify required parameter 'addItemToSuborderRequest' is not null or undefined
            assertParamExists('updateSuborder1', 'addItemToSuborderRequest', addItemToSuborderRequest)
            const localVarPath = `/order-adjustments/suborders/{suborderId}/add-items`
                .replace(`{${"suborderId"}}`, encodeURIComponent(String(suborderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addItemToSuborderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update order charge date, accepts dates up to three months in the future
         * @param {string} suborderId Suborder Id
         * @param {UpdateSuborderChargeDateRequest} updateSuborderChargeDateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuborderChargeDate: async (suborderId: string, updateSuborderChargeDateRequest: UpdateSuborderChargeDateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'suborderId' is not null or undefined
            assertParamExists('updateSuborderChargeDate', 'suborderId', suborderId)
            // verify required parameter 'updateSuborderChargeDateRequest' is not null or undefined
            assertParamExists('updateSuborderChargeDate', 'updateSuborderChargeDateRequest', updateSuborderChargeDateRequest)
            const localVarPath = `/order-adjustments/suborders/{suborderId}/charge-date`
                .replace(`{${"suborderId"}}`, encodeURIComponent(String(suborderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSuborderChargeDateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderAdjustmentControllerApi - functional programming interface
 * @export
 */
export const OrderAdjustmentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderAdjustmentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * ORDER ADJUSTMENT: Change suborder status (Allowed transitions [APPROVED, FULFILLMENT_IN_PROGRESS]->DECLINED, [DECLINED, EXPIRED]->APPROVED)
         * @param {string} id Suborder Id
         * @param {ChangeSuborderStatusRequest} changeSuborderStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeSuborderStatus(id: string, changeSuborderStatusRequest: ChangeSuborderStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeSuborderStatus(id, changeSuborderStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderAdjustmentControllerApi.changeSuborderStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set order to manually charged, killing the charge posthook and setting the charge date to null
         * @param {string} suborderId Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setSuborderToManuallyCharged(suborderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setSuborderToManuallyCharged(suborderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderAdjustmentControllerApi.setSuborderToManuallyCharged']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update packing slip\'s shipped quantities
         * @param {string} packingSlipId 
         * @param {ListRequestWrapperUpdatePackingSlipShippedQuantitiesRequest} listRequestWrapperUpdatePackingSlipShippedQuantitiesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateShippedQuantities(packingSlipId: string, listRequestWrapperUpdatePackingSlipShippedQuantitiesRequest: ListRequestWrapperUpdatePackingSlipShippedQuantitiesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateShippedQuantities(packingSlipId, listRequestWrapperUpdatePackingSlipShippedQuantitiesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderAdjustmentControllerApi.updateShippedQuantities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add items (product variants) to an suborder. Fulfilled and shipped quantities are optional.
         * @param {string} suborderId Suborder id
         * @param {AddItemToSuborderRequest} addItemToSuborderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSuborder1(suborderId: string, addItemToSuborderRequest: AddItemToSuborderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSuborder1(suborderId, addItemToSuborderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderAdjustmentControllerApi.updateSuborder1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update order charge date, accepts dates up to three months in the future
         * @param {string} suborderId Suborder Id
         * @param {UpdateSuborderChargeDateRequest} updateSuborderChargeDateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSuborderChargeDate(suborderId: string, updateSuborderChargeDateRequest: UpdateSuborderChargeDateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSuborderChargeDate(suborderId, updateSuborderChargeDateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderAdjustmentControllerApi.updateSuborderChargeDate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderAdjustmentControllerApi - factory interface
 * @export
 */
export const OrderAdjustmentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderAdjustmentControllerApiFp(configuration)
    return {
        /**
         * ORDER ADJUSTMENT: Change suborder status (Allowed transitions [APPROVED, FULFILLMENT_IN_PROGRESS]->DECLINED, [DECLINED, EXPIRED]->APPROVED)
         * @param {string} id Suborder Id
         * @param {ChangeSuborderStatusRequest} changeSuborderStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeSuborderStatus(id: string, changeSuborderStatusRequest: ChangeSuborderStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changeSuborderStatus(id, changeSuborderStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Set order to manually charged, killing the charge posthook and setting the charge date to null
         * @param {string} suborderId Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSuborderToManuallyCharged(suborderId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setSuborderToManuallyCharged(suborderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update packing slip\'s shipped quantities
         * @param {string} packingSlipId 
         * @param {ListRequestWrapperUpdatePackingSlipShippedQuantitiesRequest} listRequestWrapperUpdatePackingSlipShippedQuantitiesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShippedQuantities(packingSlipId: string, listRequestWrapperUpdatePackingSlipShippedQuantitiesRequest: ListRequestWrapperUpdatePackingSlipShippedQuantitiesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateShippedQuantities(packingSlipId, listRequestWrapperUpdatePackingSlipShippedQuantitiesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add items (product variants) to an suborder. Fulfilled and shipped quantities are optional.
         * @param {string} suborderId Suborder id
         * @param {AddItemToSuborderRequest} addItemToSuborderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuborder1(suborderId: string, addItemToSuborderRequest: AddItemToSuborderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSuborder1(suborderId, addItemToSuborderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update order charge date, accepts dates up to three months in the future
         * @param {string} suborderId Suborder Id
         * @param {UpdateSuborderChargeDateRequest} updateSuborderChargeDateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuborderChargeDate(suborderId: string, updateSuborderChargeDateRequest: UpdateSuborderChargeDateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSuborderChargeDate(suborderId, updateSuborderChargeDateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderAdjustmentControllerApi - interface
 * @export
 * @interface OrderAdjustmentControllerApi
 */
export interface OrderAdjustmentControllerApiInterface {
    /**
     * ORDER ADJUSTMENT: Change suborder status (Allowed transitions [APPROVED, FULFILLMENT_IN_PROGRESS]->DECLINED, [DECLINED, EXPIRED]->APPROVED)
     * @param {string} id Suborder Id
     * @param {ChangeSuborderStatusRequest} changeSuborderStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderAdjustmentControllerApiInterface
     */
    changeSuborderStatus(id: string, changeSuborderStatusRequest: ChangeSuborderStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Set order to manually charged, killing the charge posthook and setting the charge date to null
     * @param {string} suborderId Suborder Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderAdjustmentControllerApiInterface
     */
    setSuborderToManuallyCharged(suborderId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update packing slip\'s shipped quantities
     * @param {string} packingSlipId 
     * @param {ListRequestWrapperUpdatePackingSlipShippedQuantitiesRequest} listRequestWrapperUpdatePackingSlipShippedQuantitiesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderAdjustmentControllerApiInterface
     */
    updateShippedQuantities(packingSlipId: string, listRequestWrapperUpdatePackingSlipShippedQuantitiesRequest: ListRequestWrapperUpdatePackingSlipShippedQuantitiesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Add items (product variants) to an suborder. Fulfilled and shipped quantities are optional.
     * @param {string} suborderId Suborder id
     * @param {AddItemToSuborderRequest} addItemToSuborderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderAdjustmentControllerApiInterface
     */
    updateSuborder1(suborderId: string, addItemToSuborderRequest: AddItemToSuborderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update order charge date, accepts dates up to three months in the future
     * @param {string} suborderId Suborder Id
     * @param {UpdateSuborderChargeDateRequest} updateSuborderChargeDateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderAdjustmentControllerApiInterface
     */
    updateSuborderChargeDate(suborderId: string, updateSuborderChargeDateRequest: UpdateSuborderChargeDateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * OrderAdjustmentControllerApi - object-oriented interface
 * @export
 * @class OrderAdjustmentControllerApi
 * @extends {BaseAPI}
 */
export class OrderAdjustmentControllerApi extends BaseAPI implements OrderAdjustmentControllerApiInterface {
    /**
     * ORDER ADJUSTMENT: Change suborder status (Allowed transitions [APPROVED, FULFILLMENT_IN_PROGRESS]->DECLINED, [DECLINED, EXPIRED]->APPROVED)
     * @param {string} id Suborder Id
     * @param {ChangeSuborderStatusRequest} changeSuborderStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderAdjustmentControllerApi
     */
    public changeSuborderStatus(id: string, changeSuborderStatusRequest: ChangeSuborderStatusRequest, options?: RawAxiosRequestConfig) {
        return OrderAdjustmentControllerApiFp(this.configuration).changeSuborderStatus(id, changeSuborderStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set order to manually charged, killing the charge posthook and setting the charge date to null
     * @param {string} suborderId Suborder Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderAdjustmentControllerApi
     */
    public setSuborderToManuallyCharged(suborderId: string, options?: RawAxiosRequestConfig) {
        return OrderAdjustmentControllerApiFp(this.configuration).setSuborderToManuallyCharged(suborderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update packing slip\'s shipped quantities
     * @param {string} packingSlipId 
     * @param {ListRequestWrapperUpdatePackingSlipShippedQuantitiesRequest} listRequestWrapperUpdatePackingSlipShippedQuantitiesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderAdjustmentControllerApi
     */
    public updateShippedQuantities(packingSlipId: string, listRequestWrapperUpdatePackingSlipShippedQuantitiesRequest: ListRequestWrapperUpdatePackingSlipShippedQuantitiesRequest, options?: RawAxiosRequestConfig) {
        return OrderAdjustmentControllerApiFp(this.configuration).updateShippedQuantities(packingSlipId, listRequestWrapperUpdatePackingSlipShippedQuantitiesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add items (product variants) to an suborder. Fulfilled and shipped quantities are optional.
     * @param {string} suborderId Suborder id
     * @param {AddItemToSuborderRequest} addItemToSuborderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderAdjustmentControllerApi
     */
    public updateSuborder1(suborderId: string, addItemToSuborderRequest: AddItemToSuborderRequest, options?: RawAxiosRequestConfig) {
        return OrderAdjustmentControllerApiFp(this.configuration).updateSuborder1(suborderId, addItemToSuborderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update order charge date, accepts dates up to three months in the future
     * @param {string} suborderId Suborder Id
     * @param {UpdateSuborderChargeDateRequest} updateSuborderChargeDateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderAdjustmentControllerApi
     */
    public updateSuborderChargeDate(suborderId: string, updateSuborderChargeDateRequest: UpdateSuborderChargeDateRequest, options?: RawAxiosRequestConfig) {
        return OrderAdjustmentControllerApiFp(this.configuration).updateSuborderChargeDate(suborderId, updateSuborderChargeDateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderControllerApi - axios parameter creator
 * @export
 */
export const OrderControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Accept suborder
         * @param {string} id Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptSuborder: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('acceptSuborder', 'id', id)
            const localVarPath = `/orders/suborders/{id}/accept`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add suborder shipping info
         * @param {string} id Suborder Id
         * @param {AddSuborderShippingInfoRequest} addSuborderShippingInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSuborderShippingInfo: async (id: string, addSuborderShippingInfoRequest: AddSuborderShippingInfoRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addSuborderShippingInfo', 'id', id)
            // verify required parameter 'addSuborderShippingInfoRequest' is not null or undefined
            assertParamExists('addSuborderShippingInfo', 'addSuborderShippingInfoRequest', addSuborderShippingInfoRequest)
            const localVarPath = `/orders/suborders/{id}/add-shipping-info`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addSuborderShippingInfoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Hook for charging an suborder. After suborder is shipped, payment is scheduled for specific date on Posthook. Once it is time for payment, this endpoint is hit by the Posthook.
         * @param {string} id Suborder Id
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceFailedPaymentCapture: async (id: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('balanceFailedPaymentCapture', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('balanceFailedPaymentCapture', 'body', body)
            const localVarPath = `/orders/suborders/{id}/balance-fail-payment-capture`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Split packing slip in batch
         * @param {string} suborderId Suborder Id
         * @param {BatchSplitShipmentRequest} batchSplitShipmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchSplitShip: async (suborderId: string, batchSplitShipmentRequest: BatchSplitShipmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'suborderId' is not null or undefined
            assertParamExists('batchSplitShip', 'suborderId', suborderId)
            // verify required parameter 'batchSplitShipmentRequest' is not null or undefined
            assertParamExists('batchSplitShip', 'batchSplitShipmentRequest', batchSplitShipmentRequest)
            const localVarPath = `/orders/suborders/{suborderId}/batch-split-ship`
                .replace(`{${"suborderId"}}`, encodeURIComponent(String(suborderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchSplitShipmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send brand order reminder emails
         * @param {string} id Suborder Id
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brandOrderReminder: async (id: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('brandOrderReminder', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('brandOrderReminder', 'body', body)
            const localVarPath = `/orders/suborders/{id}/send-reminder`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Hook for charging an suborder. After suborder is shipped, payment is scheduled for specific date on Posthook. Once it is time for payment, this endpoint is hit by the Posthook.
         * @param {string} id Suborder Id
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        captureFailPayment: async (id: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('captureFailPayment', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('captureFailPayment', 'body', body)
            const localVarPath = `/orders/suborders/{id}/fail-payment-capture`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change billing address of suborder
         * @param {string} suborderId Suborder Id
         * @param {string} addressId Address Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeSuborderBillingAddress: async (suborderId: string, addressId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'suborderId' is not null or undefined
            assertParamExists('changeSuborderBillingAddress', 'suborderId', suborderId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('changeSuborderBillingAddress', 'addressId', addressId)
            const localVarPath = `/orders/suborders/{suborderId}/billing-address/{addressId}`
                .replace(`{${"suborderId"}}`, encodeURIComponent(String(suborderId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change suborder\'s credit card
         * @param {string} id Suborder Id
         * @param {ChangeSuborderCreditCardRequest} changeSuborderCreditCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeSuborderCard: async (id: string, changeSuborderCreditCardRequest: ChangeSuborderCreditCardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changeSuborderCard', 'id', id)
            // verify required parameter 'changeSuborderCreditCardRequest' is not null or undefined
            assertParamExists('changeSuborderCard', 'changeSuborderCreditCardRequest', changeSuborderCreditCardRequest)
            const localVarPath = `/orders/suborders/{id}/change-card`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeSuborderCreditCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Hook for charging an suborder. After suborder is shipped, payment is scheduled for specific date on Posthook. Once it is time for payment, this endpoint is hit by the Posthook.
         * @param {string} id Suborder Id
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chargeSuborder: async (id: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('chargeSuborder', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('chargeSuborder', 'body', body)
            const localVarPath = `/orders/suborders/{id}/charge-v2`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm packing slip
         * @param {string} id Packing Slip Id
         * @param {ConfirmPackingSlipRequest} confirmPackingSlipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPackingSlip: async (id: string, confirmPackingSlipRequest: ConfirmPackingSlipRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('confirmPackingSlip', 'id', id)
            // verify required parameter 'confirmPackingSlipRequest' is not null or undefined
            assertParamExists('confirmPackingSlip', 'confirmPackingSlipRequest', confirmPackingSlipRequest)
            const localVarPath = `/orders/suborders/packing-slips/{id}/confirm`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmPackingSlipRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create balance order
         * @param {CreateBalanceOrderRequest} createBalanceOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBalanceOrder: async (createBalanceOrderRequest: CreateBalanceOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBalanceOrderRequest' is not null or undefined
            assertParamExists('createBalanceOrder', 'createBalanceOrderRequest', createBalanceOrderRequest)
            const localVarPath = `/orders/balance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBalanceOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create order
         * @param {CreateOrderRequest} createOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrder: async (createOrderRequest: CreateOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOrderRequest' is not null or undefined
            assertParamExists('createOrder', 'createOrderRequest', createOrderRequest)
            const localVarPath = `/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create order return
         * @param {string} id Order Id
         * @param {CreateOrderReturnRequest} createOrderReturnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderReturn: async (id: string, createOrderReturnRequest: CreateOrderReturnRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createOrderReturn', 'id', id)
            // verify required parameter 'createOrderReturnRequest' is not null or undefined
            assertParamExists('createOrderReturn', 'createOrderReturnRequest', createOrderReturnRequest)
            const localVarPath = `/orders/{id}/order-returns`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrderReturnRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create packing slip
         * @param {string} suborderId Suborder Id
         * @param {CreatePackingSlipRequest} createPackingSlipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPackingSlip: async (suborderId: string, createPackingSlipRequest: CreatePackingSlipRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'suborderId' is not null or undefined
            assertParamExists('createPackingSlip', 'suborderId', suborderId)
            // verify required parameter 'createPackingSlipRequest' is not null or undefined
            assertParamExists('createPackingSlip', 'createPackingSlipRequest', createPackingSlipRequest)
            const localVarPath = `/orders/suborders/{suborderId}/packing-slips`
                .replace(`{${"suborderId"}}`, encodeURIComponent(String(suborderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPackingSlipRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Decline suborder
         * @param {string} id Suborder Id
         * @param {DeclineSuborderRequest} declineSuborderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineSuborder: async (id: string, declineSuborderRequest: DeclineSuborderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('declineSuborder', 'id', id)
            // verify required parameter 'declineSuborderRequest' is not null or undefined
            assertParamExists('declineSuborder', 'declineSuborderRequest', declineSuborderRequest)
            const localVarPath = `/orders/suborders/{id}/decline`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(declineSuborderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Decline packing slip
         * @param {string} id Packing Slip Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delcinePackingSlip: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('delcinePackingSlip', 'id', id)
            const localVarPath = `/orders/suborders/packing-slips/{id}/decline`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete order
         * @param {string} id Order Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrder: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrder', 'id', id)
            const localVarPath = `/orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete packing slips
         * @param {DeletePackingSlipsRequest} deletePackingSlipsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePackingSlips: async (deletePackingSlipsRequest: DeletePackingSlipsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deletePackingSlipsRequest' is not null or undefined
            assertParamExists('deletePackingSlips', 'deletePackingSlipsRequest', deletePackingSlipsRequest)
            const localVarPath = `/orders/packing-slips`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deletePackingSlipsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Draft packing slip
         * @param {string} id Packing Slip Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        draftPackingSlip: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('draftPackingSlip', 'id', id)
            const localVarPath = `/orders/suborders/packing-slips/{id}/draft`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Estimate shipping cost using ShipEngine API
         * @param {EstimateShippingRequest} estimateShippingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        estimateShipping: async (estimateShippingRequest: EstimateShippingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'estimateShippingRequest' is not null or undefined
            assertParamExists('estimateShipping', 'estimateShippingRequest', estimateShippingRequest)
            const localVarPath = `/orders/estimate-shipping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(estimateShippingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Changes suborder status on expired
         * @param {string} id Suborder id
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expireSuborder: async (id: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('expireSuborder', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('expireSuborder', 'body', body)
            const localVarPath = `/orders/suborders/{id}/expire`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export brand orders to csv file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportBrandOrdersToCsv: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/orders/brands/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export orders to csv file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportOrdersToCsv: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/orders/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export retailer orders to csv file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportRetailerOrdersToCsv: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/orders/retailers/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * find all the duplicate order between provided date with delta if provided.
         * @param {string} start Start Date
         * @param {string} end End Date
         * @param {number} delta Maximum Delta between order in second
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDuplicateOrder: async (start: string, end: string, delta: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'start' is not null or undefined
            assertParamExists('findDuplicateOrder', 'start', start)
            // verify required parameter 'end' is not null or undefined
            assertParamExists('findDuplicateOrder', 'end', end)
            // verify required parameter 'delta' is not null or undefined
            assertParamExists('findDuplicateOrder', 'delta', delta)
            const localVarPath = `/orders/duplicate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }

            if (delta !== undefined) {
                localVarQueryParameter['delta'] = delta;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate order return slip
         * @param {string} id Order return Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOrderReturnSlip: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('generateOrderReturnSlip', 'id', id)
            const localVarPath = `/orders/order-returns/{id}/print`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate packing slip
         * @param {string} id Packing Slip Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePackingSlip: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('generatePackingSlip', 'id', id)
            const localVarPath = `/orders/suborders/packing-slips/{id}/print`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all decline order reasons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeclineReason: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/orders/decline-reasons/dropdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cart validation, receives array of ProductVariant UUIDs. Returns deleted variants with details.
         * @param {GetDeletedVariantsRequest} getDeletedVariantsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeletedVariants: async (getDeletedVariantsRequest: GetDeletedVariantsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getDeletedVariantsRequest' is not null or undefined
            assertParamExists('getDeletedVariants', 'getDeletedVariantsRequest', getDeletedVariantsRequest)
            const localVarPath = `/orders/check-deleted-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getDeletedVariantsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Invoice by Suborder Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceBySuborderId: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInvoiceBySuborderId', 'id', id)
            const localVarPath = `/orders/suborders/{id}/invoice`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all minimum order values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMinimumOrderValues: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/orders/minimum-order-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns number of orders created by retailer for given brand
         * @param {string} brandId Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyOrderCountByBrand: async (brandId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getMyOrderCountByBrand', 'brandId', brandId)
            const localVarPath = `/orders/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (brandId !== undefined) {
                localVarQueryParameter['brand_id'] = brandId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get order details by Id
         * @param {string} id Order Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderDetails: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOrderDetails', 'id', id)
            const localVarPath = `/orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get order preview
         * @param {string} id Order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderDetailsForSuborder: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOrderDetailsForSuborder', 'id', id)
            const localVarPath = `/orders/{id}/preview`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get order return by Id
         * @param {string} id Order Return Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderReturn: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOrderReturn', 'id', id)
            const localVarPath = `/orders/order-returns/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all order return reasons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderReturnReasons: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/orders/order-returns/order-return-reasons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all order returns
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderReturns: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/orders/order-returns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get order statuses for dropdown
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderStatusesDropdown: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/orders/statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all orders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrders: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find all orders for provided brand
         * @param {string} brandId Brand Id
         * @param {string} [retailerId] Retailer Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {string} [status] Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrdersByBrand: async (brandId: string, retailerId?: string, page?: number, size?: number, searchBy?: string, status?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getOrdersByBrand', 'brandId', brandId)
            const localVarPath = `/orders/brand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (brandId !== undefined) {
                localVarQueryParameter['brandId'] = brandId;
            }

            if (retailerId !== undefined) {
                localVarQueryParameter['retailerId'] = retailerId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (searchBy !== undefined) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find all orders for provided retailer
         * @param {string} retailerId Retailer Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {string} [status] Status
         * @param {string} [sortName] Sort name
         * @param {string} [sortValue] Sort value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrdersByRetailer: async (retailerId: string, page?: number, size?: number, searchBy?: string, status?: string, sortName?: string, sortValue?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'retailerId' is not null or undefined
            assertParamExists('getOrdersByRetailer', 'retailerId', retailerId)
            const localVarPath = `/orders/retailer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (retailerId !== undefined) {
                localVarQueryParameter['retailerId'] = retailerId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (searchBy !== undefined) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (sortName !== undefined) {
                localVarQueryParameter['sortName'] = sortName;
            }

            if (sortValue !== undefined) {
                localVarQueryParameter['sortValue'] = sortValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find all orders per multiple/custom criteria
         * @param {string} [retailerId] Retailer Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {string} [status] Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrdersFiltered: async (retailerId?: string, page?: number, size?: number, searchBy?: string, status?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/orders/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (retailerId !== undefined) {
                localVarQueryParameter['retailerId'] = retailerId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (searchBy !== undefined) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get packing slip by Id
         * @param {string} suborderId Suborder Id
         * @param {string} id PackingSlip Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackingSlip: async (suborderId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'suborderId' is not null or undefined
            assertParamExists('getPackingSlip', 'suborderId', suborderId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPackingSlip', 'id', id)
            const localVarPath = `/orders/suborders/{suborderId}/packing-slips/{id}`
                .replace(`{${"suborderId"}}`, encodeURIComponent(String(suborderId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get packing slips by suborder Id
         * @param {string} suborderId Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackingSlips: async (suborderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'suborderId' is not null or undefined
            assertParamExists('getPackingSlips', 'suborderId', suborderId)
            const localVarPath = `/orders/suborders/{suborderId}/packing slips`
                .replace(`{${"suborderId"}}`, encodeURIComponent(String(suborderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get packing slip by order Id
         * @param {string} id Order Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackingSlipsByOrder: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPackingSlipsByOrder', 'id', id)
            const localVarPath = `/orders/{id}/packing-slips`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get information for billing address and card
         * @param {string} id ID of suborder with invoice needed for payment information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayInvoiceInfo: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPayInvoiceInfo', 'id', id)
            const localVarPath = `/orders/suborders/{id}/pay-invoice-info`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Payment by Suborder Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentBySuborderId: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPaymentBySuborderId', 'id', id)
            const localVarPath = `/orders/suborders/{id}/payment`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all retailer reorders
         * @param {number} page Page
         * @param {number} size Size
         * @param {string} [query] Search Term
         * @param {string} [sort] Sort Order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReorders: async (page: number, size: number, query?: string, sort?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getReorders', 'page', page)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('getReorders', 'size', size)
            const localVarPath = `/orders/reorders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all shipping carriers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShippingCarriers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/orders/shipping-carriers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get suborder by Id
         * @param {string} id Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuborder: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSuborder', 'id', id)
            const localVarPath = `/orders/suborders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pay on invoice
         * @param {string} suborderId Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payInvoice: async (suborderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'suborderId' is not null or undefined
            assertParamExists('payInvoice', 'suborderId', suborderId)
            const localVarPath = `/orders/suborders/{suborderId}/pay-invoice`
                .replace(`{${"suborderId"}}`, encodeURIComponent(String(suborderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pay suborder
         * @param {string} id Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paySuborder: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('paySuborder', 'id', id)
            const localVarPath = `/orders/suborders/{id}/paid`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get order confirmation data by Id
         * @param {string} id Order Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retailerGetOrder: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retailerGetOrder', 'id', id)
            const localVarPath = `/orders/{id}/confirmation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set suborder status as partially shipped
         * @param {string} id Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSuborderAsPartiallyShipped: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setSuborderAsPartiallyShipped', 'id', id)
            const localVarPath = `/orders/suborders/{id}/partially-shipped`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create multiple packing slips using split shipment
         * @param {string} suborderId Suborder Id
         * @param {SplitShipRequest} splitShipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        splitShip: async (suborderId: string, splitShipRequest: SplitShipRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'suborderId' is not null or undefined
            assertParamExists('splitShip', 'suborderId', suborderId)
            // verify required parameter 'splitShipRequest' is not null or undefined
            assertParamExists('splitShip', 'splitShipRequest', splitShipRequest)
            const localVarPath = `/orders/suborders/{suborderId}/split-ship`
                .replace(`{${"suborderId"}}`, encodeURIComponent(String(suborderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(splitShipRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update and accept suborder
         * @param {string} id Suborder Id
         * @param {UpdateSuborderRequest} updateSuborderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAndAcceptSuborder: async (id: string, updateSuborderRequest: UpdateSuborderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAndAcceptSuborder', 'id', id)
            // verify required parameter 'updateSuborderRequest' is not null or undefined
            assertParamExists('updateAndAcceptSuborder', 'updateSuborderRequest', updateSuborderRequest)
            const localVarPath = `/orders/suborders/{id}/update-accept`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSuborderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update algolia and salesforce by suborder number
         * @param {UpdateExternalServiceRequest} updateExternalServiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExternalService: async (updateExternalServiceRequest: UpdateExternalServiceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateExternalServiceRequest' is not null or undefined
            assertParamExists('updateExternalService', 'updateExternalServiceRequest', updateExternalServiceRequest)
            const localVarPath = `/orders/update-external-service`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateExternalServiceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update order return
         * @param {string} id Order return Id
         * @param {UpdateOrderReturnRequest} updateOrderReturnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderReturn: async (id: string, updateOrderReturnRequest: UpdateOrderReturnRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOrderReturn', 'id', id)
            // verify required parameter 'updateOrderReturnRequest' is not null or undefined
            assertParamExists('updateOrderReturn', 'updateOrderReturnRequest', updateOrderReturnRequest)
            const localVarPath = `/orders/order-returns/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderReturnRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update order return items
         * @param {string} id Order return Id
         * @param {UpdateOrderReturnItemsRequest} updateOrderReturnItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderReturnItems: async (id: string, updateOrderReturnItemsRequest: UpdateOrderReturnItemsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOrderReturnItems', 'id', id)
            // verify required parameter 'updateOrderReturnItemsRequest' is not null or undefined
            assertParamExists('updateOrderReturnItems', 'updateOrderReturnItemsRequest', updateOrderReturnItemsRequest)
            const localVarPath = `/orders/order-returns/{id}/items`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderReturnItemsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update packing slip
         * @param {string} id Packing Slip Id
         * @param {UpdatePackingSlipRequest} updatePackingSlipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePackingSlip: async (id: string, updatePackingSlipRequest: UpdatePackingSlipRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePackingSlip', 'id', id)
            // verify required parameter 'updatePackingSlipRequest' is not null or undefined
            assertParamExists('updatePackingSlip', 'updatePackingSlipRequest', updatePackingSlipRequest)
            const localVarPath = `/orders/suborders/packing-slips/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePackingSlipRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update suborder
         * @param {string} id Suborder Id
         * @param {UpdateSuborderRequest} updateSuborderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuborder: async (id: string, updateSuborderRequest: UpdateSuborderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSuborder', 'id', id)
            // verify required parameter 'updateSuborderRequest' is not null or undefined
            assertParamExists('updateSuborder', 'updateSuborderRequest', updateSuborderRequest)
            const localVarPath = `/orders/suborders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSuborderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Attach card to suborder from invoice
         * @param {string} suborderId Suborder Id
         * @param {UpdateSuborderCreditCardRequest} updateSuborderCreditCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuborderCard: async (suborderId: string, updateSuborderCreditCardRequest: UpdateSuborderCreditCardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'suborderId' is not null or undefined
            assertParamExists('updateSuborderCard', 'suborderId', suborderId)
            // verify required parameter 'updateSuborderCreditCardRequest' is not null or undefined
            assertParamExists('updateSuborderCard', 'updateSuborderCreditCardRequest', updateSuborderCreditCardRequest)
            const localVarPath = `/orders/invoices/{suborderId}/update-card`
                .replace(`{${"suborderId"}}`, encodeURIComponent(String(suborderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSuborderCreditCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate minimum order value. Checks if total order value is higher or lower than minimum order value.
         * @param {MinimumOrderValueValidationRequest} minimumOrderValueValidationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateMinimumOrderValue: async (minimumOrderValueValidationRequest: MinimumOrderValueValidationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'minimumOrderValueValidationRequest' is not null or undefined
            assertParamExists('validateMinimumOrderValue', 'minimumOrderValueValidationRequest', minimumOrderValueValidationRequest)
            const localVarPath = `/orders/mov-validation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(minimumOrderValueValidationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderControllerApi - functional programming interface
 * @export
 */
export const OrderControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Accept suborder
         * @param {string} id Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptSuborder(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptSuborder(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.acceptSuborder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add suborder shipping info
         * @param {string} id Suborder Id
         * @param {AddSuborderShippingInfoRequest} addSuborderShippingInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSuborderShippingInfo(id: string, addSuborderShippingInfoRequest: AddSuborderShippingInfoRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSuborderShippingInfo(id, addSuborderShippingInfoRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.addSuborderShippingInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Hook for charging an suborder. After suborder is shipped, payment is scheduled for specific date on Posthook. Once it is time for payment, this endpoint is hit by the Posthook.
         * @param {string} id Suborder Id
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceFailedPaymentCapture(id: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceFailedPaymentCapture(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.balanceFailedPaymentCapture']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Split packing slip in batch
         * @param {string} suborderId Suborder Id
         * @param {BatchSplitShipmentRequest} batchSplitShipmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async batchSplitShip(suborderId: string, batchSplitShipmentRequest: BatchSplitShipmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.batchSplitShip(suborderId, batchSplitShipmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.batchSplitShip']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send brand order reminder emails
         * @param {string} id Suborder Id
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brandOrderReminder(id: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.brandOrderReminder(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.brandOrderReminder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Hook for charging an suborder. After suborder is shipped, payment is scheduled for specific date on Posthook. Once it is time for payment, this endpoint is hit by the Posthook.
         * @param {string} id Suborder Id
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async captureFailPayment(id: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.captureFailPayment(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.captureFailPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change billing address of suborder
         * @param {string} suborderId Suborder Id
         * @param {string} addressId Address Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeSuborderBillingAddress(suborderId: string, addressId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeSuborderBillingAddress(suborderId, addressId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.changeSuborderBillingAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change suborder\'s credit card
         * @param {string} id Suborder Id
         * @param {ChangeSuborderCreditCardRequest} changeSuborderCreditCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeSuborderCard(id: string, changeSuborderCreditCardRequest: ChangeSuborderCreditCardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeSuborderCard(id, changeSuborderCreditCardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.changeSuborderCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Hook for charging an suborder. After suborder is shipped, payment is scheduled for specific date on Posthook. Once it is time for payment, this endpoint is hit by the Posthook.
         * @param {string} id Suborder Id
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chargeSuborder(id: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chargeSuborder(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.chargeSuborder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Confirm packing slip
         * @param {string} id Packing Slip Id
         * @param {ConfirmPackingSlipRequest} confirmPackingSlipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmPackingSlip(id: string, confirmPackingSlipRequest: ConfirmPackingSlipRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmPackingSlip(id, confirmPackingSlipRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.confirmPackingSlip']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create balance order
         * @param {CreateBalanceOrderRequest} createBalanceOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBalanceOrder(createBalanceOrderRequest: CreateBalanceOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBalanceOrder(createBalanceOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.createBalanceOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create order
         * @param {CreateOrderRequest} createOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrder(createOrderRequest: CreateOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrder(createOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.createOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create order return
         * @param {string} id Order Id
         * @param {CreateOrderReturnRequest} createOrderReturnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrderReturn(id: string, createOrderReturnRequest: CreateOrderReturnRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrderReturn(id, createOrderReturnRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.createOrderReturn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create packing slip
         * @param {string} suborderId Suborder Id
         * @param {CreatePackingSlipRequest} createPackingSlipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPackingSlip(suborderId: string, createPackingSlipRequest: CreatePackingSlipRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPackingSlip(suborderId, createPackingSlipRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.createPackingSlip']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Decline suborder
         * @param {string} id Suborder Id
         * @param {DeclineSuborderRequest} declineSuborderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declineSuborder(id: string, declineSuborderRequest: DeclineSuborderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declineSuborder(id, declineSuborderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.declineSuborder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Decline packing slip
         * @param {string} id Packing Slip Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delcinePackingSlip(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delcinePackingSlip(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.delcinePackingSlip']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete order
         * @param {string} id Order Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrder(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrder(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.deleteOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete packing slips
         * @param {DeletePackingSlipsRequest} deletePackingSlipsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePackingSlips(deletePackingSlipsRequest: DeletePackingSlipsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePackingSlips(deletePackingSlipsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.deletePackingSlips']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Draft packing slip
         * @param {string} id Packing Slip Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async draftPackingSlip(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.draftPackingSlip(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.draftPackingSlip']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Estimate shipping cost using ShipEngine API
         * @param {EstimateShippingRequest} estimateShippingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async estimateShipping(estimateShippingRequest: EstimateShippingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EstimateShippingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.estimateShipping(estimateShippingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.estimateShipping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Changes suborder status on expired
         * @param {string} id Suborder id
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async expireSuborder(id: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.expireSuborder(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.expireSuborder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export brand orders to csv file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportBrandOrdersToCsv(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportBrandOrdersToCsv(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.exportBrandOrdersToCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export orders to csv file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportOrdersToCsv(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportOrdersToCsv(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.exportOrdersToCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export retailer orders to csv file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportRetailerOrdersToCsv(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportRetailerOrdersToCsv(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.exportRetailerOrdersToCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * find all the duplicate order between provided date with delta if provided.
         * @param {string} start Start Date
         * @param {string} end End Date
         * @param {number} delta Maximum Delta between order in second
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findDuplicateOrder(start: string, end: string, delta: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DuplicateOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findDuplicateOrder(start, end, delta, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.findDuplicateOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate order return slip
         * @param {string} id Order return Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateOrderReturnSlip(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateOrderReturnSlip(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.generateOrderReturnSlip']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate packing slip
         * @param {string} id Packing Slip Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generatePackingSlip(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePackingSlip(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.generatePackingSlip']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all decline order reasons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeclineReason(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DropdownItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeclineReason(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.getDeclineReason']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cart validation, receives array of ProductVariant UUIDs. Returns deleted variants with details.
         * @param {GetDeletedVariantsRequest} getDeletedVariantsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeletedVariants(getDeletedVariantsRequest: GetDeletedVariantsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDeletedVariantsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeletedVariants(getDeletedVariantsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.getDeletedVariants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Invoice by Suborder Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceBySuborderId(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceBySuborderId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.getInvoiceBySuborderId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all minimum order values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMinimumOrderValues(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MinimumOrderValuesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMinimumOrderValues(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.getMinimumOrderValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns number of orders created by retailer for given brand
         * @param {string} brandId Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyOrderCountByBrand(brandId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderCountByBrandResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyOrderCountByBrand(brandId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.getMyOrderCountByBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get order details by Id
         * @param {string} id Order Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderDetails(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.getOrderDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get order preview
         * @param {string} id Order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderDetailsForSuborder(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderPreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderDetailsForSuborder(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.getOrderDetailsForSuborder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get order return by Id
         * @param {string} id Order Return Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderReturn(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderReturnResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderReturn(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.getOrderReturn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all order return reasons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderReturnReasons(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderReturnReasonResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderReturnReasons(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.getOrderReturnReasons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all order returns
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderReturns(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderReturnResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderReturns(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.getOrderReturns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get order statuses for dropdown
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderStatusesDropdown(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEnumOptionsResponseOrderStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderStatusesDropdown(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.getOrderStatusesDropdown']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all orders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrders(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.getOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find all orders for provided brand
         * @param {string} brandId Brand Id
         * @param {string} [retailerId] Retailer Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {string} [status] Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrdersByBrand(brandId: string, retailerId?: string, page?: number, size?: number, searchBy?: string, status?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOrdersForSubordersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrdersByBrand(brandId, retailerId, page, size, searchBy, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.getOrdersByBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find all orders for provided retailer
         * @param {string} retailerId Retailer Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {string} [status] Status
         * @param {string} [sortName] Sort name
         * @param {string} [sortValue] Sort value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrdersByRetailer(retailerId: string, page?: number, size?: number, searchBy?: string, status?: string, sortName?: string, sortValue?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOrdersForSubordersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrdersByRetailer(retailerId, page, size, searchBy, status, sortName, sortValue, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.getOrdersByRetailer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find all orders per multiple/custom criteria
         * @param {string} [retailerId] Retailer Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {string} [status] Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrdersFiltered(retailerId?: string, page?: number, size?: number, searchBy?: string, status?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOrdersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrdersFiltered(retailerId, page, size, searchBy, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.getOrdersFiltered']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get packing slip by Id
         * @param {string} suborderId Suborder Id
         * @param {string} id PackingSlip Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPackingSlip(suborderId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PackingSlipResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPackingSlip(suborderId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.getPackingSlip']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get packing slips by suborder Id
         * @param {string} suborderId Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPackingSlips(suborderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PackingSlipResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPackingSlips(suborderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.getPackingSlips']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get packing slip by order Id
         * @param {string} id Order Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPackingSlipsByOrder(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PackingSlipResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPackingSlipsByOrder(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.getPackingSlipsByOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get information for billing address and card
         * @param {string} id ID of suborder with invoice needed for payment information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayInvoiceInfo(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPayInvoiceInformationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayInvoiceInfo(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.getPayInvoiceInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Payment by Suborder Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentBySuborderId(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPaymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentBySuborderId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.getPaymentBySuborderId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all retailer reorders
         * @param {number} page Page
         * @param {number} size Size
         * @param {string} [query] Search Term
         * @param {string} [sort] Sort Order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReorders(page: number, size: number, query?: string, sort?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReorderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReorders(page, size, query, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.getReorders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all shipping carriers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShippingCarriers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShippingCarrierResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShippingCarriers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.getShippingCarriers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get suborder by Id
         * @param {string} id Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuborder(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuborderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuborder(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.getSuborder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pay on invoice
         * @param {string} suborderId Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async payInvoice(suborderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayInvoiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.payInvoice(suborderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.payInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pay suborder
         * @param {string} id Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paySuborder(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paySuborder(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.paySuborder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get order confirmation data by Id
         * @param {string} id Order Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retailerGetOrder(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retailerGetOrder(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.retailerGetOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set suborder status as partially shipped
         * @param {string} id Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setSuborderAsPartiallyShipped(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setSuborderAsPartiallyShipped(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.setSuborderAsPartiallyShipped']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create multiple packing slips using split shipment
         * @param {string} suborderId Suborder Id
         * @param {SplitShipRequest} splitShipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async splitShip(suborderId: string, splitShipRequest: SplitShipRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SplitShipResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.splitShip(suborderId, splitShipRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.splitShip']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update and accept suborder
         * @param {string} id Suborder Id
         * @param {UpdateSuborderRequest} updateSuborderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAndAcceptSuborder(id: string, updateSuborderRequest: UpdateSuborderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateSuborderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAndAcceptSuborder(id, updateSuborderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.updateAndAcceptSuborder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update algolia and salesforce by suborder number
         * @param {UpdateExternalServiceRequest} updateExternalServiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExternalService(updateExternalServiceRequest: UpdateExternalServiceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExternalService(updateExternalServiceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.updateExternalService']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update order return
         * @param {string} id Order return Id
         * @param {UpdateOrderReturnRequest} updateOrderReturnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrderReturn(id: string, updateOrderReturnRequest: UpdateOrderReturnRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrderReturn(id, updateOrderReturnRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.updateOrderReturn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update order return items
         * @param {string} id Order return Id
         * @param {UpdateOrderReturnItemsRequest} updateOrderReturnItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrderReturnItems(id: string, updateOrderReturnItemsRequest: UpdateOrderReturnItemsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrderReturnItems(id, updateOrderReturnItemsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.updateOrderReturnItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update packing slip
         * @param {string} id Packing Slip Id
         * @param {UpdatePackingSlipRequest} updatePackingSlipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePackingSlip(id: string, updatePackingSlipRequest: UpdatePackingSlipRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePackingSlip(id, updatePackingSlipRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.updatePackingSlip']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update suborder
         * @param {string} id Suborder Id
         * @param {UpdateSuborderRequest} updateSuborderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSuborder(id: string, updateSuborderRequest: UpdateSuborderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateSuborderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSuborder(id, updateSuborderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.updateSuborder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Attach card to suborder from invoice
         * @param {string} suborderId Suborder Id
         * @param {UpdateSuborderCreditCardRequest} updateSuborderCreditCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSuborderCard(suborderId: string, updateSuborderCreditCardRequest: UpdateSuborderCreditCardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSuborderCard(suborderId, updateSuborderCreditCardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.updateSuborderCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate minimum order value. Checks if total order value is higher or lower than minimum order value.
         * @param {MinimumOrderValueValidationRequest} minimumOrderValueValidationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateMinimumOrderValue(minimumOrderValueValidationRequest: MinimumOrderValueValidationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateMinimumOrderValue(minimumOrderValueValidationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControllerApi.validateMinimumOrderValue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderControllerApi - factory interface
 * @export
 */
export const OrderControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderControllerApiFp(configuration)
    return {
        /**
         * Accept suborder
         * @param {string} id Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptSuborder(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.acceptSuborder(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Add suborder shipping info
         * @param {string} id Suborder Id
         * @param {AddSuborderShippingInfoRequest} addSuborderShippingInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSuborderShippingInfo(id: string, addSuborderShippingInfoRequest: AddSuborderShippingInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addSuborderShippingInfo(id, addSuborderShippingInfoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Hook for charging an suborder. After suborder is shipped, payment is scheduled for specific date on Posthook. Once it is time for payment, this endpoint is hit by the Posthook.
         * @param {string} id Suborder Id
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceFailedPaymentCapture(id: string, body: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.balanceFailedPaymentCapture(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Split packing slip in batch
         * @param {string} suborderId Suborder Id
         * @param {BatchSplitShipmentRequest} batchSplitShipmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchSplitShip(suborderId: string, batchSplitShipmentRequest: BatchSplitShipmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.batchSplitShip(suborderId, batchSplitShipmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Send brand order reminder emails
         * @param {string} id Suborder Id
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brandOrderReminder(id: string, body: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.brandOrderReminder(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Hook for charging an suborder. After suborder is shipped, payment is scheduled for specific date on Posthook. Once it is time for payment, this endpoint is hit by the Posthook.
         * @param {string} id Suborder Id
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        captureFailPayment(id: string, body: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.captureFailPayment(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Change billing address of suborder
         * @param {string} suborderId Suborder Id
         * @param {string} addressId Address Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeSuborderBillingAddress(suborderId: string, addressId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changeSuborderBillingAddress(suborderId, addressId, options).then((request) => request(axios, basePath));
        },
        /**
         * Change suborder\'s credit card
         * @param {string} id Suborder Id
         * @param {ChangeSuborderCreditCardRequest} changeSuborderCreditCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeSuborderCard(id: string, changeSuborderCreditCardRequest: ChangeSuborderCreditCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changeSuborderCard(id, changeSuborderCreditCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Hook for charging an suborder. After suborder is shipped, payment is scheduled for specific date on Posthook. Once it is time for payment, this endpoint is hit by the Posthook.
         * @param {string} id Suborder Id
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chargeSuborder(id: string, body: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.chargeSuborder(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm packing slip
         * @param {string} id Packing Slip Id
         * @param {ConfirmPackingSlipRequest} confirmPackingSlipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPackingSlip(id: string, confirmPackingSlipRequest: ConfirmPackingSlipRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.confirmPackingSlip(id, confirmPackingSlipRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create balance order
         * @param {CreateBalanceOrderRequest} createBalanceOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBalanceOrder(createBalanceOrderRequest: CreateBalanceOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateOrderResponse> {
            return localVarFp.createBalanceOrder(createBalanceOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create order
         * @param {CreateOrderRequest} createOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrder(createOrderRequest: CreateOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateOrderResponse> {
            return localVarFp.createOrder(createOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create order return
         * @param {string} id Order Id
         * @param {CreateOrderReturnRequest} createOrderReturnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderReturn(id: string, createOrderReturnRequest: CreateOrderReturnRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper> {
            return localVarFp.createOrderReturn(id, createOrderReturnRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create packing slip
         * @param {string} suborderId Suborder Id
         * @param {CreatePackingSlipRequest} createPackingSlipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPackingSlip(suborderId: string, createPackingSlipRequest: CreatePackingSlipRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper> {
            return localVarFp.createPackingSlip(suborderId, createPackingSlipRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Decline suborder
         * @param {string} id Suborder Id
         * @param {DeclineSuborderRequest} declineSuborderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineSuborder(id: string, declineSuborderRequest: DeclineSuborderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.declineSuborder(id, declineSuborderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Decline packing slip
         * @param {string} id Packing Slip Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delcinePackingSlip(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.delcinePackingSlip(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete order
         * @param {string} id Order Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrder(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete packing slips
         * @param {DeletePackingSlipsRequest} deletePackingSlipsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePackingSlips(deletePackingSlipsRequest: DeletePackingSlipsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePackingSlips(deletePackingSlipsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Draft packing slip
         * @param {string} id Packing Slip Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        draftPackingSlip(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.draftPackingSlip(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Estimate shipping cost using ShipEngine API
         * @param {EstimateShippingRequest} estimateShippingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        estimateShipping(estimateShippingRequest: EstimateShippingRequest, options?: RawAxiosRequestConfig): AxiosPromise<EstimateShippingResponse> {
            return localVarFp.estimateShipping(estimateShippingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Changes suborder status on expired
         * @param {string} id Suborder id
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expireSuborder(id: string, body: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.expireSuborder(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Export brand orders to csv file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportBrandOrdersToCsv(options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportBrandOrdersToCsv(options).then((request) => request(axios, basePath));
        },
        /**
         * Export orders to csv file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportOrdersToCsv(options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportOrdersToCsv(options).then((request) => request(axios, basePath));
        },
        /**
         * Export retailer orders to csv file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportRetailerOrdersToCsv(options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportRetailerOrdersToCsv(options).then((request) => request(axios, basePath));
        },
        /**
         * find all the duplicate order between provided date with delta if provided.
         * @param {string} start Start Date
         * @param {string} end End Date
         * @param {number} delta Maximum Delta between order in second
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDuplicateOrder(start: string, end: string, delta: number, options?: RawAxiosRequestConfig): AxiosPromise<DuplicateOrderResponse> {
            return localVarFp.findDuplicateOrder(start, end, delta, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate order return slip
         * @param {string} id Order return Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOrderReturnSlip(id: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.generateOrderReturnSlip(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate packing slip
         * @param {string} id Packing Slip Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePackingSlip(id: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.generatePackingSlip(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all decline order reasons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeclineReason(options?: RawAxiosRequestConfig): AxiosPromise<Array<DropdownItem>> {
            return localVarFp.getDeclineReason(options).then((request) => request(axios, basePath));
        },
        /**
         * Cart validation, receives array of ProductVariant UUIDs. Returns deleted variants with details.
         * @param {GetDeletedVariantsRequest} getDeletedVariantsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeletedVariants(getDeletedVariantsRequest: GetDeletedVariantsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetDeletedVariantsResponse> {
            return localVarFp.getDeletedVariants(getDeletedVariantsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Invoice by Suborder Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceBySuborderId(id: string, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceResponse> {
            return localVarFp.getInvoiceBySuborderId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all minimum order values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMinimumOrderValues(options?: RawAxiosRequestConfig): AxiosPromise<MinimumOrderValuesResponse> {
            return localVarFp.getMinimumOrderValues(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns number of orders created by retailer for given brand
         * @param {string} brandId Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyOrderCountByBrand(brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<OrderCountByBrandResponse> {
            return localVarFp.getMyOrderCountByBrand(brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get order details by Id
         * @param {string} id Order Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderDetails(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetOrderResponse> {
            return localVarFp.getOrderDetails(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get order preview
         * @param {string} id Order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderDetailsForSuborder(id: string, options?: RawAxiosRequestConfig): AxiosPromise<OrderPreviewResponse> {
            return localVarFp.getOrderDetailsForSuborder(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get order return by Id
         * @param {string} id Order Return Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderReturn(id: string, options?: RawAxiosRequestConfig): AxiosPromise<OrderReturnResponse> {
            return localVarFp.getOrderReturn(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all order return reasons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderReturnReasons(options?: RawAxiosRequestConfig): AxiosPromise<Array<OrderReturnReasonResponse>> {
            return localVarFp.getOrderReturnReasons(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all order returns
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderReturns(options?: RawAxiosRequestConfig): AxiosPromise<Array<OrderReturnResponse>> {
            return localVarFp.getOrderReturns(options).then((request) => request(axios, basePath));
        },
        /**
         * Get order statuses for dropdown
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderStatusesDropdown(options?: RawAxiosRequestConfig): AxiosPromise<GetEnumOptionsResponseOrderStatus> {
            return localVarFp.getOrderStatusesDropdown(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all orders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrders(options?: RawAxiosRequestConfig): AxiosPromise<Array<OrderResponse>> {
            return localVarFp.getOrders(options).then((request) => request(axios, basePath));
        },
        /**
         * Find all orders for provided brand
         * @param {string} brandId Brand Id
         * @param {string} [retailerId] Retailer Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {string} [status] Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrdersByBrand(brandId: string, retailerId?: string, page?: number, size?: number, searchBy?: string, status?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedOrdersForSubordersResponse> {
            return localVarFp.getOrdersByBrand(brandId, retailerId, page, size, searchBy, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Find all orders for provided retailer
         * @param {string} retailerId Retailer Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {string} [status] Status
         * @param {string} [sortName] Sort name
         * @param {string} [sortValue] Sort value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrdersByRetailer(retailerId: string, page?: number, size?: number, searchBy?: string, status?: string, sortName?: string, sortValue?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedOrdersForSubordersResponse> {
            return localVarFp.getOrdersByRetailer(retailerId, page, size, searchBy, status, sortName, sortValue, options).then((request) => request(axios, basePath));
        },
        /**
         * Find all orders per multiple/custom criteria
         * @param {string} [retailerId] Retailer Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {string} [status] Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrdersFiltered(retailerId?: string, page?: number, size?: number, searchBy?: string, status?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedOrdersResponse> {
            return localVarFp.getOrdersFiltered(retailerId, page, size, searchBy, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Get packing slip by Id
         * @param {string} suborderId Suborder Id
         * @param {string} id PackingSlip Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackingSlip(suborderId: string, id: string, options?: RawAxiosRequestConfig): AxiosPromise<PackingSlipResponse> {
            return localVarFp.getPackingSlip(suborderId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get packing slips by suborder Id
         * @param {string} suborderId Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackingSlips(suborderId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PackingSlipResponse>> {
            return localVarFp.getPackingSlips(suborderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get packing slip by order Id
         * @param {string} id Order Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackingSlipsByOrder(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PackingSlipResponse>> {
            return localVarFp.getPackingSlipsByOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get information for billing address and card
         * @param {string} id ID of suborder with invoice needed for payment information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayInvoiceInfo(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetPayInvoiceInformationResponse> {
            return localVarFp.getPayInvoiceInfo(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Payment by Suborder Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentBySuborderId(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetPaymentResponse> {
            return localVarFp.getPaymentBySuborderId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all retailer reorders
         * @param {number} page Page
         * @param {number} size Size
         * @param {string} [query] Search Term
         * @param {string} [sort] Sort Order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReorders(page: number, size: number, query?: string, sort?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetReorderResponse> {
            return localVarFp.getReorders(page, size, query, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all shipping carriers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShippingCarriers(options?: RawAxiosRequestConfig): AxiosPromise<Array<ShippingCarrierResponse>> {
            return localVarFp.getShippingCarriers(options).then((request) => request(axios, basePath));
        },
        /**
         * Get suborder by Id
         * @param {string} id Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuborder(id: string, options?: RawAxiosRequestConfig): AxiosPromise<SuborderResponse> {
            return localVarFp.getSuborder(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Pay on invoice
         * @param {string} suborderId Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payInvoice(suborderId: string, options?: RawAxiosRequestConfig): AxiosPromise<PayInvoiceResponse> {
            return localVarFp.payInvoice(suborderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Pay suborder
         * @param {string} id Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paySuborder(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.paySuborder(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get order confirmation data by Id
         * @param {string} id Order Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retailerGetOrder(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetOrderResponse> {
            return localVarFp.retailerGetOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Set suborder status as partially shipped
         * @param {string} id Suborder Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSuborderAsPartiallyShipped(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setSuborderAsPartiallyShipped(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Create multiple packing slips using split shipment
         * @param {string} suborderId Suborder Id
         * @param {SplitShipRequest} splitShipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        splitShip(suborderId: string, splitShipRequest: SplitShipRequest, options?: RawAxiosRequestConfig): AxiosPromise<SplitShipResponse> {
            return localVarFp.splitShip(suborderId, splitShipRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update and accept suborder
         * @param {string} id Suborder Id
         * @param {UpdateSuborderRequest} updateSuborderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAndAcceptSuborder(id: string, updateSuborderRequest: UpdateSuborderRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateSuborderResponse> {
            return localVarFp.updateAndAcceptSuborder(id, updateSuborderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update algolia and salesforce by suborder number
         * @param {UpdateExternalServiceRequest} updateExternalServiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExternalService(updateExternalServiceRequest: UpdateExternalServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateExternalService(updateExternalServiceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update order return
         * @param {string} id Order return Id
         * @param {UpdateOrderReturnRequest} updateOrderReturnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderReturn(id: string, updateOrderReturnRequest: UpdateOrderReturnRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateOrderReturn(id, updateOrderReturnRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update order return items
         * @param {string} id Order return Id
         * @param {UpdateOrderReturnItemsRequest} updateOrderReturnItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderReturnItems(id: string, updateOrderReturnItemsRequest: UpdateOrderReturnItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateOrderReturnItems(id, updateOrderReturnItemsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update packing slip
         * @param {string} id Packing Slip Id
         * @param {UpdatePackingSlipRequest} updatePackingSlipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePackingSlip(id: string, updatePackingSlipRequest: UpdatePackingSlipRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePackingSlip(id, updatePackingSlipRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update suborder
         * @param {string} id Suborder Id
         * @param {UpdateSuborderRequest} updateSuborderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuborder(id: string, updateSuborderRequest: UpdateSuborderRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateSuborderResponse> {
            return localVarFp.updateSuborder(id, updateSuborderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Attach card to suborder from invoice
         * @param {string} suborderId Suborder Id
         * @param {UpdateSuborderCreditCardRequest} updateSuborderCreditCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuborderCard(suborderId: string, updateSuborderCreditCardRequest: UpdateSuborderCreditCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSuborderCard(suborderId, updateSuborderCreditCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate minimum order value. Checks if total order value is higher or lower than minimum order value.
         * @param {MinimumOrderValueValidationRequest} minimumOrderValueValidationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateMinimumOrderValue(minimumOrderValueValidationRequest: MinimumOrderValueValidationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.validateMinimumOrderValue(minimumOrderValueValidationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderControllerApi - interface
 * @export
 * @interface OrderControllerApi
 */
export interface OrderControllerApiInterface {
    /**
     * Accept suborder
     * @param {string} id Suborder Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    acceptSuborder(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Add suborder shipping info
     * @param {string} id Suborder Id
     * @param {AddSuborderShippingInfoRequest} addSuborderShippingInfoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    addSuborderShippingInfo(id: string, addSuborderShippingInfoRequest: AddSuborderShippingInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Hook for charging an suborder. After suborder is shipped, payment is scheduled for specific date on Posthook. Once it is time for payment, this endpoint is hit by the Posthook.
     * @param {string} id Suborder Id
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    balanceFailedPaymentCapture(id: string, body: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Split packing slip in batch
     * @param {string} suborderId Suborder Id
     * @param {BatchSplitShipmentRequest} batchSplitShipmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    batchSplitShip(suborderId: string, batchSplitShipmentRequest: BatchSplitShipmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Send brand order reminder emails
     * @param {string} id Suborder Id
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    brandOrderReminder(id: string, body: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Hook for charging an suborder. After suborder is shipped, payment is scheduled for specific date on Posthook. Once it is time for payment, this endpoint is hit by the Posthook.
     * @param {string} id Suborder Id
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    captureFailPayment(id: string, body: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Change billing address of suborder
     * @param {string} suborderId Suborder Id
     * @param {string} addressId Address Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    changeSuborderBillingAddress(suborderId: string, addressId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Change suborder\'s credit card
     * @param {string} id Suborder Id
     * @param {ChangeSuborderCreditCardRequest} changeSuborderCreditCardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    changeSuborderCard(id: string, changeSuborderCreditCardRequest: ChangeSuborderCreditCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Hook for charging an suborder. After suborder is shipped, payment is scheduled for specific date on Posthook. Once it is time for payment, this endpoint is hit by the Posthook.
     * @param {string} id Suborder Id
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    chargeSuborder(id: string, body: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Confirm packing slip
     * @param {string} id Packing Slip Id
     * @param {ConfirmPackingSlipRequest} confirmPackingSlipRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    confirmPackingSlip(id: string, confirmPackingSlipRequest: ConfirmPackingSlipRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Create balance order
     * @param {CreateBalanceOrderRequest} createBalanceOrderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    createBalanceOrder(createBalanceOrderRequest: CreateBalanceOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateOrderResponse>;

    /**
     * Create order
     * @param {CreateOrderRequest} createOrderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    createOrder(createOrderRequest: CreateOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateOrderResponse>;

    /**
     * Create order return
     * @param {string} id Order Id
     * @param {CreateOrderReturnRequest} createOrderReturnRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    createOrderReturn(id: string, createOrderReturnRequest: CreateOrderReturnRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper>;

    /**
     * Create packing slip
     * @param {string} suborderId Suborder Id
     * @param {CreatePackingSlipRequest} createPackingSlipRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    createPackingSlip(suborderId: string, createPackingSlipRequest: CreatePackingSlipRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper>;

    /**
     * Decline suborder
     * @param {string} id Suborder Id
     * @param {DeclineSuborderRequest} declineSuborderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    declineSuborder(id: string, declineSuborderRequest: DeclineSuborderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Decline packing slip
     * @param {string} id Packing Slip Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    delcinePackingSlip(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Delete order
     * @param {string} id Order Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    deleteOrder(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Delete packing slips
     * @param {DeletePackingSlipsRequest} deletePackingSlipsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    deletePackingSlips(deletePackingSlipsRequest: DeletePackingSlipsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Draft packing slip
     * @param {string} id Packing Slip Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    draftPackingSlip(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Estimate shipping cost using ShipEngine API
     * @param {EstimateShippingRequest} estimateShippingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    estimateShipping(estimateShippingRequest: EstimateShippingRequest, options?: RawAxiosRequestConfig): AxiosPromise<EstimateShippingResponse>;

    /**
     * Changes suborder status on expired
     * @param {string} id Suborder id
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    expireSuborder(id: string, body: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Export brand orders to csv file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    exportBrandOrdersToCsv(options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * Export orders to csv file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    exportOrdersToCsv(options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * Export retailer orders to csv file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    exportRetailerOrdersToCsv(options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * find all the duplicate order between provided date with delta if provided.
     * @param {string} start Start Date
     * @param {string} end End Date
     * @param {number} delta Maximum Delta between order in second
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    findDuplicateOrder(start: string, end: string, delta: number, options?: RawAxiosRequestConfig): AxiosPromise<DuplicateOrderResponse>;

    /**
     * Generate order return slip
     * @param {string} id Order return Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    generateOrderReturnSlip(id: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * Generate packing slip
     * @param {string} id Packing Slip Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    generatePackingSlip(id: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * Returns all decline order reasons
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    getDeclineReason(options?: RawAxiosRequestConfig): AxiosPromise<Array<DropdownItem>>;

    /**
     * Cart validation, receives array of ProductVariant UUIDs. Returns deleted variants with details.
     * @param {GetDeletedVariantsRequest} getDeletedVariantsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    getDeletedVariants(getDeletedVariantsRequest: GetDeletedVariantsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetDeletedVariantsResponse>;

    /**
     * Get Invoice by Suborder Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    getInvoiceBySuborderId(id: string, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceResponse>;

    /**
     * Returns all minimum order values
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    getMinimumOrderValues(options?: RawAxiosRequestConfig): AxiosPromise<MinimumOrderValuesResponse>;

    /**
     * Returns number of orders created by retailer for given brand
     * @param {string} brandId Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    getMyOrderCountByBrand(brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<OrderCountByBrandResponse>;

    /**
     * Get order details by Id
     * @param {string} id Order Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    getOrderDetails(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetOrderResponse>;

    /**
     * Get order preview
     * @param {string} id Order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    getOrderDetailsForSuborder(id: string, options?: RawAxiosRequestConfig): AxiosPromise<OrderPreviewResponse>;

    /**
     * Get order return by Id
     * @param {string} id Order Return Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    getOrderReturn(id: string, options?: RawAxiosRequestConfig): AxiosPromise<OrderReturnResponse>;

    /**
     * Get all order return reasons
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    getOrderReturnReasons(options?: RawAxiosRequestConfig): AxiosPromise<Array<OrderReturnReasonResponse>>;

    /**
     * Get all order returns
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    getOrderReturns(options?: RawAxiosRequestConfig): AxiosPromise<Array<OrderReturnResponse>>;

    /**
     * Get order statuses for dropdown
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    getOrderStatusesDropdown(options?: RawAxiosRequestConfig): AxiosPromise<GetEnumOptionsResponseOrderStatus>;

    /**
     * Get all orders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    getOrders(options?: RawAxiosRequestConfig): AxiosPromise<Array<OrderResponse>>;

    /**
     * Find all orders for provided brand
     * @param {string} brandId Brand Id
     * @param {string} [retailerId] Retailer Id
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {string} [searchBy] Search by
     * @param {string} [status] Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    getOrdersByBrand(brandId: string, retailerId?: string, page?: number, size?: number, searchBy?: string, status?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedOrdersForSubordersResponse>;

    /**
     * Find all orders for provided retailer
     * @param {string} retailerId Retailer Id
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {string} [searchBy] Search by
     * @param {string} [status] Status
     * @param {string} [sortName] Sort name
     * @param {string} [sortValue] Sort value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    getOrdersByRetailer(retailerId: string, page?: number, size?: number, searchBy?: string, status?: string, sortName?: string, sortValue?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedOrdersForSubordersResponse>;

    /**
     * Find all orders per multiple/custom criteria
     * @param {string} [retailerId] Retailer Id
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {string} [searchBy] Search by
     * @param {string} [status] Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    getOrdersFiltered(retailerId?: string, page?: number, size?: number, searchBy?: string, status?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedOrdersResponse>;

    /**
     * Get packing slip by Id
     * @param {string} suborderId Suborder Id
     * @param {string} id PackingSlip Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    getPackingSlip(suborderId: string, id: string, options?: RawAxiosRequestConfig): AxiosPromise<PackingSlipResponse>;

    /**
     * Get packing slips by suborder Id
     * @param {string} suborderId Suborder Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    getPackingSlips(suborderId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PackingSlipResponse>>;

    /**
     * Get packing slip by order Id
     * @param {string} id Order Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    getPackingSlipsByOrder(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PackingSlipResponse>>;

    /**
     * Get information for billing address and card
     * @param {string} id ID of suborder with invoice needed for payment information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    getPayInvoiceInfo(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetPayInvoiceInformationResponse>;

    /**
     * Get Payment by Suborder Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    getPaymentBySuborderId(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetPaymentResponse>;

    /**
     * Returns all retailer reorders
     * @param {number} page Page
     * @param {number} size Size
     * @param {string} [query] Search Term
     * @param {string} [sort] Sort Order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    getReorders(page: number, size: number, query?: string, sort?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetReorderResponse>;

    /**
     * Get all shipping carriers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    getShippingCarriers(options?: RawAxiosRequestConfig): AxiosPromise<Array<ShippingCarrierResponse>>;

    /**
     * Get suborder by Id
     * @param {string} id Suborder Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    getSuborder(id: string, options?: RawAxiosRequestConfig): AxiosPromise<SuborderResponse>;

    /**
     * Pay on invoice
     * @param {string} suborderId Suborder Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    payInvoice(suborderId: string, options?: RawAxiosRequestConfig): AxiosPromise<PayInvoiceResponse>;

    /**
     * Pay suborder
     * @param {string} id Suborder Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    paySuborder(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Get order confirmation data by Id
     * @param {string} id Order Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    retailerGetOrder(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetOrderResponse>;

    /**
     * Set suborder status as partially shipped
     * @param {string} id Suborder Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    setSuborderAsPartiallyShipped(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Create multiple packing slips using split shipment
     * @param {string} suborderId Suborder Id
     * @param {SplitShipRequest} splitShipRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    splitShip(suborderId: string, splitShipRequest: SplitShipRequest, options?: RawAxiosRequestConfig): AxiosPromise<SplitShipResponse>;

    /**
     * Update and accept suborder
     * @param {string} id Suborder Id
     * @param {UpdateSuborderRequest} updateSuborderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    updateAndAcceptSuborder(id: string, updateSuborderRequest: UpdateSuborderRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateSuborderResponse>;

    /**
     * Update algolia and salesforce by suborder number
     * @param {UpdateExternalServiceRequest} updateExternalServiceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    updateExternalService(updateExternalServiceRequest: UpdateExternalServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update order return
     * @param {string} id Order return Id
     * @param {UpdateOrderReturnRequest} updateOrderReturnRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    updateOrderReturn(id: string, updateOrderReturnRequest: UpdateOrderReturnRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update order return items
     * @param {string} id Order return Id
     * @param {UpdateOrderReturnItemsRequest} updateOrderReturnItemsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    updateOrderReturnItems(id: string, updateOrderReturnItemsRequest: UpdateOrderReturnItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update packing slip
     * @param {string} id Packing Slip Id
     * @param {UpdatePackingSlipRequest} updatePackingSlipRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    updatePackingSlip(id: string, updatePackingSlipRequest: UpdatePackingSlipRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update suborder
     * @param {string} id Suborder Id
     * @param {UpdateSuborderRequest} updateSuborderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    updateSuborder(id: string, updateSuborderRequest: UpdateSuborderRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateSuborderResponse>;

    /**
     * Attach card to suborder from invoice
     * @param {string} suborderId Suborder Id
     * @param {UpdateSuborderCreditCardRequest} updateSuborderCreditCardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    updateSuborderCard(suborderId: string, updateSuborderCreditCardRequest: UpdateSuborderCreditCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Validate minimum order value. Checks if total order value is higher or lower than minimum order value.
     * @param {MinimumOrderValueValidationRequest} minimumOrderValueValidationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApiInterface
     */
    validateMinimumOrderValue(minimumOrderValueValidationRequest: MinimumOrderValueValidationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * OrderControllerApi - object-oriented interface
 * @export
 * @class OrderControllerApi
 * @extends {BaseAPI}
 */
export class OrderControllerApi extends BaseAPI implements OrderControllerApiInterface {
    /**
     * Accept suborder
     * @param {string} id Suborder Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public acceptSuborder(id: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).acceptSuborder(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add suborder shipping info
     * @param {string} id Suborder Id
     * @param {AddSuborderShippingInfoRequest} addSuborderShippingInfoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public addSuborderShippingInfo(id: string, addSuborderShippingInfoRequest: AddSuborderShippingInfoRequest, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).addSuborderShippingInfo(id, addSuborderShippingInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Hook for charging an suborder. After suborder is shipped, payment is scheduled for specific date on Posthook. Once it is time for payment, this endpoint is hit by the Posthook.
     * @param {string} id Suborder Id
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public balanceFailedPaymentCapture(id: string, body: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).balanceFailedPaymentCapture(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Split packing slip in batch
     * @param {string} suborderId Suborder Id
     * @param {BatchSplitShipmentRequest} batchSplitShipmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public batchSplitShip(suborderId: string, batchSplitShipmentRequest: BatchSplitShipmentRequest, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).batchSplitShip(suborderId, batchSplitShipmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send brand order reminder emails
     * @param {string} id Suborder Id
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public brandOrderReminder(id: string, body: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).brandOrderReminder(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Hook for charging an suborder. After suborder is shipped, payment is scheduled for specific date on Posthook. Once it is time for payment, this endpoint is hit by the Posthook.
     * @param {string} id Suborder Id
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public captureFailPayment(id: string, body: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).captureFailPayment(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change billing address of suborder
     * @param {string} suborderId Suborder Id
     * @param {string} addressId Address Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public changeSuborderBillingAddress(suborderId: string, addressId: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).changeSuborderBillingAddress(suborderId, addressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change suborder\'s credit card
     * @param {string} id Suborder Id
     * @param {ChangeSuborderCreditCardRequest} changeSuborderCreditCardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public changeSuborderCard(id: string, changeSuborderCreditCardRequest: ChangeSuborderCreditCardRequest, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).changeSuborderCard(id, changeSuborderCreditCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Hook for charging an suborder. After suborder is shipped, payment is scheduled for specific date on Posthook. Once it is time for payment, this endpoint is hit by the Posthook.
     * @param {string} id Suborder Id
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public chargeSuborder(id: string, body: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).chargeSuborder(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm packing slip
     * @param {string} id Packing Slip Id
     * @param {ConfirmPackingSlipRequest} confirmPackingSlipRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public confirmPackingSlip(id: string, confirmPackingSlipRequest: ConfirmPackingSlipRequest, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).confirmPackingSlip(id, confirmPackingSlipRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create balance order
     * @param {CreateBalanceOrderRequest} createBalanceOrderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public createBalanceOrder(createBalanceOrderRequest: CreateBalanceOrderRequest, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).createBalanceOrder(createBalanceOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create order
     * @param {CreateOrderRequest} createOrderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public createOrder(createOrderRequest: CreateOrderRequest, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).createOrder(createOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create order return
     * @param {string} id Order Id
     * @param {CreateOrderReturnRequest} createOrderReturnRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public createOrderReturn(id: string, createOrderReturnRequest: CreateOrderReturnRequest, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).createOrderReturn(id, createOrderReturnRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create packing slip
     * @param {string} suborderId Suborder Id
     * @param {CreatePackingSlipRequest} createPackingSlipRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public createPackingSlip(suborderId: string, createPackingSlipRequest: CreatePackingSlipRequest, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).createPackingSlip(suborderId, createPackingSlipRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Decline suborder
     * @param {string} id Suborder Id
     * @param {DeclineSuborderRequest} declineSuborderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public declineSuborder(id: string, declineSuborderRequest: DeclineSuborderRequest, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).declineSuborder(id, declineSuborderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Decline packing slip
     * @param {string} id Packing Slip Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public delcinePackingSlip(id: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).delcinePackingSlip(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete order
     * @param {string} id Order Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public deleteOrder(id: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).deleteOrder(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete packing slips
     * @param {DeletePackingSlipsRequest} deletePackingSlipsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public deletePackingSlips(deletePackingSlipsRequest: DeletePackingSlipsRequest, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).deletePackingSlips(deletePackingSlipsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Draft packing slip
     * @param {string} id Packing Slip Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public draftPackingSlip(id: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).draftPackingSlip(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Estimate shipping cost using ShipEngine API
     * @param {EstimateShippingRequest} estimateShippingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public estimateShipping(estimateShippingRequest: EstimateShippingRequest, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).estimateShipping(estimateShippingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Changes suborder status on expired
     * @param {string} id Suborder id
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public expireSuborder(id: string, body: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).expireSuborder(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export brand orders to csv file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public exportBrandOrdersToCsv(options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).exportBrandOrdersToCsv(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export orders to csv file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public exportOrdersToCsv(options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).exportOrdersToCsv(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export retailer orders to csv file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public exportRetailerOrdersToCsv(options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).exportRetailerOrdersToCsv(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * find all the duplicate order between provided date with delta if provided.
     * @param {string} start Start Date
     * @param {string} end End Date
     * @param {number} delta Maximum Delta between order in second
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public findDuplicateOrder(start: string, end: string, delta: number, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).findDuplicateOrder(start, end, delta, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate order return slip
     * @param {string} id Order return Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public generateOrderReturnSlip(id: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).generateOrderReturnSlip(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate packing slip
     * @param {string} id Packing Slip Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public generatePackingSlip(id: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).generatePackingSlip(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all decline order reasons
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public getDeclineReason(options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).getDeclineReason(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cart validation, receives array of ProductVariant UUIDs. Returns deleted variants with details.
     * @param {GetDeletedVariantsRequest} getDeletedVariantsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public getDeletedVariants(getDeletedVariantsRequest: GetDeletedVariantsRequest, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).getDeletedVariants(getDeletedVariantsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Invoice by Suborder Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public getInvoiceBySuborderId(id: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).getInvoiceBySuborderId(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all minimum order values
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public getMinimumOrderValues(options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).getMinimumOrderValues(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns number of orders created by retailer for given brand
     * @param {string} brandId Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public getMyOrderCountByBrand(brandId: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).getMyOrderCountByBrand(brandId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get order details by Id
     * @param {string} id Order Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public getOrderDetails(id: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).getOrderDetails(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get order preview
     * @param {string} id Order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public getOrderDetailsForSuborder(id: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).getOrderDetailsForSuborder(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get order return by Id
     * @param {string} id Order Return Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public getOrderReturn(id: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).getOrderReturn(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all order return reasons
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public getOrderReturnReasons(options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).getOrderReturnReasons(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all order returns
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public getOrderReturns(options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).getOrderReturns(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get order statuses for dropdown
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public getOrderStatusesDropdown(options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).getOrderStatusesDropdown(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all orders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public getOrders(options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).getOrders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find all orders for provided brand
     * @param {string} brandId Brand Id
     * @param {string} [retailerId] Retailer Id
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {string} [searchBy] Search by
     * @param {string} [status] Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public getOrdersByBrand(brandId: string, retailerId?: string, page?: number, size?: number, searchBy?: string, status?: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).getOrdersByBrand(brandId, retailerId, page, size, searchBy, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find all orders for provided retailer
     * @param {string} retailerId Retailer Id
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {string} [searchBy] Search by
     * @param {string} [status] Status
     * @param {string} [sortName] Sort name
     * @param {string} [sortValue] Sort value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public getOrdersByRetailer(retailerId: string, page?: number, size?: number, searchBy?: string, status?: string, sortName?: string, sortValue?: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).getOrdersByRetailer(retailerId, page, size, searchBy, status, sortName, sortValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find all orders per multiple/custom criteria
     * @param {string} [retailerId] Retailer Id
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {string} [searchBy] Search by
     * @param {string} [status] Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public getOrdersFiltered(retailerId?: string, page?: number, size?: number, searchBy?: string, status?: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).getOrdersFiltered(retailerId, page, size, searchBy, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get packing slip by Id
     * @param {string} suborderId Suborder Id
     * @param {string} id PackingSlip Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public getPackingSlip(suborderId: string, id: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).getPackingSlip(suborderId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get packing slips by suborder Id
     * @param {string} suborderId Suborder Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public getPackingSlips(suborderId: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).getPackingSlips(suborderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get packing slip by order Id
     * @param {string} id Order Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public getPackingSlipsByOrder(id: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).getPackingSlipsByOrder(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get information for billing address and card
     * @param {string} id ID of suborder with invoice needed for payment information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public getPayInvoiceInfo(id: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).getPayInvoiceInfo(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Payment by Suborder Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public getPaymentBySuborderId(id: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).getPaymentBySuborderId(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all retailer reorders
     * @param {number} page Page
     * @param {number} size Size
     * @param {string} [query] Search Term
     * @param {string} [sort] Sort Order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public getReorders(page: number, size: number, query?: string, sort?: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).getReorders(page, size, query, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all shipping carriers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public getShippingCarriers(options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).getShippingCarriers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get suborder by Id
     * @param {string} id Suborder Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public getSuborder(id: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).getSuborder(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pay on invoice
     * @param {string} suborderId Suborder Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public payInvoice(suborderId: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).payInvoice(suborderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pay suborder
     * @param {string} id Suborder Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public paySuborder(id: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).paySuborder(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get order confirmation data by Id
     * @param {string} id Order Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public retailerGetOrder(id: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).retailerGetOrder(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set suborder status as partially shipped
     * @param {string} id Suborder Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public setSuborderAsPartiallyShipped(id: string, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).setSuborderAsPartiallyShipped(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create multiple packing slips using split shipment
     * @param {string} suborderId Suborder Id
     * @param {SplitShipRequest} splitShipRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public splitShip(suborderId: string, splitShipRequest: SplitShipRequest, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).splitShip(suborderId, splitShipRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update and accept suborder
     * @param {string} id Suborder Id
     * @param {UpdateSuborderRequest} updateSuborderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public updateAndAcceptSuborder(id: string, updateSuborderRequest: UpdateSuborderRequest, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).updateAndAcceptSuborder(id, updateSuborderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update algolia and salesforce by suborder number
     * @param {UpdateExternalServiceRequest} updateExternalServiceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public updateExternalService(updateExternalServiceRequest: UpdateExternalServiceRequest, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).updateExternalService(updateExternalServiceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update order return
     * @param {string} id Order return Id
     * @param {UpdateOrderReturnRequest} updateOrderReturnRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public updateOrderReturn(id: string, updateOrderReturnRequest: UpdateOrderReturnRequest, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).updateOrderReturn(id, updateOrderReturnRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update order return items
     * @param {string} id Order return Id
     * @param {UpdateOrderReturnItemsRequest} updateOrderReturnItemsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public updateOrderReturnItems(id: string, updateOrderReturnItemsRequest: UpdateOrderReturnItemsRequest, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).updateOrderReturnItems(id, updateOrderReturnItemsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update packing slip
     * @param {string} id Packing Slip Id
     * @param {UpdatePackingSlipRequest} updatePackingSlipRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public updatePackingSlip(id: string, updatePackingSlipRequest: UpdatePackingSlipRequest, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).updatePackingSlip(id, updatePackingSlipRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update suborder
     * @param {string} id Suborder Id
     * @param {UpdateSuborderRequest} updateSuborderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public updateSuborder(id: string, updateSuborderRequest: UpdateSuborderRequest, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).updateSuborder(id, updateSuborderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Attach card to suborder from invoice
     * @param {string} suborderId Suborder Id
     * @param {UpdateSuborderCreditCardRequest} updateSuborderCreditCardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public updateSuborderCard(suborderId: string, updateSuborderCreditCardRequest: UpdateSuborderCreditCardRequest, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).updateSuborderCard(suborderId, updateSuborderCreditCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate minimum order value. Checks if total order value is higher or lower than minimum order value.
     * @param {MinimumOrderValueValidationRequest} minimumOrderValueValidationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControllerApi
     */
    public validateMinimumOrderValue(minimumOrderValueValidationRequest: MinimumOrderValueValidationRequest, options?: RawAxiosRequestConfig) {
        return OrderControllerApiFp(this.configuration).validateMinimumOrderValue(minimumOrderValueValidationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PaymentControllerApi - axios parameter creator
 * @export
 */
export const PaymentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete retailer credit card
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCreditCard: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/payments/credit-card`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete retailer credit card by Id
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCreditCard1: async (cardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('deleteCreditCard1', 'cardId', cardId)
            const localVarPath = `/payments/{cardId}/credit-card`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find all payments per multiple/custom criteria
         * @param {string} [retailerId] Retailer Id
         * @param {string} [brandId] Brand Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {string} [sortName] Sort name
         * @param {string} [sortValue] Sort value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayments: async (retailerId?: string, brandId?: string, page?: number, size?: number, searchBy?: string, sortName?: string, sortValue?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (retailerId !== undefined) {
                localVarQueryParameter['retailerId'] = retailerId;
            }

            if (brandId !== undefined) {
                localVarQueryParameter['brandId'] = brandId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (searchBy !== undefined) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            if (sortName !== undefined) {
                localVarQueryParameter['sortName'] = sortName;
            }

            if (sortValue !== undefined) {
                localVarQueryParameter['sortValue'] = sortValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find all payments for provided brand
         * @param {string} brandId Brand Id
         * @param {string} [retailerId] Retailer Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {string} [sortName] Sort name
         * @param {string} [sortValue] Sort value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentsByBrand: async (brandId: string, retailerId?: string, page?: number, size?: number, searchBy?: string, sortName?: string, sortValue?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getPaymentsByBrand', 'brandId', brandId)
            const localVarPath = `/payments/brand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (retailerId !== undefined) {
                localVarQueryParameter['retailerId'] = retailerId;
            }

            if (brandId !== undefined) {
                localVarQueryParameter['brandId'] = brandId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (searchBy !== undefined) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            if (sortName !== undefined) {
                localVarQueryParameter['sortName'] = sortName;
            }

            if (sortValue !== undefined) {
                localVarQueryParameter['sortValue'] = sortValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replace retailer credit card
         * @param {ReplaceCreditCardRequest} replaceCreditCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCreditCard: async (replaceCreditCardRequest: ReplaceCreditCardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'replaceCreditCardRequest' is not null or undefined
            assertParamExists('replaceCreditCard', 'replaceCreditCardRequest', replaceCreditCardRequest)
            const localVarPath = `/payments/credit-card-replace`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replaceCreditCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update retailer credit card
         * @param {UpdateCreditCardRequest} updateCreditCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCreditCard: async (updateCreditCardRequest: UpdateCreditCardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateCreditCardRequest' is not null or undefined
            assertParamExists('updateCreditCard', 'updateCreditCardRequest', updateCreditCardRequest)
            const localVarPath = `/payments/credit-card`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCreditCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentControllerApi - functional programming interface
 * @export
 */
export const PaymentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete retailer credit card
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCreditCard(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCreditCard(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentControllerApi.deleteCreditCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete retailer credit card by Id
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCreditCard1(cardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCreditCard1(cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentControllerApi.deleteCreditCard1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find all payments per multiple/custom criteria
         * @param {string} [retailerId] Retailer Id
         * @param {string} [brandId] Brand Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {string} [sortName] Sort name
         * @param {string} [sortValue] Sort value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayments(retailerId?: string, brandId?: string, page?: number, size?: number, searchBy?: string, sortName?: string, sortValue?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedPaymentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayments(retailerId, brandId, page, size, searchBy, sortName, sortValue, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentControllerApi.getPayments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find all payments for provided brand
         * @param {string} brandId Brand Id
         * @param {string} [retailerId] Retailer Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {string} [sortName] Sort name
         * @param {string} [sortValue] Sort value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentsByBrand(brandId: string, retailerId?: string, page?: number, size?: number, searchBy?: string, sortName?: string, sortValue?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedPaymentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentsByBrand(brandId, retailerId, page, size, searchBy, sortName, sortValue, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentControllerApi.getPaymentsByBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replace retailer credit card
         * @param {ReplaceCreditCardRequest} replaceCreditCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceCreditCard(replaceCreditCardRequest: ReplaceCreditCardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceCreditCard(replaceCreditCardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentControllerApi.replaceCreditCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update retailer credit card
         * @param {UpdateCreditCardRequest} updateCreditCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCreditCard(updateCreditCardRequest: UpdateCreditCardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCreditCard(updateCreditCardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentControllerApi.updateCreditCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentControllerApi - factory interface
 * @export
 */
export const PaymentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentControllerApiFp(configuration)
    return {
        /**
         * Delete retailer credit card
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCreditCard(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCreditCard(options).then((request) => request(axios, basePath));
        },
        /**
         * Delete retailer credit card by Id
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCreditCard1(cardId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCreditCard1(cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Find all payments per multiple/custom criteria
         * @param {string} [retailerId] Retailer Id
         * @param {string} [brandId] Brand Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {string} [sortName] Sort name
         * @param {string} [sortValue] Sort value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayments(retailerId?: string, brandId?: string, page?: number, size?: number, searchBy?: string, sortName?: string, sortValue?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedPaymentsResponse> {
            return localVarFp.getPayments(retailerId, brandId, page, size, searchBy, sortName, sortValue, options).then((request) => request(axios, basePath));
        },
        /**
         * Find all payments for provided brand
         * @param {string} brandId Brand Id
         * @param {string} [retailerId] Retailer Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [searchBy] Search by
         * @param {string} [sortName] Sort name
         * @param {string} [sortValue] Sort value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentsByBrand(brandId: string, retailerId?: string, page?: number, size?: number, searchBy?: string, sortName?: string, sortValue?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedPaymentsResponse> {
            return localVarFp.getPaymentsByBrand(brandId, retailerId, page, size, searchBy, sortName, sortValue, options).then((request) => request(axios, basePath));
        },
        /**
         * Replace retailer credit card
         * @param {ReplaceCreditCardRequest} replaceCreditCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceCreditCard(replaceCreditCardRequest: ReplaceCreditCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.replaceCreditCard(replaceCreditCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update retailer credit card
         * @param {UpdateCreditCardRequest} updateCreditCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCreditCard(updateCreditCardRequest: UpdateCreditCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCreditCard(updateCreditCardRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentControllerApi - interface
 * @export
 * @interface PaymentControllerApi
 */
export interface PaymentControllerApiInterface {
    /**
     * Delete retailer credit card
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentControllerApiInterface
     */
    deleteCreditCard(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Delete retailer credit card by Id
     * @param {string} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentControllerApiInterface
     */
    deleteCreditCard1(cardId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Find all payments per multiple/custom criteria
     * @param {string} [retailerId] Retailer Id
     * @param {string} [brandId] Brand Id
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {string} [searchBy] Search by
     * @param {string} [sortName] Sort name
     * @param {string} [sortValue] Sort value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentControllerApiInterface
     */
    getPayments(retailerId?: string, brandId?: string, page?: number, size?: number, searchBy?: string, sortName?: string, sortValue?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedPaymentsResponse>;

    /**
     * Find all payments for provided brand
     * @param {string} brandId Brand Id
     * @param {string} [retailerId] Retailer Id
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {string} [searchBy] Search by
     * @param {string} [sortName] Sort name
     * @param {string} [sortValue] Sort value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentControllerApiInterface
     */
    getPaymentsByBrand(brandId: string, retailerId?: string, page?: number, size?: number, searchBy?: string, sortName?: string, sortValue?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedPaymentsResponse>;

    /**
     * Replace retailer credit card
     * @param {ReplaceCreditCardRequest} replaceCreditCardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentControllerApiInterface
     */
    replaceCreditCard(replaceCreditCardRequest: ReplaceCreditCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update retailer credit card
     * @param {UpdateCreditCardRequest} updateCreditCardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentControllerApiInterface
     */
    updateCreditCard(updateCreditCardRequest: UpdateCreditCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * PaymentControllerApi - object-oriented interface
 * @export
 * @class PaymentControllerApi
 * @extends {BaseAPI}
 */
export class PaymentControllerApi extends BaseAPI implements PaymentControllerApiInterface {
    /**
     * Delete retailer credit card
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentControllerApi
     */
    public deleteCreditCard(options?: RawAxiosRequestConfig) {
        return PaymentControllerApiFp(this.configuration).deleteCreditCard(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete retailer credit card by Id
     * @param {string} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentControllerApi
     */
    public deleteCreditCard1(cardId: string, options?: RawAxiosRequestConfig) {
        return PaymentControllerApiFp(this.configuration).deleteCreditCard1(cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find all payments per multiple/custom criteria
     * @param {string} [retailerId] Retailer Id
     * @param {string} [brandId] Brand Id
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {string} [searchBy] Search by
     * @param {string} [sortName] Sort name
     * @param {string} [sortValue] Sort value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentControllerApi
     */
    public getPayments(retailerId?: string, brandId?: string, page?: number, size?: number, searchBy?: string, sortName?: string, sortValue?: string, options?: RawAxiosRequestConfig) {
        return PaymentControllerApiFp(this.configuration).getPayments(retailerId, brandId, page, size, searchBy, sortName, sortValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find all payments for provided brand
     * @param {string} brandId Brand Id
     * @param {string} [retailerId] Retailer Id
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {string} [searchBy] Search by
     * @param {string} [sortName] Sort name
     * @param {string} [sortValue] Sort value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentControllerApi
     */
    public getPaymentsByBrand(brandId: string, retailerId?: string, page?: number, size?: number, searchBy?: string, sortName?: string, sortValue?: string, options?: RawAxiosRequestConfig) {
        return PaymentControllerApiFp(this.configuration).getPaymentsByBrand(brandId, retailerId, page, size, searchBy, sortName, sortValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replace retailer credit card
     * @param {ReplaceCreditCardRequest} replaceCreditCardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentControllerApi
     */
    public replaceCreditCard(replaceCreditCardRequest: ReplaceCreditCardRequest, options?: RawAxiosRequestConfig) {
        return PaymentControllerApiFp(this.configuration).replaceCreditCard(replaceCreditCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update retailer credit card
     * @param {UpdateCreditCardRequest} updateCreditCardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentControllerApi
     */
    public updateCreditCard(updateCreditCardRequest: UpdateCreditCardRequest, options?: RawAxiosRequestConfig) {
        return PaymentControllerApiFp(this.configuration).updateCreditCard(updateCreditCardRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PingControllerApi - axios parameter creator
 * @export
 */
export const PingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Ping Posthook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingPosthook: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ping/posthook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pong Posthook
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pongPosthook: async (body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('pongPosthook', 'body', body)
            const localVarPath = `/ping/posthook/pong`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send test email
         * @param {string} mail Email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testEmail1: async (mail: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mail' is not null or undefined
            assertParamExists('testEmail1', 'mail', mail)
            const localVarPath = `/ping/mail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (mail !== undefined) {
                localVarQueryParameter['mail'] = mail;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PingControllerApi - functional programming interface
 * @export
 */
export const PingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Ping Posthook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pingPosthook(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pingPosthook(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PingControllerApi.pingPosthook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pong Posthook
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pongPosthook(body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pongPosthook(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PingControllerApi.pongPosthook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send test email
         * @param {string} mail Email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testEmail1(mail: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testEmail1(mail, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PingControllerApi.testEmail1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PingControllerApi - factory interface
 * @export
 */
export const PingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PingControllerApiFp(configuration)
    return {
        /**
         * Ping Posthook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingPosthook(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.pingPosthook(options).then((request) => request(axios, basePath));
        },
        /**
         * Pong Posthook
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pongPosthook(body: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.pongPosthook(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Send test email
         * @param {string} mail Email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testEmail1(mail: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.testEmail1(mail, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PingControllerApi - interface
 * @export
 * @interface PingControllerApi
 */
export interface PingControllerApiInterface {
    /**
     * Ping Posthook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PingControllerApiInterface
     */
    pingPosthook(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Pong Posthook
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PingControllerApiInterface
     */
    pongPosthook(body: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Send test email
     * @param {string} mail Email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PingControllerApiInterface
     */
    testEmail1(mail: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * PingControllerApi - object-oriented interface
 * @export
 * @class PingControllerApi
 * @extends {BaseAPI}
 */
export class PingControllerApi extends BaseAPI implements PingControllerApiInterface {
    /**
     * Ping Posthook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PingControllerApi
     */
    public pingPosthook(options?: RawAxiosRequestConfig) {
        return PingControllerApiFp(this.configuration).pingPosthook(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pong Posthook
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PingControllerApi
     */
    public pongPosthook(body: string, options?: RawAxiosRequestConfig) {
        return PingControllerApiFp(this.configuration).pongPosthook(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send test email
     * @param {string} mail Email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PingControllerApi
     */
    public testEmail1(mail: string, options?: RawAxiosRequestConfig) {
        return PingControllerApiFp(this.configuration).testEmail1(mail, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductControllerApi - axios parameter creator
 * @export
 */
export const ProductControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id Product Id
         * @param {AddDraftProductRequest} addDraftProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateDraftProduct: async (id: string, addDraftProductRequest: AddDraftProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('activateDraftProduct', 'id', id)
            // verify required parameter 'addDraftProductRequest' is not null or undefined
            assertParamExists('activateDraftProduct', 'addDraftProductRequest', addDraftProductRequest)
            const localVarPath = `/products/{id}/activate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addDraftProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add all draft products
         * @param {AddAllDraftProductsRequest} addAllDraftProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAllDraftProducts: async (addAllDraftProductsRequest: AddAllDraftProductsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addAllDraftProductsRequest' is not null or undefined
            assertParamExists('addAllDraftProducts', 'addAllDraftProductsRequest', addAllDraftProductsRequest)
            const localVarPath = `/products/add-all-draft`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addAllDraftProductsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Approve product
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveProduct: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('approveProduct', 'id', id)
            const localVarPath = `/products/{id}/approve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Assign product image to variant
         * @param {string} variantId Product Variant Id
         * @param {string} imageId Image Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignImageToVariant: async (variantId: string, imageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'variantId' is not null or undefined
            assertParamExists('assignImageToVariant', 'variantId', variantId)
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('assignImageToVariant', 'imageId', imageId)
            const localVarPath = `/products/variants/{variantId}/image/{imageId}`
                .replace(`{${"variantId"}}`, encodeURIComponent(String(variantId)))
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import products from CSV file as Brand
         * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brandImportProductsFromCsv: async (linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/brand-csv-import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(linkRetailersWithTradeShowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk delete product
         * @param {BulkDeleteProductsRequest} bulkDeleteProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteProduct: async (bulkDeleteProductsRequest: BulkDeleteProductsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkDeleteProductsRequest' is not null or undefined
            assertParamExists('bulkDeleteProduct', 'bulkDeleteProductsRequest', bulkDeleteProductsRequest)
            const localVarPath = `/products/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkDeleteProductsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk save draft product.
         * @param {BulkSaveDraftProductRequest} bulkSaveDraftProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkSaveDraftProduct: async (bulkSaveDraftProductRequest: BulkSaveDraftProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkSaveDraftProductRequest' is not null or undefined
            assertParamExists('bulkSaveDraftProduct', 'bulkSaveDraftProductRequest', bulkSaveDraftProductRequest)
            const localVarPath = `/products/bulk-save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkSaveDraftProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk update draft products
         * @param {BulkUpdateDraftProductsRequest} bulkUpdateDraftProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateDraftProducts: async (bulkUpdateDraftProductsRequest: BulkUpdateDraftProductsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkUpdateDraftProductsRequest' is not null or undefined
            assertParamExists('bulkUpdateDraftProducts', 'bulkUpdateDraftProductsRequest', bulkUpdateDraftProductsRequest)
            const localVarPath = `/products/bulk-update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateDraftProductsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admin API to update products in bulk
         * @param {BulkUpdateProductsRequest} bulkUpdateProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateProducts: async (bulkUpdateProductsRequest: BulkUpdateProductsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkUpdateProductsRequest' is not null or undefined
            assertParamExists('bulkUpdateProducts', 'bulkUpdateProductsRequest', bulkUpdateProductsRequest)
            const localVarPath = `/products/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateProductsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change product priority
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePriority: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changePriority', 'id', id)
            const localVarPath = `/products/{id}/priority`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change product visibility
         * @param {string} id Product Id
         * @param {boolean} active Active flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeVisibility: async (id: string, active: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changeVisibility', 'id', id)
            // verify required parameter 'active' is not null or undefined
            assertParamExists('changeVisibility', 'active', active)
            const localVarPath = `/products/{id}/visibility`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Duplicate product. Receives name of copy(duplicate product). Returns UUID of new created product.
         * @param {string} id Id of product that\&#39;s going to be duplicate
         * @param {CreateDuplicateProductRequest} createDuplicateProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDuplicateProduct: async (id: string, createDuplicateProductRequest: CreateDuplicateProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createDuplicateProduct', 'id', id)
            // verify required parameter 'createDuplicateProductRequest' is not null or undefined
            assertParamExists('createDuplicateProduct', 'createDuplicateProductRequest', createDuplicateProductRequest)
            const localVarPath = `/products/{id}/duplicate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDuplicateProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Product
         * @param {CreateProductRequest} createProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct: async (createProductRequest: CreateProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductRequest' is not null or undefined
            assertParamExists('createProduct', 'createProductRequest', createProductRequest)
            const localVarPath = `/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Save information for new product video
         * @param {string} id Product Id
         * @param {CreateVideoRequest} createVideoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductVideo: async (id: string, createVideoRequest: CreateVideoRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createProductVideo', 'id', id)
            // verify required parameter 'createVideoRequest' is not null or undefined
            assertParamExists('createProductVideo', 'createVideoRequest', createVideoRequest)
            const localVarPath = `/products/{id}/video`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createVideoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create video url
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductVideoUrl: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createProductVideoUrl', 'id', id)
            const localVarPath = `/products/{id}/video-url`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete products in bulk. Supply brand_id to delete all products for that brand, or supply product_ids to delete specific products.
         * @param {DeleteBulkProductRequest} deleteBulkProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBulkProduct: async (deleteBulkProductRequest: DeleteBulkProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteBulkProductRequest' is not null or undefined
            assertParamExists('deleteBulkProduct', 'deleteBulkProductRequest', deleteBulkProductRequest)
            const localVarPath = `/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteBulkProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete draft product
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDraftProduct: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDraftProduct', 'id', id)
            const localVarPath = `/products/draft-product/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete product variant image
         * @param {string} variantId Product variant Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteImageFromVariant: async (variantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'variantId' is not null or undefined
            assertParamExists('deleteImageFromVariant', 'variantId', variantId)
            const localVarPath = `/products/variants/{variantId}/image`
                .replace(`{${"variantId"}}`, encodeURIComponent(String(variantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete product
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProduct: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteProduct', 'id', id)
            const localVarPath = `/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete product image
         * @param {string} imageId Image Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductImage: async (imageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('deleteProductImage', 'imageId', imageId)
            const localVarPath = `/products/images/{imageId}`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download csv template which should be filled with inventory information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadInventoryCsvFile: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/download-inventory-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk duplicate products
         * @param {BulkDuplicateProductsRequest} bulkDuplicateProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateBulkProducts: async (bulkDuplicateProductsRequest: BulkDuplicateProductsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkDuplicateProductsRequest' is not null or undefined
            assertParamExists('duplicateBulkProducts', 'bulkDuplicateProductsRequest', bulkDuplicateProductsRequest)
            const localVarPath = `/products/bulk-duplicate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkDuplicateProductsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export products to csv file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProductsToCsv: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Favoritize product
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoritizeProduct: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('favoritizeProduct', 'id', id)
            const localVarPath = `/products/{id}/favoritize`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find products by search criteria
         * @param {FilterProductRequest} filterProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterProductsBySearchCriteria: async (filterProductRequest: FilterProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filterProductRequest' is not null or undefined
            assertParamExists('filterProductsBySearchCriteria', 'filterProductRequest', filterProductRequest)
            const localVarPath = `/products/search-criteria`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filterProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find all draft products per brand
         * @param {string} brandId Brand Id
         * @param {number} page Page
         * @param {number} size Size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDraftProductsForBrand: async (brandId: string, page: number, size: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getAllDraftProductsForBrand', 'brandId', brandId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllDraftProductsForBrand', 'page', page)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('getAllDraftProductsForBrand', 'size', size)
            const localVarPath = `/products/brands/{brandId}/draft-products`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get brand products count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandProductsCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get draft products count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftProductsCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/draft-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user favorite products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteProducts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/favorite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user filtered favorite products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredFavoriteProducts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/favorite-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search all inventory levels by keyword with pagination
         * @param {number} page Page
         * @param {number} size Size
         * @param {string} order Order
         * @param {string} [keyword] Keyword
         * @param {boolean} [inStock] InStock
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryLevels: async (page: number, size: number, order: string, keyword?: string, inStock?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getInventoryLevels', 'page', page)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('getInventoryLevels', 'size', size)
            // verify required parameter 'order' is not null or undefined
            assertParamExists('getInventoryLevels', 'order', order)
            const localVarPath = `/products/inventory-levels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (inStock !== undefined) {
                localVarQueryParameter['in_stock'] = inStock;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get number of user favorite products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumberOfFavoriteProducts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/number-of-favorite-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get product by Id
         * @param {string} id Product Id
         * @param {boolean} [checkAccess] Check if user can access product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct: async (id: string, checkAccess?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProduct', 'id', id)
            const localVarPath = `/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (checkAccess !== undefined) {
                localVarQueryParameter['check_access'] = checkAccess;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find all products per multiple/custom criteria
         * @param {string} [brandId] Brand Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [order] Order
         * @param {string} [status] Status
         * @param {string} [categoryId] Category Id
         * @param {boolean} [createdByAdmin] Created by admin
         * @param {boolean} [active] Availability
         * @param {string} [name] Name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: async (brandId?: string, page?: number, size?: number, order?: string, status?: string, categoryId?: string, createdByAdmin?: boolean, active?: boolean, name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (brandId !== undefined) {
                localVarQueryParameter['brandId'] = brandId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (createdByAdmin !== undefined) {
                localVarQueryParameter['createdByAdmin'] = createdByAdmin;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find products by category Id
         * @param {string} categoryId Category Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsByCategory: async (categoryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('getProductsByCategory', 'categoryId', categoryId)
            const localVarPath = `/products/categories/{categoryId}`
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find products by collection Id
         * @param {string} collectionId Collection Id
         * @param {number} [page] Page, if paginating the result
         * @param {number} [limit] max number of product ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsByCollection: async (collectionId: string, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'collectionId' is not null or undefined
            assertParamExists('getProductsByCollection', 'collectionId', collectionId)
            const localVarPath = `/products/collections/{collectionId}`
                .replace(`{${"collectionId"}}`, encodeURIComponent(String(collectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get filtered products
         * @param {string} productId Product Id
         * @param {string} brandId Brand Id
         * @param {number} productNumber Product number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsFiltered: async (productId: string, brandId: string, productNumber: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProductsFiltered', 'productId', productId)
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getProductsFiltered', 'brandId', brandId)
            // verify required parameter 'productNumber' is not null or undefined
            assertParamExists('getProductsFiltered', 'productNumber', productNumber)
            const localVarPath = `/products/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (productId !== undefined) {
                localVarQueryParameter['product_id'] = productId;
            }

            if (brandId !== undefined) {
                localVarQueryParameter['brand_id'] = brandId;
            }

            if (productNumber !== undefined) {
                localVarQueryParameter['product_number'] = productNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find all tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import products from CSV file
         * @param {ImportProductsFromCsvRequest} [importProductsFromCsvRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProductsFromCsv: async (importProductsFromCsvRequest?: ImportProductsFromCsvRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/csv-import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importProductsFromCsvRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import products from CSV file for Brands and Admins
         * @param {string} csvType CSV type
         * @param {string} brandId Brand Id
         * @param {boolean} [createDraft] Create draft products
         * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProductsFromCsvV2: async (csvType: string, brandId: string, createDraft?: boolean, linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'csvType' is not null or undefined
            assertParamExists('importProductsFromCsvV2', 'csvType', csvType)
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('importProductsFromCsvV2', 'brandId', brandId)
            const localVarPath = `/products/csv-import/v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createDraft !== undefined) {
                localVarQueryParameter['createDraft'] = createDraft;
            }

            if (csvType !== undefined) {
                localVarQueryParameter['csvType'] = csvType;
            }

            if (brandId !== undefined) {
                localVarQueryParameter['brandId'] = brandId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(linkRetailersWithTradeShowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import products name, category and tags based on new navigation settings
         * @param {Array<ImportProductsNavigationRequest>} importProductsNavigationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProductsNavigation: async (importProductsNavigationRequest: Array<ImportProductsNavigationRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importProductsNavigationRequest' is not null or undefined
            assertParamExists('importProductsNavigation', 'importProductsNavigationRequest', importProductsNavigationRequest)
            const localVarPath = `/products/import-navigation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importProductsNavigationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set product active flag.
         * @param {string} id Id of product that\&#39;s going to be marked as active
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markProductAsActive: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('markProductAsActive', 'id', id)
            const localVarPath = `/products/{id}/active`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set product visible flag.
         * @param {string} id Id of product that\&#39;s going to be marked as visible
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markProductAsVisible: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('markProductAsVisible', 'id', id)
            const localVarPath = `/products/{id}/visible`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Product as ProductBuilder
         * @param {ProductBuilderCreateProductRequest} productBuilderCreateProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productBuilderCreateProduct: async (productBuilderCreateProductRequest: ProductBuilderCreateProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productBuilderCreateProductRequest' is not null or undefined
            assertParamExists('productBuilderCreateProduct', 'productBuilderCreateProductRequest', productBuilderCreateProductRequest)
            const localVarPath = `/products/product-builders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productBuilderCreateProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update product as ProductBuilder
         * @param {string} id Product Id
         * @param {ProductBuilderUpdateProductRequest} productBuilderUpdateProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productBuilderUpdateProduct: async (id: string, productBuilderUpdateProductRequest: ProductBuilderUpdateProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productBuilderUpdateProduct', 'id', id)
            // verify required parameter 'productBuilderUpdateProductRequest' is not null or undefined
            assertParamExists('productBuilderUpdateProduct', 'productBuilderUpdateProductRequest', productBuilderUpdateProductRequest)
            const localVarPath = `/products/{id}/product-builders`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productBuilderUpdateProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pull products from Algolia without an image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pullProductsWithoutImageFromAlgolia: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/pull`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reject product
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectProduct: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rejectProduct', 'id', id)
            const localVarPath = `/products/{id}/reject`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * send draft product reminder email
         * @param {string} brandId Brand ID
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendDraftProductReminder: async (brandId: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('sendDraftProductReminder', 'brandId', brandId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('sendDraftProductReminder', 'body', body)
            const localVarPath = `/products/brands/{brandId}/draft-product-reminder`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update inventory tracking data from CSV file
         * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInventoryTrackingFromCsv: async (linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/import-inventory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(linkRetailersWithTradeShowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update product
         * @param {string} id Product Id
         * @param {UpdateProductRequest} updateProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct: async (id: string, updateProductRequest: UpdateProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProduct', 'id', id)
            // verify required parameter 'updateProductRequest' is not null or undefined
            assertParamExists('updateProduct', 'updateProductRequest', updateProductRequest)
            const localVarPath = `/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductCategories: async (linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/update-categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(linkRetailersWithTradeShowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update product image crop info
         * @param {string} productId Product Id
         * @param {string} imageId Image Id
         * @param {UpdateProductImageCropInfoRequest} updateProductImageCropInfoRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateProductImageCropInfo: async (productId: string, imageId: string, updateProductImageCropInfoRequest: UpdateProductImageCropInfoRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('updateProductImageCropInfo', 'productId', productId)
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('updateProductImageCropInfo', 'imageId', imageId)
            // verify required parameter 'updateProductImageCropInfoRequest' is not null or undefined
            assertParamExists('updateProductImageCropInfo', 'updateProductImageCropInfoRequest', updateProductImageCropInfoRequest)
            const localVarPath = `/products/{productId}/images/{imageId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductImageCropInfoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update product inventory level
         * @param {string} id Product Id
         * @param {UpdateProductInventoryLevelRequest} updateProductInventoryLevelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductInventoryLevel: async (id: string, updateProductInventoryLevelRequest: UpdateProductInventoryLevelRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProductInventoryLevel', 'id', id)
            // verify required parameter 'updateProductInventoryLevelRequest' is not null or undefined
            assertParamExists('updateProductInventoryLevel', 'updateProductInventoryLevelRequest', updateProductInventoryLevelRequest)
            const localVarPath = `/products/{id}/change-inventory`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductInventoryLevelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update products inventory levels
         * @param {UpdateProductsInventoryLevelsRequest} updateProductsInventoryLevelsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductsInventoryLevels: async (updateProductsInventoryLevelsRequest: UpdateProductsInventoryLevelsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateProductsInventoryLevelsRequest' is not null or undefined
            assertParamExists('updateProductsInventoryLevels', 'updateProductsInventoryLevelsRequest', updateProductsInventoryLevelsRequest)
            const localVarPath = `/products/change-inventories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductsInventoryLevelsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload product image
         * @param {string} id Product Id
         * @param {number} ordinal Image ordinal 
         * @param {boolean} isCustomAssortment Custom Assortment flag
         * @param {UploadProductImageRequest} uploadProductImageRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        uploadProductImage: async (id: string, ordinal: number, isCustomAssortment: boolean, uploadProductImageRequest: UploadProductImageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadProductImage', 'id', id)
            // verify required parameter 'ordinal' is not null or undefined
            assertParamExists('uploadProductImage', 'ordinal', ordinal)
            // verify required parameter 'isCustomAssortment' is not null or undefined
            assertParamExists('uploadProductImage', 'isCustomAssortment', isCustomAssortment)
            // verify required parameter 'uploadProductImageRequest' is not null or undefined
            assertParamExists('uploadProductImage', 'uploadProductImageRequest', uploadProductImageRequest)
            const localVarPath = `/products/{id}/images`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordinal !== undefined) {
                localVarQueryParameter['ordinal'] = ordinal;
            }

            if (isCustomAssortment !== undefined) {
                localVarQueryParameter['is_custom_assortment'] = isCustomAssortment;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadProductImageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate variant\'s SKU
         * @param {ValidateSKURequest} validateSKURequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSKU: async (validateSKURequest: ValidateSKURequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validateSKURequest' is not null or undefined
            assertParamExists('validateSKU', 'validateSKURequest', validateSKURequest)
            const localVarPath = `/products/validate-sku`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateSKURequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductControllerApi - functional programming interface
 * @export
 */
export const ProductControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id Product Id
         * @param {AddDraftProductRequest} addDraftProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateDraftProduct(id: string, addDraftProductRequest: AddDraftProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateDraftProduct(id, addDraftProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.activateDraftProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add all draft products
         * @param {AddAllDraftProductsRequest} addAllDraftProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAllDraftProducts(addAllDraftProductsRequest: AddAllDraftProductsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddAllDraftProductStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAllDraftProducts(addAllDraftProductsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.addAllDraftProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Approve product
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveProduct(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveProduct(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.approveProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Assign product image to variant
         * @param {string} variantId Product Variant Id
         * @param {string} imageId Image Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignImageToVariant(variantId: string, imageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignImageToVariant(variantId, imageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.assignImageToVariant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import products from CSV file as Brand
         * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brandImportProductsFromCsv(linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.brandImportProductsFromCsv(linkRetailersWithTradeShowRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.brandImportProductsFromCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bulk delete product
         * @param {BulkDeleteProductsRequest} bulkDeleteProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDeleteProduct(bulkDeleteProductsRequest: BulkDeleteProductsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDeleteProduct(bulkDeleteProductsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.bulkDeleteProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bulk save draft product.
         * @param {BulkSaveDraftProductRequest} bulkSaveDraftProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkSaveDraftProduct(bulkSaveDraftProductRequest: BulkSaveDraftProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkSaveDraftProduct(bulkSaveDraftProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.bulkSaveDraftProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bulk update draft products
         * @param {BulkUpdateDraftProductsRequest} bulkUpdateDraftProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateDraftProducts(bulkUpdateDraftProductsRequest: BulkUpdateDraftProductsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateDraftProducts(bulkUpdateDraftProductsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.bulkUpdateDraftProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Admin API to update products in bulk
         * @param {BulkUpdateProductsRequest} bulkUpdateProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateProducts(bulkUpdateProductsRequest: BulkUpdateProductsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateProducts(bulkUpdateProductsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.bulkUpdateProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change product priority
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePriority(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePriority(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.changePriority']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change product visibility
         * @param {string} id Product Id
         * @param {boolean} active Active flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeVisibility(id: string, active: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeVisibility(id, active, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.changeVisibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Duplicate product. Receives name of copy(duplicate product). Returns UUID of new created product.
         * @param {string} id Id of product that\&#39;s going to be duplicate
         * @param {CreateDuplicateProductRequest} createDuplicateProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDuplicateProduct(id: string, createDuplicateProductRequest: CreateDuplicateProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDuplicateProduct(id, createDuplicateProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.createDuplicateProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Product
         * @param {CreateProductRequest} createProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProduct(createProductRequest: CreateProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProduct(createProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.createProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Save information for new product video
         * @param {string} id Product Id
         * @param {CreateVideoRequest} createVideoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProductVideo(id: string, createVideoRequest: CreateVideoRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProductVideo(id, createVideoRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.createProductVideo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create video url
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProductVideoUrl(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadVideoUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProductVideoUrl(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.createProductVideoUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete products in bulk. Supply brand_id to delete all products for that brand, or supply product_ids to delete specific products.
         * @param {DeleteBulkProductRequest} deleteBulkProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBulkProduct(deleteBulkProductRequest: DeleteBulkProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBulkProduct(deleteBulkProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.deleteBulkProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete draft product
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDraftProduct(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDraftProduct(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.deleteDraftProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete product variant image
         * @param {string} variantId Product variant Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteImageFromVariant(variantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteImageFromVariant(variantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.deleteImageFromVariant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete product
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProduct(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProduct(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.deleteProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete product image
         * @param {string} imageId Image Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProductImage(imageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProductImage(imageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.deleteProductImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download csv template which should be filled with inventory information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadInventoryCsvFile(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadInventoryCsvFile(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.downloadInventoryCsvFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bulk duplicate products
         * @param {BulkDuplicateProductsRequest} bulkDuplicateProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateBulkProducts(bulkDuplicateProductsRequest: BulkDuplicateProductsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkDuplicateProductsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateBulkProducts(bulkDuplicateProductsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.duplicateBulkProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export products to csv file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportProductsToCsv(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportProductsToCsv(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.exportProductsToCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Favoritize product
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async favoritizeProduct(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.favoritizeProduct(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.favoritizeProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find products by search criteria
         * @param {FilterProductRequest} filterProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filterProductsBySearchCriteria(filterProductRequest: FilterProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilteredProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filterProductsBySearchCriteria(filterProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.filterProductsBySearchCriteria']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find all draft products per brand
         * @param {string} brandId Brand Id
         * @param {number} page Page
         * @param {number} size Size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDraftProductsForBrand(brandId: string, page: number, size: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedProductsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDraftProductsForBrand(brandId, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.getAllDraftProductsForBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get brand products count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandProductsCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountBrandProductsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandProductsCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.getBrandProductsCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get draft products count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDraftProductsCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountDraftProductsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDraftProductsCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.getDraftProductsCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get user favorite products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFavoriteProducts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilteredProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFavoriteProducts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.getFavoriteProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get user filtered favorite products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilteredFavoriteProducts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilteredProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilteredFavoriteProducts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.getFilteredFavoriteProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search all inventory levels by keyword with pagination
         * @param {number} page Page
         * @param {number} size Size
         * @param {string} order Order
         * @param {string} [keyword] Keyword
         * @param {boolean} [inStock] InStock
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventoryLevels(page: number, size: number, order: string, keyword?: string, inStock?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInventoryLevelsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryLevels(page, size, order, keyword, inStock, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.getInventoryLevels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get number of user favorite products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNumberOfFavoriteProducts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FavoriteProductsCountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNumberOfFavoriteProducts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.getNumberOfFavoriteProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get product by Id
         * @param {string} id Product Id
         * @param {boolean} [checkAccess] Check if user can access product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProduct(id: string, checkAccess?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProduct(id, checkAccess, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.getProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find all products per multiple/custom criteria
         * @param {string} [brandId] Brand Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [order] Order
         * @param {string} [status] Status
         * @param {string} [categoryId] Category Id
         * @param {boolean} [createdByAdmin] Created by admin
         * @param {boolean} [active] Availability
         * @param {string} [name] Name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProducts(brandId?: string, page?: number, size?: number, order?: string, status?: string, categoryId?: string, createdByAdmin?: boolean, active?: boolean, name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedProductsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProducts(brandId, page, size, order, status, categoryId, createdByAdmin, active, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.getProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find products by category Id
         * @param {string} categoryId Category Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductsByCategory(categoryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProductsByCategoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductsByCategory(categoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.getProductsByCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find products by collection Id
         * @param {string} collectionId Collection Id
         * @param {number} [page] Page, if paginating the result
         * @param {number} [limit] max number of product ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductsByCollection(collectionId: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductsByCollection(collectionId, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.getProductsByCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get filtered products
         * @param {string} productId Product Id
         * @param {string} brandId Brand Id
         * @param {number} productNumber Product number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductsFiltered(productId: string, brandId: string, productNumber: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetProductFilteredResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductsFiltered(productId, brandId, productNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.getProductsFiltered']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find all tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTags(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTags(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.getTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import products from CSV file
         * @param {ImportProductsFromCsvRequest} [importProductsFromCsvRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importProductsFromCsv(importProductsFromCsvRequest?: ImportProductsFromCsvRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importProductsFromCsv(importProductsFromCsvRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.importProductsFromCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import products from CSV file for Brands and Admins
         * @param {string} csvType CSV type
         * @param {string} brandId Brand Id
         * @param {boolean} [createDraft] Create draft products
         * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importProductsFromCsvV2(csvType: string, brandId: string, createDraft?: boolean, linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importProductsFromCsvV2(csvType, brandId, createDraft, linkRetailersWithTradeShowRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.importProductsFromCsvV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import products name, category and tags based on new navigation settings
         * @param {Array<ImportProductsNavigationRequest>} importProductsNavigationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importProductsNavigation(importProductsNavigationRequest: Array<ImportProductsNavigationRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importProductsNavigation(importProductsNavigationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.importProductsNavigation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set product active flag.
         * @param {string} id Id of product that\&#39;s going to be marked as active
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markProductAsActive(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markProductAsActive(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.markProductAsActive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set product visible flag.
         * @param {string} id Id of product that\&#39;s going to be marked as visible
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markProductAsVisible(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markProductAsVisible(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.markProductAsVisible']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Product as ProductBuilder
         * @param {ProductBuilderCreateProductRequest} productBuilderCreateProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productBuilderCreateProduct(productBuilderCreateProductRequest: ProductBuilderCreateProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productBuilderCreateProduct(productBuilderCreateProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.productBuilderCreateProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update product as ProductBuilder
         * @param {string} id Product Id
         * @param {ProductBuilderUpdateProductRequest} productBuilderUpdateProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productBuilderUpdateProduct(id: string, productBuilderUpdateProductRequest: ProductBuilderUpdateProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productBuilderUpdateProduct(id, productBuilderUpdateProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.productBuilderUpdateProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pull products from Algolia without an image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pullProductsWithoutImageFromAlgolia(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductWithoutImageResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pullProductsWithoutImageFromAlgolia(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.pullProductsWithoutImageFromAlgolia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reject product
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectProduct(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectProduct(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.rejectProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * send draft product reminder email
         * @param {string} brandId Brand ID
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendDraftProductReminder(brandId: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendDraftProductReminder(brandId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.sendDraftProductReminder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update inventory tracking data from CSV file
         * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInventoryTrackingFromCsv(linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateInventoryTrackingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInventoryTrackingFromCsv(linkRetailersWithTradeShowRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.updateInventoryTrackingFromCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update product
         * @param {string} id Product Id
         * @param {UpdateProductRequest} updateProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProduct(id: string, updateProductRequest: UpdateProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProduct(id, updateProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.updateProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductCategories(linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductCategories(linkRetailersWithTradeShowRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.updateProductCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update product image crop info
         * @param {string} productId Product Id
         * @param {string} imageId Image Id
         * @param {UpdateProductImageCropInfoRequest} updateProductImageCropInfoRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async updateProductImageCropInfo(productId: string, imageId: string, updateProductImageCropInfoRequest: UpdateProductImageCropInfoRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadImageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductImageCropInfo(productId, imageId, updateProductImageCropInfoRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.updateProductImageCropInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update product inventory level
         * @param {string} id Product Id
         * @param {UpdateProductInventoryLevelRequest} updateProductInventoryLevelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductInventoryLevel(id: string, updateProductInventoryLevelRequest: UpdateProductInventoryLevelRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateInventoryLevelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductInventoryLevel(id, updateProductInventoryLevelRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.updateProductInventoryLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update products inventory levels
         * @param {UpdateProductsInventoryLevelsRequest} updateProductsInventoryLevelsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductsInventoryLevels(updateProductsInventoryLevelsRequest: UpdateProductsInventoryLevelsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateInventoryLevelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductsInventoryLevels(updateProductsInventoryLevelsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.updateProductsInventoryLevels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload product image
         * @param {string} id Product Id
         * @param {number} ordinal Image ordinal 
         * @param {boolean} isCustomAssortment Custom Assortment flag
         * @param {UploadProductImageRequest} uploadProductImageRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async uploadProductImage(id: string, ordinal: number, isCustomAssortment: boolean, uploadProductImageRequest: UploadProductImageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadImageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadProductImage(id, ordinal, isCustomAssortment, uploadProductImageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.uploadProductImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate variant\'s SKU
         * @param {ValidateSKURequest} validateSKURequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateSKU(validateSKURequest: ValidateSKURequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateSKUResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateSKU(validateSKURequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductControllerApi.validateSKU']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductControllerApi - factory interface
 * @export
 */
export const ProductControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id Product Id
         * @param {AddDraftProductRequest} addDraftProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateDraftProduct(id: string, addDraftProductRequest: AddDraftProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.activateDraftProduct(id, addDraftProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add all draft products
         * @param {AddAllDraftProductsRequest} addAllDraftProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAllDraftProducts(addAllDraftProductsRequest: AddAllDraftProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddAllDraftProductStatusResponse> {
            return localVarFp.addAllDraftProducts(addAllDraftProductsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Approve product
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveProduct(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.approveProduct(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Assign product image to variant
         * @param {string} variantId Product Variant Id
         * @param {string} imageId Image Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignImageToVariant(variantId: string, imageId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assignImageToVariant(variantId, imageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Import products from CSV file as Brand
         * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brandImportProductsFromCsv(linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.brandImportProductsFromCsv(linkRetailersWithTradeShowRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk delete product
         * @param {BulkDeleteProductsRequest} bulkDeleteProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteProduct(bulkDeleteProductsRequest: BulkDeleteProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.bulkDeleteProduct(bulkDeleteProductsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk save draft product.
         * @param {BulkSaveDraftProductRequest} bulkSaveDraftProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkSaveDraftProduct(bulkSaveDraftProductRequest: BulkSaveDraftProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.bulkSaveDraftProduct(bulkSaveDraftProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk update draft products
         * @param {BulkUpdateDraftProductsRequest} bulkUpdateDraftProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateDraftProducts(bulkUpdateDraftProductsRequest: BulkUpdateDraftProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.bulkUpdateDraftProducts(bulkUpdateDraftProductsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Admin API to update products in bulk
         * @param {BulkUpdateProductsRequest} bulkUpdateProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateProducts(bulkUpdateProductsRequest: BulkUpdateProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.bulkUpdateProducts(bulkUpdateProductsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Change product priority
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePriority(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changePriority(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Change product visibility
         * @param {string} id Product Id
         * @param {boolean} active Active flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeVisibility(id: string, active: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changeVisibility(id, active, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Duplicate product. Receives name of copy(duplicate product). Returns UUID of new created product.
         * @param {string} id Id of product that\&#39;s going to be duplicate
         * @param {CreateDuplicateProductRequest} createDuplicateProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDuplicateProduct(id: string, createDuplicateProductRequest: CreateDuplicateProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper> {
            return localVarFp.createDuplicateProduct(id, createDuplicateProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Product
         * @param {CreateProductRequest} createProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct(createProductRequest: CreateProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper> {
            return localVarFp.createProduct(createProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Save information for new product video
         * @param {string} id Product Id
         * @param {CreateVideoRequest} createVideoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductVideo(id: string, createVideoRequest: CreateVideoRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper> {
            return localVarFp.createProductVideo(id, createVideoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create video url
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductVideoUrl(id: string, options?: RawAxiosRequestConfig): AxiosPromise<UploadVideoUrlResponse> {
            return localVarFp.createProductVideoUrl(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete products in bulk. Supply brand_id to delete all products for that brand, or supply product_ids to delete specific products.
         * @param {DeleteBulkProductRequest} deleteBulkProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBulkProduct(deleteBulkProductRequest: DeleteBulkProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteBulkProduct(deleteBulkProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete draft product
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDraftProduct(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDraftProduct(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete product variant image
         * @param {string} variantId Product variant Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteImageFromVariant(variantId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteImageFromVariant(variantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete product
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProduct(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteProduct(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete product image
         * @param {string} imageId Image Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductImage(imageId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteProductImage(imageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Download csv template which should be filled with inventory information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadInventoryCsvFile(options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadInventoryCsvFile(options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk duplicate products
         * @param {BulkDuplicateProductsRequest} bulkDuplicateProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateBulkProducts(bulkDuplicateProductsRequest: BulkDuplicateProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkDuplicateProductsResponse> {
            return localVarFp.duplicateBulkProducts(bulkDuplicateProductsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Export products to csv file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProductsToCsv(options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportProductsToCsv(options).then((request) => request(axios, basePath));
        },
        /**
         * Favoritize product
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoritizeProduct(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.favoritizeProduct(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Find products by search criteria
         * @param {FilterProductRequest} filterProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterProductsBySearchCriteria(filterProductRequest: FilterProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<FilteredProductResponse> {
            return localVarFp.filterProductsBySearchCriteria(filterProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Find all draft products per brand
         * @param {string} brandId Brand Id
         * @param {number} page Page
         * @param {number} size Size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDraftProductsForBrand(brandId: string, page: number, size: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedProductsResponse> {
            return localVarFp.getAllDraftProductsForBrand(brandId, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Get brand products count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandProductsCount(options?: RawAxiosRequestConfig): AxiosPromise<CountBrandProductsResponse> {
            return localVarFp.getBrandProductsCount(options).then((request) => request(axios, basePath));
        },
        /**
         * Get draft products count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftProductsCount(options?: RawAxiosRequestConfig): AxiosPromise<CountDraftProductsResponse> {
            return localVarFp.getDraftProductsCount(options).then((request) => request(axios, basePath));
        },
        /**
         * Get user favorite products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteProducts(options?: RawAxiosRequestConfig): AxiosPromise<FilteredProductResponse> {
            return localVarFp.getFavoriteProducts(options).then((request) => request(axios, basePath));
        },
        /**
         * Get user filtered favorite products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredFavoriteProducts(options?: RawAxiosRequestConfig): AxiosPromise<FilteredProductResponse> {
            return localVarFp.getFilteredFavoriteProducts(options).then((request) => request(axios, basePath));
        },
        /**
         * Search all inventory levels by keyword with pagination
         * @param {number} page Page
         * @param {number} size Size
         * @param {string} order Order
         * @param {string} [keyword] Keyword
         * @param {boolean} [inStock] InStock
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryLevels(page: number, size: number, order: string, keyword?: string, inStock?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<GetInventoryLevelsResponse> {
            return localVarFp.getInventoryLevels(page, size, order, keyword, inStock, options).then((request) => request(axios, basePath));
        },
        /**
         * Get number of user favorite products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumberOfFavoriteProducts(options?: RawAxiosRequestConfig): AxiosPromise<FavoriteProductsCountResponse> {
            return localVarFp.getNumberOfFavoriteProducts(options).then((request) => request(axios, basePath));
        },
        /**
         * Get product by Id
         * @param {string} id Product Id
         * @param {boolean} [checkAccess] Check if user can access product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct(id: string, checkAccess?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<GetProductResponse> {
            return localVarFp.getProduct(id, checkAccess, options).then((request) => request(axios, basePath));
        },
        /**
         * Find all products per multiple/custom criteria
         * @param {string} [brandId] Brand Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [order] Order
         * @param {string} [status] Status
         * @param {string} [categoryId] Category Id
         * @param {boolean} [createdByAdmin] Created by admin
         * @param {boolean} [active] Availability
         * @param {string} [name] Name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(brandId?: string, page?: number, size?: number, order?: string, status?: string, categoryId?: string, createdByAdmin?: boolean, active?: boolean, name?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedProductsResponse> {
            return localVarFp.getProducts(brandId, page, size, order, status, categoryId, createdByAdmin, active, name, options).then((request) => request(axios, basePath));
        },
        /**
         * Find products by category Id
         * @param {string} categoryId Category Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsByCategory(categoryId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetProductsByCategoryResponse> {
            return localVarFp.getProductsByCategory(categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * Find products by collection Id
         * @param {string} collectionId Collection Id
         * @param {number} [page] Page, if paginating the result
         * @param {number} [limit] max number of product ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsByCollection(collectionId: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<CollectionResponse> {
            return localVarFp.getProductsByCollection(collectionId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Get filtered products
         * @param {string} productId Product Id
         * @param {string} brandId Brand Id
         * @param {number} productNumber Product number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsFiltered(productId: string, brandId: string, productNumber: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetProductFilteredResponse>> {
            return localVarFp.getProductsFiltered(productId, brandId, productNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Find all tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getTags(options).then((request) => request(axios, basePath));
        },
        /**
         * Import products from CSV file
         * @param {ImportProductsFromCsvRequest} [importProductsFromCsvRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProductsFromCsv(importProductsFromCsvRequest?: ImportProductsFromCsvRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.importProductsFromCsv(importProductsFromCsvRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Import products from CSV file for Brands and Admins
         * @param {string} csvType CSV type
         * @param {string} brandId Brand Id
         * @param {boolean} [createDraft] Create draft products
         * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProductsFromCsvV2(csvType: string, brandId: string, createDraft?: boolean, linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.importProductsFromCsvV2(csvType, brandId, createDraft, linkRetailersWithTradeShowRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Import products name, category and tags based on new navigation settings
         * @param {Array<ImportProductsNavigationRequest>} importProductsNavigationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProductsNavigation(importProductsNavigationRequest: Array<ImportProductsNavigationRequest>, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.importProductsNavigation(importProductsNavigationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Set product active flag.
         * @param {string} id Id of product that\&#39;s going to be marked as active
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markProductAsActive(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markProductAsActive(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Set product visible flag.
         * @param {string} id Id of product that\&#39;s going to be marked as visible
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markProductAsVisible(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markProductAsVisible(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Product as ProductBuilder
         * @param {ProductBuilderCreateProductRequest} productBuilderCreateProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productBuilderCreateProduct(productBuilderCreateProductRequest: ProductBuilderCreateProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper> {
            return localVarFp.productBuilderCreateProduct(productBuilderCreateProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update product as ProductBuilder
         * @param {string} id Product Id
         * @param {ProductBuilderUpdateProductRequest} productBuilderUpdateProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productBuilderUpdateProduct(id: string, productBuilderUpdateProductRequest: ProductBuilderUpdateProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.productBuilderUpdateProduct(id, productBuilderUpdateProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Pull products from Algolia without an image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pullProductsWithoutImageFromAlgolia(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductWithoutImageResponse>> {
            return localVarFp.pullProductsWithoutImageFromAlgolia(options).then((request) => request(axios, basePath));
        },
        /**
         * Reject product
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectProduct(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rejectProduct(id, options).then((request) => request(axios, basePath));
        },
        /**
         * send draft product reminder email
         * @param {string} brandId Brand ID
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendDraftProductReminder(brandId: string, body: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendDraftProductReminder(brandId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Update inventory tracking data from CSV file
         * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInventoryTrackingFromCsv(linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateInventoryTrackingResponse> {
            return localVarFp.updateInventoryTrackingFromCsv(linkRetailersWithTradeShowRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update product
         * @param {string} id Product Id
         * @param {UpdateProductRequest} updateProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct(id: string, updateProductRequest: UpdateProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProduct(id, updateProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductCategories(linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProductCategories(linkRetailersWithTradeShowRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update product image crop info
         * @param {string} productId Product Id
         * @param {string} imageId Image Id
         * @param {UpdateProductImageCropInfoRequest} updateProductImageCropInfoRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateProductImageCropInfo(productId: string, imageId: string, updateProductImageCropInfoRequest: UpdateProductImageCropInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadImageResponse> {
            return localVarFp.updateProductImageCropInfo(productId, imageId, updateProductImageCropInfoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update product inventory level
         * @param {string} id Product Id
         * @param {UpdateProductInventoryLevelRequest} updateProductInventoryLevelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductInventoryLevel(id: string, updateProductInventoryLevelRequest: UpdateProductInventoryLevelRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateInventoryLevelResponse> {
            return localVarFp.updateProductInventoryLevel(id, updateProductInventoryLevelRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update products inventory levels
         * @param {UpdateProductsInventoryLevelsRequest} updateProductsInventoryLevelsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductsInventoryLevels(updateProductsInventoryLevelsRequest: UpdateProductsInventoryLevelsRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateInventoryLevelResponse> {
            return localVarFp.updateProductsInventoryLevels(updateProductsInventoryLevelsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload product image
         * @param {string} id Product Id
         * @param {number} ordinal Image ordinal 
         * @param {boolean} isCustomAssortment Custom Assortment flag
         * @param {UploadProductImageRequest} uploadProductImageRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        uploadProductImage(id: string, ordinal: number, isCustomAssortment: boolean, uploadProductImageRequest: UploadProductImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadImageResponse> {
            return localVarFp.uploadProductImage(id, ordinal, isCustomAssortment, uploadProductImageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate variant\'s SKU
         * @param {ValidateSKURequest} validateSKURequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSKU(validateSKURequest: ValidateSKURequest, options?: RawAxiosRequestConfig): AxiosPromise<ValidateSKUResponse> {
            return localVarFp.validateSKU(validateSKURequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductControllerApi - interface
 * @export
 * @interface ProductControllerApi
 */
export interface ProductControllerApiInterface {
    /**
     * 
     * @param {string} id Product Id
     * @param {AddDraftProductRequest} addDraftProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    activateDraftProduct(id: string, addDraftProductRequest: AddDraftProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Add all draft products
     * @param {AddAllDraftProductsRequest} addAllDraftProductsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    addAllDraftProducts(addAllDraftProductsRequest: AddAllDraftProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddAllDraftProductStatusResponse>;

    /**
     * Approve product
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    approveProduct(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Assign product image to variant
     * @param {string} variantId Product Variant Id
     * @param {string} imageId Image Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    assignImageToVariant(variantId: string, imageId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Import products from CSV file as Brand
     * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    brandImportProductsFromCsv(linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Bulk delete product
     * @param {BulkDeleteProductsRequest} bulkDeleteProductsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    bulkDeleteProduct(bulkDeleteProductsRequest: BulkDeleteProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Bulk save draft product.
     * @param {BulkSaveDraftProductRequest} bulkSaveDraftProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    bulkSaveDraftProduct(bulkSaveDraftProductRequest: BulkSaveDraftProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Bulk update draft products
     * @param {BulkUpdateDraftProductsRequest} bulkUpdateDraftProductsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    bulkUpdateDraftProducts(bulkUpdateDraftProductsRequest: BulkUpdateDraftProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Admin API to update products in bulk
     * @param {BulkUpdateProductsRequest} bulkUpdateProductsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    bulkUpdateProducts(bulkUpdateProductsRequest: BulkUpdateProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Change product priority
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    changePriority(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Change product visibility
     * @param {string} id Product Id
     * @param {boolean} active Active flag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    changeVisibility(id: string, active: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Duplicate product. Receives name of copy(duplicate product). Returns UUID of new created product.
     * @param {string} id Id of product that\&#39;s going to be duplicate
     * @param {CreateDuplicateProductRequest} createDuplicateProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    createDuplicateProduct(id: string, createDuplicateProductRequest: CreateDuplicateProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper>;

    /**
     * 
     * @summary Create Product
     * @param {CreateProductRequest} createProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    createProduct(createProductRequest: CreateProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper>;

    /**
     * Save information for new product video
     * @param {string} id Product Id
     * @param {CreateVideoRequest} createVideoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    createProductVideo(id: string, createVideoRequest: CreateVideoRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper>;

    /**
     * Create video url
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    createProductVideoUrl(id: string, options?: RawAxiosRequestConfig): AxiosPromise<UploadVideoUrlResponse>;

    /**
     * Delete products in bulk. Supply brand_id to delete all products for that brand, or supply product_ids to delete specific products.
     * @param {DeleteBulkProductRequest} deleteBulkProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    deleteBulkProduct(deleteBulkProductRequest: DeleteBulkProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Delete draft product
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    deleteDraftProduct(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Delete product variant image
     * @param {string} variantId Product variant Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    deleteImageFromVariant(variantId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Delete product
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    deleteProduct(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Delete product image
     * @param {string} imageId Image Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    deleteProductImage(imageId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Download csv template which should be filled with inventory information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    downloadInventoryCsvFile(options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * Bulk duplicate products
     * @param {BulkDuplicateProductsRequest} bulkDuplicateProductsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    duplicateBulkProducts(bulkDuplicateProductsRequest: BulkDuplicateProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkDuplicateProductsResponse>;

    /**
     * Export products to csv file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    exportProductsToCsv(options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * Favoritize product
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    favoritizeProduct(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Find products by search criteria
     * @param {FilterProductRequest} filterProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    filterProductsBySearchCriteria(filterProductRequest: FilterProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<FilteredProductResponse>;

    /**
     * Find all draft products per brand
     * @param {string} brandId Brand Id
     * @param {number} page Page
     * @param {number} size Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    getAllDraftProductsForBrand(brandId: string, page: number, size: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedProductsResponse>;

    /**
     * Get brand products count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    getBrandProductsCount(options?: RawAxiosRequestConfig): AxiosPromise<CountBrandProductsResponse>;

    /**
     * Get draft products count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    getDraftProductsCount(options?: RawAxiosRequestConfig): AxiosPromise<CountDraftProductsResponse>;

    /**
     * Get user favorite products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    getFavoriteProducts(options?: RawAxiosRequestConfig): AxiosPromise<FilteredProductResponse>;

    /**
     * Get user filtered favorite products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    getFilteredFavoriteProducts(options?: RawAxiosRequestConfig): AxiosPromise<FilteredProductResponse>;

    /**
     * Search all inventory levels by keyword with pagination
     * @param {number} page Page
     * @param {number} size Size
     * @param {string} order Order
     * @param {string} [keyword] Keyword
     * @param {boolean} [inStock] InStock
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    getInventoryLevels(page: number, size: number, order: string, keyword?: string, inStock?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<GetInventoryLevelsResponse>;

    /**
     * Get number of user favorite products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    getNumberOfFavoriteProducts(options?: RawAxiosRequestConfig): AxiosPromise<FavoriteProductsCountResponse>;

    /**
     * Get product by Id
     * @param {string} id Product Id
     * @param {boolean} [checkAccess] Check if user can access product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    getProduct(id: string, checkAccess?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<GetProductResponse>;

    /**
     * Find all products per multiple/custom criteria
     * @param {string} [brandId] Brand Id
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {string} [order] Order
     * @param {string} [status] Status
     * @param {string} [categoryId] Category Id
     * @param {boolean} [createdByAdmin] Created by admin
     * @param {boolean} [active] Availability
     * @param {string} [name] Name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    getProducts(brandId?: string, page?: number, size?: number, order?: string, status?: string, categoryId?: string, createdByAdmin?: boolean, active?: boolean, name?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedProductsResponse>;

    /**
     * Find products by category Id
     * @param {string} categoryId Category Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    getProductsByCategory(categoryId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetProductsByCategoryResponse>;

    /**
     * Find products by collection Id
     * @param {string} collectionId Collection Id
     * @param {number} [page] Page, if paginating the result
     * @param {number} [limit] max number of product ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    getProductsByCollection(collectionId: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<CollectionResponse>;

    /**
     * Get filtered products
     * @param {string} productId Product Id
     * @param {string} brandId Brand Id
     * @param {number} productNumber Product number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    getProductsFiltered(productId: string, brandId: string, productNumber: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetProductFilteredResponse>>;

    /**
     * Find all tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    getTags(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>>;

    /**
     * Import products from CSV file
     * @param {ImportProductsFromCsvRequest} [importProductsFromCsvRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    importProductsFromCsv(importProductsFromCsvRequest?: ImportProductsFromCsvRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Import products from CSV file for Brands and Admins
     * @param {string} csvType CSV type
     * @param {string} brandId Brand Id
     * @param {boolean} [createDraft] Create draft products
     * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    importProductsFromCsvV2(csvType: string, brandId: string, createDraft?: boolean, linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Import products name, category and tags based on new navigation settings
     * @param {Array<ImportProductsNavigationRequest>} importProductsNavigationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    importProductsNavigation(importProductsNavigationRequest: Array<ImportProductsNavigationRequest>, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>>;

    /**
     * Set product active flag.
     * @param {string} id Id of product that\&#39;s going to be marked as active
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    markProductAsActive(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Set product visible flag.
     * @param {string} id Id of product that\&#39;s going to be marked as visible
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    markProductAsVisible(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Create Product as ProductBuilder
     * @param {ProductBuilderCreateProductRequest} productBuilderCreateProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    productBuilderCreateProduct(productBuilderCreateProductRequest: ProductBuilderCreateProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper>;

    /**
     * Update product as ProductBuilder
     * @param {string} id Product Id
     * @param {ProductBuilderUpdateProductRequest} productBuilderUpdateProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    productBuilderUpdateProduct(id: string, productBuilderUpdateProductRequest: ProductBuilderUpdateProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Pull products from Algolia without an image
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    pullProductsWithoutImageFromAlgolia(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductWithoutImageResponse>>;

    /**
     * Reject product
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    rejectProduct(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * send draft product reminder email
     * @param {string} brandId Brand ID
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    sendDraftProductReminder(brandId: string, body: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update inventory tracking data from CSV file
     * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    updateInventoryTrackingFromCsv(linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateInventoryTrackingResponse>;

    /**
     * Update product
     * @param {string} id Product Id
     * @param {UpdateProductRequest} updateProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    updateProduct(id: string, updateProductRequest: UpdateProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    updateProductCategories(linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update product image crop info
     * @param {string} productId Product Id
     * @param {string} imageId Image Id
     * @param {UpdateProductImageCropInfoRequest} updateProductImageCropInfoRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    updateProductImageCropInfo(productId: string, imageId: string, updateProductImageCropInfoRequest: UpdateProductImageCropInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadImageResponse>;

    /**
     * Update product inventory level
     * @param {string} id Product Id
     * @param {UpdateProductInventoryLevelRequest} updateProductInventoryLevelRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    updateProductInventoryLevel(id: string, updateProductInventoryLevelRequest: UpdateProductInventoryLevelRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateInventoryLevelResponse>;

    /**
     * Update products inventory levels
     * @param {UpdateProductsInventoryLevelsRequest} updateProductsInventoryLevelsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    updateProductsInventoryLevels(updateProductsInventoryLevelsRequest: UpdateProductsInventoryLevelsRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateInventoryLevelResponse>;

    /**
     * Upload product image
     * @param {string} id Product Id
     * @param {number} ordinal Image ordinal 
     * @param {boolean} isCustomAssortment Custom Assortment flag
     * @param {UploadProductImageRequest} uploadProductImageRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    uploadProductImage(id: string, ordinal: number, isCustomAssortment: boolean, uploadProductImageRequest: UploadProductImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadImageResponse>;

    /**
     * Validate variant\'s SKU
     * @param {ValidateSKURequest} validateSKURequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApiInterface
     */
    validateSKU(validateSKURequest: ValidateSKURequest, options?: RawAxiosRequestConfig): AxiosPromise<ValidateSKUResponse>;

}

/**
 * ProductControllerApi - object-oriented interface
 * @export
 * @class ProductControllerApi
 * @extends {BaseAPI}
 */
export class ProductControllerApi extends BaseAPI implements ProductControllerApiInterface {
    /**
     * 
     * @param {string} id Product Id
     * @param {AddDraftProductRequest} addDraftProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public activateDraftProduct(id: string, addDraftProductRequest: AddDraftProductRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).activateDraftProduct(id, addDraftProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add all draft products
     * @param {AddAllDraftProductsRequest} addAllDraftProductsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public addAllDraftProducts(addAllDraftProductsRequest: AddAllDraftProductsRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).addAllDraftProducts(addAllDraftProductsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Approve product
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public approveProduct(id: string, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).approveProduct(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Assign product image to variant
     * @param {string} variantId Product Variant Id
     * @param {string} imageId Image Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public assignImageToVariant(variantId: string, imageId: string, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).assignImageToVariant(variantId, imageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import products from CSV file as Brand
     * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public brandImportProductsFromCsv(linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).brandImportProductsFromCsv(linkRetailersWithTradeShowRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk delete product
     * @param {BulkDeleteProductsRequest} bulkDeleteProductsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public bulkDeleteProduct(bulkDeleteProductsRequest: BulkDeleteProductsRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).bulkDeleteProduct(bulkDeleteProductsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk save draft product.
     * @param {BulkSaveDraftProductRequest} bulkSaveDraftProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public bulkSaveDraftProduct(bulkSaveDraftProductRequest: BulkSaveDraftProductRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).bulkSaveDraftProduct(bulkSaveDraftProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk update draft products
     * @param {BulkUpdateDraftProductsRequest} bulkUpdateDraftProductsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public bulkUpdateDraftProducts(bulkUpdateDraftProductsRequest: BulkUpdateDraftProductsRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).bulkUpdateDraftProducts(bulkUpdateDraftProductsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admin API to update products in bulk
     * @param {BulkUpdateProductsRequest} bulkUpdateProductsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public bulkUpdateProducts(bulkUpdateProductsRequest: BulkUpdateProductsRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).bulkUpdateProducts(bulkUpdateProductsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change product priority
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public changePriority(id: string, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).changePriority(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change product visibility
     * @param {string} id Product Id
     * @param {boolean} active Active flag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public changeVisibility(id: string, active: boolean, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).changeVisibility(id, active, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Duplicate product. Receives name of copy(duplicate product). Returns UUID of new created product.
     * @param {string} id Id of product that\&#39;s going to be duplicate
     * @param {CreateDuplicateProductRequest} createDuplicateProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public createDuplicateProduct(id: string, createDuplicateProductRequest: CreateDuplicateProductRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).createDuplicateProduct(id, createDuplicateProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Product
     * @param {CreateProductRequest} createProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public createProduct(createProductRequest: CreateProductRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).createProduct(createProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Save information for new product video
     * @param {string} id Product Id
     * @param {CreateVideoRequest} createVideoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public createProductVideo(id: string, createVideoRequest: CreateVideoRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).createProductVideo(id, createVideoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create video url
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public createProductVideoUrl(id: string, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).createProductVideoUrl(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete products in bulk. Supply brand_id to delete all products for that brand, or supply product_ids to delete specific products.
     * @param {DeleteBulkProductRequest} deleteBulkProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public deleteBulkProduct(deleteBulkProductRequest: DeleteBulkProductRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).deleteBulkProduct(deleteBulkProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete draft product
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public deleteDraftProduct(id: string, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).deleteDraftProduct(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete product variant image
     * @param {string} variantId Product variant Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public deleteImageFromVariant(variantId: string, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).deleteImageFromVariant(variantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete product
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public deleteProduct(id: string, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).deleteProduct(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete product image
     * @param {string} imageId Image Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public deleteProductImage(imageId: string, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).deleteProductImage(imageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download csv template which should be filled with inventory information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public downloadInventoryCsvFile(options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).downloadInventoryCsvFile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk duplicate products
     * @param {BulkDuplicateProductsRequest} bulkDuplicateProductsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public duplicateBulkProducts(bulkDuplicateProductsRequest: BulkDuplicateProductsRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).duplicateBulkProducts(bulkDuplicateProductsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export products to csv file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public exportProductsToCsv(options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).exportProductsToCsv(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Favoritize product
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public favoritizeProduct(id: string, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).favoritizeProduct(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find products by search criteria
     * @param {FilterProductRequest} filterProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public filterProductsBySearchCriteria(filterProductRequest: FilterProductRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).filterProductsBySearchCriteria(filterProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find all draft products per brand
     * @param {string} brandId Brand Id
     * @param {number} page Page
     * @param {number} size Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public getAllDraftProductsForBrand(brandId: string, page: number, size: number, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).getAllDraftProductsForBrand(brandId, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get brand products count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public getBrandProductsCount(options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).getBrandProductsCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get draft products count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public getDraftProductsCount(options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).getDraftProductsCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user favorite products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public getFavoriteProducts(options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).getFavoriteProducts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user filtered favorite products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public getFilteredFavoriteProducts(options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).getFilteredFavoriteProducts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search all inventory levels by keyword with pagination
     * @param {number} page Page
     * @param {number} size Size
     * @param {string} order Order
     * @param {string} [keyword] Keyword
     * @param {boolean} [inStock] InStock
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public getInventoryLevels(page: number, size: number, order: string, keyword?: string, inStock?: boolean, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).getInventoryLevels(page, size, order, keyword, inStock, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get number of user favorite products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public getNumberOfFavoriteProducts(options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).getNumberOfFavoriteProducts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get product by Id
     * @param {string} id Product Id
     * @param {boolean} [checkAccess] Check if user can access product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public getProduct(id: string, checkAccess?: boolean, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).getProduct(id, checkAccess, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find all products per multiple/custom criteria
     * @param {string} [brandId] Brand Id
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {string} [order] Order
     * @param {string} [status] Status
     * @param {string} [categoryId] Category Id
     * @param {boolean} [createdByAdmin] Created by admin
     * @param {boolean} [active] Availability
     * @param {string} [name] Name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public getProducts(brandId?: string, page?: number, size?: number, order?: string, status?: string, categoryId?: string, createdByAdmin?: boolean, active?: boolean, name?: string, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).getProducts(brandId, page, size, order, status, categoryId, createdByAdmin, active, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find products by category Id
     * @param {string} categoryId Category Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public getProductsByCategory(categoryId: string, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).getProductsByCategory(categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find products by collection Id
     * @param {string} collectionId Collection Id
     * @param {number} [page] Page, if paginating the result
     * @param {number} [limit] max number of product ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public getProductsByCollection(collectionId: string, page?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).getProductsByCollection(collectionId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get filtered products
     * @param {string} productId Product Id
     * @param {string} brandId Brand Id
     * @param {number} productNumber Product number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public getProductsFiltered(productId: string, brandId: string, productNumber: number, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).getProductsFiltered(productId, brandId, productNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find all tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public getTags(options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).getTags(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import products from CSV file
     * @param {ImportProductsFromCsvRequest} [importProductsFromCsvRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public importProductsFromCsv(importProductsFromCsvRequest?: ImportProductsFromCsvRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).importProductsFromCsv(importProductsFromCsvRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import products from CSV file for Brands and Admins
     * @param {string} csvType CSV type
     * @param {string} brandId Brand Id
     * @param {boolean} [createDraft] Create draft products
     * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public importProductsFromCsvV2(csvType: string, brandId: string, createDraft?: boolean, linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).importProductsFromCsvV2(csvType, brandId, createDraft, linkRetailersWithTradeShowRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import products name, category and tags based on new navigation settings
     * @param {Array<ImportProductsNavigationRequest>} importProductsNavigationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public importProductsNavigation(importProductsNavigationRequest: Array<ImportProductsNavigationRequest>, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).importProductsNavigation(importProductsNavigationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set product active flag.
     * @param {string} id Id of product that\&#39;s going to be marked as active
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public markProductAsActive(id: string, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).markProductAsActive(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set product visible flag.
     * @param {string} id Id of product that\&#39;s going to be marked as visible
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public markProductAsVisible(id: string, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).markProductAsVisible(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Product as ProductBuilder
     * @param {ProductBuilderCreateProductRequest} productBuilderCreateProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public productBuilderCreateProduct(productBuilderCreateProductRequest: ProductBuilderCreateProductRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).productBuilderCreateProduct(productBuilderCreateProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update product as ProductBuilder
     * @param {string} id Product Id
     * @param {ProductBuilderUpdateProductRequest} productBuilderUpdateProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public productBuilderUpdateProduct(id: string, productBuilderUpdateProductRequest: ProductBuilderUpdateProductRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).productBuilderUpdateProduct(id, productBuilderUpdateProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pull products from Algolia without an image
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public pullProductsWithoutImageFromAlgolia(options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).pullProductsWithoutImageFromAlgolia(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reject product
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public rejectProduct(id: string, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).rejectProduct(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * send draft product reminder email
     * @param {string} brandId Brand ID
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public sendDraftProductReminder(brandId: string, body: string, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).sendDraftProductReminder(brandId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update inventory tracking data from CSV file
     * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public updateInventoryTrackingFromCsv(linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).updateInventoryTrackingFromCsv(linkRetailersWithTradeShowRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update product
     * @param {string} id Product Id
     * @param {UpdateProductRequest} updateProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public updateProduct(id: string, updateProductRequest: UpdateProductRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).updateProduct(id, updateProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public updateProductCategories(linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).updateProductCategories(linkRetailersWithTradeShowRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update product image crop info
     * @param {string} productId Product Id
     * @param {string} imageId Image Id
     * @param {UpdateProductImageCropInfoRequest} updateProductImageCropInfoRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public updateProductImageCropInfo(productId: string, imageId: string, updateProductImageCropInfoRequest: UpdateProductImageCropInfoRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).updateProductImageCropInfo(productId, imageId, updateProductImageCropInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update product inventory level
     * @param {string} id Product Id
     * @param {UpdateProductInventoryLevelRequest} updateProductInventoryLevelRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public updateProductInventoryLevel(id: string, updateProductInventoryLevelRequest: UpdateProductInventoryLevelRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).updateProductInventoryLevel(id, updateProductInventoryLevelRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update products inventory levels
     * @param {UpdateProductsInventoryLevelsRequest} updateProductsInventoryLevelsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public updateProductsInventoryLevels(updateProductsInventoryLevelsRequest: UpdateProductsInventoryLevelsRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).updateProductsInventoryLevels(updateProductsInventoryLevelsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload product image
     * @param {string} id Product Id
     * @param {number} ordinal Image ordinal 
     * @param {boolean} isCustomAssortment Custom Assortment flag
     * @param {UploadProductImageRequest} uploadProductImageRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public uploadProductImage(id: string, ordinal: number, isCustomAssortment: boolean, uploadProductImageRequest: UploadProductImageRequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).uploadProductImage(id, ordinal, isCustomAssortment, uploadProductImageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate variant\'s SKU
     * @param {ValidateSKURequest} validateSKURequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductControllerApi
     */
    public validateSKU(validateSKURequest: ValidateSKURequest, options?: RawAxiosRequestConfig) {
        return ProductControllerApiFp(this.configuration).validateSKU(validateSKURequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PromoCodeControllerApi - axios parameter creator
 * @export
 */
export const PromoCodeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create Promo code
         * @param {CreatePromoCodeRequest} createPromoCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPromoCode: async (createPromoCodeRequest: CreatePromoCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPromoCodeRequest' is not null or undefined
            assertParamExists('createPromoCode', 'createPromoCodeRequest', createPromoCodeRequest)
            const localVarPath = `/promo-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPromoCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete Promo code
         * @param {string} code Promo code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePromoCode: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('deletePromoCode', 'code', code)
            const localVarPath = `/promo-codes/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all brands which created promo codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandsWithPromoCodes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/promo-codes/brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find Promo Code by Id
         * @param {string} id Promo code id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromoCode: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPromoCode', 'id', id)
            const localVarPath = `/promo-codes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all promo code statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromoCodeStatuses: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/promo-codes/statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search all promo codes by keyword with pagination
         * @param {string} keyword Keyword
         * @param {number} page Page
         * @param {number} size Size
         * @param {string} status Status
         * @param {string} brandId Brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromoCodes: async (keyword: string, page: number, size: number, status: string, brandId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyword' is not null or undefined
            assertParamExists('getPromoCodes', 'keyword', keyword)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getPromoCodes', 'page', page)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('getPromoCodes', 'size', size)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('getPromoCodes', 'status', status)
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getPromoCodes', 'brandId', brandId)
            const localVarPath = `/promo-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (brandId !== undefined) {
                localVarQueryParameter['brand_id'] = brandId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Publish promo code
         * @param {string} id Promo code id
         * @param {BrandPublishPromoCodeRequest} brandPublishPromoCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishPromoCode: async (id: string, brandPublishPromoCodeRequest: BrandPublishPromoCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('publishPromoCode', 'id', id)
            // verify required parameter 'brandPublishPromoCodeRequest' is not null or undefined
            assertParamExists('publishPromoCode', 'brandPublishPromoCodeRequest', brandPublishPromoCodeRequest)
            const localVarPath = `/promo-codes/{id}/publish`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(brandPublishPromoCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update promo code
         * @param {string} id Promo code id
         * @param {UpdatePromoCodeRequest} updatePromoCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromoCode: async (id: string, updatePromoCodeRequest: UpdatePromoCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePromoCode', 'id', id)
            // verify required parameter 'updatePromoCodeRequest' is not null or undefined
            assertParamExists('updatePromoCode', 'updatePromoCodeRequest', updatePromoCodeRequest)
            const localVarPath = `/promo-codes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePromoCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PromoCodeControllerApi - functional programming interface
 * @export
 */
export const PromoCodeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PromoCodeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Create Promo code
         * @param {CreatePromoCodeRequest} createPromoCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPromoCode(createPromoCodeRequest: CreatePromoCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromoCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPromoCode(createPromoCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodeControllerApi.createPromoCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete Promo code
         * @param {string} code Promo code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePromoCode(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePromoCode(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodeControllerApi.deletePromoCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all brands which created promo codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandsWithPromoCodes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetBrandsWithPromoCodesResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandsWithPromoCodes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodeControllerApi.getBrandsWithPromoCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find Promo Code by Id
         * @param {string} id Promo code id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromoCode(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromoCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromoCode(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodeControllerApi.getPromoCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all promo code statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromoCodeStatuses(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEnumOptionsResponsePromoCodeStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromoCodeStatuses(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodeControllerApi.getPromoCodeStatuses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search all promo codes by keyword with pagination
         * @param {string} keyword Keyword
         * @param {number} page Page
         * @param {number} size Size
         * @param {string} status Status
         * @param {string} brandId Brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromoCodes(keyword: string, page: number, size: number, status: string, brandId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromoCodesWithPaginationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromoCodes(keyword, page, size, status, brandId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodeControllerApi.getPromoCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Publish promo code
         * @param {string} id Promo code id
         * @param {BrandPublishPromoCodeRequest} brandPublishPromoCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishPromoCode(id: string, brandPublishPromoCodeRequest: BrandPublishPromoCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishPromoCode(id, brandPublishPromoCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodeControllerApi.publishPromoCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update promo code
         * @param {string} id Promo code id
         * @param {UpdatePromoCodeRequest} updatePromoCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePromoCode(id: string, updatePromoCodeRequest: UpdatePromoCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePromoCode(id, updatePromoCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromoCodeControllerApi.updatePromoCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PromoCodeControllerApi - factory interface
 * @export
 */
export const PromoCodeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PromoCodeControllerApiFp(configuration)
    return {
        /**
         * Create Promo code
         * @param {CreatePromoCodeRequest} createPromoCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPromoCode(createPromoCodeRequest: CreatePromoCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<PromoCodeResponse> {
            return localVarFp.createPromoCode(createPromoCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete Promo code
         * @param {string} code Promo code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePromoCode(code: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePromoCode(code, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all brands which created promo codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandsWithPromoCodes(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetBrandsWithPromoCodesResponse>> {
            return localVarFp.getBrandsWithPromoCodes(options).then((request) => request(axios, basePath));
        },
        /**
         * Find Promo Code by Id
         * @param {string} id Promo code id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromoCode(id: string, options?: RawAxiosRequestConfig): AxiosPromise<PromoCodeResponse> {
            return localVarFp.getPromoCode(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all promo code statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromoCodeStatuses(options?: RawAxiosRequestConfig): AxiosPromise<GetEnumOptionsResponsePromoCodeStatus> {
            return localVarFp.getPromoCodeStatuses(options).then((request) => request(axios, basePath));
        },
        /**
         * Search all promo codes by keyword with pagination
         * @param {string} keyword Keyword
         * @param {number} page Page
         * @param {number} size Size
         * @param {string} status Status
         * @param {string} brandId Brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromoCodes(keyword: string, page: number, size: number, status: string, brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<PromoCodesWithPaginationResponse> {
            return localVarFp.getPromoCodes(keyword, page, size, status, brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Publish promo code
         * @param {string} id Promo code id
         * @param {BrandPublishPromoCodeRequest} brandPublishPromoCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishPromoCode(id: string, brandPublishPromoCodeRequest: BrandPublishPromoCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.publishPromoCode(id, brandPublishPromoCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update promo code
         * @param {string} id Promo code id
         * @param {UpdatePromoCodeRequest} updatePromoCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromoCode(id: string, updatePromoCodeRequest: UpdatePromoCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePromoCode(id, updatePromoCodeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PromoCodeControllerApi - interface
 * @export
 * @interface PromoCodeControllerApi
 */
export interface PromoCodeControllerApiInterface {
    /**
     * Create Promo code
     * @param {CreatePromoCodeRequest} createPromoCodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeControllerApiInterface
     */
    createPromoCode(createPromoCodeRequest: CreatePromoCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<PromoCodeResponse>;

    /**
     * Delete Promo code
     * @param {string} code Promo code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeControllerApiInterface
     */
    deletePromoCode(code: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Get all brands which created promo codes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeControllerApiInterface
     */
    getBrandsWithPromoCodes(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetBrandsWithPromoCodesResponse>>;

    /**
     * Find Promo Code by Id
     * @param {string} id Promo code id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeControllerApiInterface
     */
    getPromoCode(id: string, options?: RawAxiosRequestConfig): AxiosPromise<PromoCodeResponse>;

    /**
     * Get all promo code statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeControllerApiInterface
     */
    getPromoCodeStatuses(options?: RawAxiosRequestConfig): AxiosPromise<GetEnumOptionsResponsePromoCodeStatus>;

    /**
     * Search all promo codes by keyword with pagination
     * @param {string} keyword Keyword
     * @param {number} page Page
     * @param {number} size Size
     * @param {string} status Status
     * @param {string} brandId Brand
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeControllerApiInterface
     */
    getPromoCodes(keyword: string, page: number, size: number, status: string, brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<PromoCodesWithPaginationResponse>;

    /**
     * Publish promo code
     * @param {string} id Promo code id
     * @param {BrandPublishPromoCodeRequest} brandPublishPromoCodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeControllerApiInterface
     */
    publishPromoCode(id: string, brandPublishPromoCodeRequest: BrandPublishPromoCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update promo code
     * @param {string} id Promo code id
     * @param {UpdatePromoCodeRequest} updatePromoCodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeControllerApiInterface
     */
    updatePromoCode(id: string, updatePromoCodeRequest: UpdatePromoCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * PromoCodeControllerApi - object-oriented interface
 * @export
 * @class PromoCodeControllerApi
 * @extends {BaseAPI}
 */
export class PromoCodeControllerApi extends BaseAPI implements PromoCodeControllerApiInterface {
    /**
     * Create Promo code
     * @param {CreatePromoCodeRequest} createPromoCodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeControllerApi
     */
    public createPromoCode(createPromoCodeRequest: CreatePromoCodeRequest, options?: RawAxiosRequestConfig) {
        return PromoCodeControllerApiFp(this.configuration).createPromoCode(createPromoCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete Promo code
     * @param {string} code Promo code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeControllerApi
     */
    public deletePromoCode(code: string, options?: RawAxiosRequestConfig) {
        return PromoCodeControllerApiFp(this.configuration).deletePromoCode(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all brands which created promo codes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeControllerApi
     */
    public getBrandsWithPromoCodes(options?: RawAxiosRequestConfig) {
        return PromoCodeControllerApiFp(this.configuration).getBrandsWithPromoCodes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find Promo Code by Id
     * @param {string} id Promo code id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeControllerApi
     */
    public getPromoCode(id: string, options?: RawAxiosRequestConfig) {
        return PromoCodeControllerApiFp(this.configuration).getPromoCode(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all promo code statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeControllerApi
     */
    public getPromoCodeStatuses(options?: RawAxiosRequestConfig) {
        return PromoCodeControllerApiFp(this.configuration).getPromoCodeStatuses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search all promo codes by keyword with pagination
     * @param {string} keyword Keyword
     * @param {number} page Page
     * @param {number} size Size
     * @param {string} status Status
     * @param {string} brandId Brand
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeControllerApi
     */
    public getPromoCodes(keyword: string, page: number, size: number, status: string, brandId: string, options?: RawAxiosRequestConfig) {
        return PromoCodeControllerApiFp(this.configuration).getPromoCodes(keyword, page, size, status, brandId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Publish promo code
     * @param {string} id Promo code id
     * @param {BrandPublishPromoCodeRequest} brandPublishPromoCodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeControllerApi
     */
    public publishPromoCode(id: string, brandPublishPromoCodeRequest: BrandPublishPromoCodeRequest, options?: RawAxiosRequestConfig) {
        return PromoCodeControllerApiFp(this.configuration).publishPromoCode(id, brandPublishPromoCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update promo code
     * @param {string} id Promo code id
     * @param {UpdatePromoCodeRequest} updatePromoCodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodeControllerApi
     */
    public updatePromoCode(id: string, updatePromoCodeRequest: UpdatePromoCodeRequest, options?: RawAxiosRequestConfig) {
        return PromoCodeControllerApiFp(this.configuration).updatePromoCode(id, updatePromoCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RecommendationControllerApi - axios parameter creator
 * @export
 */
export const RecommendationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve a list of admin recommended brands
         * @param {string} retailerId Retailer Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecommendedBrands: async (retailerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'retailerId' is not null or undefined
            assertParamExists('getRecommendedBrands', 'retailerId', retailerId)
            const localVarPath = `/recommendations/retailer/{retailerId}/brands`
                .replace(`{${"retailerId"}}`, encodeURIComponent(String(retailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return number of unloaded recommendations from retailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnloadedRecommendationsCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/recommendations/new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark retailer\'s recommendations as read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markRecommendationsAsRead: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/recommendations/mark-as-read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recommend brands
         * @param {CreateRecommendationRequest} createRecommendationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendBrands: async (createRecommendationRequest: CreateRecommendationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRecommendationRequest' is not null or undefined
            assertParamExists('recommendBrands', 'createRecommendationRequest', createRecommendationRequest)
            const localVarPath = `/recommendations/recommend_brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRecommendationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RecommendationControllerApi - functional programming interface
 * @export
 */
export const RecommendationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RecommendationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve a list of admin recommended brands
         * @param {string} retailerId Retailer Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecommendedBrands(retailerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecommendedBrandsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecommendedBrands(retailerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationControllerApi.getRecommendedBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return number of unloaded recommendations from retailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnloadedRecommendationsCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecommendationsCountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnloadedRecommendationsCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationControllerApi.getUnloadedRecommendationsCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark retailer\'s recommendations as read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markRecommendationsAsRead(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markRecommendationsAsRead(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationControllerApi.markRecommendationsAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Recommend brands
         * @param {CreateRecommendationRequest} createRecommendationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recommendBrands(createRecommendationRequest: CreateRecommendationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recommendBrands(createRecommendationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationControllerApi.recommendBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RecommendationControllerApi - factory interface
 * @export
 */
export const RecommendationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RecommendationControllerApiFp(configuration)
    return {
        /**
         * Retrieve a list of admin recommended brands
         * @param {string} retailerId Retailer Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecommendedBrands(retailerId: string, options?: RawAxiosRequestConfig): AxiosPromise<RecommendedBrandsResponse> {
            return localVarFp.getRecommendedBrands(retailerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return number of unloaded recommendations from retailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnloadedRecommendationsCount(options?: RawAxiosRequestConfig): AxiosPromise<RecommendationsCountResponse> {
            return localVarFp.getUnloadedRecommendationsCount(options).then((request) => request(axios, basePath));
        },
        /**
         * Mark retailer\'s recommendations as read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markRecommendationsAsRead(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markRecommendationsAsRead(options).then((request) => request(axios, basePath));
        },
        /**
         * Recommend brands
         * @param {CreateRecommendationRequest} createRecommendationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendBrands(createRecommendationRequest: CreateRecommendationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.recommendBrands(createRecommendationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RecommendationControllerApi - interface
 * @export
 * @interface RecommendationControllerApi
 */
export interface RecommendationControllerApiInterface {
    /**
     * Retrieve a list of admin recommended brands
     * @param {string} retailerId Retailer Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationControllerApiInterface
     */
    getRecommendedBrands(retailerId: string, options?: RawAxiosRequestConfig): AxiosPromise<RecommendedBrandsResponse>;

    /**
     * Return number of unloaded recommendations from retailer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationControllerApiInterface
     */
    getUnloadedRecommendationsCount(options?: RawAxiosRequestConfig): AxiosPromise<RecommendationsCountResponse>;

    /**
     * Mark retailer\'s recommendations as read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationControllerApiInterface
     */
    markRecommendationsAsRead(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Recommend brands
     * @param {CreateRecommendationRequest} createRecommendationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationControllerApiInterface
     */
    recommendBrands(createRecommendationRequest: CreateRecommendationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RecommendationControllerApi - object-oriented interface
 * @export
 * @class RecommendationControllerApi
 * @extends {BaseAPI}
 */
export class RecommendationControllerApi extends BaseAPI implements RecommendationControllerApiInterface {
    /**
     * Retrieve a list of admin recommended brands
     * @param {string} retailerId Retailer Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationControllerApi
     */
    public getRecommendedBrands(retailerId: string, options?: RawAxiosRequestConfig) {
        return RecommendationControllerApiFp(this.configuration).getRecommendedBrands(retailerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return number of unloaded recommendations from retailer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationControllerApi
     */
    public getUnloadedRecommendationsCount(options?: RawAxiosRequestConfig) {
        return RecommendationControllerApiFp(this.configuration).getUnloadedRecommendationsCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark retailer\'s recommendations as read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationControllerApi
     */
    public markRecommendationsAsRead(options?: RawAxiosRequestConfig) {
        return RecommendationControllerApiFp(this.configuration).markRecommendationsAsRead(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recommend brands
     * @param {CreateRecommendationRequest} createRecommendationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationControllerApi
     */
    public recommendBrands(createRecommendationRequest: CreateRecommendationRequest, options?: RawAxiosRequestConfig) {
        return RecommendationControllerApiFp(this.configuration).recommendBrands(createRecommendationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReferralControllerApi - axios parameter creator
 * @export
 */
export const ReferralControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add new referrals to database
         * @param {Array<AddNewReferralsRequest>} addNewReferralsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNewReferrals: async (addNewReferralsRequest: Array<AddNewReferralsRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addNewReferralsRequest' is not null or undefined
            assertParamExists('addNewReferrals', 'addNewReferralsRequest', addNewReferralsRequest)
            const localVarPath = `/referrals/new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addNewReferralsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create referrals
         * @param {CreateReferralsRequest} createReferralsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReferrals: async (createReferralsRequest: CreateReferralsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createReferralsRequest' is not null or undefined
            assertParamExists('createReferrals', 'createReferralsRequest', createReferralsRequest)
            const localVarPath = `/referrals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReferralsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download csv template which should be filled with referral emails
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCsvFile: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/referrals/download-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find Referral by Id
         * @param {string} id Referral Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferral: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getReferral', 'id', id)
            const localVarPath = `/referrals/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get referral link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralLink: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/referrals/link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find all referrals per multiple/custom criteria
         * @param {string} [brandId] Brand Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [search] Search by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferrals: async (brandId?: string, page?: number, size?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/referrals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (brandId !== undefined) {
                localVarQueryParameter['brandId'] = brandId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find all referrals by brand
         * @param {string} brandId Brand Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [search] Search by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralsByBrandId: async (brandId: string, page?: number, size?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getReferralsByBrandId', 'brandId', brandId)
            const localVarPath = `/referrals/brands/{brandId}`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import referrals from csv to database.Receives html file and csv file. Returns array of invalid referral emails.
         * @param {ImportReferralsFromCSVRequest} [importReferralsFromCSVRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importReferralsFromCSV: async (importReferralsFromCSVRequest?: ImportReferralsFromCSVRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/referrals/import-from-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importReferralsFromCSVRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send referral completeness email
         * @param {string} id 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReferralCompletenessEmail: async (id: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sendReferralCompletenessEmail', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('sendReferralCompletenessEmail', 'body', body)
            const localVarPath = `/referrals/{id}/send-referral-completeness-email`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change referral completeness
         * @param {string} id Referral Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleReferralCompleteness: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('toggleReferralCompleteness', 'id', id)
            const localVarPath = `/referrals/{id}/toggle-complete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReferralControllerApi - functional programming interface
 * @export
 */
export const ReferralControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReferralControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add new referrals to database
         * @param {Array<AddNewReferralsRequest>} addNewReferralsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addNewReferrals(addNewReferralsRequest: Array<AddNewReferralsRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddNewReferralsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addNewReferrals(addNewReferralsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralControllerApi.addNewReferrals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create referrals
         * @param {CreateReferralsRequest} createReferralsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReferrals(createReferralsRequest: CreateReferralsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateReferralsByEmailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReferrals(createReferralsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralControllerApi.createReferrals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download csv template which should be filled with referral emails
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadCsvFile(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadCsvFile(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralControllerApi.downloadCsvFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find Referral by Id
         * @param {string} id Referral Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferral(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferralResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferral(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralControllerApi.getReferral']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get referral link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferralLink(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferralLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferralLink(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralControllerApi.getReferralLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find all referrals per multiple/custom criteria
         * @param {string} [brandId] Brand Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [search] Search by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferrals(brandId?: string, page?: number, size?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedRefferalsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferrals(brandId, page, size, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralControllerApi.getReferrals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find all referrals by brand
         * @param {string} brandId Brand Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [search] Search by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferralsByBrandId(brandId: string, page?: number, size?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedRefferalsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferralsByBrandId(brandId, page, size, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralControllerApi.getReferralsByBrandId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import referrals from csv to database.Receives html file and csv file. Returns array of invalid referral emails.
         * @param {ImportReferralsFromCSVRequest} [importReferralsFromCSVRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importReferralsFromCSV(importReferralsFromCSVRequest?: ImportReferralsFromCSVRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateReferralsByEmailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importReferralsFromCSV(importReferralsFromCSVRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralControllerApi.importReferralsFromCSV']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send referral completeness email
         * @param {string} id 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendReferralCompletenessEmail(id: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendReferralCompletenessEmail(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralControllerApi.sendReferralCompletenessEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change referral completeness
         * @param {string} id Referral Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleReferralCompleteness(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleReferralCompleteness(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralControllerApi.toggleReferralCompleteness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReferralControllerApi - factory interface
 * @export
 */
export const ReferralControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReferralControllerApiFp(configuration)
    return {
        /**
         * Add new referrals to database
         * @param {Array<AddNewReferralsRequest>} addNewReferralsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNewReferrals(addNewReferralsRequest: Array<AddNewReferralsRequest>, options?: RawAxiosRequestConfig): AxiosPromise<AddNewReferralsResponse> {
            return localVarFp.addNewReferrals(addNewReferralsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create referrals
         * @param {CreateReferralsRequest} createReferralsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReferrals(createReferralsRequest: CreateReferralsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateReferralsByEmailsResponse> {
            return localVarFp.createReferrals(createReferralsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Download csv template which should be filled with referral emails
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCsvFile(options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadCsvFile(options).then((request) => request(axios, basePath));
        },
        /**
         * Find Referral by Id
         * @param {string} id Referral Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferral(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ReferralResponse> {
            return localVarFp.getReferral(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get referral link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralLink(options?: RawAxiosRequestConfig): AxiosPromise<ReferralLinkResponse> {
            return localVarFp.getReferralLink(options).then((request) => request(axios, basePath));
        },
        /**
         * Find all referrals per multiple/custom criteria
         * @param {string} [brandId] Brand Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [search] Search by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferrals(brandId?: string, page?: number, size?: number, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedRefferalsResponse> {
            return localVarFp.getReferrals(brandId, page, size, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Find all referrals by brand
         * @param {string} brandId Brand Id
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {string} [search] Search by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralsByBrandId(brandId: string, page?: number, size?: number, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedRefferalsResponse> {
            return localVarFp.getReferralsByBrandId(brandId, page, size, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Import referrals from csv to database.Receives html file and csv file. Returns array of invalid referral emails.
         * @param {ImportReferralsFromCSVRequest} [importReferralsFromCSVRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importReferralsFromCSV(importReferralsFromCSVRequest?: ImportReferralsFromCSVRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateReferralsByEmailsResponse> {
            return localVarFp.importReferralsFromCSV(importReferralsFromCSVRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Send referral completeness email
         * @param {string} id 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReferralCompletenessEmail(id: string, body: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendReferralCompletenessEmail(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Change referral completeness
         * @param {string} id Referral Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleReferralCompleteness(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.toggleReferralCompleteness(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReferralControllerApi - interface
 * @export
 * @interface ReferralControllerApi
 */
export interface ReferralControllerApiInterface {
    /**
     * Add new referrals to database
     * @param {Array<AddNewReferralsRequest>} addNewReferralsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApiInterface
     */
    addNewReferrals(addNewReferralsRequest: Array<AddNewReferralsRequest>, options?: RawAxiosRequestConfig): AxiosPromise<AddNewReferralsResponse>;

    /**
     * Create referrals
     * @param {CreateReferralsRequest} createReferralsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApiInterface
     */
    createReferrals(createReferralsRequest: CreateReferralsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateReferralsByEmailsResponse>;

    /**
     * Download csv template which should be filled with referral emails
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApiInterface
     */
    downloadCsvFile(options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * Find Referral by Id
     * @param {string} id Referral Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApiInterface
     */
    getReferral(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ReferralResponse>;

    /**
     * Get referral link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApiInterface
     */
    getReferralLink(options?: RawAxiosRequestConfig): AxiosPromise<ReferralLinkResponse>;

    /**
     * Find all referrals per multiple/custom criteria
     * @param {string} [brandId] Brand Id
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {string} [search] Search by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApiInterface
     */
    getReferrals(brandId?: string, page?: number, size?: number, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedRefferalsResponse>;

    /**
     * Find all referrals by brand
     * @param {string} brandId Brand Id
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {string} [search] Search by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApiInterface
     */
    getReferralsByBrandId(brandId: string, page?: number, size?: number, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedRefferalsResponse>;

    /**
     * Import referrals from csv to database.Receives html file and csv file. Returns array of invalid referral emails.
     * @param {ImportReferralsFromCSVRequest} [importReferralsFromCSVRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApiInterface
     */
    importReferralsFromCSV(importReferralsFromCSVRequest?: ImportReferralsFromCSVRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateReferralsByEmailsResponse>;

    /**
     * Send referral completeness email
     * @param {string} id 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApiInterface
     */
    sendReferralCompletenessEmail(id: string, body: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Change referral completeness
     * @param {string} id Referral Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApiInterface
     */
    toggleReferralCompleteness(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ReferralControllerApi - object-oriented interface
 * @export
 * @class ReferralControllerApi
 * @extends {BaseAPI}
 */
export class ReferralControllerApi extends BaseAPI implements ReferralControllerApiInterface {
    /**
     * Add new referrals to database
     * @param {Array<AddNewReferralsRequest>} addNewReferralsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApi
     */
    public addNewReferrals(addNewReferralsRequest: Array<AddNewReferralsRequest>, options?: RawAxiosRequestConfig) {
        return ReferralControllerApiFp(this.configuration).addNewReferrals(addNewReferralsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create referrals
     * @param {CreateReferralsRequest} createReferralsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApi
     */
    public createReferrals(createReferralsRequest: CreateReferralsRequest, options?: RawAxiosRequestConfig) {
        return ReferralControllerApiFp(this.configuration).createReferrals(createReferralsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download csv template which should be filled with referral emails
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApi
     */
    public downloadCsvFile(options?: RawAxiosRequestConfig) {
        return ReferralControllerApiFp(this.configuration).downloadCsvFile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find Referral by Id
     * @param {string} id Referral Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApi
     */
    public getReferral(id: string, options?: RawAxiosRequestConfig) {
        return ReferralControllerApiFp(this.configuration).getReferral(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get referral link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApi
     */
    public getReferralLink(options?: RawAxiosRequestConfig) {
        return ReferralControllerApiFp(this.configuration).getReferralLink(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find all referrals per multiple/custom criteria
     * @param {string} [brandId] Brand Id
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {string} [search] Search by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApi
     */
    public getReferrals(brandId?: string, page?: number, size?: number, search?: string, options?: RawAxiosRequestConfig) {
        return ReferralControllerApiFp(this.configuration).getReferrals(brandId, page, size, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find all referrals by brand
     * @param {string} brandId Brand Id
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {string} [search] Search by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApi
     */
    public getReferralsByBrandId(brandId: string, page?: number, size?: number, search?: string, options?: RawAxiosRequestConfig) {
        return ReferralControllerApiFp(this.configuration).getReferralsByBrandId(brandId, page, size, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import referrals from csv to database.Receives html file and csv file. Returns array of invalid referral emails.
     * @param {ImportReferralsFromCSVRequest} [importReferralsFromCSVRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApi
     */
    public importReferralsFromCSV(importReferralsFromCSVRequest?: ImportReferralsFromCSVRequest, options?: RawAxiosRequestConfig) {
        return ReferralControllerApiFp(this.configuration).importReferralsFromCSV(importReferralsFromCSVRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send referral completeness email
     * @param {string} id 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApi
     */
    public sendReferralCompletenessEmail(id: string, body: string, options?: RawAxiosRequestConfig) {
        return ReferralControllerApiFp(this.configuration).sendReferralCompletenessEmail(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change referral completeness
     * @param {string} id Referral Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralControllerApi
     */
    public toggleReferralCompleteness(id: string, options?: RawAxiosRequestConfig) {
        return ReferralControllerApiFp(this.configuration).toggleReferralCompleteness(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RetailerControllerApi - axios parameter creator
 * @export
 */
export const RetailerControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Approve retailer by admin
         * @param {string} retailerId Retailer ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminApproveRetailer: async (retailerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'retailerId' is not null or undefined
            assertParamExists('adminApproveRetailer', 'retailerId', retailerId)
            const localVarPath = `/retailers/{retailerId}/approve`
                .replace(`{${"retailerId"}}`, encodeURIComponent(String(retailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Decline retailer by admin
         * @param {string} retailerId Retailer ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeclineRetailer: async (retailerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'retailerId' is not null or undefined
            assertParamExists('adminDeclineRetailer', 'retailerId', retailerId)
            const localVarPath = `/retailers/{retailerId}/decline`
                .replace(`{${"retailerId"}}`, encodeURIComponent(String(retailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Apply to buy
         * @param {ApplyToBuyRequest} applyToBuyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyToBuy: async (applyToBuyRequest: ApplyToBuyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applyToBuyRequest' is not null or undefined
            assertParamExists('applyToBuy', 'applyToBuyRequest', applyToBuyRequest)
            const localVarPath = `/retailers/apply-to-buy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applyToBuyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new Retailer using HubSpot form
         * @param {HubSpotRetailerSignUpRequest} hubSpotRetailerSignUpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewHubSpotRetailer: async (hubSpotRetailerSignUpRequest: HubSpotRetailerSignUpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hubSpotRetailerSignUpRequest' is not null or undefined
            assertParamExists('createNewHubSpotRetailer', 'hubSpotRetailerSignUpRequest', hubSpotRetailerSignUpRequest)
            const localVarPath = `/retailers/hub-spot/new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hubSpotRetailerSignUpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete retailer
         * @param {string} id Retailer Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRetailer: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteRetailer', 'id', id)
            const localVarPath = `/retailers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find retailer address
         * @param {boolean} [shipping] 
         * @param {boolean} [billing] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddresses: async (shipping?: boolean, billing?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/retailers/addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (shipping !== undefined) {
                localVarQueryParameter['shipping'] = shipping;
            }

            if (billing !== undefined) {
                localVarQueryParameter['billing'] = billing;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all balance levels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalanceLevels: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/retailers/balance-levels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get retailer\'s billing addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingAddresses: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/retailers/addresses/billing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all options for how did you hear for us on retailer sign up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInformedFromOptions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/retailers/informed-from-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get retailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/retailers/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find retailer Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyId: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/retailers/my-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get retailer\'s purchased brands
         * @param {string} id Retailer\&#39;s id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchasedBrands: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPurchasedBrands', 'id', id)
            const localVarPath = `/retailers/{id}/purchased-brands`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get retailer
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailer1: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRetailer1', 'id', id)
            const localVarPath = `/retailers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get count of retailer\'s orders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailerCountOfOrders: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/retailers/orders-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtain Retailer\'s saved credit cards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailerCreditCards: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/retailers/credit-cards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtain Retailer\'s saved credit cards by Id
         * @param {string} id Retailer\&#39;s id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailerCreditCardsById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRetailerCreditCardsById', 'id', id)
            const localVarPath = `/retailers/{id}/credit-cards`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get retailer info by user id
         * @param {string} id User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailerInfoByUserId: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRetailerInfoByUserId', 'id', id)
            const localVarPath = `/retailers/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all retailer statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailerStatuses: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/retailers/statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all balance levels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailerStoreTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/retailers/store-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get retailer balance
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailerUsedBalance: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRetailerUsedBalance', 'id', id)
            const localVarPath = `/retailers/balance/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all retailer values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailerValues: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/retailers/values/dropdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find all Retailer applicants per multiple/custom criteria
         * @param {string} [searchBy] Search by
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailersApplications: async (searchBy?: string, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/retailers/applications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchBy !== undefined) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find all Retailer applicants per multiple/custom criteria
         * @param {string} [searchBy] Search by
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailersDirectory: async (searchBy?: string, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/retailers/directory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchBy !== undefined) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get retailers for dropdown
         * @param {string} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailersDropdown: async (ifNoneMatch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/retailers/dropdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (ifNoneMatch != null) {
                localVarHeaderParameter['If-None-Match'] = String(ifNoneMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get retailers with a balance greater than zero.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailersWithBalance: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/retailers/balance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtain Retailer\'s Stripe Customer Id token. This api will return null if token is not yet created.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripeCustomerId: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/retailers/stripe-customer-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resends verification mail to given retailer
         * @param {string} id Retailer\&#39;s id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendVerificationMail: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resendVerificationMail', 'id', id)
            const localVarPath = `/retailers/{id}/resend-verification-mail`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retailer can request a review for pending verification from the Bulletin Verification Team.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendVerificationEmailForUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/retailers/me/send-verification-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send verification emails to retailers from given countries
         * @param {SendVerificationEmailsRequest} sendVerificationEmailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendVerificationEmailsToRetailersByCountries: async (sendVerificationEmailsRequest: SendVerificationEmailsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendVerificationEmailsRequest' is not null or undefined
            assertParamExists('sendVerificationEmailsToRetailersByCountries', 'sendVerificationEmailsRequest', sendVerificationEmailsRequest)
            const localVarPath = `/retailers/send-verification-emails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendVerificationEmailsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update retailer account by user id
         * @param {UpdateRetailerAccountRequest} updateRetailerAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyAccount: async (updateRetailerAccountRequest: UpdateRetailerAccountRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateRetailerAccountRequest' is not null or undefined
            assertParamExists('updateMyAccount', 'updateRetailerAccountRequest', updateRetailerAccountRequest)
            const localVarPath = `/retailers/me/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRetailerAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update retailer account
         * @param {string} id Retailer Id
         * @param {UpdateRetailerAccountRequest} updateRetailerAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRetailerAccount: async (id: string, updateRetailerAccountRequest: UpdateRetailerAccountRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateRetailerAccount', 'id', id)
            // verify required parameter 'updateRetailerAccountRequest' is not null or undefined
            assertParamExists('updateRetailerAccount', 'updateRetailerAccountRequest', updateRetailerAccountRequest)
            const localVarPath = `/retailers/{id}/account`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRetailerAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update retailer status - ACTIVE, SUSPENDED, BANNED
         * @param {string} retailerId 
         * @param {UpdateRetailerStatusRequest} updateRetailerStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRetailerStatus: async (retailerId: string, updateRetailerStatusRequest: UpdateRetailerStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'retailerId' is not null or undefined
            assertParamExists('updateRetailerStatus', 'retailerId', retailerId)
            // verify required parameter 'updateRetailerStatusRequest' is not null or undefined
            assertParamExists('updateRetailerStatus', 'updateRetailerStatusRequest', updateRetailerStatusRequest)
            const localVarPath = `/retailers/{retailerId}/status`
                .replace(`{${"retailerId"}}`, encodeURIComponent(String(retailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRetailerStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload retailer\'s thumbnail image
         * @param {UploadRetailerThumbnailImageRequest} [uploadRetailerThumbnailImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadRetailerThumbnailImage: async (uploadRetailerThumbnailImageRequest?: UploadRetailerThumbnailImageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/retailers/thumbnail-image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadRetailerThumbnailImageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RetailerControllerApi - functional programming interface
 * @export
 */
export const RetailerControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RetailerControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Approve retailer by admin
         * @param {string} retailerId Retailer ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminApproveRetailer(retailerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminApproveRetailer(retailerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.adminApproveRetailer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Decline retailer by admin
         * @param {string} retailerId Retailer ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeclineRetailer(retailerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeclineRetailer(retailerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.adminDeclineRetailer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Apply to buy
         * @param {ApplyToBuyRequest} applyToBuyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyToBuy(applyToBuyRequest: ApplyToBuyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplyToBuyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyToBuy(applyToBuyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.applyToBuy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new Retailer using HubSpot form
         * @param {HubSpotRetailerSignUpRequest} hubSpotRetailerSignUpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNewHubSpotRetailer(hubSpotRetailerSignUpRequest: HubSpotRetailerSignUpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNewHubSpotRetailer(hubSpotRetailerSignUpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.createNewHubSpotRetailer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete retailer
         * @param {string} id Retailer Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRetailer(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRetailer(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.deleteRetailer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find retailer address
         * @param {boolean} [shipping] 
         * @param {boolean} [billing] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAddresses(shipping?: boolean, billing?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AddressResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAddresses(shipping, billing, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.getAddresses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all balance levels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBalanceLevels(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEnumOptionsResponseBalanceLevel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBalanceLevels(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.getBalanceLevels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get retailer\'s billing addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillingAddresses(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AddressResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillingAddresses(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.getBillingAddresses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all options for how did you hear for us on retailer sign up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInformedFromOptions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEnumOptionsResponseRetailerInformedFrom>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInformedFromOptions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.getInformedFromOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get retailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMe1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetailerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMe1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.getMe1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find retailer Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyId(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyId(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.getMyId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get retailer\'s purchased brands
         * @param {string} id Retailer\&#39;s id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchasedBrands(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PurchasedBrandResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchasedBrands(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.getPurchasedBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get retailer
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRetailer1(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetailerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRetailer1(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.getRetailer1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get count of retailer\'s orders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRetailerCountOfOrders(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderCountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRetailerCountOfOrders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.getRetailerCountOfOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Obtain Retailer\'s saved credit cards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRetailerCreditCards(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaymentSourceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRetailerCreditCards(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.getRetailerCreditCards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Obtain Retailer\'s saved credit cards by Id
         * @param {string} id Retailer\&#39;s id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRetailerCreditCardsById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaymentSourceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRetailerCreditCardsById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.getRetailerCreditCardsById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get retailer info by user id
         * @param {string} id User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRetailerInfoByUserId(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetailerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRetailerInfoByUserId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.getRetailerInfoByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all retailer statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRetailerStatuses(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEnumOptionsResponseRetailerStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRetailerStatuses(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.getRetailerStatuses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all balance levels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRetailerStoreTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEnumOptionsResponseRetailerStoreType>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRetailerStoreTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.getRetailerStoreTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get retailer balance
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRetailerUsedBalance(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetailerCreditResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRetailerUsedBalance(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.getRetailerUsedBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all retailer values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRetailerValues(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DropdownItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRetailerValues(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.getRetailerValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find all Retailer applicants per multiple/custom criteria
         * @param {string} [searchBy] Search by
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRetailersApplications(searchBy?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedRetailersApplicationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRetailersApplications(searchBy, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.getRetailersApplications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find all Retailer applicants per multiple/custom criteria
         * @param {string} [searchBy] Search by
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRetailersDirectory(searchBy?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedRetailersDirectoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRetailersDirectory(searchBy, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.getRetailersDirectory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get retailers for dropdown
         * @param {string} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRetailersDropdown(ifNoneMatch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRetailersDropdown(ifNoneMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.getRetailersDropdown']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get retailers with a balance greater than zero.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRetailersWithBalance(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RetailerBalanceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRetailersWithBalance(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.getRetailersWithBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Obtain Retailer\'s Stripe Customer Id token. This api will return null if token is not yet created.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStripeCustomerId(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStripeCustomerIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStripeCustomerId(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.getStripeCustomerId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resends verification mail to given retailer
         * @param {string} id Retailer\&#39;s id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendVerificationMail(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendVerificationMail(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.resendVerificationMail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retailer can request a review for pending verification from the Bulletin Verification Team.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendVerificationEmailForUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendVerificationEmailForUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.sendVerificationEmailForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send verification emails to retailers from given countries
         * @param {SendVerificationEmailsRequest} sendVerificationEmailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendVerificationEmailsToRetailersByCountries(sendVerificationEmailsRequest: SendVerificationEmailsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendVerificationEmailsToRetailersByCountries(sendVerificationEmailsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.sendVerificationEmailsToRetailersByCountries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update retailer account by user id
         * @param {UpdateRetailerAccountRequest} updateRetailerAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMyAccount(updateRetailerAccountRequest: UpdateRetailerAccountRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMyAccount(updateRetailerAccountRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.updateMyAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update retailer account
         * @param {string} id Retailer Id
         * @param {UpdateRetailerAccountRequest} updateRetailerAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRetailerAccount(id: string, updateRetailerAccountRequest: UpdateRetailerAccountRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRetailerAccount(id, updateRetailerAccountRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.updateRetailerAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update retailer status - ACTIVE, SUSPENDED, BANNED
         * @param {string} retailerId 
         * @param {UpdateRetailerStatusRequest} updateRetailerStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRetailerStatus(retailerId: string, updateRetailerStatusRequest: UpdateRetailerStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRetailerStatus(retailerId, updateRetailerStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.updateRetailerStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload retailer\'s thumbnail image
         * @param {UploadRetailerThumbnailImageRequest} [uploadRetailerThumbnailImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadRetailerThumbnailImage(uploadRetailerThumbnailImageRequest?: UploadRetailerThumbnailImageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadFileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadRetailerThumbnailImage(uploadRetailerThumbnailImageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RetailerControllerApi.uploadRetailerThumbnailImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RetailerControllerApi - factory interface
 * @export
 */
export const RetailerControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RetailerControllerApiFp(configuration)
    return {
        /**
         * Approve retailer by admin
         * @param {string} retailerId Retailer ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminApproveRetailer(retailerId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminApproveRetailer(retailerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Decline retailer by admin
         * @param {string} retailerId Retailer ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeclineRetailer(retailerId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminDeclineRetailer(retailerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Apply to buy
         * @param {ApplyToBuyRequest} applyToBuyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyToBuy(applyToBuyRequest: ApplyToBuyRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApplyToBuyResponse> {
            return localVarFp.applyToBuy(applyToBuyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new Retailer using HubSpot form
         * @param {HubSpotRetailerSignUpRequest} hubSpotRetailerSignUpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewHubSpotRetailer(hubSpotRetailerSignUpRequest: HubSpotRetailerSignUpRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper> {
            return localVarFp.createNewHubSpotRetailer(hubSpotRetailerSignUpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete retailer
         * @param {string} id Retailer Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRetailer(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteRetailer(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Find retailer address
         * @param {boolean} [shipping] 
         * @param {boolean} [billing] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddresses(shipping?: boolean, billing?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<AddressResponse>> {
            return localVarFp.getAddresses(shipping, billing, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all balance levels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalanceLevels(options?: RawAxiosRequestConfig): AxiosPromise<GetEnumOptionsResponseBalanceLevel> {
            return localVarFp.getBalanceLevels(options).then((request) => request(axios, basePath));
        },
        /**
         * Get retailer\'s billing addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingAddresses(options?: RawAxiosRequestConfig): AxiosPromise<Array<AddressResponse>> {
            return localVarFp.getBillingAddresses(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all options for how did you hear for us on retailer sign up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInformedFromOptions(options?: RawAxiosRequestConfig): AxiosPromise<GetEnumOptionsResponseRetailerInformedFrom> {
            return localVarFp.getInformedFromOptions(options).then((request) => request(axios, basePath));
        },
        /**
         * Get retailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe1(options?: RawAxiosRequestConfig): AxiosPromise<RetailerResponse> {
            return localVarFp.getMe1(options).then((request) => request(axios, basePath));
        },
        /**
         * Find retailer Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyId(options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper> {
            return localVarFp.getMyId(options).then((request) => request(axios, basePath));
        },
        /**
         * Get retailer\'s purchased brands
         * @param {string} id Retailer\&#39;s id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchasedBrands(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PurchasedBrandResponse>> {
            return localVarFp.getPurchasedBrands(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get retailer
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailer1(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RetailerResponse> {
            return localVarFp.getRetailer1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get count of retailer\'s orders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailerCountOfOrders(options?: RawAxiosRequestConfig): AxiosPromise<OrderCountResponse> {
            return localVarFp.getRetailerCountOfOrders(options).then((request) => request(axios, basePath));
        },
        /**
         * Obtain Retailer\'s saved credit cards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailerCreditCards(options?: RawAxiosRequestConfig): AxiosPromise<Array<PaymentSourceResponse>> {
            return localVarFp.getRetailerCreditCards(options).then((request) => request(axios, basePath));
        },
        /**
         * Obtain Retailer\'s saved credit cards by Id
         * @param {string} id Retailer\&#39;s id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailerCreditCardsById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PaymentSourceResponse>> {
            return localVarFp.getRetailerCreditCardsById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get retailer info by user id
         * @param {string} id User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailerInfoByUserId(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RetailerResponse> {
            return localVarFp.getRetailerInfoByUserId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all retailer statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailerStatuses(options?: RawAxiosRequestConfig): AxiosPromise<GetEnumOptionsResponseRetailerStatus> {
            return localVarFp.getRetailerStatuses(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all balance levels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailerStoreTypes(options?: RawAxiosRequestConfig): AxiosPromise<GetEnumOptionsResponseRetailerStoreType> {
            return localVarFp.getRetailerStoreTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * Get retailer balance
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailerUsedBalance(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RetailerCreditResponse> {
            return localVarFp.getRetailerUsedBalance(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all retailer values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailerValues(options?: RawAxiosRequestConfig): AxiosPromise<Array<DropdownItem>> {
            return localVarFp.getRetailerValues(options).then((request) => request(axios, basePath));
        },
        /**
         * Find all Retailer applicants per multiple/custom criteria
         * @param {string} [searchBy] Search by
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailersApplications(searchBy?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedRetailersApplicationsResponse> {
            return localVarFp.getRetailersApplications(searchBy, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Find all Retailer applicants per multiple/custom criteria
         * @param {string} [searchBy] Search by
         * @param {number} [page] Page
         * @param {number} [size] Size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailersDirectory(searchBy?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedRetailersDirectoryResponse> {
            return localVarFp.getRetailersDirectory(searchBy, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Get retailers for dropdown
         * @param {string} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailersDropdown(ifNoneMatch?: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getRetailersDropdown(ifNoneMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Get retailers with a balance greater than zero.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailersWithBalance(options?: RawAxiosRequestConfig): AxiosPromise<Array<RetailerBalanceResponse>> {
            return localVarFp.getRetailersWithBalance(options).then((request) => request(axios, basePath));
        },
        /**
         * Obtain Retailer\'s Stripe Customer Id token. This api will return null if token is not yet created.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripeCustomerId(options?: RawAxiosRequestConfig): AxiosPromise<GetStripeCustomerIdResponse> {
            return localVarFp.getStripeCustomerId(options).then((request) => request(axios, basePath));
        },
        /**
         * Resends verification mail to given retailer
         * @param {string} id Retailer\&#39;s id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendVerificationMail(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resendVerificationMail(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retailer can request a review for pending verification from the Bulletin Verification Team.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendVerificationEmailForUser(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendVerificationEmailForUser(options).then((request) => request(axios, basePath));
        },
        /**
         * Send verification emails to retailers from given countries
         * @param {SendVerificationEmailsRequest} sendVerificationEmailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendVerificationEmailsToRetailersByCountries(sendVerificationEmailsRequest: SendVerificationEmailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendVerificationEmailsToRetailersByCountries(sendVerificationEmailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update retailer account by user id
         * @param {UpdateRetailerAccountRequest} updateRetailerAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyAccount(updateRetailerAccountRequest: UpdateRetailerAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMyAccount(updateRetailerAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update retailer account
         * @param {string} id Retailer Id
         * @param {UpdateRetailerAccountRequest} updateRetailerAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRetailerAccount(id: string, updateRetailerAccountRequest: UpdateRetailerAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateRetailerAccount(id, updateRetailerAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update retailer status - ACTIVE, SUSPENDED, BANNED
         * @param {string} retailerId 
         * @param {UpdateRetailerStatusRequest} updateRetailerStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRetailerStatus(retailerId: string, updateRetailerStatusRequest: UpdateRetailerStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateRetailerStatus(retailerId, updateRetailerStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload retailer\'s thumbnail image
         * @param {UploadRetailerThumbnailImageRequest} [uploadRetailerThumbnailImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadRetailerThumbnailImage(uploadRetailerThumbnailImageRequest?: UploadRetailerThumbnailImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadFileResponse> {
            return localVarFp.uploadRetailerThumbnailImage(uploadRetailerThumbnailImageRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RetailerControllerApi - interface
 * @export
 * @interface RetailerControllerApi
 */
export interface RetailerControllerApiInterface {
    /**
     * Approve retailer by admin
     * @param {string} retailerId Retailer ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    adminApproveRetailer(retailerId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Decline retailer by admin
     * @param {string} retailerId Retailer ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    adminDeclineRetailer(retailerId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Apply to buy
     * @param {ApplyToBuyRequest} applyToBuyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    applyToBuy(applyToBuyRequest: ApplyToBuyRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApplyToBuyResponse>;

    /**
     * Create a new Retailer using HubSpot form
     * @param {HubSpotRetailerSignUpRequest} hubSpotRetailerSignUpRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    createNewHubSpotRetailer(hubSpotRetailerSignUpRequest: HubSpotRetailerSignUpRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper>;

    /**
     * Delete retailer
     * @param {string} id Retailer Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    deleteRetailer(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Find retailer address
     * @param {boolean} [shipping] 
     * @param {boolean} [billing] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    getAddresses(shipping?: boolean, billing?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<AddressResponse>>;

    /**
     * Get all balance levels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    getBalanceLevels(options?: RawAxiosRequestConfig): AxiosPromise<GetEnumOptionsResponseBalanceLevel>;

    /**
     * Get retailer\'s billing addresses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    getBillingAddresses(options?: RawAxiosRequestConfig): AxiosPromise<Array<AddressResponse>>;

    /**
     * Get all options for how did you hear for us on retailer sign up
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    getInformedFromOptions(options?: RawAxiosRequestConfig): AxiosPromise<GetEnumOptionsResponseRetailerInformedFrom>;

    /**
     * Get retailer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    getMe1(options?: RawAxiosRequestConfig): AxiosPromise<RetailerResponse>;

    /**
     * Find retailer Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    getMyId(options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper>;

    /**
     * Get retailer\'s purchased brands
     * @param {string} id Retailer\&#39;s id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    getPurchasedBrands(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PurchasedBrandResponse>>;

    /**
     * Get retailer
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    getRetailer1(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RetailerResponse>;

    /**
     * Get count of retailer\'s orders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    getRetailerCountOfOrders(options?: RawAxiosRequestConfig): AxiosPromise<OrderCountResponse>;

    /**
     * Obtain Retailer\'s saved credit cards
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    getRetailerCreditCards(options?: RawAxiosRequestConfig): AxiosPromise<Array<PaymentSourceResponse>>;

    /**
     * Obtain Retailer\'s saved credit cards by Id
     * @param {string} id Retailer\&#39;s id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    getRetailerCreditCardsById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PaymentSourceResponse>>;

    /**
     * Get retailer info by user id
     * @param {string} id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    getRetailerInfoByUserId(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RetailerResponse>;

    /**
     * Get all retailer statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    getRetailerStatuses(options?: RawAxiosRequestConfig): AxiosPromise<GetEnumOptionsResponseRetailerStatus>;

    /**
     * Get all balance levels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    getRetailerStoreTypes(options?: RawAxiosRequestConfig): AxiosPromise<GetEnumOptionsResponseRetailerStoreType>;

    /**
     * Get retailer balance
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    getRetailerUsedBalance(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RetailerCreditResponse>;

    /**
     * Returns all retailer values
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    getRetailerValues(options?: RawAxiosRequestConfig): AxiosPromise<Array<DropdownItem>>;

    /**
     * Find all Retailer applicants per multiple/custom criteria
     * @param {string} [searchBy] Search by
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    getRetailersApplications(searchBy?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedRetailersApplicationsResponse>;

    /**
     * Find all Retailer applicants per multiple/custom criteria
     * @param {string} [searchBy] Search by
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    getRetailersDirectory(searchBy?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedRetailersDirectoryResponse>;

    /**
     * Get retailers for dropdown
     * @param {string} [ifNoneMatch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    getRetailersDropdown(ifNoneMatch?: string, options?: RawAxiosRequestConfig): AxiosPromise<object>;

    /**
     * Get retailers with a balance greater than zero.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    getRetailersWithBalance(options?: RawAxiosRequestConfig): AxiosPromise<Array<RetailerBalanceResponse>>;

    /**
     * Obtain Retailer\'s Stripe Customer Id token. This api will return null if token is not yet created.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    getStripeCustomerId(options?: RawAxiosRequestConfig): AxiosPromise<GetStripeCustomerIdResponse>;

    /**
     * Resends verification mail to given retailer
     * @param {string} id Retailer\&#39;s id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    resendVerificationMail(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Retailer can request a review for pending verification from the Bulletin Verification Team.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    sendVerificationEmailForUser(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Send verification emails to retailers from given countries
     * @param {SendVerificationEmailsRequest} sendVerificationEmailsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    sendVerificationEmailsToRetailersByCountries(sendVerificationEmailsRequest: SendVerificationEmailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update retailer account by user id
     * @param {UpdateRetailerAccountRequest} updateRetailerAccountRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    updateMyAccount(updateRetailerAccountRequest: UpdateRetailerAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update retailer account
     * @param {string} id Retailer Id
     * @param {UpdateRetailerAccountRequest} updateRetailerAccountRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    updateRetailerAccount(id: string, updateRetailerAccountRequest: UpdateRetailerAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update retailer status - ACTIVE, SUSPENDED, BANNED
     * @param {string} retailerId 
     * @param {UpdateRetailerStatusRequest} updateRetailerStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    updateRetailerStatus(retailerId: string, updateRetailerStatusRequest: UpdateRetailerStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Upload retailer\'s thumbnail image
     * @param {UploadRetailerThumbnailImageRequest} [uploadRetailerThumbnailImageRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApiInterface
     */
    uploadRetailerThumbnailImage(uploadRetailerThumbnailImageRequest?: UploadRetailerThumbnailImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadFileResponse>;

}

/**
 * RetailerControllerApi - object-oriented interface
 * @export
 * @class RetailerControllerApi
 * @extends {BaseAPI}
 */
export class RetailerControllerApi extends BaseAPI implements RetailerControllerApiInterface {
    /**
     * Approve retailer by admin
     * @param {string} retailerId Retailer ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public adminApproveRetailer(retailerId: string, options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).adminApproveRetailer(retailerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Decline retailer by admin
     * @param {string} retailerId Retailer ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public adminDeclineRetailer(retailerId: string, options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).adminDeclineRetailer(retailerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Apply to buy
     * @param {ApplyToBuyRequest} applyToBuyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public applyToBuy(applyToBuyRequest: ApplyToBuyRequest, options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).applyToBuy(applyToBuyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new Retailer using HubSpot form
     * @param {HubSpotRetailerSignUpRequest} hubSpotRetailerSignUpRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public createNewHubSpotRetailer(hubSpotRetailerSignUpRequest: HubSpotRetailerSignUpRequest, options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).createNewHubSpotRetailer(hubSpotRetailerSignUpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete retailer
     * @param {string} id Retailer Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public deleteRetailer(id: string, options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).deleteRetailer(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find retailer address
     * @param {boolean} [shipping] 
     * @param {boolean} [billing] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public getAddresses(shipping?: boolean, billing?: boolean, options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).getAddresses(shipping, billing, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all balance levels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public getBalanceLevels(options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).getBalanceLevels(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get retailer\'s billing addresses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public getBillingAddresses(options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).getBillingAddresses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all options for how did you hear for us on retailer sign up
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public getInformedFromOptions(options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).getInformedFromOptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get retailer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public getMe1(options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).getMe1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find retailer Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public getMyId(options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).getMyId(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get retailer\'s purchased brands
     * @param {string} id Retailer\&#39;s id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public getPurchasedBrands(id: string, options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).getPurchasedBrands(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get retailer
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public getRetailer1(id: string, options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).getRetailer1(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get count of retailer\'s orders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public getRetailerCountOfOrders(options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).getRetailerCountOfOrders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtain Retailer\'s saved credit cards
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public getRetailerCreditCards(options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).getRetailerCreditCards(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtain Retailer\'s saved credit cards by Id
     * @param {string} id Retailer\&#39;s id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public getRetailerCreditCardsById(id: string, options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).getRetailerCreditCardsById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get retailer info by user id
     * @param {string} id User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public getRetailerInfoByUserId(id: string, options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).getRetailerInfoByUserId(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all retailer statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public getRetailerStatuses(options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).getRetailerStatuses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all balance levels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public getRetailerStoreTypes(options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).getRetailerStoreTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get retailer balance
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public getRetailerUsedBalance(id: string, options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).getRetailerUsedBalance(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all retailer values
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public getRetailerValues(options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).getRetailerValues(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find all Retailer applicants per multiple/custom criteria
     * @param {string} [searchBy] Search by
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public getRetailersApplications(searchBy?: string, page?: number, size?: number, options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).getRetailersApplications(searchBy, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find all Retailer applicants per multiple/custom criteria
     * @param {string} [searchBy] Search by
     * @param {number} [page] Page
     * @param {number} [size] Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public getRetailersDirectory(searchBy?: string, page?: number, size?: number, options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).getRetailersDirectory(searchBy, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get retailers for dropdown
     * @param {string} [ifNoneMatch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public getRetailersDropdown(ifNoneMatch?: string, options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).getRetailersDropdown(ifNoneMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get retailers with a balance greater than zero.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public getRetailersWithBalance(options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).getRetailersWithBalance(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtain Retailer\'s Stripe Customer Id token. This api will return null if token is not yet created.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public getStripeCustomerId(options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).getStripeCustomerId(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resends verification mail to given retailer
     * @param {string} id Retailer\&#39;s id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public resendVerificationMail(id: string, options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).resendVerificationMail(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retailer can request a review for pending verification from the Bulletin Verification Team.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public sendVerificationEmailForUser(options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).sendVerificationEmailForUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send verification emails to retailers from given countries
     * @param {SendVerificationEmailsRequest} sendVerificationEmailsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public sendVerificationEmailsToRetailersByCountries(sendVerificationEmailsRequest: SendVerificationEmailsRequest, options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).sendVerificationEmailsToRetailersByCountries(sendVerificationEmailsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update retailer account by user id
     * @param {UpdateRetailerAccountRequest} updateRetailerAccountRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public updateMyAccount(updateRetailerAccountRequest: UpdateRetailerAccountRequest, options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).updateMyAccount(updateRetailerAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update retailer account
     * @param {string} id Retailer Id
     * @param {UpdateRetailerAccountRequest} updateRetailerAccountRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public updateRetailerAccount(id: string, updateRetailerAccountRequest: UpdateRetailerAccountRequest, options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).updateRetailerAccount(id, updateRetailerAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update retailer status - ACTIVE, SUSPENDED, BANNED
     * @param {string} retailerId 
     * @param {UpdateRetailerStatusRequest} updateRetailerStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public updateRetailerStatus(retailerId: string, updateRetailerStatusRequest: UpdateRetailerStatusRequest, options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).updateRetailerStatus(retailerId, updateRetailerStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload retailer\'s thumbnail image
     * @param {UploadRetailerThumbnailImageRequest} [uploadRetailerThumbnailImageRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetailerControllerApi
     */
    public uploadRetailerThumbnailImage(uploadRetailerThumbnailImageRequest?: UploadRetailerThumbnailImageRequest, options?: RawAxiosRequestConfig) {
        return RetailerControllerApiFp(this.configuration).uploadRetailerThumbnailImage(uploadRetailerThumbnailImageRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SettingsControllerApi - axios parameter creator
 * @export
 */
export const SettingsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Enable shopify update of products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableShopifyUpdate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/settings/disable-shopify-update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enable shopify update of products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableShopifyUpdate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/settings/enable-shopify-update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get shopify update settings status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShopifyUpdateSettingsResponse: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/settings/shopify-update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SettingsControllerApi - functional programming interface
 * @export
 */
export const SettingsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SettingsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Enable shopify update of products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableShopifyUpdate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableShopifyUpdate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsControllerApi.disableShopifyUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Enable shopify update of products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableShopifyUpdate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableShopifyUpdate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsControllerApi.enableShopifyUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get shopify update settings status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShopifyUpdateSettingsResponse(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopifyUpdateSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShopifyUpdateSettingsResponse(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsControllerApi.getShopifyUpdateSettingsResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SettingsControllerApi - factory interface
 * @export
 */
export const SettingsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SettingsControllerApiFp(configuration)
    return {
        /**
         * Enable shopify update of products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableShopifyUpdate(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.disableShopifyUpdate(options).then((request) => request(axios, basePath));
        },
        /**
         * Enable shopify update of products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableShopifyUpdate(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.enableShopifyUpdate(options).then((request) => request(axios, basePath));
        },
        /**
         * Get shopify update settings status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShopifyUpdateSettingsResponse(options?: RawAxiosRequestConfig): AxiosPromise<ShopifyUpdateSettingsResponse> {
            return localVarFp.getShopifyUpdateSettingsResponse(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SettingsControllerApi - interface
 * @export
 * @interface SettingsControllerApi
 */
export interface SettingsControllerApiInterface {
    /**
     * Enable shopify update of products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsControllerApiInterface
     */
    disableShopifyUpdate(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Enable shopify update of products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsControllerApiInterface
     */
    enableShopifyUpdate(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Get shopify update settings status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsControllerApiInterface
     */
    getShopifyUpdateSettingsResponse(options?: RawAxiosRequestConfig): AxiosPromise<ShopifyUpdateSettingsResponse>;

}

/**
 * SettingsControllerApi - object-oriented interface
 * @export
 * @class SettingsControllerApi
 * @extends {BaseAPI}
 */
export class SettingsControllerApi extends BaseAPI implements SettingsControllerApiInterface {
    /**
     * Enable shopify update of products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsControllerApi
     */
    public disableShopifyUpdate(options?: RawAxiosRequestConfig) {
        return SettingsControllerApiFp(this.configuration).disableShopifyUpdate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enable shopify update of products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsControllerApi
     */
    public enableShopifyUpdate(options?: RawAxiosRequestConfig) {
        return SettingsControllerApiFp(this.configuration).enableShopifyUpdate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get shopify update settings status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsControllerApi
     */
    public getShopifyUpdateSettingsResponse(options?: RawAxiosRequestConfig) {
        return SettingsControllerApiFp(this.configuration).getShopifyUpdateSettingsResponse(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ShopifyControllerApi - axios parameter creator
 * @export
 */
export const ShopifyControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Endpoint for checking registered Shopify endpoint.
         * @param {string} brandId Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkRegisteredShopifyEndpoint: async (brandId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('checkRegisteredShopifyEndpoint', 'brandId', brandId)
            const localVarPath = `/shopify/{brandId}/webhooks`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Disconnect Brand from their Shopify store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectBrandShopifyStore: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/shopify/disconnect/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get product feed id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductFeed: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/shopify/product-feed/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get count and status of products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductStatusForBrand: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/shopify/my-product-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get count and status of Shopify products
         * @param {string} brandId Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductStatusForBrandId: async (brandId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getProductStatusForBrandId', 'brandId', brandId)
            const localVarPath = `/shopify/brand/{brandId}/product-status`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get shopify connection state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShopifyConnectionInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/shopify/state`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Shopify API version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShopifyVersion: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/shopify/version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Save store token for Shopify
         * @param {SaveShopifyStoreDataRequest} saveShopifyStoreDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveStoreShopifyData: async (saveShopifyStoreDataRequest: SaveShopifyStoreDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveShopifyStoreDataRequest' is not null or undefined
            assertParamExists('saveStoreShopifyData', 'saveShopifyStoreDataRequest', saveShopifyStoreDataRequest)
            const localVarPath = `/shopify/store-token-and-archive-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveShopifyStoreDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Persist wholesale prices flag on Brand
         * @param {SaveShopifyWholesalePricesFlagRequest} saveShopifyWholesalePricesFlagRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWholesalePricesFlag: async (saveShopifyWholesalePricesFlagRequest: SaveShopifyWholesalePricesFlagRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveShopifyWholesalePricesFlagRequest' is not null or undefined
            assertParamExists('saveWholesalePricesFlag', 'saveShopifyWholesalePricesFlagRequest', saveShopifyWholesalePricesFlagRequest)
            const localVarPath = `/shopify/me/wholesale-prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveShopifyWholesalePricesFlagRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShopifyControllerApi - functional programming interface
 * @export
 */
export const ShopifyControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShopifyControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Endpoint for checking registered Shopify endpoint.
         * @param {string} brandId Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkRegisteredShopifyEndpoint(brandId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebhookList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkRegisteredShopifyEndpoint(brandId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopifyControllerApi.checkRegisteredShopifyEndpoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Disconnect Brand from their Shopify store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectBrandShopifyStore(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectBrandShopifyStore(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopifyControllerApi.disconnectBrandShopifyStore']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get product feed id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductFeed(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProductFeedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductFeed(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopifyControllerApi.getProductFeed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get count and status of products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductStatusForBrand(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopifyProductStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductStatusForBrand(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopifyControllerApi.getProductStatusForBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get count and status of Shopify products
         * @param {string} brandId Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductStatusForBrandId(brandId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopifyProductStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductStatusForBrandId(brandId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopifyControllerApi.getProductStatusForBrandId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get shopify connection state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShopifyConnectionInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopifyConnectionInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShopifyConnectionInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopifyControllerApi.getShopifyConnectionInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Shopify API version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShopifyVersion(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopifyVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShopifyVersion(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopifyControllerApi.getShopifyVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Save store token for Shopify
         * @param {SaveShopifyStoreDataRequest} saveShopifyStoreDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveStoreShopifyData(saveShopifyStoreDataRequest: SaveShopifyStoreDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveStoreShopifyData(saveShopifyStoreDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopifyControllerApi.saveStoreShopifyData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Persist wholesale prices flag on Brand
         * @param {SaveShopifyWholesalePricesFlagRequest} saveShopifyWholesalePricesFlagRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveWholesalePricesFlag(saveShopifyWholesalePricesFlagRequest: SaveShopifyWholesalePricesFlagRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveWholesalePricesFlag(saveShopifyWholesalePricesFlagRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopifyControllerApi.saveWholesalePricesFlag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ShopifyControllerApi - factory interface
 * @export
 */
export const ShopifyControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShopifyControllerApiFp(configuration)
    return {
        /**
         * Endpoint for checking registered Shopify endpoint.
         * @param {string} brandId Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkRegisteredShopifyEndpoint(brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<WebhookList> {
            return localVarFp.checkRegisteredShopifyEndpoint(brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Disconnect Brand from their Shopify store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectBrandShopifyStore(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.disconnectBrandShopifyStore(options).then((request) => request(axios, basePath));
        },
        /**
         * Get product feed id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductFeed(options?: RawAxiosRequestConfig): AxiosPromise<GetProductFeedResponse> {
            return localVarFp.getProductFeed(options).then((request) => request(axios, basePath));
        },
        /**
         * Get count and status of products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductStatusForBrand(options?: RawAxiosRequestConfig): AxiosPromise<ShopifyProductStatusResponse> {
            return localVarFp.getProductStatusForBrand(options).then((request) => request(axios, basePath));
        },
        /**
         * Get count and status of Shopify products
         * @param {string} brandId Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductStatusForBrandId(brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<ShopifyProductStatusResponse> {
            return localVarFp.getProductStatusForBrandId(brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get shopify connection state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShopifyConnectionInfo(options?: RawAxiosRequestConfig): AxiosPromise<ShopifyConnectionInfoResponse> {
            return localVarFp.getShopifyConnectionInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * Get Shopify API version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShopifyVersion(options?: RawAxiosRequestConfig): AxiosPromise<ShopifyVersionResponse> {
            return localVarFp.getShopifyVersion(options).then((request) => request(axios, basePath));
        },
        /**
         * Save store token for Shopify
         * @param {SaveShopifyStoreDataRequest} saveShopifyStoreDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveStoreShopifyData(saveShopifyStoreDataRequest: SaveShopifyStoreDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.saveStoreShopifyData(saveShopifyStoreDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Persist wholesale prices flag on Brand
         * @param {SaveShopifyWholesalePricesFlagRequest} saveShopifyWholesalePricesFlagRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWholesalePricesFlag(saveShopifyWholesalePricesFlagRequest: SaveShopifyWholesalePricesFlagRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.saveWholesalePricesFlag(saveShopifyWholesalePricesFlagRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShopifyControllerApi - interface
 * @export
 * @interface ShopifyControllerApi
 */
export interface ShopifyControllerApiInterface {
    /**
     * Endpoint for checking registered Shopify endpoint.
     * @param {string} brandId Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyControllerApiInterface
     */
    checkRegisteredShopifyEndpoint(brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<WebhookList>;

    /**
     * Disconnect Brand from their Shopify store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyControllerApiInterface
     */
    disconnectBrandShopifyStore(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Get product feed id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyControllerApiInterface
     */
    getProductFeed(options?: RawAxiosRequestConfig): AxiosPromise<GetProductFeedResponse>;

    /**
     * Get count and status of products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyControllerApiInterface
     */
    getProductStatusForBrand(options?: RawAxiosRequestConfig): AxiosPromise<ShopifyProductStatusResponse>;

    /**
     * Get count and status of Shopify products
     * @param {string} brandId Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyControllerApiInterface
     */
    getProductStatusForBrandId(brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<ShopifyProductStatusResponse>;

    /**
     * Get shopify connection state
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyControllerApiInterface
     */
    getShopifyConnectionInfo(options?: RawAxiosRequestConfig): AxiosPromise<ShopifyConnectionInfoResponse>;

    /**
     * Get Shopify API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyControllerApiInterface
     */
    getShopifyVersion(options?: RawAxiosRequestConfig): AxiosPromise<ShopifyVersionResponse>;

    /**
     * Save store token for Shopify
     * @param {SaveShopifyStoreDataRequest} saveShopifyStoreDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyControllerApiInterface
     */
    saveStoreShopifyData(saveShopifyStoreDataRequest: SaveShopifyStoreDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Persist wholesale prices flag on Brand
     * @param {SaveShopifyWholesalePricesFlagRequest} saveShopifyWholesalePricesFlagRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyControllerApiInterface
     */
    saveWholesalePricesFlag(saveShopifyWholesalePricesFlagRequest: SaveShopifyWholesalePricesFlagRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ShopifyControllerApi - object-oriented interface
 * @export
 * @class ShopifyControllerApi
 * @extends {BaseAPI}
 */
export class ShopifyControllerApi extends BaseAPI implements ShopifyControllerApiInterface {
    /**
     * Endpoint for checking registered Shopify endpoint.
     * @param {string} brandId Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyControllerApi
     */
    public checkRegisteredShopifyEndpoint(brandId: string, options?: RawAxiosRequestConfig) {
        return ShopifyControllerApiFp(this.configuration).checkRegisteredShopifyEndpoint(brandId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Disconnect Brand from their Shopify store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyControllerApi
     */
    public disconnectBrandShopifyStore(options?: RawAxiosRequestConfig) {
        return ShopifyControllerApiFp(this.configuration).disconnectBrandShopifyStore(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get product feed id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyControllerApi
     */
    public getProductFeed(options?: RawAxiosRequestConfig) {
        return ShopifyControllerApiFp(this.configuration).getProductFeed(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get count and status of products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyControllerApi
     */
    public getProductStatusForBrand(options?: RawAxiosRequestConfig) {
        return ShopifyControllerApiFp(this.configuration).getProductStatusForBrand(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get count and status of Shopify products
     * @param {string} brandId Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyControllerApi
     */
    public getProductStatusForBrandId(brandId: string, options?: RawAxiosRequestConfig) {
        return ShopifyControllerApiFp(this.configuration).getProductStatusForBrandId(brandId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get shopify connection state
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyControllerApi
     */
    public getShopifyConnectionInfo(options?: RawAxiosRequestConfig) {
        return ShopifyControllerApiFp(this.configuration).getShopifyConnectionInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Shopify API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyControllerApi
     */
    public getShopifyVersion(options?: RawAxiosRequestConfig) {
        return ShopifyControllerApiFp(this.configuration).getShopifyVersion(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Save store token for Shopify
     * @param {SaveShopifyStoreDataRequest} saveShopifyStoreDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyControllerApi
     */
    public saveStoreShopifyData(saveShopifyStoreDataRequest: SaveShopifyStoreDataRequest, options?: RawAxiosRequestConfig) {
        return ShopifyControllerApiFp(this.configuration).saveStoreShopifyData(saveShopifyStoreDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Persist wholesale prices flag on Brand
     * @param {SaveShopifyWholesalePricesFlagRequest} saveShopifyWholesalePricesFlagRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyControllerApi
     */
    public saveWholesalePricesFlag(saveShopifyWholesalePricesFlagRequest: SaveShopifyWholesalePricesFlagRequest, options?: RawAxiosRequestConfig) {
        return ShopifyControllerApiFp(this.configuration).saveWholesalePricesFlag(saveShopifyWholesalePricesFlagRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ShopifyImportControllerApi - axios parameter creator
 * @export
 */
export const ShopifyImportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ShopifyImportDTO} shopifyImportDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importAll: async (shopifyImportDTO: ShopifyImportDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopifyImportDTO' is not null or undefined
            assertParamExists('importAll', 'shopifyImportDTO', shopifyImportDTO)
            const localVarPath = `/shopify-migration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopifyImportDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ShopifyImportDTO} shopifyImportDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importBrandsWithProducts: async (shopifyImportDTO: ShopifyImportDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopifyImportDTO' is not null or undefined
            assertParamExists('importBrandsWithProducts', 'shopifyImportDTO', shopifyImportDTO)
            const localVarPath = `/shopify-migration/update-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopifyImportDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importImagesFromShopifyToS3: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/shopify-migration/import-images`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategoriesForAllProducts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/shopify-migration/update-categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShopifyImportControllerApi - functional programming interface
 * @export
 */
export const ShopifyImportControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShopifyImportControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ShopifyImportDTO} shopifyImportDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importAll(shopifyImportDTO: ShopifyImportDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importAll(shopifyImportDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopifyImportControllerApi.importAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ShopifyImportDTO} shopifyImportDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importBrandsWithProducts(shopifyImportDTO: ShopifyImportDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importBrandsWithProducts(shopifyImportDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopifyImportControllerApi.importBrandsWithProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importImagesFromShopifyToS3(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importImagesFromShopifyToS3(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopifyImportControllerApi.importImagesFromShopifyToS3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCategoriesForAllProducts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCategoriesForAllProducts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShopifyImportControllerApi.updateCategoriesForAllProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ShopifyImportControllerApi - factory interface
 * @export
 */
export const ShopifyImportControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShopifyImportControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ShopifyImportDTO} shopifyImportDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importAll(shopifyImportDTO: ShopifyImportDTO, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.importAll(shopifyImportDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShopifyImportDTO} shopifyImportDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importBrandsWithProducts(shopifyImportDTO: ShopifyImportDTO, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.importBrandsWithProducts(shopifyImportDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importImagesFromShopifyToS3(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.importImagesFromShopifyToS3(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategoriesForAllProducts(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCategoriesForAllProducts(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShopifyImportControllerApi - interface
 * @export
 * @interface ShopifyImportControllerApi
 */
export interface ShopifyImportControllerApiInterface {
    /**
     * 
     * @param {ShopifyImportDTO} shopifyImportDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyImportControllerApiInterface
     */
    importAll(shopifyImportDTO: ShopifyImportDTO, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {ShopifyImportDTO} shopifyImportDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyImportControllerApiInterface
     */
    importBrandsWithProducts(shopifyImportDTO: ShopifyImportDTO, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyImportControllerApiInterface
     */
    importImagesFromShopifyToS3(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyImportControllerApiInterface
     */
    updateCategoriesForAllProducts(options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ShopifyImportControllerApi - object-oriented interface
 * @export
 * @class ShopifyImportControllerApi
 * @extends {BaseAPI}
 */
export class ShopifyImportControllerApi extends BaseAPI implements ShopifyImportControllerApiInterface {
    /**
     * 
     * @param {ShopifyImportDTO} shopifyImportDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyImportControllerApi
     */
    public importAll(shopifyImportDTO: ShopifyImportDTO, options?: RawAxiosRequestConfig) {
        return ShopifyImportControllerApiFp(this.configuration).importAll(shopifyImportDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShopifyImportDTO} shopifyImportDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyImportControllerApi
     */
    public importBrandsWithProducts(shopifyImportDTO: ShopifyImportDTO, options?: RawAxiosRequestConfig) {
        return ShopifyImportControllerApiFp(this.configuration).importBrandsWithProducts(shopifyImportDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyImportControllerApi
     */
    public importImagesFromShopifyToS3(options?: RawAxiosRequestConfig) {
        return ShopifyImportControllerApiFp(this.configuration).importImagesFromShopifyToS3(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyImportControllerApi
     */
    public updateCategoriesForAllProducts(options?: RawAxiosRequestConfig) {
        return ShopifyImportControllerApiFp(this.configuration).updateCategoriesForAllProducts(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SitemapControllerApi - axios parameter creator
 * @export
 */
export const SitemapControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get Brand Sitemap
         * @param {boolean} [updateS3] flag to trigger s3 upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandSitemap: async (updateS3?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/site-map/brand.xml`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (updateS3 !== undefined) {
                localVarQueryParameter['updateS3'] = updateS3;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Brand Sitemap
         * @param {boolean} [updateS3] flag to trigger s3 upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategorySitemap: async (updateS3?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/site-map/category.xml`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (updateS3 !== undefined) {
                localVarQueryParameter['updateS3'] = updateS3;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Brand Sitemap
         * @param {boolean} [updateS3] flag to trigger s3 upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionSitemap: async (updateS3?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/site-map/collection.xml`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (updateS3 !== undefined) {
                localVarQueryParameter['updateS3'] = updateS3;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Brand Sitemap
         * @param {boolean} [updateS3] flag to trigger s3 upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSitemap: async (updateS3?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/site-map/product.xml`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (updateS3 !== undefined) {
                localVarQueryParameter['updateS3'] = updateS3;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SitemapControllerApi - functional programming interface
 * @export
 */
export const SitemapControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SitemapControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Get Brand Sitemap
         * @param {boolean} [updateS3] flag to trigger s3 upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandSitemap(updateS3?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandSitemap(updateS3, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitemapControllerApi.getBrandSitemap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Brand Sitemap
         * @param {boolean} [updateS3] flag to trigger s3 upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategorySitemap(updateS3?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategorySitemap(updateS3, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitemapControllerApi.getCategorySitemap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Brand Sitemap
         * @param {boolean} [updateS3] flag to trigger s3 upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionSitemap(updateS3?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectionSitemap(updateS3, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitemapControllerApi.getCollectionSitemap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Brand Sitemap
         * @param {boolean} [updateS3] flag to trigger s3 upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductSitemap(updateS3?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductSitemap(updateS3, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitemapControllerApi.getProductSitemap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SitemapControllerApi - factory interface
 * @export
 */
export const SitemapControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SitemapControllerApiFp(configuration)
    return {
        /**
         * Get Brand Sitemap
         * @param {boolean} [updateS3] flag to trigger s3 upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandSitemap(updateS3?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getBrandSitemap(updateS3, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Brand Sitemap
         * @param {boolean} [updateS3] flag to trigger s3 upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategorySitemap(updateS3?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getCategorySitemap(updateS3, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Brand Sitemap
         * @param {boolean} [updateS3] flag to trigger s3 upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionSitemap(updateS3?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getCollectionSitemap(updateS3, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Brand Sitemap
         * @param {boolean} [updateS3] flag to trigger s3 upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSitemap(updateS3?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getProductSitemap(updateS3, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SitemapControllerApi - interface
 * @export
 * @interface SitemapControllerApi
 */
export interface SitemapControllerApiInterface {
    /**
     * Get Brand Sitemap
     * @param {boolean} [updateS3] flag to trigger s3 upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitemapControllerApiInterface
     */
    getBrandSitemap(updateS3?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<object>;

    /**
     * Get Brand Sitemap
     * @param {boolean} [updateS3] flag to trigger s3 upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitemapControllerApiInterface
     */
    getCategorySitemap(updateS3?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<object>;

    /**
     * Get Brand Sitemap
     * @param {boolean} [updateS3] flag to trigger s3 upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitemapControllerApiInterface
     */
    getCollectionSitemap(updateS3?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<object>;

    /**
     * Get Brand Sitemap
     * @param {boolean} [updateS3] flag to trigger s3 upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitemapControllerApiInterface
     */
    getProductSitemap(updateS3?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<object>;

}

/**
 * SitemapControllerApi - object-oriented interface
 * @export
 * @class SitemapControllerApi
 * @extends {BaseAPI}
 */
export class SitemapControllerApi extends BaseAPI implements SitemapControllerApiInterface {
    /**
     * Get Brand Sitemap
     * @param {boolean} [updateS3] flag to trigger s3 upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitemapControllerApi
     */
    public getBrandSitemap(updateS3?: boolean, options?: RawAxiosRequestConfig) {
        return SitemapControllerApiFp(this.configuration).getBrandSitemap(updateS3, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Brand Sitemap
     * @param {boolean} [updateS3] flag to trigger s3 upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitemapControllerApi
     */
    public getCategorySitemap(updateS3?: boolean, options?: RawAxiosRequestConfig) {
        return SitemapControllerApiFp(this.configuration).getCategorySitemap(updateS3, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Brand Sitemap
     * @param {boolean} [updateS3] flag to trigger s3 upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitemapControllerApi
     */
    public getCollectionSitemap(updateS3?: boolean, options?: RawAxiosRequestConfig) {
        return SitemapControllerApiFp(this.configuration).getCollectionSitemap(updateS3, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Brand Sitemap
     * @param {boolean} [updateS3] flag to trigger s3 upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitemapControllerApi
     */
    public getProductSitemap(updateS3?: boolean, options?: RawAxiosRequestConfig) {
        return SitemapControllerApiFp(this.configuration).getProductSitemap(updateS3, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StateControllerApi - axios parameter creator
 * @export
 */
export const StateControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Find States by Country Id
         * @param {string} countryId Country Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStateByCountry: async (countryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryId' is not null or undefined
            assertParamExists('getStateByCountry', 'countryId', countryId)
            const localVarPath = `/states/by-country/{countryId}`
                .replace(`{${"countryId"}}`, encodeURIComponent(String(countryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StateControllerApi - functional programming interface
 * @export
 */
export const StateControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StateControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Find States by Country Id
         * @param {string} countryId Country Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStateByCountry(countryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StateResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStateByCountry(countryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StateControllerApi.getStateByCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StateControllerApi - factory interface
 * @export
 */
export const StateControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StateControllerApiFp(configuration)
    return {
        /**
         * Find States by Country Id
         * @param {string} countryId Country Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStateByCountry(countryId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StateResponse>> {
            return localVarFp.getStateByCountry(countryId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StateControllerApi - interface
 * @export
 * @interface StateControllerApi
 */
export interface StateControllerApiInterface {
    /**
     * Find States by Country Id
     * @param {string} countryId Country Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StateControllerApiInterface
     */
    getStateByCountry(countryId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StateResponse>>;

}

/**
 * StateControllerApi - object-oriented interface
 * @export
 * @class StateControllerApi
 * @extends {BaseAPI}
 */
export class StateControllerApi extends BaseAPI implements StateControllerApiInterface {
    /**
     * Find States by Country Id
     * @param {string} countryId Country Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StateControllerApi
     */
    public getStateByCountry(countryId: string, options?: RawAxiosRequestConfig) {
        return StateControllerApiFp(this.configuration).getStateByCountry(countryId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StripeControllerApi - axios parameter creator
 * @export
 */
export const StripeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Connect brand to Stripe
         * @param {string} id Brand Id
         * @param {AuthorizationCodeDto} authorizationCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishConnect: async (id: string, authorizationCodeDto: AuthorizationCodeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('finishConnect', 'id', id)
            // verify required parameter 'authorizationCodeDto' is not null or undefined
            assertParamExists('finishConnect', 'authorizationCodeDto', authorizationCodeDto)
            const localVarPath = `/stripe/{id}/finish-connect`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authorizationCodeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Connect user to Stripe
         * @param {AuthorizationCodeDto} authorizationCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishConnect1: async (authorizationCodeDto: AuthorizationCodeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorizationCodeDto' is not null or undefined
            assertParamExists('finishConnect1', 'authorizationCodeDto', authorizationCodeDto)
            const localVarPath = `/stripe/finish-connect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authorizationCodeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stripe Connect init
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initConnect: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/stripe/init-connect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StripeControllerApi - functional programming interface
 * @export
 */
export const StripeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StripeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Connect brand to Stripe
         * @param {string} id Brand Id
         * @param {AuthorizationCodeDto} authorizationCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finishConnect(id: string, authorizationCodeDto: AuthorizationCodeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finishConnect(id, authorizationCodeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripeControllerApi.finishConnect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Connect user to Stripe
         * @param {AuthorizationCodeDto} authorizationCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finishConnect1(authorizationCodeDto: AuthorizationCodeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finishConnect1(authorizationCodeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripeControllerApi.finishConnect1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Stripe Connect init
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initConnect(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlatformInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initConnect(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StripeControllerApi.initConnect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StripeControllerApi - factory interface
 * @export
 */
export const StripeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StripeControllerApiFp(configuration)
    return {
        /**
         * Connect brand to Stripe
         * @param {string} id Brand Id
         * @param {AuthorizationCodeDto} authorizationCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishConnect(id: string, authorizationCodeDto: AuthorizationCodeDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.finishConnect(id, authorizationCodeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Connect user to Stripe
         * @param {AuthorizationCodeDto} authorizationCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishConnect1(authorizationCodeDto: AuthorizationCodeDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.finishConnect1(authorizationCodeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Stripe Connect init
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initConnect(options?: RawAxiosRequestConfig): AxiosPromise<PlatformInfoDto> {
            return localVarFp.initConnect(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StripeControllerApi - interface
 * @export
 * @interface StripeControllerApi
 */
export interface StripeControllerApiInterface {
    /**
     * Connect brand to Stripe
     * @param {string} id Brand Id
     * @param {AuthorizationCodeDto} authorizationCodeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeControllerApiInterface
     */
    finishConnect(id: string, authorizationCodeDto: AuthorizationCodeDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Connect user to Stripe
     * @param {AuthorizationCodeDto} authorizationCodeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeControllerApiInterface
     */
    finishConnect1(authorizationCodeDto: AuthorizationCodeDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Stripe Connect init
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeControllerApiInterface
     */
    initConnect(options?: RawAxiosRequestConfig): AxiosPromise<PlatformInfoDto>;

}

/**
 * StripeControllerApi - object-oriented interface
 * @export
 * @class StripeControllerApi
 * @extends {BaseAPI}
 */
export class StripeControllerApi extends BaseAPI implements StripeControllerApiInterface {
    /**
     * Connect brand to Stripe
     * @param {string} id Brand Id
     * @param {AuthorizationCodeDto} authorizationCodeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeControllerApi
     */
    public finishConnect(id: string, authorizationCodeDto: AuthorizationCodeDto, options?: RawAxiosRequestConfig) {
        return StripeControllerApiFp(this.configuration).finishConnect(id, authorizationCodeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Connect user to Stripe
     * @param {AuthorizationCodeDto} authorizationCodeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeControllerApi
     */
    public finishConnect1(authorizationCodeDto: AuthorizationCodeDto, options?: RawAxiosRequestConfig) {
        return StripeControllerApiFp(this.configuration).finishConnect1(authorizationCodeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stripe Connect init
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeControllerApi
     */
    public initConnect(options?: RawAxiosRequestConfig) {
        return StripeControllerApiFp(this.configuration).initConnect(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SyncControllerApi - axios parameter creator
 * @export
 */
export const SyncControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update products brand object on Algolia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUpdateProductsBrandAlgoliaSourceAndEvents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sync/algolia/products-brand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Synchronizes Salesforce brand data with the main database.
         * @param {SyncBrandsToSalesforceRequest} syncBrandsToSalesforceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncBrandsToSalesforce: async (syncBrandsToSalesforceRequest: SyncBrandsToSalesforceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'syncBrandsToSalesforceRequest' is not null or undefined
            assertParamExists('syncBrandsToSalesforce', 'syncBrandsToSalesforceRequest', syncBrandsToSalesforceRequest)
            const localVarPath = `/sync/salesforce/brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncBrandsToSalesforceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Synchronizes Salesforce Order data with the main database.
         * @param {SyncOrdersToSalesforceRequest} syncOrdersToSalesforceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncOrdersToSalesforce: async (syncOrdersToSalesforceRequest: SyncOrdersToSalesforceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'syncOrdersToSalesforceRequest' is not null or undefined
            assertParamExists('syncOrdersToSalesforce', 'syncOrdersToSalesforceRequest', syncOrdersToSalesforceRequest)
            const localVarPath = `/sync/salesforce/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncOrdersToSalesforceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Synchronizes Salesforce retailer data with the main database.
         * @param {SyncRetailersToSalesforceRequest} syncRetailersToSalesforceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRetailersToSalesforce: async (syncRetailersToSalesforceRequest: SyncRetailersToSalesforceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'syncRetailersToSalesforceRequest' is not null or undefined
            assertParamExists('syncRetailersToSalesforce', 'syncRetailersToSalesforceRequest', syncRetailersToSalesforceRequest)
            const localVarPath = `/sync/salesforce/retailers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncRetailersToSalesforceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Synchronizes Salesforce Suborder data with the main database.
         * @param {SyncSubordersToSalesforceRequest} syncSubordersToSalesforceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSubordersToSalesforce: async (syncSubordersToSalesforceRequest: SyncSubordersToSalesforceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'syncSubordersToSalesforceRequest' is not null or undefined
            assertParamExists('syncSubordersToSalesforce', 'syncSubordersToSalesforceRequest', syncSubordersToSalesforceRequest)
            const localVarPath = `/sync/salesforce/suborders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncSubordersToSalesforceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sync all trade show entities to Algolia trade show index
         * @param {SyncTradeShowsToAlgoliaRequest} syncTradeShowsToAlgoliaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncTradeShowsToAlgolia: async (syncTradeShowsToAlgoliaRequest: SyncTradeShowsToAlgoliaRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'syncTradeShowsToAlgoliaRequest' is not null or undefined
            assertParamExists('syncTradeShowsToAlgolia', 'syncTradeShowsToAlgoliaRequest', syncTradeShowsToAlgoliaRequest)
            const localVarPath = `/sync/algolia/trade-shows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncTradeShowsToAlgoliaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SyncControllerApi - functional programming interface
 * @export
 */
export const SyncControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SyncControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Update products brand object on Algolia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setUpdateProductsBrandAlgoliaSourceAndEvents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setUpdateProductsBrandAlgoliaSourceAndEvents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SyncControllerApi.setUpdateProductsBrandAlgoliaSourceAndEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Synchronizes Salesforce brand data with the main database.
         * @param {SyncBrandsToSalesforceRequest} syncBrandsToSalesforceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncBrandsToSalesforce(syncBrandsToSalesforceRequest: SyncBrandsToSalesforceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncBrandsToSalesforce(syncBrandsToSalesforceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SyncControllerApi.syncBrandsToSalesforce']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Synchronizes Salesforce Order data with the main database.
         * @param {SyncOrdersToSalesforceRequest} syncOrdersToSalesforceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncOrdersToSalesforce(syncOrdersToSalesforceRequest: SyncOrdersToSalesforceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncOrdersToSalesforce(syncOrdersToSalesforceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SyncControllerApi.syncOrdersToSalesforce']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Synchronizes Salesforce retailer data with the main database.
         * @param {SyncRetailersToSalesforceRequest} syncRetailersToSalesforceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncRetailersToSalesforce(syncRetailersToSalesforceRequest: SyncRetailersToSalesforceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncRetailersToSalesforce(syncRetailersToSalesforceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SyncControllerApi.syncRetailersToSalesforce']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Synchronizes Salesforce Suborder data with the main database.
         * @param {SyncSubordersToSalesforceRequest} syncSubordersToSalesforceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncSubordersToSalesforce(syncSubordersToSalesforceRequest: SyncSubordersToSalesforceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncSubordersToSalesforce(syncSubordersToSalesforceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SyncControllerApi.syncSubordersToSalesforce']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sync all trade show entities to Algolia trade show index
         * @param {SyncTradeShowsToAlgoliaRequest} syncTradeShowsToAlgoliaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncTradeShowsToAlgolia(syncTradeShowsToAlgoliaRequest: SyncTradeShowsToAlgoliaRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncTradeShowsToAlgolia(syncTradeShowsToAlgoliaRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SyncControllerApi.syncTradeShowsToAlgolia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SyncControllerApi - factory interface
 * @export
 */
export const SyncControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SyncControllerApiFp(configuration)
    return {
        /**
         * Update products brand object on Algolia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUpdateProductsBrandAlgoliaSourceAndEvents(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setUpdateProductsBrandAlgoliaSourceAndEvents(options).then((request) => request(axios, basePath));
        },
        /**
         * Synchronizes Salesforce brand data with the main database.
         * @param {SyncBrandsToSalesforceRequest} syncBrandsToSalesforceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncBrandsToSalesforce(syncBrandsToSalesforceRequest: SyncBrandsToSalesforceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncBrandsToSalesforce(syncBrandsToSalesforceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Synchronizes Salesforce Order data with the main database.
         * @param {SyncOrdersToSalesforceRequest} syncOrdersToSalesforceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncOrdersToSalesforce(syncOrdersToSalesforceRequest: SyncOrdersToSalesforceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncOrdersToSalesforce(syncOrdersToSalesforceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Synchronizes Salesforce retailer data with the main database.
         * @param {SyncRetailersToSalesforceRequest} syncRetailersToSalesforceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRetailersToSalesforce(syncRetailersToSalesforceRequest: SyncRetailersToSalesforceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncRetailersToSalesforce(syncRetailersToSalesforceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Synchronizes Salesforce Suborder data with the main database.
         * @param {SyncSubordersToSalesforceRequest} syncSubordersToSalesforceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSubordersToSalesforce(syncSubordersToSalesforceRequest: SyncSubordersToSalesforceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncSubordersToSalesforce(syncSubordersToSalesforceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sync all trade show entities to Algolia trade show index
         * @param {SyncTradeShowsToAlgoliaRequest} syncTradeShowsToAlgoliaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncTradeShowsToAlgolia(syncTradeShowsToAlgoliaRequest: SyncTradeShowsToAlgoliaRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncTradeShowsToAlgolia(syncTradeShowsToAlgoliaRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SyncControllerApi - interface
 * @export
 * @interface SyncControllerApi
 */
export interface SyncControllerApiInterface {
    /**
     * Update products brand object on Algolia
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncControllerApiInterface
     */
    setUpdateProductsBrandAlgoliaSourceAndEvents(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Synchronizes Salesforce brand data with the main database.
     * @param {SyncBrandsToSalesforceRequest} syncBrandsToSalesforceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncControllerApiInterface
     */
    syncBrandsToSalesforce(syncBrandsToSalesforceRequest: SyncBrandsToSalesforceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Synchronizes Salesforce Order data with the main database.
     * @param {SyncOrdersToSalesforceRequest} syncOrdersToSalesforceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncControllerApiInterface
     */
    syncOrdersToSalesforce(syncOrdersToSalesforceRequest: SyncOrdersToSalesforceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Synchronizes Salesforce retailer data with the main database.
     * @param {SyncRetailersToSalesforceRequest} syncRetailersToSalesforceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncControllerApiInterface
     */
    syncRetailersToSalesforce(syncRetailersToSalesforceRequest: SyncRetailersToSalesforceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Synchronizes Salesforce Suborder data with the main database.
     * @param {SyncSubordersToSalesforceRequest} syncSubordersToSalesforceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncControllerApiInterface
     */
    syncSubordersToSalesforce(syncSubordersToSalesforceRequest: SyncSubordersToSalesforceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Sync all trade show entities to Algolia trade show index
     * @param {SyncTradeShowsToAlgoliaRequest} syncTradeShowsToAlgoliaRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncControllerApiInterface
     */
    syncTradeShowsToAlgolia(syncTradeShowsToAlgoliaRequest: SyncTradeShowsToAlgoliaRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * SyncControllerApi - object-oriented interface
 * @export
 * @class SyncControllerApi
 * @extends {BaseAPI}
 */
export class SyncControllerApi extends BaseAPI implements SyncControllerApiInterface {
    /**
     * Update products brand object on Algolia
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncControllerApi
     */
    public setUpdateProductsBrandAlgoliaSourceAndEvents(options?: RawAxiosRequestConfig) {
        return SyncControllerApiFp(this.configuration).setUpdateProductsBrandAlgoliaSourceAndEvents(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Synchronizes Salesforce brand data with the main database.
     * @param {SyncBrandsToSalesforceRequest} syncBrandsToSalesforceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncControllerApi
     */
    public syncBrandsToSalesforce(syncBrandsToSalesforceRequest: SyncBrandsToSalesforceRequest, options?: RawAxiosRequestConfig) {
        return SyncControllerApiFp(this.configuration).syncBrandsToSalesforce(syncBrandsToSalesforceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Synchronizes Salesforce Order data with the main database.
     * @param {SyncOrdersToSalesforceRequest} syncOrdersToSalesforceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncControllerApi
     */
    public syncOrdersToSalesforce(syncOrdersToSalesforceRequest: SyncOrdersToSalesforceRequest, options?: RawAxiosRequestConfig) {
        return SyncControllerApiFp(this.configuration).syncOrdersToSalesforce(syncOrdersToSalesforceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Synchronizes Salesforce retailer data with the main database.
     * @param {SyncRetailersToSalesforceRequest} syncRetailersToSalesforceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncControllerApi
     */
    public syncRetailersToSalesforce(syncRetailersToSalesforceRequest: SyncRetailersToSalesforceRequest, options?: RawAxiosRequestConfig) {
        return SyncControllerApiFp(this.configuration).syncRetailersToSalesforce(syncRetailersToSalesforceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Synchronizes Salesforce Suborder data with the main database.
     * @param {SyncSubordersToSalesforceRequest} syncSubordersToSalesforceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncControllerApi
     */
    public syncSubordersToSalesforce(syncSubordersToSalesforceRequest: SyncSubordersToSalesforceRequest, options?: RawAxiosRequestConfig) {
        return SyncControllerApiFp(this.configuration).syncSubordersToSalesforce(syncSubordersToSalesforceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sync all trade show entities to Algolia trade show index
     * @param {SyncTradeShowsToAlgoliaRequest} syncTradeShowsToAlgoliaRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncControllerApi
     */
    public syncTradeShowsToAlgolia(syncTradeShowsToAlgoliaRequest: SyncTradeShowsToAlgoliaRequest, options?: RawAxiosRequestConfig) {
        return SyncControllerApiFp(this.configuration).syncTradeShowsToAlgolia(syncTradeShowsToAlgoliaRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TestControllerApi - axios parameter creator
 * @export
 */
export const TestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addConnectToShopifyColumn: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/test/draft-brand/add-column`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {AddRandomProductsToBoardRequest} addRandomProductsToBoardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRandomProductsToBoard: async (id: string, addRandomProductsToBoardRequest: AddRandomProductsToBoardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addRandomProductsToBoard', 'id', id)
            // verify required parameter 'addRandomProductsToBoardRequest' is not null or undefined
            assertParamExists('addRandomProductsToBoard', 'addRandomProductsToBoardRequest', addRandomProductsToBoardRequest)
            const localVarPath = `/test/boards/{id}/add-products`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addRandomProductsToBoardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Test connection to dynamo - Add to cart functionality
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addToDynamo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dynamo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Compare products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compareProducts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/test/compare-db-algolia-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateOnboardingBrandRequest} createOnboardingBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOnboardingBrand: async (createOnboardingBrandRequest: CreateOnboardingBrandRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOnboardingBrandRequest' is not null or undefined
            assertParamExists('createOnboardingBrand', 'createOnboardingBrandRequest', createOnboardingBrandRequest)
            const localVarPath = `/test/brands/create-onboarding-brand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOnboardingBrandRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestBrands: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/test/brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create test order
         * @param {CreateOrderRequest} createOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestOrder: async (createOrderRequest: CreateOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOrderRequest' is not null or undefined
            assertParamExists('createTestOrder', 'createOrderRequest', createOrderRequest)
            const localVarPath = `/test/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create test product
         * @param {CreateProductRequest} createProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestProduct: async (createProductRequest: CreateProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductRequest' is not null or undefined
            assertParamExists('createTestProduct', 'createProductRequest', createProductRequest)
            const localVarPath = `/test/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Postgre
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostgre: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/test/postgre/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailer: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRetailer', 'id', id)
            const localVarPath = `/test/retailers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} retailerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailerBalanceAdmin: async (retailerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'retailerId' is not null or undefined
            assertParamExists('getRetailerBalanceAdmin', 'retailerId', retailerId)
            const localVarPath = `/retailers/{retailerId}/balance`
                .replace(`{${"retailerId"}}`, encodeURIComponent(String(retailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailerBalanceRetailer: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/retailers/my-balance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Test the brand import with modified brand attributes provided by the API request.
         * @param {string} eventId 
         * @param {ImportTestExhibitorsRequest} importTestExhibitorsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importTestExhibitors: async (eventId: string, importTestExhibitorsRequest: ImportTestExhibitorsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('importTestExhibitors', 'eventId', eventId)
            // verify required parameter 'importTestExhibitorsRequest' is not null or undefined
            assertParamExists('importTestExhibitors', 'importTestExhibitorsRequest', importTestExhibitorsRequest)
            const localVarPath = `/test/trade-shows/{eventId}/exhibitors`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importTestExhibitorsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnOk: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Test all emails
         * @param {IdWrapper} idWrapper 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testAllEmails: async (idWrapper: IdWrapper, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idWrapper' is not null or undefined
            assertParamExists('testAllEmails', 'idWrapper', idWrapper)
            const localVarPath = `/test/emails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(idWrapper, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Test calendar connection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCalendarConnection: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/test-calendar-connection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testDDSpan: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/test/dd-span`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send Test email (pass template name from EmailConstants)
         * @param {TestEmailRequest} testEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testEmail: async (testEmailRequest: TestEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testEmailRequest' is not null or undefined
            assertParamExists('testEmail', 'testEmailRequest', testEmailRequest)
            const localVarPath = `/test/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Test Postgre
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testPostgre: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/test/postgre`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Test posthook schedule hook and delete the same hook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testPosthook: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/test-posthook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Test ReCaptcha
         * @param {string} gRecaptchaResponse recaptcha response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testReCaptcha: async (gRecaptchaResponse: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gRecaptchaResponse' is not null or undefined
            assertParamExists('testReCaptcha', 'gRecaptchaResponse', gRecaptchaResponse)
            const localVarPath = `/test-recaptcha`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gRecaptchaResponse !== undefined) {
                localVarQueryParameter['g-recaptcha-response'] = gRecaptchaResponse;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/update-product-characteristics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestControllerApi - functional programming interface
 * @export
 */
export const TestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addConnectToShopifyColumn(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addConnectToShopifyColumn(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestControllerApi.addConnectToShopifyColumn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {AddRandomProductsToBoardRequest} addRandomProductsToBoardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addRandomProductsToBoard(id: string, addRandomProductsToBoardRequest: AddRandomProductsToBoardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addRandomProductsToBoard(id, addRandomProductsToBoardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestControllerApi.addRandomProductsToBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Test connection to dynamo - Add to cart functionality
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addToDynamo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addToDynamo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestControllerApi.addToDynamo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Compare products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async compareProducts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.compareProducts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestControllerApi.compareProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateOnboardingBrandRequest} createOnboardingBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOnboardingBrand(createOnboardingBrandRequest: CreateOnboardingBrandRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOnboardingBrand(createOnboardingBrandRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestControllerApi.createOnboardingBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTestBrands(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BrandResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTestBrands(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestControllerApi.createTestBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create test order
         * @param {CreateOrderRequest} createOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTestOrder(createOrderRequest: CreateOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTestOrder(createOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestControllerApi.createTestOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create test product
         * @param {CreateProductRequest} createProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTestProduct(createProductRequest: CreateProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTestProduct(createProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestControllerApi.createTestProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Postgre
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPostgre(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductVariant>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPostgre(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestControllerApi.getPostgre']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRetailer(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRetailerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRetailer(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestControllerApi.getRetailer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} retailerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRetailerBalanceAdmin(retailerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRetailerBalanceAdmin(retailerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestControllerApi.getRetailerBalanceAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRetailerBalanceRetailer(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRetailerBalanceRetailer(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestControllerApi.getRetailerBalanceRetailer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Test the brand import with modified brand attributes provided by the API request.
         * @param {string} eventId 
         * @param {ImportTestExhibitorsRequest} importTestExhibitorsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importTestExhibitors(eventId: string, importTestExhibitorsRequest: ImportTestExhibitorsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importTestExhibitors(eventId, importTestExhibitorsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestControllerApi.importTestExhibitors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async returnOk(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.returnOk(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestControllerApi.returnOk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Test all emails
         * @param {IdWrapper} idWrapper 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testAllEmails(idWrapper: IdWrapper, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testAllEmails(idWrapper, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestControllerApi.testAllEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Test calendar connection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testCalendarConnection(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testCalendarConnection(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestControllerApi.testCalendarConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testDDSpan(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testDDSpan(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestControllerApi.testDDSpan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send Test email (pass template name from EmailConstants)
         * @param {TestEmailRequest} testEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testEmail(testEmailRequest: TestEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testEmail(testEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestControllerApi.testEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Test Postgre
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testPostgre(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testPostgre(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestControllerApi.testPostgre']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Test posthook schedule hook and delete the same hook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testPosthook(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testPosthook(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestControllerApi.testPosthook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Test ReCaptcha
         * @param {string} gRecaptchaResponse recaptcha response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testReCaptcha(gRecaptchaResponse: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testReCaptcha(gRecaptchaResponse, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestControllerApi.testReCaptcha']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProduct1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProduct1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestControllerApi.updateProduct1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestControllerApi - factory interface
 * @export
 */
export const TestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addConnectToShopifyColumn(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addConnectToShopifyColumn(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {AddRandomProductsToBoardRequest} addRandomProductsToBoardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRandomProductsToBoard(id: string, addRandomProductsToBoardRequest: AddRandomProductsToBoardRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addRandomProductsToBoard(id, addRandomProductsToBoardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Test connection to dynamo - Add to cart functionality
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addToDynamo(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addToDynamo(options).then((request) => request(axios, basePath));
        },
        /**
         * Compare products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compareProducts(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.compareProducts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateOnboardingBrandRequest} createOnboardingBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOnboardingBrand(createOnboardingBrandRequest: CreateOnboardingBrandRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper> {
            return localVarFp.createOnboardingBrand(createOnboardingBrandRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestBrands(options?: RawAxiosRequestConfig): AxiosPromise<Array<BrandResponse>> {
            return localVarFp.createTestBrands(options).then((request) => request(axios, basePath));
        },
        /**
         * Create test order
         * @param {CreateOrderRequest} createOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestOrder(createOrderRequest: CreateOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper> {
            return localVarFp.createTestOrder(createOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create test product
         * @param {CreateProductRequest} createProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestProduct(createProductRequest: CreateProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper> {
            return localVarFp.createTestProduct(createProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Postgre
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostgre(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductVariant>> {
            return localVarFp.getPostgre(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailer(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetRetailerResponse> {
            return localVarFp.getRetailer(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} retailerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailerBalanceAdmin(retailerId: string, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getRetailerBalanceAdmin(retailerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRetailerBalanceRetailer(options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getRetailerBalanceRetailer(options).then((request) => request(axios, basePath));
        },
        /**
         * Test the brand import with modified brand attributes provided by the API request.
         * @param {string} eventId 
         * @param {ImportTestExhibitorsRequest} importTestExhibitorsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importTestExhibitors(eventId: string, importTestExhibitorsRequest: ImportTestExhibitorsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.importTestExhibitors(eventId, importTestExhibitorsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnOk(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.returnOk(options).then((request) => request(axios, basePath));
        },
        /**
         * Test all emails
         * @param {IdWrapper} idWrapper 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testAllEmails(idWrapper: IdWrapper, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.testAllEmails(idWrapper, options).then((request) => request(axios, basePath));
        },
        /**
         * Test calendar connection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCalendarConnection(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.testCalendarConnection(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testDDSpan(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.testDDSpan(options).then((request) => request(axios, basePath));
        },
        /**
         * Send Test email (pass template name from EmailConstants)
         * @param {TestEmailRequest} testEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testEmail(testEmailRequest: TestEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.testEmail(testEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Test Postgre
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testPostgre(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.testPostgre(options).then((request) => request(axios, basePath));
        },
        /**
         * Test posthook schedule hook and delete the same hook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testPosthook(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.testPosthook(options).then((request) => request(axios, basePath));
        },
        /**
         * Test ReCaptcha
         * @param {string} gRecaptchaResponse recaptcha response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testReCaptcha(gRecaptchaResponse: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.testReCaptcha(gRecaptchaResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * Update product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct1(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProduct1(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestControllerApi - interface
 * @export
 * @interface TestControllerApi
 */
export interface TestControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApiInterface
     */
    addConnectToShopifyColumn(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {string} id 
     * @param {AddRandomProductsToBoardRequest} addRandomProductsToBoardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApiInterface
     */
    addRandomProductsToBoard(id: string, addRandomProductsToBoardRequest: AddRandomProductsToBoardRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Test connection to dynamo - Add to cart functionality
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApiInterface
     */
    addToDynamo(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Compare products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApiInterface
     */
    compareProducts(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {CreateOnboardingBrandRequest} createOnboardingBrandRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApiInterface
     */
    createOnboardingBrand(createOnboardingBrandRequest: CreateOnboardingBrandRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApiInterface
     */
    createTestBrands(options?: RawAxiosRequestConfig): AxiosPromise<Array<BrandResponse>>;

    /**
     * Create test order
     * @param {CreateOrderRequest} createOrderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApiInterface
     */
    createTestOrder(createOrderRequest: CreateOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper>;

    /**
     * Create test product
     * @param {CreateProductRequest} createProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApiInterface
     */
    createTestProduct(createProductRequest: CreateProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper>;

    /**
     * Get Postgre
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApiInterface
     */
    getPostgre(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductVariant>>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApiInterface
     */
    getRetailer(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetRetailerResponse>;

    /**
     * 
     * @param {string} retailerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApiInterface
     */
    getRetailerBalanceAdmin(retailerId: string, options?: RawAxiosRequestConfig): AxiosPromise<number>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApiInterface
     */
    getRetailerBalanceRetailer(options?: RawAxiosRequestConfig): AxiosPromise<number>;

    /**
     * Test the brand import with modified brand attributes provided by the API request.
     * @param {string} eventId 
     * @param {ImportTestExhibitorsRequest} importTestExhibitorsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApiInterface
     */
    importTestExhibitors(eventId: string, importTestExhibitorsRequest: ImportTestExhibitorsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApiInterface
     */
    returnOk(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Test all emails
     * @param {IdWrapper} idWrapper 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApiInterface
     */
    testAllEmails(idWrapper: IdWrapper, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Test calendar connection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApiInterface
     */
    testCalendarConnection(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApiInterface
     */
    testDDSpan(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Send Test email (pass template name from EmailConstants)
     * @param {TestEmailRequest} testEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApiInterface
     */
    testEmail(testEmailRequest: TestEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Test Postgre
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApiInterface
     */
    testPostgre(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Test posthook schedule hook and delete the same hook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApiInterface
     */
    testPosthook(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Test ReCaptcha
     * @param {string} gRecaptchaResponse recaptcha response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApiInterface
     */
    testReCaptcha(gRecaptchaResponse: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApiInterface
     */
    updateProduct1(options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * TestControllerApi - object-oriented interface
 * @export
 * @class TestControllerApi
 * @extends {BaseAPI}
 */
export class TestControllerApi extends BaseAPI implements TestControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public addConnectToShopifyColumn(options?: RawAxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).addConnectToShopifyColumn(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {AddRandomProductsToBoardRequest} addRandomProductsToBoardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public addRandomProductsToBoard(id: string, addRandomProductsToBoardRequest: AddRandomProductsToBoardRequest, options?: RawAxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).addRandomProductsToBoard(id, addRandomProductsToBoardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Test connection to dynamo - Add to cart functionality
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public addToDynamo(options?: RawAxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).addToDynamo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Compare products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public compareProducts(options?: RawAxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).compareProducts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateOnboardingBrandRequest} createOnboardingBrandRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public createOnboardingBrand(createOnboardingBrandRequest: CreateOnboardingBrandRequest, options?: RawAxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).createOnboardingBrand(createOnboardingBrandRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public createTestBrands(options?: RawAxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).createTestBrands(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create test order
     * @param {CreateOrderRequest} createOrderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public createTestOrder(createOrderRequest: CreateOrderRequest, options?: RawAxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).createTestOrder(createOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create test product
     * @param {CreateProductRequest} createProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public createTestProduct(createProductRequest: CreateProductRequest, options?: RawAxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).createTestProduct(createProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Postgre
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public getPostgre(options?: RawAxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).getPostgre(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public getRetailer(id: string, options?: RawAxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).getRetailer(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} retailerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public getRetailerBalanceAdmin(retailerId: string, options?: RawAxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).getRetailerBalanceAdmin(retailerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public getRetailerBalanceRetailer(options?: RawAxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).getRetailerBalanceRetailer(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Test the brand import with modified brand attributes provided by the API request.
     * @param {string} eventId 
     * @param {ImportTestExhibitorsRequest} importTestExhibitorsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public importTestExhibitors(eventId: string, importTestExhibitorsRequest: ImportTestExhibitorsRequest, options?: RawAxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).importTestExhibitors(eventId, importTestExhibitorsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public returnOk(options?: RawAxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).returnOk(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Test all emails
     * @param {IdWrapper} idWrapper 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public testAllEmails(idWrapper: IdWrapper, options?: RawAxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).testAllEmails(idWrapper, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Test calendar connection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public testCalendarConnection(options?: RawAxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).testCalendarConnection(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public testDDSpan(options?: RawAxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).testDDSpan(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send Test email (pass template name from EmailConstants)
     * @param {TestEmailRequest} testEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public testEmail(testEmailRequest: TestEmailRequest, options?: RawAxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).testEmail(testEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Test Postgre
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public testPostgre(options?: RawAxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).testPostgre(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Test posthook schedule hook and delete the same hook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public testPosthook(options?: RawAxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).testPosthook(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Test ReCaptcha
     * @param {string} gRecaptchaResponse recaptcha response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public testReCaptcha(gRecaptchaResponse: string, options?: RawAxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).testReCaptcha(gRecaptchaResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public updateProduct1(options?: RawAxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).updateProduct1(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TradeShowControllerApi - axios parameter creator
 * @export
 */
export const TradeShowControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add buyer directory header for the specific trade show
         * @param {string} eventId Event Id
         * @param {BuyerDirectoryHeaderRequest} buyerDirectoryHeaderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBuyerDirectoryHeaderDetails: async (eventId: string, buyerDirectoryHeaderRequest: BuyerDirectoryHeaderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('addBuyerDirectoryHeaderDetails', 'eventId', eventId)
            // verify required parameter 'buyerDirectoryHeaderRequest' is not null or undefined
            assertParamExists('addBuyerDirectoryHeaderDetails', 'buyerDirectoryHeaderRequest', buyerDirectoryHeaderRequest)
            const localVarPath = `/trade-shows/{eventId}/buyer-directory-header`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(buyerDirectoryHeaderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add exhibitor directory header for the specific trade show
         * @param {string} eventId Event Id
         * @param {ExhibitorDirectoryHeaderRequest} exhibitorDirectoryHeaderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addExhibitorDirectoryHeaderDetails: async (eventId: string, exhibitorDirectoryHeaderRequest: ExhibitorDirectoryHeaderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('addExhibitorDirectoryHeaderDetails', 'eventId', eventId)
            // verify required parameter 'exhibitorDirectoryHeaderRequest' is not null or undefined
            assertParamExists('addExhibitorDirectoryHeaderDetails', 'exhibitorDirectoryHeaderRequest', exhibitorDirectoryHeaderRequest)
            const localVarPath = `/trade-shows/{eventId}/exhibitor-directory-header`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exhibitorDirectoryHeaderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive trade show
         * @param {string} eventId TradeShow event Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveTradeShow: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('archiveTradeShow', 'eventId', eventId)
            const localVarPath = `/trade-shows/{eventId}/archive`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new trade show
         * @param {CreateTradeShowRequest} createTradeShowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTradeShow: async (createTradeShowRequest: CreateTradeShowRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTradeShowRequest' is not null or undefined
            assertParamExists('createTradeShow', 'createTradeShowRequest', createTradeShowRequest)
            const localVarPath = `/trade-shows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTradeShowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete trade show
         * @param {string} id TradeShow Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTradeShow: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTradeShow', 'id', id)
            const localVarPath = `/trade-shows/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export trade show exhibitors to the CSV file.
         * @param {string} eventId Event Id
         * @param {ExportTradeShowExhibitorsToCSVRequest} exportTradeShowExhibitorsToCSVRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTradeShowExhibitorsToCSV: async (eventId: string, exportTradeShowExhibitorsToCSVRequest: ExportTradeShowExhibitorsToCSVRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('exportTradeShowExhibitorsToCSV', 'eventId', eventId)
            // verify required parameter 'exportTradeShowExhibitorsToCSVRequest' is not null or undefined
            assertParamExists('exportTradeShowExhibitorsToCSV', 'exportTradeShowExhibitorsToCSVRequest', exportTradeShowExhibitorsToCSVRequest)
            const localVarPath = `/trade-shows/{eventId}/exhibitors-export`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportTradeShowExhibitorsToCSVRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enables the connection between A2z and NY NOW Online.
         * @param {ConfirmOrCreateA2zBrandConnectionRequest} confirmOrCreateA2zBrandConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getA2zConnectionResponse: async (confirmOrCreateA2zBrandConnectionRequest: ConfirmOrCreateA2zBrandConnectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'confirmOrCreateA2zBrandConnectionRequest' is not null or undefined
            assertParamExists('getA2zConnectionResponse', 'confirmOrCreateA2zBrandConnectionRequest', confirmOrCreateA2zBrandConnectionRequest)
            const localVarPath = `/trade-shows/confirm-or-create-event-and-brand-connection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmOrCreateA2zBrandConnectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of sections for a given Trade Show ID
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveTradeShowSections: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getActiveTradeShowSections', 'eventId', eventId)
            const localVarPath = `/trade-shows/{eventId}/sections`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get active trade shows
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getActiveTradeShows: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/trade-shows/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Admin view of all Trade Shows
         * @param {string} [status] Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTradeShows: async (status?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/trade-shows/admin-view`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all available trade show brands.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTradeShowBrands: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/trade-shows/trade-show-brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get exhibitor directory header by trade show id
         * @param {string} eventId Event Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuyerDirectoryHeaderDetails: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getBuyerDirectoryHeaderDetails', 'eventId', eventId)
            const localVarPath = `/trade-shows/{eventId}/buyer-directory-header`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get exhibitor directory header by trade show id
         * @param {string} eventId Event Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExhibitorDirectoryHeaderDetails: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getExhibitorDirectoryHeaderDetails', 'eventId', eventId)
            const localVarPath = `/trade-shows/{eventId}/exhibitor-directory-header`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of exhibitors for the current trade show from A2z. This API is available in case a manual trigger is needed. 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExhibitors: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getExhibitors', 'eventId', eventId)
            const localVarPath = `/trade-shows/{eventId}/exhibitors`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of featured exhibitors.
         * @param {string} eventId 
         * @param {number} [offset] Offset
         * @param {number} [size] Size
         * @param {string} [seed] Seed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeaturedExhibitors: async (eventId: string, offset?: number, size?: number, seed?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getFeaturedExhibitors', 'eventId', eventId)
            const localVarPath = `/trade-shows/{eventId}/featured-exhibitors`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (seed !== undefined) {
                localVarQueryParameter['seed'] = seed;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get marketing category values by trade show ID
         * @param {string} eventId Event Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingCategoryValuesByTradeShow: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getMarketingCategoryValuesByTradeShow', 'eventId', eventId)
            const localVarPath = `/trade-shows/{eventId}/marketing-category-values`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Trade Show Buyers by eventId
         * @param {string} eventId Event Id
         * @param {number} page Page
         * @param {number} size Size
         * @param {string} sortOrder Order
         * @param {string} [state] State
         * @param {string} [country] Country
         * @param {string} [sections] Sections
         * @param {string} [search] Search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradeShowBuyers: async (eventId: string, page: number, size: number, sortOrder: string, state?: string, country?: string, sections?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getTradeShowBuyers', 'eventId', eventId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getTradeShowBuyers', 'page', page)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('getTradeShowBuyers', 'size', size)
            // verify required parameter 'sortOrder' is not null or undefined
            assertParamExists('getTradeShowBuyers', 'sortOrder', sortOrder)
            const localVarPath = `/trade-shows/{eventId}/buyer-directory`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (sections !== undefined) {
                localVarQueryParameter['sections'] = sections;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get trade show by event id
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradeShowByEventId: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getTradeShowByEventId', 'eventId', eventId)
            const localVarPath = `/trade-shows/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Trade Show Countries by eventId
         * @param {string} eventId Event Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradeShowCountries: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getTradeShowCountries', 'eventId', eventId)
            const localVarPath = `/trade-shows/{eventId}/countries`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Admin view of the specific Trade Show (by eventId)
         * @param {string} eventId Event Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradeShowDetailsByEventId: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getTradeShowDetailsByEventId', 'eventId', eventId)
            const localVarPath = `/trade-shows/{eventId}/admin-view`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradeShowEnabledFeatures: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/trade-shows/enabled-features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all levers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradeShowLevers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/trade-shows/levers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of recommended brands by trade show ID
         * @param {string} eventId Event Id
         * @param {string} brandId Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradeShowRecommendedBrands: async (eventId: string, brandId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getTradeShowRecommendedBrands', 'eventId', eventId)
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getTradeShowRecommendedBrands', 'brandId', brandId)
            const localVarPath = `/trade-shows/{eventId}/brand/{brandId}/recommended-brands`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get trade shows with active exhibitor or buyer directory feature for a brand
         * @param {string} brandSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradeShowsWithActiveExhibitorOrBuyerDirectoryByBrand: async (brandSlug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandSlug' is not null or undefined
            assertParamExists('getTradeShowsWithActiveExhibitorOrBuyerDirectoryByBrand', 'brandSlug', brandSlug)
            const localVarPath = `/trade-shows/{brandSlug}/brand`
                .replace(`{${"brandSlug"}}`, encodeURIComponent(String(brandSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import exhibitors from Bulletin Incubator.
         * @param {ImportBulletinIncubatorBrandsRequest} importBulletinIncubatorBrandsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importBulletinIncubatorBrands: async (importBulletinIncubatorBrandsRequest: ImportBulletinIncubatorBrandsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importBulletinIncubatorBrandsRequest' is not null or undefined
            assertParamExists('importBulletinIncubatorBrands', 'importBulletinIncubatorBrandsRequest', importBulletinIncubatorBrandsRequest)
            const localVarPath = `/trade-shows/bulletin-incubator/exhibitors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importBulletinIncubatorBrandsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import trade show brand from A2z with specific company id
         * @param {string} eventId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importTradeShowBrandByCompanyId: async (eventId: string, companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('importTradeShowBrandByCompanyId', 'eventId', eventId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('importTradeShowBrandByCompanyId', 'companyId', companyId)
            const localVarPath = `/trade-shows/{eventId}/coid/{companyId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Link retailers with trade show and change their status to be approved.
         * @param {string} eventId Event Id
         * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkRetailersWithTradeShow: async (eventId: string, linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('linkRetailersWithTradeShow', 'eventId', eventId)
            const localVarPath = `/trade-shows/{eventId}/link-retailers`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(linkRetailersWithTradeShowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The end date of existing levers should not overlap with the start of these levers.
         * @param {PreventEndDateOverlapRequest} preventEndDateOverlapRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preventEndDateOverlap: async (preventEndDateOverlapRequest: PreventEndDateOverlapRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preventEndDateOverlapRequest' is not null or undefined
            assertParamExists('preventEndDateOverlap', 'preventEndDateOverlapRequest', preventEndDateOverlapRequest)
            const localVarPath = `/trade-shows/levers/prevent-end-date-overlap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(preventEndDateOverlapRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReindexTradeShowBrandRequest} reindexTradeShowBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexTradeShowBrands: async (reindexTradeShowBrandRequest: ReindexTradeShowBrandRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reindexTradeShowBrandRequest' is not null or undefined
            assertParamExists('reindexTradeShowBrands', 'reindexTradeShowBrandRequest', reindexTradeShowBrandRequest)
            const localVarPath = `/trade-shows/brands/reindex`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reindexTradeShowBrandRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resend trade show attendees welcome email for the retailers that have not changed their password
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendTradeShowAttendeesWelcomeEmail: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('resendTradeShowAttendeesWelcomeEmail', 'eventId', eventId)
            const localVarPath = `/trade-shows/{eventId}/resend-retailer-welcome-email`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send trade show attendees welcome email fron the specific event
         * @param {string} eventId 
         * @param {SendWelcomeEmailToTradeShowAttendeesRequest} sendWelcomeEmailToTradeShowAttendeesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTradeShowAttendeesWelcomeEmail: async (eventId: string, sendWelcomeEmailToTradeShowAttendeesRequest: SendWelcomeEmailToTradeShowAttendeesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('sendTradeShowAttendeesWelcomeEmail', 'eventId', eventId)
            // verify required parameter 'sendWelcomeEmailToTradeShowAttendeesRequest' is not null or undefined
            assertParamExists('sendTradeShowAttendeesWelcomeEmail', 'sendWelcomeEmailToTradeShowAttendeesRequest', sendWelcomeEmailToTradeShowAttendeesRequest)
            const localVarPath = `/trade-shows/{eventId}/send-retailer-welcome-email`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendWelcomeEmailToTradeShowAttendeesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is a utility endpoint to manually send trade show welcome emails in case of need.
         * @param {string} eventId Event Id
         * @param {SendTradeShowWelcomeEmailsRequest} sendTradeShowWelcomeEmailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTradeShowWelcomeEmailsToBrands: async (eventId: string, sendTradeShowWelcomeEmailsRequest: SendTradeShowWelcomeEmailsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('sendTradeShowWelcomeEmailsToBrands', 'eventId', eventId)
            // verify required parameter 'sendTradeShowWelcomeEmailsRequest' is not null or undefined
            assertParamExists('sendTradeShowWelcomeEmailsToBrands', 'sendTradeShowWelcomeEmailsRequest', sendTradeShowWelcomeEmailsRequest)
            const localVarPath = `/trade-shows/{eventId}/send-welcome-emails`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendTradeShowWelcomeEmailsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update trade show
         * @param {string} id TradeShow Id
         * @param {UpdateTradeShowRequest} updateTradeShowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTradeShow: async (id: string, updateTradeShowRequest: UpdateTradeShowRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTradeShow', 'id', id)
            // verify required parameter 'updateTradeShowRequest' is not null or undefined
            assertParamExists('updateTradeShow', 'updateTradeShowRequest', updateTradeShowRequest)
            const localVarPath = `/trade-shows/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTradeShowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update links related to the selected trade show.
         * @param {string} id 
         * @param {UpdateTradeShowLinksRequest} updateTradeShowLinksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTradeShowLinks: async (id: string, updateTradeShowLinksRequest: UpdateTradeShowLinksRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTradeShowLinks', 'id', id)
            // verify required parameter 'updateTradeShowLinksRequest' is not null or undefined
            assertParamExists('updateTradeShowLinks', 'updateTradeShowLinksRequest', updateTradeShowLinksRequest)
            const localVarPath = `/trade-shows/{id}/links`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTradeShowLinksRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TradeShowControllerApi - functional programming interface
 * @export
 */
export const TradeShowControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TradeShowControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add buyer directory header for the specific trade show
         * @param {string} eventId Event Id
         * @param {BuyerDirectoryHeaderRequest} buyerDirectoryHeaderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addBuyerDirectoryHeaderDetails(eventId: string, buyerDirectoryHeaderRequest: BuyerDirectoryHeaderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuyerDirectoryHeaderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addBuyerDirectoryHeaderDetails(eventId, buyerDirectoryHeaderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.addBuyerDirectoryHeaderDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add exhibitor directory header for the specific trade show
         * @param {string} eventId Event Id
         * @param {ExhibitorDirectoryHeaderRequest} exhibitorDirectoryHeaderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addExhibitorDirectoryHeaderDetails(eventId: string, exhibitorDirectoryHeaderRequest: ExhibitorDirectoryHeaderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExhibitorDirectoryHeaderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addExhibitorDirectoryHeaderDetails(eventId, exhibitorDirectoryHeaderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.addExhibitorDirectoryHeaderDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive trade show
         * @param {string} eventId TradeShow event Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveTradeShow(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveTradeShow(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.archiveTradeShow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new trade show
         * @param {CreateTradeShowRequest} createTradeShowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTradeShow(createTradeShowRequest: CreateTradeShowRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTradeShow(createTradeShowRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.createTradeShow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete trade show
         * @param {string} id TradeShow Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTradeShow(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTradeShow(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.deleteTradeShow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export trade show exhibitors to the CSV file.
         * @param {string} eventId Event Id
         * @param {ExportTradeShowExhibitorsToCSVRequest} exportTradeShowExhibitorsToCSVRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportTradeShowExhibitorsToCSV(eventId: string, exportTradeShowExhibitorsToCSVRequest: ExportTradeShowExhibitorsToCSVRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportTradeShowExhibitorsToCSV(eventId, exportTradeShowExhibitorsToCSVRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.exportTradeShowExhibitorsToCSV']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Enables the connection between A2z and NY NOW Online.
         * @param {ConfirmOrCreateA2zBrandConnectionRequest} confirmOrCreateA2zBrandConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getA2zConnectionResponse(confirmOrCreateA2zBrandConnectionRequest: ConfirmOrCreateA2zBrandConnectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<A2zConnectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getA2zConnectionResponse(confirmOrCreateA2zBrandConnectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.getA2zConnectionResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get list of sections for a given Trade Show ID
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveTradeShowSections(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveTradeShowSections(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.getActiveTradeShowSections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get active trade shows
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getActiveTradeShows(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TradeShowResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveTradeShows(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.getActiveTradeShows']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Admin view of all Trade Shows
         * @param {string} [status] Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTradeShows(status?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllTradeShowsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTradeShows(status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.getAllTradeShows']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all available trade show brands.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableTradeShowBrands(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAvailableTradeShowBrandsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableTradeShowBrands(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.getAvailableTradeShowBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get exhibitor directory header by trade show id
         * @param {string} eventId Event Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBuyerDirectoryHeaderDetails(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuyerDirectoryHeaderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBuyerDirectoryHeaderDetails(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.getBuyerDirectoryHeaderDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get exhibitor directory header by trade show id
         * @param {string} eventId Event Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExhibitorDirectoryHeaderDetails(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExhibitorDirectoryHeaderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExhibitorDirectoryHeaderDetails(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.getExhibitorDirectoryHeaderDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch a list of exhibitors for the current trade show from A2z. This API is available in case a manual trigger is needed. 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExhibitors(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExhibitors(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.getExhibitors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get list of featured exhibitors.
         * @param {string} eventId 
         * @param {number} [offset] Offset
         * @param {number} [size] Size
         * @param {string} [seed] Seed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeaturedExhibitors(eventId: string, offset?: number, size?: number, seed?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedGetFeaturedExhibitorsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeaturedExhibitors(eventId, offset, size, seed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.getFeaturedExhibitors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get marketing category values by trade show ID
         * @param {string} eventId Event Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarketingCategoryValuesByTradeShow(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingCategoriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketingCategoryValuesByTradeShow(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.getMarketingCategoryValuesByTradeShow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Trade Show Buyers by eventId
         * @param {string} eventId Event Id
         * @param {number} page Page
         * @param {number} size Size
         * @param {string} sortOrder Order
         * @param {string} [state] State
         * @param {string} [country] Country
         * @param {string} [sections] Sections
         * @param {string} [search] Search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTradeShowBuyers(eventId: string, page: number, size: number, sortOrder: string, state?: string, country?: string, sections?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTradeShowBuyersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTradeShowBuyers(eventId, page, size, sortOrder, state, country, sections, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.getTradeShowBuyers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get trade show by event id
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTradeShowByEventId(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TradeShowResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTradeShowByEventId(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.getTradeShowByEventId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Trade Show Countries by eventId
         * @param {string} eventId Event Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTradeShowCountries(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TradeShowCountryResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTradeShowCountries(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.getTradeShowCountries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Admin view of the specific Trade Show (by eventId)
         * @param {string} eventId Event Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTradeShowDetailsByEventId(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTradeShowByEventIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTradeShowDetailsByEventId(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.getTradeShowDetailsByEventId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTradeShowEnabledFeatures(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TradeShowEnabledFeaturesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTradeShowEnabledFeatures(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.getTradeShowEnabledFeatures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all levers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTradeShowLevers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeversResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTradeShowLevers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.getTradeShowLevers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get list of recommended brands by trade show ID
         * @param {string} eventId Event Id
         * @param {string} brandId Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTradeShowRecommendedBrands(eventId: string, brandId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTradeShowRecommendedBrandsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTradeShowRecommendedBrands(eventId, brandId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.getTradeShowRecommendedBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get trade shows with active exhibitor or buyer directory feature for a brand
         * @param {string} brandSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTradeShowsWithActiveExhibitorOrBuyerDirectoryByBrand(brandSlug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TradeShowResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTradeShowsWithActiveExhibitorOrBuyerDirectoryByBrand(brandSlug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.getTradeShowsWithActiveExhibitorOrBuyerDirectoryByBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import exhibitors from Bulletin Incubator.
         * @param {ImportBulletinIncubatorBrandsRequest} importBulletinIncubatorBrandsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importBulletinIncubatorBrands(importBulletinIncubatorBrandsRequest: ImportBulletinIncubatorBrandsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importBulletinIncubatorBrands(importBulletinIncubatorBrandsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.importBulletinIncubatorBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import trade show brand from A2z with specific company id
         * @param {string} eventId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importTradeShowBrandByCompanyId(eventId: string, companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importTradeShowBrandByCompanyId(eventId, companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.importTradeShowBrandByCompanyId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Link retailers with trade show and change their status to be approved.
         * @param {string} eventId Event Id
         * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkRetailersWithTradeShow(eventId: string, linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkRetailersWithTradeShow(eventId, linkRetailersWithTradeShowRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.linkRetailersWithTradeShow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The end date of existing levers should not overlap with the start of these levers.
         * @param {PreventEndDateOverlapRequest} preventEndDateOverlapRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async preventEndDateOverlap(preventEndDateOverlapRequest: PreventEndDateOverlapRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TradeShowFeatureResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.preventEndDateOverlap(preventEndDateOverlapRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.preventEndDateOverlap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ReindexTradeShowBrandRequest} reindexTradeShowBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindexTradeShowBrands(reindexTradeShowBrandRequest: ReindexTradeShowBrandRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindexTradeShowBrands(reindexTradeShowBrandRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.reindexTradeShowBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resend trade show attendees welcome email for the retailers that have not changed their password
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendTradeShowAttendeesWelcomeEmail(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendTradeShowAttendeesWelcomeEmail(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.resendTradeShowAttendeesWelcomeEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send trade show attendees welcome email fron the specific event
         * @param {string} eventId 
         * @param {SendWelcomeEmailToTradeShowAttendeesRequest} sendWelcomeEmailToTradeShowAttendeesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendTradeShowAttendeesWelcomeEmail(eventId: string, sendWelcomeEmailToTradeShowAttendeesRequest: SendWelcomeEmailToTradeShowAttendeesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendTradeShowAttendeesWelcomeEmail(eventId, sendWelcomeEmailToTradeShowAttendeesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.sendTradeShowAttendeesWelcomeEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This is a utility endpoint to manually send trade show welcome emails in case of need.
         * @param {string} eventId Event Id
         * @param {SendTradeShowWelcomeEmailsRequest} sendTradeShowWelcomeEmailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendTradeShowWelcomeEmailsToBrands(eventId: string, sendTradeShowWelcomeEmailsRequest: SendTradeShowWelcomeEmailsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendTradeShowWelcomeEmailsToBrands(eventId, sendTradeShowWelcomeEmailsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.sendTradeShowWelcomeEmailsToBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update trade show
         * @param {string} id TradeShow Id
         * @param {UpdateTradeShowRequest} updateTradeShowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTradeShow(id: string, updateTradeShowRequest: UpdateTradeShowRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTradeShow(id, updateTradeShowRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.updateTradeShow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update links related to the selected trade show.
         * @param {string} id 
         * @param {UpdateTradeShowLinksRequest} updateTradeShowLinksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTradeShowLinks(id: string, updateTradeShowLinksRequest: UpdateTradeShowLinksRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTradeShowLinks(id, updateTradeShowLinksRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TradeShowControllerApi.updateTradeShowLinks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TradeShowControllerApi - factory interface
 * @export
 */
export const TradeShowControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TradeShowControllerApiFp(configuration)
    return {
        /**
         * Add buyer directory header for the specific trade show
         * @param {string} eventId Event Id
         * @param {BuyerDirectoryHeaderRequest} buyerDirectoryHeaderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBuyerDirectoryHeaderDetails(eventId: string, buyerDirectoryHeaderRequest: BuyerDirectoryHeaderRequest, options?: RawAxiosRequestConfig): AxiosPromise<BuyerDirectoryHeaderResponse> {
            return localVarFp.addBuyerDirectoryHeaderDetails(eventId, buyerDirectoryHeaderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add exhibitor directory header for the specific trade show
         * @param {string} eventId Event Id
         * @param {ExhibitorDirectoryHeaderRequest} exhibitorDirectoryHeaderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addExhibitorDirectoryHeaderDetails(eventId: string, exhibitorDirectoryHeaderRequest: ExhibitorDirectoryHeaderRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExhibitorDirectoryHeaderResponse> {
            return localVarFp.addExhibitorDirectoryHeaderDetails(eventId, exhibitorDirectoryHeaderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive trade show
         * @param {string} eventId TradeShow event Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveTradeShow(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.archiveTradeShow(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new trade show
         * @param {CreateTradeShowRequest} createTradeShowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTradeShow(createTradeShowRequest: CreateTradeShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper> {
            return localVarFp.createTradeShow(createTradeShowRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete trade show
         * @param {string} id TradeShow Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTradeShow(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTradeShow(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Export trade show exhibitors to the CSV file.
         * @param {string} eventId Event Id
         * @param {ExportTradeShowExhibitorsToCSVRequest} exportTradeShowExhibitorsToCSVRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTradeShowExhibitorsToCSV(eventId: string, exportTradeShowExhibitorsToCSVRequest: ExportTradeShowExhibitorsToCSVRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportTradeShowExhibitorsToCSV(eventId, exportTradeShowExhibitorsToCSVRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Enables the connection between A2z and NY NOW Online.
         * @param {ConfirmOrCreateA2zBrandConnectionRequest} confirmOrCreateA2zBrandConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getA2zConnectionResponse(confirmOrCreateA2zBrandConnectionRequest: ConfirmOrCreateA2zBrandConnectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<A2zConnectionResponse> {
            return localVarFp.getA2zConnectionResponse(confirmOrCreateA2zBrandConnectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of sections for a given Trade Show ID
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveTradeShowSections(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getActiveTradeShowSections(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get active trade shows
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getActiveTradeShows(options?: RawAxiosRequestConfig): AxiosPromise<Array<TradeShowResponse>> {
            return localVarFp.getActiveTradeShows(options).then((request) => request(axios, basePath));
        },
        /**
         * Get Admin view of all Trade Shows
         * @param {string} [status] Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTradeShows(status?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetAllTradeShowsResponse> {
            return localVarFp.getAllTradeShows(status, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all available trade show brands.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTradeShowBrands(options?: RawAxiosRequestConfig): AxiosPromise<GetAvailableTradeShowBrandsResponse> {
            return localVarFp.getAvailableTradeShowBrands(options).then((request) => request(axios, basePath));
        },
        /**
         * Get exhibitor directory header by trade show id
         * @param {string} eventId Event Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuyerDirectoryHeaderDetails(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<BuyerDirectoryHeaderResponse> {
            return localVarFp.getBuyerDirectoryHeaderDetails(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get exhibitor directory header by trade show id
         * @param {string} eventId Event Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExhibitorDirectoryHeaderDetails(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<ExhibitorDirectoryHeaderResponse> {
            return localVarFp.getExhibitorDirectoryHeaderDetails(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch a list of exhibitors for the current trade show from A2z. This API is available in case a manual trigger is needed. 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExhibitors(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getExhibitors(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of featured exhibitors.
         * @param {string} eventId 
         * @param {number} [offset] Offset
         * @param {number} [size] Size
         * @param {string} [seed] Seed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeaturedExhibitors(eventId: string, offset?: number, size?: number, seed?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedGetFeaturedExhibitorsResponse> {
            return localVarFp.getFeaturedExhibitors(eventId, offset, size, seed, options).then((request) => request(axios, basePath));
        },
        /**
         * Get marketing category values by trade show ID
         * @param {string} eventId Event Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingCategoryValuesByTradeShow(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<MarketingCategoriesResponse> {
            return localVarFp.getMarketingCategoryValuesByTradeShow(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Trade Show Buyers by eventId
         * @param {string} eventId Event Id
         * @param {number} page Page
         * @param {number} size Size
         * @param {string} sortOrder Order
         * @param {string} [state] State
         * @param {string} [country] Country
         * @param {string} [sections] Sections
         * @param {string} [search] Search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradeShowBuyers(eventId: string, page: number, size: number, sortOrder: string, state?: string, country?: string, sections?: string, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetTradeShowBuyersResponse> {
            return localVarFp.getTradeShowBuyers(eventId, page, size, sortOrder, state, country, sections, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Get trade show by event id
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradeShowByEventId(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<TradeShowResponse> {
            return localVarFp.getTradeShowByEventId(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Trade Show Countries by eventId
         * @param {string} eventId Event Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradeShowCountries(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TradeShowCountryResponse>> {
            return localVarFp.getTradeShowCountries(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Admin view of the specific Trade Show (by eventId)
         * @param {string} eventId Event Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradeShowDetailsByEventId(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetTradeShowByEventIdResponse> {
            return localVarFp.getTradeShowDetailsByEventId(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradeShowEnabledFeatures(options?: RawAxiosRequestConfig): AxiosPromise<TradeShowEnabledFeaturesResponse> {
            return localVarFp.getTradeShowEnabledFeatures(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all levers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradeShowLevers(options?: RawAxiosRequestConfig): AxiosPromise<LeversResponse> {
            return localVarFp.getTradeShowLevers(options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of recommended brands by trade show ID
         * @param {string} eventId Event Id
         * @param {string} brandId Brand Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradeShowRecommendedBrands(eventId: string, brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetTradeShowRecommendedBrandsResponse> {
            return localVarFp.getTradeShowRecommendedBrands(eventId, brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get trade shows with active exhibitor or buyer directory feature for a brand
         * @param {string} brandSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradeShowsWithActiveExhibitorOrBuyerDirectoryByBrand(brandSlug: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TradeShowResponse>> {
            return localVarFp.getTradeShowsWithActiveExhibitorOrBuyerDirectoryByBrand(brandSlug, options).then((request) => request(axios, basePath));
        },
        /**
         * Import exhibitors from Bulletin Incubator.
         * @param {ImportBulletinIncubatorBrandsRequest} importBulletinIncubatorBrandsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importBulletinIncubatorBrands(importBulletinIncubatorBrandsRequest: ImportBulletinIncubatorBrandsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.importBulletinIncubatorBrands(importBulletinIncubatorBrandsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Import trade show brand from A2z with specific company id
         * @param {string} eventId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importTradeShowBrandByCompanyId(eventId: string, companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.importTradeShowBrandByCompanyId(eventId, companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Link retailers with trade show and change their status to be approved.
         * @param {string} eventId Event Id
         * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkRetailersWithTradeShow(eventId: string, linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.linkRetailersWithTradeShow(eventId, linkRetailersWithTradeShowRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The end date of existing levers should not overlap with the start of these levers.
         * @param {PreventEndDateOverlapRequest} preventEndDateOverlapRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preventEndDateOverlap(preventEndDateOverlapRequest: PreventEndDateOverlapRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TradeShowFeatureResponse>> {
            return localVarFp.preventEndDateOverlap(preventEndDateOverlapRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReindexTradeShowBrandRequest} reindexTradeShowBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexTradeShowBrands(reindexTradeShowBrandRequest: ReindexTradeShowBrandRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reindexTradeShowBrands(reindexTradeShowBrandRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Resend trade show attendees welcome email for the retailers that have not changed their password
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendTradeShowAttendeesWelcomeEmail(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resendTradeShowAttendeesWelcomeEmail(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Send trade show attendees welcome email fron the specific event
         * @param {string} eventId 
         * @param {SendWelcomeEmailToTradeShowAttendeesRequest} sendWelcomeEmailToTradeShowAttendeesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTradeShowAttendeesWelcomeEmail(eventId: string, sendWelcomeEmailToTradeShowAttendeesRequest: SendWelcomeEmailToTradeShowAttendeesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendTradeShowAttendeesWelcomeEmail(eventId, sendWelcomeEmailToTradeShowAttendeesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This is a utility endpoint to manually send trade show welcome emails in case of need.
         * @param {string} eventId Event Id
         * @param {SendTradeShowWelcomeEmailsRequest} sendTradeShowWelcomeEmailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTradeShowWelcomeEmailsToBrands(eventId: string, sendTradeShowWelcomeEmailsRequest: SendTradeShowWelcomeEmailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendTradeShowWelcomeEmailsToBrands(eventId, sendTradeShowWelcomeEmailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update trade show
         * @param {string} id TradeShow Id
         * @param {UpdateTradeShowRequest} updateTradeShowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTradeShow(id: string, updateTradeShowRequest: UpdateTradeShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateTradeShow(id, updateTradeShowRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update links related to the selected trade show.
         * @param {string} id 
         * @param {UpdateTradeShowLinksRequest} updateTradeShowLinksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTradeShowLinks(id: string, updateTradeShowLinksRequest: UpdateTradeShowLinksRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateTradeShowLinks(id, updateTradeShowLinksRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TradeShowControllerApi - interface
 * @export
 * @interface TradeShowControllerApi
 */
export interface TradeShowControllerApiInterface {
    /**
     * Add buyer directory header for the specific trade show
     * @param {string} eventId Event Id
     * @param {BuyerDirectoryHeaderRequest} buyerDirectoryHeaderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    addBuyerDirectoryHeaderDetails(eventId: string, buyerDirectoryHeaderRequest: BuyerDirectoryHeaderRequest, options?: RawAxiosRequestConfig): AxiosPromise<BuyerDirectoryHeaderResponse>;

    /**
     * Add exhibitor directory header for the specific trade show
     * @param {string} eventId Event Id
     * @param {ExhibitorDirectoryHeaderRequest} exhibitorDirectoryHeaderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    addExhibitorDirectoryHeaderDetails(eventId: string, exhibitorDirectoryHeaderRequest: ExhibitorDirectoryHeaderRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExhibitorDirectoryHeaderResponse>;

    /**
     * Archive trade show
     * @param {string} eventId TradeShow event Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    archiveTradeShow(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Create a new trade show
     * @param {CreateTradeShowRequest} createTradeShowRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    createTradeShow(createTradeShowRequest: CreateTradeShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper>;

    /**
     * Delete trade show
     * @param {string} id TradeShow Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    deleteTradeShow(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Export trade show exhibitors to the CSV file.
     * @param {string} eventId Event Id
     * @param {ExportTradeShowExhibitorsToCSVRequest} exportTradeShowExhibitorsToCSVRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    exportTradeShowExhibitorsToCSV(eventId: string, exportTradeShowExhibitorsToCSVRequest: ExportTradeShowExhibitorsToCSVRequest, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * Enables the connection between A2z and NY NOW Online.
     * @param {ConfirmOrCreateA2zBrandConnectionRequest} confirmOrCreateA2zBrandConnectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    getA2zConnectionResponse(confirmOrCreateA2zBrandConnectionRequest: ConfirmOrCreateA2zBrandConnectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<A2zConnectionResponse>;

    /**
     * Get list of sections for a given Trade Show ID
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    getActiveTradeShowSections(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>>;

    /**
     * Get active trade shows
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    getActiveTradeShows(options?: RawAxiosRequestConfig): AxiosPromise<Array<TradeShowResponse>>;

    /**
     * Get Admin view of all Trade Shows
     * @param {string} [status] Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    getAllTradeShows(status?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetAllTradeShowsResponse>;

    /**
     * Get all available trade show brands.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    getAvailableTradeShowBrands(options?: RawAxiosRequestConfig): AxiosPromise<GetAvailableTradeShowBrandsResponse>;

    /**
     * Get exhibitor directory header by trade show id
     * @param {string} eventId Event Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    getBuyerDirectoryHeaderDetails(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<BuyerDirectoryHeaderResponse>;

    /**
     * Get exhibitor directory header by trade show id
     * @param {string} eventId Event Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    getExhibitorDirectoryHeaderDetails(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<ExhibitorDirectoryHeaderResponse>;

    /**
     * Fetch a list of exhibitors for the current trade show from A2z. This API is available in case a manual trigger is needed. 
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    getExhibitors(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Get list of featured exhibitors.
     * @param {string} eventId 
     * @param {number} [offset] Offset
     * @param {number} [size] Size
     * @param {string} [seed] Seed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    getFeaturedExhibitors(eventId: string, offset?: number, size?: number, seed?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedGetFeaturedExhibitorsResponse>;

    /**
     * Get marketing category values by trade show ID
     * @param {string} eventId Event Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    getMarketingCategoryValuesByTradeShow(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<MarketingCategoriesResponse>;

    /**
     * Get Trade Show Buyers by eventId
     * @param {string} eventId Event Id
     * @param {number} page Page
     * @param {number} size Size
     * @param {string} sortOrder Order
     * @param {string} [state] State
     * @param {string} [country] Country
     * @param {string} [sections] Sections
     * @param {string} [search] Search
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    getTradeShowBuyers(eventId: string, page: number, size: number, sortOrder: string, state?: string, country?: string, sections?: string, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetTradeShowBuyersResponse>;

    /**
     * Get trade show by event id
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    getTradeShowByEventId(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<TradeShowResponse>;

    /**
     * Get Trade Show Countries by eventId
     * @param {string} eventId Event Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    getTradeShowCountries(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TradeShowCountryResponse>>;

    /**
     * Get Admin view of the specific Trade Show (by eventId)
     * @param {string} eventId Event Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    getTradeShowDetailsByEventId(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetTradeShowByEventIdResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    getTradeShowEnabledFeatures(options?: RawAxiosRequestConfig): AxiosPromise<TradeShowEnabledFeaturesResponse>;

    /**
     * Get all levers.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    getTradeShowLevers(options?: RawAxiosRequestConfig): AxiosPromise<LeversResponse>;

    /**
     * Get list of recommended brands by trade show ID
     * @param {string} eventId Event Id
     * @param {string} brandId Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    getTradeShowRecommendedBrands(eventId: string, brandId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetTradeShowRecommendedBrandsResponse>;

    /**
     * Get trade shows with active exhibitor or buyer directory feature for a brand
     * @param {string} brandSlug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    getTradeShowsWithActiveExhibitorOrBuyerDirectoryByBrand(brandSlug: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TradeShowResponse>>;

    /**
     * Import exhibitors from Bulletin Incubator.
     * @param {ImportBulletinIncubatorBrandsRequest} importBulletinIncubatorBrandsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    importBulletinIncubatorBrands(importBulletinIncubatorBrandsRequest: ImportBulletinIncubatorBrandsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Import trade show brand from A2z with specific company id
     * @param {string} eventId 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    importTradeShowBrandByCompanyId(eventId: string, companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Link retailers with trade show and change their status to be approved.
     * @param {string} eventId Event Id
     * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    linkRetailersWithTradeShow(eventId: string, linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * The end date of existing levers should not overlap with the start of these levers.
     * @param {PreventEndDateOverlapRequest} preventEndDateOverlapRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    preventEndDateOverlap(preventEndDateOverlapRequest: PreventEndDateOverlapRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TradeShowFeatureResponse>>;

    /**
     * 
     * @param {ReindexTradeShowBrandRequest} reindexTradeShowBrandRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    reindexTradeShowBrands(reindexTradeShowBrandRequest: ReindexTradeShowBrandRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Resend trade show attendees welcome email for the retailers that have not changed their password
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    resendTradeShowAttendeesWelcomeEmail(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Send trade show attendees welcome email fron the specific event
     * @param {string} eventId 
     * @param {SendWelcomeEmailToTradeShowAttendeesRequest} sendWelcomeEmailToTradeShowAttendeesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    sendTradeShowAttendeesWelcomeEmail(eventId: string, sendWelcomeEmailToTradeShowAttendeesRequest: SendWelcomeEmailToTradeShowAttendeesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * This is a utility endpoint to manually send trade show welcome emails in case of need.
     * @param {string} eventId Event Id
     * @param {SendTradeShowWelcomeEmailsRequest} sendTradeShowWelcomeEmailsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    sendTradeShowWelcomeEmailsToBrands(eventId: string, sendTradeShowWelcomeEmailsRequest: SendTradeShowWelcomeEmailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update trade show
     * @param {string} id TradeShow Id
     * @param {UpdateTradeShowRequest} updateTradeShowRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    updateTradeShow(id: string, updateTradeShowRequest: UpdateTradeShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update links related to the selected trade show.
     * @param {string} id 
     * @param {UpdateTradeShowLinksRequest} updateTradeShowLinksRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApiInterface
     */
    updateTradeShowLinks(id: string, updateTradeShowLinksRequest: UpdateTradeShowLinksRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * TradeShowControllerApi - object-oriented interface
 * @export
 * @class TradeShowControllerApi
 * @extends {BaseAPI}
 */
export class TradeShowControllerApi extends BaseAPI implements TradeShowControllerApiInterface {
    /**
     * Add buyer directory header for the specific trade show
     * @param {string} eventId Event Id
     * @param {BuyerDirectoryHeaderRequest} buyerDirectoryHeaderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public addBuyerDirectoryHeaderDetails(eventId: string, buyerDirectoryHeaderRequest: BuyerDirectoryHeaderRequest, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).addBuyerDirectoryHeaderDetails(eventId, buyerDirectoryHeaderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add exhibitor directory header for the specific trade show
     * @param {string} eventId Event Id
     * @param {ExhibitorDirectoryHeaderRequest} exhibitorDirectoryHeaderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public addExhibitorDirectoryHeaderDetails(eventId: string, exhibitorDirectoryHeaderRequest: ExhibitorDirectoryHeaderRequest, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).addExhibitorDirectoryHeaderDetails(eventId, exhibitorDirectoryHeaderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive trade show
     * @param {string} eventId TradeShow event Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public archiveTradeShow(eventId: string, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).archiveTradeShow(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new trade show
     * @param {CreateTradeShowRequest} createTradeShowRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public createTradeShow(createTradeShowRequest: CreateTradeShowRequest, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).createTradeShow(createTradeShowRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete trade show
     * @param {string} id TradeShow Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public deleteTradeShow(id: string, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).deleteTradeShow(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export trade show exhibitors to the CSV file.
     * @param {string} eventId Event Id
     * @param {ExportTradeShowExhibitorsToCSVRequest} exportTradeShowExhibitorsToCSVRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public exportTradeShowExhibitorsToCSV(eventId: string, exportTradeShowExhibitorsToCSVRequest: ExportTradeShowExhibitorsToCSVRequest, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).exportTradeShowExhibitorsToCSV(eventId, exportTradeShowExhibitorsToCSVRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enables the connection between A2z and NY NOW Online.
     * @param {ConfirmOrCreateA2zBrandConnectionRequest} confirmOrCreateA2zBrandConnectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public getA2zConnectionResponse(confirmOrCreateA2zBrandConnectionRequest: ConfirmOrCreateA2zBrandConnectionRequest, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).getA2zConnectionResponse(confirmOrCreateA2zBrandConnectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of sections for a given Trade Show ID
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public getActiveTradeShowSections(eventId: string, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).getActiveTradeShowSections(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get active trade shows
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public getActiveTradeShows(options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).getActiveTradeShows(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Admin view of all Trade Shows
     * @param {string} [status] Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public getAllTradeShows(status?: string, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).getAllTradeShows(status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all available trade show brands.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public getAvailableTradeShowBrands(options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).getAvailableTradeShowBrands(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get exhibitor directory header by trade show id
     * @param {string} eventId Event Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public getBuyerDirectoryHeaderDetails(eventId: string, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).getBuyerDirectoryHeaderDetails(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get exhibitor directory header by trade show id
     * @param {string} eventId Event Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public getExhibitorDirectoryHeaderDetails(eventId: string, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).getExhibitorDirectoryHeaderDetails(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch a list of exhibitors for the current trade show from A2z. This API is available in case a manual trigger is needed. 
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public getExhibitors(eventId: string, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).getExhibitors(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of featured exhibitors.
     * @param {string} eventId 
     * @param {number} [offset] Offset
     * @param {number} [size] Size
     * @param {string} [seed] Seed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public getFeaturedExhibitors(eventId: string, offset?: number, size?: number, seed?: string, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).getFeaturedExhibitors(eventId, offset, size, seed, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get marketing category values by trade show ID
     * @param {string} eventId Event Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public getMarketingCategoryValuesByTradeShow(eventId: string, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).getMarketingCategoryValuesByTradeShow(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Trade Show Buyers by eventId
     * @param {string} eventId Event Id
     * @param {number} page Page
     * @param {number} size Size
     * @param {string} sortOrder Order
     * @param {string} [state] State
     * @param {string} [country] Country
     * @param {string} [sections] Sections
     * @param {string} [search] Search
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public getTradeShowBuyers(eventId: string, page: number, size: number, sortOrder: string, state?: string, country?: string, sections?: string, search?: string, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).getTradeShowBuyers(eventId, page, size, sortOrder, state, country, sections, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get trade show by event id
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public getTradeShowByEventId(eventId: string, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).getTradeShowByEventId(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Trade Show Countries by eventId
     * @param {string} eventId Event Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public getTradeShowCountries(eventId: string, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).getTradeShowCountries(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Admin view of the specific Trade Show (by eventId)
     * @param {string} eventId Event Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public getTradeShowDetailsByEventId(eventId: string, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).getTradeShowDetailsByEventId(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public getTradeShowEnabledFeatures(options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).getTradeShowEnabledFeatures(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all levers.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public getTradeShowLevers(options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).getTradeShowLevers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of recommended brands by trade show ID
     * @param {string} eventId Event Id
     * @param {string} brandId Brand Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public getTradeShowRecommendedBrands(eventId: string, brandId: string, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).getTradeShowRecommendedBrands(eventId, brandId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get trade shows with active exhibitor or buyer directory feature for a brand
     * @param {string} brandSlug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public getTradeShowsWithActiveExhibitorOrBuyerDirectoryByBrand(brandSlug: string, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).getTradeShowsWithActiveExhibitorOrBuyerDirectoryByBrand(brandSlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import exhibitors from Bulletin Incubator.
     * @param {ImportBulletinIncubatorBrandsRequest} importBulletinIncubatorBrandsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public importBulletinIncubatorBrands(importBulletinIncubatorBrandsRequest: ImportBulletinIncubatorBrandsRequest, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).importBulletinIncubatorBrands(importBulletinIncubatorBrandsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import trade show brand from A2z with specific company id
     * @param {string} eventId 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public importTradeShowBrandByCompanyId(eventId: string, companyId: string, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).importTradeShowBrandByCompanyId(eventId, companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Link retailers with trade show and change their status to be approved.
     * @param {string} eventId Event Id
     * @param {LinkRetailersWithTradeShowRequest} [linkRetailersWithTradeShowRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public linkRetailersWithTradeShow(eventId: string, linkRetailersWithTradeShowRequest?: LinkRetailersWithTradeShowRequest, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).linkRetailersWithTradeShow(eventId, linkRetailersWithTradeShowRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The end date of existing levers should not overlap with the start of these levers.
     * @param {PreventEndDateOverlapRequest} preventEndDateOverlapRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public preventEndDateOverlap(preventEndDateOverlapRequest: PreventEndDateOverlapRequest, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).preventEndDateOverlap(preventEndDateOverlapRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReindexTradeShowBrandRequest} reindexTradeShowBrandRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public reindexTradeShowBrands(reindexTradeShowBrandRequest: ReindexTradeShowBrandRequest, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).reindexTradeShowBrands(reindexTradeShowBrandRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resend trade show attendees welcome email for the retailers that have not changed their password
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public resendTradeShowAttendeesWelcomeEmail(eventId: string, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).resendTradeShowAttendeesWelcomeEmail(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send trade show attendees welcome email fron the specific event
     * @param {string} eventId 
     * @param {SendWelcomeEmailToTradeShowAttendeesRequest} sendWelcomeEmailToTradeShowAttendeesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public sendTradeShowAttendeesWelcomeEmail(eventId: string, sendWelcomeEmailToTradeShowAttendeesRequest: SendWelcomeEmailToTradeShowAttendeesRequest, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).sendTradeShowAttendeesWelcomeEmail(eventId, sendWelcomeEmailToTradeShowAttendeesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This is a utility endpoint to manually send trade show welcome emails in case of need.
     * @param {string} eventId Event Id
     * @param {SendTradeShowWelcomeEmailsRequest} sendTradeShowWelcomeEmailsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public sendTradeShowWelcomeEmailsToBrands(eventId: string, sendTradeShowWelcomeEmailsRequest: SendTradeShowWelcomeEmailsRequest, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).sendTradeShowWelcomeEmailsToBrands(eventId, sendTradeShowWelcomeEmailsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update trade show
     * @param {string} id TradeShow Id
     * @param {UpdateTradeShowRequest} updateTradeShowRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public updateTradeShow(id: string, updateTradeShowRequest: UpdateTradeShowRequest, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).updateTradeShow(id, updateTradeShowRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update links related to the selected trade show.
     * @param {string} id 
     * @param {UpdateTradeShowLinksRequest} updateTradeShowLinksRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradeShowControllerApi
     */
    public updateTradeShowLinks(id: string, updateTradeShowLinksRequest: UpdateTradeShowLinksRequest, options?: RawAxiosRequestConfig) {
        return TradeShowControllerApiFp(this.configuration).updateTradeShowLinks(id, updateTradeShowLinksRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserControllerApi - axios parameter creator
 * @export
 */
export const UserControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Ban user with provided id
         * @param {string} id User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        banUser: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('banUser', 'id', id)
            const localVarPath = `/user/{id}/ban`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete instagram token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInstagramToken: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/instagram-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get access level for logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessLevelForUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/access-level`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get email associated with the \'reset password code\' for brands with source \'APPLICATION\' or \'EXHIBITOR\'
         * @param {string} resetPasswordCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailFromResetPasswordCode: async (resetPasswordCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordCode' is not null or undefined
            assertParamExists('getEmailFromResetPasswordCode', 'resetPasswordCode', resetPasswordCode)
            const localVarPath = `/user/code/{resetPasswordCode}`
                .replace(`{${"resetPasswordCode"}}`, encodeURIComponent(String(resetPasswordCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get email verification status
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailVerification: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEmailVerification', 'id', id)
            const localVarPath = `/user/{id}/email-verification`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retailer is able to message Brands
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessagingAbilityForUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/me/can-send-message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProfile: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/me/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Grant access to Bulletin+ to user with provided id
         * @param {string} id User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantAccessToUser: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('grantAccessToUser', 'id', id)
            const localVarPath = `/user/{id}/grant-access-level`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove access to Bulletin+ to user with provided id
         * @param {string} id User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAccessToUser: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeAccessToUser', 'id', id)
            const localVarPath = `/user/{id}/remove-access-level`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve instagram token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveInstagramToken: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/instagram-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Save new instagram token
         * @param {SaveInstagramTokenRequest} saveInstagramTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveInstagramToken: async (saveInstagramTokenRequest: SaveInstagramTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveInstagramTokenRequest' is not null or undefined
            assertParamExists('saveInstagramToken', 'saveInstagramTokenRequest', saveInstagramTokenRequest)
            const localVarPath = `/user/instagram-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveInstagramTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update user email verified status by ADMIN.
         * @param {string} id 
         * @param {UpdateUserEmailVerifiedRequest} updateUserEmailVerifiedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserEmailVerified: async (id: string, updateUserEmailVerifiedRequest: UpdateUserEmailVerifiedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUserEmailVerified', 'id', id)
            // verify required parameter 'updateUserEmailVerifiedRequest' is not null or undefined
            assertParamExists('updateUserEmailVerified', 'updateUserEmailVerifiedRequest', updateUserEmailVerifiedRequest)
            const localVarPath = `/user/{id}/verify-email`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserEmailVerifiedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update user reset password code by ADMIN.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPasswordResetCode: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUserPasswordResetCode', 'id', id)
            const localVarPath = `/user/{id}/generate-password-reset-code`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update user phone number
         * @param {UpdateUserPhoneNumberRequest} updateUserPhoneNumberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPhoneNumber: async (updateUserPhoneNumberRequest: UpdateUserPhoneNumberRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateUserPhoneNumberRequest' is not null or undefined
            assertParamExists('updateUserPhoneNumber', 'updateUserPhoneNumberRequest', updateUserPhoneNumberRequest)
            const localVarPath = `/user/me/phone_number`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserPhoneNumberRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update user
         * @param {UpdateUserProfileRequest} updateUserProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserProfile: async (updateUserProfileRequest: UpdateUserProfileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateUserProfileRequest' is not null or undefined
            assertParamExists('updateUserProfile', 'updateUserProfileRequest', updateUserProfileRequest)
            const localVarPath = `/user/me/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserProfileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserControllerApi - functional programming interface
 * @export
 */
export const UserControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Ban user with provided id
         * @param {string} id User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async banUser(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.banUser(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.banUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete instagram token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInstagramToken(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInstagramToken(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.deleteInstagramToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get access level for logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessLevelForUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserAccessLevelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccessLevelForUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.getAccessLevelForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get email associated with the \'reset password code\' for brands with source \'APPLICATION\' or \'EXHIBITOR\'
         * @param {string} resetPasswordCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailFromResetPasswordCode(resetPasswordCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResetPasswordCodeToEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailFromResetPasswordCode(resetPasswordCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.getEmailFromResetPasswordCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get email verification status
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailVerification(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEmailVerificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailVerification(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.getEmailVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retailer is able to message Brands
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMessagingAbilityForUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserMessagingAbilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMessagingAbilityForUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.getMessagingAbilityForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserProfile(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserProfile(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.getUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Grant access to Bulletin+ to user with provided id
         * @param {string} id User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantAccessToUser(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantAccessToUser(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.grantAccessToUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove access to Bulletin+ to user with provided id
         * @param {string} id User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeAccessToUser(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeAccessToUser(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.removeAccessToUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve instagram token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveInstagramToken(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInstagramTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveInstagramToken(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.retrieveInstagramToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Save new instagram token
         * @param {SaveInstagramTokenRequest} saveInstagramTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveInstagramToken(saveInstagramTokenRequest: SaveInstagramTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveInstagramToken(saveInstagramTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.saveInstagramToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update user email verified status by ADMIN.
         * @param {string} id 
         * @param {UpdateUserEmailVerifiedRequest} updateUserEmailVerifiedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserEmailVerified(id: string, updateUserEmailVerifiedRequest: UpdateUserEmailVerifiedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserEmailVerified(id, updateUserEmailVerifiedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.updateUserEmailVerified']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update user reset password code by ADMIN.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserPasswordResetCode(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGeneratePasswordResetCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserPasswordResetCode(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.updateUserPasswordResetCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update user phone number
         * @param {UpdateUserPhoneNumberRequest} updateUserPhoneNumberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserPhoneNumber(updateUserPhoneNumberRequest: UpdateUserPhoneNumberRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserPhoneNumber(updateUserPhoneNumberRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.updateUserPhoneNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update user
         * @param {UpdateUserProfileRequest} updateUserProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserProfile(updateUserProfileRequest: UpdateUserProfileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserProfile(updateUserProfileRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.updateUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserControllerApi - factory interface
 * @export
 */
export const UserControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserControllerApiFp(configuration)
    return {
        /**
         * Ban user with provided id
         * @param {string} id User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        banUser(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.banUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete instagram token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInstagramToken(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteInstagramToken(options).then((request) => request(axios, basePath));
        },
        /**
         * Get access level for logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessLevelForUser(options?: RawAxiosRequestConfig): AxiosPromise<UserAccessLevelResponse> {
            return localVarFp.getAccessLevelForUser(options).then((request) => request(axios, basePath));
        },
        /**
         * Get email associated with the \'reset password code\' for brands with source \'APPLICATION\' or \'EXHIBITOR\'
         * @param {string} resetPasswordCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailFromResetPasswordCode(resetPasswordCode: string, options?: RawAxiosRequestConfig): AxiosPromise<ResetPasswordCodeToEmailResponse> {
            return localVarFp.getEmailFromResetPasswordCode(resetPasswordCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Get email verification status
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailVerification(id: string, options?: RawAxiosRequestConfig): AxiosPromise<UserEmailVerificationResponse> {
            return localVarFp.getEmailVerification(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retailer is able to message Brands
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessagingAbilityForUser(options?: RawAxiosRequestConfig): AxiosPromise<UserMessagingAbilityResponse> {
            return localVarFp.getMessagingAbilityForUser(options).then((request) => request(axios, basePath));
        },
        /**
         * Get user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProfile(options?: RawAxiosRequestConfig): AxiosPromise<UserProfileResponse> {
            return localVarFp.getUserProfile(options).then((request) => request(axios, basePath));
        },
        /**
         * Grant access to Bulletin+ to user with provided id
         * @param {string} id User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantAccessToUser(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.grantAccessToUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove access to Bulletin+ to user with provided id
         * @param {string} id User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAccessToUser(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeAccessToUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve instagram token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveInstagramToken(options?: RawAxiosRequestConfig): AxiosPromise<GetInstagramTokenResponse> {
            return localVarFp.retrieveInstagramToken(options).then((request) => request(axios, basePath));
        },
        /**
         * Save new instagram token
         * @param {SaveInstagramTokenRequest} saveInstagramTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveInstagramToken(saveInstagramTokenRequest: SaveInstagramTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.saveInstagramToken(saveInstagramTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update user email verified status by ADMIN.
         * @param {string} id 
         * @param {UpdateUserEmailVerifiedRequest} updateUserEmailVerifiedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserEmailVerified(id: string, updateUserEmailVerifiedRequest: UpdateUserEmailVerifiedRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserEmailVerified(id, updateUserEmailVerifiedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update user reset password code by ADMIN.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPasswordResetCode(id: string, options?: RawAxiosRequestConfig): AxiosPromise<UserGeneratePasswordResetCodeResponse> {
            return localVarFp.updateUserPasswordResetCode(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update user phone number
         * @param {UpdateUserPhoneNumberRequest} updateUserPhoneNumberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPhoneNumber(updateUserPhoneNumberRequest: UpdateUserPhoneNumberRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserPhoneNumber(updateUserPhoneNumberRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update user
         * @param {UpdateUserProfileRequest} updateUserProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserProfile(updateUserProfileRequest: UpdateUserProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserProfile(updateUserProfileRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserControllerApi - interface
 * @export
 * @interface UserControllerApi
 */
export interface UserControllerApiInterface {
    /**
     * Ban user with provided id
     * @param {string} id User id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    banUser(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Delete instagram token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    deleteInstagramToken(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Get access level for logged in user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    getAccessLevelForUser(options?: RawAxiosRequestConfig): AxiosPromise<UserAccessLevelResponse>;

    /**
     * Get email associated with the \'reset password code\' for brands with source \'APPLICATION\' or \'EXHIBITOR\'
     * @param {string} resetPasswordCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    getEmailFromResetPasswordCode(resetPasswordCode: string, options?: RawAxiosRequestConfig): AxiosPromise<ResetPasswordCodeToEmailResponse>;

    /**
     * Get email verification status
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    getEmailVerification(id: string, options?: RawAxiosRequestConfig): AxiosPromise<UserEmailVerificationResponse>;

    /**
     * Retailer is able to message Brands
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    getMessagingAbilityForUser(options?: RawAxiosRequestConfig): AxiosPromise<UserMessagingAbilityResponse>;

    /**
     * Get user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    getUserProfile(options?: RawAxiosRequestConfig): AxiosPromise<UserProfileResponse>;

    /**
     * Grant access to Bulletin+ to user with provided id
     * @param {string} id User id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    grantAccessToUser(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Remove access to Bulletin+ to user with provided id
     * @param {string} id User id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    removeAccessToUser(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Retrieve instagram token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    retrieveInstagramToken(options?: RawAxiosRequestConfig): AxiosPromise<GetInstagramTokenResponse>;

    /**
     * Save new instagram token
     * @param {SaveInstagramTokenRequest} saveInstagramTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    saveInstagramToken(saveInstagramTokenRequest: SaveInstagramTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update user email verified status by ADMIN.
     * @param {string} id 
     * @param {UpdateUserEmailVerifiedRequest} updateUserEmailVerifiedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    updateUserEmailVerified(id: string, updateUserEmailVerifiedRequest: UpdateUserEmailVerifiedRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update user reset password code by ADMIN.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    updateUserPasswordResetCode(id: string, options?: RawAxiosRequestConfig): AxiosPromise<UserGeneratePasswordResetCodeResponse>;

    /**
     * Update user phone number
     * @param {UpdateUserPhoneNumberRequest} updateUserPhoneNumberRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    updateUserPhoneNumber(updateUserPhoneNumberRequest: UpdateUserPhoneNumberRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update user
     * @param {UpdateUserProfileRequest} updateUserProfileRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    updateUserProfile(updateUserProfileRequest: UpdateUserProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * UserControllerApi - object-oriented interface
 * @export
 * @class UserControllerApi
 * @extends {BaseAPI}
 */
export class UserControllerApi extends BaseAPI implements UserControllerApiInterface {
    /**
     * Ban user with provided id
     * @param {string} id User id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public banUser(id: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).banUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete instagram token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public deleteInstagramToken(options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).deleteInstagramToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get access level for logged in user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public getAccessLevelForUser(options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).getAccessLevelForUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get email associated with the \'reset password code\' for brands with source \'APPLICATION\' or \'EXHIBITOR\'
     * @param {string} resetPasswordCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public getEmailFromResetPasswordCode(resetPasswordCode: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).getEmailFromResetPasswordCode(resetPasswordCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get email verification status
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public getEmailVerification(id: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).getEmailVerification(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retailer is able to message Brands
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public getMessagingAbilityForUser(options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).getMessagingAbilityForUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public getUserProfile(options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).getUserProfile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Grant access to Bulletin+ to user with provided id
     * @param {string} id User id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public grantAccessToUser(id: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).grantAccessToUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove access to Bulletin+ to user with provided id
     * @param {string} id User id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public removeAccessToUser(id: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).removeAccessToUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve instagram token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public retrieveInstagramToken(options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).retrieveInstagramToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Save new instagram token
     * @param {SaveInstagramTokenRequest} saveInstagramTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public saveInstagramToken(saveInstagramTokenRequest: SaveInstagramTokenRequest, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).saveInstagramToken(saveInstagramTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update user email verified status by ADMIN.
     * @param {string} id 
     * @param {UpdateUserEmailVerifiedRequest} updateUserEmailVerifiedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public updateUserEmailVerified(id: string, updateUserEmailVerifiedRequest: UpdateUserEmailVerifiedRequest, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).updateUserEmailVerified(id, updateUserEmailVerifiedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update user reset password code by ADMIN.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public updateUserPasswordResetCode(id: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).updateUserPasswordResetCode(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update user phone number
     * @param {UpdateUserPhoneNumberRequest} updateUserPhoneNumberRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public updateUserPhoneNumber(updateUserPhoneNumberRequest: UpdateUserPhoneNumberRequest, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).updateUserPhoneNumber(updateUserPhoneNumberRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update user
     * @param {UpdateUserProfileRequest} updateUserProfileRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    public updateUserProfile(updateUserProfileRequest: UpdateUserProfileRequest, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).updateUserProfile(updateUserProfileRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ValidationControllerApi - axios parameter creator
 * @export
 */
export const ValidationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Validate an email address using SendGrid - third party service.
         * @param {ValidateEmailRequest} validateEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEmail: async (validateEmailRequest: ValidateEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validateEmailRequest' is not null or undefined
            assertParamExists('validateEmail', 'validateEmailRequest', validateEmailRequest)
            const localVarPath = `/validations/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidationControllerApi - functional programming interface
 * @export
 */
export const ValidationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ValidationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Validate an email address using SendGrid - third party service.
         * @param {ValidateEmailRequest} validateEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateEmail(validateEmailRequest: ValidateEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateEmail(validateEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationControllerApi.validateEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ValidationControllerApi - factory interface
 * @export
 */
export const ValidationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ValidationControllerApiFp(configuration)
    return {
        /**
         * Validate an email address using SendGrid - third party service.
         * @param {ValidateEmailRequest} validateEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEmail(validateEmailRequest: ValidateEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ValidateEmailResponse> {
            return localVarFp.validateEmail(validateEmailRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ValidationControllerApi - interface
 * @export
 * @interface ValidationControllerApi
 */
export interface ValidationControllerApiInterface {
    /**
     * Validate an email address using SendGrid - third party service.
     * @param {ValidateEmailRequest} validateEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationControllerApiInterface
     */
    validateEmail(validateEmailRequest: ValidateEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ValidateEmailResponse>;

}

/**
 * ValidationControllerApi - object-oriented interface
 * @export
 * @class ValidationControllerApi
 * @extends {BaseAPI}
 */
export class ValidationControllerApi extends BaseAPI implements ValidationControllerApiInterface {
    /**
     * Validate an email address using SendGrid - third party service.
     * @param {ValidateEmailRequest} validateEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationControllerApi
     */
    public validateEmail(validateEmailRequest: ValidateEmailRequest, options?: RawAxiosRequestConfig) {
        return ValidationControllerApiFp(this.configuration).validateEmail(validateEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VideoControllerApi - axios parameter creator
 * @export
 */
export const VideoControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete video
         * @param {string} id Video id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVideo: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteVideo', 'id', id)
            const localVarPath = `/videos/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get playback ids
         * @param {string} uploadId Video upload id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaybackIds: async (uploadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadId' is not null or undefined
            assertParamExists('getPlaybackIds', 'uploadId', uploadId)
            const localVarPath = `/videos/{uploadId}/poll-for-playback-ids`
                .replace(`{${"uploadId"}}`, encodeURIComponent(String(uploadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VideoControllerApi - functional programming interface
 * @export
 */
export const VideoControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VideoControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete video
         * @param {string} id Video id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVideo(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVideo(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VideoControllerApi.deleteVideo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get playback ids
         * @param {string} uploadId Video upload id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlaybackIds(uploadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaybackIDsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlaybackIds(uploadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VideoControllerApi.getPlaybackIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VideoControllerApi - factory interface
 * @export
 */
export const VideoControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VideoControllerApiFp(configuration)
    return {
        /**
         * Delete video
         * @param {string} id Video id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVideo(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteVideo(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get playback ids
         * @param {string} uploadId Video upload id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaybackIds(uploadId: string, options?: RawAxiosRequestConfig): AxiosPromise<PlaybackIDsResponse> {
            return localVarFp.getPlaybackIds(uploadId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VideoControllerApi - interface
 * @export
 * @interface VideoControllerApi
 */
export interface VideoControllerApiInterface {
    /**
     * Delete video
     * @param {string} id Video id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoControllerApiInterface
     */
    deleteVideo(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Get playback ids
     * @param {string} uploadId Video upload id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoControllerApiInterface
     */
    getPlaybackIds(uploadId: string, options?: RawAxiosRequestConfig): AxiosPromise<PlaybackIDsResponse>;

}

/**
 * VideoControllerApi - object-oriented interface
 * @export
 * @class VideoControllerApi
 * @extends {BaseAPI}
 */
export class VideoControllerApi extends BaseAPI implements VideoControllerApiInterface {
    /**
     * Delete video
     * @param {string} id Video id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoControllerApi
     */
    public deleteVideo(id: string, options?: RawAxiosRequestConfig) {
        return VideoControllerApiFp(this.configuration).deleteVideo(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get playback ids
     * @param {string} uploadId Video upload id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoControllerApi
     */
    public getPlaybackIds(uploadId: string, options?: RawAxiosRequestConfig) {
        return VideoControllerApiFp(this.configuration).getPlaybackIds(uploadId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ViewControllerApi - axios parameter creator
 * @export
 */
export const ViewControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Change activity status for view component
         * @param {ChangeViewComponentActivityRequest} changeViewComponentActivityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeActivity: async (changeViewComponentActivityRequest: ChangeViewComponentActivityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changeViewComponentActivityRequest' is not null or undefined
            assertParamExists('changeActivity', 'changeViewComponentActivityRequest', changeViewComponentActivityRequest)
            const localVarPath = `/views/component/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeViewComponentActivityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Construct navigation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        constructNavigation: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/views/navigation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create collection from view container
         * @param {string} id View Container Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollectionFromViewContainer: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createCollectionFromViewContainer', 'id', id)
            const localVarPath = `/views/containers/{id}/create-collection`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create component
         * @param {string} id View Container Id
         * @param {CreateViewComponentRequest} createViewComponentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComponent: async (id: string, createViewComponentRequest: CreateViewComponentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createComponent', 'id', id)
            // verify required parameter 'createViewComponentRequest' is not null or undefined
            assertParamExists('createComponent', 'createViewComponentRequest', createViewComponentRequest)
            const localVarPath = `/views/containers/{id}/component`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createViewComponentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create container
         * @param {CreateViewContainerRequest} createViewContainerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContainer: async (createViewContainerRequest: CreateViewContainerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createViewContainerRequest' is not null or undefined
            assertParamExists('createContainer', 'createViewContainerRequest', createViewContainerRequest)
            const localVarPath = `/views/containers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createViewContainerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create view components
         * @param {string} id View Container Id
         * @param {CreateViewComponentsRequest} createViewComponentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createViewComponents: async (id: string, createViewComponentsRequest: CreateViewComponentsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createViewComponents', 'id', id)
            // verify required parameter 'createViewComponentsRequest' is not null or undefined
            assertParamExists('createViewComponents', 'createViewComponentsRequest', createViewComponentsRequest)
            const localVarPath = `/views/containers/{id}/components`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createViewComponentsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create view container elements
         * @param {string} id Parent Container Id
         * @param {CreateViewContainerElementsRequest} createViewContainerElementsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createViewContainerElements: async (id: string, createViewContainerElementsRequest: CreateViewContainerElementsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createViewContainerElements', 'id', id)
            // verify required parameter 'createViewContainerElementsRequest' is not null or undefined
            assertParamExists('createViewContainerElements', 'createViewContainerElementsRequest', createViewContainerElementsRequest)
            const localVarPath = `/views/containers/{id}/children-containers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createViewContainerElementsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete component
         * @param {string} id View Container Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComponent: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteComponent', 'id', id)
            const localVarPath = `/views/components/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete container
         * @param {string} id View Container Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContainer: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteContainer', 'id', id)
            const localVarPath = `/views/containers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete view container elements
         * @param {string} parentContainerId Parent container id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteViewContainerElements: async (parentContainerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parentContainerId' is not null or undefined
            assertParamExists('deleteViewContainerElements', 'parentContainerId', parentContainerId)
            const localVarPath = `/views/containers/{parentContainerId}/children-containers`
                .replace(`{${"parentContainerId"}}`, encodeURIComponent(String(parentContainerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get homepage container and it\'s components by type. Allowed enum values for homepage containers: FEATURED_COLLECTIONS, FEATURED_BRANDS, PRODUCT_CATEGORIES, TRENDING_BRANDS, HERO, ABOUT.
         * @param {GetHomepageViewContainerTypeEnum} type Container type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHomepageViewContainer: async (type: GetHomepageViewContainerTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getHomepageViewContainer', 'type', type)
            const localVarPath = `/views/homepage/containers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get navigation view container
         * @param {string} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavigation: async (ifNoneMatch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/views/navigation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (ifNoneMatch != null) {
                localVarHeaderParameter['If-None-Match'] = String(ifNoneMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get products by view component Id
         * @param {string} id View Component Id
         * @param {number} [page] Page, if paginating the result
         * @param {number} [limit] max number of product ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsFromViewComponent: async (id: string, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductsFromViewComponent', 'id', id)
            const localVarPath = `/views/components/{id}/products`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get products by view container Id
         * @param {string} id View Container Id
         * @param {number} [page] Page, if paginating the result
         * @param {number} [limit] max number of product ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsFromViewContainer: async (id: string, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductsFromViewContainer', 'id', id)
            const localVarPath = `/views/containers/{id}/products`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get view container by id
         * @param {string} id View Container Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getViewContainerById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getViewContainerById', 'id', id)
            const localVarPath = `/views/containers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get view containers by type
         * @param {GetViewContainersTypeEnum} type Container type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getViewContainers: async (type: GetViewContainersTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getViewContainers', 'type', type)
            const localVarPath = `/views/containers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Rename view components
         * @param {Array<RenameViewComponentRequest>} renameViewComponentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameViewComponents: async (renameViewComponentRequest: Array<RenameViewComponentRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'renameViewComponentRequest' is not null or undefined
            assertParamExists('renameViewComponents', 'renameViewComponentRequest', renameViewComponentRequest)
            const localVarPath = `/views/rename`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renameViewComponentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update homepage container with components. Allowed enum values for homepage containers: FEATURED_COLLECTIONS, FEATURED_BRANDS, PRODUCT_CATEGORIES, TRENDING_BRANDS, HERO, ABOUT.
         * @param {UpdateContainerTypeEnum} type View Container type
         * @param {UpdateViewContainerRequest} updateViewContainerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContainer: async (type: UpdateContainerTypeEnum, updateViewContainerRequest: UpdateViewContainerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('updateContainer', 'type', type)
            // verify required parameter 'updateViewContainerRequest' is not null or undefined
            assertParamExists('updateContainer', 'updateViewContainerRequest', updateViewContainerRequest)
            const localVarPath = `/views/homepage/containers/{type}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateViewContainerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change activity status for view component
         * @param {UpdateBannerContainerRequest} updateBannerContainerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromoBannerContainer: async (updateBannerContainerRequest: UpdateBannerContainerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateBannerContainerRequest' is not null or undefined
            assertParamExists('updatePromoBannerContainer', 'updateBannerContainerRequest', updateBannerContainerRequest)
            const localVarPath = `/views/components/promo-banner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBannerContainerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<UpdateViewComponentsRequest>} updateViewComponentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateViewComponents: async (updateViewComponentsRequest: Array<UpdateViewComponentsRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateViewComponentsRequest' is not null or undefined
            assertParamExists('updateViewComponents', 'updateViewComponentsRequest', updateViewComponentsRequest)
            const localVarPath = `/views/homepage/components`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateViewComponentsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update view container elements
         * @param {string} id View Container Id
         * @param {UpdateViewContainerElementsRequest} updateViewContainerElementsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateViewContainerElements: async (id: string, updateViewContainerElementsRequest: UpdateViewContainerElementsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateViewContainerElements', 'id', id)
            // verify required parameter 'updateViewContainerElementsRequest' is not null or undefined
            assertParamExists('updateViewContainerElements', 'updateViewContainerElementsRequest', updateViewContainerElementsRequest)
            const localVarPath = `/views/containers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateViewContainerElementsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload component image
         * @param {string} componentId View Component Id
         * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadComponentImage: async (componentId: string, uploadComponentImageRequest?: UploadComponentImageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('uploadComponentImage', 'componentId', componentId)
            const localVarPath = `/views/images/{componentId}`
                .replace(`{${"componentId"}}`, encodeURIComponent(String(componentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadComponentImageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update collection image
         * @param {string} id View component id
         * @param {File} image Image request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImageToViewComponent: async (id: string, image: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadImageToViewComponent', 'id', id)
            // verify required parameter 'image' is not null or undefined
            assertParamExists('uploadImageToViewComponent', 'image', image)
            const localVarPath = `/views/component/{id}/image`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (image !== undefined) {
                localVarQueryParameter['image'] = image;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ViewControllerApi - functional programming interface
 * @export
 */
export const ViewControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ViewControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Change activity status for view component
         * @param {ChangeViewComponentActivityRequest} changeViewComponentActivityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeActivity(changeViewComponentActivityRequest: ChangeViewComponentActivityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeActivity(changeViewComponentActivityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewControllerApi.changeActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Construct navigation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async constructNavigation(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.constructNavigation(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewControllerApi.constructNavigation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create collection from view container
         * @param {string} id View Container Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCollectionFromViewContainer(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCollectionFromViewContainer(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewControllerApi.createCollectionFromViewContainer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create component
         * @param {string} id View Container Id
         * @param {CreateViewComponentRequest} createViewComponentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createComponent(id: string, createViewComponentRequest: CreateViewComponentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createComponent(id, createViewComponentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewControllerApi.createComponent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create container
         * @param {CreateViewContainerRequest} createViewContainerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContainer(createViewContainerRequest: CreateViewContainerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createContainer(createViewContainerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewControllerApi.createContainer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create view components
         * @param {string} id View Container Id
         * @param {CreateViewComponentsRequest} createViewComponentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createViewComponents(id: string, createViewComponentsRequest: CreateViewComponentsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createViewComponents(id, createViewComponentsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewControllerApi.createViewComponents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create view container elements
         * @param {string} id Parent Container Id
         * @param {CreateViewContainerElementsRequest} createViewContainerElementsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createViewContainerElements(id: string, createViewContainerElementsRequest: CreateViewContainerElementsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createViewContainerElements(id, createViewContainerElementsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewControllerApi.createViewContainerElements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete component
         * @param {string} id View Container Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteComponent(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteComponent(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewControllerApi.deleteComponent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete container
         * @param {string} id View Container Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteContainer(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContainer(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewControllerApi.deleteContainer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete view container elements
         * @param {string} parentContainerId Parent container id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteViewContainerElements(parentContainerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteViewContainerElements(parentContainerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewControllerApi.deleteViewContainerElements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get homepage container and it\'s components by type. Allowed enum values for homepage containers: FEATURED_COLLECTIONS, FEATURED_BRANDS, PRODUCT_CATEGORIES, TRENDING_BRANDS, HERO, ABOUT.
         * @param {GetHomepageViewContainerTypeEnum} type Container type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHomepageViewContainer(type: GetHomepageViewContainerTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAbstractViewComponentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHomepageViewContainer(type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewControllerApi.getHomepageViewContainer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get navigation view container
         * @param {string} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNavigation(ifNoneMatch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNavigation(ifNoneMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewControllerApi.getNavigation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get products by view component Id
         * @param {string} id View Component Id
         * @param {number} [page] Page, if paginating the result
         * @param {number} [limit] max number of product ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductsFromViewComponent(id: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedFilteredProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductsFromViewComponent(id, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewControllerApi.getProductsFromViewComponent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get products by view container Id
         * @param {string} id View Container Id
         * @param {number} [page] Page, if paginating the result
         * @param {number} [limit] max number of product ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductsFromViewContainer(id: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedFilteredProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductsFromViewContainer(id, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewControllerApi.getProductsFromViewContainer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get view container by id
         * @param {string} id View Container Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getViewContainerById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewContainerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getViewContainerById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewControllerApi.getViewContainerById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get view containers by type
         * @param {GetViewContainersTypeEnum} type Container type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getViewContainers(type: GetViewContainersTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViewContainerResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getViewContainers(type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewControllerApi.getViewContainers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Rename view components
         * @param {Array<RenameViewComponentRequest>} renameViewComponentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renameViewComponents(renameViewComponentRequest: Array<RenameViewComponentRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renameViewComponents(renameViewComponentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewControllerApi.renameViewComponents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update homepage container with components. Allowed enum values for homepage containers: FEATURED_COLLECTIONS, FEATURED_BRANDS, PRODUCT_CATEGORIES, TRENDING_BRANDS, HERO, ABOUT.
         * @param {UpdateContainerTypeEnum} type View Container type
         * @param {UpdateViewContainerRequest} updateViewContainerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContainer(type: UpdateContainerTypeEnum, updateViewContainerRequest: UpdateViewContainerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContainer(type, updateViewContainerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewControllerApi.updateContainer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change activity status for view component
         * @param {UpdateBannerContainerRequest} updateBannerContainerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePromoBannerContainer(updateBannerContainerRequest: UpdateBannerContainerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePromoBannerContainer(updateBannerContainerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewControllerApi.updatePromoBannerContainer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<UpdateViewComponentsRequest>} updateViewComponentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateViewComponents(updateViewComponentsRequest: Array<UpdateViewComponentsRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateViewComponents(updateViewComponentsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewControllerApi.updateViewComponents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update view container elements
         * @param {string} id View Container Id
         * @param {UpdateViewContainerElementsRequest} updateViewContainerElementsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateViewContainerElements(id: string, updateViewContainerElementsRequest: UpdateViewContainerElementsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateViewContainerElements(id, updateViewContainerElementsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewControllerApi.updateViewContainerElements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload component image
         * @param {string} componentId View Component Id
         * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadComponentImage(componentId: string, uploadComponentImageRequest?: UploadComponentImageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadComponentImage(componentId, uploadComponentImageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewControllerApi.uploadComponentImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update collection image
         * @param {string} id View component id
         * @param {File} image Image request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadImageToViewComponent(id: string, image: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadImageToViewComponent(id, image, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewControllerApi.uploadImageToViewComponent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ViewControllerApi - factory interface
 * @export
 */
export const ViewControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ViewControllerApiFp(configuration)
    return {
        /**
         * Change activity status for view component
         * @param {ChangeViewComponentActivityRequest} changeViewComponentActivityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeActivity(changeViewComponentActivityRequest: ChangeViewComponentActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changeActivity(changeViewComponentActivityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Construct navigation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        constructNavigation(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.constructNavigation(options).then((request) => request(axios, basePath));
        },
        /**
         * Create collection from view container
         * @param {string} id View Container Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollectionFromViewContainer(id: string, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper> {
            return localVarFp.createCollectionFromViewContainer(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Create component
         * @param {string} id View Container Id
         * @param {CreateViewComponentRequest} createViewComponentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComponent(id: string, createViewComponentRequest: CreateViewComponentRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper> {
            return localVarFp.createComponent(id, createViewComponentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create container
         * @param {CreateViewContainerRequest} createViewContainerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContainer(createViewContainerRequest: CreateViewContainerRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper> {
            return localVarFp.createContainer(createViewContainerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create view components
         * @param {string} id View Container Id
         * @param {CreateViewComponentsRequest} createViewComponentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createViewComponents(id: string, createViewComponentsRequest: CreateViewComponentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createViewComponents(id, createViewComponentsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create view container elements
         * @param {string} id Parent Container Id
         * @param {CreateViewContainerElementsRequest} createViewContainerElementsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createViewContainerElements(id: string, createViewContainerElementsRequest: CreateViewContainerElementsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createViewContainerElements(id, createViewContainerElementsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete component
         * @param {string} id View Container Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComponent(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteComponent(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete container
         * @param {string} id View Container Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContainer(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteContainer(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete view container elements
         * @param {string} parentContainerId Parent container id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteViewContainerElements(parentContainerId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteViewContainerElements(parentContainerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get homepage container and it\'s components by type. Allowed enum values for homepage containers: FEATURED_COLLECTIONS, FEATURED_BRANDS, PRODUCT_CATEGORIES, TRENDING_BRANDS, HERO, ABOUT.
         * @param {GetHomepageViewContainerTypeEnum} type Container type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHomepageViewContainer(type: GetHomepageViewContainerTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<GetAbstractViewComponentResponse> {
            return localVarFp.getHomepageViewContainer(type, options).then((request) => request(axios, basePath));
        },
        /**
         * Get navigation view container
         * @param {string} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavigation(ifNoneMatch?: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getNavigation(ifNoneMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Get products by view component Id
         * @param {string} id View Component Id
         * @param {number} [page] Page, if paginating the result
         * @param {number} [limit] max number of product ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsFromViewComponent(id: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedFilteredProductResponse> {
            return localVarFp.getProductsFromViewComponent(id, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Get products by view container Id
         * @param {string} id View Container Id
         * @param {number} [page] Page, if paginating the result
         * @param {number} [limit] max number of product ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsFromViewContainer(id: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedFilteredProductResponse> {
            return localVarFp.getProductsFromViewContainer(id, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Get view container by id
         * @param {string} id View Container Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getViewContainerById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ViewContainerResponse> {
            return localVarFp.getViewContainerById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get view containers by type
         * @param {GetViewContainersTypeEnum} type Container type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getViewContainers(type: GetViewContainersTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<ViewContainerResponse>> {
            return localVarFp.getViewContainers(type, options).then((request) => request(axios, basePath));
        },
        /**
         * Rename view components
         * @param {Array<RenameViewComponentRequest>} renameViewComponentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameViewComponents(renameViewComponentRequest: Array<RenameViewComponentRequest>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.renameViewComponents(renameViewComponentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update homepage container with components. Allowed enum values for homepage containers: FEATURED_COLLECTIONS, FEATURED_BRANDS, PRODUCT_CATEGORIES, TRENDING_BRANDS, HERO, ABOUT.
         * @param {UpdateContainerTypeEnum} type View Container type
         * @param {UpdateViewContainerRequest} updateViewContainerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContainer(type: UpdateContainerTypeEnum, updateViewContainerRequest: UpdateViewContainerRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateContainer(type, updateViewContainerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Change activity status for view component
         * @param {UpdateBannerContainerRequest} updateBannerContainerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromoBannerContainer(updateBannerContainerRequest: UpdateBannerContainerRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePromoBannerContainer(updateBannerContainerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<UpdateViewComponentsRequest>} updateViewComponentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateViewComponents(updateViewComponentsRequest: Array<UpdateViewComponentsRequest>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateViewComponents(updateViewComponentsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update view container elements
         * @param {string} id View Container Id
         * @param {UpdateViewContainerElementsRequest} updateViewContainerElementsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateViewContainerElements(id: string, updateViewContainerElementsRequest: UpdateViewContainerElementsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateViewContainerElements(id, updateViewContainerElementsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload component image
         * @param {string} componentId View Component Id
         * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadComponentImage(componentId: string, uploadComponentImageRequest?: UploadComponentImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.uploadComponentImage(componentId, uploadComponentImageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update collection image
         * @param {string} id View component id
         * @param {File} image Image request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImageToViewComponent(id: string, image: File, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.uploadImageToViewComponent(id, image, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ViewControllerApi - interface
 * @export
 * @interface ViewControllerApi
 */
export interface ViewControllerApiInterface {
    /**
     * Change activity status for view component
     * @param {ChangeViewComponentActivityRequest} changeViewComponentActivityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApiInterface
     */
    changeActivity(changeViewComponentActivityRequest: ChangeViewComponentActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Construct navigation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApiInterface
     */
    constructNavigation(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Create collection from view container
     * @param {string} id View Container Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApiInterface
     */
    createCollectionFromViewContainer(id: string, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper>;

    /**
     * Create component
     * @param {string} id View Container Id
     * @param {CreateViewComponentRequest} createViewComponentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApiInterface
     */
    createComponent(id: string, createViewComponentRequest: CreateViewComponentRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper>;

    /**
     * Create container
     * @param {CreateViewContainerRequest} createViewContainerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApiInterface
     */
    createContainer(createViewContainerRequest: CreateViewContainerRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdWrapper>;

    /**
     * Create view components
     * @param {string} id View Container Id
     * @param {CreateViewComponentsRequest} createViewComponentsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApiInterface
     */
    createViewComponents(id: string, createViewComponentsRequest: CreateViewComponentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Create view container elements
     * @param {string} id Parent Container Id
     * @param {CreateViewContainerElementsRequest} createViewContainerElementsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApiInterface
     */
    createViewContainerElements(id: string, createViewContainerElementsRequest: CreateViewContainerElementsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Delete component
     * @param {string} id View Container Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApiInterface
     */
    deleteComponent(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Delete container
     * @param {string} id View Container Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApiInterface
     */
    deleteContainer(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Delete view container elements
     * @param {string} parentContainerId Parent container id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApiInterface
     */
    deleteViewContainerElements(parentContainerId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Get homepage container and it\'s components by type. Allowed enum values for homepage containers: FEATURED_COLLECTIONS, FEATURED_BRANDS, PRODUCT_CATEGORIES, TRENDING_BRANDS, HERO, ABOUT.
     * @param {GetHomepageViewContainerTypeEnum} type Container type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApiInterface
     */
    getHomepageViewContainer(type: GetHomepageViewContainerTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<GetAbstractViewComponentResponse>;

    /**
     * Get navigation view container
     * @param {string} [ifNoneMatch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApiInterface
     */
    getNavigation(ifNoneMatch?: string, options?: RawAxiosRequestConfig): AxiosPromise<object>;

    /**
     * Get products by view component Id
     * @param {string} id View Component Id
     * @param {number} [page] Page, if paginating the result
     * @param {number} [limit] max number of product ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApiInterface
     */
    getProductsFromViewComponent(id: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedFilteredProductResponse>;

    /**
     * Get products by view container Id
     * @param {string} id View Container Id
     * @param {number} [page] Page, if paginating the result
     * @param {number} [limit] max number of product ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApiInterface
     */
    getProductsFromViewContainer(id: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedFilteredProductResponse>;

    /**
     * Get view container by id
     * @param {string} id View Container Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApiInterface
     */
    getViewContainerById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ViewContainerResponse>;

    /**
     * Get view containers by type
     * @param {GetViewContainersTypeEnum} type Container type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApiInterface
     */
    getViewContainers(type: GetViewContainersTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<ViewContainerResponse>>;

    /**
     * Rename view components
     * @param {Array<RenameViewComponentRequest>} renameViewComponentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApiInterface
     */
    renameViewComponents(renameViewComponentRequest: Array<RenameViewComponentRequest>, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update homepage container with components. Allowed enum values for homepage containers: FEATURED_COLLECTIONS, FEATURED_BRANDS, PRODUCT_CATEGORIES, TRENDING_BRANDS, HERO, ABOUT.
     * @param {UpdateContainerTypeEnum} type View Container type
     * @param {UpdateViewContainerRequest} updateViewContainerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApiInterface
     */
    updateContainer(type: UpdateContainerTypeEnum, updateViewContainerRequest: UpdateViewContainerRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Change activity status for view component
     * @param {UpdateBannerContainerRequest} updateBannerContainerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApiInterface
     */
    updatePromoBannerContainer(updateBannerContainerRequest: UpdateBannerContainerRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {Array<UpdateViewComponentsRequest>} updateViewComponentsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApiInterface
     */
    updateViewComponents(updateViewComponentsRequest: Array<UpdateViewComponentsRequest>, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update view container elements
     * @param {string} id View Container Id
     * @param {UpdateViewContainerElementsRequest} updateViewContainerElementsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApiInterface
     */
    updateViewContainerElements(id: string, updateViewContainerElementsRequest: UpdateViewContainerElementsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Upload component image
     * @param {string} componentId View Component Id
     * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApiInterface
     */
    uploadComponentImage(componentId: string, uploadComponentImageRequest?: UploadComponentImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * Update collection image
     * @param {string} id View component id
     * @param {File} image Image request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApiInterface
     */
    uploadImageToViewComponent(id: string, image: File, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ViewControllerApi - object-oriented interface
 * @export
 * @class ViewControllerApi
 * @extends {BaseAPI}
 */
export class ViewControllerApi extends BaseAPI implements ViewControllerApiInterface {
    /**
     * Change activity status for view component
     * @param {ChangeViewComponentActivityRequest} changeViewComponentActivityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApi
     */
    public changeActivity(changeViewComponentActivityRequest: ChangeViewComponentActivityRequest, options?: RawAxiosRequestConfig) {
        return ViewControllerApiFp(this.configuration).changeActivity(changeViewComponentActivityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Construct navigation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApi
     */
    public constructNavigation(options?: RawAxiosRequestConfig) {
        return ViewControllerApiFp(this.configuration).constructNavigation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create collection from view container
     * @param {string} id View Container Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApi
     */
    public createCollectionFromViewContainer(id: string, options?: RawAxiosRequestConfig) {
        return ViewControllerApiFp(this.configuration).createCollectionFromViewContainer(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create component
     * @param {string} id View Container Id
     * @param {CreateViewComponentRequest} createViewComponentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApi
     */
    public createComponent(id: string, createViewComponentRequest: CreateViewComponentRequest, options?: RawAxiosRequestConfig) {
        return ViewControllerApiFp(this.configuration).createComponent(id, createViewComponentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create container
     * @param {CreateViewContainerRequest} createViewContainerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApi
     */
    public createContainer(createViewContainerRequest: CreateViewContainerRequest, options?: RawAxiosRequestConfig) {
        return ViewControllerApiFp(this.configuration).createContainer(createViewContainerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create view components
     * @param {string} id View Container Id
     * @param {CreateViewComponentsRequest} createViewComponentsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApi
     */
    public createViewComponents(id: string, createViewComponentsRequest: CreateViewComponentsRequest, options?: RawAxiosRequestConfig) {
        return ViewControllerApiFp(this.configuration).createViewComponents(id, createViewComponentsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create view container elements
     * @param {string} id Parent Container Id
     * @param {CreateViewContainerElementsRequest} createViewContainerElementsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApi
     */
    public createViewContainerElements(id: string, createViewContainerElementsRequest: CreateViewContainerElementsRequest, options?: RawAxiosRequestConfig) {
        return ViewControllerApiFp(this.configuration).createViewContainerElements(id, createViewContainerElementsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete component
     * @param {string} id View Container Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApi
     */
    public deleteComponent(id: string, options?: RawAxiosRequestConfig) {
        return ViewControllerApiFp(this.configuration).deleteComponent(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete container
     * @param {string} id View Container Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApi
     */
    public deleteContainer(id: string, options?: RawAxiosRequestConfig) {
        return ViewControllerApiFp(this.configuration).deleteContainer(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete view container elements
     * @param {string} parentContainerId Parent container id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApi
     */
    public deleteViewContainerElements(parentContainerId: string, options?: RawAxiosRequestConfig) {
        return ViewControllerApiFp(this.configuration).deleteViewContainerElements(parentContainerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get homepage container and it\'s components by type. Allowed enum values for homepage containers: FEATURED_COLLECTIONS, FEATURED_BRANDS, PRODUCT_CATEGORIES, TRENDING_BRANDS, HERO, ABOUT.
     * @param {GetHomepageViewContainerTypeEnum} type Container type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApi
     */
    public getHomepageViewContainer(type: GetHomepageViewContainerTypeEnum, options?: RawAxiosRequestConfig) {
        return ViewControllerApiFp(this.configuration).getHomepageViewContainer(type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get navigation view container
     * @param {string} [ifNoneMatch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApi
     */
    public getNavigation(ifNoneMatch?: string, options?: RawAxiosRequestConfig) {
        return ViewControllerApiFp(this.configuration).getNavigation(ifNoneMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get products by view component Id
     * @param {string} id View Component Id
     * @param {number} [page] Page, if paginating the result
     * @param {number} [limit] max number of product ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApi
     */
    public getProductsFromViewComponent(id: string, page?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return ViewControllerApiFp(this.configuration).getProductsFromViewComponent(id, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get products by view container Id
     * @param {string} id View Container Id
     * @param {number} [page] Page, if paginating the result
     * @param {number} [limit] max number of product ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApi
     */
    public getProductsFromViewContainer(id: string, page?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return ViewControllerApiFp(this.configuration).getProductsFromViewContainer(id, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get view container by id
     * @param {string} id View Container Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApi
     */
    public getViewContainerById(id: string, options?: RawAxiosRequestConfig) {
        return ViewControllerApiFp(this.configuration).getViewContainerById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get view containers by type
     * @param {GetViewContainersTypeEnum} type Container type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApi
     */
    public getViewContainers(type: GetViewContainersTypeEnum, options?: RawAxiosRequestConfig) {
        return ViewControllerApiFp(this.configuration).getViewContainers(type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Rename view components
     * @param {Array<RenameViewComponentRequest>} renameViewComponentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApi
     */
    public renameViewComponents(renameViewComponentRequest: Array<RenameViewComponentRequest>, options?: RawAxiosRequestConfig) {
        return ViewControllerApiFp(this.configuration).renameViewComponents(renameViewComponentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update homepage container with components. Allowed enum values for homepage containers: FEATURED_COLLECTIONS, FEATURED_BRANDS, PRODUCT_CATEGORIES, TRENDING_BRANDS, HERO, ABOUT.
     * @param {UpdateContainerTypeEnum} type View Container type
     * @param {UpdateViewContainerRequest} updateViewContainerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApi
     */
    public updateContainer(type: UpdateContainerTypeEnum, updateViewContainerRequest: UpdateViewContainerRequest, options?: RawAxiosRequestConfig) {
        return ViewControllerApiFp(this.configuration).updateContainer(type, updateViewContainerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change activity status for view component
     * @param {UpdateBannerContainerRequest} updateBannerContainerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApi
     */
    public updatePromoBannerContainer(updateBannerContainerRequest: UpdateBannerContainerRequest, options?: RawAxiosRequestConfig) {
        return ViewControllerApiFp(this.configuration).updatePromoBannerContainer(updateBannerContainerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<UpdateViewComponentsRequest>} updateViewComponentsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApi
     */
    public updateViewComponents(updateViewComponentsRequest: Array<UpdateViewComponentsRequest>, options?: RawAxiosRequestConfig) {
        return ViewControllerApiFp(this.configuration).updateViewComponents(updateViewComponentsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update view container elements
     * @param {string} id View Container Id
     * @param {UpdateViewContainerElementsRequest} updateViewContainerElementsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApi
     */
    public updateViewContainerElements(id: string, updateViewContainerElementsRequest: UpdateViewContainerElementsRequest, options?: RawAxiosRequestConfig) {
        return ViewControllerApiFp(this.configuration).updateViewContainerElements(id, updateViewContainerElementsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload component image
     * @param {string} componentId View Component Id
     * @param {UploadComponentImageRequest} [uploadComponentImageRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApi
     */
    public uploadComponentImage(componentId: string, uploadComponentImageRequest?: UploadComponentImageRequest, options?: RawAxiosRequestConfig) {
        return ViewControllerApiFp(this.configuration).uploadComponentImage(componentId, uploadComponentImageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update collection image
     * @param {string} id View component id
     * @param {File} image Image request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewControllerApi
     */
    public uploadImageToViewComponent(id: string, image: File, options?: RawAxiosRequestConfig) {
        return ViewControllerApiFp(this.configuration).uploadImageToViewComponent(id, image, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetHomepageViewContainerTypeEnum = {
    Navigation: 'NAVIGATION',
    NavigationV2: 'NAVIGATION_V2',
    NavigationV2Retailer: 'NAVIGATION_V2_RETAILER',
    NavigationV2Collection: 'NAVIGATION_V2_COLLECTION',
    NavigationV2Categories: 'NAVIGATION_V2_CATEGORIES',
    NavigationV2Subcategory: 'NAVIGATION_V2_SUBCATEGORY',
    Landing: 'LANDING',
    FeaturedCollections: 'FEATURED_COLLECTIONS',
    FeaturedBrands: 'FEATURED_BRANDS',
    FeaturedLinksRetailer: 'FEATURED_LINKS_RETAILER',
    ProductCategories: 'PRODUCT_CATEGORIES',
    TrendingBrands: 'TRENDING_BRANDS',
    Hero: 'HERO',
    About: 'ABOUT',
    PromoBanner: 'PROMO_BANNER',
    PerfectForThe: 'PERFECT_FOR_THE',
    NyNow: 'NY_NOW',
    ExploreNewTrending: 'EXPLORE_NEW_TRENDING',
    TradeShow: 'TRADE_SHOW'
} as const;
export type GetHomepageViewContainerTypeEnum = typeof GetHomepageViewContainerTypeEnum[keyof typeof GetHomepageViewContainerTypeEnum];
/**
 * @export
 */
export const GetViewContainersTypeEnum = {
    Navigation: 'NAVIGATION',
    NavigationV2: 'NAVIGATION_V2',
    NavigationV2Retailer: 'NAVIGATION_V2_RETAILER',
    NavigationV2Collection: 'NAVIGATION_V2_COLLECTION',
    NavigationV2Categories: 'NAVIGATION_V2_CATEGORIES',
    NavigationV2Subcategory: 'NAVIGATION_V2_SUBCATEGORY',
    Landing: 'LANDING',
    FeaturedCollections: 'FEATURED_COLLECTIONS',
    FeaturedBrands: 'FEATURED_BRANDS',
    FeaturedLinksRetailer: 'FEATURED_LINKS_RETAILER',
    ProductCategories: 'PRODUCT_CATEGORIES',
    TrendingBrands: 'TRENDING_BRANDS',
    Hero: 'HERO',
    About: 'ABOUT',
    PromoBanner: 'PROMO_BANNER',
    PerfectForThe: 'PERFECT_FOR_THE',
    NyNow: 'NY_NOW',
    ExploreNewTrending: 'EXPLORE_NEW_TRENDING',
    TradeShow: 'TRADE_SHOW'
} as const;
export type GetViewContainersTypeEnum = typeof GetViewContainersTypeEnum[keyof typeof GetViewContainersTypeEnum];
/**
 * @export
 */
export const UpdateContainerTypeEnum = {
    Navigation: 'NAVIGATION',
    NavigationV2: 'NAVIGATION_V2',
    NavigationV2Retailer: 'NAVIGATION_V2_RETAILER',
    NavigationV2Collection: 'NAVIGATION_V2_COLLECTION',
    NavigationV2Categories: 'NAVIGATION_V2_CATEGORIES',
    NavigationV2Subcategory: 'NAVIGATION_V2_SUBCATEGORY',
    Landing: 'LANDING',
    FeaturedCollections: 'FEATURED_COLLECTIONS',
    FeaturedBrands: 'FEATURED_BRANDS',
    FeaturedLinksRetailer: 'FEATURED_LINKS_RETAILER',
    ProductCategories: 'PRODUCT_CATEGORIES',
    TrendingBrands: 'TRENDING_BRANDS',
    Hero: 'HERO',
    About: 'ABOUT',
    PromoBanner: 'PROMO_BANNER',
    PerfectForThe: 'PERFECT_FOR_THE',
    NyNow: 'NY_NOW',
    ExploreNewTrending: 'EXPLORE_NEW_TRENDING',
    TradeShow: 'TRADE_SHOW'
} as const;
export type UpdateContainerTypeEnum = typeof UpdateContainerTypeEnum[keyof typeof UpdateContainerTypeEnum];


